/* eslint-disable default-case */
import * as THREE from "three";
import React, { Component } from "react";
//import CustomizeBuilding from '../js/customizeBuilding';
import * as cuBuilding from './pricingReducer';
import * as cuComponent from './componentReducer';
import * as validate from '../../Components/Modals/validations';
// import * as cuComponent from './componentReducer';
import TWEEN from '@tweenjs/tween.js';
import * as utils from './utils'
import {addValidation, cupolaEditValidation, cupolaValidation, editValidation, wallNameArrForValid } from "../../utils/Validation";
import { controls } from "./eventReducer";
import { ManufacturesDefaultDetails } from "../../Constants/constant";
import { setQuoteStateCountForNonLoggedIn } from "../../action";

export const params = {
    p_c_i: false,
    apiCallAfterEdit:false,
    selectedState: "",
    selectedManufacture:"",
    selectedManufactureId: "",
    leanStyle:{left :"standard", right:"standard", front:"standard", back:"standard"},
    freeStandingSide : "left",
    logoWidth:(3800/1000)/20,
    logoHeight:(2200/1000)/20,
    insulation: {
        center: {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false, custom:false }, 
        frontLean: {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,custom:false  }, 
        leftLean: {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,custom:false  }, 
        rightLean: {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,custom:false  }, 
        backLean: {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,custom:false  }
    },
    preAction: {},
    toggleBuildingStyleChange: false,
    isBuildingStyleChange:false,
    selectedInsulationId :0,
    isBuildingStyleChange:false,
    isDefaultfourFeet:false,
    canopy:false,
    cupola:false,
    cupolaQty:1,
    cupolasize:'',
    newtrussType:'',
    c_r_c: "0xffffff",
    c_r_c_name: 'White',
    c_r_c_id: 'White',
    isWallCheck:"Open",
    oncenter_val:0,
    oncenter_val_with_action:'',
    lift_type:false,
    lifttype_price:0,
    lifttype_name:'',
    params_cancel:{},
    inspirationalQuotesData: [],
    trimVal:-2,
    alignL:"1",
    alignR:"1",
    alignB:"1",
    alignF:"1",
    activeWall: "c_b_f_w",
    isSnowLoad: false,
    is_showCenter: false,
    is_translusant: false,
    isDoorOverlap: false,
    isShowCenter: false,
    singleSlope: false,
    p_l_w_center: false,
    dropdown_flagF: false,
    dropdown_flagB: false,
    paymentmode: 'cash',
    p_f_wF: "Open",
    p_b_wB: "Open",
    p_w: 12,
    p_d: 21,
    p_h: 8,
    p_r_t: "Gabled",
    p_a_s: 0,
    p_r_p: 3,
    p_s_m: "Steel",
    p_r_c: "0xAE8F66",
    p_w_c: "0xAE8F66",
    p_t_c: "0xffffff",
    p_s_c: "Gray",
    p_w_c_c: "0x124B8A",
    p_w_c_n: false,
    p_w_c_n_j_trim: true,
    p_w_s1: false,
    p_w_s2: false,
    p_w_s3: false,
    p_w_s4: false,
    p_g_f: 0,
    building_type_name: '',
    other_building_type_name: "",
    checkeditName: false,
    p_g_b: 0,
    p_e: 0,
    p_e_p_l: 2,
    p_e_s_l: false,
    p_e_r: 0,
    p_e_p_r: 2,
    p_e_s_r: false,
    p_c_2: false,
    p_c_3: false,
    additional_note: '',
    p_b_t: 1,
    manageSideLean: 'left',
    p_r_s: "3",
    p_b_c: "Open",
    p_b_c_b: "Open",
    p_v_w: false,
    wallTexture:"none",
    p_e_i: "",
    p_e_i_other: "",
    gauge_val: "",
    gauge_val_check: false,
    fourth_center_cost: false,
    risk_cost: false,
    cert_pac_cost: false,
    p_b: "0",
    p_i_s: "1",
    p_e_l: false,
    lean_p_e_l: false,
    leanF_p_e_l: false,
    leanR_p_e_l: false,
    leanB_p_e_l: false,
    p_t_u: 0,
    p_f_w: "Open",
    p_c_p_l: false,
    p_c_p_r: false,
    p_c_p_f: false,
    p_c_p_b: false,
    p_b_w: "Open",
    p_l_w: "Open",
    p_r_w: "Open",
    p_r_w_S_S_L: "Open",
    is_trasparent: false,
    p_c_a_w: false,
    p_c_a_f_l_w: false,
    p_c_a_b_l_w: false,
    p_c_a_l_l_w: false,
    p_c_a_r_l_w: false,
    p_l_w_p: 0,
    p_r_w_p: 0,
    p_j_t: false,
    p_j_t_end: false,
    p_e_b: 0,
    p_e_t: 0,
    p_b_p: false,
    p_b_p_feet: "Select",
    p_b_p_feetVal: "0",
    p_i_o: "0",
    p_a_ch: 0,
    p_a_ch_w_B: 0,
    p_b_c_b_l_f: "Open",
    p_b_c_b_l_b: "Open",
    p_b_c_b_l: "Open",
    p_b_c_b_f_f: "Open",
    p_b_c_b_f_b: "Open",
    p_b_c_b_f_l: "Open",
    p_b_c_b_b_b: "Open",
    p_b_c_b_b_f: "Open",
    p_b_c_b_b_l: "Open",
    p_b_c_b_r_f: "Open",
    p_b_c_b_r_b: "Open",
    p_b_c_b_r: "Open",
    w_a_s_tTYP: 0,
    w_a_s_tTYP_OPT_S: 0,
    w_a_s_tTYP_OPT_E: 0,
    p_u_t: 10,
    p_u_c: false,
    p_f_b_l: true,
    p_l_b_l: true,
    p_r_b_l: true,
    p_b_b_l: true,
    p_m_h_a: 0,
    p_r_a: 0,
    p_f_i: false,
    p_r_o: false,
    p_s_i: "",
    p_s_n: "",
    m_s_n: "",
    p_g_i: "",
    truck: false,
    orignalName: "",
    truckPOS: "0,0,0",
    truckROT: "0,0,0",
    driveway: false,
    drivewayPOS: "0,0,0",
    drivewayROT: "0,0,0",
    p_v: .21,
    dpSelectComponentValue: 'Select',
    wallPos: "Select",
    p_a_g_r_u_d: "Select",
    p_a_g_r_u_d_c_s: "Select",
    p_a_g_r_u_d_c_s1: "Select",
    f_r_m_o_t: "Select",
    f_r_m_o_t1: "Select",
    p_d_c: "Select",
    doorSize: "Select",
    doorType: "Garage",
    doorLabel: '',
    trimkit: false,
    chain_hoist: false,
    header_seal: false,
    certified_door: false,
    automatic_openers: false,
    insulated: false,
    extra_notes: "",
    p_w_cc: "Select",
    l_l_to: "Open",
    r_l_to: "Open",
    b_r_p: "3",
    p_r_c_name: 'Red',
    p_w_c_name: 'Red',
    p_t_c_name: 'Red',
    p_w_c_c_name: 'Red',
    p_r_c_id: 'Red',
    p_w_c_id: 'Red',
    p_t_c_id: 'Red',
    p_w_c_c_id: 'Red',
    p_u_f_w: "Close",
    b_l_t_r_pF: "2",
    b_l_t_r_pB: "2",
    b_l_t_r_p: "2",
    b_l_t_r_pR: "2",
    p_b_l_t_r_p_f: "3",
    p_b_l_t_r_p_b: "3",
    p_b_l_t_r_p: "3",
    p_b_l_t_r_p_r: "3",
    b_l_t_r_p_r: "3",
    b_l_t_r_p_f: "3",
    b_l_t_r_p_b: "3",
    b_r_p: "3",
    b_l_t_s: "",
    p_f_w_f: "Open",
    b_f_l_t_f: "Open",
    b_f_l_t_r: "Open",
    b_f_l_t_l: "Open",
    b_b_l_t_f: "Open",
    b_b_l_t_r: "Open",
    b_b_l_t_l: "Open",
    b_l_l_t_f: "Open",
    b_l_l_t_b: "Open",
    b_l_l_t_l: "Open",
    b_r_l_t_f: "Open",
    b_r_l_t_b: "Open",
    b_r_l_t_r: "Open",
    b_w_r_p: "",
    b_r_s: false,
    leantoHeight: 0,
    DoorPosOnEdit: "",
    DoorLocOnEdit: "",
    UpdatedDoorPosOnEdit: "",
    DoorRotOnEdit: "",
    isDefault_r_p: "4",
    isDefault_l_t_r_p: "3",
    cd: 0,
    b_w_p: "",
    scrUP: false,
    scrDW: false,
    add_front_lean: false,
    add_back_lean: false,
    add_left_lean: false,
    add_right_lean: false,
    leanF_p_w: 12,
    leanF_p_d: 12,
    leanF_p_h: 6,
    leanF_p_pos: 0,
    leanB_p_w: 12,
    leanB_p_d: 12,
    leanB_p_h: 6,
    leanB_p_pos: 0,
    lean_p_w: 12,
    lean_p_d: 21,
    lean_p_h: 6,
    lean_p_pos: 0,
    leanR_p_w: 12,
    leanR_p_d: 21,
    leanR_p_h: 6,
    leanR_p_pos: 0,
    continous_front_lean: false,
    continous_back_lean: false,
    continous_left_lean: false,
    continous_right_lean: false,
    add_storage: 5,
    add_storage_check: false,
    cB_addStorage_front: 10,
    cB_addStorage_check_front: false,
    isBreezeway: false,
    nostorage: true,
    noStorageCertificatePriceChange: false,
    cB_addStorage_check_right: false,
    cB_addStorage_check_right_utility: false,
    cB_addStorage_check_left_utility: false,
    cB_addStorage_right_utility: 5,
    cB_addStorage_left_utility: 5,
    cB_addStorage_check_left: false,
    cB_addStorage_check_both:false,
    cB_addStorage_check_both_with_back:false,
    add_storage_check_front: false,
    add_storage_check_back: false,
    cB_addStorage_right: 10,
    cB_addStorage_left: 10,
    add_storage_right: 5,
    add_storage_front: 5,
    add_storage_back: 5,
    add_storage_check_right: false,
    add_storage_check_1: false,
    add_storage_check_right_1: false,
    add_storage_check_front_1: false,
    add_storage_check_back_1: false,
    add_right_front_porch: false,
    add_right_back_porch: false,
    add_left_front_porch: false,
    add_left_back_porch: false,
    add_wrap_around_porch: false,
    add_left_front_lean_porch: false,
    add_right_front_lean_porch: false,
    add_right_back_lean_porch: false,
    add_left_back_lean_porch: false,
    add_full_lean_porch: false,
    r_f_p_w: 5,
    r_f_p_d: 5,
    r_b_p_w: 5,
    r_b_p_d: 5,
    l_f_p_w: 5,
    l_f_p_d: 5,
    l_b_p_w: 5,
    l_b_p_d: 5,
    cmrpos: false,
    leftstorage: false,
    rightstorage: false,
    centerstorage: false,
    leantoAlignmentFront: 1,
    leantoAlignmentLeft: 1,
    leantoAlignmentRight: 1,
    leantoAlignmentBack: 1,
    oldPosleantoAlignmentLeft: 1,
    oldPosleantoAlignmentRight: 1,
    p_g_c: false,
    o_v_h_n_g: false,
    o_v_h_n_g_e: false,
    p_o_p: false,
    p_p_b: 0,
    a_c_p_l: false,
    a_c_p_r: false,
    a_c_p_f: false,
    a_c_p_b: false,
    p_s_c_b: false,
    p_e_c_b: false,
    leanF_p_e_i: "0",
    leanB_p_e_i: "0",
    lean_p_e_i: "0",
    leanR_p_e_i: "0",
    leanF_p_e_i_other: "",
    leanB_p_e_i_other: "",
    lean_p_e_i_other: "",
    leanR_p_e_i_other: "",
    tax_exempt: false,
    tax_zipcode: "",
    ShowLeanRecord: false,
    customW: "6",
    customH: "6",
    job_site_level: "yes",
    power_avail: "yes",
    chkFrameOpening: false,
    display_product_status: "in_stock",
    globalTaxValue: 'sales_tax',
    g_d_c: "0xffffff",
    g_d_c_name: 'White',
    g_d_c_id: 'White',
    frame_length:0,
    m_s_n_1:0,
    m_s_n_2:0,
    m_n_f_1:"Select",
    m_n_f_2:"Select",
    g_d_c_Obj: {"blue_value": 255,
                "cost": 0,
                "cost_type": 0,
                "green_value": 255,
                "hex_value": "#ffffff",
                "id": -1,
                "manufacturer_id": 8,
                "name": "White",
                "percentage_of_cost": 0,
                "red_value": 255},

    }
    export const const_var = {
    stripe:{"checkout_key":"","checkout_type":""},
    wallSectionTab: "Center Building",
    zipErrDefaultMessage:"",
    showStateBoxInZipErr:false,
    showStateBoxInZipDefault:false,
    state_mfg_zipcode_old:"",
    zipcodeToolTipDataFlag:false,
    zipcodeToolTipData:{},
    isGlobalZipUpdate : false,
    zipErrorMsgFlag : false,
    showStateFieldInToolTip: false,
    isFreeStandingBuilding: false,
    insulationJsonLeanTo: [],
    compareInsId: 0,
    insulationJsonCompare: {},
    wallNameArray: { "p_f_w": "front", "p_b_w": "back", "p_l_w": "left", "p_r_w": "right",
        "p_b_c_b_f_f" : "front","p_b_c_b_f_b": "back","p_b_c_b_f_l":"side",
        "p_b_c_b_l_f" : "front","p_b_c_b_l_b": "back","p_b_c_b_l":"side",
        "p_b_c_b_r_f" : "front","p_b_c_b_r_b": "back","p_b_c_b_r":"side",
        "p_b_c_b_b_f" : "front","p_b_c_b_b_b": "back","p_b_c_b_b_l":"side",
        "storage_back" : "storage back","storage_front": "storage front","storage_left":"storage left","storage_right":"storage right",
        "storage_roof": "storage roof","open_roof":"open roof","full_roof" : "full roof"
    },
    CompareCBInsulationPrice: 0,
    CompareFLInsulationPrice: 0,
    CompareBLInsulationPrice: 0,
    CompareLLInsulationPrice: 0,
    CompareRLInsulationPrice: 0,
    CBInsulationPrice: 0,
    FLInsulationPrice: 0,
    BLInsulationPrice: 0,
    LLInsulationPrice: 0,
    RLInsulationPrice: 0,
    InsulationOnWall: {},
    InsulationObj: [],
    skyIMG:"",
    groundIMG:"",
    envIMG:"",
    textureGrass:"",
    textureGray:"",
    TrimTexture:"",
    metalTexture:"",
    wallTextureObj:{"vertical":null, "lap":null, "board_batten":null, "none":null},
    loadGltObj:"",
    stateManufactureChangeId: "",
    stateManufactureFlag : "",
    is_price_edit:false,
    isForStandardBuilding:false,
    isFeedbackFieldMandatory: false,
    navEventKey:{"leanto":"leftLean","walls":"0"},
    showProfileModal : false,
    additionalChargeArr:[],
    showComparePrices : true,
    regionId:[],
    commonBuildingFlag:{
        center:{"buildingHeight":false},
        leftLean:{"leftLeanHeight":false},
        rightLean:{"rightLeanHeight":false},
        frontLean:{"frontLeanHeight":false},
        backLean:{"backLeanHeight":false},
        wrap:false,
        premiumcolor:false,
    },
    wallSelection : {
        centerBuildingWall : "c_b_f_w",
        leanToWall: "select"
    },
    componentNameForAlert: "",
    activeTab:null,
    popularSizeArray:[],
    oldPriceForColorCost:0,
    colorPrice: {
        'roof_color_price_changed': false,
        'wall_color_price_changed': false,
        'trim_color_price_changed': false,
        'wainscot_color_price_changed': false
    },
    setSidesEndsWallOption:'open',
    setLeanWallOption:{"frontLean":"open","backLean":"open","rightLean":"open","leftLean":"open"},
    reinforcedtype:{'center':'single','left':'single','right':'single','front':'single','back':'single'},
    defaultCameraValue:{},
    checkoutPageImage:"",
    showDeleteButton:{},
    orderSaveForm:false,
    isShowConfigBox:true,
    horizontalSliderRange:0,
    new_building_name:"",
    /****************  Giorgi  **********************/
    componentDistance: 1,
    /****************  Giorgi  **********************/

    focusedSection: '',
    isDataWithlegCut: false,
    legCutFlag:true,
    mutipleSizesBuilding:false,
    isFromStateChange:false,
    checkmoreCustomizeFlag:false,
    isMultiSelectDrawingOpt: true,
    is_custom_building:false,
    dealer_discount_label:"",
    manufacturer_discount_label:"",
    exact_order_permit_fee: 0,
    isFromCompare: false,
    Overhang: {},
    isOverhang: {
        'end' : {
            isChecked: false,
            selected: '',
            size: 0.5
        },
        'side' : {
            isChecked: false,
            selected: '',
            size: 0.5
        },
        'both' : {
            isChecked: false,
            selected: '',
            size: 0.5
        }
    },
    isLayoutDesign:false,
    resetpasswordcrm:true,
    isShowSaveQuote:false,
    fromGetBuildingData: false,
    fromChangeDimension: false,
    zipManufErrMsg: '',
    is_State_Edit: false,
    showStateZip: false,
    isZipcodeIncluded: true,
    state_mfg_zipcode: '',
    tempZCode: '', 
    resetVal: false,
    isTBSOldQuotesForVerticalRoof: false,
    isShowUpdatedBuildingImages: [
        "carport1.com", "americanmetalbuildings.com", 
        "aametalbuildings.com", "safeguardmetalbuildings.com",
        "steelbuildingsandstructures.com",
        "eaglebuildings.com", 
    ],
    changeComponentSize: false,
    isKLinkEnable: false,
    KLinkDataUpdate: false,
    SApiCalled: false,
    showInfoError: false,
    showStateOnly: false,
    apiCalledforState: false,
    showStateField: false,
    MFApiCalled: false,
    tempPostData: {},
    saveLatterModal: false,
    preQuoteApiCalled: false,
    preQuoteError: false,
    zipCode: '',
    ziperrormsg: '',
    showReportLoading: false,
    reportDesc: '',
    reportIssueID: '',
    showReportIssueModal: false,
    errormsg: '',
    setScreenshot: '',
    ticketId:'',
    duplicateTaxZipCode:'',
    TempLeadCustomerData: '',
    isSetZip: false,
    isTripleWide : false,
    isSingleBaseRail: false,
    singleBaseRailByMnf:[34, 58, 73,],
    wallNameColor:"aqua",
    checkPanelForLean:{"left":false,"right":false},
    isInsulaltionForOldQuotes:false,
    isOpenMeeting:false,
    isOpenUserTour:false,
    startTourNumber:'',
    currentStepTour:1,
        selectWaterMarkByMNF: {
        '7KJeHld8lthhZRr0qzJEjYfnbjmXhXiKSGa73bv1XqENGNIthoKdbT4gIznBTV7i':"martinezcarportsllc",
        '7oVN03loA8TrK6y1igOxmmdJ1D9OCew5MB8W97YetSLVNpzXgOgXUPrcPVH3kYYh':"building4Less",
        'IGMWikT6PT82EHlYmEAMzQ6POIfNI7uWbQXxpRM3lOKu9OvVBYaZ5Jto4Msu7CM8':"bullbuildings",
        "TQ4cpaVBiUhiX1nqR4THXreYThhailXckCQ25pAJsXY4b8QVQ4ISPrpiCPvpUg8g":"riversidemetalstructures",
        'r3VDel5LeO4uY020FAYZ99zhNO8zBfHXP5tiIBhXZxdVuggT2jDmeQNHlIOFdzAg':"pacificbuildingsinc",
        'Fq6Meq4bloS4c7Pqj7OuVNHfiPhWnuesTwy3KiuFNCJ2cyu3WKIGEFqc74qsprei':"steelbuildingsandstructures",
        'Bqxq40K4zojI9VBP630isdq7GqlmZOV4oWhnHC5eanGpV7iOacGP9Gba6D9slWTG':"eaglebuildings",
        'GuEssZt4YAZi5ot69xbO9I4w3dbxgPJNXsUFCJJPevH3zt1ONTUabif5hRKJ41Oc':"rhinometalstructures",
        'X9J7WuONkgZck41DEkbhi9r6HIkwypqpMnH1HoXx57LrvuCxtX7gLKFeDnQlrSfc':"anchoragesteelbuildings",
        'xhkZaSoQHjhlFHCOQgesOnsy7o1juN0tkg8wMfk8JAVljzl4XdPsPj5AzlDeZnoT':"americanmetalbuildings",
        'j71D6wqYltk69UVs9lw4UFiVhRQC1kevjFNI6yHWxGI9Mpz1C0Tbl1wJrWdlarZ2':"aametalbuildings",
        'P7jxFfksz6Caf8pfuWSaaAUbg86JLeelGnVZgAwugjI0ayK35I9Olh0V5wMgKpvQ':"carport1",
        'P0pjF0vzahFWP8DTFzQulTkOFi5b2cpoeNrLSxIMXxgMRe0fpAYKRpFRLCPvC9ke':"safeguardmetalbuildings",
        'iIzTnlBDIJSwr1zqFpZ6u7iPnEwL12EjfgZ0JpminlR2N6byb3P1XsXeu95QoeRD':"custombuiltstructures",
        'mflMO6hnObaoNO7Z8oPLP6HScYnTg5QARdj7lq8dICqGgEcCWX11Uprgq35aMIo3':"samsonsteelstructures",
        'tqRONV664tLp1rKbyF7Lqjs0rG5ngbvdhyzvCJ9FAQ6Vfe00DArmnVfL5ZGAPspv':"ultimatebuildingsolution",
    },
    centerGroundWaterMark:[,"pacificbuildingsinc","us-steelbuilding", "allsteelstructure", "universalbuildingsllc", "riversidemetalstructures","bullbuildings","aametalbuildings","steelbuildingsandstructures","eaglebuildings"],
    showNonLoginWaterMark:["pacificbuildingsinc.com", "complexsteelbuildings.com", "us-steelbuilding.com", "jvmetalbuildingsllc.com" ,"allsteelstructure.com", "universalbuildingsllc.com", "riversidemetalstructures.com" ,"bullbuildings.com","aametalbuildings.com","steelbuildingsandstructures.com","eaglebuildings.com", "rhinometalstructures.net","anchoragesteelbuildings.com","americanmetalbuildings.com","carport1.com","safeguardmetalbuildings.com","custombuiltstructures.com","samsonsteelstructures.com","ultimatebuildingsolution.com","bestwaybarns.com"],
    breezewayLength:10,
    breezewayFrontStorageOptions:[],
    breezewayBackStorageOptions:[],
    breezewayFrameoutOptions:[],
    count_numberofLegs:0,
    referralID:'',
    alertPubliMessage:"",
    alertExpireMessage:"",
    isPublicModuleID:'',
    isPublicEdit:false,
    noCursorClass:false,
    is_loader:false,
    ScrollCaptureEnd:true,
    surcharge_amount_is_edit:false,
    isCheckDisabled:false,
    cupolaForMove:[],
    cupola:"",
    cupolaCount:0,
    cupolaUniqueId:1,
    dragCupola :false,
    cupolas :[],
    cupolaEntries:[],
    cupolasData:[],
    cupolaPosition:{},
    isCupolaAdded:false,
    isheilightCupola:false,
    previousCupolaZpositionOnMove:0,
    cupolaType:'without_windows',
    wallsData :{center:{}, leftLean:{}, rightLean:{}, frontLean:{}, backLean:{}},
    lengthData : {center:{length:0,legsCount:0,previousLength:0,porchLength:0,}, leftLean:{length:0,legsCount:0,previousLength:0,porchLength:0,}, rightLean:{length:0,legsCount:0,previousLength:0,porchLength:0,}, frontLean:{length:0,legsCount:0,previousLength:0,porchLength:0,}, backLean:{length:0,legsCount:0,previousLength:0,porchLength:0,}},
    cbClosedSideWalls:0,
    cbClosedEndWalls:0,
    cbFullyEnclosedWalls:0,
    flFullyEnclosedWalls:0,
    blFullyEnclosedWalls:0,
    llFullyEnclosedWalls:0,
    rlFullyEnclosedWalls:0,
    flClosedSideWalls:0,
    flClosedEndWalls:0,
    llClosedSideWalls:0,
    llClosedEndWalls:0,
    rlClosedSideWalls:0,
    rlClosedEndWalls:0,
    blClosedSideWalls:0,
    blClosedEndWalls:0,
    frontLeanLegs:0,
    leftLeanLegs:0,
    rightLeanLegs:0,
    backLeanLegs:0,
    checkPickThisBuilding:false,
    isBreezewayPickThisBuilding:false,
    compareMainBuildingPriceRes:'',
    ShowTwodLayoutDefault:false,
    hodldEditBuildingData:{},
    checkDoorIsadded:false,
    leanHeight:0,
    checkForCutPannel : 0,
    checkVerticalCheckBox:false,
    paymentOptionObj:{'finance':{'type':'financing','finance_company':'','application_id':'','plan_no':''},'cash':{'type':'cash','finance_company':'','application_id':'','plan_no':''},'rto':{'type':'rent_to_own','finance_company':'','application_id':'','plan_no':''},'certified_check':{'type':'certified_check','finance_company':'','application_id':'','plan_no':''},'money_order':{'type':'money_order','finance_company':'','application_id':'','plan_no':''},'cod':{'type':'cash_on_delivery','finance_company':'','application_id':'','plan_no':''}},
    getPaymentValue:{'financing':'finance','rent_to_own':'rto','cash':'cash','certified_check':'certified_check','money_order':'money_order','cash_on_delivery': 'cod'},
    showDisabledClass:false,
    porch:{},
    leanto_condition_by_mfg:{},
    compare_leanto_condition_by_mfg:{ side_lean_to: 1, end_lean_to: 0, wrap_around: 0},
    leadSourceStateData:{},
    leanDimension:{},
    mainLeantoValue:{1:'Left',2:'Right',3:'Front',4:'Back'},
    newRaycaster :new THREE.Raycaster(),
    newMouse :new THREE.Vector2(),
    newIntersects:'',
    normalMatrix :new THREE.Matrix3(),
    worldNormal :new THREE.Vector3(),
    lookAtVector :new THREE.Vector3(),
    dragging :false,
    newDoorsArray :[],
    notMovableDoors: [],
    wallArray :{"front": {},"back": {}},
    user_type_for_comparision:'standard',
    checkUserRole:[],
    showhideUpgradePlan:'',
    jtrimCustomArray:false,
    ComparisionDataArray:{},
    NoCompareData1:false,
    NoCompareData2:false,
    showCompareMnfList_1:false,
    showCompareMnfList_2:false,
    comparisionLoadermfg1: false,
    comparisionLoadermfg2: false,
    comparisionLeantoloader:false,
    chknewCount: 0,
    isShowEditConfigurationButton: false,
    defaultBuildingColorArray: [],
    checkSurchangeData: false,
    checkforLeanto: false,
    checkForLeantoLegs: false,
    SendAPIBuildingData: {},
    isShowEmageEditor: false,
    PrintAlertBoxShowButton: false,
    PrintAlertBox: false,
    SharingAlertBox: false,
    showGaugePrice: false,
    showGaugePriceVal: 0,
    showTrussPriceVal: 0,
    two_d_layuot: {},
    feedback_object: {},
    feedback_object_to_server: { 'like_count': false, 'dislike_count': false, 'feedback': '','feedback_name':'','feedback_email':'','first_name':'', 'last_name':'','phone_number':'' },
    price_breakdown_key: {},
    card_processing_fee: {},
    addressBook: [],
    taxTypeName:{"city_rate":"city_tax","county_rate":"county_tax","state_rate":"state_tax","surtax_rate":"sur_tax","local_rate":"local_tax","special_dist_rate":"special_tax"},
    checkedEndCrossBracing: false,
    checkedSideCrossBracing: false,

    CheckDefaultLoadForTween: false,
    referrer: "",
    checkCaptuareImage: false,
    entry_wall_location_reverse: { "left": "c_b_l_w", "right": "c_b_r_w", "front": "c_b_f_w", "back": "c_b_b_w", "ufend": "c_b_f_s_w", "fubend":"c_b_f_s_b_w","c_b_l_w": "c_b_l_w", "c_b_r_w": "c_b_r_w", "c_b_f_w": "c_b_f_w", "c_b_b_w": "c_b_b_w", "c_b_f_s_w": "c_b_f_s_w", "c_b_f_s_b_w":"c_b_f_s_b_w", },
    // entry_wall_location:{"F_S_L_R_W":"fsrside","c_b_l_s_w":"sideul","c_b_l_s_f_w":"lufend","c_b_l_s_b_w":"lubend","c_b_r_s_f_w":"rufend","c_b_r_s_b_w":"rubend","c_b_r_s_w":"ulside","c_b_l_w":"lside","c_b_r_w":"rside","c_b_f_w":"fend","c_b_b_w":"bend","c_b_f_s_w":"ufend","c_b_l_s_r_w":"rfend","c_b_r_s_l_w":"lfend","L_L_L_W":"lllside","L_L_F_W":"llfend","L_L_B_W":"llbend","R_L_F_W":"rlfend","R_L_B_W":"rlbend","R_L_R_W":"rlrside","L_L_F_S_W":"ufend","R_L_F_S_W":"ufend","F_L_F_S_W":"ufend","B_L_F_S_W":"ufend","F_L_F_W":"flfside","F_L_R_W":"flfend","F_L_L_W":"flbend","B_L_S_W":"blbside","B_L_F_W":"blfend","B_L_B_W":"blbend"},
    // "L_L_R_S_W":"llurside","R_L_L_S_W":"rlulside","B_L_B_S_W":"blulside","F_L_B_S_W":"flurside"
    entry_wall_location: { 
        "c_b_l_w": "lside", "c_b_r_w": "rside", "c_b_f_w": "fend", "c_b_b_w": "bend","F_S_L_R_W": "fsrside",
        
        "c_b_r_s_w": "ulside", "c_b_l_s_w": "sideul","c_b_f_s_w": "ufend",
        "c_b_f_s_l_w": "fulside", "c_b_f_s_r_w": "furside","c_b_f_s_b_w": "fubend",
        "c_b_l_s_b_w": "lubend","c_b_l_s_r_w": "rfend","c_b_l_s_f_w": "lufend", 
        "c_b_r_s_l_w": "lfend","c_b_r_s_f_w": "rufend", "c_b_r_s_b_w": "rubend",

        "F_L_F_W": "flfside", "F_L_R_W": "flfend", "F_L_L_W": "flbend",
        "F_L_B_S_W": "flurside", "F_L_R_S_W": "flufend", "F_L_F_S_W": "flulside",

        "L_L_L_W": "lllside", "L_L_F_W": "llfend", "L_L_B_W": "llbend", 
        "L_L_R_S_W": "llurside","L_L_F_S_W": "llufend","L_L_L_S_W": "llulside",

        "R_L_F_W": "rlfend", "R_L_B_W": "rlbend", "R_L_R_W": "rlrside", 
        "R_L_L_S_W": "rlulside","R_L_R_S_W": "rrurside","R_L_F_S_W": "rlufend", 

        "B_L_S_W": "blbside", "B_L_F_W": "blfend", "B_L_B_W": "blbend",
        "B_L_B_S_W": "blulside","B_L_L_S_W": "blufend","B_L_F_S_W": "bluside",
    },

    updated_entry_wall_location: {
        "lside": "Left", "rside": "Right", "fsrside": "Right","fend": "Front", "bend": "Back",

            "ulside" :"Back Storage Right","sideul":"Back Storage Left","ufend":"Back Storage Front",
            "furside" :"Front Storage Right","fulside":"Front Storage Left","fubend":"Front Storage Back",
            "lubend":"Left Storage Back", "rfend":"Left Storage Right","lufend":"Left Storage Front", 
            "lfend":"Right Storage Left","rufend":"Right Storage Front","rubend":"Right Storage Back",

            "flfside": "Front Leanto Side", "flfend": "Front Leanto Front", "flbend": "Front Leanto Back", 
            "flurside":"Front Lean Storage Right", "flufend":"Front Lean Storage Front","flulside":"Front Lean Storage Side",

            "lllside": "Left Leanto Side", "llfend": "Left Leanto Front", "llbend": "Left Leanto Back",
            "llurside":"Left Lean Storage Right","llufend":"Left Lean Storage Front","llulside":"Left Lean Storage Left",

            "rlfend": "Right Leanto Front", "rlbend": "Right Leanto Back", "rlrside": "Right Leanto Side", 
            "rlulside":"Right Lean Storage Left", "rrurside":"Right Lean Storage Right","rlufend":"Right Lean Storage Front",

            "blbside": "Back Leanto Side", "blfend": "Back Leanto Front", "blbend": "Back Leanto Back",
            "blulside":"Back Lean Storage Right", "blufend":"Back Lean Storage Front","bluside":"Back Lean Storage Side", 
        },

    checkWallClose: {"c_b_l_w": "p_l_w", "c_b_r_w": "p_r_w", "c_b_f_w": "p_f_w", "c_b_b_w": "p_b_w", "L_L_L_W": "p_b_c_b_l", "L_L_F_W": "p_b_c_b_l_f", "L_L_B_W": "p_b_c_b_l_b", "R_L_F_W": "p_b_c_b_r_f", "R_L_B_W": "p_b_c_b_r_b", "R_L_R_W": "p_b_c_b_r", "F_L_F_W": "p_b_c_b_f_l", "F_L_R_W": "p_b_c_b_f_f", "F_L_L_W": "p_b_c_b_f_b", "B_L_S_W": "p_b_c_b_b_l", "B_L_F_W": "p_b_c_b_b_f", "B_L_B_W": "p_b_c_b_b_b" , "L_L_F_S_W":'utility', "L_L_L_S_W":'utility', "L_L_R_S_W":'utility', "R_L_F_S_W":'utility', "R_L_L_S_W":'utility', "R_L_R_S_W":'utility', "F_L_F_S_W":'utility', "F_L_L_S_W":'utility',"F_L_R_S_W":'utility', "F_L_B_S_W":'utility',"B_L_L_S_W":'utility',"B_L_R_S_W":'utility', "B_L_F_S_W":'utility', "B_L_B_S_W":'utility',"F_S_L_R_W": "p_r_w","c_b_f_s_w":'utility',"c_b_l_s_w":'utility',"c_b_b_s_w":'utility',"c_b_r_s_w":'utility',"R_S_F_W_VT":'utility',"R_S_B_W_VT":'utility',"R_S_F_2W_VT":'utility',"R_S_B_2W_VT":'utility',"c_b_r_s_f_w":'utility',"c_b_r_s_b_w":'utility',"c_b_r_s_l_w":'utility',"c_b_l_s_r_w":'utility',"c_b_l_s_b_w":'utility',"c_b_l_s_f_w":'utility', "L_S_F_W_VT":'utility',"L_S_B_W_VT":'utility',"L_S_F_2W_VT":'utility',"L_S_B_2W_VT":'utility',"L_S_B_2W_VT":'utility', "c_b_f_s_l_w":'utility',"c_b_f_s_r_w":'utility',"c_b_f_s_b_w":'utility',"c_b_f_s_l_w":'utility',"c_b_f_s_r_w":'utility',"c_b_f_s_b_w":'utility',},

    entry_component_location: { "fsrside": "Right", 'front': 'fend', 'back': 'bend', 'left': 'lside', 'right': 'rside', 'FrontR': 'rlfend', 'BarnRight': 'rlrside', 'BackR': 'rlbend', 'FrontL': 'llfend', 'BarnLeft': 'lllside', 'BackL': 'llbend', 'FrontS': 'ufend', 'RightS': 'ufend', 'LeftS': 'ufend' },

    entry_component_locationName: { "fsrside": "Right", 'front': 'front', 'back': 'back', 'left': 'left', 'right': 'right', 'right_leanto_front': 'right_leanto_front', 'right_leanto_side': 'right_leanto_side', 'right_leanto_back': 'right_leanto_back', 'left_leanto_front': 'left_leanto_front', 'left_leanto_back': 'left_leanto_back', 'left_leanto_side': 'left_leanto_side', 'front_leanto_front': 'front_leanto_front', 'front_leanto_back': 'front_leanto_back', 'front_leanto_side': 'front_leanto_side', 'back_leanto_front': 'back_leanto_front', 'back_leanto_back': 'back_leanto_back', 'back_leanto_side': 'back_leanto_side', 'center_storage': 'front_storage_front', 'right_leanto_storage': 'right_storage_front', 'left_leanto_storage': 'left_storage_front' },

    hide_price_calculation: 1,//0,
    sendTaxarray: [],
    newCustomSizesArray: { "45_degree_angle": 0, "automatic_openers": 0, "certified_cost": 0, "chain_hoist": 0, "color_cost": 0, "cost": 0, "header_bar": 0, "header_seal": 0, "height": 8, "id": 55374, "is_automatic_openers": 0, "is_certified": 0, "is_chain_hoist": 0, "is_header_bar": 0, "is_header_seal": 0, "map_id": 13, "name": "8x8", "side_cost": 0, "vertical_side_cost": 0, "width": 8 },
    estimator_disclaimer: "",
    estimator_QuestionAnswer: [],
    estimator_DefaultQuestionAnswer: [],
    newTaxCalcuArray: [],
    MainBuilingImage: "",
    refData: "",
    checkBlobImg: false,
    showProcessLoaderchkEdit: true,
    editAPIDataByResponse: {},
    otherDataforPostAPI: {},
    BuildingPriceArrar: {},
    roofObject: {},
    leadSourceData: "",
    showProcessLoaderchk: false,
    tax: { "percentage": 0, "type": "%", "name": 'sales_tax', "amount": 0 },
    is_loggedinUserData: {},
    taxDropDownValue: [
        { value: 'sales_tax', label: 'Sales Tax' },
        { value: 'sur_tax', label: 'Surtax' },
        { value: 'additional_tax', label: 'Additional Tax' },
        { value: 'city_tax', label: 'City Tax' },
        { value: 'county_tax', label: 'County Tax' },
        { value: 'local_tax', label: 'Local Tax' },
        { value: 'state_tax', label: 'State Tax' },
        { value: 'federal_tax', label: 'Federal Tax' },
        { value: 'indirect_tax', label: 'Indirect Tax' },
        { value: 'material_tax', label: 'Material Tax' },
        { value: 'special_tax', label: 'Special Tax' }
    ],
    othertaxDropDownValue: { 'sales_tax': 'Sales Tax', 'sur_tax': 'Surtax', 'additional_tax': 'Additional Tax', 'city_tax': 'City Tax', 'county_tax': 'County Tax', 'local_tax': 'Local Tax', 'state_tax': 'State Tax', 'federal_tax': 'Federal Tax', 'indirect_tax': 'Indirect Tax', 'material_tax': 'Material Tax','special_tax':'Special Tax' },
    customEntrySize: { "45_degree_angle": 0, "automatic_openers": 0, "certified_cost": 0, "chain_hoist": 0, "color_cost": 0, "cost": 0, "header_bar": 0, "header_seal": 0, "height": 8, "id": 55374, "is_automatic_openers": 0, "is_certified": 0, "is_chain_hoist": 0, "is_header_bar": 0, "is_header_seal": 0, "map_id": 13, "name": "8x8", "side_cost": 0, "vertical_side_cost": 0, "width": 8 },
    UpdatedPriceData: { 'roof_style_price_changed': true,'lifttype_price_changed':true,'cupola_price_changed':true, 'width_price_changed': true, 'length_price_changed': true, 'height_price_changed': true, 'insulation_price_changed': true, 'left_wall_price_changed': true, 'right_wall_price_changed': true, "right_wall_cut_panel_price_changed": true, "left_wall_cut_panel_price_changed": true, 'front_wall_price_changed': true, 'back_wall_price_changed': true, "certificate_price_changed": true, "common_width_changed": true, "common_length_changed": true, "common_height_changed": true, "utility_price_changed": true, "front_utility_price_changed": true, "wainscot_price_changed": true, "connection_fee_end_changed": true, "connection_fee_side_changed": true, "roof_pitch_price_changed": true,'lifttype_price_changed':true, 'left_lean_roof_style_price_changed': true, 'left_lean_width_price_changed': true, 'left_lean_length_price_changed': true, 'left_lean_height_price_changed': true, 'left_lean_left_wall_price_changed': true, 'left_lean_front_wall_price_changed': true, 'left_lean_back_wall_price_changed': true, "left_lean_certificate_price_changed": true, "left_lean_utility_price_changed": true, "left_lean_roof_pitch_price_changed": true, 'right_lean_roof_style_price_changed': true, 'right_lean_width_price_changed': true, 'right_lean_length_price_changed': true, 'right_lean_height_price_changed': true, 'right_lean_right_wall_price_changed': true, 'right_lean_front_wall_price_changed': true, 'right_lean_back_wall_price_changed': true, "right_lean_certificate_price_changed": true, "right_lean_utility_price_changed": true, "right_lean_roof_pitch_price_changed": true, 'front_lean_roof_style_price_changed': true, 'front_lean_width_price_changed': true, 'front_lean_length_price_changed': true, 'front_lean_height_price_changed': true, 'front_lean_left_wall_price_changed': true, 'front_lean_front_wall_price_changed': true, 'front_lean_back_wall_price_changed': true, "front_lean_certificate_price_changed": true, "front_lean_utility_price_changed": true, "front_lean_roof_pitch_price_changed": true, 'back_lean_roof_style_price_changed': true, 'back_lean_width_price_changed': true, 'back_lean_length_price_changed': true, 'back_lean_height_price_changed': true, 'back_lean_left_wall_price_changed': true, 'back_lean_front_wall_price_changed': true, 'back_lean_back_wall_price_changed': true, "back_lean_certificate_price_changed": true, "back_lean_utility_price_changed": true, "back_lean_roof_pitch_price_changed": true,"left_front_wrap_connection_fee_changed":true,"right_front_wrap_connection_fee_changed":true,"right_back_wrap_connection_fee_changed":true,"left_back_wrap_connection_fee_changed":true,"front_lean_insulation_price_changed":true,"left_lean_insulation_price_changed":true, "right_lean_insulation_price_changed":true,"back_lean_insulation_price_changed":true,'roof_color_price_changed':true,'wall_color_price_changed': true,'trim_color_price_changed':true, "truss_price_changed": true},
    inputs: [],
    Componentinputs: [],
    MoreTaxinputs: [],
    CheckSnowLoadValue: 35,
    CheckSnowLoadFlag: false,
    loginRememberMe: false,
    additionalFeaturesArray: [],
    additionalFeaturesArrayWithPosition:[],
    ExtraItemsFeaturesArray: [],
    extraItemsFeaturesCost: [],
    extraItemsFeaturesQuantityCost: [],
    ExtraItemsFeaturesQuantityArray: [],
    ExtraItemsFeaturesDropdownQuantityArray: [],
    makeCertificateArrayLeft: {},
    makeCertificateArrayRight: {},
    makeCertificateArrayFront: {},
    makeCertificateArrayBack: {},
    frontCertArr: {},
    leftCertArr: {},
    rightCertArr: {},
    backCertArr: {},
    stateChangeflag: "",
    stateMenuChangeflag: "",
    loginErrorHandlingMessage: '',
    username: '',
    defalutProductLoad: false,
    loginSession: false,
    isShowfeedbackModule: false,
    IsMentananceWindow: false,
    logininitial: false,
    defaultBuildingArr: [],
    checkLoadDefaultBuildingRespone: false,
    sideDistance1: 0,
    FrontLeandrop_arr: {},
    BackLeandrop_arr: {},
    LeftLeandrop_arr: {},
    RightLeandrop_arr: {},
    llsh: false,
    rlsh: false,
    flsh: false,
    blsh: false,
    rlff: false,
    llff: false,
    font: "",
    p_i_o_other: "",
    doorWall: '',
    sign_jpeg: '',
    sigPad: {},
    textureImageForRoofSecond: '',
    textureImageForRoof: '',
    textureImageForRoofL: '',
    textureImageForRoofR: '',
    leanGetDataLeftComparision: '',
    leanGetDataFrontComparision: '',
    leanGetDataBackComparision: '',
    leanGetDataRightComparision: '',
    leanGetDataRight: '',
    leanGetDataLeft: '',
    newLeanArr: [],
    dimensionsLeanLWF: [],
    dimensionsLeanLDF: [],
    dimensionsLeanLHF: [],
    dimensionsLeanLWB: [],
    dimensionsLeanLDB: [],
    dimensionsLeanLHB: [],
    dimensionsLeanLH: [],
    dimensionsLeanLW: [],
    dimensionsLeanLD: [],
    dimensionsLeanLH: [],
    dimensionsLeanLWR: [],
    dimensionsLeanLDR: [],
    dimensionsLeanLHR: [],
    leanGetDataFront: '',
    leanGetDataBack: '',
    leanGetDataLeft: '',
    leanGetDataRight: '',
    mapIdforLean: "",
    leantoCompare: [],
    leanto: [],
    checkoutModal: false,
    isShowSaveLater: false,
    isShowSaveLaterForPdf:false,
    isShowDoorwindowmobile: false,
    resizeCalledOnce: '',
    walkFrameoutInitialValue: '',
    walkInitialValue: '',
    windowsFrameoutInitialValue: '',
    windowsInitialValue: '',
    customFrameoutInitialSize: '',
    garageInitialValue: '',
    confirmStateError: false,
    confirmState: false,
    tabCountDisplay: false,
    ClickforPhotosMobile: false,
    doorProperty: {},
    pos: '',
    submitCheckoutBtn: false,
    shippingState: '',
    editComponentDimension: '',
    commonDoorType: '',
    doorUniqueId: '',
    legCutFee: false,
    legCutFeeMnfs: [8, 121, 122],
    doorUniqueIndex:'',
    object_name: '',
    billingState: '',
    paymentFailedMessage: false,
    stripeErrorHandlingMessage: '',
    showDefaultInsullation: false,
    BuildingRoofPitch: {},
    BuildingLRoofPitch: {},
    showInsulation: true,
    frameDimension: '',
    frameHDimension: '',
    invoicePDFURL: '',
    showWainscotJSX: false,
    showWallColorJSX: false,
    showComponentEditBox: false,
    timer: null,
    showCupolaEditBox: false,
    hasDoublelegshow: false,
    hasDoublelegName: 'Single',
    hasDoublelegdisable: false,
    leanHasDoublelegshow: false,
    leanHasDoublelegName: 'Single',
    leanHasDoublelegdisable: false,
    leanFHasDoublelegshow: false,
    leanFHasDoublelegName: 'Single',
    leanFHasDoublelegdisable: false,
    leanRHasDoublelegshow: false,
    leanRHasDoublelegName: 'Single',
    leanRHasDoublelegdisable: false,
    leanBHasDoublelegshow: false,
    leanBHasDoublelegName: 'Single',
    leanBHasDoublelegdisable: false,
    compareLeanLegs :{leftLean:{}, rightLean:{}, frontLean:{}, backLean:{}},
    isAutoRotate: false,
    cupolaObj:{},
    componentLabel: "",
    StopPRAPI: false,
    checkoutBtnDisabled: false,
    orderLaterSubmitBtn: false,
    checkValidatePattern: false,
    checkValidate: false,
    checkStripeID: false,
    pdfURL: '',
    exactDoorType: 'Garage',
    targetRedirectUrl: {
        "order":
        {
            "create": "orders/3d_create?sensei=2.0",
            "edit": "orders/3d_edit/",
            "view": "orders/",
            "duplicate": "orders/3d_duplicate/",
            "visualform": "create",
        },
        "quote":
        {
            "create": "quotes/3d_create?sensei=2.0",
            "edit": "quotes/3d_edit/",
            "view": "quotes/",
            "duplicate": "quotes/3d_duplicate/",
            "visualform": "create",
        },
        "inventory":
        {
            "create": "inventory/3d_create?sensei=2.0",
            "edit": "inventory/3d_edit/",
            "view": "inventory/",
            "duplicate": "inventory/3d_duplicate/",
            "visualform": "create",
        },

    },

    paymentOption: (window.paymentOption != undefined) ? window.paymentOption : { "enabled": "yes", "testmode": "yes", "key": "", "test_secret_key": "", "publishable_key": "", "secret_key": "", "type": 1 },
    // crmSetting :(window.crmSetting!=undefined)?window.crmSetting:{"crm_product_id":"21","api_token":"xhkZaSoQHjhlFHCOQgesOnsy7o1juN0tkg8wMfk8JAVljzl4XdPsPj5AzlDeZnoT","stripe_detail":{"enabled":"yes","testmode":"yes","test_publishable_key":"pk_test_rdFjxhfdgUp51mDhmHz2VjTL","test_secret_key":"","publishable_key":"","secret_key":""},"api_post_url":"https://crm.senseicrm.com", "email":"hello@americanmetalbuildings.com","phone_number": "+1 (888) 896-0027"},
    //crmSetting :(window.crmSetting!=undefined)?window.crmSetting:{"crm_product_id":"11","api_token":"1ygRgrlamRCw72eCT0uBKtGwLKNhyLTSMGv65pgwhiPxuT9rybMIrhvjjVFTGL8W","stripe_detail":{"enabled":"yes","testmode":"yes","test_publishable_key":"pk_test_rdFjxhfdgUp51mDhmHz2VjTL","test_secret_key":"","publishable_key":"","secret_key":""},"api_post_url":"https://10x.cibirix.com", "email":"hello@americanmetalbuildings.com","phone_number": "+1 (888) 896-0027"},
    // 5M0njqYPUOWBbp3Yts2Ktio7FiPqB2tik7BJh7o1Hn94akMjf5UFArj9rXn1e4Sq
    // BuxsjbgSeOWw33lUPMCqZsmbzXWGwcLgV0NOw1UsguS3STvB2z0ffmTKAbU28uDL
    // 1ygRgrlamRCw72eCT0uBKtGwLKNhyLTSMGv65pgwhiPxuT9rybMIrhvjjVFTGL8W
    //9vZYfym4VG99tLmdoqWYI8TYW01klRpr7ywM7SA5 crm 
    //Jr9ORHkgSCav399MX0qVj8nkzQXLIw8X4RJCLpUd pre

    crmSetting: (window.crmSetting != undefined) ? window.crmSetting : {
        "Logo_IMG": "logo.svg",
            "is_Action_url": "order/update",
            "is_CRM": true,
            "login_user_id": "dForU0todjVjd3JoNk5zcVVBM09hQT09",
            "referral_id": "AQ40JK",
            "form_action": "edit",
            "is_Edit": true,
            "is_quote_Edit": 0,
            "module_id_string": '',
            "sub_module": "",
            "sub_module_id": "",
            "is_module_id": "NURMSFNDRDJlYmU5cGZMUmxXaUVZQT09",
            "is_module_name": "inventory",
            "duplicate_module": "",
            "web_url": "https://crm.senseicrm.com",
            "selected_sub_module ": "0",
            "company_name": "Raju company",
            "gTag": false,
            "orderColor": "#D12029",
            "is_loggedin": true,
            "price_api_url": "https://api.senseicrm.com/",
            "header_key": {
                "x-api-key": "9vZYfym4VG99tLmdoqWYI8TYW01klRpr7ywM7SA5"
            },
            "order_now": true,
            "BuisnessName": "Sensei CRM",
            "crm_product_id": "MTI1MTk=",
            "api_token": "13IMU4ZLF9WyrjRj6JuTfVRwGswQVmfBpO39w7bYvaFT93nbcTKE8PnUBv4bWMrM",
            "parent_api_token": "13IMU4ZLF9WyrjRj6JuTfVRwGswQVmfBpO39w7bYvaFT93nbcTKE8PnUBv4bWMrM",
            "stripe_detail": {
                "enabled": "yes",
                "testmode": "yes",
                "test_publishable_key": "pk_test_rdFjxhfdgUp51mDhmHz2VjTL",
                "test_secret_key": "",
                "publishable_key": "",
                "secret_key": ""
            },
            "api_post_url": "https://crm.senseicrm.com",
            "email": "harish@cibirix.com",
            "phone_number": "(347) 674-6098",
            "source": "https://crm.senseicrm.com",
            "form": "Inventory",
            "page": "https://pre.senseicrm.com/inventory/3d_edit/NURMSFNDRDJlYmU5cGZMUmxXaUVZQT09",
            "menu_address": "604, Airen Heights address line -1 testing. AB Road testing.",
            "main_domain_url": "probuiltsteel.com",
            "pre_quote_form":false, 
            "is_zipcode_screen" : false,
            "navigation_url": {"lead":"https:\/\/pre.senseicrm.com\/leads","quote":"https:\/\/pre.senseicrm.com\/quotes","my_account":"https:\/\/pre.senseicrm.com\/settings\/personal","post":"https:\/\/pre.senseicrm.com\/posts-sensei\/R3RTZGJmYzBLa2J3VDBseUtCMGwrdz09","my_team":"https:\/\/pre.senseicrm.com\/users","my_subscription":"https:\/\/pre.senseicrm.com\/subscriptions","logout":"https:\/\/pre.senseicrm.com\/logout","report_error":"https:\/\/pre.senseicrm.com\/tickets"},
            "is_klink_generated" : 0,
            "has_customer_permission": "1",
            "is_CRM_V4": true,
            "latest_api_url": "https://gateway.senseicrm.com/",
            "discount_api_url":"https://gateway.senseicrm.com/",
    },
    componentPriceUpdateData: {},
    stateManufacturer: {},  
    stateManufacturerNewDiscount:{},
    stateManufacturerAcordingAPI: {},
    stateManufacturerAcordingAPIDiscount: {},
    stateNameAcordingAPI: {},
    stateColorAcordingAPI: {},
    editstateColorAcordingAPI: {},
    LogIm: 'data:image/png;base64,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',
    calCulationVal: 0,
    calCulationValIndex: 0,
    checkIsEditData:false,
    twoDImageObj:[],
    twodImageData:'',
    totalWidth: 0,
    color: [],
    isActiveSlide: true,
    downPersentage: 10,
    buildingWidthArrayCust: [],
    buildingLengthArrayCust: [],
    buildingWidthArray: [],
    buildingLengthArray: [],
    buildingHeightArray: [],
    main_gauge_arr: {},
    door_h_arr: {},
    door_w_arr: {},
    selectedRoofColor: '',
    building: [],
    ExtraBuildingID: [],
    roof_style: [],
    roof_style_Barn: [],
    roof_style_Barn_with_centerbuilding: [],
    anchors_cost: [],
    garageDoorColor: [],
    selectedBuilding: [],
    trsArr: {},
    reg_d: "",
    s_v: "",
    bjD: [],
    bjDData: [],
    AllBuildingData: [],
    dtr: {},
    p_l_r: {},
    b_p_r: {},
    r_s_a: {},
    g_d_a: [],
    w_o_a: {},
    w_d_a: {},
    callMesure: false,
    roofAction: true,
    g_d_a_p: [],
    g_d_s_p: [],
    w_o_p: [],
    w_o_p_s: [],
    w_d_p: [],
    w_d_p_s: [],
    showCustomerModal: false,
    isSlidebarOpen: false,
    doorWallArrayValue: { "Front": params.p_f_w, "Back": params.p_b_w, "Left": params.p_l_w, "Right": params.p_r_w },
    //ManageDoorArrar :{"front":[],"back":[],"left":[],"right":[]},
    ManageDoorWallVal: { "front": "Front", "back": "Back", "left": "Left", "right": "Right", "Ltleft": "Left Leanto Left", "Ltright": "Right Leanto Right", "FrontL": "Left Leanto Front", "FrontR": "Right Leanto Front", "BackL": "Left Leanto Back", "BackR": "Right Leanto Back", "LeftS": "Left Leanto Utility Front", "RightS": "Right Leanto Utility Front", "BarnRight": "Right Leanto Right", "BarnLeft": "Left Leanto Left" },

    defaultBuildingJson: {
        "building_id": 4,
        "id": 261,
        "image_name": "Commercial_Buildings.png",
        "leanto": null,
        "leanto_size": "0x0x0",
        "leanto_wall": null,
        "manufacturer_id": 17,
        "name": "Commercial Buildings",
        "other_building_id": "4,10",
        "roof_color": "#2f0e13",
        "roof_id": 3,
        "size": "32x31x9",
        "trim_color": "#2f0e13",
        "utility": 0,
        "wall": "close",
        "wall_color": "#ebe0d3",
    },
    ManageDoorValue: 0,
    walls: [],
    coords: null,
    c_m_a: [],
    c_m_a_Anchors: {},
    c_m_a_Colors: {},
    DistanceArr: [],
    DistanceArrCompare: [],
    ConditionArr: [],
    ConditionArrForLean: [],
    ConditionArrCompare: [],
    conditionArrForLeanCompare: [],
    BarnConditionArr: [],
    main_extraItems_arr: { "Select": "Select" },
    t_c: 0,
    t_c_b: 0,
    g_v: "14",
    map: { '2': 'box_style_cost', '1': 'regular_cost', '3': 'vertical_roof_cost', '8': 'regular_cost', '4': 'vertical_roof_cost', '5': 'box_style_cost', '6': 'vertical_roof_cost', '7': 'box_style_cost' },
    e_i_a: [],
    e_i_b_a: [0],
    g_v_a: [],
    c_f_a: [],
    c_f_a_per: [],
    c_f_a_sCer: [],
    c_f_aCer: [],
    c_f_i_a: [],
    c_f_a_b: [],
    c_f_i_a_b: [],
    c_f_b_a: [],
    f_r_o_d: "", f_r_o_d_p: 0,
    d_w_a_r: [],
    a_p_d_a: [],
    a_p_d_a_b: [],
    door_arry: { 'window': [], 'garage': [], 'door': [], 'frameout': [] },
    c_k_p_d: true,
    d_v_i: "front",
    d_b_u_g: false,
    i_c_l_g: true,
    i_c_l_g_n: true,
    checkIval: 0,
    SetFlag: false,
    b_r_p_a: [],
    b_r_p_l_to_a: [],
    container: '',
    scene: '',
    camera: '',
    renderer: '',
    controls: '',
    tween: '',
    dragControls: '',
    b_h_t1Bx: '',
    b_h_t2Bx: '',
    b_h_t3Bx: '',
    b_h_t4Bx: '',
    b_h_t5Bx: '',
    b_h_t6Bx: '',
    b_h_t7Bx: '',
    b_h_t8Bx: '',
    ground: '',
    foundation: '',
    c_b_g_p: '',
    c_b_g_f: '',
    c_b_g_b: '',
    c_b_g_r: '',
    b_i_g_B: '',
    b_B_g_B: '',
    b_r_f_R: '',
    b_r_f_L: '',
    b_r_f_l_t_L: '',
    b_r_f_l_t_R: '',
    b_r_f_E_R: '',
    b_r_f_E_L: '',
    b_m_a_n: '',
    b_a_p_l: '',
    b_t_u_k: '',
    b_d_a_y: '',
    b_c_p_2: '',
    b_c_p_3: '',
    halfTruss: '',
    b_l_g: '',
    b_T_t_L_u: '',
    b_T_t_L_u_S: '',
    driveway: '',
    truck: '',
    b_w_b_c_l: '',
    b_w_b_c_r: '',
    b_f_g_p: '',
    b_f_g_p_r_L: '',
    b_f_g_p_r_R: '',
    b_t_M_R: new THREE.Group(),
    b_t_M_L: new THREE.Group(),
    F_S_L_R: new THREE.Group(),
    b_t_M_F_t_F: new THREE.Group(),
    b_t_M_B_t_B: new THREE.Group(),
    b_t_M_L_t_L: new THREE.Group(),
    b_t_M_R_t_R: new THREE.Group(),
    wainScote: new THREE.Group(),
    R_F_P: new THREE.Group(),
    L_F_P: new THREE.Group(),
    R_B_P: new THREE.Group(),
    L_B_P: new THREE.Group(),
    L_F_L_P: new THREE.Group(),
    R_F_L_P: new THREE.Group(),
    b_t_M_L_t_R: '',
    wallsForCut: {},
    originalLeg: null,
    originalConnector: null,
    legsForCut: {
        front: {},
        back: {},
        left: {},
        right: {},
        frontLean: {},
        backLean: {},
        leftLean: {},
        rightLean: {},
        leftFrontLean: {},
        leftBackLean: {},
        rightFrontLean: {},
        rightBackLean: {},
        frontFrontLean: {},
        frontBackLean: {},
        backFrontLean: {},
        backBackLean: {}
    },
    legsForCutFee: {
        left: {},
        right: {},
        leftLean: {},
        rightLean: {},
        frontLean: {},
        backLean: {},
    },

    originalWainscot: null,
    originalChannel: null,
    c_b_h_c: [],
    Webbing: '',
    b_r_c_r: '', b_w_c_r: '', b_t_c_r: '', b_w_s_c_r: '',
    b_a_d_I_O_t: '',
    b_s_t_s: '',
    b_p_i_g_u_l: '',
    b_i_d_e: false,
    b_s_c_s_X: 0,
    b_s_c_s_Y: 0,
    b_i_R_z_D: false,
    b_m_P_s_X: 0,
    b_m_P_s_Y: 0,
    checkBitly: false,
    b_s_c_n: null,
    offset: new THREE.Vector3(),
    custDM: {},
    b_d_g_b_O_c: [],
    b_d_g_b_O_cN: [],
    b_d_g_b_O_cObj: {},
    b_d_g_b_O_c1: [],

    raycaster: new THREE.Raycaster(),

    b_m_i_w: '', b_m_x_w: '', b_m_i_h: '', b_m_x_h: '', b_m_i_l: '', b_m_x_l: '', b_m_x_lC: '', b_m_i_hlean: '',
    arrayendLengthRoof: [],
    BuildingMinWidth: [],
    b_c_h_I_g: false,
    b_I_g_n_e: "building-normal.jpg",
    b_r_g_v: "",
    b_f_w_C: false,
    b_f_w_B: false,
    vVal: -0.030,
    sum: 1,
    b_r_d_V: "",
    leanto: [],
    b_o_J_1: {},
    b_f_o_J: {},
    post_data: {},
    entry_points: [],
    CheckDoorForEdit: false,
    b_l_o_J: {},
    Map_Id: {},
    defaultBuildingImgName: "",
    bTypeJson: {
        'Garages': {
            'door': { 'Size': [{ 'size': '8X8', 'wall': 'fend', 'pos': { 'x': 0.47607825542070437, 'y': 0, 'z': 0 }, 'TrimKit': false }], },
        },
        'Triple_Wide_Garages': {
            'door': { 'Size': [{ 'size': '8X8', 'wall': 'fend', 'pos': { 'x': -6.010555550834087, 'y': 3.2, 'z': 0 }, 'TrimKit': false }, { 'size': '8X8', 'wall': 'fend', 'pos': { 'x': 5.023228140694575, 'y': 3.2, 'z': 0 }, 'TrimKit': false }], },
        },
        'Raised_Center_Barns': {
            'door': { 'Size': [{ 'size': '10X8', 'wall': 'fend', 'pos': { 'x': 0.47607825542070437, 'y': 0, 'z': 0 }, 'TrimKit': false }], },
        },
        'Utility_Buildings': {
            'door': { 'Size': [{ 'size': '10X8', 'wall': 'fend', 'pos': { 'x': 0.42771661532304966, 'y': 0, 'z': 11 }, 'TrimKit': false }], },
        },
        'Commercial_Buildings': {
            'door': { 'Size': [{ 'size': '10X8', 'wall': 'fend', 'pos': { 'x': 0.47607825542070437, 'y': 0, 'z': 0 }, 'TrimKit': false }], },
        },
        'Free_Standing_Buildings': {
            'door': { 'Size': [{ 'size': '8X8', 'wall': 'rside', 'pos': { 'x': -6.010555550834087, 'y': 3.2, 'z': 0 }, 'TrimKit': false }, { 'size': '8X8', 'wall': 'rside', 'pos': { 'x': 5.023228140694575, 'y': 3.2, 'z': 0 }, 'TrimKit': false }], },
        },
    },
    TypeAlingnment: {
        "1": "center",
        "2": "front",
        "3": "back",
        "4": "custom",
    },
    endLeanAlingnmentType: {
        "1": "center",
        "2": "Left",
        "3": "Right",
        "4": "custom",
    },
    endLeanAlingnmentTypeReverse: {
            "center": 1,
            "Left": 2,
            "Right": 3,
            "custom": 4,
    },
    TypeAlingnmentReverse: {
        "center": 1,
        "front": 2,
        "back": 3,
        "custom": 4,
    },
    TypeWallName: {
        "open": "Opened",
        "close": "Closed",
        "gable": "Gable",
        "extended_gable": "Extended Gable",
        "one_fourth_close": "1/4 Closed",
        "three_fourth_close": "3/4 Closed",
        "half_close": "1/2 Closed",
        "half dutch end": "Half Dutch End",
        "half end": "Half End",
    },
    TypeWallNameForEdit: {
        "open": "Open",
        "close": "Close",
        "gable": "Gable",
        "extended_gable": "Extended Gable",
        "one_fourth_close": "One_Fourth_Close",
        "three_fourth_close": "Three_Fourth_Close",
        "half_close": "Half_Close",
        "half dutch end": "Half Dutch End",
        "half end": "Half End",
    },
    TypeEnum: {
        "1": "Regular",
        "2": "A-frame",
        "3": "Vertical",
        "8": "Regular",
        "4": "Vertical",
        "5": "A-frame",
        "6": "Vertical",
        "7": "A-frame",
    },
    TypeEnumForRoofChange: {
        1: 0,
        2: 1,
        3: 2,
    },
    TypeEnumID: {
        "1": "Regular",
        "2": "A-frame",
        "3": "Vertical",
        "8": "Regular Roof Barn",
        "4": "Raised Center Vertical",
        "5": "Raised Center",
        "6": "Continous Roof Vertical",
        "7": "Continous Roof",
    },
    TypeEnumINDEX: {
        "1": "0",
        "2": "1",
        "3": "2",
        "8": "4",
        "4": "0",
        "5": "1",
        "6": "2",
        "7": "3",
    },
    WallClass: {
        "front": "fend",
        "back": "bend",
        "left": "lside",
        "right": "rside",
    },

    WallClassEdit: {
        "fend": "front",
        "bend": "back",
        "lside": "left",
        "rside": "right",
    },
    installationValue: {
        "1": "Concrete",
        "2": "Asphalt",
        "3": "Ground",
        "4": "Gravel",
    },
    // r_f_p_w_arr: [5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40],
    r_f_p_w_arr: [],
    l_f_p_w_arr: [],
    r_b_p_w_arr: [],
    l_b_p_w_arr: [],
    r_f_p_d_arr: [],
    r_b_p_d_arr: [],
    l_f_p_d_arr: [],
    l_b_p_d_arr: [],
    b_u_D_p_a7: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40],
    b_u_D_p_a6: [
        3, 4, 5, 6, 7, 8, 9, 10,
        11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
        31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
        41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
        51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
        61, 62, 63, 64, 65, 66, 67, 68, 69, 70,
        71, 72, 73, 74, 75, 76, 77, 78, 79, 80,
        81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
        91, 92, 93, 94, 95, 96, 97, 98, 99, 100
    ],
    b_u_D_p_a5: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90],
    b_u_D_p_a4: [4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72, 76, 80, 84, 88],
    b_u_D_p_a: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120, 125, 130, 135, 140, 145, 150, 155, 160, 165, 170, 175, 180, 185, 190, 195, 200, 205, 210, 215, 220, 225, 230, 235.240, 245, 250, 255, 260, 265, 270, 275, 280, 285, 290, 295, 300],
    b_u_D_p_a_c_b: [
        3, 4, 5, 6, 7, 8, 9, 10,
        11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
        31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
        41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
        51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
        61, 62, 63, 64, 65, 66, 67, 68, 69, 70,
        71, 72, 73, 74, 75, 76, 77, 78, 79, 80,
        81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
        91, 92, 93, 94, 95, 96, 97, 98, 99, 100
    ],
    b_u_D_p_a_c_b_l: [
        3, 4, 5, 6, 7, 8, 9, 10,
        11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
        31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
        41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
        51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
        61, 62, 63, 64, 65, 66, 67, 68, 69, 70,
        71, 72, 73, 74, 75, 76, 77, 78, 79, 80,
        81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
        91, 92, 93, 94, 95, 96, 97, 98, 99, 100
    ],
    leantoleft: {
        alignment: "center",
        back_wall: "open",
        back_wall_price: 0,
        back_wall_vertical: false,
        basic_price: 0,
        continous_lean: false,
        front_wall: "open",
        front_wall_price: 0,
        front_wall_vertical: false,
        height: 8,
        height_price: 0,
        leanto_drop: null,
        leanto_type: 1,
        length: 31,
        pricing_data: "",
        roof_pitch: "3/12",
        roof_pitch_name: "3/12",
        roof_pitch_price: 0,
        side_wall: "open",
        side_wall_price: 0,
        side_wall_vertical: false,
        width: 12,
    },
    leantoright: {
        alignment: "center",
        back_wall: "open",
        back_wall_price: 0,
        back_wall_vertical: false,
        basic_price: 0,
        continous_lean: false,
        front_wall: "open",
        front_wall_price: 0,
        front_wall_vertical: false,
        height: 8,
        height_price: 0,
        leanto_drop: null,
        leanto_type: 2,
        length: 31,
        pricing_data: "",
        roof_pitch: "3/12",
        roof_pitch_name: "3/12",
        roof_pitch_price: 0,
        side_wall: "open",
        side_wall_price: 0,
        side_wall_vertical: false,
        width: 12,
    },
    b_M_g_V: 0.02,
    defaultProData: '',
    cutPanleLeftCheckL: true,
    cutPanleLeftCheckR: true,
    b_n_B_d: "",
    b_t_x_P_g: [],
    c_h_L_I_g: "",
    c_h_L_I_g1: "",
    s_L_d_C_k: 0,
    c_h_k_I_g_U_d: "",
    c_h_k_S_l_d: false,
    i_g_A_y: [],
    displayerrorMessage: {},
    c_h_L_d_V: true,
    d_r_a_m_l: {},
    c_h_d_M_l: false,
    checkFVL: "",
    checkFVR: "",
    H_d_l_D_r_ar: { 'front': [], 'back': [] },
    c_k_Do_po_s: "",
    c_k_C_n_s: false,
    I_g_m_ar_R: {},
    main_posGet: "",
    chkPrmVl: "",
    chkTabbedVal: "",
    chkModValByTab: false,
    drop_arr: {},
    d_w_a_r_N_w: [],
    colorTable: {},
    g_d_a_pD: [],
    CallApionAction: false,
    isPriceAPIcalled:false,
    place_d: false,
    chk_place: true,
    cmpObj_place: true,
    legstype: "single",
    leanLegstype: "single",
    leanFLegstype: "single",
    leanRLegstype: "single",
    leanBLegstype: "single",
    insulationJson: [],
    insulationPriceJson: [],
    insulationArrayForLeantoLeft: [],
    insulationArrayForLeantoFront: [],
    insulationArrayForLeantoBack: [],
    insulationArrayForLeantoRight: [],
    insulationPriceJsonCompare: [],
    insulationArrayForLeantoLeftCompare: {},
    insulationArrayForLeantoFrontCompare: {},
    insulationArrayForLeantoBackCompare:{},
    insulationArrayForLeantoRightCompare: {},
    compareInsulationForMainBuilding:{},
    compareInsulationForRightLeanto:{},
    compareInsulationForLefttLeanto:{},
    compareInsulationForFrontLeanto:{},
    compareInsulationForBacktLeanto:{},
    colorTableNext: {},
    MainuId: "",
    makeArrayForComponent: [],
    makeArrayForComponent_Barn: [],
    makeArrayForComponent_BarnR: [],
    Manidata: [{ "id": 1, "name": "Alabama", "manufacturer_id": 8 }, { "id": 2, "name": "Arizona", "manufacturer_id": 4 }, { "id": 3, "name": "Arkansas", "manufacturer_id": 11 }, { "id": 4, "name": "California", "manufacturer_id": 6 }, { "id": 5, "name": "Colorado", "manufacturer_id": 11 }, { "id": 6, "name": "Connecticut", "manufacturer_id": 8 }, { "id": 7, "name": "Delaware", "manufacturer_id": 8 }, { "id": 8, "name": "Florida", "manufacturer_id": 3 }, { "id": 9, "name": "Georgia", "manufacturer_id": 8 }, { "id": 10, "name": "Idaho", "manufacturer_id": 11 }, { "id": 11, "name": "Illinois", "manufacturer_id": 11 }, { "id": 12, "name": "Indiana", "manufacturer_id": 7 }, { "id": 13, "name": "Iowa", "manufacturer_id": 4 }, { "id": 14, "name": "Kansas", "manufacturer_id": 11 }, { "id": 15, "name": "Kentucky", "manufacturer_id": 8 }, { "id": 16, "name": "Louisiana", "manufacturer_id": 9 }, { "id": 17, "name": "Maryland", "manufacturer_id": 8 }, { "id": 18, "name": "Massachusetts", "manufacturer_id": 8 }, { "id": 19, "name": "Michigan", "manufacturer_id": 7 }, { "id": 20, "name": "Minnesota", "manufacturer_id": 4 }, { "id": 21, "name": "Mississippi", "manufacturer_id": 11 }, { "id": 22, "name": "Missouri", "manufacturer_id": 11 }, { "id": 23, "name": "Montana", "manufacturer_id": 11 }, { "id": 24, "name": "Nebraska", "manufacturer_id": 11 }, { "id": 25, "name": "Nevada", "manufacturer_id": 11 }, { "id": 26, "name": "New Jersey", "manufacturer_id": 8 }, { "id": 27, "name": "New Mexico", "manufacturer_id": 11 }, { "id": 28, "name": "New York", "manufacturer_id": 8 }, { "id": 29, "name": "North Carolina", "manufacturer_id": 8 }, { "id": 30, "name": "North Dakota", "manufacturer_id": 8 }, { "id": 31, "name": "Ohio", "manufacturer_id": 8 }, { "id": 32, "name": "Oklahoma", "manufacturer_id": 11 }, { "id": 33, "name": "Oregon", "manufacturer_id": 11 }, { "id": 34, "name": "Pennsylvania", "manufacturer_id": 8 }, { "id": 35, "name": "South Carolina", "manufacturer_id": 8 }, { "id": 36, "name": "South Dakota", "manufacturer_id": 8 }, { "id": 37, "name": "Tennessee", "manufacturer_id": 8 }, { "id": 38, "name": "Texas", "manufacturer_id": 9 }, { "id": 39, "name": "Utah", "manufacturer_id": 11 }, { "id": 40, "name": "Virginia", "manufacturer_id": 8 }, { "id": 41, "name": "West Virginia", "manufacturer_id": 8 }, { "id": 42, "name": "Wisconsin", "manufacturer_id": 4 }, { "id": 43, "name": "Wyoming", "manufacturer_id": 11 }, { "id": 44, "name": "Washington", "manufacturer_id": 8 }, { "id": 45, "name": "Maine", "manufacturer_id": 8 }, { "id": 46, "name": "New Hampshire", "manufacturer_id": 8 }, { "id": 47, "name": "Rhode Island", "manufacturer_id": 8 }, { "id": 48, "name": "Vermont", "manufacturer_id": 8 }],
    checkFunCalling: false,
    DiscountData: "",
    Heading: "",
    newComponentArray: {},
    CustomDoorArr: {
        'Garage': { 'Size': {}, 'Object': {}, 'SidePrice': {}, 'EndPrice': {}, 'TrimKit': {}, 'Chain_Hoist': {}, 'Header_Seal': {}, 'Is_Chain_Hoist': {}, 'Is_Header_Seal': {}, 'Is_Certified': {}, 'Certified_Cost': {}, 'Is_Automatic_Openers': {}, 'Automatic_Openers_Cost': {}, 'garageDoorColor': {} },
        'sectionalGarage': { 'Size': {}, 'Object': {}, 'SidePrice': {}, 'EndPrice': {}, 'TrimKit': {}, 'Chain_Hoist': {}, 'Header_Seal': {} },
        'Walk': { 'Size': {}, 'Object': {}, 'SidePrice': {}, 'EndPrice': {} },
        'WalkFrameout': { 'Size': {}, 'Object': {}, 'SidePrice': {}, 'EndPrice': {} },
        'Windows': { 'Size': {}, 'Object': {}, 'SidePrice': {}, 'EndPrice': {} },
        'WindowsFrameout': { 'Size': {}, 'Object': {}, 'SidePrice': {}, 'EndPrice': {} },
        'GarageFrameout': { 'Size': {}, 'Object': {}, 'SidePrice': {}, 'EndPrice': {}, 'TrimKit': {} },
        'CustomFrameout': { 'Size': {}, 'Object': {}, 'SidePrice': {}, 'EndPrice': {}, 'TrimKit': {}, 'Width': {}, 'Height': {} }
    },
    CustomDoorArrForOtherBtype: {},
    ManageDoorWallVal: { "front": "Front", "back": "Back", "left": "Left", "right": "Right", "Ltleft": "Left Leanto Left", "Ltright": "Right Leanto Right", "FrontL": "Left Leanto Front", "FrontR": "Right Leanto Front", "BackL": "Left Leanto Back", "BackR": "Right Leanto Back", "LeftS": "Left Leanto Utility Front", "RightS": "Right Leanto Utility Front", "BarnRight": "Right Leanto Right", "BarnLeft": "Left Leanto Left" },
    ManageDoorArrar: { "front": [], "back": [], "left": [], "right": [], "ltleft": [], "ltright": [], "ltfront": [], "ltback": [], "frontl": [], "frontr": [], "leftf": [], "backl": [], "backr": [], "rightf": [], "lefts": [], "rights": [], "fronts": [], "backs": [], },
    ManageGlobalComponent: { "front": [], "back": [], "left": [], "right": [], "ltleft": [], "ltright": [], "ltfront": [], "ltback": [], "frontl": [], "frontr": [], "leftf": [], "backl": [], "backr": [], "rightf": [], "lefts": [], "rights": [], "fronts": [], "backs": [], },
    ManageSpaces: [],
    ManageDoorPlaces: {
        "front": { "Garage": true, "CustomFrameout": true, "Walk": true, "WalkFrameout": true, "Windows": true, "WindowsFrameout": true, "GarageFrameout": true },
        "back": { "Garage": true, "CustomFrameout": true, "Walk": true, "WalkFrameout": true, "Windows": true, "WindowsFrameout": true, "GarageFrameout": true },
        "left": { "Garage": true, "CustomFrameout": true, "Walk": true, "WalkFrameout": true, "Windows": true, "WindowsFrameout": true, "GarageFrameout": true },
        "right": { "Garage": true, "CustomFrameout": true, "Walk": true, "WalkFrameout": true, "Windows": true, "WindowsFrameout": true, "GarageFrameout": true },
        "ltleft": { "Garage": true, "CustomFrameout": true, "Walk": true, "WalkFrameout": true, "Windows": true, "WindowsFrameout": true, "GarageFrameout": true },
        "ltright": { "Garage": true, "CustomFrameout": true, "Walk": true, "WalkFrameout": true, "Windows": true, "WindowsFrameout": true, "GarageFrameout": true },
        "frontl": { "Garage": true, "CustomFrameout": true, "Walk": true, "WalkFrameout": true, "Windows": true, "WindowsFrameout": true, "GarageFrameout": true },
        "frontr": { "Garage": true, "CustomFrameout": true, "Walk": true, "WalkFrameout": true, "Windows": true, "WindowsFrameout": true, "GarageFrameout": true },
        "backl": { "Garage": true, "CustomFrameout": true, "Walk": true, "WalkFrameout": true, "Windows": true, "WindowsFrameout": true, "GarageFrameout": true },
        "backr": { "Garage": true, "CustomFrameout": true, "Walk": true, "WalkFrameout": true, "Windows": true, "WindowsFrameout": true, "GarageFrameout": true },
        "lefts": { "Garage": true, "CustomFrameout": true, "Walk": true, "WalkFrameout": true, "Windows": true, "WindowsFrameout": true, "GarageFrameout": true },
        "rights": { "Garage": true, "CustomFrameout": true, "Walk": true, "WalkFrameout": true, "Windows": true, "WindowsFrameout": true, "GarageFrameout": true },
        "fronts": { "Garage": true, "CustomFrameout": true, "Walk": true, "WalkFrameout": true, "Windows": true, "WindowsFrameout": true, "GarageFrameout": true },
    },
    persistWallVal: { "front": "Open", "back": "Open", "left": "Open", "right": "Open", "cutpanel_Left": false, "cutpanel_Right": false, "AllWall": false, "Utility": false },
    lightUpdate: "",
    PointLight11: '', PointLight111: '', PointLight: '', PointLight1: '',
    textureUrl: '',
    textureLoader: '',
    textureWidth: '',
    textureWidthLeft: '',
    textureWidthRight: '',
    textureDepth: '',
    textureHalfTruss1Width: '',
    textureHalfTruss1Depth: '',
    textureHalfTruss2Width: '',
    textureHalfTruss2Depth: '',
    textureHalfTruss3Width: '',
    textureHalfTruss3Depth: '',
    textureHalfTruss4Width: '',
    textureHalfTruss4Depth: '',
    isShowAlert: false,
    isShowCompare: false,
    alertUsedFor: "",
    selectedTabKeyForWheel: 'statechange',
    stateHelpTextContent: false,
    colorsHelpTextContent: false,
    buildSizeHelpTextContent: false,
    leantoHelpTextContent: false,
    wallsHelpTextContent: false,
    doorWindowHelpTextContent: false,
    extraHelpTextContent: false,
    isHalfEnclosedChecked: false,
    isHalfEnclosedCheckedVal: "",
    isShowbuildingtype: false,
    isShowbuildingtypeArr: [],
    colorTable: {
        CardinalRed: "0x9c132e",
        TrueBurgundy: "0x7a2527",
        PebbleBeige: "0xd9dabb",
        Clay: "0xccc7c0",
        EarthBrown: "0x4e3227",
        Evergreen: "0x274e37",
        Black: "0x212121",
        Gray: "0x8c8d8e",
        QuakerGray: "0x575a5d",
        Sandstone: "0xd2d0b5",
        SlateBlue: "0x44687d",
        Tan: "0xbe9272",
        White: "0xffffff",
        BarnRed: "0xa63f1e",
        VintageBurgundy: "0x5a2c34",
        KingBlue: "0x3380b8"
    },
    /* APi Manager Constant */
    BASE_URL: "https://pricing.senseicrm.com:3006/api/",
    GET_BUILDING_APi: "getBuildingData",
    GET_PRICEING_APi: "getBuildingPricing",
    order_extra_items: {
        job_site_level: "no",
        inside_city: "no",
        installation_ready: "no",
        surface_level: "no",
        electricity: "no",
        welded_spacer:'no',
        notched_lip:'no',
        space_around_building:'no',
        site_clear_obstacle:'no',
        permit: "yes",
        order_permit_fee:0,
        includeIn: "",
        equipment_rental: 0,
        document_fee: 0,
        order_processing_fee: 0,
        surchargeFees: 0,
        delivery_fee: 0,
        engineer_drawings: 0,
        freight: 0,
        extra_labour: 0,
        processing_fee: 0,
        grvy_value: 0,
        has_grvy: 0,
        concrete_work: 0,
        ground_work: 0,
        pdf_price_breakdown: "0",
        dont_show_processing_fee_pdf: 1,
        engineer_drawings_name: '' , //{'name': 'None', 'cost': 0},
    },
    moveBoxName: "",
    showComponentDeleteAlert: false,
    isFrontLeanFront: false,
    isFrontLeanRight: false,
    isFrontLeanLeft: false,
    isBackLeanFront: false,
    isBackLeanRight: false,
    isBackLeanLeft: false,
    isLeftLeanFront: false,
    isLeftLeanBack: false,
    isLeftLeanLeft: false,
    isCenterFront: false,
    isCenterBack: false,
    isCenterRight: false,
    isCenterLeft: false,
    isRightLeanFront: false,
    isRightLeanBack: false,
    isRightLeanRight: false,
    componentNameForAlert: "",

    // 2d layout
    layout2DMapId: 0,
    generated2DMapId: null,
    componentCount:{"door":1,"window":1},
    isBillingAddressSame: false,
    }

    export const kFront = "front";
    export const kBack = "back";
    export const kLeft = "left";
    export const kRight = "right";
    export const kLeftCutPanel = "leftCutPanel";
    export const kRightCutPanel = "rightCutPanel";
    export const kFronttCutPanel = "frontCutPanel";
    export const kBackCutPanel = "backCutPanel";
    export const kYES = "YES";
    export const kNO = "NO";

    export const initialState = {

    /****************  Giorgi  **********************/
    mainTrussPosInfo: [],
    nonLoggedInpriceCompareData:null,
    leanToTrussPosInfo: {
        frontLeanTo: [],
        leftLeanTo: [],
        rightLeanTo: [],
        backLeanTo: []
    },
    isLeanDragging: false,
    wallCloseStateWrap : {},
    leftWallCloseState : 0,
    rightWallCloseState : 0,
    isShowEditIconSection: false,
    selectedCmpType: 'none',
    backStoragePositionZ: 0,
    leftLeanStoragePositionZ: 0,
    rightLeanStoragePositionZ: 0,
    frontLeanStoragePositionX: 0,
    backLeanStoragePositionX: 0,
    /****************  Giorgi  **********************/
    isfullviewbuilding : false,
        infoMessage: false,
    oldFreeStandingData: {},
    roof_check:false,
    infoMessage: false,
    horizontalSliderRange:0,
    verticalSliderRange:0,
    iscustompopup:false,
    isShowBuynowConfirm:false,
    isCustomizeBuilding:false,
    isShowSpecification:false,
    isMobile: false,
    isShowMobileBuildingSummary:false,
    doorWindowIconsPos: [],
    feetVal:0,
    cupolaEditIconsPos: [],
    changeOtherBuildingTypeName: '',
    editDataChangeAction: '',
    AdditionComponentAdd: '',
    AdditionNewComponentAdd: '',
    isNeedToReRender: "NO",
    checkValidateKeyValue: false,
    selectedTrimColor: '',
    selectedWallColor: '',
    isFullyEnclosedChecked: false,
    isFullyEnclosedCheckedForFrontLeanTo: false,
    isFullyEnclosedCheckedForBackLeanTo: false,
    isFullyEnclosedCheckedForLeftLeanTo: false,
    isFullyEnclosedCheckedForRightLeanTo: false,
    fullyEnclosed: '',
    checkedBuildingType: '',
    ends: {},
    sides: {},
    lentoEnds: {},
    lentoSides: {},
    p_l_r: {},
    p_l_rL: {},
    p_l_rR: {},
    b_p_r: {},
    b_p_rR: {},
    jsonDataR: "",
    jsonDataL: "",
    frontlentoEnds: {},
    frontlentoSides: {},
    backlentoEnds: {},
    backlentoSides: {},
    leftlentoEnds: {},
    leftlentoSides: {},
    rightlentoEnds: {},
    rightlentoSides: {},
    selectedOption: null,
    c_m_a: [],
    b_m_i_w: [],
    const_var: const_var,
    isAllVerticalChecked: false,
    params: params,
    newColor: '',
    defaultRoof: "0",
    defaultBuilding: "",
    OlddefaultBuilding: "",
    b_m_i_w: '',
    selectedTabKey: 'buildingtypetab',
    selectedTabstate: 'statechange',
    isShowThankYou: false,
    isShowMoreDetail: false,
    isShowTalkExpert: false,
    isShowShare: false,
    isShowImage: -1,
    isShowMobileImage:false,
    isShowConnectBox: '',
    isShowCallForPricing:false,
    isShowDownloadProgressBar: false,
    isShowSaveThankBox: false,
    isShowThankBox:false,
    isShowWhatThis: false,
    isShowfeedback: false,
    isShowfeedbackloader: false,
    iswelcomeModal:false,
    isShowSuccessOq: false,
    isShowSummaryModal: false,
    isShowComparePriceModal: false,
    screenShareModal: false,
    isShowPhotoModal: false,
    isShowOverlay: false,
    selectedManufacturer: 0,
    isShowShareModal: false,
    priceBookFile: '',
    alertUsedFor: "",
    isFullyOpenedChecked: false,
    isFullyOpenedCheckedForFrontLeanTo: false,
    isFullyOpenedCheckedForBackLeanTo: false,
    isFullyOpenedCheckedForLeftLeanTo: false,
    isFullyOpenedCheckedForRightLeanTo: false,
    showFullPageLoader: '',
    defaulProductLoad: false,
    holdPreviousRoofStyle: 3,
    holdCurrentRoofStyle: 3,
    carportDirectData: [],
    activemaintabkey:'builtSize',
    checkwallposition:'',
    checkwrapside:'',
    doorDataType:'',
    windowDataType:'',
    doorData:[],
    windowData:[],
    carportDirectData:{},
    activeWall: "c_b_f_w",
    activeLeanWalls: {
        "leftlean":"L_L_F_W",
        "rightlean":"R_L_F_W",
        "frontlean":"F_L_F_W",
        "backlean":"B_L_F_W",
        "leftleanstorage":"L_L_F_S_W",
        "rightleanstorage":"R_L_F_S_W",
        "frontleanstorage":"F_L_F_S_W",
        "backleanstorage":"B_L_F_S_W",
    },
    doorSizesData:[],
    defaultBuilding:[],
    buildingDimension:{},
    buildingStructure:{},
    legsData:[],
    utilityPosition:"",
    windowSizesData:[],
    doorComponent:[],
    windowComponent:[],
    colorData:[],
    leanTosWidth:[],
    leanTosHeight:[],
    leanTosLength:[],
    emojiindex: 4,
    isShowPredesignOption:true,
    isMobileDraw: false,
    isShowBookDemo: true,
    selectedPiceAndSummaryMobileView: 0,
    copyShareText: "Copy Link",
    updateStateForlean:false,
    showThumb: false,
    discount_Offers_all: [],
    }

    let f_S_LeanLegScale = {
    "1": { "6": 0.000, "7": 0.050, "8": 0.10, "9": 0.100, "10": 0.100, "11": 0.100, "12": 0.00, "13": 0.00, "14": 0.10, "15": 0.15, "16": 0.20, "17": 0.20, "18": 0.20, "19": 0.20, "20": 0.20, "21": 0.20, "22": 0.20, "23": 0.20, "24": 0.20, "25": 0.20, "26": 0.20, "27": 0.20, "28": 0.20, "29": 0.20, "30": 0.20, },
    "2": { "6": 0.83, "7": 0.95, "8": 1.1, "9": 1.3, "10": 1.3, "11": 1.6, "12": 1.9, "13": 2.0, "14": 2.2, "15": 2.4, "16": 2.6, "17": 2.9, "18": 2.9, "19": 3.1, "20": 3.2, "21": 3.33, "22": 3.65, "23": 3.9, "24": 4.05, "25": 2.9, "26": 2.9, "27": 2.9, "28": 2.9, "29": 2.9, "30": 2.9, },
    "3": { "6": 1.40, "7": 1.70, "8": 2.06, "9": 2.24, "10": 2.60, "11": 2.78, "12": 3.10, "13": 3.20, "14": 3.50, "15": 3.70, "16": 4.02, "17": 4.25, "18": 4.30, "19": 4.60, "20": 4.90, "21": 5.20, "22": 5.55, "23": 5.65, "24": 5.95, "25": 0.55, "26": 0.55, "27": 0.60, "28": 0.65, "29": 0.70, "30": 0.75, },
    "4": { "6": 0.175, "7": 0.200, "8": 0.25, "9": 0.300, "10": 0.350, "11": 0.375, "12": 0.35, "13": 0.35, "14": 0.40, "15": 0.45, "16": 0.50, "17": 0.55, "18": 0.60, "19": 0.65, "20": 0.70, "21": 0.70, "22": 0.75, "23": 0.75, "24": 0.80, "25": 0.85, "26": 0.85, "27": 0.90, "28": 0.95, "29": 1.00, "30": 1.05, },
    "5": { "6": 0.250, "7": 0.300, "8": 0.35, "9": 0.425, "10": 0.475, "11": 0.525, "12": 0.50, "13": 0.55, "14": 0.60, "15": 0.65, "16": 0.70, "17": 0.75, "18": 0.85, "19": 0.90, "20": 0.95, "21": 1.00, "22": 1.05, "23": 1.10, "24": 1.15, "25": 1.20, "26": 1.25, "27": 1.30, "28": 1.35, "29": 1.40, "30": 1.45, },
    "6": { "6": 0.350, "7": 0.450, "8": 0.50, "9": 0.575, "10": 0.650, "11": 0.700, "12": 0.70, "13": 0.80, "14": 0.90, "15": 0.95, "16": 1.00, "17": 1.05, "18": 1.15, "19": 1.20, "20": 1.30, "21": 1.35, "22": 1.40, "23": 1.50, "24": 1.60, "25": 1.65, "26": 1.70, "27": 1.75, "28": 1.85, "29": 1.90, "30": 2.00, },
    };

    let activeWallP = "";

    const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {



    /************************** Giorgi ************************* */
    case 'setSelectedCmpType': {
        state.selectedCmpType = action.value
        return {
            ...state,
            action
        }
    }

    case 'setIsShowEditIconSection': {
        state.isShowEditIconSection = action.value
        return {
            ...state,
            action
        }
    }

    case "changeLeanDragState": {
        state.isLeanDragging = action.isDrag;

        return {
            ...state,
            action
        }
    }

    case "setMainTrussPosInfo":
        {
            state.mainTrussPosInfo = action.value;
            return {
                ...state,
                action
            }
        }

    case "setLeanToTrussPosInfo":
        {
            state.leanToTrussPosInfo = {
                ...state.leanToTrussPosInfo,
                ...action.value.data
            };
            return {
                ...state,
                action
            }
        }

    case "updateLeanToPosition": {
        if (action.name === 'front') {
            state.params.leanF_p_pos = action.position;
        } else if (action.name === 'back') {
            state.params.leanB_p_pos = action.position;
        } else if (action.name === 'left') {
            state.params.lean_p_pos = action.position;
        } else if (action.name === 'right') {
            state.params.leanR_p_pos = action.position;
        }

        return {
            ...state,
            action
        }
    }

    case "ADDINSPIRATIONALQUOTES": {
        state.const_var.inspirationalQuotesData = action.data || [];
        return {
            ...state,
            inspirationalQuotesData:action.data || []
        }
    }

    case "updateDoorWindowsArray": {
        // console.log('giorgi- updateDoorWindowsArray: ', {action});
        state.const_var.newDoorsArray = action.newArray;
        let newDataArra = [];
        if(const_var.newDoorsArray)
        {
            const_var.newDoorsArray.map((item,index) => {
                // console.log(item,index,"const_var.entry_points")
                let findIndex = const_var.entry_points.findIndex(data=>data.uniqueId==item.uniqueId);
                if(findIndex!== -1)
                {
                    const_var.entry_points[findIndex].cutLegCount = item.cutLegCount
                    if(const_var.entry_points[findIndex].entry_type != undefined && (const_var.entry_points[findIndex].entry_type == "walkin" || const_var.entry_points[findIndex].entry_type == "window" || const_var.entry_points[findIndex].entry_type=="walk_in_door")){
                        utils.updateWalkinWindowlegCutPrice(const_var.entry_points[findIndex].uniqueId)
                    }
                    newDataArra.push(const_var.entry_points[findIndex]);
                }
            })
        }
        if(newDataArra.length== const_var.newDoorsArray.length)
        {
            const_var.oldEntry_points = const_var.entry_points;
            const_var.entry_points = newDataArra;
        }

        else if (const_var.newDoorsArray.length > const_var.entry_points.length && const_var.oldEntry_points) {
            const restEntry_points = const_var.oldEntry_points.filter((item) => !const_var.entry_points.some((element) => element.uniqueId === item.uniqueId));
            const_var.entry_points = const_var.entry_points.concat(restEntry_points);
        } else {
            const_var.oldEntry_points = const_var.entry_points;
        }

        if(action.isChk!=undefined && action.isChk)
        {
            cuBuilding.cP();
            if(params.p_u_c == true || params.cB_addStorage_check_left == true || params.cB_addStorage_check_right){
                const_var.UpdatedPriceData.utility_price_changed = true
            }
            if(params.cB_addStorage_check_front){
                const_var.UpdatedPriceData.front_utility_price_changed = true
            }
        }
        //console.log(newDataArra,const_var.entry_points,action.newArray,"const_var.entry_points")
        return {
            ...state,
            action
        }
    }

    case "updateDoorWindowPosition": {
        // console.log('giorgi- updateDoorWindowPosition: ', {action});
        const tempArray = [...const_var.newDoorsArray]
        const doorIndex = tempArray.findIndex((item) => item.uniqueId === action.doorUniqueId);
        if (doorIndex !== -1) {
            if (action.positionX !== undefined) {
                tempArray[doorIndex].positionX = action.positionX;
                tempArray[doorIndex].position.positionX = action.positionX;
            }
            if (action.positionY !== undefined) {
                tempArray[doorIndex].positionY = action.positionY;
                tempArray[doorIndex].position.positionY = action.positionY;
            }
            state.const_var.newDoorsArray = tempArray;
        }

        const tempArray1 = [...const_var.entry_points]
        const doorIndex1 = tempArray1.findIndex((item) => item.uniqueId === action.doorUniqueId);
        if (doorIndex1 !== -1) {
            if (action.positionX !== undefined) {
                tempArray1[doorIndex1].entry_position.positionX = action.positionX;
            }
            if (action.positionY !== undefined) {
                tempArray1[doorIndex1].entry_position.positionY = action.positionY;
            }
            state.const_var.entry_points = tempArray1;
        }
        //console.log(tempArray,const_var.entry_points,action,"const_var.entry_points")
        return {
            ...state,
            action
        }
    }


    case "updateBackStoragePositionZ": {
        state.backStoragePositionZ = action.positionZ;
        return {
            ...state,
            action
        }
    }

    case "updateLeftLeanStoragePositionZ": {
        state.leftLeanStoragePositionZ = action.positionZ;
        return {
            ...state,
            action
        }
    }

    case "updateRightLeanStoragePositionZ": {
        state.rightLeanStoragePositionZ = action.positionZ;
        return {
            ...state,
            action
        }
    }

    case "updateFrontLeanStoragePositionX": {
        state.frontLeanStoragePositionX = action.positionX;
        return {
            ...state,
            action
        }
    }

    case "updateBackLeanStoragePositionX": {
        state.backLeanStoragePositionX = action.positionX;
        return {
            ...state,
            action
        }
    }

    case "updateCupolasArray": {
        const tempArr = [...action.newArray]
        state.const_var.cupolas = tempArr;
        let newCupolaArra = [];
            if(state.const_var.cupolas)
            {
                state.const_var.cupolas.map((item,index) => {
                    let findIndex = const_var.cupolaEntries.findIndex(data=>data.uniqueId == item.uniqueId);
                    if(findIndex !== -1)
                    {
                        newCupolaArra.push(const_var.cupolaEntries[findIndex]);
                    }
                })
            }
        if(newCupolaArra.length== state.const_var.cupolas.length)
        {
            const_var.cupolaEntries = newCupolaArra;
        }

        return {
            ...state,
            action
        }
    }


    case "updateCupolas": {
        const tempArray = [...const_var.cupolas]
        const cupolaIndex = tempArray.findIndex(item => item.uniqueId === action.uniqueId);
        if (cupolaIndex !== -1) {
            tempArray[cupolaIndex].positionZ = action.positionZ;
            state.const_var.cupolas = tempArray;
        }
        return {
            ...state,
            action
        }
    }

    case "updateDoorWindowLimitPosition":
        {
            const tempArray = [...const_var.newDoorsArray];
            const objIndex = tempArray.findIndex(item => item.uniqueId === action.doorUniqueId);
            if (objIndex !== -1) {
                tempArray[objIndex].minLimitX = action.minLimitX;
                tempArray[objIndex].maxLimitX = action.maxLimitX;
                state.const_var.newDoorsArray = tempArray;
            }
            return {
                ...state,
                action
            }
        }

    case "changeDoorWindowSize":
        const validationValue = editValidation({
            compType: action.compType,
            compName: action.compName,
            width: action.width,
            height: action.height,
            wallname: action.wallName,
            parentkey: action.parentkey,
            childkey: action.childkey,
            nestedkey: action.nestedkey,
            positionX: action.positionX,
            positionY: action.positionY,
            sideArray: action.sideArray,
        });
        if(validationValue.isEdit) {
            const tempArray = [...const_var.newDoorsArray]
            const doorIndex = tempArray.findIndex((item) => item.uniqueId === action.doorUniqueId);
            if (doorIndex !== -1) {
                tempArray[doorIndex].width = action.width;
                tempArray[doorIndex].height = action.height;
                tempArray[doorIndex].positionX = action.positionX;
                tempArray[doorIndex].positionY = action.positionY;
                tempArray[doorIndex].minLimitX = validationValue.minLimitX;
                tempArray[doorIndex].maxLimitX = validationValue.maxLimitX;
                tempArray[doorIndex].actual_val = action.width + "x" + action.height;
                tempArray[doorIndex].size = (action.compType === 'garage_door' || action.compType === 'garage_door_frameout') ? action.width + "x" + action.height : (action.width * 12) + "x" + (action.height * 12);
                state.const_var.newDoorsArray = tempArray;
            }
        } else {
            state.const_var.showComponentEditBox = false;
            let alertText = '';
            if (action.compType === 'garage_door' || action.compType === 'garage_door_frameout') {
                alertText = "NoMoreGarageDoorsCanBeAdded"
            } else if (action.compType === 'walkin' || action.compType === 'walkin_frameout') {
                alertText = "NoMoreWalkInDoorsCanBeAdded"
            } else if (action.compType === "window" || action.compType === "window_frameout") {
                alertText = "NoMoreWindowsCanBeAdded"
            }
            state.const_var.isShowAlert = !state.const_var.isShowAlert;
            state.const_var.alertUsedFor = alertText;
        }
        return {
            ...state,
            action
        }

    case "updateChangeSizeType":
        const doorIndex = const_var.newDoorsArray.findIndex((item) => item.uniqueId === action.doorUniqueId);
        if (doorIndex !== -1) {
            state.const_var.newDoorsArray[doorIndex].isCustomSizeChange = action.isCustomSizeChange;
        }
        return {
            ...state,
            action
        }

    case "alertDone":        
        const_var.chknewCount++;
        if (state.const_var.alertUsedFor == "FULLYENCLOSED") {
            state.isFullyEnclosedChecked = !state.isFullyEnclosedChecked;
            fullyWallEnclosed(state);
        } else if (state.const_var.alertUsedFor == "ADDUTILITY") {
            state.params.p_u_c = !state.params.p_u_c;
            handleAddUtilityCheckboxChange(state);
        } else if (state.const_var.alertUsedFor == "REMOVECOMPONENT") {
            state.isShowEditIconSection = false;
            state.const_var.showComponentDeleteAlert = false;
            cuComponent.removeComponentFromWall(const_var.doorUniqueId);
        } else if (state.const_var.alertUsedFor == "noSpaceAvailableOnWall") {
            state.isShowEditIconSection = false;
            state.const_var.showComponentEditBox = false;
            clearTimeout(const_var.timer)
        } else if (state.const_var.alertUsedFor == "CancelOrderQuote") {
            state.isfullviewbuilding = false
            if (const_var.crmSetting.is_Action_url != "order/save" && const_var.crmSetting.is_Action_url != "order/update" ) {
                window.location.href = const_var.crmSetting.web_url + "/" + const_var.targetRedirectUrl[const_var.crmSetting.is_module_name].view + const_var.crmSetting.is_module_id;
            } else {
                // state.selectedTabstate = 'statechange';
            }
        } else if (state.const_var.alertUsedFor == "removeCupola"){
            state.isShowEditIconSection = false;
            cuComponent.updataOrRemoveCupola(const_var.cupolaUniqueId,'','','','','','','','','remove');
            state.cupolaEditIconsPos =[];
        } else if (state.const_var.alertUsedFor == "YourCanNotAddPorch") {
            cuBuilding.cP();
        } else if (state.const_var.alertUsedFor == "nonVerticalRoofStyleForTubulerBuildingMnf") {
            state.params.p_r_s = state.holdCurrentRoofStyle;
            if (const_var.DistanceArr[params.p_b_t][params.p_r_s] == undefined) {
                const_var.DistanceArr[params.p_b_t][params.p_r_s] = (params.isDefaultfourFeet || params.fourth_center_cost) ? 4 : 5;
            }
            makeDimensionArray(state);
            cuBuilding.BuildingUpdate();
            if (params.add_left_lean){
                cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
                cuBuilding.UpdateLeftLean();
            } 
            if (params.add_right_lean) {
                cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
                cuBuilding.UpdateRightLean();
            }
            if (params.add_front_lean) utils.updateFunctionsOnLeantoRemoval("frontLean");
            if (params.add_back_lean) utils.updateFunctionsOnLeantoRemoval("backLean");
        } else if (state.const_var.alertUsedFor == "clearComponent") {
            state.isShowEditIconSection = false;
            cuComponent.removeAlltheComponent();
            state.const_var.cupolaObj = {};
            cuComponent.removeAllCupolas();
            if (!params.is_translusant && state.const_var.selectedTabKeyForWheel == 'doorwindow') { 
            }
        }

        else if(state.const_var.alertUsedFor == "NoMfgExsist"){
            const_var.crmSetting.is_quote_Edit = false;
            const_var.crmSetting.is_Edit = false;
            state.const_var.isShowAlert = false;
            state.const_var.alertUsedFor = "";
            state.isShowSummaryModal = false;
            state.selectedTabstate = 'statechange';
        }

        state.const_var.isShowAlert = false;
        state.const_var.alertUsedFor = "";
        params.preAction = {};
        return {
            ...state,
            newColor: action + state.const_var.isShowAlert + state.const_var.alertUsedFor + state.const_var.showComponentEditBox + state.const_var.showComponentDeleteAlert + const_var.chknewCount
        }

    case "removeComponent":
        // state.const_var.isShowAlert = !state.const_var.isShowAlert;
        // state.const_var.alertUsedFor = "REMOVECOMPONENT";
        state.const_var.doorUniqueId = action.uniqueId;
        // state.const_var.doorUniqueIndex = action.uniqueindex;
        // state.const_var.object_name = action.component_name;
        state.const_var.showComponentEditBox = false;
        cuComponent.removeComponentFromWall(action.uniqueId);
        // state.const_var.showComponentDeleteAlert = true;
        return {
            ...state,
            newColor: state.const_var.isShowAlert + action.uniqueId + state.const_var.showComponentEditBox + state.const_var.alertUsedFor + state.const_var.showComponentDeleteAlert
        }

    case "showAlert":
        state.const_var.isShowAlert = !state.const_var.isShowAlert;
        state.const_var.alertUsedFor = action.alertText;
        // state.const_var.doorUniqueId = action.uniqueId;
        // state.const_var.doorUniqueIndex = action.uniqueindex;
        // state.const_var.object_name = action.component_name;
        state.const_var.showComponentEditBox = false;
        // state.const_var.showComponentDeleteAlert = true;

        return{
            ...state,
            action
        }

    case 'setActiveBuildingWall':
        state.params.activeWall = action.value;
        state.const_var.focusedSection = cuComponent.wallnameBySec[action.value];

        if(state.const_var.focusedSection == "center" || state.const_var.focusedSection == "") {
            const_var.wallSelection.leanToWall = "select"
        } else {
            const_var.wallSelection.centerBuildingWall = "select"
        }
        
        return {
            ...state,
            action
        }

    case 'setWallCloseStateWrap':
        state.wallCloseStateWrap = {
            ...state.wallCloseStateWrap,
            ...action.value
        }
        return {
            ...state,
            action
        }

        case 'setLeftWallCloseState':
            if(action.key == "left") state.leftWallCloseState = action.value
            if(action.key == "right") state.rightWallCloseState = action.value
            return {
                ...state,
                action
            }
        
    /************************** Giorgi ************************* */



        case "COLOR":
            let newColor = '';
            if (action.str == "Roof") {
                state.params.p_r_c = action.value.hex_value.replace('#', '0x');
                state.params.p_r_c_name = action.value.name;
                state.params.p_r_c_id = action.value.id;
                newColor = action.str + state.params.p_r_c;
                //this.setState({ selectedRoofColor: a.name });
                const_var.UpdatedPriceData.roof_color_price_changed = true;
            } else if (action.str == "Trim") {
                state.params.p_t_c = action.value.hex_value.replace('#', '0x');
                state.params.p_t_c_name = action.value.name;
                state.params.p_t_c_id = action.value.id;
                newColor = action.str + state.params.p_t_c;
                //this.setState({ selectedTrimColor: a.name });
                const_var.UpdatedPriceData.trim_color_price_changed = true;
            } else if (action.str == "Wall") {
                state.params.p_w_c = action.value.hex_value.replace('#', '0x');
                state.params.p_w_c_name = action.value.name;
                state.params.p_w_c_id = action.value.id;
                newColor = action.str + state.params.p_w_c;
                //this.setState({ selectedWallColor: a.name });
                const_var.UpdatedPriceData.wall_color_price_changed = true;
            } else if (action.str == "Wainscot") {
                const_var.UpdatedPriceData.wainscot_color_price = true;
                state.params.p_w_c_c = action.value.hex_value.replace('#', '0x');
                state.params.p_w_c_c_name = action.value.name;
                state.params.p_w_c_c_id = action.value.id;
                newColor = action.str + state.params.p_w_c_c;
                //this.setState({ selectedWallColor: a.name });
                const_var.UpdatedPriceData.wainscot_price_changed = true;
            } else if (action.str == "Door") {
                state.params.g_d_c = action.value.hex_value.replace('#', '0x');
                state.params.g_d_c_name = action.value.name;
                state.params.g_d_c_id = action.value.id;
                newColor = action.str + state.params.g_d_c;
            }
            // const_var.UpdatedPriceData.color_price_changed = true;
            state.selectedID = state.params.p_w_c;
            cuBuilding.cP();
            return {
                ...state,
                newColor: newColor
            }
            break;
        case "publicEditFun":

            if(action.actionType==undefined)
            {
                if(action.key==='fromheader'){
                    const_var.crmSetting.is_quote_Edit = false;
                    const_var.hide_price_calculation = 0;
                    document.querySelector('body').classList.remove("active-hidden-price");
                    document.querySelector('body').classList.add("hidden-customer-edit");
                    // setTimeout(function () {
                    //     cuComponent.onResize();
                    // }, 500);
                }else{
                    state.isShowSummaryModal = !state.isShowSummaryModal;
                    const_var.crmSetting.is_quote_Edit = false;
                    const_var.hide_price_calculation = 0;
                    document.querySelector('body').classList.remove("active-hidden-price");
                    document.querySelector('body').classList.add("hidden-customer-edit");
                    // setTimeout(function () {
                    //     cuComponent.onResize();
                    // }, 500);
                }
            }else{
                if(action.key!='fromheader'){
                state.isShowSummaryModal = !state.isShowSummaryModal;
                }
                const_var.crmSetting.is_quote_Edit = true;
                state.const_var.isShowAlert = true;
                state.const_var.alertUsedFor = "publicAccessURL";
                const_var.alertPubliMessage = action.value;
                document.querySelector('body').classList.remove("active-hidden-price");
                    document.querySelector('body').classList.add("hidden-customer-edit");
                    // setTimeout(function () {
                    //     cuComponent.onResize();
                    // }, 500);
            }
            return{
                ...state,
                newColor:action.value+action.actionType+const_var.crmSetting.is_quote_Edit+const_var.selectedTabKeyForWheel+state.isShowSummaryModal
            }
            break;
        case "ManageKlinkExpire":
            if(action.value==false)
            {
                state.const_var.isShowAlert = true;
                state.const_var.alertUsedFor = "ManageKlinkMessage";
            }else
            {
                state.const_var.isShowAlert = true;
                state.const_var.alertUsedFor = "ManageKlinkExpire";
                const_var.alertExpireMessage = action.value;
            }

            if(state.const_var.isShowAlert==true) {
                document.querySelector('body').classList.remove('active-state-screen')
            }

        return{
            ...state,
            newColor:action.value+state.const_var.isShowAlert+state.const_var.alertUsedFor+const_var.alertExpireMessage
        }    
        break;    
        case "CallPublicAPI":
            // cuComponent.onResize();
            // cuComponent.onResize();
            const_var.isShowEditConfigurationButton = action.value.data.status;
            // setTimeout(function () {
            //     cuComponent.onResize();
            // }, 1000);

            return {
                ...state,
                action
            }
            break;
    case "handleIconClick":
        if (action.value =="door"){
            // let id = action.event.currentTarget.getAttribute("uniqueId");
            let id = action.doorUniqueId;
            let doorObj = const_var.newDoorsArray.find((door) => door.uniqueId === Number(id));
            let doorObjNew = const_var.entry_points.find((door) => door.uniqueId === Number(id));
            if (doorObj) {
                //params.legCutFee= doorObjNew.legCutFee != undefined ? doorObjNew.legCutFee : false;
                const_var.showComponentEditBox = true;
                const_var.doorUniqueId = doorObj.uniqueId;
                params.trimkit = doorObj.DoorObj != undefined ? doorObj.DoorObj.trimkit : false;
                params.header_seal = doorObj.DoorObj != undefined ? doorObj.DoorObj.header_seal : false;
                params.chain_hoist = doorObj.DoorObj != undefined ? doorObj.DoorObj.chain_hoist : false;
                params.automatic_openers = doorObj.DoorObj != undefined ? doorObj.DoorObj.automatic_openers : false;
                params.insulated = doorObj.DoorObj != undefined ? doorObj.DoorObj.insulated : false;
                params.motor = doorObj.DoorObj != undefined ? doorObj.DoorObj.motor : false;
                doorObjNew && Object.keys(doorObjNew).map((e) => {
                    if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price"))  {
                        let prop = e.replace("entry_", "");
                        params[prop] = doorObjNew[e] != undefined ? doorObjNew[e]: false;
                    }
                })

                params.certified_door = doorObj.DoorObj != undefined ? doorObj.DoorObj.certified_door : false;
                params.extra_notes = doorObj.DoorObj != undefined ? doorObj.DoorObj.entry_note : params.extra_notes;
                if(doorObjNew!=undefined && doorObjNew.parent_array_key=="Garage")
                {
                    commonFunctionForColor(doorObjNew.name, doorObjNew.parent_array_key, doorObjNew.child_array_key, doorObjNew.nested_array_key,false,doorObjNew)   
                }                 
            }

            if (const_var.showComponentEditBox==true) {
                setTimeout(() => {
                    let windowInnerHeight = window.innerHeight;
                    let windowInnerWidth = window.innerWidth;
                    let shiftDwBox = document.querySelector('.door-window-drag-inner')
                    let DwEditBoxPos = document.querySelector('.door-window-drag-inner').getBoundingClientRect();
                    let getTransform = shiftDwBox.style.transform.split("translate(")
                    let getTransformnew = getTransform[1].replace(')', '').split(',')
                    let getTransformX = getTransformnew[0].replace('px', '');
                    let getTransformY = getTransformnew[1].replace('px', '');
                    let OpencheckDwEditPos = document.querySelector('.dw-show-edit-box-bottom').getBoundingClientRect();
                    let diffrenceBottom = Math.abs(windowInnerHeight - OpencheckDwEditPos.top) + 80;
                    let diffrenceLeft = Math.abs(OpencheckDwEditPos.left);
                    let finaltransformTop = getTransformY - diffrenceBottom;
                    let finaltransformLeft = getTransformX;

                    if ((OpencheckDwEditPos.top + 60) > windowInnerHeight) {
                        shiftDwBox.style.transform = `translate(${finaltransformLeft}px, ${finaltransformTop}px)`;
                    }
                    if (Math.sign(OpencheckDwEditPos.left) === -1) {
                        shiftDwBox.style.transform = `translate(20px, ${finaltransformTop}px)`;
                    }

                    if (Math.sign(DwEditBoxPos.top) === -1) {
                        shiftDwBox.style.transform = `translate(${finaltransformLeft}px, 0)`;
                    }

                    if (OpencheckDwEditPos.right > windowInnerWidth) {                       
                        shiftDwBox.style.transform = `translate(${windowInnerWidth - 350}px, ${getTransformY}px)`;
                    }
                }, 300)
            }
        }
        if (action.value =="cupola"){
            // let id = action.event.currentTarget.getAttribute("uniqueId");
            let id = action.doorUniqueId;
            let cupolaObj = const_var.cupolas.find((cupola) => cupola.uniqueId === Number(id));
            if (cupolaObj) {
                const_var.showCupolaEditBox = true;
                const_var.cupolaUniqueId = cupolaObj.uniqueId;
            }
        }
        return {
            ...state,
            action
        }
    case "ShowHideTranslusant":
        if(action.key != "doorwindow"){
            params.is_translusant = !params.is_translusant;
        }else{
            params.is_translusant = false;
        }
        utils.makeTranslucent(controls.isCheckActiveTab,params.activeWall,params.is_translusant,const_var.scene);
        return {
            ...state,
            newData : params.is_translusant+Date.now()
        }
        break;
    case "manageSideLeanUI":
        state.params.manageSideLean = action.value;
        return {
            ...state,
            action
        }
        break;
    case "BUILDING":
        return {
            ...state,
            building: newState.building
        }
        break;
    case "changeOtherBuildingTypeName":
        let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
        //params.other_building_type_name = (action.value == "") ? newVal : action.value;
        params.other_building_type_name = action.value;
        params.checkeditName = true;
        if (const_var.post_data.building != undefined) {
            const_var.post_data.building.other_building_type_name = params.other_building_type_name;
            const_var.post_data.building.name = params.other_building_type_name;
        }
        return {
            ...state,
            changeOtherBuildingTypeName: action
        }
        break;
    case "updatePaymentOption":
        let newReder = action.key;
        if (action.key != undefined) {
            const_var.paymentOptionObj[params.paymentmode][action.key] = (action.key == "expiry_date") ? action.event : action.event.replace(/[^a-zA-Z0-9\s]/g, '');
            newReder = action.key+params.paymentmode+action.event;
        } else {
            params.paymentmode = action.event;
            newReder = action.key+params.paymentmode+action.event;
        }
        const_var.post_data['building'].payment_mode = const_var.paymentOptionObj[params.paymentmode];
        return {
            ...state,
            newColor:newReder
        }
        break;
    case "GAUGEACTION":
        state.params.gauge_val_check = !state.params.gauge_val_check;
        if (state.params.gauge_val_check == true) {
            state.params.gauge_val = 12;
        } else {
            state.params.gauge_val = 14;
        }
        const_var.CallApionAction = true;
        state.const_var.g_v = state.params.gauge_val;
        state.params.p_e_i = "";
        if (const_var.UpdatedPriceData.gauge != state.params.gauge_val) {
            const_var.UpdatedPriceData.roof_style_price_changed = true;
            const_var.UpdatedPriceData.height_price_changed = true;
            const_var.UpdatedPriceData.certificate_price_changed = true;
            
            if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
                const_var.UpdatedPriceData.roof_pitch_price_changed = true;
                const_var.UpdatedPriceData.left_lean_roof_pitch_price_changed = true;
                const_var.UpdatedPriceData.right_lean_roof_pitch_price_changed = true;
                const_var.UpdatedPriceData.front_lean_roof_pitch_price_changed = true;
                const_var.UpdatedPriceData.back_lean_roof_pitch_price_changed = true;
                const_var.UpdatedPriceData.surcharge_amount = undefined;
            }
        }
        let newCheckforAPI = false;
        if(const_var.a_p_d_a!=undefined)
        {
            for (let key in action.apiResponseData.center.data)
            {
                const_var.a_p_d_a[key] = action.apiResponseData.center.data[key];
                newCheckforAPI = true;
            }
            if(params.add_left_lean==true)
            {
                newCheckforAPI = false;
                for (let key in action.apiResponseData.left.data)
                {
                    const_var.leanGetDataLeft[key] = action.apiResponseData.left.data[key];
                    newCheckforAPI = true;
                }
                if(const_var.leanGetDataLeft.central_certificate!=undefined && const_var.leanGetDataLeft.central_certificate.length>0)
                {
                    const_var.a_p_d_a.certificate = const_var.leanGetDataLeft.central_certificate;
                    if (const_var.crmSetting.is_Edit != true) {
                        const_var.UpdatedPriceData.certificate_price_changed = true;  
                    }
                }
                if (const_var.leanGetDataLeft.central_side != undefined && const_var.leanGetDataLeft.central_side.length > 0) {
                    const_var.a_p_d_a.side = const_var.leanGetDataLeft.central_side;
                }
                if (const_var.leanGetDataLeft.central_side_full_length != undefined && const_var.leanGetDataLeft.central_side_full_length.length > 0) {
                    const_var.a_p_d_a.full_length_side = const_var.leanGetDataLeft.central_side_full_length;
                }
                if (const_var.leanGetDataLeft.central_insulation != undefined && const_var.leanGetDataLeft.central_insulation.length > 0) {
                    const_var.a_p_d_a.insulation = const_var.leanGetDataLeft.central_insulation;
                }
                if (const_var.leanGetDataLeft.central_end != undefined && const_var.leanGetDataLeft.central_end.length > 0) {
                    const_var.a_p_d_a.end = const_var.leanGetDataLeft.central_end;
                }
                if (const_var.leanGetDataLeft.central_utility_side != undefined && const_var.leanGetDataLeft.central_utility_side.length > 0) {
                    const_var.a_p_d_a.utility_side = const_var.leanGetDataLeft.central_utility_side;
                }
                if (const_var.leanGetDataLeft.end_combo_v3 != undefined && const_var.leanGetDataLeft.end_combo_v3.length > 0) {
                    const_var.a_p_d_a.end_combo_v3 = const_var.leanGetDataLeft.end_combo_v3;
                }
                if (const_var.leanGetDataLeft.side_combo_v3 != undefined && const_var.leanGetDataLeft.side_combo_v3.length > 0) {
                    const_var.a_p_d_a.side_combo_v3 = const_var.leanGetDataLeft.side_combo_v3;
                }
                    if (const_var.leanGetDataLeft.central_trusses != undefined && const_var.leanGetDataLeft.central_trusses.length > 0) {
                    const_var.a_p_d_a.trusses = const_var.leanGetDataLeft.central_trusses;
                }
                utils.updateCenterBuildingPricesOnLeanAPICalls(state, "leanGetDataLeft",'left');
            }
            if(params.add_right_lean==true)
            {
                newCheckforAPI = false;
                for (let key in action.apiResponseData.right.data)
                {
                    const_var.leanGetDataRight[key] = action.apiResponseData.right.data[key];
                    newCheckforAPI = true;
                }
                if(const_var.leanGetDataRight.central_certificate!=undefined && const_var.leanGetDataRight.central_certificate.length>0)
                {
                    const_var.a_p_d_a.certificate = const_var.leanGetDataRight.central_certificate;
                    if (const_var.crmSetting.is_Edit != true) {
                        const_var.UpdatedPriceData.certificate_price_changed = true;  
                    }
                }
                if (const_var.leanGetDataRight.central_side != undefined && const_var.leanGetDataRight.central_side.length > 0) {
                    const_var.a_p_d_a.side = const_var.leanGetDataRight.central_side;
                }
                if (const_var.leanGetDataRight.central_insulation != undefined && const_var.leanGetDataRight.central_insulation.length > 0) {
                    const_var.a_p_d_a.insulation = const_var.leanGetDataRight.central_insulation;
                }
                if (const_var.leanGetDataRight.central_side_full_length != undefined && const_var.leanGetDataRight.central_side_full_length.length > 0) {
                    const_var.a_p_d_a.full_length_side = const_var.leanGetDataRight.central_side_full_length;
                }
                if (const_var.leanGetDataRight.central_end != undefined && const_var.leanGetDataRight.central_end.length > 0) {
                    const_var.a_p_d_a.end = const_var.leanGetDataRight.central_end;
                }
                if (const_var.leanGetDataRight.central_utility_side != undefined && const_var.leanGetDataRight.central_utility_side.length > 0) {
                    const_var.a_p_d_a.utility_side = const_var.leanGetDataRight.central_utility_side;
                }
                if (const_var.leanGetDataRight.end_combo_v3 != undefined && const_var.leanGetDataRight.end_combo_v3.length > 0) {
                    const_var.a_p_d_a.end_combo_v3 = const_var.leanGetDataRight.end_combo_v3;
                }
                if (const_var.leanGetDataRight.side_combo_v3 != undefined && const_var.leanGetDataRight.side_combo_v3.length > 0) {
                    const_var.a_p_d_a.side_combo_v3 = const_var.leanGetDataRight.side_combo_v3;
                }
                if (const_var.leanGetDataRight.central_trusses != undefined && const_var.leanGetDataRight.central_trusses.length > 0) {
                    const_var.a_p_d_a.trusses = const_var.leanGetDataRight.central_trusses;
                }
                utils.updateCenterBuildingPricesOnLeanAPICalls(state, "leanGetDataRight",'right');
            }
            if(params.add_front_lean==true)
            {
                newCheckforAPI = false;
                for (let key in action.apiResponseData.front.data)
                {
                    const_var.leanGetDataFront[key] = action.apiResponseData.front.data[key];
                    newCheckforAPI = true;
                }
                if(const_var.leanGetDataFront.central_certificate!=undefined && const_var.leanGetDataFront.central_certificate.length>0)
                {
                    const_var.a_p_d_a.certificate = const_var.leanGetDataFront.central_certificate;
                    if (const_var.crmSetting.is_Edit != true) {
                        const_var.UpdatedPriceData.certificate_price_changed = true;  
                    }
                }
                if (const_var.leanGetDataFront.central_side != undefined && const_var.leanGetDataFront.central_side.length > 0) {
                    const_var.a_p_d_a.side = const_var.leanGetDataFront.central_side;
                }
                if (const_var.leanGetDataFront.central_side_full_length != undefined && const_var.leanGetDataFront.central_side_full_length.length > 0) {
                    const_var.a_p_d_a.full_length_side = const_var.leanGetDataFront.central_side_full_length;
                }
                if (const_var.leanGetDataFront.central_insulation != undefined && const_var.leanGetDataFront.central_insulation.length > 0) {
                    const_var.a_p_d_a.insulation = const_var.leanGetDataFront.central_insulation;
                }
                if (const_var.leanGetDataFront.central_end != undefined && const_var.leanGetDataFront.central_end.length > 0) {
                    const_var.a_p_d_a.end = const_var.leanGetDataFront.central_end;
                }
                if (const_var.leanGetDataFront.central_utility_side != undefined && const_var.leanGetDataFront.central_utility_side.length > 0) {
                    const_var.a_p_d_a.utility_side = const_var.leanGetDataFront.central_utility_side;
                }
                if (const_var.leanGetDataFront.end_combo_v3 != undefined && const_var.leanGetDataFront.end_combo_v3.length > 0) {
                    const_var.a_p_d_a.end_combo_v3 = const_var.leanGetDataFront.end_combo_v3;
                }
                if (const_var.leanGetDataFront.side_combo_v3 != undefined && const_var.leanGetDataFront.side_combo_v3.length > 0) {
                    const_var.a_p_d_a.side_combo_v3 = const_var.leanGetDataFront.side_combo_v3;
                }
                if (const_var.leanGetDataFront.central_trusses != undefined && const_var.leanGetDataFront.central_trusses.length > 0) {
                    const_var.a_p_d_a.trusses = const_var.leanGetDataFront.central_trusses;
                }
            }
            if(params.add_back_lean==true)
            {
                newCheckforAPI = false;
                for (let key in action.apiResponseData.back.data)
                {
                    const_var.leanGetDataBack[key] = action.apiResponseData.back.data[key];
                    newCheckforAPI = true;
                }
                if(const_var.leanGetDataBack.central_certificate!=undefined && const_var.leanGetDataBack.central_certificate.length>0)
                {
                    const_var.a_p_d_a.certificate = const_var.leanGetDataBack.central_certificate;
                    if (const_var.crmSetting.is_Edit != true) {
                        const_var.UpdatedPriceData.certificate_price_changed = true;  
                    }
                }
                if (const_var.leanGetDataBack.central_side != undefined && const_var.leanGetDataBack.central_side.length > 0) {
                    const_var.a_p_d_a.side = const_var.leanGetDataBack.central_side;
                }
                if (const_var.leanGetDataBack.central_side_full_length != undefined && const_var.leanGetDataBack.central_side_full_length.length > 0) {
                    const_var.a_p_d_a.full_length_side = const_var.leanGetDataBack.central_side_full_length;
                }
                if (const_var.leanGetDataBack.central_insulation != undefined && const_var.leanGetDataBack.central_insulation.length > 0) {
                    const_var.a_p_d_a.insulation = const_var.leanGetDataBack.central_insulation;
                }
                if (const_var.leanGetDataBack.central_end != undefined && const_var.leanGetDataBack.central_end.length > 0) {
                    const_var.a_p_d_a.end = const_var.leanGetDataBack.central_end;
                }
                if (const_var.leanGetDataBack.central_utility_side != undefined && const_var.leanGetDataBack.central_utility_side.length > 0) {
                    const_var.a_p_d_a.utility_side = const_var.leanGetDataBack.central_utility_side;
                }
                if (const_var.leanGetDataBack.end_combo_v3 != undefined && const_var.leanGetDataBack.end_combo_v3.length > 0) {
                    const_var.a_p_d_a.end_combo_v3 = const_var.leanGetDataBack.end_combo_v3;
                }
                if (const_var.leanGetDataBack.side_combo_v3 != undefined && const_var.leanGetDataBack.side_combo_v3.length > 0) {
                    const_var.a_p_d_a.side_combo_v3 = const_var.leanGetDataBack.side_combo_v3;
                }
                if (const_var.leanGetDataBack.central_trusses != undefined && const_var.leanGetDataBack.central_trusses.length > 0) {
                    const_var.a_p_d_a.trusses = const_var.leanGetDataBack.central_trusses;
                }
            }
            const isBuildingOnFourFeetOnCenter = params.fourth_center_cost;
            const isBuildingOnFourFeetOnCenterLegs = const_var.DistanceArr[params.p_b_t][params.p_r_s];
            cuBuilding.makeCertificateArray();

            if (isBuildingOnFourFeetOnCenter != params.fourth_center_cost && isBuildingOnFourFeetOnCenterLegs != const_var.DistanceArr[params.p_b_t][params.p_r_s]){
                cuBuilding.BuildingUpdate(true, "");
                if (params.add_front_lean) cuBuilding.UpdateFrontLean();
                if (params.add_left_lean) cuBuilding.UpdateLeftLean();
                if (params.add_right_lean) cuBuilding.UpdateRightLean();
                if (params.add_back_lean) cuBuilding.UpdateBackLean();
            }

            if ((const_var.ExtraItemsFeaturesArray.length > 0 || params.fourth_center_cost)) {
                calculateLegsCount();
            }

            //const_var.a_p_d_a.side = 
        }
        
        if (state.params.add_left_lean == true && newCheckforAPI == true) {
            const_var.UpdatedPriceData.left_lean_roof_style_price_changed = true;
            const_var.UpdatedPriceData.left_lean_height_price_changed = true;
            const_var.UpdatedPriceData.certificate_price_changed = true;

            cuBuilding.makeCertificateArrayLeft("left");
            if(params.fourth_center_cost==true)
            {
                if (params.add_left_lean) calculateLegsCount(const_var.leanGetDataLeft,'leftLean');
            }
            cuBuilding.cPforLLeanOnly(state.const_var.leanGetDataLeft);
            const_var.is_loader = false;
        }
        if (state.params.add_front_lean == true && newCheckforAPI == true) {
            const_var.UpdatedPriceData.front_lean_roof_style_price_changed = true;
            const_var.UpdatedPriceData.front_lean_height_price_changed = true;
            const_var.UpdatedPriceData.certificate_price_changed = true;
            if(params.fourth_center_cost==true)
            {
                if (params.add_front_lean) calculateLegsCount(const_var.leanGetDataFront,'frontLean');
            }
            cuBuilding.makeCertificateArrayLeft("front");
            cuBuilding.cPforFLeanOnly(state.const_var.leanGetDataFront);
            const_var.is_loader = false;
        }
        if (state.params.add_back_lean == true && newCheckforAPI == true) {
            const_var.UpdatedPriceData.back_lean_roof_style_price_changed = true;
            const_var.UpdatedPriceData.back_lean_height_price_changed = true;
            const_var.UpdatedPriceData.certificate_price_changed = true;
            if(params.fourth_center_cost==true)
            {
                if (params.add_back_lean) calculateLegsCount(const_var.leanGetDataBack,'backLean'); 
            }
            cuBuilding.makeCertificateArrayLeft("back");
            cuBuilding.cPforBLeanOnly(state.const_var.leanGetDataBack);
            const_var.is_loader = false;
        }
        if (state.params.add_right_lean == true && newCheckforAPI == true) {
            const_var.UpdatedPriceData.right_lean_roof_style_price_changed = true;
            const_var.UpdatedPriceData.right_lean_height_price_changed = true;
            const_var.UpdatedPriceData.certificate_price_changed = true;
            if(params.fourth_center_cost==true)
            {
                if (params.add_right_lean) calculateLegsCount(const_var.leanGetDataRight,'rightLean');
            }
            cuBuilding.makeCertificateArrayLeft("right");
            cuBuilding.cPforRLeanOnly(state.const_var.leanGetDataRight);
            const_var.is_loader = false;
        }
        if (state.params.add_right_lean == false && state.params.add_left_lean == false && newCheckforAPI == true) {
            const_var.UpdatedPriceData.roof_style_price_changed = true;
            const_var.UpdatedPriceData.height_price_changed = true;
            const_var.UpdatedPriceData.certificate_price_changed = true;
            cuBuilding.cP();
            const_var.is_loader = false;
        }
        
        return {
            ...state,
            newColor: state.params.gauge_val_check + state.params.gauge_val + const_var.is_loader
        }

    case "handleCanopyCheckboxChange": 
    params.canopy = !params.canopy
    cuBuilding.BuildingUpdate(true)
    // const_var.scene.getObjectByName("C_B_R_P_Legs").visible = false
    // const_var.scene.getObjectByName("C_B_R_P_Roof").visible = false
    return {
        ...state,
        action
    }
    
    
    case "handleCupola": 
    let cupola,cupolaType,dimension,width,length,price,cupolaTypeId,position,cupolaName;
    let prom = Promise.resolve(undefined);
    if (action.option === 'add') {
        params.cupola = true;
        const_var.isCupolaAdded = true;
        cupola = const_var.cupolasData[action.value][0];
        cupolaType = cupola.slug;
        cupolaName = cupola.name;
        cupolaTypeId = cupola.id;
        dimension = cupola.structure;
        width = Number(dimension.split("x")[0]);
        length = Number(dimension.split("x")[1]);
        price = cupola.cost;
        
        const add_Cupola = (cupolaType,width,length,dimension,price,cupolaTypeId,cupolaName) => {
            prom = prom.then(async(res, rej) => {
                const ans = await  cuComponent.addCupola(cupolaType,width,length,dimension,price,cupolaTypeId,cupolaName);
            });
        }
        add_Cupola(cupolaType,width,length,dimension,price,cupolaTypeId,cupolaName)
    }
    else if (action.option === 'update') {
        cupolaType = action.cupola.userData.compType;
        cupolaName = action.cupola.userData.compName;
        cupola = const_var.cupolasData[cupolaType].find(cupola => cupola.id === parseFloat(action.value))
        position = action.cupola.positionZ;
        cupolaTypeId = action.value;
        dimension = cupola.structure;
        width = Number(dimension.split("x")[0]);
        length = Number(dimension.split("x")[1]);
        price = cupola.cost;
        let mode = 'update';
        let cupola_width = action.cupola.width
        let cupolaUniqueId = const_var.cupolaUniqueId
        
        const filterCupolaArr = const_var.cupolas.filter(item => item.uniqueId !== cupolaUniqueId);
        const { isEdit, isChangePos } = cupolaEditValidation(cupolaUniqueId, length, filterCupolaArr, position);
        if (isEdit) {
            const update_Cupola = (cupolaUniqueId,cupolaType,width,length,dimension,price,cupolaTypeId,cupolaName,position,mode,cupola_width) => {
                prom = prom.then(async(res, rej) => {
                    const ans = await  cuComponent.updataOrRemoveCupola(cupolaUniqueId,cupolaType,width,length,dimension,price,cupolaTypeId,cupolaName,position,mode,cupola_width);
                });
            }
            update_Cupola(cupolaUniqueId,cupolaType,width,length,dimension,price,cupolaTypeId,cupolaName,position,mode,cupola_width)
        
            state.cupolaEditIconsPos =[];
            const_var.showCupolaEditBox = false
        } else {
            const_var.showCupolaEditBox = false;
            const_var.isShowAlert = true;
            const_var.alertUsedFor = "noSpaceToUpdateCupola";
        }
    }
    else if (action.option === 'clone') {
        params.cupola = true;
        const_var.isCupolaAdded = true;
        cupola = action.cupola;
        cupolaType = cupola.userData.compType;
        cupolaName = cupola.userData.compName;
        cupolaTypeId = cupola.userData.cupolaTypeId;
        dimension = cupola.dimension;
        width = Number(dimension.split("x")[0]);
        length = Number(dimension.split("x")[1]);
        price = cupola.price;
        const add_Cupola = (cupolaType,width,length,dimension,price,cupolaTypeId,cupolaName) => {
            prom = prom.then(async(res, rej) => {
                const ans = await  cuComponent.addCupola(cupolaType,width,length,dimension,price,cupolaTypeId,cupolaName);
            });
        }
        add_Cupola(cupolaType,width,length,dimension,price,cupolaTypeId,cupolaName)
        const_var.showCupolaEditBox = false;
        const_var.showCupolaEditBox = false
    }
    else if (action.option === 'remove') {
        // state.const_var.isShowAlert = true;
        // state.const_var.alertUsedFor = "removeCupola";
        if(action.cupola == "fromOptionTab") {
            let id = '';
            if(const_var.cupolaEntries != undefined && const_var.cupolaEntries.length > 0) {
                if(action.value == "with_windows") { 
                    id = const_var.cupolaEntries.find((item) => item.cupolaType == "with_windows")?.uniqueId
                } 
                if(action.value == "without_windows") {
                    id = const_var.cupolaEntries.find((item) => item.cupolaType == "without_windows")?.uniqueId
                }
            }
            cuComponent.updataOrRemoveCupola(id,'','','','','','','','','remove');
            state.cupolaEditIconsPos =[];
            
        } else {
            const_var.cupolaUniqueId = action.uniqueId
            const_var.showCupolaEditBox = false;
            state.isShowEditIconSection = false;
            cuComponent.updataOrRemoveCupola(const_var.cupolaUniqueId,'','','','','','','','','remove');
            state.cupolaEditIconsPos =[];
        }
    }
    else if (action.option === 'close') {
        const_var.showCupolaEditBox = false;
        state.cupolaEditIconsPos =[];
    }
    else if (action.option === 'type') {
        const_var.cupolaType = action.value;
    }
    else if (action.option === 'cupolaRoofColor') {
        params.c_r_c = action.value.hex_value.replace('#', '0x');
        let cupola = const_var.cupolaEntries.find((cupola) => cupola.uniqueId === action.uniqueId);
        if (cupola){
            cupola.cupola_roof_color_price = action.value.cost;
            const_var.cupola_roof_color_price = action.value.cost
        }
        
    }
    // const_var.UpdatedPriceData.cupola_price_changed = true;
    const_var.UpdatedPriceData.surcharge_amount = undefined;
    return {
        ...state,
        newColor: action.option + cupola + cupolaType + dimension + width + length + price + cupolaTypeId + position + cupolaName,
        action
    }
    
    case "setPriceForCupola":
        if (action.flag === true) cuBuilding.cP('',undefined,'');
        return {
            ...state,
            newColor:action.flag+action.length
        }
        break;
    case "commonActionCall":
        if(action.key == "closeInfo"){
            const_var.infoMessage = false
        }
        if(action.key=="change_share_text"){
            state.copyShareText = "Copied";
        }
        return{
            ...state,
            action
        }
    break;     
    case "PRICEDATACERTIFICATION":
        // console.log(action , "PRICEDATACERTIFICATION");
        if (action.str == "center") {
            let exactNum = 0;
            const_var.UpdatedPriceData.certificate_price_changed = true;
            const_var.UpdatedPriceData.surcharge_amount = undefined;
            if (params.p_f_w !== "Close" && params.p_f_w !== "Open" && params.p_f_w !== "Half_Close" && params.p_f_w !== "One_Fourth_Close" && params.p_f_w !== "Three_Fourth_Close") {
                const_var.UpdatedPriceData.front_wall_price_changed = true;
            }
            if (params.p_b_w !== "Close" && params.p_b_w !== "Open" && params.p_b_w !== "Half_Close" && params.p_b_w !== "One_Fourth_Close" && params.p_b_w !== "Three_Fourth_Close") {
                const_var.UpdatedPriceData.back_wall_price_changed = true;
            }
            if(action.other!=undefined)
            {
            state.params.p_e_i_other = action.value;
            }else
            {
            state.params.p_e_i =  action.value;
            state.params.p_e_i_other = "";
            }
            let chkDistance = const_var.c_f_aCer.find((data)=>data && data.distance_on_center==4);
            if(action.other==undefined && action.value!="other" && action.value!="Select")
            {
            if(chkDistance!=undefined &&  params.p_e_i == const_var.c_f_aCer[action.value].certificate_id && const_var.c_f_aCer[action.value].distance_on_center!=undefined)
            {
            let chKDefaultVal = false;
            if((const_var.c_f_aCer[action.value].distance_on_center==4))
            {
                params.fourth_center_cost = true;
                const_var.DistanceArr[params.p_b_t][params.p_r_s] = 4;
                params.isDefaultfourFeet = true;

            }else{
                params.fourth_center_cost = (const_var.defaultDistanceOnCenter==4)?true:false;
                const_var.DistanceArr[params.p_b_t][params.p_r_s] = const_var.defaultDistanceOnCenter;
                params.isDefaultfourFeet = false;
            }
            if (params.fourth_center_cost) {
                if (!params.isBreezeway){
                    params.p_u_t = Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s]
                } else {
                    makeDimensionArray(state);
                    updateBreezewayFrameAndStorages({option:"buildingLength"}, undefined,  Number(params.p_h), Number(params.p_d));
                }
            } else {
                if (!params.isBreezeway){
                    params.p_u_t = Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s]
                } else {
                    makeDimensionArray(state);
                    updateBreezewayFrameAndStorages({option:"buildingLength"}, undefined,  Number(params.p_h), Number(params.p_d));
                }
            }

            if((const_var.a_p_d_a.extra_items) && const_var.a_p_d_a.extra_items.length>0 && const_var.a_p_d_a.extra_items[0].checkbox!=undefined)
            {
                let eqiDis = 0;
                if(params.fourth_center_cost == true){
                if(const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined)
                {
                    eqiDis = (params.oncenter_val_with_action!='')?((params.p_d)/parseInt(params.oncenter_val_with_action)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
                }
                } else {
                    if(const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined)
                    {
                        eqiDis = (params.oncenter_val_with_action!='')?((params.p_d)/parseInt(params.oncenter_val_with_action)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0)
                    }
                }
                let dataNew = JSON.parse(JSON.stringify(const_var.a_p_d_a.extra_items[0].checkbox));
                dataNew.map((val, index)=> {
                    if(val.name == "fourth_center_cost" || val.label == "4ft on Center")
                    {
                        // if(const_var.ExtraItemsFeaturesArray.length==0)
                        // {
                        //     const_var.ExtraItemsFeaturesArray[index] = val;
                        // }
                        if(params.fourth_center_cost==true)
                        {
                            const_var.ExtraItemsFeaturesArray[index] = val;
                            const_var.ExtraItemsFeaturesArray[index].quantity = 1;
                            const_var.ExtraItemsFeaturesArray[index].is_checked = (params.fourth_center_cost==true)?true:false;
                            const_var.ExtraItemsFeaturesArray[index].cost = 0;
                            if (const_var.UpdatedPriceData['elements']!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()]!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit!= undefined){
                                const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit = false;
                                const_var.UpdatedPriceData['elements'][val.label.toString()].item_price = 0;
                            }
                        }else{
                            if(const_var.ExtraItemsFeaturesArray!=undefined && const_var.ExtraItemsFeaturesArray[index]!=undefined)
                            {
                                const_var.ExtraItemsFeaturesArray[index].cost = val.cost;
                                const_var.ExtraItemsFeaturesArray[index] = val;
                                const_var.ExtraItemsFeaturesArray[index].is_checked = false;
                                const_var.ExtraItemsFeaturesArray[index].quantity = 1;
                                if (const_var.UpdatedPriceData['elements']!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()]!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit!= undefined){
                                    const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit = false;
                                    const_var.UpdatedPriceData['elements'][val.label.toString()].item_price = val.cost;
                                }
                            }
                        }
                        if(state.const_var.ExtraItemsFeaturesArray[index]!=undefined && state.const_var.ExtraItemsFeaturesArray[index].cost==0 && state.params.fourth_center_cost)
                        {
                            let checkCost = '';
                            if(const_var.a_p_d_a.extra_items!=undefined && const_var.a_p_d_a.extra_items[0].checkbox_quantity!=undefined)
                            {
                                let dataNew = JSON.parse(JSON.stringify(const_var.a_p_d_a.extra_items[0].checkbox_quantity));
                                dataNew.map((val, index)=> {
                                if(val.name=="bows")
                                {
                                    if(val.cost!=0 || val.double_leg!=0 || val.ladder_leg!=0)
                                    {
                                        exactNum = Math.abs(const_var.count_numberofLegs - eqiDis);
                                        let price = (params.p_e_l && const_var.legstype.includes("double") && val.double_leg != 0)?parseFloat(val.double_leg):(params.p_e_l && const_var.legstype.includes("ladder") && val.ladder_leg != 0 )?parseFloat(val.ladder_leg):parseFloat(val.cost);
                                        
                                        if(const_var.ExtraItemsFeaturesArray[index]!=undefined)
                                        {
                                            const_var.ExtraItemsFeaturesArray[index].cost = const_var.ExtraItemsFeaturesArray[index].cost==0?parseFloat(price * exactNum):const_var.ExtraItemsFeaturesArray[index].cost;
                                            
                                            if(params.fourth_center_cost && const_var.defaultDistanceOnCenter==4)
                                            {
                                                const_var.ExtraItemsFeaturesArray[index].cost = 0;
                                            }
                                            if(params.fourth_center_cost && const_var.c_f_aCer[action.value].distance_on_center==4)
                                            {
                                                const_var.ExtraItemsFeaturesArray[index].cost = 0;
                                            }
                                        }
                                                if(val.name == "bows")
                                                {
                                                    if(params.fourth_center_cost==true)
                                                    {
                                                        const_var.ExtraItemsFeaturesQuantityArray[index] = val;
                                                        //params.isDefaultfourFeet = false;
                                                        const_var.ExtraItemsFeaturesQuantityArray[index].quantity = 1;
                                                        const_var.ExtraItemsFeaturesQuantityArray[index].is_checked = (params.fourth_center_cost==true)?true:false;
                                                        const_var.ExtraItemsFeaturesQuantityArray[index].cost = 0;
                                                        const_var.ExtraItemsFeaturesQuantityArray[index].double_leg = 0;
                                                        const_var.ExtraItemsFeaturesQuantityArray[index].ladder_leg = 0;
                                                        const_var.ExtraItemsFeaturesQuantityArray[index].is_edit = false;
                                                        const_var.ExtraItemsFeaturesQuantityArray[index].is_disabled = true;
                                                        if (const_var.UpdatedPriceData['elements']!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()]!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit!= undefined){
                                                            const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit = false;
                                                            const_var.UpdatedPriceData['elements'][val.label.toString()].item_price = 0;
                                                        }
                                                    }else{
                                                        const_var.ExtraItemsFeaturesQuantityArray[index].cost = val.cost;
                                                        const_var.ExtraItemsFeaturesQuantityArray[index] = val;
                                                        const_var.ExtraItemsFeaturesQuantityArray[index].is_checked = false;
                                                        const_var.ExtraItemsFeaturesQuantityArray[index].quantity = 1;
                                                        const_var.ExtraItemsFeaturesQuantityArray[index].is_edit = false;
                                                        const_var.ExtraItemsFeaturesQuantityArray[index].is_disabled = true;
                                                        if (const_var.UpdatedPriceData['elements']!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()]!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit!= undefined){
                                                            const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit = false;
                                                            const_var.UpdatedPriceData['elements'][val.label.toString()].item_price = val.cost;
                                                        }
                                                        
                                                    }
                                                }
                                            
                                    }
                                }
                            })
                            }
                        }else{
                            if(const_var.ExtraItemsFeaturesQuantityArray.length>0)
                            {
                                let FilterIndex = const_var.ExtraItemsFeaturesQuantityArray.findIndex(data=> data && data.name=="bows" && data.is_disabled!=undefined);
                                    if (FilterIndex >= 0){
                                    const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].is_checked = false;
                                    const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].quantity = 1;
                                    const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].is_edit = false;
                                    const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].is_disabled = false;
                                    //const_var.ExtraItemsFeaturesQuantityArray.splice(FilterIndex,1);
                                }
                            }
                            
                        }

                    }
                })
                // let chkFlag = false;
                // console.log(params.fourth_center_cost,"params.fourth_center_cost",const_var.c_f_aCer[action.value].distance_on_center,const_var.post_data['building'].certificate.certificate_id,"==", action.value)
                // if(const_var.post_data['building'].certificate!=undefined && (const_var.post_data['building'].certificate.certificate_id!=undefined || const_var.post_data['building'].certificate.certificate_id==undefined))
                // {
                //     if(const_var.post_data['building'].certificate.certificate_id!=undefined && const_var.post_data['building'].certificate.certificate_id!=action.value)
                //     {
                //         const_var.post_data['building'].certificate.certificate_id = action.value;
                //     }
                //    if(const_var.post_data['building'].certificate.certificate_id==undefined || const_var.post_data['building'].certificate.certificate_id == action.value)
                //    {
                //         if (params.add_front_lean) calculateLegsCount(const_var.leanGetDataFront,'frontLean');
                //         if (params.add_left_lean) calculateLegsCount(const_var.leanGetDataLeft,'leftLean');
                //         if (params.add_right_lean) calculateLegsCount(const_var.leanGetDataRight,'rightLean');
                //         if (params.add_back_lean) calculateLegsCount(const_var.leanGetDataBack,'backLean'); 
                //    } 
                // }
                if(params.fourth_center_cost && const_var.c_f_aCer[action.value].distance_on_center==4 && params.isDefaultfourFeet==true && const_var.defaultDistanceOnCenter==4) 
                {
                    if (params.add_front_lean) calculateLegsCount(const_var.leanGetDataFront,'frontLean');
                    if (params.add_left_lean) calculateLegsCount(const_var.leanGetDataLeft,'leftLean');
                    if (params.add_right_lean) calculateLegsCount(const_var.leanGetDataRight,'rightLean');
                    if (params.add_back_lean) calculateLegsCount(const_var.leanGetDataBack,'backLean'); 
                }
                if(params.fourth_center_cost && const_var.c_f_aCer[action.value].distance_on_center!=4)
                {
                    if (params.add_front_lean) calculateLegsCount(const_var.leanGetDataFront,'frontLean');
                    if (params.add_left_lean) calculateLegsCount(const_var.leanGetDataLeft,'leftLean');
                    if (params.add_right_lean) calculateLegsCount(const_var.leanGetDataRight,'rightLean');
                    if (params.add_back_lean) calculateLegsCount(const_var.leanGetDataBack,'backLean'); 
                }
                if(params.fourth_center_cost && const_var.ExtraItemsFeaturesArray != undefined  && const_var.ExtraItemsFeaturesArray.length > 0 && const_var.c_f_aCer[action.value].distance_on_center==4 )
                {
                    let FilterIndex = const_var.ExtraItemsFeaturesArray.findIndex(data=> data != null && (data.name == "fourth_center_cost" || data.label == "4ft on Center"));
                    if(params.isDefaultfourFeet!=true && FilterIndex >= 0)
                    {
                        if(const_var.ExtraItemsFeaturesArray[FilterIndex].is_checked == true)
                        {
                        if(params.add_front_lean)
                        {
                            if(const_var.leanGetDataFront!=undefined)
                            {
                                if(const_var.leanGetDataFront.building_structure.distance_on_center!=4)
                                {
                                    calculateLegsCount(const_var.leanGetDataFront,'frontLean')
                                }
                            }
                        }if(params.add_left_lean)
                        {
                            if(const_var.leanGetDataLeft!=undefined)
                            {
                                if(const_var.leanGetDataLeft.building_structure.distance_on_center!=4)
                                {
                                    calculateLegsCount(const_var.leanGetDataLeft,'leftLean')
                                }
                            }
                        }if(params.add_right_lean)
                        {
                            if(const_var.leanGetDataRight!=undefined)
                            {
                                if(const_var.leanGetDataRight.building_structure.distance_on_center!=4)
                                {
                                    calculateLegsCount(const_var.leanGetDataRight,'rightLean')
                                }
                            }
                        }if(params.add_back_lean)
                        {
                            if(const_var.leanGetDataBack!=undefined)
                            {
                                if(const_var.leanGetDataBack.building_structure.distance_on_center!=4)
                                {
                                    calculateLegsCount(const_var.leanGetDataBack,'backLean')
                                }
                            }
                        }
                    }
                    }
                }
                
                
            }

            cuBuilding.uUdDCB();
            // cuBuilding.uUdDp();
            cuBuilding.uUdD();
            cuBuilding.leanuUdD();
            cuBuilding.BuildingUpdate(true, "");
            if (params.add_front_lean == true) cuBuilding.UpdateFrontLean();
            if (params.add_left_lean == true) cuBuilding.UpdateLeftLean();
            if (params.add_right_lean == true) cuBuilding.UpdateRightLean();
            if (params.add_back_lean == true) cuBuilding.UpdateBackLean();
            if(const_var.entry_points.length>0){
            }
            cuBuilding.cP();
            }else{
            cuBuilding.cP();
            }
        }else{
            if(params.fourth_center_cost==true)
            {
                const_var.DistanceArr[params.p_b_t][params.p_r_s] = const_var.a_p_d_a.building_structure[0]?.distance_on_center;
                if(const_var.DistanceArr[params.p_b_t][params.p_r_s]==5)
                {
                    params.isDefaultfourFeet =  params.fourth_center_cost = false;
                    if (!params.isBreezeway) {
                        if (state.params.p_u_c) {
                            state.params.p_u_t = Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s]
                        }
                        cuBuilding.uUdD();
                    } else {
                        makeDimensionArray(state);
                        updateBreezewayFrameAndStorages({option:"buildingLength"}, undefined,  Number(params.p_h), Number(params.p_d));
                    }
                    cuBuilding.leanuUdD();
                    cuBuilding.BuildingUpdate(true, "");
                    if (params.add_front_lean == true) cuBuilding.UpdateFrontLean();
                    if (params.add_left_lean == true) cuBuilding.UpdateLeftLean();
                    if (params.add_right_lean == true) cuBuilding.UpdateRightLean();
                    if (params.add_back_lean == true) cuBuilding.UpdateBackLean();
                    if (params.add_front_lean) calculateLegsCount(const_var.leanGetDataFront,'frontLean');
                    if (params.add_left_lean) calculateLegsCount(const_var.leanGetDataLeft,'leftLean');
                    if (params.add_right_lean) calculateLegsCount(const_var.leanGetDataRight,'rightLean');
                    if (params.add_back_lean) calculateLegsCount(const_var.leanGetDataBack,'backLean'); 
                    if(const_var.entry_points.length>0){
                    }
                }
                if((const_var.a_p_d_a.extra_items) && const_var.a_p_d_a.extra_items.length>0 && const_var.a_p_d_a.extra_items[0].checkbox!=undefined)
                {
                    let dataNew = JSON.parse(JSON.stringify(const_var.a_p_d_a.extra_items[0].checkbox));
                    dataNew.map((val, index)=> {
                        if(val.name == "fourth_center_cost" || val.label == "4ft on Center")
                        {
                            if(params.fourth_center_cost==true)
                            {
                                params.isDefaultfourFeet = (const_var.DistanceArr[params.p_b_t][params.p_r_s]==4 && params.isDefaultfourFeet==true)?true:params.isDefaultfourFeet;
                                const_var.ExtraItemsFeaturesArray[index].cost = val.cost;
                                const_var.ExtraItemsFeaturesArray[index] = val;
                                const_var.ExtraItemsFeaturesArray[index].is_checked = params.isDefaultfourFeet==false?false:true;
                                const_var.ExtraItemsFeaturesArray[index].quantity = 1;
                                params.fourth_center_cost = const_var.ExtraItemsFeaturesArray[index].is_checked;
                                if (const_var.UpdatedPriceData['elements']!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()]!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit!= undefined){
                                    const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit = false;
                                    const_var.UpdatedPriceData['elements'][val.label.toString()].item_price = val.cost;
                                }
                            }else{
                                if(const_var.ExtraItemsFeaturesArray!=undefined && const_var.ExtraItemsFeaturesArray[index]!=undefined)
                                {
                                    const_var.ExtraItemsFeaturesArray[index].cost = val.cost;
                                    const_var.ExtraItemsFeaturesArray[index] = val;
                                    const_var.ExtraItemsFeaturesArray[index].is_checked = false;
                                    const_var.ExtraItemsFeaturesArray[index].quantity = 1;
                                    if (const_var.UpdatedPriceData['elements']!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()]!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit!= undefined){
                                        const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit = false;
                                        const_var.UpdatedPriceData['elements'][val.label.toString()].item_price = val.cost;
                                    }
                                }
                            }
                        }
                    })
                }
            }
            if(const_var.ExtraItemsFeaturesQuantityArray.length>0)
            {
                let FilterIndex = const_var.ExtraItemsFeaturesQuantityArray.findIndex(data=> data && data.name=="bows" && data.is_disabled!=undefined);
                if (FilterIndex >= 0 && params.isDefaultfourFeet!=true){
                    const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].is_checked = false;
                    const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].quantity = 1;
                    const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].is_edit = false;
                    const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].is_disabled = false;   
                    // const_var.ExtraItemsFeaturesQuantityArray.splice(FilterIndex,1);
                }
            }
            if(params.fourth_center_cost)
            {
                    if(params.add_front_lean)
                    {
                        if(const_var.leanGetDataFront!=undefined)
                        {
                            if(const_var.leanGetDataFront.building_structure.distance_on_center!=4)
                            {
                                calculateLegsCount(const_var.leanGetDataFront,'frontLean')
                            }
                        }
                    }if(params.add_left_lean)
                    {
                        if(const_var.leanGetDataLeft!=undefined)
                        {
                            if(const_var.leanGetDataLeft.building_structure.distance_on_center!=4)
                            {
                                calculateLegsCount(const_var.leanGetDataLeft,'leftLean')
                            }
                        }
                    }if(params.add_right_lean)
                    {
                        if(const_var.leanGetDataRight!=undefined)
                        {
                            if(const_var.leanGetDataRight.building_structure.distance_on_center!=4)
                            {
                                calculateLegsCount(const_var.leanGetDataRight,'rightLean')
                            }
                        }
                    }if(params.add_back_lean)
                    {
                        if(const_var.leanGetDataBack!=undefined)
                        {
                            if(const_var.leanGetDataBack.building_structure.distance_on_center!=4)
                            {
                                calculateLegsCount(const_var.leanGetDataBack,'backLean')
                            }
                        }
                    }
            }
            cuBuilding.cP();
        }
            
            
            if(params.add_left_lean==true)
            {
                const_var.UpdatedPriceData.certificate_price_changed = true;    
                cuBuilding.cPforLLeanOnly(state.const_var.leanGetDataLeft);
            }if(params.add_right_lean==true)
            {
                const_var.UpdatedPriceData.certificate_price_changed = true;    
                cuBuilding.cPforRLeanOnly(state.const_var.leanGetDataRight);
            }if(params.add_front_lean==true)
            {
                const_var.UpdatedPriceData.certificate_price_changed = true; 
                cuBuilding.cPforFLeanOnly(state.const_var.leanGetDataFront);
            }if(params.add_back_lean==true)
            {
                const_var.UpdatedPriceData.certificate_price_changed = true;    
                cuBuilding.cPforBLeanOnly(state.const_var.leanGetDataBack);
            }
            //cuBuilding.cP();   
            
        }if(action.str=="left")
        {  
            const_var.UpdatedPriceData.certificate_price_changed = true; 
            if(action.other!=undefined)
            {
            state.params.lean_p_e_i_other = action.value;
            }else
            {
            state.params.lean_p_e_i =  action.value;
            state.params.lean_p_e_i_other = "";
            }
            cuBuilding.cPforLLeanOnly(state.const_var.leanGetDataLeft);
        }if(action.str=="front")
        {  
            const_var.UpdatedPriceData.certificate_price_changed = true; 
            if(action.other!=undefined)
            {
            state.params.leanF_p_e_i_other = action.value;
            }else
            {
            state.params.leanF_p_e_i =  action.value;
            state.params.leanF_p_e_i_other = "";
            }
            cuBuilding.cPforFLeanOnly(state.const_var.leanGetDataFront);
        }if(action.str=="back")
        {  
            const_var.UpdatedPriceData.certificate_price_changed = true; 
            if(action.other!=undefined)
            {
            state.params.leanB_p_e_i_other = action.value;
            }else
            {
            state.params.leanB_p_e_i =  action.value;
            state.params.leanB_p_e_i_other = "";
            }
            cuBuilding.cPforBLeanOnly(state.const_var.leanGetDataBack);
        }if(action.str=="right")
        {  
            const_var.UpdatedPriceData.certificate_price_changed = true; 
            if(action.other!=undefined)
            {
            state.params.leanR_p_e_i_other = action.value;
            }else
            {
            state.params.leanR_p_e_i =  action.value;
            state.params.leanR_p_e_i_other = "";
            }
            cuBuilding.cPforRLeanOnly(state.const_var.leanGetDataRight);
        } 
        return {
        ...state,
        newColor: action.str+new Date().getTime(),
        action
        }
        break;
        case "changeBuildingOnCenter":        
                            
        if(action.actionType=="action")
        {
            if(isNaN(params.oncenter_val)==true)
            {
                params.oncenter_val = 2;
            }
            params.oncenter_val_with_action = parseInt(params.oncenter_val);
            //const_var.DistanceArr[params.p_b_t][params.p_r_s] = parseInt(params.oncenter_val);
            cuBuilding.BuildingUpdate(true);
            if (params.add_front_lean == true) cuBuilding.UpdateFrontLean();
            if (params.add_left_lean == true) cuBuilding.UpdateLeftLean();
            if (params.add_right_lean == true) cuBuilding.UpdateRightLean();
            if (params.add_back_lean == true) cuBuilding.UpdateBackLean();
        
        }

        else if (action.actionType=="selectvalue") {
            document.getElementById("distancecenter").select();
        }

        else{
            params.oncenter_val = parseInt(action.value);
        }
        return{
        ...state,
        action
        }
        break;
    case "changeProductStatus":
        state.params.display_product_status = action.event;
        return {
            ...state,
            action
        }
        break;
    case "clearComponents":
        state.const_var.isShowAlert = true;
        state.const_var.alertUsedFor = 'clearComponent'
        return {
            ...state,
            action
        }
        break;

    case "ChangeBackgroundAccordingtoCon":        
    document.querySelector('body').classList.add("canvasloaderbg");
        setTimeout(() => {
        document.querySelector('body').classList.remove("canvasloaderbg");
        }, 1000)          
        state.const_var.crmSetting.is_show_background = !state.const_var.crmSetting.is_show_background; 
        if(state.const_var.crmSetting.is_show_background==true) {
            document.querySelector('body').classList.add("activebuildingbg"); 
        }

        else {
            document.querySelector('body').classList.remove("activebuildingbg"); 
        }
    //    cuBuilding.makeBackgroundwithImage();
        // cuBuilding.wallNameInBackgroundImage("all")
        //setTimeout(() => {const_var.canvasbgloader = false;console.log(const_var.canvasbgloader,"const_var.canvasbgloader");}, 5000)
    
        return {
            ...state,
            newColor: const_var.crmSetting.is_show_background + state.const_var.doorWall + state.const_var.doorWallArrayValue + params.isShowCenter + const_var.canvasbgloader
        }
        break;

        
    
        return {
                ...state,
        }
            break;
    case "priceAPI":
        return {
            ...state,
        }
        break;
    case "DEFAULTBUILDINGDATA":
        state.defaulProductLoad = true;
        setBuildingData(state, action.value, state.defaulProductLoad);
        return {
            ...state,
            newColor: action.value,
            defaulProductLoad: true
        }
        break;
    case "SETDEFAULTCONFIGURATION":
        if(action.value.request_data!=undefined && action.value.request_data.building!=undefined &&action.value.request_data.building.display_building_type_name == "Custom Buildings"){
            state.const_var.checkmoreCustomizeFlag =  true
        }
        state.defaulProductLoad = true
        state.selectedManufacturer = 0;
        //state.const_var.bjD = action.value.data.state
        // let payment_option= {"type":2};
        // state.const_var.paymentOption = (action.value.data.payment_option!=undefined)?action.value.data.payment_option:payment_option;
        if(state.const_var.crmSetting.is_Edit == true) {
            state.selectedTabKey = "buildsizes";
        } else {
            state.selectedTabKey = "buildingtypetab";
        }
        setDefaultConfiguration(state, action.value);
        cuBuilding.BuildingUpdate(true);
        if (params.add_front_lean == true){ 
            cuBuilding.UpdateFrontLean();
        state.checkwallposition = "front";
        };
        if (params.add_left_lean == true) {
            cuBuilding.UpdateLeftLean();
        state.checkwallposition = "left";
        };
        if (params.add_right_lean == true) {
            cuBuilding.UpdateRightLean();
        state.checkwallposition = "right";
        };
        if (params.add_back_lean == true) {
            cuBuilding.UpdateBackLean();
            state.checkwallposition = "back";
        };

        
        return {
            ...state,
            newColor: action.value
        }
        break;
    case "CheckDoorWindowsInstallationFees":
        if(const_var.entry_points.length>0)
        {
            let wallCheckForEnd = false;
            let wallCheckForSide = false;
            const_var.entry_points.map((value,key)=>{
                if(value.parent_array_key=="Garage" || value.parent_array_key=="Garage_Frameout")
                {
                    let currentObjData = const_var.newComponentArray[value.parent_array_key][value.child_array_key][value.nested_array_key]["Size"][value.name];
                    if(currentObjData!=undefined)
                    {
                        if(const_var.entry_wall_location[value.component_wall_name].includes('end')==true)
                        {
                            wallCheckForEnd = true;
                        }
                        if(const_var.entry_wall_location[value.component_wall_name].includes('side')==true)
                        {
                            wallCheckForSide = true;
                        }
                        if (wallCheckForEnd==true && currentObjData.installation_end_wall_fee!=undefined) {
                            value.installation_end_wall_fee = currentObjData.installation_end_wall_fee;
                            value.installation_is_end_wall = currentObjData.installation_is_end_wall;
                        }
                        if (wallCheckForSide==true && currentObjData.installation_side_wall_fee!=undefined) {
                            value.installation_side_wall_fee = currentObjData.installation_side_wall_fee;
                            value.installation_is_side_wall = currentObjData.installation_is_side_wall;
                        }
                    }
                }
            })
            cuBuilding.cP();
        }
    return{
        ...state,
        action
    }    
    case "CheckOtherBuildingType":
        //console.log(action,action.defaultVal);
        state.defaultBuilding = action.defaultVal;
        //console.log(action,action.defaultVal,state.defaultBuilding,const_var.defaultBuildingArr,'const_var.defaultBuildingArr');
        //    console.log(action,"action1111111")
        state.checkedBuildingType = action.value;
        if (const_var.defaultBuildingArr[action.defaultVal].building_id != action.value) {

            if (const_var.defaultBuildingArr[parseInt(action.defaultVal + 1)] == undefined) {
                state.defaultBuilding = parseInt(action.defaultVal + 1);
            }
        }
        //   console.log(action.defaultVal,state.OlddefaultBuilding,"action.defaultVal!=state.OlddefaultBuilding")
        if (action.defaultVal != state.OlddefaultBuilding) {
            delete const_var.defaultBuildingArr[parseInt(action.defaultVal)];
            state.defaultBuilding = state.OlddefaultBuilding;
            action.defaultVal = state.OlddefaultBuilding;
        }
        //console.log(state.defaultBuilding,action,const_var.defaultBuildingArr,'const_var.defaultBuildingArr')
        if (const_var.defaultBuildingArr[action.defaultVal].building_id != action.value) {
            const_var.defaultBuildingJson = {};
            //console.log(state.defaultBuilding,action,const_var.defaultBuildingJson,'const_var.defaultBuildingArr')
            state.defaultBuilding = parseInt(action.defaultVal + 1);
            if (const_var.defaultBuildingArr[action.defaultVal + action.value] == undefined) {
                const_var.defaultBuildingJson.building_id = parseInt(action.value);
                const_var.defaultBuildingJson.id = parseInt(action.defaultVal + 1);
                const_var.defaultBuildingJson.default_doors = const_var.defaultBuildingArr[action.defaultVal].default_doors;
                const_var.defaultBuildingJson.image_name = const_var.defaultBuildingArr[action.defaultVal].image_name;
                const_var.defaultBuildingJson.leanto = const_var.defaultBuildingArr[action.defaultVal].leanto;
                const_var.defaultBuildingJson.leanto_size = const_var.defaultBuildingArr[action.defaultVal].leanto_size;
                const_var.defaultBuildingJson.leanto_wall = const_var.defaultBuildingArr[action.defaultVal].leanto_wall;

                const_var.defaultBuildingJson.central_roof_pitch = const_var.defaultBuildingArr[action.defaultVal].central_roof_pitch;
                const_var.defaultBuildingJson.leanto_roof_pitch = const_var.defaultBuildingArr[action.defaultVal].leanto_roof_pitch;
                const_var.defaultBuildingJson.leanto_data = const_var.defaultBuildingArr[action.defaultVal].leanto_data;
                const_var.defaultBuildingJson.wainscot_color = const_var.defaultBuildingArr[action.defaultVal].wainscot_color;

                const_var.defaultBuildingJson.manufacturer_id = const_var.defaultBuildingArr[action.defaultVal].manufacturer_id;
                const_var.defaultBuildingJson.name = const_var.defaultBuildingArr[action.defaultVal].name;
                const_var.defaultBuildingJson.other_building_id = const_var.defaultBuildingArr[action.defaultVal].other_building_id;
                const_var.defaultBuildingJson.roof_color = const_var.defaultBuildingArr[action.defaultVal].roof_color;
                const_var.defaultBuildingJson.roof_id = const_var.defaultBuildingArr[action.defaultVal].roof_id;
                const_var.defaultBuildingJson.trim_color = const_var.defaultBuildingArr[action.defaultVal].trim_color;
                const_var.defaultBuildingJson.utility = const_var.defaultBuildingArr[action.defaultVal].utility;
                const_var.defaultBuildingJson.utility_front = const_var.defaultBuildingArr[action.defaultVal].utility_front;
                const_var.defaultBuildingJson.wall = const_var.defaultBuildingArr[action.defaultVal].wall;
                const_var.defaultBuildingJson.wall_color = const_var.defaultBuildingArr[action.defaultVal].wall_color;

                //const_var.defaultBuildingJson.size = const_var.defaultBuildingArr[action.defaultVal].size;
                // For multiple sizes in utility SE3-T519
                let utilitySizes =  const_var.defaultBuildingArr[action.defaultVal].size.split(",")
                if(const_var.defaultBuildingArr[action.defaultVal].name.includes("Utility Carports") && utilitySizes!= undefined && utilitySizes.length>1){
                    let utilityID =  const_var.defaultBuildingArr[action.defaultVal].other_building_id.split(",");
                    let find_Index = utilityID.findIndex((s,ind)=>s == action.value)
                    if(find_Index > 0 && action.value == utilityID[find_Index]){
                        const_var.defaultBuildingJson.size = utilitySizes[find_Index];
                    }
                }else{
                    const_var.defaultBuildingJson.size = const_var.defaultBuildingArr[action.defaultVal].size;
                }
                const_var.defaultBuildingJson.is_show = false;
                const_var.defaultBuildingJson.garageDoorColor = const_var.defaultBuildingArr[action.defaultVal].garageDoorColor;
                // let splitValH = const_var.defaultBuildingArr[action.defaultVal].size.split('x')[2];

                // if(state.c_m_a[action.value].roof_style!=undefined && state.c_m_a[action.value].roof_style.length==3)
                // {
                //     const_var.defaultBuildingJson.size = state.c_m_a[action.value].roof_style[2].min_width+'x'+state.c_m_a[action.value].roof_style[2].start_length+'x'+splitValH;    
                // }else if(state.c_m_a[action.value].roof_style!=undefined && state.c_m_a[action.value].roof_style.length==2)
                // {
                //    const_var.defaultBuildingJson.size = state.c_m_a[action.value].roof_style[1].min_width+'x'+state.c_m_a[action.value].roof_style[1].start_length+'x'+splitValH;    
                // }else
                // {
                //    const_var.defaultBuildingJson.size = state.c_m_a[action.value].roof_style[0].min_width+'x'+state.c_m_a[action.value].roof_style[0].start_length+'x'+splitValH;    
                // }

                const_var.defaultBuildingArr[parseInt(action.defaultVal + 1)] = const_var.defaultBuildingJson;
                //console.log(const_var.defaultBuildingArr,state.defaultBuilding);
            }
        }
        // console.log(const_var.defaultBuildingArr,state.defaultBuilding);
        return {
            ...state,
            newColor: action.value + action.defaultVal
        }
        break;
    case "CHANGEBUILDINGDATA":
        //state.defaulProductLoad = false

        state.defaultBuilding = undefined;
        state.checkedBuildingType = undefined;
        state.OlddefaultBuilding = undefined;
        state.const_var.defaultBuildingArr = [];
        state.const_var.newLeanArr = [];
        state.isFullyOpenedChecked = false;
        state.isFullyOpenedCheckedForFrontLeanTo = false;
        state.isFullyOpenedCheckedForBackLeanTo = false;
        state.isFullyOpenedCheckedForLeftLeanTo = false;
        state.isFullyOpenedCheckedForRightLeanTo = false;
        state.isFullyEnclosedChecked = false;
        state.isFullyEnclosedCheckedForLeftLeanTo = false;
        state.isFullyEnclosedCheckedForRightLeanTo = false;
        state.const_var.AllBuildingData = action.value;
        state.const_var.order_extra_items.engineer_drawings_name ="";
        state.const_var.order_extra_items.engineer_drawings =0;
        cuComponent.removeAlltheComponent();
        // console.log("rahul here for checking")
        cuBuilding.loadDefaultBuilding(state, action.value.data.default_building);
        state.selectedTabKey = 'buildingtypetab';
        
        const_var.callMesure = false;
        //   console.log("rahul here",state.const_var.AllBuildingData);
        state.const_var.SendAPIBuildingData = action.value.data;
        setBuildingData(state, action.value, state.defaulProductLoad)
        return {
            ...state,
            newColor: action.value
        }
        break;
    case "BUILDINGTYPECHANGE":
        buildingTypeChange(state, action.value)

        return {
            ...state,
            newColor: action.value,
            //defaultRoof:"0"
        }
        break;
    case "ROOFSTYLECHANGE":
        let index = const_var.roof_style.findIndex(data => data.roof_id == action.value);
        if(action?.event?.target){
            if(action?.event?.target?.checked){
                index = const_var.roof_style.findIndex(data => data.roof_id == 3);
            } else {
                index = const_var.roof_style.findIndex(data => data.roof_id == const_var.editAPIDataByResponse.data.request_data.building.roof_style);
            }
        }
        //   console.log(index,action,"const_var.roof_style",const_var.roof_style);
        roofStyleChange(state, index, true, true)
        return {
            ...state,
            newColor: action.value,
            defaultRoof: action.value
        }
        break;
    case "editActionAfterPreparingData":
        editActionAfterPreparingData(state, action.data,action.doorData);
        return {
            ...state,
            editDataChangeAction: action
        }
        break;
    case "loadCupolaInEditMode":
        let isOldQuotes = 'No';
        if (params.cupola && params.cupolaObj && action.data.cupola_price && !action.data.cupolaEntries ) isOldQuotes='Yes';
        cuComponent.loadCupolaInEditMode(action.data.cupolaEntries,isOldQuotes,action.data.cupola_price,action.data.cupola_qty);
        return{
            ...state,
            action
        }    
        break;
    case "BUILDINGSTYLECHANGEBYTYPE":
        const_var.isOverhang = {
            'end' : {
                isChecked: false,
                selected: '',
                size: 0.5
            },
            'side' : {
                isChecked: false,
                selected: '',
                size: 0.5
            },
            'both' : {
                isChecked: false,
                selected: '',
                size: 0.5
            }
        }
        // const_var.newDoorsArray = [];
        params.is_translusant = false;
        // const_var.cupolas = [];
        if (action.value == undefined) {
            const_var.isShowbuildingtype = false;
            state.defaultBuilding = state.defaultBuilding;
            state.checkedBuildingType = state.checkedBuildingType;
            state.OlddefaultBuilding = state.OlddefaultBuilding;
        } else {
            if (action.othertype.length > 1) {
                // console.log(action,"action1111111")
                state.const_var.isShowbuildingtypeArr = action.othertype;
                // console.log(state.checkedBuildingType,const_var.isShowbuildingtypeArr,"const_var.isShowbuildingtypeArr");
                //state.checkedBuildingType = 
                if (state.checkedBuildingType != undefined && action.othertype.includes(state.checkedBuildingType) != true) {
                    state.checkedBuildingType = action.othertype[0];
                }
                const_var.isShowbuildingtype = true;
                if(state.const_var.selectedTabKeyForWheel == "buildsizes"){
                    const_var.isShowbuildingtype = false;
                    document.querySelector('body').classList.remove('active-modal-loader') 

                }
                state.defaultBuilding = action.value;
                state.OlddefaultBuilding = action.value;

                //let filteredArray1 = state.const_var.building.filter(el => action.othertype.includes(el));
                //console.log(filteredArray1); 
            }
        }
        //   console.log(action.value.currentTarget.parentNode.parentNode);
        //   console.log('BUILDINGSTYLECHANGE');

        return {
            ...state,
            newColor: action.value + action.othertype + const_var.isShowbuildingtype
        }
        break;
    case "resetAlltheEditValue":
        state.const_var.UpdatedPriceData = { 'roof_style_price_changed': true,'lifttype_price_changed':true,'cupola_price_changed':true, 'width_price_changed': true, 'length_price_changed': true, 'height_price_changed': true, 'left_wall_price_changed': true, 'right_wall_price_changed': true, "right_wall_cut_panel_price_changed": true, "left_wall_cut_panel_price_changed": true, 'front_wall_price_changed': true, 'back_wall_price_changed': true, "certificate_price_changed": true, "common_width_changed": true, "common_length_changed": true, "common_height_changed": true, "utility_price_changed": true, "wainscot_price_changed": true, "connection_fee_end_changed": true, "connection_fee_side_changed": true, "roof_pitch_price_changed": true,'lifttype_price_changed':true, 'left_lean_roof_style_price_changed': true, 'left_lean_width_price_changed': true, 'left_lean_length_price_changed': true, 'left_lean_height_price_changed': true, 'left_lean_left_wall_price_changed': true, 'left_lean_front_wall_price_changed': true, 'left_lean_back_wall_price_changed': true, "left_lean_certificate_price_changed": true, "left_lean_utility_price_changed": true, "left_lean_roof_pitch_price_changed": true, 'right_lean_roof_style_price_changed': true, 'right_lean_width_price_changed': true, 'right_lean_length_price_changed': true, 'right_lean_height_price_changed': true, 'right_lean_right_wall_price_changed': true, 'right_lean_front_wall_price_changed': true, 'right_lean_back_wall_price_changed': true, "right_lean_certificate_price_changed": true, "right_lean_utility_price_changed": true, "right_lean_roof_pitch_price_changed": true, 'front_lean_roof_style_price_changed': true, 'front_lean_width_price_changed': true, 'front_lean_length_price_changed': true, 'front_lean_height_price_changed': true, 'front_lean_left_wall_price_changed': true, 'front_lean_front_wall_price_changed': true, 'front_lean_back_wall_price_changed': true, "front_lean_certificate_price_changed": true, "front_lean_utility_price_changed": true, "front_lean_roof_pitch_price_changed": true, 'back_lean_roof_style_price_changed': true, 'back_lean_width_price_changed': true, 'back_lean_length_price_changed': true, 'back_lean_height_price_changed': true, 'back_lean_left_wall_price_changed': true, 'back_lean_front_wall_price_changed': true, 'back_lean_back_wall_price_changed': true, "back_lean_certificate_price_changed": true, "back_lean_utility_price_changed": true, "back_lean_roof_pitch_price_changed": true,"color_price_changed":true,"down_payment_type": "per", "down_payment_discount_type": "per", "discount_type": "per", "left_front_wrap_connection_fee_changed":true,"right_front_wrap_connection_fee_changed":true,"right_back_wrap_connection_fee_changed":true,"left_back_wrap_connection_fee_changed":true,"front_lean_insulation_price_changed":true,"left_lean_insulation_price_changed":true, "right_lean_insulation_price_changed":true,"back_lean_insulation_price_changed":true, "wall_color_price_changed" :true , "roof_color_price_changed" :true , "trim_color_price_changed" :true , "wainscot_price_changed" :true, "truss_price_changed": true};
    return{
        ...state,
        action
    }    
    case "BUILDINGSTYLECHANGE":
        // state.const_var.isShowAlert = !state.const_var.isShowAlert;
        // state.const_var.alertUsedFor = "CHANGEBUILDINGTYPE";
        params.toggleBuildingStyleChange = !params.toggleBuildingStyleChange;
        state.selectedTabstate = 'hidestatebox';
        params.is_translusant = false;
        //console.log(action,"buildingStyleChange")
        buildingStyleChange(state, action.value);
        
        if (const_var.focusedSection !== "") {
            const_var.scene.traverse((child) => {
                if (child.type === "Mesh") {
                    child.material.transparent = false;
                    child.material.opacity = 1;
                    child.material.depthWrite = true;
                }
                if((child.name == "frontWallWaterMark" || child.name == "backWallWaterMark" || child.name == "usSteelbuildingCenterGround" || child.name == "eagleLogo" || child.name == "manufacturerLogoFront" || child.name == "manufacturerLogoBack" || child.name == "manufacturerLogoCenter")) {
                    child.material.transparent = true;
                    child.material.opacity = 1;
                    child.material.depthWrite = true;
                }
            })
            const_var.focusedSection = "";
        }


        return {
            ...state,
            newColor: action.value
        }
        break;
    case "checkCHANGEDIMENSION":

            if (action.checkCustomDimension != undefined) {
                let p_w = parseInt(action.value);
                let p_d = parseInt(action.secondParam);
                let leanF_p_d = state.params.leanF_p_d;
                let leanB_p_d = state.params.leanB_p_d;
                let lean_p_d = state.params.lean_p_d;
                let leanR_p_d = state.params.leanR_p_d;

                if ((p_d > (state.const_var.arrayendLengthRoof[params.p_r_s])) && ("Vertical" != state.const_var.TypeEnum[state.params.p_r_s])) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "RoofStyleLength";
                }
                                    
                if (state.params.add_left_front_lean_porch == true && state.params.add_right_front_lean_porch == true) {
                    leanF_p_d = p_w;
                }
        
                if (state.params.add_right_back_lean_porch == true && state.params.add_left_back_lean_porch == true) {
                    leanB_p_d = p_w;
                }
        
                if (state.params.add_left_front_lean_porch == true && state.params.add_left_back_lean_porch == true) {
                    lean_p_d = p_d;
                }
        
                if (state.params.add_right_back_lean_porch == true && state.params.add_right_front_lean_porch == true) {
                    leanR_p_d = p_d;
                }
                if (state.params.add_left_front_lean_porch == true && state.params.leantoAlignmentFront != "2" && (p_w != leanF_p_d)) {            
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_right_front_lean_porch == true && state.params.leantoAlignmentFront != "3" && (p_w != leanF_p_d)) {        
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_left_back_lean_porch == true && state.params.leantoAlignmentBack != "3" && (p_w != leanB_p_d)) {    
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_right_back_lean_porch == true && state.params.leantoAlignmentBack != "2" && (p_w != leanB_p_d)) {            
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
                if (state.params.add_left_front_lean_porch == true && state.params.leantoAlignmentLeft != "2" && (p_d != lean_p_d)) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_left_back_lean_porch == true && state.params.leantoAlignmentLeft != "3" && (p_d != lean_p_d)) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_right_front_lean_porch == true && state.params.leantoAlignmentRight != "2" && (p_d != lean_p_d)) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_right_back_lean_porch == true && state.params.leantoAlignmentRight != "3" && (p_d != lean_p_d)) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }

            }
            if (action.str == "w" && action.checkCustomDimension == undefined) {
        
                let p_w = parseInt(action.value);
                let leanF_p_d = params.leanF_p_d;
                let leanB_p_d = state.params.leanB_p_d
        
                if (leanF_p_d >= p_w) {
                    leanF_p_d = p_w
                }
                if (leanB_p_d >= p_w) {
                    leanB_p_d = p_w
                }                   

                if (state.params.add_left_front_lean_porch == true && state.params.add_right_front_lean_porch == true) {
                    leanF_p_d = p_w;
                }
        
        
                if (state.params.add_right_back_lean_porch == true && state.params.add_left_back_lean_porch == true) {
                    leanB_p_d = p_w;
                }
        
                if (state.params.add_left_front_lean_porch == true && state.params.leantoAlignmentFront != "2" && (p_w != leanF_p_d)) {        
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_right_front_lean_porch == true && state.params.leantoAlignmentFront != "3" && (p_w != leanF_p_d)) {        
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_left_back_lean_porch == true && state.params.leantoAlignmentBack != "3" && (p_w != leanB_p_d)) {        
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_right_back_lean_porch == true && state.params.leantoAlignmentBack != "2" && (p_w != leanB_p_d)) {    
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
            } else if (action.str == "l" && action.checkCustomDimension == undefined) {
                let p_d = parseInt(action.value);
                let lean_p_d = state.params.lean_p_d;
                if ((p_d > (state.const_var.arrayendLengthRoof[params.p_r_s])) && ("Vertical" != state.const_var.TypeEnum[state.params.p_r_s])) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "RoofStyleLength";
                }

                if (state.params.add_left_front_lean_porch == true && state.params.add_left_back_lean_porch == true) {
                    lean_p_d = p_d;
                }
        
                if (state.params.add_left_front_lean_porch == true && state.params.leantoAlignmentLeft != "2" && (p_d != lean_p_d)) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotChangePorch";
                }
        
                if (state.params.add_left_back_lean_porch == true && state.params.leantoAlignmentLeft != "3" && (p_d != lean_p_d)) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotChangePorch";
                }
        
                if (state.params.add_right_front_lean_porch == true && state.params.leantoAlignmentRight != "2" && (p_d != lean_p_d)) {           
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotChangePorch";
                }
        
                if (state.params.add_right_back_lean_porch == true && state.params.leantoAlignmentRight != "3" && (p_d != lean_p_d)) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotChangePorch";
                }
                
            } else if (action.str == "h") {

        
            } else if (action.str == "lean_w") {
                const lean_p_w = parseInt(action.value);
                if (state.params.add_left_front_lean_porch != false && state.params.leanF_p_w != lean_p_w) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_left_back_lean_porch != false && state.params.leanB_p_w != lean_p_w) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_right_front_lean_porch != false && state.params.add_left_front_lean_porch == true && lean_p_w != state.params.leanR_p_w) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_right_back_lean_porch != false && state.params.add_left_back_lean_porch == true && lean_p_w != state.params.leanR_p_w) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }

            } else if (action.str == "lean_l") {

                const lean_p_d = parseInt(action.value)
                if (state.params.add_left_front_lean_porch != false && state.params.leantoAlignmentLeft != "2") {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                } else if (state.params.add_left_front_lean_porch != false && state.params.leantoAlignmentLeft == "2") {
                    state.params.lean_p_pos = params.lean_p_pos - (lean_p_d - params.lean_p_d) / 2
                }
        
                if (state.params.add_left_back_lean_porch != false && state.params.leantoAlignmentLeft != "3") {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                } else if (state.params.add_left_back_lean_porch != false && state.params.leantoAlignmentLeft == "3") {
                    state.params.lean_p_pos = params.lean_p_pos + (lean_p_d - params.lean_p_d) / 2
                }
                
        
            } else if (action.str == "lean_h") {
                const lean_p_h = parseInt(action.value);
        
                if (state.params.add_left_front_lean_porch != false && state.params.leanF_p_h != lean_p_h) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_left_back_lean_porch != false && state.params.leanB_p_h != lean_p_h) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_right_front_lean_porch != false && state.params.add_left_front_lean_porch == true && lean_p_h != state.params.leanR_p_h) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_right_back_lean_porch != false && state.params.add_left_back_lean_porch == true && lean_p_h != state.params.leanR_p_h) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
            } else if (action.str == "leanR_w") {
                const leanR_p_w = parseInt(action.value);
        
        
                if (state.params.add_right_front_lean_porch != false && state.params.leanF_p_w != leanR_p_w) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_right_back_lean_porch != false && state.params.leanB_p_w != leanR_p_w) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
        
                if (state.params.add_left_front_lean_porch != false && state.params.add_right_front_lean_porch == true && state.params.lean_p_w != leanR_p_w) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_left_back_lean_porch != false && state.params.add_right_back_lean_porch == true && state.params.lean_p_w != leanR_p_w) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }

            } else if (action.str == "leanR_l") {

                const leanR_p_d = parseInt(action.value);
                if (state.params.add_right_front_lean_porch != false && state.params.leantoAlignmentRight != "2") {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                } else if (state.params.add_right_front_lean_porch != false && state.params.leantoAlignmentRight == "2") {
                    state.params.leanR_p_pos = params.leanR_p_pos - (leanR_p_d - params.leanR_p_d) / 2
                }
        
                if (state.params.add_right_back_lean_porch != false && state.params.leantoAlignmentRight != "3") {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                } else if (state.params.add_right_back_lean_porch != false && state.params.leantoAlignmentRight == "3") {
                    state.params.leanR_p_pos = params.leanR_p_pos + (leanR_p_d - params.leanR_p_d) / 2
                }
        
            } else if (action.str == "leanR_h") {
        
                if (state.params.add_right_front_lean_porch != false) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_right_back_lean_porch != false) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }

            }
            //   else if (action.str=="leanF_w") {
            else if (action.str == "leanF_w") {
        
                if (state.params.add_left_front_lean_porch != false) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_right_front_lean_porch != false) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
            }
            else if (action.str == "leanF_l") {

                const leanF_p_d = parseInt(action.value);
                if (state.params.add_left_front_lean_porch != false && state.params.leantoAlignmentFront != "2" && leanF_p_d != params.p_w) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                } else if (state.params.add_left_front_lean_porch != false && state.params.leantoAlignmentFront == "2" && leanF_p_d != params.leanF_p_d) {
                    state.params.leanF_p_pos = params.leanF_p_pos + (leanF_p_d - params.leanF_p_d) / 2
                }
        
                if (state.params.add_right_front_lean_porch != false && state.params.leantoAlignmentFront != "3" && leanF_p_d != params.p_w) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                } else if (state.params.add_right_front_lean_porch != false && state.params.leantoAlignmentFront == "3" && leanF_p_d != params.leanF_p_d) {
                    state.params.leanF_p_pos = params.leanF_p_pos - (leanF_p_d - params.leanF_p_d) / 2
                }
            }
            else if (action.str == "leanF_h") {
        
                if (state.params.add_left_front_lean_porch != false) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_right_front_lean_porch != false) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
            }
            else if (action.str == "leanB_w") {
        
                if (state.params.add_left_back_lean_porch != false) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_right_back_lean_porch != false) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }

            }
            else if (action.str == "leanB_l" ) {
        
                const leanB_p_d = parseInt(action.value);

                if (state.params.add_left_back_lean_porch != false && state.params.leantoAlignmentBack != "3" && leanB_p_d != params.p_w) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                } else if (state.params.add_left_back_lean_porch != false && state.params.leantoAlignmentBack == "3" && leanB_p_d != params.leanB_p_d) {
                    state.params.leanB_p_pos = params.leanB_p_pos + (leanB_p_d - params.leanB_p_d) / 2
                }
        
                if (state.params.add_right_back_lean_porch != false && state.params.leantoAlignmentBack != "2" && leanB_p_d != params.p_w) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                } else if (state.params.add_right_back_lean_porch != false && state.params.leantoAlignmentBack == "2" && leanB_p_d != params.leanB_p_d) {
                    state.params.leanB_p_pos = params.leanB_p_pos - (leanB_p_d - params.leanB_p_d) / 2
                }
            }
            else if (action.str == "leanB_h") {            
                if (state.params.add_left_back_lean_porch != false) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
        
                if (state.params.add_right_back_lean_porch != false) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }        
            }
        return {
            ...state,
            action
        }
        break;
    case "CHANGEDIMENSION":

        if (params.singleSlope == true && (const_var.c_m_a[params.p_b_t].fixed_new_leg_width==undefined ||const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length == 0)&& ((action.str == "h" && (parseInt(action.value)  - (Number(params.p_r_p)/12) * params.p_w) < const_var.b_m_i_hlean) ||
            (action.str == "w" && (params.p_h  - (Number(params.p_r_p)/12) * parseInt(action.value)) < const_var.b_m_i_hlean))) {
                state.const_var.isShowAlert = true;
                if (action.str == "w"){
                    state.const_var.alertUsedFor = "restrictedBuildingHeight";  
                    action.value = params.p_w; 
                }             
                if (action.str == "h"){
                    state.const_var.alertUsedFor = "restrictedBuildingHeight1";   
                    action.value = params.p_h;
                } 
        } else {
            const_var.fromChangeDimension = true;
            const_var.showDisabledClass = true;
            changeBuildingDimension(state, action.value, action.str, action.secondParam, action.checkCustomDimension, action.valueToSet,action.from);
            if (action.str == 'w') {
                if (action.value > 40) {
                    widerlongeranimate();
                }
            }                                    

            if (action.str == 'l') {
                if (action.value > 50) {
                    widerlongeranimate();
                }
            }
        }


        return {
            ...state,
            action
        }
        break;
    case "CHANGEPORCHDIMENSION":
        changePorchDimension(state, action.value, action.str, action.secondParam, action.checkCustomDimension)
        return {
            ...state,
            action
        }
        break;
    case "genratePrintImages":
        const_var.PrintAlertBox = action.payload;
        if (const_var.PrintAlertBox == true && const_var.i_g_A_y.length < 1) {
            const_var.selectedTabKeyForWheel = "capture";
            // cuComponent.removeDoorWindowsIcons();
            const_var.activeTab = "buildingtypetab"
            cuComponent.TsCeSot('print');
        }
        return {
            ...state,
            action
        }
        break;
    case "submitReportIssue":
        state.const_var.reportIssueID = action.response ? action.response.ticket_string : ''
        state.const_var.ticketId = action.response ? action.response.id : ''
        state.const_var.errormsg = action.errormsg ? action.errormsg : ''
        return {
            ...state,
            action
        }
        break;
    case "handleReportLoader":
        state.const_var.showReportLoading = action.value
        return {
            ...state,
            action
        }
        break;
    // case "resetErrorMsg":
    //     if(action.key == 'zipCode'){
    //         state.ziperrormsg = ''
    //     }
    //     else{
    //         delete state.const_var.displayerrorMessage.reportIssue;
    //         state.errormsg = ''
    //     }
    //     return {
    //         ...state,
    //         action
    //     }
    //     break;       
    case "manageReportIssueModal":
        state.const_var.reportIssueID = '';
        state.const_var.ticketId = '';
        state.const_var.showReportIssueModal = action.value;
        delete state.const_var.displayerrorMessage.reportIssue;
        state.const_var.errormsg = ''
        return {
            ...state,
            action
        }
        break;
    case "zipCodeError":
        state.const_var.ziperrormsg = action.msg;
        // if(action.msg != ''){
        //     state.const_var.displayerrorMessage.zipcode = action.msg    
        // }
        return {
            ...state,
            action
        }
        break;
    case "showStateField":
        state.const_var.showStateField = action.value;
        if(action.apiCallForStateVal != ''){
        state.const_var.apiCalledforState = action.apiCallForStateVal;
        state.params.p_s_n = '';
        state.params.m_s_n = '';
        state.const_var.stateManufacturerAcordingAPIDiscount = {}
        }
        return {
            ...state,
            action
        }
        break;
    case "setScreenShot":
        state.const_var.setScreenshot = action.value
        return {
            ...state,
            action
        }
        break;
    case "APICalledForState":
        state.const_var.apiCalledforState = action.value
        return {
            ...state,
            action
        }
        break;
    case "updatePreQuoteErr":
        state.const_var.preQuoteError = action.value
        if(action.resetState == true){
            state.params.p_s_n = '';
            state.params.m_s_n = '';
            state.const_var.stateManufacturerAcordingAPIDiscount = {}
            state.const_var.bjDData= []
        }
        return {
            ...state,
            action
        }
        break;
    case "updatePostData":
        delete state.const_var.post_data.full_name;
        delete state.const_var.post_data.first_name;
        delete state.const_var.post_data.last_name;
        delete state.const_var.post_data.email;
        delete state.const_var.post_data.phone_no;
        delete state.const_var.zipCode;
        delete state.const_var.billing_address_line_1;
        delete state.const_var.billing_zipcode;
        delete state.const_var.shipping_zipcode;
        // shipping_address_line_1
        // shipping_zipcode
        if(state.const_var.post_data.address && state.const_var.post_data.address.length > 0){
            delete state.const_var.post_data.address[0].zipcode;
            delete state.const_var.post_data.address[0].address_line_1;
        }
        return {
            ...state,
            action
        }
        break;
    case "handleDescription":
        state.const_var.reportDesc = action.value
        return {
            ...state,
            action
        }
        break;
    case "setupTween":

        var cam = const_var.camera.position;
        var contro = const_var.controls.target;
        var xTarget = 0;
        var yTarget = params.p_h / 2;
        var zTarget = 1.25 * state.params.p_d;
        var tweenDuration = 2500;
        const_var.tween = true;
        TWEEN.removeAll();
        var camNewPosition = { x: xTarget, y: yTarget, z: zTarget };
        var targetNewPos = { x: xTarget, y: yTarget, z: 0 };
        var camTween = new TWEEN.Tween(cam).to(camNewPosition, tweenDuration).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
        var targetTween = new TWEEN.Tween(contro).to(targetNewPos, tweenDuration).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();

        return {
            ...state,
            action
        }
    case "makeDimensionUpdate":
        makeDimensionUpdateLeft(state);
        makeDimensionUpdateFront(state);
        makeDimensionUpdateBack(state);
        makeDimensionUpdateRight(state);

        return {
            ...state,
            newColor: action.value
        }
        break;
    case "SETPRICINGDATAFORLEANTO":
        setPricingDataForLeanto(state, action.value, action.str, state.defaulProductLoad);
        return {
            ...state,
            action
        }
        break;
    case "setPricingDataForLeantoComparision":
        setPricingDataForLeantoComparision(state, action.value, action.str, state.defaulProductLoad, action.iiD);
        return {
            ...state,
            newColor: action + const_var.i_g_A_y.length + const_var.NoCompareData1 + const_var.NoCompareData2 +action.str+action.iiD + const_var.comparisionLoadermfg1 + const_var.comparisionLoadermfg2 + params.m_s_n_1 + params.m_s_n_2
        }
        break;
    case "handleShowFullPageLoader":
        const_var.checkIval = 0;
        const_var.i_g_A_y = [];
        state.const_var.showProcessLoaderchk = true;
        return {
            ...state,
            showFullPageLoader: state.const_var.i_g_A_y.length + const_var.isShowAlert + state + 1
        }
        break;
    case "RAISETICKETS":
        if (action.response == '') {
            state.const_var.comparisionLoadermfg1 = true;
        } else {
            const_var.showhideUpgradePlan = action.response;
            state.const_var.comparisionLoadermfg1 = false;
        }
        return {
            ...state,
            action
        }
        break;
    case "SETCOMPARISIONBUILDINGLOADER":
        if (action.mfgindex == '_1') {
            state.const_var.comparisionLoadermfg1 = true;
            if ((params.add_front_lean || params.add_back_lean) && const_var.compare_leanto_condition_by_mfg.end_lean_to == false){
                state.const_var.comparisionLoadermfg1 = false;
            }
        }

        if (action.mfgindex == '_2') {
            state.const_var.comparisionLoadermfg2 = true;
            if ((params.add_front_lean || params.add_back_lean) && const_var.compare_leanto_condition_by_mfg.end_lean_to == false){
                state.const_var.comparisionLoadermfg2 = false;
            }
        }

        return {
            ...state,
            action,
            newColor:state.const_var.comparisionLoadermfg1+state.const_var.comparisionLoadermfg2
        }
        break;
    case "NoDataCompare":
        if (action.mfgindex == '_1') {
            state.const_var.NoCompareData1 = true;
            state.const_var.comparisionLoadermfg1 = false;
            
        }
        if (action.mfgindex == '_2') {
            state.const_var.NoCompareData2 = true;
            state.const_var.comparisionLoadermfg2 = false;
        }

        params[`${"showCompareMnfList"}${action.mfgindex}`] = true;
        for(let key in const_var.ComparisionDataArray){
            if (key.includes(action.mfgindex)){
                delete const_var.ComparisionDataArray[key];
            }                    
        }
        // console.log(const_var.ComparisionDataArray,"const_var.ComparisionDataArray")
        //const_var.ComparisionDataArray[action.key+action.mfgindex] = undefined;    
        return {
            ...state,
            action,
            newColor: state.const_var.comparisionLoadermfg1+state.const_var.comparisionLoadermfg2 + state.const_var.NoCompareData1 + state.const_var.NoCompareData2 + const_var.ComparisionDataArray
        }
        break;
    case "makeComponentArrayForOtherBuildingForInspiration":
        makeComponentArrayForOtherBuildingForInspiration(action.value);
        // console.log(action,'const_var.showProcessLoaderchkEdit');
        const_var.showProcessLoaderchkEdit = false;
    return{
        ...state,
        action,
    } 
    break;    
    case "SETCOMPARISIONBUILDINGDATA":
        // state.const_var.NoCompareData1 = false;
        // state.const_var.NoCompareData2 = false;
        const [compareManufacturer, compareId] = action.iiD.split("_");
        const_var[`${"NoCompareData"}${compareId}`] = false;
        if(const_var.isInspirtionGalleryEditFlow) {
            //makeComponentArrayForOtherBuildingForInspiration(state,action.iiD)
        } else {
            makeComponentArrayForOtherBuilding(state, action.iiD)
        }
        
        state.const_var.showComparePrices = true;
        cuBuilding.setComparePricingData(action.iiD);
        if(params.add_right_lean!=true && params.add_left_lean!=true && params.add_front_lean!=true && params.add_back_lean!=true)
        {
            state.const_var.comparisionLoadermfg1 = false;
            state.const_var.comparisionLoadermfg2 = false;
        }

        return {
            ...state,
            newColor: action + const_var.i_g_A_y.length + const_var.NoCompareData1 + const_var.NoCompareData2 + const_var.comparisionLoadermfg1 + const_var.comparisionLoadermfg2 + params.m_s_n_1 + params.m_s_n_2
        }
        break;
    case "prepareNewBuilding":
        console.log(action.value,action.value.split("_"),"const_var.ComparisionDataArray",const_var.ComparisionDataArray);
    

    return{
        ...state,
        action
    }    
    case "changeComparisonData":
        // console.log(action.event.target.value, "action.event.target.value", action);
        const_var.leantoCompare = const_var.ComparisionDataArray[action.iid].request_data.building.leanto;
        cuBuilding.setComparePricingData(action.iid, action.event.target.value);

        return {
            ...state,
            action
        }
    case "SETPRICINGDATA":
        setPricingData(state, action.value, state.defaulProductLoad,action.str, action.isEdit);
        return {
            ...state,
            action
        }
        break;
    case "STATECHANGEVALUE":
    if(action.payload!=null)
    {
        params.p_s_n = action.payload;
        //const_var.isShowButtonLoader = false;
    }else{
        //const_var.isShowButtonLoader = true;
    }
    return{
        ...state,
        action
    }      
    case "SELECTED_TAB": {
        state.const_var.selectedTabKeyForWheel = action.key;
                state.const_var.tabCountDisplay = true;
        if (action.key == 'statechange') {
            state.const_var.tabCountDisplay = false;
            state.const_var.confirmState = false;
        }
        if (action.key != "doorwindow") {
            state.doorWindowIconsPos = [];
        } 
        
        if (action.key === "doorwindow") {
            cuComponent.cameraFocusOnWall(state, params.activeWall);
        } else if (const_var.focusedSection !== "") {
            // if (!params.is_translusant) {
            //     const_var.scene.traverse((child) => {
            //         if (child.type === "Mesh") {
            //             child.material.transparent = false;
            //             child.material.opacity = 1;
            //             child.material.depthWrite = true;
            //         }

            //         if((child.name == "frontWallWaterMark" || child.name == "backWallWaterMark" || child.name == "usSteelbuildingCenterGround" || child.name == "eagleLogo" || child.name == "manufacturerLogoFront" || child.name == "manufacturerLogoBack" || child.name == "manufacturerLogoCenter")) {
            //             child.material.transparent = true;
            //             child.material.opacity = 1;
            //             child.material.depthWrite = true;
            //         }
            //     })
            // }
            const_var.focusedSection = "";
        }

        // let dwIconsDiv = document.getElementsByClassName("doorwindowicons-1")[0];
        // if (action.key === 'doorwindow' && dwIconsDiv) {
        //     dwIconsDiv.classList.remove('d-none');
        // } else {
        //     dwIconsDiv.classList.add("d-none");
        // }

        state.const_var.ClickforPhotosMobile = React.createRef();
            {/*for mobile photos click*/}
        if(action.key=='capture' &&  state.const_var.crmSetting.parent_api_token != "lSnJFZzVzjafjqu1530dlyobYTsubogpP5SXJRYpIVEL0yPfvcWusou7Vhg6Coor" && state.const_var.crmSetting.main_domain_url != "Leadingsteelbuildings.com") {         

            document.querySelector('body').classList.add('active-mobile-capture')

            if(const_var.i_g_A_y.length>0) {

            }

            else {                   

                setTimeout(()=>{
                document.querySelector('body').classList.remove('active-offset-thumbnail')
                
                state.const_var.ClickforPhotosMobile.current.click();                        

                // document.querySelector('body').classList.remove('activethumb-view')
                },100)
            }
        }
        else {
            document.querySelector('body').classList.remove('active-mobile-capture')
        }


        return {
            ...state,
            selectedTabKey: action.key
        }
    }
        break;
    case "SELECTED_TAB_STATE": {
        if(action.key == "statechange"){
            state.const_var.isForStandardBuilding = false
        }
        state.selectedTabKey = action.key;
        state.const_var.selectedTabKeyForWheel = state.selectedTabKey;
        state.const_var.showComponentEditBox = false;
        state.const_var.tabCountStateDisplay = true;
        state.doorWindowIconsPos = [];
        state.cupolaEditIconsPos = [];

        if (const_var.focusedSection !== "") {
            // const_var.scene.traverse((child) => {
            //     if (child.type === "Mesh") {
            //         child.material.transparent = false;
            //         child.material.opacity = 1;
            //         child.material.depthWrite = true;
            //     }
            //     if((child.name == "frontWallWaterMark" || child.name == "backWallWaterMark" || child.name == "usSteelbuildingCenterGround" || child.name == "eagleLogo" || child.name == "manufacturerLogoFront" || child.name == "manufacturerLogoBack" || child.name == "manufacturerLogoCenter")) {
            //         child.material.transparent = true;
            //         child.material.opacity = 1;
            //         child.material.depthWrite = true;
            //     }
            // })
            const_var.focusedSection = "";
        }
        // utils.logoTexture()

        return {
            ...state,
            selectedTabstate: action.key
        }


    }

        break;

    case "SURFACECHANGE":
        state.params.p_i_s = action.value;
        utils.installationSurface(state.params.p_i_s)
        if (const_var.post_data['building'] != undefined) {
            const_var.post_data['building'].installation_surface = const_var.installationValue[params.p_i_s].toLowerCase();
        }
        const_var.UpdatedPriceData.certificate_price_changed = true;
        if (params.add_left_lean == true) {
            const_var.UpdatedPriceData.certificate_price_changed = true;
            cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
        } if (params.add_front_lean == true) {
            const_var.UpdatedPriceData.certificate_price_changed = true;
            cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
        } if (params.add_back_lean == true) {
            const_var.UpdatedPriceData.certificate_price_changed = true;
            cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
        } if (params.add_right_lean == true) {
            const_var.UpdatedPriceData.certificate_price_changed = true;
            cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
        }
        cuBuilding.cP();
        return {
            ...state,
            action,
            newColor: action.value
        }
        break;
    case "stateManufacturerChange":
        const initValue = 2;
        params.b_l_t_r_pF = initValue;
        params.b_l_t_r_pB = initValue;
        params.b_l_t_r_pR = initValue;
        params.b_l_t_r_p = initValue;
        const_var.checkmoreCustomizeFlag = false
        const_var.dealer_discount_label = "" ;
        const_var.manufacturer_discount_label = "" ;
        if(state.const_var.crmSetting.is_zipcode_screen != undefined && state.const_var.crmSetting.is_zipcode_screen == true && action.key == "state" && state.const_var.showStateZip != undefined && state.const_var.showStateZip == true){
            state.const_var.state_mfg_zipcode=''
        }
        const_var.eventKey = "garages"
        if(const_var.i_g_A_y && const_var.i_g_A_y.length > 0 && const_var.crmSetting.form_action !== "edit"){
            const_var.i_g_A_y = []
            state.isShowPhotoModal = false
        }
        if(const_var.order_extra_items && const_var.order_extra_items.additional_note !== undefined && const_var.order_extra_items.additional_note.length > 0 ){
            const_var.order_extra_items.additional_note = ""
        }
        const_var.navEventKey.leanto = "leftLean";
        
        state.const_var.crmSetting.is_show_background = false;
        const_var.hide_price_calculation = const_var.stateData.hide_price_calculation 
        if (const_var.hide_price_calculation == 0 && document.querySelector('body').classList.contains("active-hidden-price")) {
            document.querySelector('body').classList.remove("active-hidden-price");
        }
        if(const_var.loginSession != false) {
            state.priceBookFile = []
        }
        
        stateManufacturerChange(state, action.value, action.key)
        return {
            ...state,
            newColor: action.value + action.key
        }
        break;
    
    case "setZipCodeVal":
        state.const_var.ziperrormsg = '';
        // state.const_var.displayerrorMessage = {};
        state.const_var.zipManufErrMsg = '';
        if(action.value!=undefined && action.value.length<5 && const_var.showStateField)
        {
            const_var.showStateField = false;
            const_var.showStateOnly = false;
            state.const_var.bjDData= []
            state.const_var.bjD= []
        }
        if(const_var.crmSetting.is_zipcode_screen != undefined && const_var.crmSetting.is_zipcode_screen == true){
            state.const_var.state_mfg_zipcode = action.value;
            state.const_var.zipCode = action.value;
            if(action.key == "statemanufacturechangepage") {
                const_var.crmSetting.is_Edit = false
            }
            if(action.value != undefined && action.value.length < 5) {
                state.const_var.showStateZip = false;
            }
            if(action.value == ''){
                state.params.p_s_n = '';
                state.params.m_s_n = '';
                state.const_var.stateManufacturerAcordingAPIDiscount = {}
                state.const_var.bjDData= []
            }

            
        }
        else{

            state.const_var.zipCode = action.value;
            if(action.value == ''){
                state.params.p_s_n = '';
                state.params.m_s_n = '';
                state.const_var.stateManufacturerAcordingAPIDiscount = {}
                state.const_var.bjDData= []
            }
        }
        state.const_var.MFApiCalled = false;
        state.const_var.SApiCalled = false;
        return {
            ...state,
            action
        }
    break;
        
    case "FULLYOPENED":
        let UpdateOpenAction = '';
        if (action.value == 'openCenterBuldingWalls') {
            state.isFullyOpenedChecked = true;
            state.isFullyEnclosedChecked = false;
            if (params.cB_addStorage_check_left ||  params.cB_addStorage_check_right){
                params.cB_addStorage_check_left = false;
                params.cB_addStorage_check_right = false;
            }
            state.params.p_u_c = false;
            state.params.nostorage = true;
            // console.log('FULLYOPENED');
            const_var.insulationPriceJson.insulation_wall = {};
            const_var.UpdatedPriceData.insulation_price_changed = true;
            utils.updateWallSelection('center', true)
            fullyWallEnclosed(state);
            UpdateOpenAction = state.isFullyEnclosedChecked + state.params.p_u_c
        }
        else if (action.value == 'openFrontLeanWalls') {
            state.isFullyOpenedCheckedForFrontLeanTo = true;
            state.isFullyEnclosedCheckedForFrontLeanTo = false;
            state.params.add_storage_check_front = false;
            state.newColor = '';
            const_var.insulationArrayForLeantoFront.insulation_wall = {};
            const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
            utils.updateWallSelection('frontLean', true)
            fullyWallEnclosedFrontLeanTo(state);

            // removeWainscot(state); 
            // UpdateOpenAction = state.isFullyOpenedCheckedForFrontLeanTo+state.isFullyEnclosedCheckedForFrontLeanTo+state.params.add_storage_check_front
        }
        else if (action.value == 'openLeftLeanWalls') {
            state.isFullyOpenedCheckedForLeftLeanTo = true;
            state.isFullyEnclosedCheckedForLeftLeanTo = false;
            state.params.add_storage_check = false;
            state.newColor = '';
            const_var.insulationArrayForLeantoLeft.insulation_wall = {};
            const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
            utils.updateWallSelection('leftLean', true)

            fullyWallEnclosedLeftLeanTo(state);
            // removeWainscot(state);
            UpdateOpenAction = state.isFullyOpenedCheckedForLeftLeanTo + state.isFullyEnclosedCheckedForLeftLeanTo + state.isFullyEnclosedCheckedForRightLeanTo + state.params.add_storage_check

        }
        else if (action.value == 'openRightLeanWalls') {
            state.isFullyOpenedCheckedForRightLeanTo = true;
            state.params.add_storage_check_right = false;
            state.isFullyEnclosedCheckedForRightLeanTo = false;
            state.newColor = '';
            const_var.insulationArrayForLeantoRight.insulation_wall = {};
            const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
            utils.updateWallSelection('rightLean', true)
            fullyWallEnclosedRightLeanTo(state);
            // removeWainscot(state);
            UpdateOpenAction = state.isFullyOpenedCheckedForRightLeanTo + state.isFullyEnclosedCheckedForRightLeanTo + state.isFullyEnclosedCheckedForLeftLeanTo + state.params.add_storage_check_right

        }
        else if (action.value == 'openBackLeanWalls') {
            state.isFullyOpenedCheckedForBackLeanTo = true;
            state.isFullyEnclosedCheckedForBackLeanTo = false;
            state.params.add_storage_check_back = false;
            state.newColor = '';
            const_var.insulationArrayForLeantoBack.insulation_wall = {};
            const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
            utils.updateWallSelection('backLean', true)
            fullyWallEnclosedBackLeanTo(state);

            // removeWainscot(state);
            UpdateOpenAction = state.isFullyOpenedCheckedForBackLeanTo + state.isFullyEnclosedCheckedForBackLeanTo + state.isFullyEnclosedCheckedForRightLeanTo + state.params.add_storage_check_back

        }

        if (state.params.p_f_w === "Close" && state.params.p_r_w === "Close" && state.params.p_l_w === "Close" && state.params.p_b_w === "Close") {
            const_var.setSidesEndsWallOption ="close";
        }else if(state.params.p_f_w === "Open" && state.params.p_r_w === "Open" && state.params.p_l_w === "Open" && state.params.p_b_w === "Open" && state.params.p_c_p_l == false && state.params.p_c_p_r == false && params.p_c_p_l == false && params.p_c_p_r == false) {
            const_var.setSidesEndsWallOption = "open"
        }
            else {
            const_var.setSidesEndsWallOption = "partial";
        }
        return {
            ...state,
            // newColor:UpdateOpenAction
            action
        }
        break;
    case "FULLYENCLOSED":
        let UpdateCloseAction = '';
        if (action.value == 'closeCenterBuldingWalls') {
            state.isFullyEnclosedChecked = true;
            state.isFullyOpenedChecked = false;
            const_var.UpdatedPriceData.insulation_price_changed = true;
            fullyWallEnclosed(state); 
            
            UpdateCloseAction = state.isFullyEnclosedChecked + state.isFullyOpenedChecked
        }
        if (action.value == 'closeFrontLeanWalls') {
            state.isFullyEnclosedCheckedForFrontLeanTo = true;
            state.isFullyOpenedCheckedForFrontLeanTo = false;
            const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
            fullyWallEnclosedFrontLeanTo(state);
            // UpdateCloseAction = state.isFullyOpenedCheckedForFrontLeanTo+state.isFullyEnclosedCheckedForFrontLeanTo+state.isFullyEnclosedCheckedForRightLeanTo+state.params.add_storage_check_front   
        }
        else if (action.value == 'closeLeftLeanWalls') {
            state.isFullyEnclosedCheckedForLeftLeanTo = true;
            //state.params.add_storage_check = false;
            state.isFullyOpenedCheckedForLeftLeanTo = false;
            const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
            fullyWallEnclosedLeftLeanTo(state);
            UpdateCloseAction = state.isFullyOpenedCheckedForLeftLeanTo + state.isFullyEnclosedCheckedForLeftLeanTo + state.isFullyEnclosedCheckedForRightLeanTo + state.params.add_storage_check
        }
        else if (action.value == 'closeRightLeanWalls') {
            state.isFullyEnclosedCheckedForRightLeanTo = true;
            //state.params.add_storage_check_right = false;
            state.isFullyOpenedCheckedForRightLeanTo = false;
            const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
            fullyWallEnclosedRightLeanTo(state);
            UpdateCloseAction = state.isFullyEnclosedCheckedForRightLeanTo + state.isFullyOpenedCheckedForRightLeanTo + state.params.add_storage_check_right

        }
        else if (action.value == 'closeBackLeanWalls') {
            state.isFullyEnclosedCheckedForBackLeanTo = true;
            //state.params.add_storage_check_back = false;
            state.isFullyOpenedCheckedForBackLeanTo = false;
            const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
            fullyWallEnclosedBackLeanTo(state);
            UpdateCloseAction = state.isFullyOpenedCheckedForBackLeanTo + state.isFullyEnclosedCheckedForBackLeanTo + state.isFullyEnclosedCheckedForRightLeanTo + state.params.add_storage_check_back
        }
        if (state.params.p_f_w === "Close" && state.params.p_r_w === "Close" && state.params.p_l_w === "Close" && state.params.p_b_w === "Close") {
            const_var.setSidesEndsWallOption ="close";
        }else if(state.params.p_f_w === "Open" && state.params.p_r_w === "Open" && state.params.p_l_w === "Open" && state.params.p_b_w === "Open" && state.params.p_c_p_l == false && state.params.p_c_p_r == false) {
            const_var.setSidesEndsWallOption = "open"
        }
            else {
            const_var.setSidesEndsWallOption = "partial";
        }
        return {
            ...state,
            action
        }
        break;
    case "INDUVIDUALWALLCHANGE":
        handleWallSelectonChangeValue(state, action.value, action.wall);
        return {
            ...state,
            // newColor: action.value.target.value + action.wall + action.value.timeStamp
            action
        }
        break;
    case "ALLVERTICAL":
        let renderVerticalData = "";
        state.params.p_v_w = !state.params.p_v_w;
        if (params.p_v_w == true && const_var.TypeEnum[state.params.p_r_s] == "Regular" && params.m_s_n != 12) {
            state.params.p_v_w = false;
            state.const_var.isShowAlert = true;
            state.const_var.alertUsedFor = "RegularRoofStyle";
            renderVerticalData = "state.isFullyEnclosedChecked" + state.params.p_v_w + state.const_var.isShowAlert;
        } else {
            state.const_var.isShowAlert = false;
            renderVerticalData = "state.isFullyEnclosedChecked" + state.params.p_v_w + state.const_var.isShowAlert;
            toggleAllVerticalCheckboxChange(state);
        }
        
        if(action.key != undefined && action.key != "vertical"){
            state.params.wallTexture = action.key;
            state.params.p_v_w = false;
        }else if(action.key != undefined && action.key == "vertical" && state.params.p_v_w == true){
            state.params.wallTexture = action.key;
        }else{
            state.params.wallTexture = "none";
        }
        return {
            ...state,
            newColor: renderVerticalData+action.key
        }
        break;
    case "CUTPANELACTION":
        let panelRendr = "";
        var chkEndJtrim = false;
        var chkSideJtrim = false;
        if((const_var.a_p_d_a.jtrim) && const_var.a_p_d_a.jtrim.length>0)
        {
            chkEndJtrim = (const_var.a_p_d_a.jtrim.filter(data=>data.type=="end")).length>0?true:false;
            chkSideJtrim = (const_var.a_p_d_a.jtrim.filter(data=>data.type=="side")).length>0?true:false;
        }
        if (action.key == "leftCutPanel") {
            state.params.p_c_p_l = action.value;
            state.params.a_c_p_l = true;
            const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
            const_var.UpdatedPriceData.common_length_changed = true;
            const_var.UpdatedPriceData.surcharge_amount = undefined;
            const_var.UpdatedPriceData.certificate_price_changed = true;
            panelRendr = state.params.p_c_p_l + action.key;
            if(params.p_c_p_l==true && chkSideJtrim==true)
            {
                params.p_j_t = true;
            }
            // cuBuilding.cP('left_cut');
        } else if (action.key == "rightCutPanel") {
            state.params.p_c_p_r = action.value;
            state.params.a_c_p_r = true;
            const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
            const_var.UpdatedPriceData.common_length_changed = true;
            const_var.UpdatedPriceData.surcharge_amount = undefined;
            const_var.UpdatedPriceData.certificate_price_changed = true;
            panelRendr = state.params.p_c_p_r + action.key;
            if(params.p_c_p_r==true && chkSideJtrim==true)
            {
                params.p_j_t = true;
            }
            // cuBuilding.cP('right_cut');
        }

        const_var.UpdatedPriceData.insulation_price = undefined;
        cuBuilding.BuildingUpdate(true, 'centerwall');
        cuBuilding.cP();
        return {
            ...state,
            action
        }
        break;
    case "handleShowWhatThis":
        state.const_var.stateHelpTextContent = false;
        state.const_var.colorsHelpTextContent = false;
        state.const_var.buildSizeHelpTextContent = false;
        state.const_var.leantoHelpTextContent = false;
        state.const_var.wallsHelpTextContent = false;
        state.const_var.doorWindowHelpTextContent = false;
        state.const_var.extraHelpTextContent = false;
        state.isShowWhatThis = true;


        if (action.value == 'state') {
            state.const_var.stateHelpTextContent = true;
        } else if (action.value == 'colors') {
            state.const_var.colorsHelpTextContent = true;
        } else if (action.value == 'buildsize') {
            state.const_var.buildSizeHelpTextContent = true;
            if (action.id == 'gaugeCertificatescroll') {
                setTimeout(function () {
                    let ele = document.getElementById(action.id);
                    ele.scrollIntoView();
                }, 100);

            }

            if (action.id == 'roofscroll') {
                setTimeout(function () {
                    let ele = document.getElementById(action.id);
                    ele.scrollIntoView();
                }, 100);

            }

            if (action.id == 'instalaltionscroll') {
                setTimeout(function () {
                    let ele = document.getElementById(action.id);
                    ele.scrollIntoView();
                }, 100);

            }
        } else if (action.value == 'leanto') {
            state.const_var.leantoHelpTextContent = true;
        } else if (action.value == 'doorwindow') {
            state.const_var.doorWindowHelpTextContent = true;
        } else if (action.value == 'extraoption') {
            state.const_var.extraHelpTextContent = true;

            if (action.id == 'extraoptionscroll') {
                setTimeout(function () {
                    let ele = document.getElementById(action.id);
                    ele.scrollIntoView();
                }, 100);

            }

            if (action.id == 'jtrimscroll') {
                setTimeout(function () {
                    let ele = document.getElementById(action.id);
                    ele.scrollIntoView();
                }, 100);

            }
        } else if (action.value == 'walls') {
            state.const_var.extraHelpTextContent = true;

            if (action.id == 'wallsscroll') {
                setTimeout(function () {
                    let ele = document.getElementById(action.id);
                    ele.scrollIntoView();
                }, 100);

            }

            if (action.id == 'addinsulationscroll') {
                setTimeout(function () {
                    let ele = document.getElementById(action.id);
                    ele.scrollIntoView();
                }, 100);

            }
        }

        return {
            ...state,
            newColor: state.isShowWhatThis + "isShowWhatThis"
        }
        break;
    case "handleShowsummarymodal":
        state.params.m_s_n_1 = "";
        state.params.m_s_n_2 = "";
        state.params.m_n_f_1 = "";
        state.params.m_n_f_2 = "";
        state.selectedManufacturer = 0;
        state.isShowSummaryModal = !state.isShowSummaryModal;
        //console.log(state.selectedManufacturer,"selectedManufacturerselectedManufacturerselectedManufacturer")
        return {
            ...state,
            action,
        }
        break;
    case "handleSummaryComapreModal":
        state.const_var.isForStandardBuilding = false
        state.const_var.showComparePrices = false;
        state.params.m_s_n_1 = "";
        state.params.m_s_n_2 = "";
        state.params.m_n_f_1 = "";
        state.params.m_n_f_2 = "";
        state.selectedManufacturer = 0;
        state.isShowSummaryModal = false;
        state.isShowComparePriceModal = false;   
        return {
            ...state,
            action
        }
        break;

    case "handleShowComparePriceModal":
        state.const_var.isForStandardBuilding = false
        state.const_var.showComparePrices = false;
        state.params.m_s_n_1 = "";
        state.params.m_s_n_2 = "";
        state.params.m_n_f_1 = "";
        state.params.m_n_f_2 = ""; 
        state.selectedManufacturer = 0;
        state.isShowComparePriceModal = !state.isShowComparePriceModal;   

        state.const_var.comparisionLoadermfg1= false
        state.const_var.comparisionLoadermfg2= false
        state.const_var.NoCompareData1=false
        state.const_var.NoCompareData2=false

        return {
            ...state,
            action
        }
        break;

    case "handleScreenShareModal":
        state.screenShareModal = !state.screenShareModal;

        return {
            ...state,
            action
        }
        break;

    case "handleShowOverlay":
        state.isShowOverlay = action.value;

        return {
            ...state,
            action
        }
        break;

    case "handleShowPhotoModal":
        state.isShowPhotoModal = !state.isShowPhotoModal;
        if(controls.isCheckActiveTab == "doorwindow" && state.isShowPhotoModal == true) {
            const_var.activeTab = "buildingtypetab";         
        }
        if(controls.isCheckActiveTab == "doorwindow" && state.isShowPhotoModal == false){
            const_var.activeTab = "doorwindow"; 
        }
        

        return {
            ...state,
            action
        }
        break;

    case "handleMobileDraw":
        state.isMobileDraw = action.value;

        return {
            ...state,
            action
        }
        break;

    case "handleShowBookDemo":
        state.isShowBookDemo = !state.isShowBookDemo;

        return {
            ...state,
            action
        }
        break;

    case "handlePriceAndSummaryMobileView":
        state.selectedPiceAndSummaryMobileView = action.value;

        return {
            ...state,
            action
        }
        break;

    case "handleSetManufacturer":
        state.selectedManufacturer = action.id;

        return {
            ...state,
            action
        }
        break;

    case "handleShowShareModal":
        state.isShowShareModal = !state.isShowShareModal;

        return {
            ...state,
            action
        }
        break;

    case "handleShowfeedback":       
        if (action.category == "prompt") {   
                state.isFeedbackcontent = true;
                    
            if(const_var.loginSession ==true){
                state.isFeedbackcontent = true;
            }
            
            state.isShowfeedback = !state.isShowfeedback;
            const_var.feedback_object_to_server.success = false;
            // #################### For resetting input fields value on click of close button #################### 
            const_var.feedback_object_to_server.feedback = '';
            const_var.feedback_object_to_server.feedback_email = '';
            const_var.feedback_object_to_server.first_name = '';
            const_var.feedback_object_to_server.last_name = '';
            const_var.feedback_object_to_server.phone_number = '';
            // #################### For resetting errors on click of close button ####################
            const_var.displayerrorMessage["feedback"] = '';
            const_var.displayerrorMessage["feedback_first_name"] = '';
            const_var.displayerrorMessage["feedback_last_name"] = '';
            const_var.displayerrorMessage["feedback_email"] = '';
            const_var.displayerrorMessage["feedback_phone_number"] = '';
            // #################### For resetting emoji name and hiding input fields ####################
            state.emojiname = "love";
            state.emojiindex = 4;
        } else {

            if(action.category == "validation") {
                const_var.feedback_object_to_server.dislike_count = false;
            }

            if (action.category == "handleShowfeedbackloader") {
                state.isShowfeedbackloader = true;
            }

            if (action.category == "success") {
                state.isShowfeedbackloader = false;
                const_var.feedback_object_to_server.dislike_count = false;
                const_var.feedback_object_to_server.feedback = '';
                const_var.feedback_object_to_server.success = true;
                const_var.feedback_object_to_server.like_count = false;
                state.emojiindex = 4;
                const_var.isFeedbackFieldMandatory = false
                // #################### For resetting input fields value #################### 
                const_var.feedback_object_to_server.feedback_email = '';
                const_var.feedback_object_to_server.first_name = '';
                const_var.feedback_object_to_server.last_name = '';
                const_var.feedback_object_to_server.phone_number = '';
                // #################### For resetting errors ####################
                const_var.displayerrorMessage["feedback"] = '';
                const_var.displayerrorMessage["feedback_first_name"] = '';
                const_var.displayerrorMessage["feedback_last_name"] = '';
                const_var.displayerrorMessage["feedback_email"] = '';
                const_var.displayerrorMessage["feedback_phone_number"] = '';
                // #################### For resetting emoji name and hiding input fields ####################
                state.emojiname= "love";
                state.emojiindex= 4;

            }
            if (action.category == "dislike") {
                const_var.feedback_object_to_server.dislike_count = !const_var.feedback_object_to_server.dislike_count;
            }
            if (action.category == "like") {
                const_var.feedback_object_to_server.like_count = !const_var.feedback_object_to_server.like_count;
                if (const_var.feedback_object_to_server.like_count == true) {
                    const_var.feedback_object.like_count = const_var.feedback_object.like_count + 1;
                } else {
                    const_var.feedback_object.like_count = const_var.feedback_object.like_count - 1;
                }

            }

            if(action.category == "emojis"){
                const emojisArray = ['sad' , 'sad2', 'confused' , 'happy' , 'love'];
                state.emojiname= emojisArray[action.typen];                  
                state.emojiindex= action.typen;
                const_var.isFeedbackFieldMandatory = false;
                            
                // #################### For resetting input fields value #################### 
                const_var.feedback_object_to_server.feedback = '';
                const_var.feedback_object_to_server.feedback_email = '';
                const_var.feedback_object_to_server.first_name = '';
                const_var.feedback_object_to_server.last_name = '';
                const_var.feedback_object_to_server.phone_number = '';
                // #################### For resetting errors ####################
                const_var.displayerrorMessage["feedback"] = '';
                const_var.displayerrorMessage["feedback_first_name"] = '';
                const_var.displayerrorMessage["feedback_last_name"] = '';
                const_var.displayerrorMessage["feedback_email"] = '';
                const_var.displayerrorMessage["feedback_phone_number"] = '';
                    
                    
                    
            }
            if (action.category == "feedback") {
                const_var.feedback_object_to_server.feedback = action.event.target.value;
                // #################### Resetting error on input change fields value change #################### 
                if (action.event.target.value.length > 0) {
                    const_var.displayerrorMessage["feedback"] = '';
                }
            }
            if (action.category == "feedback_name") {
                const_var.feedback_object_to_server.feedback_name = action.event.target.value;
            }
            if (action.category == "feedback_email") {
                validate.checkValidEmail(action.event)
                const_var.feedback_object_to_server.feedback_email = action.event.target.value;
                // #################### Resetting error on input change fields value change #################### 
                if(action.event.target.value.length > 0) {
                    const_var.displayerrorMessage["feedback_email"] = '';
                }
            }
            if (action.category == "first_name") {
                const_var.feedback_object_to_server.first_name = action.event.target.value;
                // #################### Resetting error on input change fields value change #################### 
                if(action.event.target.value.length > 0) {
                    const_var.displayerrorMessage["feedback_first_name"] = '';
                }
            }
            if (action.category == "last_name") {
                const_var.feedback_object_to_server.last_name = action.event.target.value;
                // #################### Resetting error on input change fields value change #################### 
                if(action.event.target.value.length > 0) {
                    const_var.displayerrorMessage["feedback_last_name"] = '';
                }
            }
            if (action.category == "phone_number") {
                const_var.feedback_object_to_server.phone_number = action.event.target.value;
                // #################### Resetting error on input change fields value change #################### 
                if(action.event.target.value.length > 0) {
                    const_var.displayerrorMessage["feedback_phone_number"] = '';
                }
            }
            //console.log(action,action.event.target.value,const_var.feedback_object_to_server,"action1111111")
        }
        return {
            ...state,
            action
        }
        break;

    case "handleCloseBuildingModal":
        //console.log("handleCloseBuildingModal")
        state.const_var.isShowDoorwindowmobile = !state.const_var.isShowDoorwindowmobile;
        return {
            ...state,
            action
        }
        break;
    case "handlePriceBookFile":
        state.priceBookFile = action.value;

        return {
            ...state,
        }
        break;
    case "CheckSharingAlertBox":
        if (action.value == 'show') {
            const_var.SharingAlertBox = true;
        } if (action.value == 'true') {
            const_var.SharingAlertBox = false;
            window.location.href = window.location.href = const_var.crmSetting.web_url + "/" + const_var.targetRedirectUrl[const_var.crmSetting.is_module_name].view + const_var.crmSetting.is_module_id;
        }
        return {
            ...state,
            newColor: action
        }

    case "handleClose":
        state.isShowThankYou = false;
        state.const_var.checkoutModal = false;
        state.isShowWhatThis = false;
        state.isShowfeedback = false;
        state.isShowSummaryModal = false;
        state.const_var.agreeTermsAndConditionCheckbox = false;
        state.const_var.backToCheckoutBtn = true;
        state.const_var.showComponentEditBox = false;
        state.const_var.displayerrorMessage = {};
        state.isCustomer = false;
        state.isEdit = false;
        state.isaddCustomer = false;

        return {
            ...state,
            newColor: state.const_var.checkoutModal + state.isShowSummaryModal
        }
        break;
    case "handleCloseforDoorWindows":
        state.const_var.showComponentEditBox = false;
        state.isShowEditIconSection = false;
        const_var.b_s_c_n = null;
        clearTimeout(const_var.timer)
        let tempDoorArr = [...const_var.newDoorsArray]
        // if (action.doorIndex !== undefined && action.entryNoteDataValue !== undefined) {
        //     if(tempDoorArr[action.doorIndex].entryNoteData!=undefined)
        //     {
        //         tempDoorArr[action.doorIndex].entryNoteData = action.entryNoteDataValue;
        //     }
        // }
        state.const_var.newDoorsArray = tempDoorArr;
        let newDataArra = [];
        if(const_var.newDoorsArray)
        {
            const_var.newDoorsArray.map((item,index) => {
                // console.log(item,index,"const_var.entry_points")
                    let findIndex = const_var.entry_points.findIndex(data=>data.uniqueId==item.uniqueId);
                    if(findIndex!== -1)
                    {
                        newDataArra.push(const_var.entry_points[findIndex]);
                    }
            })
        }
        if(newDataArra.length== const_var.newDoorsArray.length)
        {
            const_var.entry_points = newDataArra;
        }
        return {
            ...state, action,
            newColor: const_var.showComponentEditBox + action.uniqueid + 1
        }
        break;

        case "DeviceCapture":                  
                document.querySelector('body').classList.remove('active-offset-thumbnail')

                state.const_var.ClickforPhotosMobile = React.createRef();
                    setTimeout(()=>{
                    state.const_var.ClickforPhotosMobile.current.click();                        
                    },100)


                    if(action.key=='redirect'){
                        const capturescroll = document.querySelector(`#${action.id}`); 
                        setTimeout(function(){
                        capturescroll.scrollIntoView({ behavior: "smooth"});
                    }, 500);
                    }
        return {
            ...state, 
            action,
            
        }
        break;

        

    case "hancleClickOutside":
            state.const_var.showComponentEditBox = false;
            state.const_var.showCupolaEditBox = false;
        return {
            ...state, action,
            
        }
            break;
    case "TRUSSCHANGEFUNCTION":
        state.params.trussType = action.value.replace(/[0-9]/g, '');
        state.params.newtrussType = action.value.replace(/[0-9]/g, '');
        const_var.post_data['building'].edit_truss_name = state.params.trussType;
        const_var.UpdatedPriceData.truss_price_changed = true;
        let filterDataTruss = const_var.a_p_d_a.truss_name.filter(data=>data.name.includes(const_var.post_data['building'].edit_truss_name));
        if(filterDataTruss.length>0)
        {
            const_var.post_data['building'].truss_type_name = filterDataTruss[0].is_default==true?'Standard Truss': (state.params.m_s_n == 153 ? "Ladder Truss" : 'High Truss');
        }
        cuBuilding.BuildingUpdate(true,"");
        cuBuilding.cP();
    return{
        ...state,
        newColor:action.value + const_var.post_data['building'].edit_truss_name
    }        
    case "ADDWAINSCOT":
        const_var.UpdatedPriceData.wainscot_price_changed = true;
        // const_var.UpdatedPriceData.roof_color_price_changed = true;
        // const_var.UpdatedPriceData.wall_color_price_changed = true;
        // const_var.UpdatedPriceData.trim_color_price_changed = true;
        // const_var.UpdatedPriceData.color_price_changed = true;
        if( params.p_e_i != "other" ) const_var.UpdatedPriceData.certificate_price_changed = true;
        updateWainscot(state)
        return {
            ...state,
            newColor: state.params.p_w_c_n + "updateWainscot"
        }
        break;

    case "handleAccordion":
        //  console.log(action.value);
        var sections = document.querySelectorAll('.accordion-type-2 .card');
        // console.log(e.currentTarget.parentNode.parentNode.classList.contains("active"),"e.currentTarget.parentNode.parentNode.classList.contains")
        if (action.value.currentTarget.parentNode.parentNode.classList.contains("active") == true) {
            action.value.currentTarget.parentNode.parentNode.classList.remove('active');
        } else {
            sections = action.value.currentTarget.parentNode.parentNode.parentNode.children;
            for (let i = 0; i < sections.length; i++) {
                sections[i].classList.contains("active")
                sections[i].classList.remove('active');
            }

            action.value.currentTarget.parentNode.parentNode.classList.add('active')
        }           
        const_var.accodionEvent = action.value.currentTarget.parentNode.parentNode.classList  
        
        return {
            ...state,
            action
        }
        break;
        
    case 'activeTabPanel':
        let newAction
        // if(action.key !=undefined && action.key !="" && action.flag == undefined){
        //     if (action.value.currentTarget.parentNode.classList.contains("active") == true && const_var.isActiveSlide) {
        //         action.value.currentTarget.parentNode.classList.remove('active');
        //         const_var.activeTab = null
        //         newAction = const_var.activeTab
        //     } else {
        //         sections = action.value.currentTarget.parentNode.parentNode.children;
        //         for (let i = 0; i < sections.length; i++) {
        //             sections[i].classList.contains("active")
        //             sections[i].classList.remove('active');
        //         }
        //         const_var.activeTab = action.key
        //         action.value.currentTarget.parentNode.classList.add('active')
        //         newAction = const_var.activeTab
        //     }
        //  }else{
        //      const_var.activeTab = null
        //  }
        //  if(action.flag == "change" &&  document.getElementsByClassName('card-menu')!=undefined){
        //     const_var.activeTab = action.key
        //     document.getElementsByClassName('card-menu')[1]?.classList.remove('active')
        //     document.getElementsByClassName('card-menu')[0]?.classList.add('active')
        //  }


            if(action.key !=undefined && action.key != null  ){
                    const_var.activeTab =  action.key
                    newAction = const_var.activeTab
                
            }else{
                const_var.activeTab = null
                newAction = const_var.activeTab
            }
        return {
            ...state,
            newAction
        }


        

    case "TaxDepositCalculation":
        if (action.index == "type") {
            if (action.key != "tax") {
                //state.const_var.UpdatedPriceData[action.key] = (action.value=="%")?"per":"amt";
                state.const_var.UpdatedPriceData[action.key] = (action.value == "%") ? "per" : "amt";
                if (action.key == "down_payment_discount_type") {
                    state.const_var.UpdatedPriceData['down_payment_discount_rate'] = 0;
                    state.const_var.UpdatedPriceData['down_payment_discount_rate_Updated'] = 0;
                } if (action.key == "down_payment_type") {
                    state.const_var.UpdatedPriceData['down_payment_rate'] = 0;
                    state.const_var.UpdatedPriceData['down_payment_discount_rate'] = 0;
                    state.const_var.UpdatedPriceData['down_payment_rate_Updated'] = 0;
                    state.const_var.UpdatedPriceData['down_payment_discount_rate_Updated'] = 0;
                }
                if (action.key == "discount_type") {
                    const_var.UpdatedPriceData.surcharge_amount=undefined;
                    state.const_var.UpdatedPriceData['discount_rate'] = 0;
                    state.const_var.UpdatedPriceData['discount_rate_updated'] = 0;
                }
                if (action.key == "custom_insulation_down_payment_type") {
                    state.const_var.UpdatedPriceData['custom_insulation_down_payment_rate'] = 0;
                }
                if (action.key == "custom_overhead_down_payment_type") {
                    state.const_var.UpdatedPriceData['custom_overhead_down_payment_rate'] = 0;
                }

            } else {
                state.const_var.tax.type = (action.value == "%") ? "per" : "amt";
                state.const_var.tax.percentage = 0;
                if (params.tax_zipcode !== "" && params.tax_zipcode.length > 4 ){
                    state.const_var.tax.percentage = state.const_var.tax.tax_value;
                }
            }
        } else if (action.index == "name") {
            if (action.key == "tax") {
                state.const_var.tax.name = action.value;
                params.globalTaxValue = action.value;
            }
        } else {
            if (action.key != "percentage") {
                //console.log(const_var.UpdatedPriceData.down_payment_discount_type,"const_var.UpdatedPriceData.down_payment_discount_type",const_var.UpdatedPriceData.down_payment_discount_rate)
                //state.const_var.UpdatedPriceData[action.key] = parseInt(action.value);
                if(action.key == "discounttypename"){
                    let ValueValidate = /^[a-zA-Z\s]*$/;
                    if(action.value !== null && ValueValidate.test(action.value)){
                        const_var.dealer_discount_label = action.value
                    }
                    else{
                        const_var.dealer_discount_label = const_var.dealer_discount_label 
                    }                        
                }
                if(action.key == "MFdiscounttypename"){
                    let ValueValidate = /^[a-zA-Z\s]*$/;
                    if(action.value !== null && ValueValidate.test(action.value)){
                        const_var.manufacturer_discount_label = action.value
                    }
                    else{
                        const_var.manufacturer_discount_label = const_var.manufacturer_discount_label
                    }                        
                }
                action.value = action.value.replace(/^0+/, '');
                action.value = action.value.replace(/[^\d.-]/g, '');
                action.value = action.value.replace(/\-/g,'');
                state.const_var.UpdatedPriceData[action.key] = action.value;
                state.const_var.UpdatedPriceData[action.key + '_Updated'] = action.value;
                const_var.post_data.building[action.key + '_Updated'] = action.value;
                state.const_var.UpdatedPriceData[action.key + '_updated'] = action.value;
                const_var.post_data.building[action.key + '_updated'] = action.value;
                var regex = /^\d+(\.\d{0,2})?$/g;
                if (!regex.test(state.const_var.UpdatedPriceData[action.key])) {
                    if (isNaN(parseFloat(state.const_var.UpdatedPriceData[action.key])) == true || state.const_var.UpdatedPriceData[action.key] == "") {
                        state.const_var.UpdatedPriceData[action.key] = 0;
                    } else {
                        state.const_var.UpdatedPriceData[action.key] = state.const_var.UpdatedPriceData[action.key].split(".");
                        state.const_var.UpdatedPriceData[action.key] = state.const_var.UpdatedPriceData[action.key][0] + '.' + state.const_var.UpdatedPriceData[action.key][1].substring(0, 2);
                    }
                }

                if(action.key == 'down_payment_rate' &&  state.const_var.UpdatedPriceData[action.key] == 0){
                    const_var.UpdatedPriceData.down_payment_total = 0
                }
                if(action.key=="discount_rate")
                {
                    const_var.UpdatedPriceData.surcharge_amount=undefined;
                }
                // var regex = /^\d+(\.\d{0,2})?$/g;
                // if (!regex.test(state.const_var.UpdatedPriceData[action.key])) {
                //     state.const_var.UpdatedPriceData[action.key] = 0;
                // }
                if (const_var.UpdatedPriceData.custom_insulation_down_payment_type == 'per' && parseFloat(const_var.UpdatedPriceData.custom_insulation_down_payment_rate) > 100) {
                    state.const_var.UpdatedPriceData[action.key] = 0;
                    const_var.post_data.building.custom_insulation_down_payment_rate = 0;
                }
                if (const_var.UpdatedPriceData.custom_overhead_down_payment_type == 'per' && parseFloat(const_var.UpdatedPriceData.custom_overhead_down_payment_rate) > 100) {
                    state.const_var.UpdatedPriceData[action.key] = 0;
                    const_var.post_data.building.custom_overhead_down_payment_rate = 0;
                }
                if (const_var.UpdatedPriceData.custom_insulation_down_payment_type == 'amt' && action.key == "custom_insulation_down_payment_rate" && parseFloat(action.value)>parseFloat(const_var.post_data.building.custom_insulation_total_amount)) {
                    state.const_var.UpdatedPriceData[action.key] = 0;
                    const_var.post_data.building.custom_insulation_down_payment_rate = 0;
                }
                if (const_var.UpdatedPriceData.custom_overhead_down_payment_type == 'amt' && action.key == "custom_overhead_down_payment_rate" && parseFloat(action.value)>parseFloat(const_var.UpdatedPriceData.custom_overhead_total_amount)) {
                    state.const_var.UpdatedPriceData[action.key] = 0;
                    const_var.post_data.building.custom_overhead_down_payment_rate = 0;
                }
                if (const_var.UpdatedPriceData.down_payment_type == 'per' && parseFloat(const_var.UpdatedPriceData.down_payment_rate) > 100) {
                    state.const_var.UpdatedPriceData[action.key] = 0;
                    const_var.post_data.building.down_payment_rate = 0;
                } if (const_var.UpdatedPriceData.down_payment_type == 'amt' && const_var.BuildingPriceArrar['sub_order_total'] != undefined && parseFloat(const_var.UpdatedPriceData.down_payment_rate) > parseFloat(const_var.BuildingPriceArrar['sub_order_total'])) {
                    state.const_var.UpdatedPriceData[action.key] = 0;
                    const_var.post_data.building.down_payment_rate = 0;
                } if (const_var.UpdatedPriceData.down_payment_discount_type == 'per' && parseFloat(const_var.UpdatedPriceData.down_payment_discount_rate) > 100) {
                    state.const_var.UpdatedPriceData[action.key] = 0;
                    const_var.post_data.building.down_payment_discount_rate = 0;
                } if (const_var.UpdatedPriceData.down_payment_discount_type == 'amt' && parseFloat(const_var.UpdatedPriceData.down_payment_discount_rate) > parseFloat(const_var.UpdatedPriceData.down_payment_total)) {
                    state.const_var.UpdatedPriceData[action.key] = 0;
                    const_var.post_data.building.down_payment_discount_rate = 0;
                    const_var.UpdatedPriceData['down_payment_discount_rate'] = 0;
                }
                if (const_var.UpdatedPriceData.discount_type == 'per' && parseFloat(const_var.UpdatedPriceData.discount_rate) > 100) {
                    state.const_var.UpdatedPriceData[action.key] = 0;
                    const_var.post_data.building.discount_rate = 0;
                    const_var.UpdatedPriceData.surcharge_amount=undefined;
                } if (const_var.UpdatedPriceData.discount_type == 'amt' && parseFloat(const_var.UpdatedPriceData.discount_rate) > parseFloat(const_var.UpdatedPriceData.order_total)) {
                    state.const_var.UpdatedPriceData[action.key] = 0;
                    const_var.post_data.building.discount_rate = 0;
                    const_var.UpdatedPriceData.surcharge_amount=undefined;
                }
                if (const_var.UpdatedPriceData.discount_type == 'per' && parseFloat(const_var.UpdatedPriceData.discount_rate) == 100) {
                    state.const_var.UpdatedPriceData['down_payment_rate'] = 0;
                    state.const_var.UpdatedPriceData['down_payment_discount_rate'] = 0;
                    const_var.post_data.building.down_payment_rate = 0;
                    const_var.post_data.building.down_payment_discount_rate = 0;
                    const_var.UpdatedPriceData.surcharge_amount=undefined;
                }
                if (const_var.UpdatedPriceData.discount_type == 'amt' && parseFloat(const_var.UpdatedPriceData.discount_rate) == parseFloat(const_var.UpdatedPriceData.order_total)) {
                    state.const_var.UpdatedPriceData['down_payment_rate'] = 0;
                    state.const_var.UpdatedPriceData['down_payment_discount_rate'] = 0;
                    const_var.post_data.building.down_payment_rate = 0;
                    const_var.post_data.building.down_payment_discount_rate = 0;
                    const_var.UpdatedPriceData.surcharge_amount=undefined;
                }
                if (isNaN((action.value))) {
                    state.const_var.UpdatedPriceData[action.key] = 0;
                }
            } else {
                action.value = action.value.replace(/^0+/, '');
                action.value = action.value.replace(/[^\d.-]/g, '');
                action.value = action.value.replace(/\-/g,'');
                const_var.LeadCustomerData.taxPersentage = action.value;
                state.const_var.tax.percentage = action.value;

                var regex = /^\d+(\.\d{0,3})?$/g;
                if (!regex.test(state.const_var.tax.percentage)) {
                    if (isNaN(parseFloat(state.const_var.tax.percentage)) == true || state.const_var.tax.percentage == "") {
                        state.const_var.tax.percentage = 0;
                        state.const_var.tax.amount = 0;
                    } else {
                        state.const_var.tax.percentage = state.const_var.tax.percentage.split(".");
                        state.const_var.tax.percentage = state.const_var.tax.percentage[0] + '.' + state.const_var.tax.percentage[1].substring(0, 3);
                    }
                }

                // var regex = /^\d+(\.\d{0,2})?$/g;
                // if (!regex.test(state.const_var.tax.percentage)) {
                //     state.const_var.tax.percentage = 0;
                // }
                //state.const_var.tax.percentage = action.value;
                if (isNaN((state.const_var.tax.percentage))) {
                    state.const_var.tax.percentage = 0;
                }
            }
        }
        cuBuilding.cP();
        //console.log(state.const_var.UpdatedPriceData[action.key],action.key,"tate.const_var.UpdatedPriceData[action.key]",const_var.post_data.building)
        return {
            ...state,
            newColor: action
        }
        break;
    case "AdditionComponentAdd":
        if (action.condition == "additionalComponent" && action.nextVal != '') {
            state.const_var.inputs[action.index] = action.nextVal;
            if (action.indexName == "additional_name") {
                if(action.value!='')
                {
                    state.const_var.inputs[action.index].additional_name = action.value;
                }else{
                    state.const_var.inputs[action.index].additional_name = action.value;
                    state.const_var.inputs[action.index].additional_quantity = 0;
                }
                
                cuBuilding.cP();
            } else {
                state.const_var.inputs[action.index].additional_quantity = (isNaN(parseInt(action.value)) == true) ? 0 : parseInt(action.value);
                cuBuilding.cP();
            }
        }
        return {
            ...state,
            AdditionComponentAdd: state.const_var.inputs[action.index].additional_name + state.const_var.inputs[action.index].additional_quantity + action.value + action.condition
        }
        break;
    case "AddNewComponentAdd":
        if (action.condition == "addNewComponent" && action.nextVal != '') {
            state.const_var.Componentinputs[action.index] = action.nextVal;
            if (action.indexName == "additional_name") {
                if(action.value!='')
                {
                    state.const_var.Componentinputs[action.index].additional_name = action.value;
                }else{
                    state.const_var.Componentinputs[action.index].additional_name = action.value;
                    state.const_var.Componentinputs[action.index].additional_quantity = 0;
                }
                cuBuilding.cP();
            } else {
                state.const_var.Componentinputs[action.index].additional_quantity = (isNaN(parseInt(action.value)) == true) ? 0 : parseInt(action.value);
                cuBuilding.cP();
            }
        }
        return {
            ...state,
            AdditionComponentAdd: state.const_var.Componentinputs[action.index].additional_name + state.const_var.Componentinputs[action.index].additional_quantity + action.value + action.condition
        }
        break;
    case "addNewTax":
        // console.log(action.index, "index", action.condition,"condition",action.value,"value",action.indexName,"indexName",action.nextVal,"nextVal",);
        if (action.condition == "addNewTax" && action.nextVal != '') {
            state.const_var.MoreTaxinputs[action.index] = action.nextVal;
            if (action.indexName == "type") {
                state.const_var.MoreTaxinputs[action.index].type = (action.value == "%") ? "per" : "amt";
                action.value = (action.value == "%") ? "per" : "amt";
                // state.const_var.MoreTaxinputs[action.index].percentage = 0;
                // state.const_var.MoreTaxinputs[action.index].percentage = state.const_var.MoreTaxinputs[action.index].tax_value;
            } else {
                if (state.const_var.MoreTaxinputs[action.index].type == "%") {
                    state.const_var.MoreTaxinputs[action.index].type = "per";
                } if (state.const_var.MoreTaxinputs[action.index].type == "$") {
                    state.const_var.MoreTaxinputs[action.index].type = "amt";
                }
            }
            if (action.indexName != "percentage") {
                state.const_var.MoreTaxinputs[action.index][action.indexName] = action.value;
                params.globalTaxValue = action.value;
            } else {
                action.value = action.value.replace(/^0+/, '');
                action.value = action.value.replace(/[^\d.-]/g, '');
                action.value = action.value.replace(/\-/g,'');
                state.const_var.MoreTaxinputs[action.index][action.indexName] = action.value;
                // state.const_var.MoreTaxinputs[action.index].tax_value = action.value

                var regex = /^\d+(\.\d{0,3})?$/g;
                if (!regex.test(state.const_var.MoreTaxinputs[action.index][action.indexName])) {
                    if (isNaN(parseFloat(state.const_var.MoreTaxinputs[action.index][action.indexName])) == true || state.const_var.MoreTaxinputs[action.index][action.indexName] == "") {
                        state.const_var.MoreTaxinputs[action.index][action.indexName] = 0;
                    } else {
                        state.const_var.MoreTaxinputs[action.index][action.indexName] = state.const_var.MoreTaxinputs[action.index][action.indexName].split(".");
                        state.const_var.MoreTaxinputs[action.index][action.indexName] = state.const_var.MoreTaxinputs[action.index][action.indexName][0] + '.' + state.const_var.MoreTaxinputs[action.index][action.indexName][1].substring(0, 3);
                    }
                }

                // var regex = /^\d+(\.\d{0,2})?$/g;
                // if (!regex.test(state.const_var.MoreTaxinputs[action.index][action.indexName])) {
                //     state.const_var.MoreTaxinputs[action.index][action.indexName] = 0;
                // }
                //state.const_var.tax.percentage = action.value;
                if (isNaN((state.const_var.MoreTaxinputs[action.index][action.indexName]))) {
                    state.const_var.MoreTaxinputs[action.index][action.indexName] = 0;
                }
            }
            cuBuilding.cP();
        }
        return {
            ...state,
            AdditionNewComponentAdd: action.index + state.const_var.MoreTaxinputs[action.index].name+ params.globalTaxValue + state.const_var.MoreTaxinputs[action.index].type + action.value + action.condition
        }
        break;
        case 'handleLiftRequired':
            state.params.lift_type = ! params.lift_type;
            const_var.UpdatedPriceData.lifttype_price_changed = true;
            cuBuilding.cP();
        return{
            ...state,
            action
        }
        break;
    case "handleInsulation":
        //console.log(action ,"handleInsulation");
        //console.log('params.insulation.rightLean.insulationId',params.insulation.leftLean.insulationId);
        const type = action._type;
        const leanType = type.split("Lean")[0];
        const insulation_price_changed = `${leanType}${"_lean_insulation_price_changed"}`;
        if (action.condition == "insulation") {
            state.params.insulation[type].insulationId = action.value;
            if (action.value !=0) state.params.selectedInsulationId = action.value;
            // console.log(action.value,"action.value", state.params.selectedInsulationId , "selectedInsulationId");
            if (state.params.insulation[type].insulationId != 0) {
                state.params.insulation[type].showInsulationOptions = true;
                if ( !state.params.insulation[type].fullBuilding ) state.params.insulation[type].roofOnly = true;       
                
            } else {
                state.params.insulation[type].showInsulationOptions = false;
                // state.params.insulation[type].fullBuilding = false;
                // state.params.insulation[type].roofOnly = false;
                // state.params.insulation.center.showInsulationOptions = false;
                state.const_var.showDefaultInsullation = false;
                // state.params.p_r_o = false;
                // state.params.p_f_i = false;

            }
            
                const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
            // if( type != "frontLean" && params.add_front_lean && state.params.insulation.frontLean.insulationId != 0 && state.params.insulation.frontLean.insulationId != state.params.selectedInsulationId) {
            //     state.params.insulation.frontLean.insulationId = state.params.selectedInsulationId;
            //     const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
            //     cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
            // }
            // if( type != "leftLean" && params.add_left_lean && state.params.insulation.leftLean.insulationId != 0 && state.params.insulation.leftLean.insulationId != state.params.selectedInsulationId) {
            //     state.params.insulation.leftLean.insulationId = state.params.selectedInsulationId;
            //     const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
            //     cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
            // }
            // if( type != "rightLean" && params.add_right_lean && state.params.insulation.rightLean.insulationId != 0 && state.params.insulation.rightLean.insulationId != state.params.selectedInsulationId) {
            //     state.params.insulation.rightLean.insulationId = state.params.selectedInsulationId;
            //     const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
            //     cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
            // }
            // if( type != "backLean" && params.add_back_lean && state.params.insulation.backLean.insulationId != 0 && state.params.insulation.backLean.insulationId != state.params.selectedInsulationId) {
            //     state.params.insulation.backLean.insulationId = state.params.selectedInsulationId;
            //     const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
            //     cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
            // }

            // if(state.params.p_i_o != 0 &&  state.params.p_i_o != state.params.selectedInsulationId) {
            //     state.params.p_i_o = state.params.selectedInsulationId;
            //     const_var.UpdatedPriceData.insulation_price = undefined;
            //     if (state.params.p_i_o != 0) {
            //         // state.params.insulation.center.showInsulationOptions = true;
            //         if ( !state.params.p_f_i ) state.params.p_r_o = true;
            //     }
            //      else {
            //         state.params.insulation.center.showInsulationOptions = false;
            //     //     state.params.p_r_o = false;
            //     //     state.params.p_f_i = false;
            //     }
            // }
        }
        if (action.condition == "custom") {
            state.params.insulation[type].insulationId = action.value == 0 ? (type != undefined ? Object.keys(const_var.insulationJsonLeanTo)[0] : Object.keys(const_var.insulationJson)[0] ) : action.value;
            if (action.value !=0) state.params.selectedInsulationId = action.value;
            // console.log(action.value,"action.value", state.params.selectedInsulationId , "selectedInsulationId");
            // console.log('type',type, state.params.insulation[type].insulationId);
            // console.log('params.insulation.rightLean.insulationId',params.insulation.leftLean.insulationId);
            if (state.params.insulation[type].insulationId != 0) {
                state.params.insulation[type].showInsulationOptions = true;
                state.params.insulation[type].custom = true
                state.params.insulation[type].fullBuilding = false
                state.params.insulation[type].roofOnly = false
                
            } else {
                state.params.insulation[type].showInsulationOptions = false;
                // state.params.insulation[type].fullBuilding = false;
                // state.params.insulation[type].roofOnly = false;
                // state.params.insulation.center.showInsulationOptions = false;
                state.const_var.showDefaultInsullation = false;
                // state.params.p_r_o = false;
                // state.params.p_f_i = false;

            }
            // console.log('params.insulation.rightLean.insulationId',params.insulation.leftLean.insulationId);
            
                const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
            // if( type != "frontLean" && params.add_front_lean && state.params.insulation.frontLean.insulationId != 0 ) {
            // // if( type != "frontLean" && params.add_front_lean && state.params.insulation.frontLean.insulationId != 0 && state.params.insulation.frontLean.insulationId != state.params.selectedInsulationId) {
            //     state.params.insulation.frontLean.insulationId = state.params.selectedInsulationId;
            //     const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
            //     cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
            // }
            // if( type != "leftLean" && params.add_left_lean && state.params.insulation.leftLean.insulationId != 0 ) {
            // // if( type != "leftLean" && params.add_left_lean && state.params.insulation.leftLean.insulationId != 0 && state.params.insulation.leftLean.insulationId != state.params.selectedInsulationId) {
            //     state.params.insulation.leftLean.insulationId = state.params.selectedInsulationId;
            //     const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
            //     cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
            // }
            // if( type != "rightLean" && params.add_right_lean && state.params.insulation.rightLean.insulationId != 0 ) {
            // // if( type != "rightLean" && params.add_right_lean && state.params.insulation.rightLean.insulationId != 0 && state.params.insulation.rightLean.insulationId != state.params.selectedInsulationId) {
            //     state.params.insulation.rightLean.insulationId = state.params.selectedInsulationId;
            //     const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
            //     cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
            // }
            // if( type != "backLean" && params.add_back_lean && state.params.insulation.backLean.insulationId != 0 ) {
            // // if( type != "backLean" && params.add_back_lean && state.params.insulation.backLean.insulationId != 0 && state.params.insulation.backLean.insulationId != state.params.selectedInsulationId) {
            //     state.params.insulation.backLean.insulationId = state.params.selectedInsulationId;
            //     const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
            //     cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
            // }

            // if(state.params.p_i_o != 0 &&  state.params.p_i_o != state.params.selectedInsulationId) {
            //     state.params.p_i_o = state.params.selectedInsulationId;
            //     const_var.UpdatedPriceData.insulation_price = undefined;
            //     if (state.params.p_i_o != 0) {
            //         // state.params.insulation.center.showInsulationOptions = true;
            //         // if ( !state.params.p_f_i ) state.params.p_r_o = true;
                    
            //         state.params.p_c_i = true
            //         state.params.p_f_i = false
            //         state.params.p_r_o = false
            //     }
            //      else {
            //         state.params.insulation.center.showInsulationOptions = false;
            //     //     state.params.p_r_o = false;
            //     //     state.params.p_f_i = false;
            //     }
            // }
        }
        if (action.condition == "roofOnly") {
            state.params.insulation[type].roofOnly = !state.params.insulation[type].roofOnly;
            state.params.insulation[type].fullBuilding = (state.params.insulation[type].roofOnly == true) ? false : state.params.insulation[type].fullBuilding;
            state.params.insulation[type].custom = (state.params.insulation[type].roofOnly == true || state.params.insulation[type].fullBuilding == true) ? false : state.params.insulation[type].custom;
            if (state.params.insulation[type].roofOnly == false) {
                state.params.insulation[type].insulationId = 0;
                state.params.insulation[type].showInsulationOptions = false;
            }
        }
        if (action.condition == "fullBuilding") {
            state.params.insulation[type].fullBuilding = !state.params.insulation[type].fullBuilding;
            state.params.insulation[type].roofOnly = (state.params.insulation[type].fullBuilding == true) ? false : state.params.insulation[type].roofOnly;
            state.params.insulation[type].custom = (state.params.insulation[type].roofOnly == true || state.params.insulation[type].fullBuilding == true) ? false : state.params.insulation[type].custom;
            if (state.params.insulation[type].fullBuilding == false) {
                state.params.insulation[type].insulationId = 0;
                state.params.insulation[type].showInsulationOptions = false;
            }
        }

        if (action.condition == "checkBox") {
            if (type == "center") {
                state.params.insulation.center.isCheked = !state.params.insulation.center.isCheked;
                if (state.params.insulation.center.isCheked){
                    // console.log(const_var.insulationJson, const_var.insulationJson[1], const_var.insulationPriceJson , const_var.insulationPriceJson[1], const_var.a_p_d_a.insulation ,const_var.a_p_d_a.insulation[0].insulation_id);
                    state.params.p_i_o = state.params.selectedInsulationId == 0 ? const_var.a_p_d_a.insulation[0].insulation_id : state.params.selectedInsulationId ;
                    state.params.insulation.center.insulationId = state.params.p_i_o;
                    state.params.selectedInsulationId = state.params.p_i_o;
                } else {
                    state.params.p_i_o = 0;
                    state.params.insulation.center.insulationId = 0;
                }
                state.params.insulation.center.showInsulationOptions = state.params.insulation.center.isCheked ? true : false;
                state.params.insulation.center.roofOnly = state.params.insulation.center.insulationId !== 0 ? true : false;
                state.params.insulation.center.fullBuilding = state.params.insulation.center.roofOnly ? false : state.params.insulation.center.fullBuilding;
                state.params.insulation.center.custom = (state.params.insulation.center.roofOnly || state.params.insulation.center.fullBuilding) ? false : state.params.insulation.center.custom;
                state.params.p_r_o = state.params.p_i_o !== 0 ? true : false;
                state.params.p_f_i = state.params.p_r_o ? false : state.params.p_f_i;
                state.params.p_c_i = (state.params.p_r_o || state.params.p_f_i) ? false : state.params.p_c_i;
                const_var.UpdatedPriceData.insulation_price = undefined;
                const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
                // console.log(state.params.p_i_o,"p_i_o", state.params.p_r_o, "p_r_o", state.params.p_f_i,"p_f_i" );
                cuBuilding.cP();

            } else {
                state.params.insulation[type].isCheked = !state.params.insulation[type].isCheked;
                if (state.params.insulation[type].isCheked){
                    state.params.insulation[type].insulationId = state.params.selectedInsulationId == 0 ? const_var.a_p_d_a.insulation[0].insulation_id : state.params.selectedInsulationId ;
                    state.params.selectedInsulationId = state.params.insulation[type].insulationId
                } else{
                    state.params.insulation[type].insulationId = 0;
                }
                state.params.insulation[type].showInsulationOptions = state.params.insulation[type].isCheked ? true : false;
                state.params.insulation[type].roofOnly = state.params.insulation[type].insulationId !== 0 ? true : false;
                state.params.insulation[type].fullBuilding = state.params.insulation[type].roofOnly ? false : state.params.insulation[type].fullBuilding;
                state.params.insulation[type].custom = (state.params.insulation[type].roofOnly || state.params.insulation[type].fullBuilding) ? false : state.params.insulation[type].custom;
            }
        }

        // console.log(params.insulation[type] , "insulation[type]");
        /*Assign initial value to params.selectedInsulationId=0*/
        const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
        let isInsulation = Object.keys(state.params.insulation).find(lean=>state.params.insulation[lean].insulationId != 0)
        /*End of the code*/
        state.const_var.UpdatedPriceData[insulation_price_changed] = true;
        state.const_var.UpdatedPriceData.insulation_price = undefined;
        state.const_var.UpdatedPriceData.insulation_price_changed = true;
        // console.log('params.insulation.rightLean.insulationId',params.insulation.leftLean.insulationId);
        if( type == "frontLean") cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront); 
        if( type == "leftLean") cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft); 
        if( type == "rightLean") cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight); 
        if( type == "backLean") cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
        return {
            ...state,
            action,
            newColor:isInsulation + params.selectedInsulationId+action+state.params.insulation+state.params.insulation[type]+insulation_price_changed+leanType+new Date() 
        }
        break;
    case "handleInsulationFor":
            // console.log('action',action);
        if(action.isfor == undefined && const_var.a_p_d_a){
            if( const_var.insulationPriceJson.insulation_wall == undefined){
                const_var.insulationPriceJson.insulation_wall = {};
            }
            const_var.insulationPriceJson.insulation_wall[action.key] = const_var.insulationPriceJson.insulation_wall && const_var.insulationPriceJson.insulation_wall[action.key] && const_var.insulationPriceJson.insulation_wall[action.key] == true ? false : true
            
            if(action.key == "full_roof" && (params.cB_addStorage_check_left || params.p_u_c || params.cB_addStorage_check_right)){
                const_var.insulationPriceJson.insulation_wall['open_roof'] = const_var.insulationPriceJson.insulation_wall[action.key] == true ? 'included' : false
                const_var.insulationPriceJson.insulation_wall['storage_roof'] = const_var.insulationPriceJson.insulation_wall[action.key] == true ? 'included' : false
            }
            if((action.key == "open_roof" || action.key == "storage_roof") && (params.cB_addStorage_check_left || params.p_u_c || params.cB_addStorage_check_right)){
                if(const_var.insulationPriceJson.insulation_wall['open_roof'] == true && const_var.insulationPriceJson.insulation_wall['storage_roof'] == true){
                    const_var.insulationPriceJson.insulation_wall['full_roof'] = true
                    const_var.insulationPriceJson.insulation_wall['open_roof'] = 'included'
                    const_var.insulationPriceJson.insulation_wall['storage_roof'] = 'included'
                }
                // if(const_var.a_p_d_a.insulation_wall['open_roof'] == true && const_var.a_p_d_a.insulation_wall['storage_roof'] == true && const_var.a_p_d_a.insulation_wall['open_roof'] != 'included' && const_var.a_p_d_a.insulation_wall['storage_roof'] != 'included'){
                //     const_var.a_p_d_a.insulation_wall['full_roof'] = false
                // }
            }
            // left wall + left/end storage is added, then left wall of storage is already included
            if(action.key == "p_l_w" && params.p_u_c){
                const_var.insulationPriceJson.insulation_wall['storage_left'] = const_var.insulationPriceJson.insulation_wall[action.key] == true ? 'included' : false
            }
            // if(action.key == "storage_left" && params.p_u_c && params.p_l_w == "Close"){
            //     const_var.insulationPriceJson.insulation_wall['p_l_w'] = true
            //     const_var.insulationPriceJson.insulation_wall['storage_left'] = 'included'
            // }
            // if(action.key == "p_l_w" && (params.cB_addStorage_check_left || params.p_u_c)){
            //     const_var.insulationPriceJson.insulation_wall['storage_left'] = const_var.insulationPriceJson.insulation_wall[action.key] == true ? 'included' : false
            // }
            // right wall + right/end storage is added, then right wall of storage is already included
            if(action.key == "p_r_w" && params.p_u_c){
                const_var.insulationPriceJson.insulation_wall['storage_right'] = const_var.insulationPriceJson.insulation_wall[action.key] == true ? 'included' : false
            }
            // if(action.key == "storage_right" && params.p_u_c && params.p_r_w == "Close"){
            //     const_var.insulationPriceJson.insulation_wall['p_r_w'] = true
            //     const_var.insulationPriceJson.insulation_wall['storage_right'] = 'included'
            // }
            // if(action.key == "p_r_w" && (params.cB_addStorage_check_right || params.p_u_c)){
            //     const_var.insulationPriceJson.insulation_wall['storage_right'] = const_var.insulationPriceJson.insulation_wall[action.key] == true ? 'included' : false
            // }
            // back wall + any storage is added, then back wall of storage is already included
            if(action.key == "p_b_w" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)){
                const_var.insulationPriceJson.insulation_wall['storage_back'] = const_var.insulationPriceJson.insulation_wall[action.key] == true ? 'included' : false
            }
            // if(action.key == "storage_back" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right) && params.p_b_w == "Close"){
            //     const_var.insulationPriceJson.insulation_wall['p_b_w'] = true
            //     const_var.insulationPriceJson.insulation_wall['storage_back'] = 'included'
            // }
            // front wall + left/right storage is added, then front wall of storage is already included
            if(action.key == "p_f_w" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)){
                const_var.insulationPriceJson.insulation_wall['storage_front'] = const_var.insulationPriceJson.insulation_wall[action.key] == true ? 'included' : false
            }
            // if(action.key == "storage_front" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right) && params.p_f_w == "Close"){
            //     const_var.insulationPriceJson.insulation_wall['p_f_w'] = true
            //     const_var.insulationPriceJson.insulation_wall['storage_front'] = 'included'
            // }
            
        }
        if(action.isfor != undefined && action.isfor== 'frontLean' && const_var.leanGetDataFront){
            if( const_var.insulationArrayForLeantoFront.insulation_wall == undefined){
                const_var.insulationArrayForLeantoFront['insulation_wall'] = {}
            }
            const_var.insulationArrayForLeantoFront.insulation_wall[action.key] = const_var.insulationArrayForLeantoFront.insulation_wall && const_var.insulationArrayForLeantoFront.insulation_wall[action.key] && const_var.insulationArrayForLeantoFront.insulation_wall[action.key] == true ? false : true
            // left wall + storage, then front wall of storage is already included
            if(action.key == "p_b_c_b_f_l" && params.add_storage_check_front){
                const_var.insulationArrayForLeantoFront.insulation_wall['storage_left'] = const_var.insulationArrayForLeantoFront.insulation_wall[action.key] == true ? 'included' : false
            }
            // if(action.key == "storage_left" && params.add_storage_check_front && params.p_b_c_b_f_l == "Close"){
            //     const_var.insulationArrayForLeantoFront.insulation_wall['p_b_c_b_f_l'] = true
            //     const_var.insulationArrayForLeantoFront.insulation_wall['storage_left'] = 'included'
            // }
            // back wall + storage, then back wall of storage is already included
            // if(action.key == "p_b_c_b_f_b" && params.add_storage_check_front){
            //     const_var.insulationArrayForLeantoFront.insulation_wall['storage_back'] = const_var.insulationArrayForLeantoFront.insulation_wall[action.key] == true ? 'included' : false
            // }
            // full roof + storage, then storage roof + open roof also included
            if(action.key == "full_roof" && params.add_storage_check_front){
                const_var.insulationArrayForLeantoFront.insulation_wall['open_roof'] = const_var.insulationArrayForLeantoFront.insulation_wall[action.key] == true ? 'included' : false
                const_var.insulationArrayForLeantoFront.insulation_wall['storage_roof'] = const_var.insulationArrayForLeantoFront.insulation_wall[action.key] == true ? 'included' : false
            }
            if((action.key == "open_roof" || action.key == "storage_roof") && params.add_storage_check_front){
                if(const_var.insulationArrayForLeantoFront.insulation_wall['open_roof'] == true && const_var.insulationArrayForLeantoFront.insulation_wall['storage_roof'] == true){
                    const_var.insulationArrayForLeantoFront.insulation_wall['full_roof'] = true
                    const_var.insulationArrayForLeantoFront.insulation_wall['open_roof'] = 'included'
                    const_var.insulationArrayForLeantoFront.insulation_wall['storage_roof'] = 'included'
                }
            }
        }
        if(action.isfor != undefined && action.isfor== 'backLean' && const_var.leanGetDataBack){
            if( const_var.insulationArrayForLeantoBack.insulation_wall == undefined){
                const_var.insulationArrayForLeantoBack['insulation_wall'] = {}
            }
            const_var.insulationArrayForLeantoBack.insulation_wall[action.key] = const_var.insulationArrayForLeantoBack.insulation_wall && const_var.insulationArrayForLeantoBack.insulation_wall[action.key] && const_var.insulationArrayForLeantoBack.insulation_wall[action.key] == true ? false : true
            
            // left wall + storage, then front wall of storage is already included
            if(action.key == "p_b_c_b_b_l" && params.add_storage_check_back){
                const_var.insulationArrayForLeantoBack.insulation_wall['storage_right'] = const_var.insulationArrayForLeantoBack.insulation_wall[action.key] == true ? 'included' : false
            }
            // if(action.key == "storage_right" && params.add_storage_check_back && params.p_b_c_b_b_l == "Close"){
            //     const_var.insulationArrayForLeantoBack.insulation_wall['p_b_c_b_b_l'] = true
            //     const_var.insulationArrayForLeantoBack.insulation_wall['storage_right'] = 'included'
            // }
            // back wall + storage, then back wall of storage is already included
            // if(action.key == "p_b_c_b_b_b" && params.add_storage_check_back){
            //     const_var.insulationArrayForLeantoBack.insulation_wall['storage_back'] = const_var.insulationArrayForLeantoBack.insulation_wall[action.key] == true ? 'included' : false
            // }
            // full roof + storage, then storage roof + open roof also included
            if(action.key == "full_roof" && params.add_storage_check_back){
                const_var.insulationArrayForLeantoBack.insulation_wall['open_roof'] = const_var.insulationArrayForLeantoBack.insulation_wall[action.key] == true ? 'included' : false
                const_var.insulationArrayForLeantoBack.insulation_wall['storage_roof'] = const_var.insulationArrayForLeantoBack.insulation_wall[action.key] == true ? 'included' : false
            }
            if((action.key == "open_roof" || action.key == "storage_roof") && params.add_storage_check_back){
                if(const_var.insulationArrayForLeantoBack.insulation_wall['open_roof'] == true && const_var.insulationArrayForLeantoBack.insulation_wall['storage_roof'] == true){
                    const_var.insulationArrayForLeantoBack.insulation_wall['full_roof'] = true
                    const_var.insulationArrayForLeantoBack.insulation_wall['open_roof'] = 'included'
                    const_var.insulationArrayForLeantoBack.insulation_wall['storage_roof'] = 'included'
                }
            }
        }
        if(action.isfor != undefined && action.isfor== "leftLean" && const_var.leanGetDataLeft){
            if( const_var.insulationArrayForLeantoLeft.insulation_wall == undefined){
                const_var.insulationArrayForLeantoLeft['insulation_wall'] = {}
            }
            const_var.insulationArrayForLeantoLeft.insulation_wall[action.key] = const_var.insulationArrayForLeantoLeft.insulation_wall && const_var.insulationArrayForLeantoLeft.insulation_wall[action.key] && const_var.insulationArrayForLeantoLeft.insulation_wall[action.key] == true ? false : true
            
            // left wall + storage, then front wall of storage is already included
            if(action.key == "p_b_c_b_l" && params.add_storage_check){
                const_var.insulationArrayForLeantoLeft.insulation_wall['storage_left'] = const_var.insulationArrayForLeantoLeft.insulation_wall[action.key] == true ? 'included' : false
            }
            // if(action.key == "storage_left" && params.add_storage_check && params.p_b_c_b_l == "Close"){
            //     const_var.insulationArrayForLeantoLeft.insulation_wall['p_b_c_b_l'] = true
            //     const_var.insulationArrayForLeantoLeft.insulation_wall['storage_left'] = 'included'
            // }
            // back wall + storage, then back wall of storage is already included
            // if(action.key == "p_b_c_b_l_b" && params.add_storage_check){
            //     const_var.insulationArrayForLeantoLeft.insulation_wall['storage_back'] = const_var.insulationArrayForLeantoLeft.insulation_wall[action.key] == true ? 'included' : false
            // }
            // full roof + storage, then storage roof + open roof also included
            if(action.key == "full_roof" && params.add_storage_check){
                const_var.insulationArrayForLeantoLeft.insulation_wall['open_roof'] = const_var.insulationArrayForLeantoLeft.insulation_wall[action.key] == true ? 'included' : false
                const_var.insulationArrayForLeantoLeft.insulation_wall['storage_roof'] = const_var.insulationArrayForLeantoLeft.insulation_wall[action.key] == true ? 'included' : false
            }
            if((action.key == "open_roof" || action.key == "storage_roof") && params.add_storage_check){
                if(const_var.insulationArrayForLeantoLeft.insulation_wall['open_roof'] == true && const_var.insulationArrayForLeantoLeft.insulation_wall['storage_roof']== true){
                    const_var.insulationArrayForLeantoLeft.insulation_wall['full_roof'] = true
                    const_var.insulationArrayForLeantoLeft.insulation_wall['open_roof'] = 'included'
                    const_var.insulationArrayForLeantoLeft.insulation_wall['storage_roof'] = 'included'
                }
            }
            
        }
        if(action.isfor != undefined && action.isfor== 'rightLean' && const_var.leanGetDataRight){
            if( const_var.insulationArrayForLeantoRight.insulation_wall == undefined){
                const_var.insulationArrayForLeantoRight['insulation_wall'] = {}
            }
            const_var.insulationArrayForLeantoRight.insulation_wall[action.key] = const_var.insulationArrayForLeantoRight.insulation_wall && const_var.insulationArrayForLeantoRight.insulation_wall[action.key] && const_var.insulationArrayForLeantoRight.insulation_wall[action.key] == true ? false : true
            
            // left wall + storage, then front wall of storage is already included
            if(action.key == "p_b_c_b_r" && params.add_storage_check_right){
                const_var.insulationArrayForLeantoRight.insulation_wall['storage_right'] = const_var.insulationArrayForLeantoRight.insulation_wall[action.key] == true ? 'included' : false
            }
            // if(action.key == "storage_right" && params.add_storage_check_right && params.p_b_c_b_r == "Close"){
            //     const_var.insulationArrayForLeantoRight.insulation_wall['p_b_c_b_r'] = true
            //     const_var.insulationArrayForLeantoRight.insulation_wall['storage_right'] = 'included'
            // }
            // back wall + storage, then back wall of storage is already included
            // if(action.key == "p_b_c_b_r_b" && params.add_storage_check_right){
            //     const_var.insulationArrayForLeantoRight.insulation_wall['storage_back'] = const_var.insulationArrayForLeantoRight.insulation_wall[action.key] == true ? 'included' : false
            // }
            // full roof + storage, then storage roof + open roof also included
            if(action.key == "full_roof" && params.add_storage_check_right){
                const_var.insulationArrayForLeantoRight.insulation_wall['open_roof'] = const_var.insulationArrayForLeantoRight.insulation_wall[action.key] == true ? 'included' : false
                const_var.insulationArrayForLeantoRight.insulation_wall['storage_roof'] = const_var.insulationArrayForLeantoRight.insulation_wall[action.key] == true ? 'included' : false
            }
            if((action.key == "open_roof" || action.key == "storage_roof") && params.add_storage_check_right){
                if(const_var.insulationArrayForLeantoRight.insulation_wall['open_roof'] == true && const_var.insulationArrayForLeantoRight.insulation_wall['storage_roof'] == true){
                    const_var.insulationArrayForLeantoRight.insulation_wall['full_roof'] = true
                    const_var.insulationArrayForLeantoRight.insulation_wall['open_roof'] = 'included'
                    const_var.insulationArrayForLeantoRight.insulation_wall['storage_roof'] = 'included'
                }
            }
        }
        state.const_var.UpdatedPriceData.insulation_price = undefined;
        state.const_var.UpdatedPriceData.insulation_price_changed = true;
        state.updateStateForlean = !state.updateStateForlean    
        return {
            ...state,
            action,
            
        }
        break;
    case "EXTRAELEMENTS":
        //extraItemsAction(state,action.action.value,action.condition)
        // console.log(action ,"action");
        let reRenderVar = "";
        if (action.condition == "jtrim") {
            state.params.p_j_t = !state.params.p_j_t;
            reRenderVar = action.condition + state.params.p_j_t;
            state.const_var.UpdatedPriceData.common_length_changed = true;
        }
        if (action.condition == "end_jtrim") {
            state.params.p_j_t_end = !state.params.p_j_t_end;
            reRenderVar = action.condition + state.params.p_j_t_end;
            state.const_var.UpdatedPriceData.common_width_changed = true;
        }
        if (action.condition == "4feetcenter") {
            state.params.fourth_center_cost = !state.params.fourth_center_cost;
            reRenderVar = action.condition + state.params.fourth_center_cost;
            if (state.params.fourth_center_cost) {
                state.const_var.DistanceArr[state.params.p_b_t][state.params.p_r_s] = 4;
                state.params.p_u_t = Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
            } else {
                state.const_var.DistanceArr[state.params.p_b_t][state.params.p_r_s] = 5;
                state.params.p_u_t = Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
            }
            params.oncenter_val_with_action = '';
            params.oncenter_val = 0;
            cuBuilding.uUdDCB();
            // cuBuilding.uUdDp();
            cuBuilding.uUdD();
            cuBuilding.leanuUdD();
            cuBuilding.BuildingUpdate(true, "");
            if (params.add_front_lean == true) cuBuilding.UpdateFrontLean();
            if (params.add_left_lean == true) cuBuilding.UpdateLeftLean();
            if (params.add_right_lean == true) cuBuilding.UpdateRightLean();
            if (params.add_back_lean == true) cuBuilding.UpdateBackLean();
        }

        if (action.condition == "riskcategory") {
            state.params.risk_cost = !state.params.risk_cost;
            reRenderVar = action.condition + state.params.risk_cost;
        }
        if (action.condition == "certificatecost") {
            state.params.cert_pac_cost = !state.params.cert_pac_cost;
            reRenderVar = action.condition + state.params.cert_pac_cost;
        }
        if (action.condition == "groundcertificate") {
            state.params.p_g_c = !state.params.p_g_c;
            reRenderVar = action.condition + state.params.p_g_c;
        }
        if (action.condition == "overhang") {
            state.params.p_o_p = !state.params.p_o_p;
            reRenderVar = action.condition + state.params.p_o_p;
            if (const_var.UpdatedPriceData.common_length_changed != state.params.p_o_p) {
                state.const_var.UpdatedPriceData.common_length_changed = true;
            }
            const_var.UpdatedPriceData.roof_color_price_changed = true
        }

        if (action.condition == "extraBracing") {
            state.params.p_b_p = !state.params.p_b_p;
            reRenderVar = action.condition + state.params.p_b_p;
        }
        if (action.condition == "insulation") {
            state.params.p_i_o =  action.value;
            if (action.value !=0 ) state.params.selectedInsulationId = action.value;
            state.const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
            state.const_var.UpdatedPriceData.insulation_price_changed = true;
            state.const_var.UpdatedPriceData.insulation_price = undefined;
            // reRenderVar = action.condition + state.params.p_i_o + state.const_var.showDefaultInsullation;
            reRenderVar = action;
        }
        if(action.condition == "noInsulation"){

            state.params.p_r_o = false; 
            state.params.p_f_i = false;
            state.params.p_c_i = false;
            state.const_var.InsulationOnWall = {}

            if(const_var.insulationPriceJson.insulation_wall != undefined){
                const_var.insulationPriceJson.insulation_wall = {}
                // const_var.insulationPriceJson.insulation_wall = const_var.insulationPriceJson.insulation_wall;
            }

            if(const_var.post_data && const_var.post_data.building && const_var.post_data.building.leanto && const_var.post_data.building.leanto.length > 0){
                utils.deleteInsulationKeysForLeanTo()
            }
            
            if(params.add_front_lean){
                if(const_var.leanGetDataFront && const_var.insulationArrayForLeantoFront.insulation_wall != undefined){ 
                    const_var.insulationArrayForLeantoFront.insulation_wall = {}
                }
                state.params.insulation.frontLean.fullBuilding = state.params.p_f_i
                state.params.insulation.frontLean.roofOnly = state.params.p_r_o
                state.params.insulation.frontLean.custom = state.params.p_c_i
            }
            if(params.add_left_lean){
                if(const_var.leanGetDataLeft && const_var.insulationArrayForLeantoLeft.insulation_wall != undefined){ 
                    const_var.insulationArrayForLeantoLeft.insulation_wall = {}
                }
                state.params.insulation.leftLean.fullBuilding = state.params.p_f_i
                state.params.insulation.leftLean.roofOnly = state.params.p_r_o
                state.params.insulation.leftLean.custom = state.params.p_c_i
            }
            if(params.add_right_lean){
                if(const_var.leanGetDataRight && const_var.insulationArrayForLeantoRight.insulation_wall != undefined){ 
                    const_var.insulationArrayForLeantoRight.insulation_wall = {}
                }
                state.params.insulation.rightLean.fullBuilding = state.params.p_f_i
                state.params.insulation.rightLean.roofOnly = state.params.p_r_o
                state.params.insulation.rightLean.custom = state.params.p_c_i
            }
            if(params.add_back_lean){
                if(const_var.leanGetDataBack && const_var.insulationArrayForLeantoBack.insulation_wall != undefined){ 
                    const_var.insulationArrayForLeantoBack.insulation_wall = {}
                }
                state.params.insulation.backLean.fullBuilding = state.params.p_f_i
                state.params.insulation.backLean.roofOnly = state.params.p_r_o
                state.params.insulation.backLean.custom = state.params.p_c_i
            }

            if(params.add_front_lean && state.params.insulation.frontLean.insulationId != 0) {
                state.params.insulation.frontLean.insulationId = 0;
                const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
                const_var.UpdatedPriceData.insulation_price_changed = true;
                cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
            }
            if(params.add_left_lean && state.params.insulation.leftLean.insulationId != 0) {
                state.params.insulation.leftLean.insulationId = 0;
                const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
                const_var.UpdatedPriceData.insulation_price_changed = true;
                cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
            }
            if(params.add_right_lean && state.params.insulation.rightLean.insulationId != 0) {
                state.params.insulation.rightLean.insulationId = 0;
                const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
                const_var.UpdatedPriceData.insulation_price_changed = true;
                cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
            }
            if(params.add_back_lean && state.params.insulation.backLean.insulationId != 0) {
                state.params.insulation.backLean.insulationId = 0;
                const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
                const_var.UpdatedPriceData.insulation_price_changed = true;
                cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
            }


            state.params.p_i_o = 0;
            state.params.selectedInsulationId =  state.params.p_i_o
            state.const_var.showDefaultInsullation = false;
            state.const_var.UpdatedPriceData.insulation_price = undefined;
            state.const_var.UpdatedPriceData.insulation_price_changed = true;
            const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;


        }
        if (action.condition == "roofOnly") {

            state.params.p_r_o = !state.params.p_r_o;
            state.params.p_f_i = false; //(state.params.p_r_o == true) ? false : state.params.p_f_i;
            state.params.p_c_i = false;
            state.const_var.InsulationOnWall = {}

            if(const_var.insulationPriceJson.insulation_wall != undefined){
                const_var.insulationPriceJson.insulation_wall = {}
                //const_var.insulationPriceJson.insulation_wall = const_var.insulationPriceJson.insulation_wall;
            }

            if(const_var.post_data && const_var.post_data.building && const_var.post_data.building.leanto && const_var.post_data.building.leanto.length > 0){
                utils.deleteInsulationKeysForLeanTo()
            }

            if(params.add_front_lean){
                if(const_var.leanGetDataFront && const_var.insulationArrayForLeantoFront.insulation_wall != undefined){ 
                    const_var.insulationArrayForLeantoFront.insulation_wall = {}
                }
                state.params.insulation.frontLean.fullBuilding = state.params.p_f_i
                state.params.insulation.frontLean.roofOnly = state.params.p_r_o
                state.params.insulation.frontLean.custom = state.params.p_c_i
            }
            if(params.add_left_lean){
                if(const_var.leanGetDataLeft && const_var.insulationArrayForLeantoLeft.insulation_wall != undefined){ 
                    const_var.insulationArrayForLeantoLeft.insulation_wall = {}
                }
                state.params.insulation.leftLean.fullBuilding = state.params.p_f_i
                state.params.insulation.leftLean.roofOnly = state.params.p_r_o
                state.params.insulation.leftLean.custom = state.params.p_c_i
            }
            if(params.add_right_lean){
                if(const_var.leanGetDataRight && const_var.insulationArrayForLeantoRight.insulation_wall != undefined){ 
                    const_var.insulationArrayForLeantoRight.insulation_wall = {}
                }
                state.params.insulation.rightLean.fullBuilding = state.params.p_f_i
                state.params.insulation.rightLean.roofOnly = state.params.p_r_o
                state.params.insulation.rightLean.custom = state.params.p_c_i
            }
            if(params.add_back_lean){
                if(const_var.leanGetDataBack && const_var.insulationArrayForLeantoBack.insulation_wall != undefined){ 
                    const_var.insulationArrayForLeantoBack.insulation_wall = {}
                }
                state.params.insulation.backLean.fullBuilding = state.params.p_f_i
                state.params.insulation.backLean.roofOnly = state.params.p_r_o
                state.params.insulation.backLean.custom = state.params.p_c_i
            }
            // reRenderVar = action.condition + state.params.p_r_o + state.params.p_f_i + state.showDefaultInsullation;
            reRenderVar = action;
            if (state.params.p_r_o == false) {
                state.params.p_i_o = 0;
                if(const_var.a_p_d_a && const_var.a_p_d_a.insulation!=undefined && const_var.a_p_d_a.insulation.length > 0){
                    state.params.insulation.frontLean.insulationId = 0
                    state.params.insulation.leftLean.insulationId = 0
                    state.params.insulation.rightLean.insulationId = 0
                    state.params.insulation.backLean.insulationId = 0
                }
                state.const_var.showDefaultInsullation = false;
            }
            if(state.params.p_i_o == 0){
                state.params.p_i_o = Object.keys(const_var.insulationJson)[0]
                
                if(const_var.a_p_d_a && const_var.a_p_d_a.insulation!=undefined && const_var.a_p_d_a.insulation.length > 0){
                    if(params.add_front_lean){
                        state.params.insulation.frontLean.insulationId = state.params.p_i_o
                    }
                    if(params.add_left_lean){
                        state.params.insulation.leftLean.insulationId = state.params.p_i_o
                    }
                    if(params.add_right_lean){
                        state.params.insulation.rightLean.insulationId = state.params.p_i_o
                    }
                    if(params.add_back_lean){
                        state.params.insulation.backLean.insulationId = state.params.p_i_o
                    }
                }
            }
            // if( params.add_front_lean && state.params.insulation.frontLean.insulationId != 0) {
            //     const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
            //     const_var.UpdatedPriceData.insulation_price_changed = true;
            //     cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront); 
            // }
            // if( params.add_left_lean && state.params.insulation.leftLean.insulationId != 0) {
            //     const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
            //     const_var.UpdatedPriceData.insulation_price_changed = true;
            //     cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft); 
            // }
            // if( params.add_right_lean && state.params.insulation.rightLean.insulationId != 0) {
            //     const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
            //     const_var.UpdatedPriceData.insulation_price_changed = true;
            //     cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight); 
            // }
            // if( params.add_back_lean && state.params.insulation.backLean.insulationId != 0) {
            //     const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
            //     const_var.UpdatedPriceData.insulation_price_changed = true;
            //     cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
            // }
            state.const_var.UpdatedPriceData.insulation_price = undefined;
            state.const_var.UpdatedPriceData.insulation_price_changed = true;
            const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
            state.params.selectedInsulationId =  state.params.p_i_o
        }
        if (action.condition == "fullBuilding") {
            state.params.p_f_i = !state.params.p_f_i;
            state.params.p_r_o = false; //(state.params.p_f_i == true) ? false : state.params.p_r_o;
            state.params.p_c_i = false;
            // reRenderVar = action.condition + state.params.p_f_i + state.params.p_r_o  +  state.showDefaultInsullation;
            state.const_var.InsulationOnWall = {}

            if(const_var.insulationPriceJson.insulation_wall != undefined){
                const_var.insulationPriceJson.insulation_wall = {}
                //const_var.insulationPriceJson.insulation_wall = const_var.insulationPriceJson.insulation_wall;
            }

            if(const_var.post_data && const_var.post_data.building && const_var.post_data.building.leanto && const_var.post_data.building.leanto.length > 0){
                utils.deleteInsulationKeysForLeanTo()
            }

            if(params.add_front_lean){
                if(const_var.leanGetDataFront && const_var.insulationArrayForLeantoFront.insulation_wall != undefined){ 
                    const_var.insulationArrayForLeantoFront.insulation_wall = {}
                }
                state.params.insulation.frontLean.fullBuilding = state.params.p_f_i
                state.params.insulation.frontLean.roofOnly = state.params.p_r_o
                state.params.insulation.frontLean.custom = state.params.p_c_i
            }
            if(params.add_left_lean){
                if(const_var.leanGetDataLeft && const_var.insulationArrayForLeantoLeft.insulation_wall != undefined){ 
                    const_var.insulationArrayForLeantoLeft.insulation_wall = {}
                }
                state.params.insulation.leftLean.fullBuilding = state.params.p_f_i
                state.params.insulation.leftLean.roofOnly = state.params.p_r_o
                state.params.insulation.leftLean.custom = state.params.p_c_i
            }
            if(params.add_right_lean){
                if(const_var.leanGetDataRight && const_var.insulationArrayForLeantoRight.insulation_wall != undefined){ 
                    const_var.insulationArrayForLeantoRight.insulation_wall = {}
                }
                state.params.insulation.rightLean.fullBuilding = state.params.p_f_i
                state.params.insulation.rightLean.roofOnly = state.params.p_r_o
                state.params.insulation.rightLean.custom = state.params.p_c_i
            }
            if(params.add_back_lean){
                if(const_var.leanGetDataBack && const_var.insulationArrayForLeantoBack.insulation_wall != undefined){ 
                    const_var.insulationArrayForLeantoBack.insulation_wall = {}
                }
                state.params.insulation.backLean.fullBuilding = state.params.p_f_i
                state.params.insulation.backLean.roofOnly = state.params.p_r_o
                state.params.insulation.backLean.custom = state.params.p_c_i
            }
            if (state.params.p_f_i == false) {
                state.params.p_i_o = 0;
                if(const_var.a_p_d_a && const_var.a_p_d_a.insulation!=undefined && const_var.a_p_d_a.insulation.length > 0){
                    state.params.insulation.frontLean.insulationId = 0
                    state.params.insulation.leftLean.insulationId = 0
                    state.params.insulation.rightLean.insulationId = 0
                    state.params.insulation.backLean.insulationId = 0
                }
                state.const_var.showDefaultInsullation = false;
            }
            if(state.params.p_i_o == 0){
                                    
                // state.params.p_i_o = const_var.a_p_d_a.insulation[0].insulation_id
                
                state.params.p_i_o = Object.keys(const_var.insulationJson)[0]
                
                if(const_var.a_p_d_a && const_var.a_p_d_a.insulation!=undefined && const_var.a_p_d_a.insulation.length > 0){
                    if(params.add_front_lean){
                        state.params.insulation.frontLean.insulationId = state.params.p_i_o
                    }
                    if(params.add_left_lean){
                        state.params.insulation.leftLean.insulationId = state.params.p_i_o
                    }
                    if(params.add_right_lean){
                        state.params.insulation.rightLean.insulationId = state.params.p_i_o
                    }
                    if(params.add_back_lean){
                        state.params.insulation.backLean.insulationId = state.params.p_i_o
                    }
                }
                // else{
                //     state.params.p_i_o = Object.keys(const_var.insulationJson)[0]
                // }
            }

            reRenderVar = action
            // if( params.add_front_lean && state.params.insulation.frontLean.insulationId != 0) {
            //     const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
            //     const_var.UpdatedPriceData.insulation_price_changed = true;
            //     cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront); 
            // }
            // if( params.add_left_lean && state.params.insulation.leftLean.insulationId != 0) {
            //     const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
            //     const_var.UpdatedPriceData.insulation_price_changed = true;
            //     cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft); 
            // }
            // if( params.add_right_lean && state.params.insulation.rightLean.insulationId != 0) {
            //     const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
            //     const_var.UpdatedPriceData.insulation_price_changed = true;
            //     cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight); 
            // }
            // if( params.add_back_lean && state.params.insulation.backLean.insulationId != 0) {
            //     const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
            //     const_var.UpdatedPriceData.insulation_price_changed = true;
            //     cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
            // }
            state.const_var.UpdatedPriceData.insulation_price = undefined;
            state.const_var.UpdatedPriceData.insulation_price_changed = true;
            const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
            state.params.selectedInsulationId =  state.params.p_i_o
        }
        if (action.condition == "custom") {

            if(state.params.p_c_i == false){
                state.params.p_i_o = 0;
                state.params.insulation.frontLean.insulationId = 0
                state.params.insulation.leftLean.insulationId = 0
                state.params.insulation.rightLean.insulationId = 0
                state.params.insulation.backLean.insulationId = 0

                state.params.insulation.frontLean.fullBuilding = false
                state.params.insulation.frontLean.roofOnly = false
                state.params.insulation.frontLean.custom = false
                

                state.params.insulation.leftLean.fullBuilding = false
                state.params.insulation.leftLean.roofOnly = false
                state.params.insulation.leftLean.custom = false

                state.params.insulation.rightLean.fullBuilding = false
                state.params.insulation.rightLean.roofOnly = false
                state.params.insulation.rightLean.custom = false

                state.params.insulation.backLean.fullBuilding = false
                state.params.insulation.backLean.roofOnly = false
                state.params.insulation.backLean.custom = false
                
                /*SE3-I4060 even if no insulation is added, then also new UI is coming up, and insulation prices are getting calculated START*/
                if(const_var.post_data?.building?.leanto != undefined && const_var.post_data?.building?.leanto?.length > 0){
                    const_var.post_data?.building?.leanto.forEach((item) => {
                            item.insulation_price = undefined
                    })
                }
                /*SE3-I4060 even if no insulation is added, then also new UI is coming up, and insulation prices are getting calculated END*/

                if(const_var.insulationPriceJson.insulation_wall != undefined){
                    const_var.insulationPriceJson.insulation_wall = {}
                    //const_var.insulationPriceJson.insulation_wall = const_var.insulationPriceJson.insulation_wall;
                }
                // {console.log('const_var.UpdatedPriceData?.insulation_type',const_var.UpdatedPriceData?.insulation_type);}
                if(const_var.UpdatedPriceData?.insulation_type?.insulation_wall){
                    const_var.UpdatedPriceData.insulation_type.insulation_wall = undefined
                }
                // console.log('const_var.UpdatedPriceData.leanto',const_var.UpdatedPriceData.leanto);
                if(const_var.UpdatedPriceData?.leanto && const_var.UpdatedPriceData.leanto.length > 0){
                    const_var.UpdatedPriceData.leanto.forEach((obj)=>{
                        if(obj && obj.insulation_type?.insulation_wall){
                            obj.insulation_type.insulation_wall={}
                        }
                    })
                // if(const_var.UpdatedPriceData?.insulation_type?.insulation_wall){
                //     const_var.UpdatedPriceData.leanto.
                }
                // console.log('const_var.UpdatedPriceData.leanto',const_var.UpdatedPriceData.leanto);
                if(const_var.insulationArrayForLeantoFront.insulation_wall != undefined){
                    const_var.insulationArrayForLeantoFront.insulation_wall = {}
                    //const_var.insulationPriceJson.insulation_wall = const_var.insulationPriceJson.insulation_wall;
                }
                if(const_var.insulationArrayForLeantoBack.insulation_wall != undefined){
                    const_var.insulationArrayForLeantoBack.insulation_wall = {}
                    //const_var.insulationPriceJson.insulation_wall = const_var.insulationPriceJson.insulation_wall;
                }
                if(const_var.insulationArrayForLeantoLeft.insulation_wall != undefined){
                    const_var.insulationArrayForLeantoLeft.insulation_wall = {}
                    //const_var.insulationPriceJson.insulation_wall = const_var.insulationPriceJson.insulation_wall;
                }
                if(const_var.insulationArrayForLeantoRight.insulation_wall != undefined){
                    const_var.insulationArrayForLeantoRight.insulation_wall = {}
                    //const_var.insulationPriceJson.insulation_wall = const_var.insulationPriceJson.insulation_wall;
                }
            }
            state.params.p_c_i = action.isInsChange == true ? state.params.p_c_i : !state.params.p_c_i;
            state.params.p_r_o = false
            state.params.p_f_i = false
            if(params.add_front_lean){
                state.params.insulation.frontLean.fullBuilding = state.params.p_f_i
                state.params.insulation.frontLean.roofOnly = state.params.p_r_o
                state.params.insulation.frontLean.custom = state.params.p_c_i
            }
            if(params.add_left_lean){
                state.params.insulation.leftLean.fullBuilding = state.params.p_f_i
                state.params.insulation.leftLean.roofOnly = state.params.p_r_o
                state.params.insulation.leftLean.custom = state.params.p_c_i
            }
            if(params.add_right_lean){
                state.params.insulation.rightLean.fullBuilding = state.params.p_f_i
                state.params.insulation.rightLean.roofOnly = state.params.p_r_o
                state.params.insulation.rightLean.custom = state.params.p_c_i
            }
            if(params.add_back_lean){
                state.params.insulation.backLean.fullBuilding = state.params.p_f_i
                state.params.insulation.backLean.roofOnly = state.params.p_r_o
                state.params.insulation.backLean.custom = state.params.p_c_i
            }
            if (state.params.p_c_i == false) {
                state.params.p_i_o = 0;
                if(const_var.a_p_d_a && const_var.a_p_d_a.insulation!=undefined && const_var.a_p_d_a.insulation.length > 0){
                    state.params.insulation.frontLean.insulationId = 0
                    state.params.insulation.leftLean.insulationId = 0
                    state.params.insulation.rightLean.insulationId = 0
                    state.params.insulation.backLean.insulationId = 0
                }
                state.const_var.showDefaultInsullation = false;
            }
            if(state.params.p_i_o == 0){
                state.params.p_i_o = Object.keys(const_var.insulationJson)[0]

                if(const_var.a_p_d_a && const_var.a_p_d_a.insulation!=undefined && const_var.a_p_d_a.insulation.length > 0 && const_var.insulationJsonLeanTo){
                    if(params.add_front_lean){
                        state.params.insulation.frontLean.insulationId = Object.keys(const_var.insulationJsonLeanTo)[0]
                    }
                    if(params.add_left_lean){
                        state.params.insulation.leftLean.insulationId = Object.keys(const_var.insulationJsonLeanTo)[0]
                    }
                    if(params.add_right_lean){
                        state.params.insulation.rightLean.insulationId = Object.keys(const_var.insulationJsonLeanTo)[0]
                    }
                    if(params.add_back_lean){
                        state.params.insulation.backLean.insulationId = Object.keys(const_var.insulationJsonLeanTo)[0]
                    }
                }
            }
            reRenderVar = action
            // if( params.add_front_lean && state.params.insulation.frontLean.insulationId != 0) {
            //     const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
            //     cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront); 
            // }
            // if( params.add_left_lean && state.params.insulation.leftLean.insulationId != 0) {
            //     const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
            //     cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft); 
            // }
            // if( params.add_right_lean && state.params.insulation.rightLean.insulationId != 0) {
            //     const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
            //     cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight); 
            // }
            // if( params.add_back_lean && state.params.insulation.backLean.insulationId != 0) {
            //     const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
            //     cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
            // }
            state.const_var.UpdatedPriceData.insulation_price = undefined;
            state.const_var.UpdatedPriceData.insulation_price_changed = true;
            const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
            state.params.selectedInsulationId =  state.params.p_i_o;
        }
        // console.log(state.params.p_i_o,"p_i_o", state.params.p_r_o, "p_r_o", state.params.p_f_i,"p_f_i" );
        if (action.condition == "trussUpgrade") {
            state.params.p_t_u = action.value;
            reRenderVar = action.condition + state.params.p_t_u;
        }
        if (action.condition == "additionalFeatures" && action.nextVal != '') {
            if (state.const_var.additionalFeaturesArray[action.index] !=undefined && state.const_var.additionalFeaturesArray[action.index].is_checked != undefined) {
                state.const_var.additionalFeaturesArray[action.index].is_checked = !state.const_var.additionalFeaturesArray[action.index].is_checked;
                state.const_var.additionalFeaturesArray[action.index].cost = action.nextVal.cost;
            } else {
                state.const_var.additionalFeaturesArray[action.index] = action.nextVal;
                state.const_var.additionalFeaturesArray[action.index].is_checked = true
            }
            // state.const_var.additionalFeaturesArray[action.index] = action.nextVal;
            // state.const_var.additionalFeaturesArray[action.index].is_checked = !state.const_var.additionalFeaturesArray[action.index].is_checked;
            reRenderVar = action.condition + action.index + action.value + state.const_var.additionalFeaturesArray[action.index].is_checked;
            if(state.const_var.additionalFeaturesArray[action.index].is_checked==true)
            {
                const_var.additionalFeaturesArrayWithPosition.map((data,index1)=>{

                    if(data!= null && data.id==state.const_var.additionalFeaturesArray[action.index].id)
                    {
                        const_var.additionalFeaturesArrayWithPosition.splice(index1,1);
                    }
                })
            }
            if(state.const_var.additionalFeaturesArray[action.index].is_checked!=false && (const_var.additionalFeaturesArrayWithPosition.length==0 || const_var.additionalFeaturesArrayWithPosition.filter(data=> (data!= null && data.additional_feature) !=state.const_var.additionalFeaturesArray[action.index].additional_feature).length>0))
            {
                const_var.additionalFeaturesArrayWithPosition.push(action.nextVal);
            }
            if(state.const_var.additionalFeaturesArray[action.index].is_checked==false)
            {
                // let findIndexVal = const_var.additionalFeaturesArrayWithPosition.findIndex(data=>data.id==state.const_var.additionalFeaturesArray[action.index].id);
                const_var.additionalFeaturesArrayWithPosition.map((data,index1)=>{
                    if((data != null && data.id) == state.const_var.additionalFeaturesArray[action.index].id)
                    {
                        const_var.additionalFeaturesArrayWithPosition.splice(index1,1);
                    }
                })
            }
            const_var.UpdatedPriceData['elements'][state.const_var.additionalFeaturesArray[action.index].additional_feature.toString()] = undefined;

        }
        if (action.condition == "extraitemsCheckbox" && action.nextVal != '') {
            let exactNum = 0;
            if (state.const_var.ExtraItemsFeaturesArray[action.index] !=undefined && action.nextVal.name == "fourth_center_cost" && params.fourth_center_cost == true) {
                state.const_var.ExtraItemsFeaturesArray[action.index].is_checked = params.fourth_center_cost;
            }
            if (state.const_var.ExtraItemsFeaturesArray[action.index] !=undefined && state.const_var.ExtraItemsFeaturesArray[action.index].is_checked != undefined && (action.isSelect == undefined || action.isSelect == false)) {
                state.const_var.ExtraItemsFeaturesArray[action.index].is_checked = !state.const_var.ExtraItemsFeaturesArray[action.index].is_checked;
                state.const_var.ExtraItemsFeaturesArray[action.index].cost = action.nextVal.cost;
            } else {
                state.const_var.ExtraItemsFeaturesArray[action.index] = JSON.parse(JSON.stringify(action.nextVal));
                state.const_var.ExtraItemsFeaturesArray[action.index].is_checked = true
            }
            // state.const_var.ExtraItemsFeaturesArray[action.index] = action.nextVal;
            // state.const_var.ExtraItemsFeaturesArray[action.index].is_checked = !state.const_var.ExtraItemsFeaturesArray[action.index].is_checked;

            state.const_var.ExtraItemsFeaturesArray[action.index].is_edit = false;
            state.const_var.ExtraItemsFeaturesArray[action.index].quantity = (state.const_var.ExtraItemsFeaturesArray[action.index].is_checked == true) ? 1 : 0;
            if (state.const_var.ExtraItemsFeaturesArray[action.index].is_checked) {
                state.const_var.extraItemsFeaturesCost[action.index] = action.nextVal.cost;
            }
            if (!state.const_var.ExtraItemsFeaturesArray[action.index].is_checked) {
                state.const_var.ExtraItemsFeaturesArray[action.index].cost = (state.const_var.extraItemsFeaturesCost[action.index]==undefined)?state.const_var.ExtraItemsFeaturesArray[action.index].cost:state.const_var.extraItemsFeaturesCost[action.index];
            }
            if (state.const_var.ExtraItemsFeaturesArray[action.index].cost == undefined) {
                state.const_var.ExtraItemsFeaturesArray[action.index].cost = 0;
            }
            
            
            if(action.indexName == 'overhang'){
                const_var.UpdatedPriceData.roof_color_price_changed = true
                if(action.nextVal.sheet_type == 'both'){
                    state.const_var.isOverhang['end']['size'] = const_var.ExtraItemsFeaturesArray[action.index].is_checked == true ? 1 : 0.5
                    state.const_var.isOverhang['side']['size'] = const_var.ExtraItemsFeaturesArray[action.index].is_checked == true ? 1 : 0.5
                    state.const_var.isOverhang['both']['size'] = const_var.ExtraItemsFeaturesArray[action.index].is_checked == true ? 1 : 0.5
                    state.const_var.isOverhang['both']['selected'] = const_var.ExtraItemsFeaturesArray[action.index].is_checked;
                    state.params.o_v_h_n_g = state.const_var.ExtraItemsFeaturesArray[action.index].is_checked;
                    state.params.o_v_h_n_g_e = state.const_var.ExtraItemsFeaturesArray[action.index].is_checked;
                }
                else{
                    state.const_var.isOverhang[action.nextVal.sheet_type]['selected'] = const_var.a_p_d_a.overhang[action.nextVal.sheet_type][0].sheet_name
                    state.const_var.isOverhang[action.nextVal.sheet_type]['isChecked'] = const_var.ExtraItemsFeaturesArray[action.index].is_checked
                    let size = calcOverhangSize(state.const_var.isOverhang[action.nextVal.sheet_type]['selected'])
                    // let size = state.const_var.isOverhang[action.nextVal.sheet_type]['selected'].split(`'`)
                    state.const_var.isOverhang[action.nextVal.sheet_type]['size'] = const_var.ExtraItemsFeaturesArray[action.index].is_checked == true ? size[0] : 0.5;

                    if(action.nextVal.sheet_type == 'side'){
                        state.params.o_v_h_n_g = state.const_var.ExtraItemsFeaturesArray[action.index].is_checked;
                    }
                    else{
                        state.params.o_v_h_n_g_e = state.const_var.ExtraItemsFeaturesArray[action.index].is_checked;
                    }
                }
                cuBuilding.BuildingUpdate(true, "");
                if (params.add_front_lean == true) cuBuilding.UpdateFrontLean(params.add_front_lean);
                if (params.add_left_lean == true) cuBuilding.UpdateLeftLean(params.add_left_lean);
                if (params.add_right_lean == true) cuBuilding.UpdateRightLean(params.add_right_lean);
                if (params.add_back_lean == true) cuBuilding.UpdateBackLean(params.add_back_lean); 
            }

            if (action.nextVal.name == "overhang") {
                const_var.UpdatedPriceData.roof_color_price_changed = true
                if (action.nextVal.label == "1' Overhang on Sides") {
                    state.params.o_v_h_n_g = state.const_var.ExtraItemsFeaturesArray[action.index].is_checked;
                    state.const_var.isOverhang['side']['size'] = const_var.ExtraItemsFeaturesArray[action.index].is_checked == true ? 1 : 0.5
                }
                if (action.nextVal.label == "1' Overhang on Ends") {
                    state.params.o_v_h_n_g_e = state.const_var.ExtraItemsFeaturesArray[action.index].is_checked;
                    state.const_var.isOverhang['end']['size'] = const_var.ExtraItemsFeaturesArray[action.index].is_checked == true ? 1 : 0.5
                }
                //state.params.o_v_h_n_g = state.const_var.ExtraItemsFeaturesArray[action.index].is_checked;
                cuBuilding.BuildingUpdate(true, "");
                if (params.add_front_lean == true) cuBuilding.UpdateFrontLean(params.add_front_lean);
                if (params.add_left_lean == true) cuBuilding.UpdateLeftLean(params.add_left_lean);
                if (params.add_right_lean == true) cuBuilding.UpdateRightLean(params.add_right_lean);
                if (params.add_back_lean == true) cuBuilding.UpdateBackLean(params.add_back_lean);

            }
            if (action.nextVal.name == "fourth_center_cost") {
                state.feetVal = state.feetVal+1;
                state.params.fourth_center_cost = state.const_var.ExtraItemsFeaturesArray[action.index].is_checked;
                
                if (state.params.fourth_center_cost) {
                    state.const_var.DistanceArr[state.params.p_b_t][state.params.p_r_s] = 4;
                    if (!params.isBreezeway){
                        state.params.p_u_t = Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s]
                    } else {
                        makeDimensionArray(state);
                        updateBreezewayFrameAndStorages({option:"buildingLength"}, undefined,  Number(params.p_h), Number(params.p_d));
                    }
                } else {
                    state.const_var.DistanceArr[state.params.p_b_t][state.params.p_r_s] = 5;
                    if (!params.isBreezeway){
                        state.params.p_u_t = Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s]
                    } else {
                        makeDimensionArray(state);
                        updateBreezewayFrameAndStorages({option:"buildingLength"}, undefined,  Number(params.p_h), Number(params.p_d));
                    }
                }
                let eqiDis = 0;
                if(state.params.fourth_center_cost==true)
                {
                    if(const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined)
                    {
                        eqiDis = (params.oncenter_val_with_action!='')?((params.p_d)/parseInt(params.oncenter_val_with_action)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
                        eqiDis = parseFloat(eqiDis) +1;
                    }
                }
                if(params.fourth_center_cost==false)
                {
                    // state.const_var.ExtraItemsFeaturesArray[action.index].cost = 0;
                    state.const_var.ExtraItemsFeaturesArray[action.index].cost = action.nextVal.cost;
                }
                // console.log(state.const_var.ExtraItemsFeaturesArray[action.index].cost , "cost",state.params.fourth_center_cost);
                if(state.const_var.ExtraItemsFeaturesArray[action.index].cost==0 && state.params.fourth_center_cost)
                {
                    let checkCost = '';
                    if(const_var.a_p_d_a.extra_items!=undefined && const_var.a_p_d_a.extra_items[0].checkbox_quantity!=undefined)
                    {
                        let dataNew = JSON.parse(JSON.stringify(const_var.a_p_d_a.extra_items[0].checkbox_quantity));
                        // console.log(const_var.a_p_d_a,"dataNew",dataNew ,);
                        dataNew.map((val, index)=> {
                        if(val.name=="bows")
                        {
                            if(val.cost!=0 || val.double_leg!=0 || val.ladder_leg!=0)
                            {
                                // console.log(const_var.count_numberofLegs, "const_var.count_numberofLegs",eqiDis);
                                exactNum = Math.abs(const_var.count_numberofLegs - eqiDis);
                                let price = (params.p_e_l && const_var.legstype.includes("double") && val.double_leg != 0)?parseFloat(val.double_leg):(params.p_e_l && const_var.legstype.includes("ladder") && val.ladder_leg != 0 )?parseFloat(val.ladder_leg):parseFloat(val.cost);
                                // console.log(price ,"price", exactNum, "exactNum", const_var.ExtraItemsFeaturesArray[action.index].cost);
                                const_var.ExtraItemsFeaturesArray[action.index].cost = const_var.ExtraItemsFeaturesArray[action.index].cost==0?parseFloat(price * exactNum):const_var.ExtraItemsFeaturesArray[action.index].cost;
                                    // console.log( const_var.ExtraItemsFeaturesArray[action.index].cost ,"final caost");
                                        if(val.name == "bows")
                                        {
                                            // console.log(val ,"val");

                                            if(params.fourth_center_cost==true)
                                            {
                                                const_var.ExtraItemsFeaturesQuantityArray[index] = val;
                                                const_var.ExtraItemsFeaturesQuantityArray[index].quantity = 1;
                                                const_var.ExtraItemsFeaturesQuantityArray[index].is_checked = (params.fourth_center_cost==true)?true:false;
                                                const_var.ExtraItemsFeaturesQuantityArray[index].cost = 0;
                                                const_var.ExtraItemsFeaturesQuantityArray[index].double_leg = 0;
                                                const_var.ExtraItemsFeaturesQuantityArray[index].ladder_leg = 0;
                                                const_var.ExtraItemsFeaturesQuantityArray[index].is_edit = false;
                                                const_var.ExtraItemsFeaturesQuantityArray[index].is_disabled = true;
                                                if (const_var.UpdatedPriceData['elements']!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()]!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit!= undefined){
                                                    const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit = false;
                                                    const_var.UpdatedPriceData['elements'][val.label.toString()].item_price = 0;
                                                }
                                            }else{
                                                const_var.ExtraItemsFeaturesQuantityArray[index].cost = val.cost;
                                                const_var.ExtraItemsFeaturesQuantityArray[index] = val;
                                                const_var.ExtraItemsFeaturesQuantityArray[index].is_checked = false;
                                                const_var.ExtraItemsFeaturesQuantityArray[index].quantity = 1;
                                                const_var.ExtraItemsFeaturesQuantityArray[index].is_edit = false;
                                                const_var.ExtraItemsFeaturesQuantityArray[index].is_disabled = true;
                                                if (const_var.UpdatedPriceData['elements']!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()]!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit!= undefined){
                                                    const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit = false;
                                                    const_var.UpdatedPriceData['elements'][val.label.toString()].item_price = val.cost;
                                                }
                                            }
                                        }
                                    
                            }
                        }
                    })
                    }
                }else{
                    if(const_var.ExtraItemsFeaturesQuantityArray.length>0)
                    {
                        let FilterIndex = const_var.ExtraItemsFeaturesQuantityArray.findIndex(data=> data && data.name=="bows" && data.is_disabled!=undefined);
                            if (FilterIndex >= 0){
                            const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].is_checked = false;
                            const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].quantity = 1;
                            const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].is_edit = false;
                            const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].is_disabled = false;
                                //const_var.ExtraItemsFeaturesQuantityArray.splice(FilterIndex,1);
                        }
                    }
                }

                cuBuilding.uUdDCB();
                // cuBuilding.uUdDp();
                cuBuilding.uUdD();
                cuBuilding.leanuUdD();
                cuBuilding.BuildingUpdate(true, "")   
                if (params.add_front_lean) calculateLegsCount(const_var.leanGetDataFront,'frontLean');
                if (params.add_left_lean) calculateLegsCount(const_var.leanGetDataLeft,'leftLean');
                if (params.add_right_lean) calculateLegsCount(const_var.leanGetDataRight,'rightLean');
                if (params.add_back_lean) calculateLegsCount(const_var.leanGetDataBack,'backLean'); 
                if (params.add_front_lean) cuBuilding.UpdateFrontLean();
                if (params.add_left_lean) cuBuilding.UpdateLeftLean();
                if (params.add_right_lean) cuBuilding.UpdateRightLean();
                if (params.add_back_lean) cuBuilding.UpdateBackLean(); 
                }
            reRenderVar = state.feetVal + params.p_e_i + exactNum + action.condition + action.index + action.value + state.const_var.ExtraItemsFeaturesArray[action.index].quantity + state.const_var.ExtraItemsFeaturesArray[action.index].is_checked+state.const_var.ExtraItemsFeaturesArray[action.index].cost+params.fourth_center_cost;
        } if (action.condition == "extraitemsCheckboxwithQuantity" && action.nextVal != '') {
            // console.log(action ,"extraitemsCheckboxwithQuantity");
            if (state.const_var.ExtraItemsFeaturesQuantityArray[action.index] !=undefined && state.const_var.ExtraItemsFeaturesQuantityArray[action.index].is_checked != undefined) {
                state.const_var.ExtraItemsFeaturesQuantityArray[action.index].is_checked = !state.const_var.ExtraItemsFeaturesQuantityArray[action.index].is_checked;
                state.const_var.ExtraItemsFeaturesQuantityArray[action.index].cost = action.nextVal.cost;
                if (state.const_var.ExtraItemsFeaturesQuantityArray[action.index].name == "bows") {
                    state.const_var.ExtraItemsFeaturesQuantityArray[action.index].double_leg = action.nextVal.double_leg;
                    state.const_var.ExtraItemsFeaturesQuantityArray[action.index].ladder_leg = action.nextVal.ladder_leg;
                }

            } else {
                state.const_var.ExtraItemsFeaturesQuantityArray[action.index] = JSON.parse(JSON.stringify(action.nextVal));
                state.const_var.ExtraItemsFeaturesQuantityArray[action.index].is_checked = true
            }
            // state.const_var.ExtraItemsFeaturesQuantityArray[action.index] = JSON.parse(JSON.stringify(action.nextVal));
            // state.const_var.ExtraItemsFeaturesQuantityArray[action.index].is_checked = !state.const_var.ExtraItemsFeaturesQuantityArray[action.index].is_checked;
            state.const_var.ExtraItemsFeaturesQuantityArray[action.index].quantity = (state.const_var.ExtraItemsFeaturesQuantityArray[action.index].is_checked == true) ? 1 : 0;
            state.const_var.ExtraItemsFeaturesQuantityArray[action.index].is_edit = false;
            reRenderVar = action.condition + action.index + action.value + state.const_var.ExtraItemsFeaturesQuantityArray[action.index].quantity + state.const_var.ExtraItemsFeaturesQuantityArray[action.index].is_checked;

            if (state.const_var.ExtraItemsFeaturesQuantityArray[action.index].is_checked) {
                state.const_var.extraItemsFeaturesQuantityCost[action.index] = action.nextVal.cost;

            }
            if (!state.const_var.ExtraItemsFeaturesQuantityArray[action.index].is_checked) {
                //state.const_var.ExtraItemsFeaturesQuantityArray[action.index].cost = action.nextVal.cost;
                state.const_var.ExtraItemsFeaturesQuantityArray[action.index].cost = (state.const_var.extraItemsFeaturesQuantityCost[action.index]==undefined)?state.const_var.ExtraItemsFeaturesQuantityArray[action.index].cost:state.const_var.extraItemsFeaturesQuantityCost[action.index]
            }
            const_var.UpdatedPriceData['elements'][state.const_var.ExtraItemsFeaturesQuantityArray[action.index].label.toString()] = undefined;
        }
        if (action.condition == "extraitemsCheckboxwithDropdownQuantity" && action.nextVal != '') {

            state.const_var.ExtraItemsFeaturesDropdownQuantityArray[action.index] = action.nextVal;
            state.const_var.ExtraItemsFeaturesDropdownQuantityArray[action.index].is_checked = !state.const_var.ExtraItemsFeaturesDropdownQuantityArray[action.index].is_checked;
            state.const_var.ExtraItemsFeaturesDropdownQuantityArray[action.index].quantity = (state.const_var.ExtraItemsFeaturesDropdownQuantityArray[action.index].is_checked == true) ? 1 : 0;
            state.const_var.ExtraItemsFeaturesDropdownQuantityArray[action.index].is_edit = false;
            reRenderVar = action.condition + action.index + action.value + state.const_var.ExtraItemsFeaturesDropdownQuantityArray[action.index].quantity + state.const_var.ExtraItemsFeaturesDropdownQuantityArray[action.index].is_checked;

            // if(state.const_var.ExtraItemsFeaturesDropdownQuantityArray[action.index].is_checked){
            //     state.const_var.extraItemsFeaturesQuantityCost[action.index]=action.nextVal.cost;

            // }
            if (!state.const_var.ExtraItemsFeaturesDropdownQuantityArray[action.index].is_checked) {
                state.const_var.ExtraItemsFeaturesDropdownQuantityArray[action.index].cost = state.const_var.extraItemsFeaturesQuantityCost[action.index];
            }
        }
        if (action.condition == "extraitemsCheckboxValue" && action.nextVal != '') {
            let rightLeanTOCost = 0;
            let leftLeanTOCost = 0;
            let backLeanTOCost = 0;
            let forntLeanTOCost = 0;
            if (params.add_left_lean) {

                leftLeanTOCost = const_var.leanGetDataLeft.extra_items[0].checkbox_quantity[action.index] !== undefined && (parseInt(action.value) * const_var.leanGetDataLeft.extra_items[0].checkbox_quantity[action.index].cost);
            }
            if (params.add_right_lean) {

                rightLeanTOCost = const_var.leanGetDataRight.extra_items[0].checkbox_quantity[action.index] !== undefined && (parseInt(action.value) * const_var.leanGetDataRight.extra_items[0].checkbox_quantity[action.index].cost);
            }
            if (params.add_back_lean) {

                backLeanTOCost = const_var.leanGetDataBack.extra_items[0].checkbox_quantity[action.index] !== undefined && (parseInt(action.value) * const_var.leanGetDataBack.extra_items[0].checkbox_quantity[action.index].cost);
            }
            if (params.add_front_lean) {

                forntLeanTOCost = const_var.leanGetDataFront.extra_items[0].checkbox_quantity[action.index] !== undefined && (parseInt(action.value) * const_var.leanGetDataFront.extra_items[0].checkbox_quantity[action.index].cost);
            }
            state.const_var.ExtraItemsFeaturesQuantityArray[action.index].quantity = (action.value != '') ? parseInt(action.value) : 0;
            const_var.UpdatedPriceData['elements'][action.nextVal.label].item_price = (action.value != '') ? ((parseFloat(action.value) * action.nextVal.cost) + rightLeanTOCost + leftLeanTOCost + forntLeanTOCost + backLeanTOCost) : 0;
            reRenderVar = action.condition + action.value + state.const_var.ExtraItemsFeaturesQuantityArray[action.index].quantity;
        }


        if (action.condition == "extraTruss") {
            state.params.p_e_t = action.value;
            reRenderVar = action.condition + state.params.p_e_t;
        }
        if (action.condition == "peakbraces") {
            state.params.p_p_b = action.value;
            reRenderVar = action.condition + state.params.p_p_b;
        }
        if (action.condition == "extraBows") {
            state.params.p_e_b = action.value;
            reRenderVar = action.condition + state.params.p_e_b;
            const_var.UpdatedPriceData.common_width_changed = true;
            const_var.UpdatedPriceData.common_height_changed = true;
        }
        if (action.condition == "concreteAnchors") {
            state.params.p_a_ch = action.value;
            reRenderVar = action.condition + state.params.p_a_ch;
        }
        if (action.condition == "mobileAnchors") {
            state.params.p_m_h_a = action.value;
            reRenderVar = action.condition + state.params.p_m_h_a;
        }
        if (action.condition == "asphaltAnchors") {
            state.params.p_r_a = action.value;
            reRenderVar = action.condition + state.params.p_r_a;
        }
        if (action.condition == "scbracing") {

            state.params.p_s_c_b = !state.params.p_s_c_b;
            reRenderVar = action;
            state.const_var.UpdatedPriceData.common_length_changed = true;
            cuBuilding.BuildingUpdate(true);
        }
        if (action.condition == "ecbracing") {
            state.params.p_e_c_b = !state.params.p_e_c_b;
            reRenderVar = action;
            //cuBuilding.rP();
            state.const_var.UpdatedPriceData.common_width_changed = true;
            cuBuilding.BuildingUpdate(true);
        }
        if (const_var.c_f_a_per[params.p_e_i] != 0 && params.p_e_i !='other') {
            const_var.UpdatedPriceData.certificate_price_changed = true;
        }
        const_var.UpdatedPriceData.surcharge_amount = undefined;
        const_var.UpdatedPriceData.insulation_price_changed = true;
        cuBuilding.cP();
        const_var.UpdatedPriceData.insulation_price_changed = true;
        return {
            ...state,
            newColor: reRenderVar
        }
        break;
    case "EXTRAINFORMATION":
        let reRenderInfo = "";
        if (action.condition == "jobsite") {
            // if(action.value.target.value == 'no'){
            //     state.params.job_site_level = "yes";
            // }else{
            //     state.params.job_site_level = "no";
            // }
            state.params.job_site_level = action.value;
            reRenderInfo = action.condition + state.params.p_j_l + state.params.job_site_level;
        }
        if (action.condition == "notes") {
            state.params.additional_note = action.value;
            reRenderInfo = action.condition + state.params.additional_note;
        }
        if (action.condition == "power") {
            state.params.power_avail = action.value;
            // if(action.value.target.value == 'no'){
            //     state.params.power_avail = "yes";
            // }else{
            //     state.params.power_avail = "no";
            // }
            reRenderInfo = action.condition + state.params.p_p_a + state.params.power_avail;
        }
        return {
            ...state,
            newColor: reRenderInfo
        }
        break;
        case "handleOverhang":
            state.const_var.isOverhang[action.isfor]['isChecked']= !state.const_var.isOverhang[action.isfor]['isChecked']
            if(action.isfor == 'side'){
                state.params.o_v_h_n_g = state.const_var.isOverhang[action.isfor]['isChecked']
            }
            if(action.isfor == 'end'){
                state.params.o_v_h_n_g_e = state.const_var.isOverhang[action.isfor]['isChecked']
            }
            if(action.isfor == 'both'){
                state.params.o_v_h_n_g = state.const_var.isOverhang[action.isfor]['isChecked']
                state.params.o_v_h_n_g_e = state.const_var.isOverhang[action.isfor]['isChecked']

                state.const_var.isOverhang['both']['size'] = 1
                state.const_var.isOverhang['side']['size'] = 1
                state.const_var.isOverhang['end']['size'] = 1

                state.const_var.isOverhang['both']['selected'] = ''
                state.const_var.isOverhang['side']['selected'] = ''
                state.const_var.isOverhang['end']['selected'] = ''
            }
            if(action.isfor != 'both'){
                state.const_var.isOverhang[action.isfor]['selected'] = const_var.a_p_d_a.overhang[action.isfor][0].sheet_name
                // let size = state.const_var.isOverhang[action.isfor]['selected'].split(`'`)
                // state.const_var.isOverhang[action.isfor]['size'] = size[0]

                let size = calcOverhangSize(state.const_var.isOverhang[action.isfor]['selected'])
                state.const_var.isOverhang[action.isfor]['size'] = size

                if( state.const_var.isOverhang[action.isfor]['isChecked'] == true){
                    let objIndex = -1;
                    state.const_var.ExtraItemsFeaturesArray.length > 0 && state.const_var.ExtraItemsFeaturesArray.some((key, value) => { 
                        if (key!=null && key.sheet_type != undefined && key.sheet_type == action.isfor) { 
                            objIndex = value; 
                            return true; 
                        } 
                    }); 
                    if(objIndex != -1){
                        let tempArray = [...state.const_var.ExtraItemsFeaturesArray]
                        tempArray[objIndex] = {}
                        state.const_var.ExtraItemsFeaturesArray = tempArray
                    }
                }
            }
            const_var.UpdatedPriceData.roof_color_price_changed = true;


            return {
                ...state,
                action
            }
            break;
            case "handleOverhangSel":
                state.const_var.isOverhang[action.isfor]['selected'] = action.value;
                // let size = state.const_var.isOverhang[action.isfor]['selected'].split(`'`)
                // state.const_var.isOverhang[action.isfor]['size'] = size[0]

                let size = calcOverhangSize(state.const_var.isOverhang[action.isfor]['selected'])
                state.const_var.isOverhang[action.isfor]['size'] = size

                const_var.UpdatedPriceData.roof_color_price_changed = true;
            return {
                ...state,
                action
            }
            break;
    case "INDUVIDUALLEANTOWALLCHANGE":
        let updatewallAction = '';
        var chkEndJtrim = false;
        var chkSideJtrim = false;
        if((const_var.a_p_d_a.jtrim) && const_var.a_p_d_a.jtrim.length>0)
        {
            chkEndJtrim = (const_var.a_p_d_a.jtrim.filter(data=>data.type=="end")).length>0?true:false;
            chkSideJtrim = (const_var.a_p_d_a.jtrim.filter(data=>data.type=="side")).length>0?true:false;
        }
        if (action.wall === "front_leanto_front") {
            state.params.p_b_c_b_f_f = action.value;
            updatewallAction = action.value + action.wall;
            if(params.p_b_c_b_f_f!="Open" && params.p_b_c_b_f_f!="Close" && params.p_b_c_b_f_f!="Half Dutch End" && params.p_b_c_b_f_f!="Half End" && chkEndJtrim==true)
            {
                params.p_j_t_end = true;
            }
            const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;
            //state.params.p_b_c_b_l_b = action.value;
            cuBuilding.UpdateFrontLean("walls");
        }
        else if (action.wall === "front_leanto_back") {
            state.params.p_b_c_b_f_b = action.value;
            state.params.b_f_l_t_l = action.value;
            updatewallAction = action.value + action.wall;
            if(params.p_b_c_b_f_b!="Open" && params.p_b_c_b_f_b!="Close" && params.p_b_c_b_f_b!="Half Dutch End" && params.p_b_c_b_f_b!="Half End" && chkEndJtrim==true)
            {
                params.p_j_t_end = true;
            }
            const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
            //state.params.p_b_c_b_l_f = action.value; 
            cuBuilding.UpdateFrontLean("walls");
        }
        else if (action.wall === "front_leanto_left") {
            state.params.p_b_c_b_f_l = action.value;
            state.params.b_f_l_t_l = action.value;
            updatewallAction = action.value + action.wall;
            if(params.p_b_c_b_f_l!="Open" && params.p_b_c_b_f_l!="Close" && params.p_b_c_b_f_l!="Half Dutch End" && params.p_b_c_b_f_l!="Half End" && chkSideJtrim==true)
            {
                params.p_j_t = true;
            }
            const_var.UpdatedPriceData.front_lean_left_wall_price_changed = true;
            cuBuilding.UpdateFrontLean("walls");
        }
        else if (action.wall === "back_leanto_back") {
            state.params.p_b_c_b_b_b = action.value;
            state.params.b_b_l_t_f = action.value;
            if(params.p_b_c_b_b_b!="Open" && params.p_b_c_b_b_b!="Close" && params.p_b_c_b_b_b!="Half Dutch End" && params.p_b_c_b_b_b!="Half End" && chkEndJtrim==true)
            {
                params.p_j_t_end = true;
            }
            updatewallAction = action.value + action.wall;
            if(params.p_b_c_b_b_b!="Open" && params.p_b_c_b_b_b!="Close" && chkEndJtrim==true)
            {
                params.p_j_t_end = true;
            }
            const_var.UpdatedPriceData.back_lean_back_wall_price_changed = true;
            //state.params.p_b_c_b_l_b = action.value;
            cuBuilding.UpdateBackLean("walls");

        }
        else if (action.wall === "back_leanto_left") {
            state.params.p_b_c_b_b_l = action.value;
            state.params.b_b_l_t_l = action.value;
            updatewallAction = action.value + action.wall;
            if(params.p_b_c_b_b_l!="Open" && params.p_b_c_b_b_l!="Close" && params.p_b_c_b_b_l!="Half Dutch End" && params.p_b_c_b_b_l!="Half End" && chkSideJtrim==true)
            {
                params.p_j_t = true;
            }
            const_var.UpdatedPriceData.back_lean_left_wall_price_changed = true;
            cuBuilding.UpdateBackLean("walls");
        }
        else if (action.wall === "back_leanto_front") {
            state.params.p_b_c_b_b_f = action.value;
            state.params.b_b_l_t_l = action.value;
            updatewallAction = action.value + action.wall;
            if(params.p_b_c_b_b_f!="Open" && params.p_b_c_b_b_f!="Close" && params.p_b_c_b_b_f!="Half Dutch End" && params.p_b_c_b_b_f!="Half End" && chkEndJtrim==true)
            {
                params.p_j_t_end = true;
            }
            const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;
            cuBuilding.UpdateBackLean("walls");

        }
        else if (action.wall === "left_leanto_front") {
            state.params.p_b_c_b_l_f = action.value;
            state.params.b_l_l_t_f = action.value;
            updatewallAction = action.value + action.wall;
            //cuComponent.autoRotateBuilding(state,"Front");
            if(params.p_b_c_b_l_f!="Open" && params.p_b_c_b_l_f!="Close" && params.p_b_c_b_l_f!="Half Dutch End" && params.p_b_c_b_l_f!="Half End" && chkEndJtrim==true)
            {
                params.p_j_t_end = true;
            }
            const_var.UpdatedPriceData.left_lean_front_wall_price_changed = true;
            const_var.UpdatedPriceData.common_width_changed = true;
            //state.params.p_b_c_b_l_b = action.value;
            cuBuilding.UpdateLeftLean("walls");
        }
        else if (action.wall === "left_leanto_back") {
            state.params.p_b_c_b_l_b = action.value;
            state.params.b_l_l_t_b = action.value;
            updatewallAction = action.value + action.wall;
            if(params.p_b_c_b_l_b!="Open" && params.p_b_c_b_l_b!="Close" && chkEndJtrim==true)
            {
                params.p_j_t_end = true;
            }
            //cuComponent.autoRotateBuilding(state,"Back");
            if(params.p_b_c_b_l_b!="Open" && params.p_b_c_b_l_b!="Close" && params.p_b_c_b_l_b!="Half Dutch End" && params.p_b_c_b_l_b!="Half End" && chkEndJtrim==true)
            {
                params.p_j_t_end = true;
            }
            const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
            const_var.UpdatedPriceData.common_width_changed = true;
            //state.params.p_b_c_b_l_f = action.value;
            cuBuilding.UpdateLeftLean("walls"); 
        }
        else if (action.wall === "left_leanto_left") {
            state.params.p_b_c_b_l = action.value;
            state.params.b_l_l_t_l = action.value;
            updatewallAction = action.value + action.wall;
            if(params.p_b_c_b_l!="Open" && params.p_b_c_b_l!="Close" && params.p_b_c_b_l!="Half Dutch End" && params.p_b_c_b_l!="Half End" && chkSideJtrim==true)
            {
                params.p_j_t = true;
            }
            //cuComponent.autoRotateBuilding(state,"Left");
            if(params.p_b_c_b_l!="Open" && params.p_b_c_b_l!="Close" && chkSideJtrim==true)
            {
                params.p_j_t = true;
            }
            const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
            const_var.UpdatedPriceData.common_length_changed = true;
            cuBuilding.UpdateLeftLean("walls"); 
        }
        else if (action.wall === "right_leanto_front") {
            state.params.p_b_c_b_r_f = action.value;
            state.params.b_r_l_t_f = action.value;
            updatewallAction = action.value + action.wall;
            if(params.p_b_c_b_r_f!="Open" && params.p_b_c_b_r_f!="Close" && params.p_b_c_b_r_f!="Half Dutch End" && params.p_b_c_b_r_f!="Half End" && chkEndJtrim==true)
            {
                params.p_j_t_end = true;
            }
            const_var.UpdatedPriceData.right_lean_front_wall_price_changed = true;
            const_var.UpdatedPriceData.common_width_changed = true;
            //state.params.p_b_c_b_r_b = action.value;
            cuBuilding.UpdateRightLean("walls");
        }
        else if (action.wall === "right_leanto_back") {
            state.params.p_b_c_b_r_b = action.value;
            state.params.b_r_l_t_b = action.value;
            updatewallAction = action.value + action.wall;
            if(params.p_b_c_b_r_b!="Open" && params.p_b_c_b_r_b!="Close" && chkEndJtrim==true)
            {
                params.p_j_t_end = true;
            }
            //cuComponent.autoRotateBuilding(state,"Back");
            if(params.p_b_c_b_r_b!="Open" && params.p_b_c_b_r_b!="Close" && params.p_b_c_b_r_b!="Half Dutch End" && params.p_b_c_b_r_b!="Half End" && chkEndJtrim==true)
            {
                params.p_j_t_end = true;
            }
            const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
            const_var.UpdatedPriceData.common_width_changed = true;
            //state.params.p_b_c_b_r_f = action.value;
            cuBuilding.UpdateRightLean("walls");
        }
        else if (action.wall === "right_leanto_right") {
            state.params.p_b_c_b_r = action.value;
            state.params.b_r_l_t_r = action.value;
            updatewallAction = action.value + action.wall;
            if(params.p_b_c_b_r!="Open" && params.p_b_c_b_r!="Close" && params.p_b_c_b_r!="Half Dutch End" && params.p_b_c_b_r!="Half End" && chkSideJtrim==true)
            {
                params.p_j_t = true;
            }
            //cuComponent.autoRotateBuilding(state,"Right");
            const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
            const_var.UpdatedPriceData.common_length_changed = true;
            cuBuilding.UpdateRightLean("walls");
        }
            //--- front lean wall
            if(state.params.p_b_c_b_f_l == "Close" && state.params.p_b_c_b_f_b == "Close" && state.params.p_b_c_b_f_f == "Close"){
                const_var.setLeanWallOption.frontLean = 'close'
            }else if(state.params.p_b_c_b_f_l == "Open" && state.params.p_b_c_b_f_b == "Open" && state.params.p_b_c_b_f_f == "Open"){
                const_var.setLeanWallOption.frontLean = 'open'
            }else{
                const_var.setLeanWallOption.frontLean = 'partial'
            }
            //--- right lean wall
            if(state.params.p_b_c_b_r == "Close" && state.params.p_b_c_b_r_b == "Close" && state.params.p_b_c_b_r_f == "Close"){
                const_var.setLeanWallOption.rightLean = 'close'
            }else if(state.params.p_b_c_b_r == "Open" && state.params.p_b_c_b_r_b == "Open" && state.params.p_b_c_b_r_f == "Open"){
                const_var.setLeanWallOption.rightLean = 'open'
            }else{
                const_var.setLeanWallOption.rightLean = 'partial'
            }
            //--- left lean wall
            if(state.params.p_b_c_b_l == "Close" && state.params.p_b_c_b_l_b == "Close" && state.params.p_b_c_b_l_f == "Close"){
                const_var.setLeanWallOption.leftLean = 'close'
            }else if(state.params.p_b_c_b_l == "Open" && state.params.p_b_c_b_l_b == "Open" && state.params.p_b_c_b_l_f == "Open"){
                const_var.setLeanWallOption.leftLean = 'open'
            }else{
                const_var.setLeanWallOption.leftLean = 'partial'
            }
            //--- back lean wall
            if(state.params.p_b_c_b_b_l == "Close" && state.params.p_b_c_b_b_b == "Close" && state.params.p_b_c_b_b_f == "Close"){
                const_var.setLeanWallOption.backLean = 'close'
            }else if(state.params.p_b_c_b_b_l == "Open" && state.params.p_b_c_b_b_b == "Open" && state.params.p_b_c_b_b_f == "Open"){
                const_var.setLeanWallOption.backLean = 'open'
            }else{
                const_var.setLeanWallOption.backLean = 'partial'
            }
        // console.log(const_var.makeCertificateArrayLeft,"const_var.makeCertificateArrayLeftconst_var.makeCertificateArrayLeftconst_var.makeCertificateArrayLeft");
        checkForFullEnclosedBuilding(state);
        // console.log(const_var.makeCertificateArrayLeft,"const_var.makeCertificateArrayLeft111")
        utils.updateWainscotOnWallCahnge();
        if (const_var.isInsulaltionForOldQuotes) const_var.UpdatedPriceData.insulation_price = undefined;
        if (action.typeofLean == "left") {
            if (params.insulation.leftLean.fullBuilding || params.insulation.leftLean.custom) const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
            const_var.UpdatedPriceData.wainscot_price_changed = true;
            // const_var.UpdatedPriceData.color_price_changed = true;
            const_var.UpdatedPriceData.insulation_price_changed = true;
            const_var.UpdatedPriceData.roof_color_price_changed = true;
            const_var.UpdatedPriceData.wall_color_price_changed = true;
            const_var.UpdatedPriceData.trim_color_price_changed = true;
            const_var.UpdatedPriceData.surcharge_amount = undefined;
            cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
        } if (action.typeofLean == "right") {
            if (params.insulation.rightLean.fullBuilding || params.insulation.rightLean.custom) const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
            const_var.UpdatedPriceData.wainscot_price_changed = true;
            // const_var.UpdatedPriceData.color_price_changed = true;
            const_var.UpdatedPriceData.insulation_price_changed = true;
            const_var.UpdatedPriceData.roof_color_price_changed = true;
            const_var.UpdatedPriceData.wall_color_price_changed = true;
            const_var.UpdatedPriceData.trim_color_price_changed = true;
            const_var.UpdatedPriceData.surcharge_amount = undefined;
            cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
        }
        if (action.typeofLean == "front") {
            if (params.insulation.frontLean.fullBuilding || params.insulation.frontLean.custom) const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
            const_var.UpdatedPriceData.wainscot_price_changed = true;
            // const_var.UpdatedPriceData.color_price_changed = true;
            const_var.UpdatedPriceData.insulation_price_changed = true;
            const_var.UpdatedPriceData.roof_color_price_changed = true;
            const_var.UpdatedPriceData.wall_color_price_changed = true;
            const_var.UpdatedPriceData.trim_color_price_changed = true;
            const_var.UpdatedPriceData.surcharge_amount = undefined;
            cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
        } if (action.typeofLean == "back") {
            if (params.insulation.backLean.fullBuilding || params.insulation.backLean.custom) const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
            const_var.UpdatedPriceData.wainscot_price_changed = true;
            // const_var.UpdatedPriceData.color_price_changed = true;
            const_var.UpdatedPriceData.insulation_price_changed = true;
            const_var.UpdatedPriceData.roof_color_price_changed = true;
            const_var.UpdatedPriceData.wall_color_price_changed = true;
            const_var.UpdatedPriceData.trim_color_price_changed = true;
            const_var.UpdatedPriceData.surcharge_amount = undefined;
            cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
        }

        return {
            ...state,
            newColor: updatewallAction
        }
        break;
        case "UTILITYPRICECALCULATION":
            cuBuilding.cP();
            return {
                ...state,
                newColor: action.str + action.value
            }
            break;
        case "ADDUTILITY":

            let UpdateStorageAction = '';

            let rightWall,leftWall,backWall
            (state.params.cB_addStorage_check_right) ? rightWall = true : rightWall = false;
            (state.params.cB_addStorage_check_left) ? leftWall = true : leftWall = false;
            (state.params.p_u_c) ? backWall = true : backWall = false;

            if (action.storage === "back") {
                state.params.p_u_c = !state.params.p_u_c;
                if (params.p_u_c == true) {
                    params.cB_addStorage_check_right = false;
                    params.cB_addStorage_check_left = false;
                    params.nostorage = false;
                    params.cB_addStorage_check_both_with_back = false;
                    params.cB_addStorage_check_both = false;
                }
                state.params.p_u_t = Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];;
                // state.isFullyEnclosedChecked = false;
                params.p_b_w = "Open";
                state.params.p_u_f_w = "Close";
                if(rightWall == true && state.isFullyEnclosedChecked != true){
                    params.p_r_w = "Open"
                }
                if(leftWall == true && state.isFullyEnclosedChecked != true){
                    params.p_l_w = "Open"
                }
                const_var.UpdatedPriceData.utility_price_changed = true;
                const_var.UpdatedPriceData.back_wall_price_changed = true;
                const_var.UpdatedPriceData.right_wall_price_changed = true;
                const_var.UpdatedPriceData.left_wall_price_changed = true;
                const_var.UpdatedPriceData.roof_pitch_price_changed = true;
                const_var.UpdatedPriceData.insulation_price_changed = true;
                cuBuilding.BuildingUpdate(false, 'utilitywall');
                // resetLeantoStoragePrice("leftLean");
                // resetLeantoStoragePrice("rightLean");
                // resetLeantoStoragePrice("backLean");
                if(params.p_l_w != "Close"){
                    if(params.p_r_w != "Close"){
                    }
                }else if (params.p_b_w != "Close"){
                }else if (params.p_l_w != "Close" && params.p_b_w != "Close"){
                }else{
                }
                //removeWainscot(state);
                // newColor: state.isFullyEnclosedChecked + state.params.p_u_c + state.isFullyOpenedChecked + "ADDUTILITY"

                UpdateStorageAction = action.event + action.storage + params.p_u_c
            }
            else if (action.storage === "left") {
                if((state.params.cB_addStorage_check_right || state.params.p_u_c) && const_var.insulationPriceJson?.insulation_wall != undefined && const_var.insulationPriceJson.insulation_wall['storage_left'] != undefined && const_var.insulationPriceJson.insulation_wall['storage_left'] == true){
                    delete const_var.insulationPriceJson.insulation_wall['storage_left']
                }
                state.params.cB_addStorage_check_left = !state.params.cB_addStorage_check_left;
                state.params.cB_addStorage_check_right = false;
                if (state.params.cB_addStorage_check_left == false) {
                    state.params.cB_addStorage_check_left_utility = false;
                }
                if (params.cB_addStorage_check_left == true) {
                    params.p_u_c = false;
                    params.cB_addStorage_check_right = false;
                    params.nostorage = false;
                    params.cB_addStorage_check_both_with_back = false;
                    params.cB_addStorage_check_both = false;
                    params.p_c_p_l = false
                    // params.p_r_w = (params.add_right_lean == true) ? 1 : "Open";
                    // params.p_b_w = "Open";  
                }
                state.params.cB_addStorage_left = state.const_var.DistanceArr[state.params.p_b_t][state.params.p_r_s];
                params.p_l_w = (state.params.cB_addStorage_check_left == false) ? (params.add_left_lean == true) ? 1 : "Open" : params.p_l_w;

                if(params.p_f_w == "Half End" || params.p_f_w == "Half Dutch End") params.p_f_w = "Open";
                if(params.p_b_w == "Half End" || params.p_b_w == "Half Dutch End") params.p_b_w = "Open";

                if (state.isFullyEnclosedChecked != true) {
                    params.p_r_w = params.p_r_w;
                }
                if (state.isFullyEnclosedChecked == true) {
                    params.p_b_w = params.p_l_w = params.p_r_w = "Close";
                }
                if(rightWall == true && state.isFullyEnclosedChecked != true){
                    params.p_r_w = "Open"
                    params.p_c_p_r = false
                }
                if(backWall == true && state.isFullyEnclosedChecked != true){
                    params.p_b_w = "Open"
                }
                const_var.UpdatedPriceData.utility_price_changed = true;
                const_var.UpdatedPriceData.front_wall_price_changed = true;
                const_var.UpdatedPriceData.left_wall_price_changed = true;
                const_var.UpdatedPriceData.back_wall_price_changed = true;
                const_var.UpdatedPriceData.roof_pitch_price_changed = true;
                const_var.UpdatedPriceData.insulation_price_changed = true;
                params.cB_addStorage_left = Math.round(params.p_w / 2)
                cuBuilding.BuildingUpdate(false, 'utilitywallLeft');
                // resetLeantoStoragePrice("leftLean");
                // resetLeantoStoragePrice("backLean");
                // resetLeantoStoragePrice("frontLean");
                if(params.p_r_w != "Close"){
                }else{
                }
                UpdateStorageAction = action.event + action.storage + params.cB_addStorage_check_left
            }
            else if (action.storage === "right") {
                if((state.params.cB_addStorage_check_left  || state.params.p_u_c) && const_var.insulationPriceJson?.insulation_wall != undefined && const_var.insulationPriceJson.insulation_wall['storage_right'] != undefined && const_var.insulationPriceJson.insulation_wall['storage_right'] == true){
                    delete const_var.insulationPriceJson.insulation_wall['storage_right']
                }
                state.params.cB_addStorage_check_right = !state.params.cB_addStorage_check_right;
                state.params.cB_addStorage_check_left = false;
                if (state.params.cB_addStorage_check_right == false) {
                    state.params.cB_addStorage_check_right_utility = false;
                }
                params.p_r_w = (state.params.cB_addStorage_check_right == false) ? (params.add_right_lean == true) ? 1 : "Open" : params.p_r_w;
                if(params.p_f_w == "Half End" || params.p_f_w == "Half Dutch End") params.p_f_w = "Open";
                if(params.p_b_w == "Half End" || params.p_b_w == "Half Dutch End") params.p_b_w = "Open";

                state.params.cB_addStorage_right = state.const_var.DistanceArr[state.params.p_b_t][state.params.p_r_s];
                if (params.cB_addStorage_check_right == true) {
                    params.p_u_c = false;
                    params.cB_addStorage_check_left = false;
                    // params.p_l_w = (params.add_left_lean == true) ? 1 : "Open";
                    params.nostorage = false;
                    params.cB_addStorage_check_both_with_back = false;
                    params.cB_addStorage_check_both = false;
                    params.p_c_p_r = false
                    // params.p_b_w = "Open"; 
                }

                if (state.isFullyEnclosedChecked != true) {
                    params.p_l_w = params.p_l_w;//"Open"
                }
                if (state.isFullyEnclosedChecked == true) {
                    params.p_b_w = params.p_l_w = params.p_r_w = "Close";
                }

                if(leftWall == true && state.isFullyEnclosedChecked != true){
                    params.p_l_w = "Open"
                    params.p_c_p_l = false
                }
                if(backWall == true && state.isFullyEnclosedChecked != true){
                    params.p_b_w = "Open"
                }

                const_var.UpdatedPriceData.utility_price_changed = true;
                const_var.UpdatedPriceData.utility_price_changed = true;
                const_var.UpdatedPriceData.front_wall_price_changed = true;
                const_var.UpdatedPriceData.right_wall_price_changed = true;
                const_var.UpdatedPriceData.back_wall_price_changed = true;
                const_var.UpdatedPriceData.roof_pitch_price_changed = true;
                const_var.UpdatedPriceData.insulation_price_changed = true;
                //removeWainscot(state);
                params.cB_addStorage_right = Math.round(params.p_w / 2)
                // resetLeantoStoragePrice("rightLean");
                // resetLeantoStoragePrice("backLean");
                // resetLeantoStoragePrice("frontLean");
                cuBuilding.BuildingUpdate(false, 'utilitywallRight');

                UpdateStorageAction = action.event + action.storage + params.cB_addStorage_check_right
            }else if (action.storage === "both") {
                params.cB_addStorage_check_both =! params.cB_addStorage_check_both;
                state.params.cB_addStorage_check_right = params.cB_addStorage_check_both;
                state.params.cB_addStorage_check_left = params.cB_addStorage_check_both;
                
                params.nostorage = false;
                params.cB_addStorage_check_both_with_back = false;
                

                const_var.UpdatedPriceData.utility_price_changed = true;
                const_var.UpdatedPriceData.utility_price_changed = true;
                const_var.UpdatedPriceData.front_wall_price_changed = true;
                const_var.UpdatedPriceData.right_wall_price_changed = true;
                const_var.UpdatedPriceData.back_wall_price_changed = true;
                const_var.UpdatedPriceData.roof_pitch_price_changed = true;
                const_var.UpdatedPriceData.insulation_price_changed = true;
                //removeWainscot(state);
                params.cB_addStorage_right = Math.round((params.p_w / 2)-2.5)
                params.cB_addStorage_left = Math.round((params.p_w / 2)-2.5)
                // resetLeantoStoragePrice("rightLean");
                // resetLeantoStoragePrice("backLean");
                // resetLeantoStoragePrice("frontLean");
                cuBuilding.BuildingUpdate(false, 'utilitywallRight');
                cuBuilding.BuildingUpdate(false, 'utilitywallLeft');

                UpdateStorageAction = action.event + action.storage + params.cB_addStorage_check_right+ params.cB_addStorage_check_left
            }else if(action.storage=="bothside_with_back")
            {
                params.cB_addStorage_check_both_with_back =! params.cB_addStorage_check_both_with_back;
                params.p_u_c = params.cB_addStorage_check_both_with_back;
                state.params.cB_addStorage_check_right = params.cB_addStorage_check_both_with_back;
                state.params.cB_addStorage_check_left = params.cB_addStorage_check_both_with_back;


                state.params.p_u_t = Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
                state.isFullyEnclosedChecked = false;
                params.p_b_w = "Open";
                
                // resetLeantoStoragePrice("leftLean");
                // resetLeantoStoragePrice("rightLean");
                // resetLeantoStoragePrice("backLean");
                
                
                params.cB_addStorage_check_both = false;
                params.nostorage = false;

                

                const_var.UpdatedPriceData.utility_price_changed = true;
                const_var.UpdatedPriceData.utility_price_changed = true;
                const_var.UpdatedPriceData.front_wall_price_changed = true;
                const_var.UpdatedPriceData.right_wall_price_changed = true;
                const_var.UpdatedPriceData.back_wall_price_changed = true;
                const_var.UpdatedPriceData.roof_pitch_price_changed = true;
                const_var.UpdatedPriceData.insulation_price_changed = true;
                //removeWainscot(state);
                params.cB_addStorage_right = Math.round((params.p_w / 2)-2.5)
                params.cB_addStorage_left = Math.round((params.p_w / 2)-2.5)
                cuBuilding.BuildingUpdate(false, 'utilitywall');
                
                cuBuilding.BuildingUpdate(false, 'utilitywallRight');
                cuBuilding.BuildingUpdate(false, 'utilitywallLeft');
                // resetLeantoStoragePrice("rightLean");
                // resetLeantoStoragePrice("backLean");
                // resetLeantoStoragePrice("frontLean");
                
                UpdateStorageAction = action.event + action.storage + params.cB_addStorage_check_right+ params.cB_addStorage_check_left + params.p_u_c
            }
            // state.params.insulation.center.isDisableFullInsulation = false;
            const_var.UpdatedPriceData.wainscot_price_changed = true;
            // const_var.UpdatedPriceData.color_price_changed = true;
            const_var.UpdatedPriceData.roof_color_price_changed = true;
            const_var.UpdatedPriceData.wall_color_price_changed = true;
            const_var.UpdatedPriceData.trim_color_price_changed = true;
            const_var.UpdatedPriceData.insulation_price_changed = true;
            if(params.p_e_i != "other") const_var.UpdatedPriceData.certificate_price_changed = true;
            const_var.wallSelection.centerBuildingWall = "c_b_f_w";
            const_var.wallSelection.leanToWall = "select";
            params.activeWall = "c_b_f_w";
            cuComponent.cameraFocusOnWall("c_b_f_w");
            return {
                ...state,
                // action
                newColor: UpdateStorageAction
            }
            break;
        case "NOSTORAGE":
            params.nostorage = !params.nostorage;
            if (params.nostorage == true) {
                // params.p_u_c = false;
                // params.cB_addStorage_check_right = false;
                // params.cB_addStorage_check_left = false;
                // params.p_b_w = "Open";
                if (state.isFullyEnclosedChecked == true) {
                    params.p_b_w = params.p_l_w = params.p_r_w = "Close";
                    params.p_u_c = false;
                    params.cB_addStorage_check_right = false;
                    params.cB_addStorage_check_left = false;
                    params.cB_addStorage_check_both =false;
                    params.cB_addStorage_check_both_with_back = false;

                } else {
                    // params.p_l_w = (params.add_left_lean == true) ? "1" : "Open";
                    // params.p_r_w = (params.add_right_lean == true) ? "1" : "Open";
                    if(params.p_u_c == true){
                        params.p_b_w = "Open"
                        params.p_u_c = false;
                    }
                    if(params.cB_addStorage_check_front == true){
                        params.p_f_w = "Open"
                        params.cB_addStorage_check_front = false;
                    }
                    if(params.cB_addStorage_check_left == true){
                        params.p_l_w = "Open"
                        params.cB_addStorage_check_left = false;
                    }
                    if(params.cB_addStorage_check_right == true){
                        params.p_r_w = "Open"
                        params.cB_addStorage_check_right = false
                    }
                    params.cB_addStorage_check_both =false;
                    params.cB_addStorage_check_both_with_back = false;
                }
                const_var.UpdatedPriceData.utility_price_changed = true;
                const_var.UpdatedPriceData.front_wall_price_changed = true;
                const_var.UpdatedPriceData.left_wall_price_changed = true;
                const_var.UpdatedPriceData.right_wall_price_changed = true;
                const_var.UpdatedPriceData.back_wall_price_changed = true;
                const_var.UpdatedPriceData.roof_pitch_price_changed = true;
                const_var.UpdatedPriceData.wainscot_price_changed = true;
                // const_var.UpdatedPriceData.color_price_changed = true;
                const_var.UpdatedPriceData.roof_color_price_changed = true;
                const_var.UpdatedPriceData.wall_color_price_changed = true;
                const_var.UpdatedPriceData.trim_color_price_changed = true;
                const_var.UpdatedPriceData.surcharge_amount = undefined;
                const_var.UpdatedPriceData.insulation_price = undefined;
                if( params.p_e_i != "other" ) const_var.UpdatedPriceData.certificate_price_changed = true;
                params.noStorageCertificatePriceChange = true;
                const compRemoveWalls = ['c_b_r_s_f_w', 'c_b_r_s_b_w', 'c_b_r_s_l_w', 'c_b_l_s_f_w', 'c_b_l_s_b_w', 'c_b_l_s_r_w', 'c_b_f_s_w', 'c_b_l_s_w', 'c_b_r_s_w'];
                if(params.p_b_w != 'Close') compRemoveWalls.push('c_b_b_w');
                if(params.p_l_w != 'Close') compRemoveWalls.push('c_b_l_w');
                if(params.p_r_w != 'Close') compRemoveWalls.push('c_b_r_w');
                cuBuilding.cP()
            }
            cuBuilding.BuildingUpdate(false, 'utilitywallRight');
            // resetLeantoStoragePrice("leftLean");
            // resetLeantoStoragePrice("rightLean");
            // resetLeantoStoragePrice("backLean");
            // resetLeantoStoragePrice("frontLean");


            return {
                ...state,
                action
            }
            break;

        case "ADDUTILITYFRONT":
            let renderDataF = "";
            state.params.add_storage_check_front = !state.params.add_storage_check_front;
            state.params.add_storage_check_front_1 = state.params.add_storage_check_front;
            params.add_storage_front = const_var.DistanceArr[params.p_b_t][params.p_r_s] * 1;
            const_var.UpdatedPriceData.front_lean_utility_price_changed = true;
            const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;
            const_var.UpdatedPriceData.wainscot_price_changed = true;
            const_var.UpdatedPriceData.color_price_changed = true;
            const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
            const_var.UpdatedPriceData.wainscot_price_changed = true;
            // const_var.UpdatedPriceData.color_price_changed = true;
            const_var.UpdatedPriceData.roof_color_price_changed = true;
            const_var.UpdatedPriceData.wall_color_price_changed = true;
            const_var.UpdatedPriceData.trim_color_price_changed = true;
            (params.add_storage_check_front == true) ? (params.p_b_c_b_f_b = "Close") : (params.p_b_c_b_f_b = "Open") 
            if (state.isFullyEnclosedCheckedForFrontLeanTo) {
                const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
                params.p_b_c_b_f_b = "Close"
            }
            const_var.UpdatedPriceData.insulation_price_changed = true;
            const_var.UpdatedPriceData.front_lean_left_wall_price_changed = true;
            if (params.insulation.frontLean.fullBuilding || params.insulation.frontLean.custom) const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
            // state.params.insulation.frontLean.isDisableFullInsulation = false;
            state.params.add_storage_front = Math.floor((params.leanF_p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
            renderDataF = state.params.add_storage_check_front + state.isFullyEnclosedCheckedForFrontLeanTo + params.add_storage_front + state.params.p_c_a_f_l_w + "frontLeanto";
            const_var.wallSelection.centerBuildingWall = "c_b_f_w";
            const_var.wallSelection.leanToWall = "select";
            params.activeWall = "c_b_f_w";
            const_var.UpdatedPriceData.front_lean_insulation_price_changed = true
            const_var.UpdatedPriceData.insulation_price_changed = true
            cuBuilding.UpdateFrontLean("walls");
            cuComponent.cameraFocusOnWall("c_b_f_w");
            return {
                ...state,
                newColor: renderDataF
            }
            break;
        case "ADDUTILITYBACK":
            let renderDataB = "";
            state.params.add_storage_check_back = !state.params.add_storage_check_back;
            state.params.add_storage_check_back_1 = state.params.add_storage_check_back;
            params.add_storage_back = const_var.DistanceArr[params.p_b_t][params.p_r_s] * 1;
            const_var.UpdatedPriceData.back_lean_utility_price_changed = true;
            const_var.UpdatedPriceData.back_lean_back_wall_price_changed = true;
            const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;
            const_var.UpdatedPriceData.wainscot_price_changed = true;
            // const_var.UpdatedPriceData.color_price_changed = true;
            const_var.UpdatedPriceData.roof_color_price_changed = true;
            const_var.UpdatedPriceData.wall_color_price_changed = true;
            const_var.UpdatedPriceData.trim_color_price_changed = true;
            const_var.UpdatedPriceData.back_lean_left_wall_price_changed = true;
            (params.add_storage_check_back == true) ? (params.p_b_c_b_b_b = "Close") : (params.p_b_c_b_b_b = "Open") 
            if (state.isFullyEnclosedCheckedForBackLeanTo) {
                const_var.UpdatedPriceData.back_lean_back_wall_price_changed = true;
                params.p_b_c_b_b_b = "Close"
            }
            const_var.UpdatedPriceData.insulation_price_changed = true;
            if (params.insulation.backLean.fullBuilding || params.insulation.backLean.custom) const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
            // state.params.insulation.backLean.isDisableFullInsulation = false;
            state.params.add_storage_back = Math.floor((params.leanB_p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
            renderDataB = state.params.add_storage_check_back + state.isFullyEnclosedCheckedForBackLeanTo + params.add_storage_back + state.params.p_c_a_b_l_w + "backLeanto";
            const_var.wallSelection.centerBuildingWall = "c_b_f_w";
            const_var.wallSelection.leanToWall = "select";
            params.activeWall = "c_b_f_w";
            const_var.UpdatedPriceData.back_lean_insulation_price_changed = true
            const_var.UpdatedPriceData.insulation_price_changed = true
            cuBuilding.UpdateBackLean("walls");
            cuComponent.cameraFocusOnWall("c_b_f_w");
            return {
                ...state,
                newColor: renderDataB
            }
            break;
        case "ADDUTILITYLEFT":
            let renderData = "";
            state.params.add_storage_check = !state.params.add_storage_check;
            state.params.add_storage_check_1 = state.params.add_storage_check;
            params.add_storage = const_var.DistanceArr[params.p_b_t][params.p_r_s] * 1;
            const_var.UpdatedPriceData.left_lean_utility_price_changed = true;
            const_var.UpdatedPriceData.left_lean_front_wall_price_changed = true
            const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
            const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
            const_var.UpdatedPriceData.wainscot_price_changed = true;
            // const_var.UpdatedPriceData.color_price_changed = true;
            const_var.UpdatedPriceData.roof_color_price_changed = true;
            const_var.UpdatedPriceData.wall_color_price_changed = true;
            const_var.UpdatedPriceData.trim_color_price_changed = true;
            (params.add_storage_check == true) ? (params.p_b_c_b_l_b = "Close") : (params.p_b_c_b_l_b = "Open") 
            if (state.isFullyEnclosedCheckedForLeftLeanTo) {
                const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
                params.p_b_c_b_l_b = "Close"
            }
            const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
            const_var.UpdatedPriceData.insulation_price_changed = true;
            if (params.insulation.leftLean.fullBuilding || params.insulation.leftLean.custom) const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
            // state.params.insulation.leftLean.isDisableFullInsulation = false;
            state.params.add_storage = Math.floor((params.lean_p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
            renderData = state.params.add_storage_check + state.isFullyEnclosedCheckedForLeftLeanTo + params.add_storage + state.params.p_c_a_l_l_w + "leftLeanto";
        
            cuBuilding.UpdateLeftLean("walls");
            const_var.wallSelection.centerBuildingWall = "c_b_f_w";
            const_var.wallSelection.leanToWall = "select";
            params.activeWall = "c_b_f_w";
            const_var.UpdatedPriceData.left_lean_insulation_price_changed = true
            const_var.UpdatedPriceData.insulation_price_changed = true
            cuComponent.cameraFocusOnWall("c_b_f_w");
            return {
                ...state,
                newColor: renderData
            }
            break;
        case "ADDUTILITYRIGHT":
            let renderData1 = "";
            state.params.add_storage_check_right = !state.params.add_storage_check_right;
            state.params.add_storage_check_right_1 = state.params.add_storage_check_right;
            params.add_storage_right = const_var.DistanceArr[params.p_b_t][params.p_r_s] * 1;
            const_var.UpdatedPriceData.right_lean_utility_price_changed = true;
            const_var.UpdatedPriceData.right_lean_front_wall_price_changed = true
            const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
            const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
            const_var.UpdatedPriceData.wainscot_price_changed = true;
            // const_var.UpdatedPriceData.color_price_changed = true;
            const_var.UpdatedPriceData.roof_color_price_changed = true;
            const_var.UpdatedPriceData.wall_color_price_changed = true;
            const_var.UpdatedPriceData.trim_color_price_changed = true;
            (params.add_storage_check_right == true) ? (params.p_b_c_b_r_b = "Close") : (params.p_b_c_b_r_b = "Open") 
            if (state.isFullyEnclosedCheckedForRightLeanTo) {
                const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
                params.p_b_c_b_r_b = "Close"
            }
            const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
            const_var.UpdatedPriceData.insulation_price_changed = true;
            if (params.insulation.rightLean.fullBuilding || params.insulation.rightLean.custom) const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
            // state.params.insulation.rightLean.isDisableFullInsulation = false;
            state.params.add_storage_right = Math.floor((params.leanR_p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
            renderData1 = state.params.add_storage_check_right + state.isFullyEnclosedCheckedForRightLeanTo + params.add_storage_right + state.params.p_c_a_r_l_w + "rightLeanto";
            
            const_var.UpdatedPriceData.right_lean_insulation_price_changed = true
            const_var.UpdatedPriceData.insulation_price_changed = true
            cuBuilding.UpdateRightLean("walls");
            const_var.wallSelection.centerBuildingWall = "c_b_f_w";
            const_var.wallSelection.leanToWall = "select";
            params.activeWall = "c_b_f_w";
            cuComponent.cameraFocusOnWall("c_b_f_w");
            return {
                ...state,
                newColor: renderData1
            }
            break;
        case "UTILITYLENGHTCHANGE":
            let checkUtilityVal = action.str + action.value;
            handleUtilityLenghtSelectonChangeValue(action.str, action.value, state);
            const_var.UpdatedPriceData.wainscot_price_changed = true;
            // const_var.UpdatedPriceData.color_price_changed = true;
                const_var.UpdatedPriceData.roof_color_price_changed = true;
            const_var.UpdatedPriceData.wall_color_price_changed = true;
            const_var.UpdatedPriceData.trim_color_price_changed = true;
            const_var.wallSelection.centerBuildingWall = "c_b_f_w";
            const_var.wallSelection.leanToWall = "select";
            params.activeWall = "c_b_f_w";
            cuComponent.cameraFocusOnWall("c_b_f_w");
            return {
                ...state,
                newColor: checkUtilityVal
            }

            break;


        case "commonConfirmationAlert":
            if (action.key == "cancel") {
                state.const_var.isShowAlert = true;
                state.const_var.alertUsedFor = "CancelOrderQuote";
            } if (action.key == "captuareIMG") {
                state.const_var.isShowAlert = true;
                state.const_var.alertUsedFor = "captuareIMG";
            } if (action.key == "compare") {
                state.const_var.isShowCompare = !state.const_var.isShowCompare;             
                document.querySelector('body').classList.toggle('active-twod-drawing-popup');
                document.querySelector('body').classList.toggle('modal-open');
                state.const_var.ComparisionDataArray = {};
                params.m_s_n_1 = 0;
                params.m_s_n_2 = 0;
                params.m_n_f_1 = params.m_n_f_2 = "Select"; 
                state.const_var.NoCompareData1 = false;
                state.const_var.NoCompareData2 = false;
                state.const_var.comparisionLoadermfg1 = false;
                state.const_var.comparisionLoadermfg2 = false;
                params.showCompareMnfList_1 = params.showCompareMnfList_2 = false;
                state.cupolaEditIconsPos = [];
                state.doorWindowIconsPos = [];

            }
            if(action.key == "customBuilding"){
                state.const_var.isShowAlert = true;
                state.const_var.alertUsedFor = "customBuildings";
            }
            return {
                ...state,
                newColor: action + const_var.isShowAlert + const_var.alertUsedFor + state.const_var.isShowCompare
            }
            break;
        case "alertCancel":
            const_var.chknewCount++;
            // state.const_var.doorUniqueId = action.uniqueId;
            if (state.const_var.alertUsedFor == "nonVerticalRoofStyleForTubulerBuildingMnf") {
                    state.params.p_r_s = state.holdPreviousRoofStyle;
                    makeDimensionArray(state);
                    cuBuilding.BuildingUpdate(true, '')
                    if (params.isBreezeway /* && chkEdit != "edit" */) updateBreezewayFrameAndStorages({option:"buildingHeight"}, undefined, Number(params.p_h));
                    if (params.cupola) cuComponent.handlCupolaPositionOnDimensionChange('roofPitch');
                    if (params.add_front_lean) cuBuilding.UpdateFrontLean();
                    if (params.add_left_lean) cuBuilding.UpdateLeftLean();
                    if (params.add_right_lean) cuBuilding.UpdateRightLean();
                    if (params.add_back_lean) cuBuilding.UpdateBackLean(); 
            }
            if (state.const_var.alertUsedFor == "REMOVECOMPONENT" || state.const_var.alertUsedFor == "noSpaceAvailableOnWall") {
                state.isShowEditIconSection = false;
                state.const_var.showComponentEditBox = false;
                state.const_var.showComponentDeleteAlert = false;
            }
            if (state.const_var.alertUsedFor == "YourCanNotAddPorch1") {
                for (const key in params.params_cancel) {
                    params[key] = params.params_cancel[key];
                }
                //
                cuBuilding.CheckLeanLegsByResponse(state, "all");
                cuBuilding.BuildingUpdate(true, '')
                if (params.cupola) cuComponent.handlCupolaPositionOnDimensionChange("h");
    
                if (params.add_left_lean == true) {
                    const_var.UpdatedPriceData.left_lean_roof_pitch_price_changed = true;
                    const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
                    const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
                    cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
                }
                if (params.add_front_lean == true) {
                    const_var.UpdatedPriceData.front_lean_roof_pitch_price_changed = true;
                    const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
                    const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
                    cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
                }
                if (params.add_back_lean == true) {
                    const_var.UpdatedPriceData.back_lean_roof_pitch_price_changed = true;
                    const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
                    const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
                    cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
                }
                if (params.add_right_lean == true) {
                    const_var.UpdatedPriceData.right_lean_roof_pitch_price_changed = true;
                    const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
                    const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
                    cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
                }
                cuBuilding.cP();
            }
            state.const_var.isShowAlert = false;
            state.const_var.alertUsedFor = "";
            params.preAction = {};
            return {
                ...state,
                newColor: action + state.const_var.isShowAlert + state.const_var.alertUsedFor + state.const_var.showComponentEditBox + state.const_var.showComponentDeleteAlert + const_var.chknewCount
            }
            break;
        
        case "checkChangeBuildingRoof":
            if (action.value == "front") {
                let b_l_t_r_pF = parseInt(action.event);
                let p_h = state.params.p_h;
                const_var.UpdatedPriceData.height_price_changed = true
                if (state.params.add_front_lean == true) {
                    var calHeight = state.params.leanF_p_h + Math.round(state.params.leanF_p_w * b_l_t_r_pF / 12);
                    let frontLeanRoofHeight = calHeight;
                    if (calHeight > p_h && calHeight <= state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                        // state.params.p_h = state.params.leanF_p_h + Math.round(state.params.leanF_p_w * state.params.b_l_t_r_pF / 12);
                        p_h = ( p_h <= frontLeanRoofHeight ) ? frontLeanRoofHeight : p_h;
                    }

                    if (calHeight > state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                        b_l_t_r_pF = 3;
                    }
                    var exactVal = Math.floor(p_h - ((params.leanF_p_w * b_l_t_r_pF) / 12));
    
                    // console.log({ exactVal });
                    if (exactVal < 6 && p_h < state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                        p_h = p_h + 1;
                    }
                }
                var dataW = Math.floor(((p_h - state.params.leanF_p_h) * 100) / (((b_l_t_r_pF) / 12) * 100));
                var newDataW = (parseInt(dataW) >= 24) ? 24 : parseInt(dataW);
                var dataH = Math.floor(p_h - ((state.params.leanF_p_w * b_l_t_r_pF) / 12));
                if (dataH < 6 || newDataW < 6) {
                    b_l_t_r_pF = "2";
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "RoofPitchAction";
                }
    
                if (state.params.add_right_front_lean_porch == true && b_l_t_r_pF != state.params.b_l_t_r_pR) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
    
                if (state.params.add_left_front_lean_porch == true && b_l_t_r_pF != state.params.b_l_t_r_p) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
            }
            if (action.value == "left") {
                const_var.UpdatedPriceData.left_wall_price_changed = true
                const_var.UpdatedPriceData.height_price_changed = true

                let b_l_t_r_p = parseInt(action.event);
                let p_h = state.params.p_h;
                if (state.params.add_left_lean == true) {
                    var calHeight = state.params.lean_p_h + Math.round(state.params.lean_p_w * b_l_t_r_p / 12);
                    let leftLeanRoofHeight = calHeight;
                    if (calHeight > state.params.p_h && calHeight <= state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                        // state.params.p_h = state.params.lean_p_h + Math.round(state.params.lean_p_w * state.params.b_l_t_r_p / 12);
                        p_h = ( p_h < leftLeanRoofHeight ) ? leftLeanRoofHeight : p_h;
                    }
                    if (calHeight > state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                        b_l_t_r_p = 3;
                    }
                    var exactVal = Math.floor(p_h - ((params.lean_p_w * b_l_t_r_p) / 12));
    
                    if (exactVal < 6 && p_h < state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                        p_h = p_h + 1;
                    }
                }
                var dataW = Math.floor(((p_h - state.params.lean_p_h) * 100) / (((b_l_t_r_p) / 12) * 100));
                var newDataW = (parseInt(dataW) >= 24) ? 24 : parseInt(dataW);
                var dataH = Math.floor(p_h - ((state.params.lean_p_w * b_l_t_r_p) / 12));
                let minWidthL = 6;
                let roofDatanew = const_var.roof_style_Barn;
                if(const_var.roof_style_Barn_with_centerbuilding[params.p_b_t]!=undefined)
                {
                    roofDatanew = const_var.roof_style_Barn_with_centerbuilding[params.p_b_t];
                }
                roofDatanew.map((val, i) => {
                    if (params.p_r_s == val.roof_id) {
                        minWidthL = val.min_width;
                    }
                })
    
                if (dataH < 6 || newDataW < minWidthL) {
                    b_l_t_r_p = "2";
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "RoofPitchAction";
                }
    
    
                if (state.params.add_left_front_lean_porch != false && b_l_t_r_p != params.b_l_t_r_pF) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
    
                if (state.params.add_left_back_lean_porch != false && b_l_t_r_p != params.b_l_t_r_pB) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
            }
            if (action.value == "right") {
                const_var.UpdatedPriceData.height_price_changed = true
                let b_l_t_r_pR = parseInt(action.event);
                let p_h = state.params.p_h;
                if (state.params.add_right_lean == true) {
                    var calHeight = state.params.leanR_p_h + Math.round(state.params.leanR_p_w * b_l_t_r_pR / 12);
                    let rightLeanRoofHeight = calHeight;
                    if (calHeight > state.params.p_h && calHeight <= state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                        // state.params.p_h = state.params.leanR_p_h + Math.round(state.params.leanR_p_w * state.params.b_l_t_r_pR / 12);
                        p_h = ( p_h < rightLeanRoofHeight ) ? rightLeanRoofHeight : p_h;
                    }
                    if (calHeight > state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                        b_l_t_r_pR = 3;
                    }
                    var exactVal = Math.floor(params.p_h - ((params.leanR_p_w * b_l_t_r_pR) / 12));
                    if (exactVal < 6 && p_h < state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                        p_h = p_h + 1;
                    }
                }
                var dataW = Math.floor(((p_h - state.params.leanR_p_h) * 100) / (((b_l_t_r_pR) / 12) * 100));
    
                var newDataW = (parseInt(dataW) >= 24) ? 24 : parseInt(dataW);
                var dataH = Math.floor(p_h - ((state.params.leanR_p_w * b_l_t_r_pR) / 12));
                let minWidthR = 6;
                let roofDatanew = const_var.roof_style_Barn;
                if(const_var.roof_style_Barn_with_centerbuilding[params.p_b_t]!=undefined)
                {
                    roofDatanew = const_var.roof_style_Barn_with_centerbuilding[params.p_b_t];
                }
                roofDatanew.map((val, i) => {
                    if (params.p_r_s == val.roof_id) {
                        minWidthR = val.min_width;
                    }
                })
                if (dataH < 6 || newDataW < minWidthR) {
                    b_l_t_r_pR = "2";
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "RoofPitchAction";
                }
    
                if (state.params.add_right_front_lean_porch != false && b_l_t_r_pR != params.b_l_t_r_pF) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
    
                if (state.params.add_right_back_lean_porch != false && b_l_t_r_pR != params.b_l_t_r_pB) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
            }
            if (action.value == "back") {
                let b_l_t_r_pB = parseInt(action.event);
                const_var.UpdatedPriceData.height_price_changed = true
                let p_h = state.params.p_h;
                if (state.params.add_back_lean == true) {
                    var calHeight = state.params.leanB_p_h + parseInt(b_l_t_r_pB);
                    let backLeanRoofHeight = calHeight;
                    if (calHeight > state.params.p_h && calHeight <= state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                        // state.params.p_h = state.params.leanB_p_h + Math.round(state.params.leanB_p_w * state.params.b_l_t_r_pB / 12);
                        p_h = ( params.p_h < backLeanRoofHeight ) ? backLeanRoofHeight : state.params.p_h;
                    }
                    if (calHeight > state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                        b_l_t_r_pB = 3;
                    }
                    var exactVal = Math.floor(params.p_h - ((params.leanB_p_w * b_l_t_r_pB) / 12));
    
                    if (exactVal < 6 && p_h < state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                        p_h = p_h + 1;
                    }
                }
                var dataW = Math.floor(((p_h - state.params.leanB_p_h) * 100) / (((b_l_t_r_pB) / 12) * 100));
                var newDataW = (parseInt(dataW) >= 24) ? 24 : parseInt(dataW);
                var dataH = Math.floor(p_h - ((state.params.leanB_p_w * b_l_t_r_pB) / 12));
                if (dataH < 6 || newDataW < 6) {
                    b_l_t_r_pB = "2";
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "RoofPitchAction";
                }
                if (state.params.add_right_back_lean_porch == true && b_l_t_r_pB != state.params.b_l_t_r_pR) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
    
                if (state.params.add_left_back_lean_porch == true && b_l_t_r_pB != state.params.b_l_t_r_p) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }
            }
            return {
                ...state,
                action
            } 
            break;

        case "changeBuildingRoof":
            let p_r_p = action.event.slice(0, 1);

            if (params.singleSlope == true && const_var.c_m_a[params.p_b_t]!=undefined && (const_var.c_m_a[params.p_b_t].fixed_new_leg_width==undefined ||const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length == 0) && (params.p_h  - (Number(p_r_p)/12) * params.p_w) < const_var.b_m_i_hlean) {
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "restrictedBuildingHeight";             
            }else if(params.singleSlope == true && const_var.c_m_a[params.p_b_t]!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length >0 && action.value == "center"){
                    state.const_var.isShowAlert = false;
            } else {
            const_var.showDisabledClass = true;
                changeBuildingRoof(state, action.event, action.value);
            }
            return {
                ...state,
                newColor: action.event + action.value
            }
            break;
        
        case "handleSidePanel":
            state.const_var.isActiveSlide = !state.const_var.isActiveSlide;
            document.querySelector('body').classList.toggle("active-left-panel");
            // cuComponent.onResize();
            // setTimeout(function () {
            //     cuComponent.onResize();
            // }, 1000);
            return {
                ...state,
                action
            }
            break;
        case "CheckSnowLoadBuilding":
            params.isSnowLoad = !params.isSnowLoad
            if (params.isSnowLoad == true) {
                const_var.CheckSnowLoadValue = 65;
            } else {
                const_var.CheckSnowLoadValue = 35;

            }
            if(const_var.checkmoreCustomizeFlag == true && !params.isSnowLoad && const_var.stateData!=undefined){
                const_var.hide_price_calculation = const_var.stateData.hide_price_calculation 
                document.querySelector('body').classList.remove("active-hidden-price")
            }
            if(const_var.checkmoreCustomizeFlag == true && params.isSnowLoad && const_var.stateData!=undefined){
                const_var.hide_price_calculation = 1
                document.querySelector('body').classList.remove("active-hidden-price")
            }
            const_var.eventKey = "garages";
            return {
                ...state,
                CheckSnowLoadBuilding: params.isSnowLoad
            }
            break;
        case "removeComponent":
            state.const_var.isShowAlert = !state.const_var.isShowAlert;
            state.const_var.alertUsedFor = "REMOVECOMPONENT";
            state.const_var.doorUniqueId = action.uniqueId;
            state.const_var.doorUniqueIndex = action.uniqueindex;
            state.const_var.object_name = action.component_name;
            state.const_var.showComponentEditBox = false;
            state.const_var.showComponentDeleteAlert = true;

            
            return {
                ...state,
                newColor: state.const_var.isShowAlert + action.uniqueId + state.const_var.showComponentEditBox + state.const_var.alertUsedFor + state.const_var.showComponentDeleteAlert
            }
            break;
        case "cloneComponent":
            let editData = action.doorObj;
            let noDoorAdded = false;
            if( params.m_s_n==11 && 
                const_var.entry_wall_location[editData.component_wall_name].includes('end') &&
                (editData.parent_array_key == "Garage" || editData.parent_array_key == "Garage_Frameout") && 
                editData.entry_dimension_height >= params.p_h
            )
            {
                noDoorAdded = true;
            }

            if (noDoorAdded === true) {
                const_var.isShowAlert = true;
                const_var.alertUsedFor = "NoMoreGarageDoorsCanBeAdded";
                const_var.showComponentEditBox = false;
            } else {
                params.trimkit = editData != undefined ? editData.entry_trim_kit : false;
                AddDoorComponentonWall(editData.entry_type, editData.component_name, editData.component_wall_name, editData.name, editData.parent_array_key, editData.child_array_key, editData.nested_array_key, editData.entry_rotation==undefined?0:editData.entry_rotation, editData.entry_position,undefined,action.doorObj)
                state.const_var.showComponentEditBox = false;
                if (state.const_var.isShowAlert == true && state.const_var.alertUsedFor == "noSpaceAvailableOnWall") {
                    state.const_var.showComponentEditBox = false;
                }
            }
            return {
                ...state,
                action
            }
        case "toggleActionForUtility":
            if (action.value == "left") {
                state.params.leftstorage = !state.params.leftstorage;
                if (state.params.leftstorage == true) {
                    state.params.wallPos = "LeftS";
                } else {
                    state.params.wallPos = "FrontL";
                }
                if (state.params.rightstorage == true) {
                    state.params.rightstorage = false;
                    state.params.wallPos = "FrontR";
                }
            } if (action.value == "right") {
                state.params.rightstorage = !state.params.rightstorage;
                if (state.params.rightstorage == true) {
                    state.params.wallPos = "RightS";
                } else {
                    state.params.wallPos = "FrontR";
                }
                if (state.params.leftstorage == true) {
                    state.params.leftstorage = false;
                    state.params.wallPos = "FrontL";
                }
            }
            if (action.value == "center") {
                state.params.centerstorage = !state.params.centerstorage;
            }
            return {
                ...state,
                newColor: action.value + state.params.leftstorage + state.params.rightstorage + state.params.centerstorage
            }
            break;
        case "addCustomComponent":
            const_var.editComponentDimension = '';
            params.extra_notes = '';
            params.g_d_c = params.g_d_c;
            if (action.con == "walls") {
                const_var.sideDistance1 = 0;
                state.params.wallPos = action.event;
                if (state.params.wallPos != "Select") {
                    if (action.event == "Front") {
                        state.params.centerstorage = false;
                        state.const_var.doorWall = "Front";
                    }
                    if (action.event == "Left") {
                        if (params.add_left_lean == true && state.const_var.llsh == false) {
                            state.const_var.doorWall = "LeftL";
                        }
                    }
                    if (action.event == "Right") {
                        if (params.add_right_lean == true && state.const_var.rlsh == false) {
                            state.const_var.doorWall = "RightR";
                        }
                    }
                }
            } else if (action.con != "walls") {
                // console.log("HERE ------- 333333333333");
                state.params.wallPos = const_var.doorWall;
                params.b_l_t_s = const_var.doorWall;
                let componentName = "";
                state.params.p_a_g_r_u_d = "Select";
                state.params.p_d_c = "Select";
                state.params.p_w_cc = "Select";
                state.params.p_a_g_r_u_d_c_s = "Select";
                state.params.p_a_g_r_u_d_c_s1 = "Select";
                state.params.f_r_m_o_t = state.params.f_r_m_o_t1 = "Select";
                params.trimkit = params.chain_hoist = params.header_seal = params.automatic_openers = params.certified_door = params.insulated = params.motor = false;
                Object.keys(state.params).map((e) => {
                    if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price"))  {
                        let prop = e.replace("entry_", "");
                        params[prop] = false;
                    }
                })

                if (action.value == "sectionalGarage" && action.event != "Select") {
                    state.params.p_a_g_r_u_d = action.event;
                    const_var.editComponentDimension = action.event;
                    state.params.doorType = action.value;
                    componentName = "garageRollUpDoor_" + action.event;
                }
                if (action.value == "Garage" && action.event != "Select") {
                    state.params.p_a_g_r_u_d = action.event;
                    const_var.editComponentDimension = action.event;
                    state.params.doorType = action.value;
                    componentName = "garageRollUpDoor_" + action.event;
                }
                if ((action.value == "Walk" || action.value == "WalkFrameout") && action.event != "Select") {
                    state.params.p_d_c = action.event;
                    const_var.editComponentDimension = action.event;
                    state.params.doorType = action.value;
                    componentName = "walkDoorSolid" + action.event;
                }
                if ((action.value == "Windows" || action.value == "WindowsFrameout") && action.event != "Select") {
                    state.params.p_w_cc = action.event;
                    const_var.editComponentDimension = action.event;
                    state.params.doorType = action.value;
                    componentName = "window" + action.event;
                }
                addCustomComponent(state, action.event, action.value, componentName);
                if (action.value == "CustomFrameout" && action.event != "Select") {
                    const_var.editComponentDimension = action.event;
                    //state.params.p_a_g_r_u_d = action.event;
                    // if(action.dim == "w")
                    // {
                    const_var.custDM.w = action.event.split('X')[0];
                    // }
                    // if(action.dim == "h")
                    // {
                    const_var.custDM.h = action.event.split('X')[1];
                    // }
                    // if(const_var.custDM.w !=undefined)
                    // {state.params.f_r_m_o_t = const_var.custDM.w;}
                    // if(const_var.custDM.h !=undefined)
                    // {state.params.f_r_m_o_t1 = const_var.custDM.h;}                    
                    // if(const_var.custDM.w !=undefined && const_var.custDM.h !=undefined)
                    // {
                    state.params.f_r_m_o_t = const_var.custDM.w;
                    state.params.f_r_m_o_t1 = const_var.custDM.h;
                    state.params.p_a_g_r_u_d = state.params.f_r_m_o_t + "X" + state.params.f_r_m_o_t1 + "_Frameout";
                    componentName = "garageRollUpDoor_" + state.params.f_r_m_o_t + "X" + state.params.f_r_m_o_t1 + "_Frameout";
                    addCustomComponent(state, action.event, action.value, componentName);
                    // } 
                }
            }
            return {
                ...state,
                newColor: action.event + state.params.wallPos + action.value
            }
            break;
        case "handleBreezawayFrameAndStorages" :
            updateBreezewayFrameAndStorages(action, Number(action.value), undefined);
            return{
                ...state,
                action
            };
            break;   
        case "ADD_DOOR_COMPONENT":
            params.trimkit = params.chain_hoist = params.header_seal = params.automatic_openers = params.certified_door = params.insulated = params.motor = false;
            Object.keys(params).map((e) => {
                if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price"))  {
                    let prop = e.replace("entry_", "");
                    params[prop] = false;
                }
            })
            params.extra_notes = "";
            params.g_d_c = "0xffffff";
            let doorSizes = action.componentsize.split("x")[1];
            let finalComponentPrice = const_var.entry_wall_location[action.wall].includes('side')?1:0;
            if(action.obj!=undefined && action.obj.side_clearance!=undefined)
            {
                finalComponentPrice = const_var.entry_wall_location[action.wall].includes('side')?action.obj.side_clearance:0;
            }
            if(params.m_s_n==11 && action.obj!=undefined)
            {
                finalComponentPrice = const_var.entry_wall_location[action.wall].includes('end')?action.obj.end_clearance:finalComponentPrice;

                if (action.wall == "c_b_f_w" || action.wall == "c_b_b_w" || action.wall == "c_b_f_s_w") {
                    let doors = const_var.entry_points.filter((e) => {
                        if ( e.component_wall_name == action.wall && e.entry_dimension_height >= params.p_h) {
                        return true;
                        }
                    });
                    if (doors.length == 0) finalComponentPrice = 0;
                }
            }

            let wallHeight = params.p_h;

            let sec = cuComponent.wallnameBySec[action.wall];
            // let height = params.p_h;
            switch(sec) {
                case "leftlean": 
                    wallHeight = params.lean_p_h;
                    break;
                case "rightlean": 
                    wallHeight = params.leanR_p_h;
                    break;
                case "frontlean": 
                    wallHeight = params.leanF_p_h;
                    break;
                case "backlean": 
                    wallHeight = params.leanB_p_h;
                    break;
            }

            if (params.m_s_n === 3 && action.compType == "garage_door_frameout") {
                const isSide = const_var.entry_wall_location[action.wall].includes('side');
                if (isSide) {
                    finalComponentPrice = Number(doorSizes) >= 13 ? 2: 1;
                }
            }

            // ########## Handling heritage end clearance ##########
            if(params.m_s_n == 153 && action.obj!=undefined) {
                finalComponentPrice = const_var.entry_wall_location[action.wall].includes('end')?action.obj.end_clearance:finalComponentPrice;
            }
            // let wallHight = const_var.scene.getObjectByName(action.wall).scale.y
            if (doorSizes > ( wallHeight - finalComponentPrice) && (action.parentkey == "Garage" || action.parentkey == "Garage_Frameout")) {
                const_var.isShowAlert = true;
                const_var.alertUsedFor = "NoMoreGarageDoorsCanBeAdded";
                const_var.showComponentEditBox = false;
            }
            else{
                const_var.checkDoorIsadded = true;
                let colorData = '';
                    if(const_var.garageDoorColor!=undefined)
                    {
                    let colorData = const_var.garageDoorColor.filter(data=>data.name=="White");
                    if(colorData.length==0)
                    {
                        colorData = const_var.SendAPIBuildingData.garageDoorColor[0];
                    }else
                    {
                        colorData = colorData[0];
                    }
                    state.params.g_d_c_name = colorData.name;
                    state.params.g_d_c_id = colorData.id;
                    params.g_d_c = colorData.hex_value.replace('#', '0x');
                    }
                        
                AddDoorComponentonWall(action.compType, action.compName, action.wall, action.componentsize, action.parentkey, action.childkey, action.nestedkey);
            }

            return {
                ...state,
                newColor: action.obj + action.compType + action.compName + action.wall + action.componentsize + action.parentkey + action.childkey + action.nestedkey + state.const_var.entry_points.length+const_var.isShowAlert + const_var.showComponentEditBox,
                action,
            };
            break;

        case "updateDoorComponent":
            state.const_var.doorUniqueId = action.uniqueId;
            state.const_var.doorUniqueIndex = action.uniqueIndex;
            state.const_var.object_name = action.componentName;
            cuComponent.removeComponentFromWall(Number(action.uniqueId));
            return {
                ...state,
                action
            }
            break;

        case "setPricingForSurcharge":
            cuBuilding.cP();
        return{
            ...state,
            action
        }    
        case "setPricingForComponent":
            state.newColor = action.id + action.flag;
            //cuBuilding.calculateDoorComponentPrice(true,action.indexVal,true);
            if(params.p_e_i != "other") const_var.UpdatedPriceData.certificate_price_changed = true;
            cuBuilding.cP('',undefined,action.indexVal,action.chk,action.is_editChk);
            const_var.checkDoorIsadded = false;

            return {
                ...state,
                action
            }
            break;
        case "showDoorWindowsPrompt":
            const_var.isShowAlert = !const_var.isShowAlert;
            // console.log("dsfsdhfjhgjh","dsgfsdg")
            const_var.alertUsedFor = 'noSpaceForComponent';
        return{
            ...state,
            newColor:const_var.isShowAlert + const_var.alertUsedFor,
            action
        }    
        case "changeComponent":
            // console.log('giorgi- changeComponent: ', {action});
            params.trimkit = params.chain_hoist = params.header_seal = params.certified_door = params.automatic_openers = params.insulated = params.motor = false;
            Object.keys(params).map((e) => {
                if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price"))  {
                    let prop = e.replace("entry_", "");
                    params[prop] = false;
                }
            })
            var currentComp = JSON.parse(JSON.stringify(action.component_Obj));
            // params.g_d_c = "0xffffff"
            let doorName = `${action.component_Obj.child_array_key}_${action.doorName.replace(" ", "_" ).toLowerCase()}`
            state.isotherDoorType = doorName;
            cuComponent.RemoveDoorComponent(currentComp.uniqueId, currentComp.entry_type, doorName, currentComp.component_wall_name, currentComp.name, currentComp.parent_array_key, currentComp.child_array_key, currentComp.nested_array_key,currentComp.entry_rotation, currentComp.entry_position, undefined,undefined, currentComp.component_name);
            //cuComponent.RemoveDoorComponent(currentComponent.uniqueId, currentComponent.entry_type, 'standard_door', currentComponent.component_wall_name, currentComponent.name, currentComponent.parent_array_key, currentComponent.child_array_key, currentComponent.nested_array_key, currentComponent.entry_rotation, currentComponent.entry_position,undefined,undefined, 'standard_trim_door',isChangePos);
                            
            return{
                ...state,
                action
            }
            break;
        case "changeComponentSize":
            let updateComponent = action.doorsize+action.uniqueId+action.component_Obj+action.is_trim+action.is_Checked;
            let currentComponent = JSON.parse(JSON.stringify(action.component_Obj));
            let currentComponentName = currentComponent.name;
            if (action.doorsize === 'Custom Size') {
                currentComponentName = '5x5';
                if (currentComponent.parent_array_key == "Walk" || currentComponent.parent_array_key == "Walk_Frameout")
                {
                    currentComponentName = '24x60';
                }
                else if (currentComponent.parent_array_key == "Windows" || currentComponent.parent_array_key == "Windows_Frameout")
                {
                    currentComponentName = '24x24';

                    if (currentComponent.nested_array_key.includes("Transom Window")) {
                        currentComponentName = '24x10';
                    }
                }
                else{
                    if(currentComponent.parent_array_key == "Garage_Frameout")
                    {
                        currentComponentName = (action.is_Checked==true)?'5x5': const_var.customFrameoutInitialSize;
                    }else{
                        currentComponentName = '5x5';
                    }
                }
            }
            let componentdimension = (action.is_trim == 'trim' || action.doorsize === 'Custom Size') ? currentComponentName.split("x") : action.doorsize.split("x");
            const Doorwidth = (currentComponent.entry_type == "garage_door" || currentComponent.entry_type == "garage_door_frameout") ? parseInt(componentdimension[0]) : parseInt(componentdimension[0]) / 12;
            const Doorheight = (currentComponent.entry_type == "garage_door" || currentComponent.entry_type == "garage_door_frameout") ? parseInt(componentdimension[1]) : parseInt(componentdimension[1]) / 12;
            const compName = (currentComponent.component_name=="standard_trim_door") ? 'standard_door' : currentComponent.component_name;

            // const addValidationVariable = addValidation(currentComponent.entry_type, compName, Doorwidth, Doorheight, currentComponent.component_wall_name);
            
            const selectedComponent = const_var.newDoorsArray.find(s => s.uniqueId === action.uniqueId)
            const positionX = selectedComponent && selectedComponent.positionX;
            const positionY = selectedComponent && selectedComponent.positionY;

            const targetWallNameArr = wallNameArrForValid.find(subArray => subArray.includes(currentComponent.component_wall_name));
            // const sideArray = const_var.newDoorsArray.filter((item) => item.uniqueId !== currentComponent.uniqueId && item.userData.wallName === currentComponent.component_wall_name);
            const sideArray = const_var.newDoorsArray.filter((item) => item.uniqueId !== currentComponent.uniqueId && targetWallNameArr.includes(item.userData.wallName));

            // implement the clearance free space size
            let parentkey = '';
            let childkey = '';
            let nestedkey = '';
            
            if (currentComponent) {
                parentkey = currentComponent.parent_array_key;
                childkey = currentComponent.child_array_key;
                nestedkey = currentComponent.nested_array_key;
            }
            
            const editValidationVariable = editValidation({
                compType: currentComponent.entry_type,
                compName,
                width: Doorwidth,
                height: Doorheight,
                wallName: currentComponent.component_wall_name,
                parentkey,
                childkey,
                nestedkey,
                positionX,
                positionY,
                sideArray
            });
            
            const isEdit = (currentComponent.component_name=="standard_trim_door" && action.is_Checked && action.is_trim === 'trim') ? true : editValidationVariable.isEdit;
            const isChangePos = editValidationVariable.isChangePos;
            const_var.changeComponentSize = true;

            if(isEdit)
            {
                if (action.doorsize == "Custom Size") {
                    let colorData = '';
                    const doorIndex = const_var.newDoorsArray.findIndex((item) => item.uniqueId === action.doorUniqueId);
                    if (doorIndex !== -1) {
                        state.const_var.newDoorsArray[doorIndex].isCustomSizeChange = action.isCustomSizeChange;
                    }
                        if(const_var.garageDoorColor!=undefined)
                        {
                        let colorData = const_var.garageDoorColor.filter(data=>data.name=="White");
                        if(colorData.length==0)
                        {
                            colorData = const_var.SendAPIBuildingData.garageDoorColor[0];
                        }else
                        {
                            colorData = colorData[0];
                        }
                        state.params.g_d_c_name = colorData.name;
                        state.params.g_d_c_id = colorData.id;
                        params.g_d_c = colorData.hex_value.replace('#', '0x');
                        state.params.g_d_c_Obj = colorData;
                        }
                    
                    let comDimension = '5x5';
                    if (currentComponent.parent_array_key == "Walk" || currentComponent.parent_array_key == "Walk_Frameout")
                    {
                        comDimension = '24x60';
                    }
                    else if (currentComponent.parent_array_key == "Windows" || currentComponent.parent_array_key == "Windows_Frameout")
                    {
                        comDimension = '24x24';

                        if (currentComponent.nested_array_key.includes("Transom Window")) {
                            comDimension = '24x10';
                        }
                    }
                    else{
                        if(currentComponent.parent_array_key == "Garage_Frameout")
                        {
                            comDimension = (action.is_Checked==true)?'5x5': const_var.customFrameoutInitialSize;
                            if(currentComponent.entry_doorNewType == "Custom Size") {
                                currentComponent.entry_doorNewType = undefined;
                                comDimension = const_var.customFrameoutInitialSize;
                            }
                        }else{
                            comDimension = '5x5';
                        }
                    }

                    commonFunctionForColor(comDimension, currentComponent.parent_array_key, currentComponent.child_array_key, currentComponent.nested_array_key,false,currentComponent);

                    currentComponent.entry_automatic_openers = false;
                    currentComponent.entry_certified = false;
                    currentComponent.entry_chain_hoist = false;
                    currentComponent.entry_header_seal = false;
                    currentComponent.entry_is_automatic_openers = false;
                    currentComponent.entry_is_certified =false;
                    currentComponent.entry_is_chain_hoist=false;
                    currentComponent.entry_is_header_seal=false;
                    params.header_seal = false;
                    params.chain_hoist = false;
                    params.automatic_openers = false;
                    params.certified_door = false;
                    params.insulated = false;
                    params.motor = false;
                    Object.keys(params).map((e) => {
                        if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price"))  {
                            let prop = e.replace("entry_", "");
                            params[prop] = false;
                        }
                    })
                    params.extra_notes = currentComponent.entry_note;
                    cuComponent.RemoveDoorComponent(currentComponent.uniqueId, currentComponent.entry_type, currentComponent.component_name, currentComponent.component_wall_name, comDimension, currentComponent.parent_array_key, currentComponent.child_array_key, currentComponent.nested_array_key,currentComponent.entry_rotation, currentComponent.entry_position,undefined,undefined,undefined, isChangePos);
                } else {
                    const componentSize  = action.is_trim !== 'trim' ? action.doorsize : currentComponent.name;
                    commonFunctionForColor(componentSize, currentComponent.parent_array_key, currentComponent.child_array_key, currentComponent.nested_array_key,false,currentComponent);
                
                    let checkComponentSize = action.doorsize.split("x");
                    let checkHeight = 1;
                    //for SBS - prince (11/4/24)
                    if (params.m_s_n==3 && action.component_Obj.entry_type.includes('frameout')) {
                        if (checkComponentSize[0] >=13) {
                            checkHeight = 2;
                        }
                    }
                    //*********end */
                    // let wallHight = const_var.scene.getObjectByName(currentComponent.component_wall_name).scale.y

                    let wallHeight = params.p_h;
                    // let wall = const_var.scene.getObjectByName(currentComponent.component_wall_name);
                    // let wall1 = const_var.scene.getObjectByName(currentComponent.component_wall_name + 1);
                    let endSide = const_var.entry_wall_location[currentComponent.component_wall_name];
                    let clearance = const_var.newComponentArray[currentComponent.parent_array_key][currentComponent.child_array_key][currentComponent.nested_array_key]["Size"][action.doorsize];
                    
                    
                    let sec = cuComponent.wallnameBySec[currentComponent.component_wall_name];
                    // let height = params.p_h;
                    switch(sec) {
                        case "leftlean": 
                            wallHeight = params.lean_p_h;
                            break;
                        case "rightlean": 
                            wallHeight = params.leanR_p_h;
                            break;
                        case "frontlean": 
                            wallHeight = params.leanF_p_h;
                            break;
                        case "backlean": 
                            wallHeight = params.leanB_p_h;
                            break;
                    }
                    // if (wall) {
                    //     wallHeight = Math.round(wall.scale.y);
                    //     //if (wall1 && wallHeight !== Math.round(wall1.scale.y)) wallHeight += Math.round(wall1.scale.y);
                    //     if (wall1 && height !== Math.round(wall1.scale.y)) wallHeight += Math.round(wall1.scale.y);
                    // }
                    if (params.singleSlope && currentComponent.component_wall_name == "c_b_l_w") {
                        wallHeight = params.p_h - (Number(params.p_r_p)/12) * params.p_w;
                    }
                    if (endSide.includes("end")) {
                        if (clearance && clearance.end_clearance) checkHeight = clearance.end_clearance;
                        
                        let clearanceFromRoof = true;

                        if (params.m_s_n==11 ) {
                            if (currentComponent.component_wall_name == "c_b_f_w" || currentComponent.component_wall_name == "c_b_b_w" || currentComponent.component_wall_name == "c_b_f_s_w") {
                                let doors = const_var.entry_points.filter((e) => {
                                    if ( e.component_wall_name == currentComponent.component_wall_name && 
                                    e.uniqueId != currentComponent.uniqueId &&
                                    e.entry_dimension_height >= params.p_h) {
                                    return true;
                                    }
                                });
                                if (doors.length > 0 || checkComponentSize[1] > params.p_h) clearanceFromRoof = false;
                            }
                        }

                        if (params.m_s_n== 153) {
                            if (currentComponent.component_wall_name == "c_b_f_w" || currentComponent.component_wall_name == "c_b_b_w" || currentComponent.component_wall_name == "c_b_f_s_w") {
                                let doors = const_var.entry_points.filter((e) => {
                                    if ( e.component_wall_name == currentComponent.component_wall_name && 
                                    e.uniqueId != currentComponent.uniqueId &&
                                    e.entry_dimension_height >= params.p_h -1) {
                                    return true;
                                    }
                                });
                                if (doors.length > 0 || checkComponentSize[1] > params.p_h - 1) clearanceFromRoof = false;
                            }
                        }

                        if (clearanceFromRoof) {
                            switch(sec) {
                                case "center":
                                    wallHeight += Number(params.p_r_p) / 12 * (params.singleSlope? params.p_w: params.p_w / 2);
                                    if (params.singleSlope) { // add this condition to fix the single slope door more than building size
                                        if(currentComponent.component_wall_name == "c_b_r_w"){
                                            wallHeight = params.p_h
                                        } else if (currentComponent.component_wall_name == "c_b_f_w") {
                                            wallHeight = params.p_h - (Number(params.p_r_p)/12) * (params.p_w / 2 - selectedComponent.positionX - currentComponent.entry_dimension_width / 2);
                                        }else if (currentComponent.component_wall_name == "c_b_b_w") {
                                            wallHeight = params.p_h - (Number(params.p_r_p)/12) * (params.p_w / 2 + selectedComponent.positionX + currentComponent.entry_dimension_width / 2);
                                        }else{
                                            wallHeight = params.p_h - (Number(params.p_r_p)/12) * params.p_w;
                                        }
                                    }
                                    break;
                                case "leftlean":
                                    wallHeight += Number(params.b_l_t_r_p) / 12 * (params.lean_p_w);
                                    break;
                                case "rightlean":
                                    wallHeight += Number(params.b_l_t_r_pR) / 12 * (params.leanR_p_w);
                                    break;
                                case "frontlean":
                                    wallHeight += Number(params.b_l_t_r_pF) / 12 * (params.leanF_p_w);
                                    break;
                                case "backlean":
                                    wallHeight += Number(params.b_l_t_r_pB) / 12 * (params.leanB_p_w);
                                    break;
                            }
                        }
                    } else if(clearance && clearance.side_clearance) {
                        checkHeight = clearance.side_clearance;
                    } 
                    if (checkComponentSize[1] > (wallHeight - checkHeight) && (currentComponent.parent_array_key == "Garage" || currentComponent.parent_array_key == "Garage_Frameout")) {
                        const_var.isShowAlert = true;
                        const_var.alertUsedFor = "NoMoreGarageDoorsCanBeAdded";
                        const_var.showComponentEditBox = false;
                    } else {
                        if(clearance && clearance.is_chain_hoist!=undefined)
                        {
                            currentComponent.entry_chain_hoist = clearance.is_chain_hoist==2 ?true:false;
                        }
                        params.header_seal = currentComponent.entry_header_seal;
                        params.chain_hoist = currentComponent.entry_chain_hoist;
                        params.automatic_openers = currentComponent.entry_automatic_openers;
                        params.certified_door = currentComponent.entry_certified;
                        params.insulated = currentComponent.entry_insulated;
                        params.motor = currentComponent.entry_motor;
                        params.extra_notes = currentComponent.entry_note;

                        if (currentComponent.component_name.includes("overhead_door_door") && clearance && clearance.door_add_ons) {
                            const wOPtion = clearance.door_add_ons.filter((e) => e.door == 'window_option');
                            const doorName = currentComponent.component_name.replace("overhead_door_door_", '');
                            const door = wOPtion[0].category.find((item) => item.category.split(' ').join('_').toLowerCase() == doorName);

                            if(!door) {
                                cuComponent.RemoveDoorComponent(currentComponent.uniqueId,  currentComponent.component_name);
                                currentComponent.component_name = "overhead_door_door_" + wOPtion[0].category[0].category.split(' ').join('_').toLowerCase();
                            }

                            if(clearance!=undefined && clearance.door_add_ons!=undefined)
                            {
                                const addOnOption = clearance.door_add_ons.find((e) => e.door == 'add_on_options');                        
                                Object.keys(currentComponent).map((e) => {
                                    if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price"))  {
                                        let prop = e.replace("entry_", "");
                                        params[prop] = currentComponent[e];
                                        let isAvble = addOnOption?.category.find((option) => prop.includes(option.category.split(' ').join('_').toLowerCase()));
                                        if (!isAvble) {
                                            params[prop] = false;
                                            // currentComponent[e] = false;
                                        }
                                    }
                                })
                            }
                        }



                        if (action.is_trim == 'trim') {
                            if (!state.const_var.checkDoorIsadded) {
                            state.const_var.checkDoorIsadded = true;
                            params.chain_hoist = params.header_seal = params.automatic_openers = params.certified_door = params.insulated = params.motor = false;
                            Object.keys(params).map((e) => {
                                if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price"))  {
                                    let prop = e.replace("entry_", "");
                                    params[prop] = false;
                                }
                            })
                            params.trimkit = (action.is_Checked==true)?true:false;
                                const_var.garageDoorColor.map((value, key) => {
                                    if (currentComponent.garage_door_color == value.hex_value.replace('#', '0x')) {
                                        state.params.g_d_c_name = value.name;
                                        state.params.g_d_c_id = value.id;
                                        params.g_d_c = value.hex_value.replace('#', '0x');
                                        state.params.g_d_c_Obj = value;
                                    }
                                })
                            
                            if (params.trimkit == true) {
                                cuComponent.RemoveDoorComponent(currentComponent.uniqueId, currentComponent.entry_type, 'standard_trim_door', currentComponent.component_wall_name, currentComponent.name, currentComponent.parent_array_key, currentComponent.child_array_key, currentComponent.nested_array_key, currentComponent.entry_rotation, currentComponent.entry_position,undefined,undefined, 'standard_door',isChangePos);
                            } else {
                                cuComponent.RemoveDoorComponent(currentComponent.uniqueId, currentComponent.entry_type, 'standard_door', currentComponent.component_wall_name, currentComponent.name, currentComponent.parent_array_key, currentComponent.child_array_key, currentComponent.nested_array_key, currentComponent.entry_rotation, currentComponent.entry_position,undefined,undefined, 'standard_trim_door',isChangePos);
                            }
                            }
                        } else {
                            if(currentComponent.entry_trim_kit == true && params.trimkit==false)
                            {
                                params.trimkit = true;
                            }
                            cuComponent.RemoveDoorComponent(currentComponent.uniqueId, currentComponent.entry_type, currentComponent.component_name, currentComponent.component_wall_name, action.doorsize, currentComponent.parent_array_key, currentComponent.child_array_key, currentComponent.nested_array_key,currentComponent.entry_rotation, currentComponent.entry_position,undefined,undefined,undefined, isChangePos);
                        }

                    }
                }
            }else{
                const_var.isShowAlert = !const_var.isShowAlert;
                const_var.alertUsedFor = 'noSpaceAvailableOnWall';
            }

            const_var.changeComponentSize = false;

            return {
                ...state,
                newColor:updateComponent,
                action
            }
            break;

        case "UPDATE_DOOR_WINDOW_EDIT_ICONS":
            let doorWindowIconsPos = [];
            const vObjs = [];
            // const_var.scene.traverse((c) => {
            //     if (c.type === "Mesh" && ((c.visible && !c.parent?.DoorObj && c.material?.opacity === 1)
            //     || (c.parent?.DoorObj  && (((!params.isBreezeway ? cuComponent.wallnameBySec[c.parent.userData.wallName] : cuComponent.breezewayWallnameByStorage[c.parent.userData.wallName]) === const_var.focusedSection) 
            //     || const_var.selectedTabKeyForWheel !== 'doorwindow')))){
            //         vObjs.push(c);
            //     }
            // });
            const intersectedDoor = cuComponent.getIntersectedObjects(action.event, vObjs);
            let leantoWalls = [
                "L_L_L_W", "L_L_F_W", "L_L_B_W", "L_L_F_S_W", "L_L_L_S_W", "L_L_R_S_W",
                "R_L_F_W", "R_L_B_W", "R_L_R_W", "R_L_F_S_W", "R_L_L_S_W", "R_L_R_S_W",
                "F_L_F_W", "F_L_R_W", "F_L_L_W", "F_L_F_S_W", "F_L_L_S_W","F_L_R_S_W", "F_L_B_S_W",
                "B_L_F_W", "B_L_B_W", "B_L_S_W", "B_L_L_S_W","B_L_R_S_W", "B_L_F_S_W", "B_L_B_S_W",
            ];
            
            if (intersectedDoor.length > 0) {
                if(leantoWalls.includes(intersectedDoor[0].object.parent.userData.wallName)==true && params.isShowCenter==true)
                {
                    doorWindowIconsPos = [];
                }else if (intersectedDoor.length > 0 
                    && intersectedDoor[0].object.parent.DoorObj 
                    && intersectedDoor[0].object.name !== "hline" 
                    && intersectedDoor[0].object.name !== "vline"
                    && ((intersectedDoor[0].face.normal.x && intersectedDoor[0].face.normal.x < 0)
                    || (intersectedDoor[0].face.normal.y && intersectedDoor[0].face.normal.y < 0)
                    || (intersectedDoor[0].face.normal.z && intersectedDoor[0].face.normal.z < 0))
                    ){
                    let doorObj = intersectedDoor[0].object.parent;
                    let doorWallName = doorObj && doorObj.userData.wallName;
                    let doorcurrentUniqueId = doorObj && doorObj.userData.uniqueId;
                    doorWindowIconsPos = cuComponent.updateDoorIconsPos(state, doorWallName, doorcurrentUniqueId);
                }
            }

            let cupolaEditIconsPos = []
            const intersectedCupola = cuComponent.getIntersectedObjects(action.event, const_var.cupolaForMove);
            if (intersectedCupola.length > 0) {
                let cupolaObj = intersectedCupola[0].object.parent;
                let cupolaName = cupolaObj && cupolaObj.name;
                let currentCupolaUniqueId = cupolaObj && cupolaObj.userData.uniqueId;

            }

            if ((state.doorWindowIconsPos.length === 0 && doorWindowIconsPos.length === 0) && (state.cupolaEditIconsPos.length === 0 && cupolaEditIconsPos.length === 0) && activeWallP === state.params.activeWall) return newState;

            activeWallP = state.params.activeWall;

            return {
                ...state,
                doorWindowIconsPos,cupolaEditIconsPos
            };
            break;

        case "DISABLE_DOOR_WINDOW_EDIT_ICONS":
            return {
                ...state,
                doorWindowIconsPos: []
            };
            break;

        case "CAMERA_FOCUS_ON_WALL":
            state.params.activeWall = action.value; 
            state.const_var.focusedSection = cuComponent.wallnameBySec[action.value];
        
            cuComponent.cameraFocusOnWall(state, action.value);
            return {
                ...state,
                action
            };
            break;
        case "showSingleSlope":
            if (action.key == true) {
                state.params.singleSlope = !state.params.singleSlope;
                cuBuilding.BuildingUpdate(true, 'centerwall');
            } else {
                params.p_l_w_center = !params.p_l_w_center;
            }

            return {
                ...state,
                newColor: state.params.singleSlope
            }
            break;
        case "hasDoublelegBaiserail":

                if (const_var.ExtraItemsFeaturesQuantityArray.length > 0) {
                    const_var.a_p_d_a.extra_items[0].checkbox_quantity.map(val => {
                        const_var.ExtraItemsFeaturesQuantityArray.map(item => {
                            if (item && item.label == val.label && item.name == 'bows') {
                                item.cost = val.cost;
                                item.is_edit = false;
                                if (const_var.UpdatedPriceData['elements'] != undefined && const_var.UpdatedPriceData['elements'][item.label.toString()] != undefined && const_var.UpdatedPriceData['elements'][item.label.toString()].is_edit == true) {
                                    const_var.UpdatedPriceData['elements'][item.label.toString()].is_edit = false;
                                }
                            }
                        });
                    });
            }

            let updateLegsAction = ""
            if (action.buildingType === "center") {
                if(action.otherLegs === undefined)
                {
                    state.params.p_e_l = !state.params.p_e_l;
                }else{
                    state.params.p_e_l = true;
                    const_var.legstype = (action.otherLegs=="reinforced")?"double":(action.otherLegs.legs_type).toLowerCase();
                    const_var.hasDoublelegName = action.event;
                }
                const_var.UpdatedPriceData.height_price_changed = true;
                updateLegsAction = action.event + action.buildingType + params.p_e_l + const_var.legstype;
                updateLegsAction = action;
                if(params.fourth_center_cost)
                {
                    if  (const_var.ExtraItemsFeaturesArray.length > 0 ) {
                        const_var.a_p_d_a.extra_items[0].checkbox.map((val, index) => {
                            state.const_var.ExtraItemsFeaturesArray.map(item => {
                                if (item != null && item.label == val.label && item.name == "fourth_center_cost") {
                                    item.cost = val.cost;
                                }
                            });
                        })
                    }
                    calculateLegsCount();
                }
                cuBuilding.BuildingUpdate();
                cuBuilding.cP();
            }
            if (action.buildingType === "leftLean") {
                // params.lean_p_e_l = !params.lean_p_e_l;
                if(action.otherLegs === undefined)
                {
                    state.params.lean_p_e_l = !state.params.lean_p_e_l;
                }else{
                    state.params.lean_p_e_l = true;
                    const_var.leanLegstype = (action.otherLegs=="reinforced")?"double":action.otherLegs.legs_type;
                    const_var.leanHasDoublelegName = action.event;
                }

                const_var.UpdatedPriceData.left_lean_height_price_changed = true;
                updateLegsAction = action.event + action.buildingType + params.lean_p_e_l;
                if(params.fourth_center_cost==true)
                {
                    calculateLegsCount(const_var.leanGetDataLeft,'leftLean');
                }
                cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
            }
            if (action.buildingType === "rightLean") {
                // params.leanR_p_e_l = !params.leanR_p_e_l;
                if(action.otherLegs === undefined)
                {
                    state.params.leanR_p_e_l = !state.params.leanR_p_e_l;
                }else{
                    state.params.leanR_p_e_l = true;
                    const_var.leanRLegstype = (action.otherLegs=="reinforced")?"double":action.otherLegs.legs_type;
                    const_var.leanRHasDoublelegName = action.event
                }
                // if (state.params.leanR_p_e_l != const_var.UpdatedPriceData.leanR_has_double_leg) {
                //     const_var.UpdatedPriceData.right_lean_height_price_changed = true;
                // }
                const_var.UpdatedPriceData.right_lean_height_price_changed = true;
                updateLegsAction = action.event + action.buildingType + params.leanR_p_e_l;
                if(params.fourth_center_cost==true)
                {
                    calculateLegsCount(const_var.leanGetDataRight,'rightLean');
                }
                cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
            }
            if (action.buildingType === "frontLean") {
                // params.leanF_p_e_l = !params.leanF_p_e_l;
                if(action.otherLegs === undefined)
                {
                    state.params.leanF_p_e_l = !state.params.leanF_p_e_l;
                }else{
                    state.params.leanF_p_e_l = true;
                    const_var.leanFLegstype = (action.otherLegs=="reinforced")?"double":action.otherLegs.legs_type;
                    const_var.leanFHasDoublelegName = action.event
                }
                // if (state.params.leanF_p_e_l != const_var.UpdatedPriceData.leanF_has_double_leg) {
                //     const_var.UpdatedPriceData.front_lean_height_price_changed = true;
                // }
                const_var.UpdatedPriceData.front_lean_height_price_changed = true;
                updateLegsAction = action.event + action.buildingType + params.leanF_p_e_l;
                if(params.fourth_center_cost==true)
                {
                    calculateLegsCount(const_var.leanGetDataFront,'frontLean');
                }
                cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront)

            }
            if (action.buildingType === "backLean") {
                // params.leanB_p_e_l = !params.leanB_p_e_l;
                if(action.otherLegs === undefined)
                {
                    state.params.leanB_p_e_l = !state.params.leanB_p_e_l;
                }else{
                    state.params.leanB_p_e_l = true;
                    const_var.leanBLegstype = (action.otherLegs=="reinforced")?"double":action.otherLegs.legs_type;
                    const_var.leanBHasDoublelegName = action.event;
                }
                // if (state.params.leanB_p_e_l != const_var.UpdatedPriceData.leanB_has_double_leg) {
                //     const_var.UpdatedPriceData.back_lean_height_price_changed = true;
                // }
                const_var.UpdatedPriceData.back_lean_height_price_changed = true;
                updateLegsAction = action.event + action.buildingType + params.leanB_p_e_l;
                if(params.fourth_center_cost==true)
                {
                    calculateLegsCount(const_var.leanGetDataBack,'backLean');
                }
                cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack)
            }

            // if (state.params.p_e_l != const_var.UpdatedPriceData.has_double_leg) {
            //     const_var.UpdatedPriceData.height_price_changed = true;
            // }
            
            
            return {
                ...state,
                newColor: updateLegsAction,
                action
            }
            break;
        case "handleClickForFrameValue":
            state.params.chkFrameOpening = !state.params.chkFrameOpening;
            if (state.params.chkFrameOpening == true) {
                if (action.dropdownType == "WidthHeight") {
                    action.comName = "CustomGarageSize";
                    const_var.editComponentDimension = "CustomGarageSize";
                    params.customW = 5;
                    params.customH = 5;
                }
            } else {

                const_var.editComponentDimension = const_var.customFrameoutInitialSize + "_Frameout";
            }
            return {
                ...state,
                action
            }
            break;

        case "editComponentSize":
            // console.log(action,"action")
            // if(action.comName=="CustomGarageSize" && action.comType=="CustomFrameout" && action.dropdownType=="")
            // {
            //  action.dropdownType = "WidthHeight";
            // }
            params.certified_door = false;
            if (action.dropdownType == 'Width') {
                state.const_var.frameDimension = action.comName;
            }
            if (action.dropdownType == 'Height') {
                state.const_var.frameHDimension = action.comName;
            }
            if (action.trimdoor != "") {
                state.params.trimkit = !state.params.trimkit;
            } else {
                state.params.trimkit = false;
            }
            if ((action.dropdownType == 'Width' || action.dropdownType == 'Height')) {
                let valData = (const_var.editComponentDimension.replace("_Frameout", "").split("X"));
                state.const_var.frameHDimension = (state.const_var.frameHDimension == '') ? valData[1] : state.const_var.frameHDimension;
                state.const_var.frameDimension = (state.const_var.frameDimension == '') ? valData[0] : state.const_var.frameDimension;
            }
            if (action.dropdownType == "WidthHeight") {
                action.comName = "CustomGarageSize";
                const_var.editComponentDimension = "CustomGarageSize";
            } else {
                action.comName = action.dropdownType != '' ? state.const_var.frameDimension + 'X' + state.const_var.frameHDimension : action.comName;
            }
            if (action.comName == "CustomGarageSize") {
                params.certified_door = false;
            }
            return {
                ...state,
                newColor: action.comName + action.comType + action.comId + state.params.trimkit
            }
            break;
        case "headerSealChainHoistAction":
            let door = const_var.newDoorsArray.find((door) => door.uniqueId === Number(action.UniqueId));
            let returnData = "";
            if (door) {

                if (action.value == 'insulated') {
                    state.params.insulated = !state.params.insulated;
                    door.DoorObj.insulated = state.params.insulated;
                }
                
                if (action.value == 'headerSeal') {
                    state.params.header_seal = !state.params.header_seal;
                    door.DoorObj.header_seal = state.params.header_seal;
                    
                    if ((state.params.m_s_n == 3 || state.params.m_s_n == 9) && state.params.header_seal == true) {
                        state.params.automatic_openers = false;
                        door.DoorObj.automatic_openers = state.params.automatic_openers;
                    }
                }

                if (action.value == 'chainHoist') {
                    state.params.chain_hoist = !state.params.chain_hoist;
                    door.DoorObj.chain_hoist = state.params.chain_hoist;
                }
                if (action.value == 'certified_door') {
                    state.params.certified_door = !state.params.certified_door;
                    action.bool_var = state.params.certified_door;
                    door.DoorObj.certified_door = state.params.certified_door;
                }
                if (action.value == 'automatic_openers') {
                    state.params.automatic_openers = !state.params.automatic_openers;
                    door.DoorObj.automatic_openers = state.params.automatic_openers;

                    if ((state.params.m_s_n == 3 || state.params.m_s_n == 9) && state.params.automatic_openers == true) {
                        state.params.header_seal = false;
                        door.DoorObj.header_seal = state.params.header_seal;
                    }
                }
                if (action.value == 'installation_is_end_wall') {
                    //state.params.automatic_openers = !state.params.automatic_openers;
                    door.DoorObj.installation_is_end_wall = door.DoorObj.installation_is_end_wall=="yes"?'no':"yes";
                }
                if (action.value == 'installation_is_side_wall') {
                    door.DoorObj.installation_is_side_wall = door.DoorObj.installation_is_side_wall=="yes"?'no':"yes";
                }
                if (action.value == 'door_color_price') {
                    //console.log(action); 
                    state.params.g_d_c = action.event.hex_value.replace('#', '0x');
                    state.params.g_d_c_name = action.event.name;
                    state.params.g_d_c_id = action.event.id;
                    state.params.g_d_c_Obj = action.event;
                }
                if (action.value == 'extra_notes') {
                    state.params.extra_notes = action.event;
                    door.DoorObj.entry_note = state.params.extra_notes;
                }
            }
            let holdIndex = 0;
            var ii = const_var.entry_points.length;
            while (ii--) {
                if (const_var.entry_points[ii].uniqueId == action.UniqueId) {
                    const doorDefualtValues = const_var.entry_points[ii].entry_size;
                    if (const_var.entry_points[ii].parent_array_key == "Garage" && doorDefualtValues) {
                        if(doorDefualtValues.is_header_seal && doorDefualtValues.is_header_seal == 2) state.params.header_seal = true;
                        if(doorDefualtValues.is_chain_hoist && doorDefualtValues.is_chain_hoist == 2 ) state.params.chain_hoist = true;
                        if(doorDefualtValues.is_certified && doorDefualtValues.is_certified == 2 ) state.params.certified_door = true;
                        if(doorDefualtValues.is_automatic_openers && doorDefualtValues.is_automatic_openers == 2 ) state.params.automatic_openers = true;
                    }
                    
                    if (action.value == 'headerSeal') const_var.entry_points[ii].entry_header_seal_price = doorDefualtValues.header_seal;
                    if (action.value == 'chainHoist') const_var.entry_points[ii].entry_chain_hoist_price = doorDefualtValues.chain_hoist;
                    if (action.value == 'automatic_openers') const_var.entry_points[ii].entry_automatic_openers_price = doorDefualtValues.automatic_openers;
                    if (action.value == 'installation_is_end_wall') const_var.entry_points[ii].installation_end_wall_fee = doorDefualtValues.installation_end_wall_fee;
                    if (action.value == 'installation_is_side_wall') const_var.entry_points[ii].installation_side_wall_fee = doorDefualtValues.installation_side_wall_fee;

                    holdIndex = ii;
                    const_var.entry_points[ii].entry_header_seal = const_var.entry_points[ii].entry_is_header_seal = state.params.header_seal;
                    const_var.entry_points[ii].entry_certified = const_var.entry_points[ii].entry_is_certified = state.params.certified_door;
                    const_var.entry_points[ii].entry_chain_hoist = const_var.entry_points[ii].entry_is_chain_hoist = state.params.chain_hoist;
                    const_var.entry_points[ii].entry_note = params.extra_notes;
                    const_var.entry_points[ii].entry_automatic_openers = const_var.entry_points[ii].entry_is_automatic_openers = state.params.automatic_openers;
                    const_var.entry_points[ii].installation_is_end_wall = door.DoorObj.installation_is_end_wall;
                    const_var.entry_points[ii].installation_is_side_wall = door.DoorObj.installation_is_side_wall;
                    const_var.entry_points[ii].entry_insulated = door.DoorObj.insulated;

                    if (action.value == 'motorOption') {
                        state.params.motor = !state.params.motor;
                        door.DoorObj.motor = state.params.motor;
                        const_var.entry_points[ii].entry_motor = door.DoorObj.motor;

                        returnData = state.params.motor;
                    }

                    if (action.value == 'motor') {
                        const_var.entry_points[ii].entry_motor_price = action.event?.price;
                        const_var.entry_points[ii].entry_motor_name = action.event?.name;
                        returnData = action.event?.name;

                    }
                
                    
                    if (action.value.includes('add_on_options')) {     
                        // if (const_var.)
                        

                        const_var.entry_points[ii]["entry_" + action.value] = (action.bool_var == undefined || action.bool_var == false)? true: false;
                        const_var.entry_points[ii]["entry_" + action.value + "_price"] = action.event;

                        state.params[action.value] = !state.params[action.value];
                        door.DoorObj[action.value] = state.params[action.value];
                        returnData = state.params[action.value] + action.value;
                    }
                    if (action.value == 'insulated') {
                        const_var.entry_points[ii].entry_price = parseFloat(action.componentObj.cost)
                        if(const_var.entry_wall_location[const_var.entry_points[ii].component_wall_name].includes('side')==true)
                        {
                                const_var.entry_points[ii].entry_price = (action.componentObj.side_cost!=undefined && action.componentObj.side_cost!=0)?parseFloat(const_var.entry_points[ii].entry_price) + parseFloat(action.componentObj.side_cost):parseFloat(const_var.entry_points[ii].entry_price);
                        }
                        if (state.params.insulated == true) {
                            const_var.entry_points[ii].entry_price =(parseFloat(const_var.entry_points[ii].entry_price) + parseFloat(action.event)).toFixed(2);
                        } 
                    }
                    
                    if (action.value == 'certified_door') {
                        const_var.entry_points[ii].entry_price = parseFloat(action.componentObj.cost) + parseFloat(const_var.entry_wall_location && const_var.entry_wall_location[const_var.entry_points[ii].component_wall_name] && const_var.entry_wall_location[const_var.entry_points[ii].component_wall_name].includes('side')==true ? parseFloat(action.componentObj.side_cost) : 0);
                        if (state.params.certified_door == true && action.bool_var == true) {
                            const_var.entry_points[ii].entry_price = (action.componentObj.certified_cost != undefined) ? (parseFloat(const_var.entry_points[ii].entry_price) + parseFloat(action.componentObj.certified_cost)).toFixed(2) : const_var.entry_points[ii].entry_price + 0;
                        } 

                    }


                    if (const_var.entry_points[ii].entry_type == "garage_door" && action.value == 'door_color_price') {
                        let UpdateColorDoor = const_var.newDoorsArray.filter(data=>data.uniqueId==action.UniqueId);
                        UpdateColorDoor[0].doorColor = params.g_d_c.replace("0x","#");
                        const_var.entry_points[ii].entry_garageDoor_color_Obj = action.event;
                        const_var.entry_points[ii].garage_door_color = params.g_d_c;
                        const_var.entry_points[ii].entry_garageDoor_color_price = (const_var.garageDoorColor[state.params.g_d_c_id].percentage_of_cost > 0) ? const_var.entry_points[ii].entry_price * const_var.garageDoorColor[state.params.g_d_c_id].cost / 100 : const_var.garageDoorColor[state.params.g_d_c_id].cost;
                    }
                    
                    if (const_var.garageDoorColor[state.params.g_d_c_id].percentage_of_cost > 0) {
                        const_var.entry_points[ii].entry_garageDoor_color_price = const_var.entry_points[ii].entry_price * const_var.garageDoorColor[state.params.g_d_c_id].cost / 100 ;
                    }
                }
                if (const_var.entry_points[ii].uniqueId != action.UniqueId) {
                    if (const_var.entry_points[ii].entry_type == "garage_door") {
                        const_var.garageDoorColor.map((value, key) => {
                            if (value.name == "White" && const_var.entry_points[ii].garage_door_color.replace("0x","#") ==value.hex_value) {
                                const_var.entry_points[ii].entry_garageDoor_color_Obj = value;
                            }
                        })
                    }

                }
            }

            if (door && action.value != 'extra_notes') {
                cuBuilding.cP('',undefined,holdIndex);
                
            }

            returnData = returnData + state.params.header_seal + action.UniqueId + state.params.chain_hoist + state.params.certified_door + state.params.extra_notes + state.params.automatic_openers + state.params.g_d_c + state.params.g_d_c_name+door.DoorObj.installation_is_end_wall+door.DoorObj.installation_is_side_wall + state.params.insulated;

            return {
                ...state,
                newColor: returnData,
                action
            }
            break;
        case "confirmStateAction":
            state.const_var.confirmState = !state.const_var.confirmState;
            return {
                ...state,
                newColor: state.const_var.confirmState
            }
            break;
        case "onSubmitState":
            onSubmitState(state, action.event);
            // const_var.showReportLoading = true;
            return {
                ...state,
                newColor: state.const_var.confirmState + action.event
            }
            break;
        case "Update_estimator_QuestionAnswer":
            const_var.estimator_QuestionAnswer[action.key].options.map((val, i) => {
                const_var.estimator_QuestionAnswer[action.key].options[i].is_checked = false;
            })
            const_var.estimator_QuestionAnswer[action.key].options[action.key1].is_checked = true;
            return {
                ...state,
                action
            }
            break;
        case "showInsulationAction":
            state.const_var.showInsulation = !state.const_var.showInsulation;
            if (state.const_var.showInsulation == false) {
                state.const_var.showDefaultInsullation = false;
                state.params.p_r_o = false;
            }
            cuBuilding.cP();
            return {
                ...state,
                newColor: state.const_var.showInsulation
            }
            break;
        case "checkChangeLeantoPosition":
                if (action.value == "left") {                    
                    if (params.add_left_front_lean_porch != false && action.event != "2") {                        
                        const_var.isShowAlert = true;
                        const_var.alertUsedFor = "YourCanNotAlignPorch";
            
                    }
            
                    if (params.add_left_back_lean_porch != false && action.event != "3") {                        
                        const_var.isShowAlert = true;
                        const_var.alertUsedFor = "YourCanNotAlignPorch";
                    }
                } 
                
                if (action.value == "right") {                    
            
                    if (params.add_right_front_lean_porch != false && action.event != "2") {                        
                        const_var.isShowAlert = true;
                        const_var.alertUsedFor = "YourCanNotAlignPorch";
                    }
            
                    if (params.add_right_back_lean_porch != false && action.event != "3") {                        
                        const_var.isShowAlert = true;
                        const_var.alertUsedFor = "YourCanNotAlignPorch";
                    }
                }
            
                if (action.value == "front") {                    
            
                    if (params.add_right_front_lean_porch != false && action.event != "3") {                        
                        const_var.isShowAlert = true;
                        const_var.alertUsedFor = "YourCanNotAlignPorch";
                    }
            
                    if (params.add_left_front_lean_porch != false && action.event != "2") {                        
                        const_var.isShowAlert = true;
                        const_var.alertUsedFor = "YourCanNotAlignPorch";
                    }
                }
                
                if (action.value == "back") {                    
            
                    if (params.add_right_back_lean_porch != false && action.event != "2") {                        
                        const_var.isShowAlert = true;
                        const_var.alertUsedFor = "YourCanNotAlignPorch";
                    }
            
                    if (params.add_left_back_lean_porch != false && action.event != "3") {                        
                        const_var.isShowAlert = true;
                        const_var.alertUsedFor = "YourCanNotAlignPorch";
                    }
                }     
                
                return {
                    ...state,
                    action
                }      
            break
        case "changeLeantoPosition":

            // for (const key in params) {
            //     params.params_cancel[key] = params[key];
            // }
            
            if (action.value == "left") {
                params.leantoAlignmentLeft = action.event;
                if (state.params.add_left_front_lean_porch != false && params.leantoAlignmentLeft != "2") {
                    state.params.add_left_front_lean_porch = false;
                    // state.const_var.isShowAlert = true;
                    // state.const_var.alertUsedFor = "YourCanNotAddPorch";

                }

                if (state.params.add_left_back_lean_porch != false && params.leantoAlignmentLeft != "3") {
                    state.params.add_left_back_lean_porch = false;
                    // state.const_var.isShowAlert = true;
                    // state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }

                // const leftLean = const_var.scene.getObjectByName("LeftLeanWalls");
                let lstPos = 0;
                let currPos = 0;
                // if(leftLean) lstPos = leftLean.position.z;
                if (params.leantoAlignmentLeft=="1") state.params.lean_p_pos = 0;
                if (params.leantoAlignmentLeft=="2") state.params.lean_p_pos = params.p_d/2-params.lean_p_d/2;
                if (params.leantoAlignmentLeft=="3") state.params.lean_p_pos = -params.p_d/2+params.lean_p_d/2;
                currPos = state.params.lean_p_pos
                if (lstPos != currPos) {
                    const diff = currPos - lstPos;
                    const_var.entry_points.forEach((e) => {
                        if (e.component_wall_name == "L_L_L_W" || e.component_wall_name == "L_L_L_S_W" || e.component_wall_name == "L_L_R_S_W") e.entry_position.z +=diff;
                    })
                }

    
            } if (action.value == "right") {
                params.leantoAlignmentRight = action.event;

                if (state.params.add_right_front_lean_porch != false && params.leantoAlignmentRight != "2") {
                    state.params.add_right_front_lean_porch = false;
                    // state.const_var.isShowAlert = true;
                    // state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }

                if (state.params.add_right_back_lean_porch != false && params.leantoAlignmentRight != "3") {
                    state.params.add_right_back_lean_porch = false;
                    // state.const_var.isShowAlert = true;
                    // state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }

                // const leftLean = const_var.scene.getObjectByName("RightLeanWalls");
                let lstPos = 0;
                let currPos = 0;
                // if(leftLean) lstPos = leftLean.position.z;
                if (params.leantoAlignmentRight=="1") state.params.leanR_p_pos = 0;
                if (params.leantoAlignmentRight=="2") state.params.leanR_p_pos = params.p_d/2-params.leanR_p_d/2;
                if (params.leantoAlignmentRight=="3") state.params.leanR_p_pos = -params.p_d/2+params.leanR_p_d/2;
                currPos = state.params.leanR_p_pos
                if (lstPos != currPos) {
                    const diff = currPos - lstPos;
                    const_var.entry_points.forEach((e) => {
                        if (e.component_wall_name == "R_L_R_W" || e.component_wall_name == "R_L_R_S_W" || e.component_wall_name == "R_L_L_S_W") e.entry_position.z +=diff;
                    })
                }


            }
            if (action.value == "front") {
                params.leantoAlignmentFront = action.event;

                if (state.params.add_right_front_lean_porch != false && params.leantoAlignmentFront != "3") {
                    state.params.add_right_front_lean_porch = false;
                    // state.const_var.isShowAlert = true;
                    // state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }

                if (state.params.add_left_front_lean_porch != false && params.leantoAlignmentFront != "2") {
                    state.params.add_left_front_lean_porch = false;
                    // state.const_var.isShowAlert = true;
                    // state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }

                // const leftLean = const_var.scene.getObjectByName("FrontLeanWalls");
                let lstPos = 0;
                let currPos = 0;
                // if(leftLean) lstPos = leftLean.position.x;
                if (params.leantoAlignmentFront=="1") state.params.leanF_p_pos = 0;
                if (params.leantoAlignmentFront=="3") state.params.leanF_p_pos = params.p_w/2-params.leanF_p_d/2;
                if (params.leantoAlignmentFront=="2") state.params.leanF_p_pos = -params.p_w/2+params.leanF_p_d/2;
                currPos = state.params.leanF_p_pos
                if (lstPos != currPos) {
                    const diff = currPos - lstPos;
                    const_var.entry_points.forEach((e) => {
                        if (e.component_wall_name == "F_L_F_W" || e.component_wall_name == "F_L_F_S_W") e.entry_position.x +=diff;
                    })
                }


                if (params.add_left_front_lean_porch == true ) cuBuilding.UpdateLeftLean();
                }
            if (action.value == "back") {
                params.leantoAlignmentBack = action.event;

                if (state.params.add_right_back_lean_porch != false && params.leantoAlignmentBack != "2") {
                    state.params.add_right_back_lean_porch = false;
                    // state.const_var.isShowAlert = true;
                    // state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }

                if (state.params.add_left_back_lean_porch != false && params.leantoAlignmentBack != "3") {
                    state.params.add_left_back_lean_porch = false;
                    // state.const_var.isShowAlert = true;
                    // state.const_var.alertUsedFor = "YourCanNotAddPorch";
                }

                // const leftLean = const_var.scene.getObjectByName("BackLeanWalls");
                let lstPos = 0;
                let currPos = 0;
                // if(leftLean) lstPos = leftLean.position.x;
                if (params.leantoAlignmentBack=="1") state.params.leanB_p_pos = 0;
                if (params.leantoAlignmentBack=="2") state.params.leanB_p_pos = params.p_w/2-params.leanB_p_d/2;
                if (params.leantoAlignmentBack=="3") state.params.leanB_p_pos = -params.p_w/2+params.leanB_p_d/2;
                currPos = state.params.leanB_p_pos
                if (lstPos != currPos) {
                    const diff = currPos - lstPos;
                    const_var.entry_points.forEach((e) => {
                        if (e.component_wall_name == "B_L_S_W" || e.component_wall_name == "B_L_F_S_W") e.entry_position.x +=diff;
                    })
                }


            }
            cuBuilding.cP();
            
        
            cuComponent.RemovePorchComponent();
            
            return {
                ...state,
                newColor: action.event+action.value
            }
            break;
        case "showCenterBuilding":
            params.isShowCenter = !params.isShowCenter
            if(params.isShowCenter == true && params.add_left_lean == true && params.activeWall == "L_L_L_W"){
                params.activeWall = "c_b_l_w"
            }
            if(params.isShowCenter == false && params.add_left_lean == true && params.activeWall == "c_b_l_w"){
                params.activeWall = "L_L_L_W"
            }

            if(params.isShowCenter == true && params.add_right_lean == true && params.activeWall == "R_L_R_W"){
                params.activeWall = "c_b_r_w"
            }
            if(params.isShowCenter == false && params.add_right_lean == true && params.activeWall == "c_b_r_w"){
                params.activeWall = "R_L_R_W"
            }

            if(params.isShowCenter == true && params.add_front_lean == true && params.activeWall == "F_L_F_W"){
                params.activeWall = "c_b_f_w"
            }
            if(params.isShowCenter == false && params.add_front_lean == true && params.activeWall == "c_b_f_w"){
                params.activeWall = "F_L_F_W"
            }

            if(params.isShowCenter == true && params.add_back_lean == true && params.activeWall == "B_L_S_W"){
                params.activeWall = "c_b_b_w"
            }
            if(params.isShowCenter == false && params.add_back_lean == true && params.activeWall == "c_b_b_w"){
                params.activeWall = "B_L_S_W"
            }

            const_var.focusedSection = "center";
            const_var.wallSelection.centerBuildingWall = params.activeWall;
            const_var.wallSelection.leanToWall = "select";
            state.doorWindowIconsPos = [];
            if (const_var.callMesure){
            }
            // utils.findActiveWall(const_var.controls);
            cuBuilding.BuildingUpdate(true, action.value);
            cuBuilding.UpdateFrontLean();
            cuBuilding.UpdateLeftLean();
            cuBuilding.UpdateRightLean();
            cuBuilding.UpdateBackLean()

            
            return {
                ...state,
                showCenterBuilding: action

            }
            break;
        case "wallSelection":
            if(action.key == "center" ) {
                const_var.wallSelection.centerBuildingWall = action.value;
                const_var.wallSelection.leanToWall = "select"
            } else {
                const_var.wallSelection.centerBuildingWall = "select"
                const_var.wallSelection.leanToWall = action.value;
            }
            
            return {
                ...state,
                wallSelection: action

            }
            break;
        case "addLeantoSection":
            let UpdateAction = '';
            let LeanFlag = false;
            var chkEndJtrim = false;
            var chkSideJtrim = false;
            if((const_var.a_p_d_a.jtrim) && const_var.a_p_d_a.jtrim.length>0)
            {
                chkEndJtrim = (const_var.a_p_d_a.jtrim.filter(data=>data.type=="end")).length>0?true:false;
                chkSideJtrim = (const_var.a_p_d_a.jtrim.filter(data=>data.type=="side")).length>0?true:false;
            }
            if (action.value ==  "endLeantosForTubulerBuildingMnf"){
                const_var.isShowAlert = true;
                const_var.alertUsedFor = "endLeantosForTubulerBuildingMnf";
                state.checkwallposition = ""
                return {
                    ...state,
                    action
                }
            }
            let isOlderThen12June = const_var.crmSetting.is_Edit == true && const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data.main_created_at !=undefined && const_var.editAPIDataByResponse.data.main_created_at<="2024-06-12" ? true : false
            
            let buildingName = const_var.defaultBuildingArr[const_var.BuldingIDforReset] && const_var.defaultBuildingArr[const_var.BuldingIDforReset]?.image_name.split(".").includes("Straight_Roof_Barns")

            let checkType = params.m_s_n == 3 && buildingName && ( ( const_var.editAPIDataByResponse.data?.main_created_at >= "2024-07-01" && (const_var.crmSetting.is_Edit == true || const_var.isKLinkEnable == true) || (const_var.loginSession == false || const_var.loginSession == true) )) ? true : false

            if(const_var.crmSetting.is_Edit == true && const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.request_data !=undefined && const_var.editAPIDataByResponse.data.request_data.building !=undefined && const_var.editAPIDataByResponse.data.request_data.building.create_at_date !=undefined && const_var.editAPIDataByResponse.data.request_data.building.create_at_date<="2024-06-12"){
                isOlderThen12June = true
            }
            if (action.value == 'addFrontLean') {
                state.params.leanF_p_pos = 0;
                state.params.add_front_lean = (action.chkRemoveLean!=undefined)?false:true;
                if(state.params.add_front_lean == false && !isOlderThen12June && (params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) && (params.p_f_w.toLowerCase() == "one_fourth_close" || params.p_f_w.toLowerCase() == "three_fourth_close" || params.p_f_w.toLowerCase() == "half_close")){
                    params.p_f_w = 'Open'
                }
                if (state.params.add_front_lean == true) {
                    //state.params.p_l_w = "Open";
                    params.p_f_b_l = false;
                    ////cuComponent.autoRotateBuilding(state,"Left");
                } else {
                    ////cuComponent.autoRotateBuilding(state,"Front");
                    params.p_f_b_l = true;
                    params.add_storage_check_front = false;
                    const_var.leanFHasDoublelegshow = params.leanF_p_e_l = false;
                    params.insulation.frontLean = {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,  }
                }
                if(state.params.add_front_lean == false){
                    // state.checkwallposition = ""
                    state.checkwallposition = state.params.add_right_lean ? 'right' : state.params.add_left_lean ? 'left' : state.params.add_back_lean ? 'back' : ''
                }
                // params.p_f_w = "Gable";
                // state.params.ShowLeanRecord = (params.add_front_lean == true) ? true : false;
                params.isShowCenter = false;
                const_var.llsh = false;
                const_var.rlsh = false;
                const_var.flsh = false;
                const_var.blsh = false;
                state.params.b_l_t_r_pF = "2";
                state.params.b_f_l_t_f = "Open";
                state.params.b_f_l_t_r = "Open";
                state.params.b_f_l_t_l = "Open";
                state.params.p_b_c_b_f_f = "Open";
                state.params.p_b_c_b_f_b = "Open";
                state.params.p_b_c_b_f_l = "Open";
                state.params.leantoAlignmentFront = "1"
                // state.params.leanF_p_d = 21;
                const_var.checkforLeanto = (state.params.add_front_lean == true) ? true : false;
                state.params.leanF_p_d = state.params.p_w;
                state.params.leanF_p_w = 12
                state.params.leanF_p_h = state.const_var.b_m_i_hlean;
                const_var.lengthData.frontLean.length = state.params.leanF_p_d;
                state.isFullyEnclosedCheckedForFrontLeanTo = false;
                state.isFullyOpenedCheckedForFrontLeanTo = true;
                UpdateAction = action.event + action.value + state.params.add_front_lean;

                if (state.params.add_front_lean == false) {
                    state.params.add_left_front_lean_porch = false
                    state.params.add_right_front_lean_porch = false
                }

                /*------------Write code to increase the main building's height when a lean-to is added. (SE3-I3082) (Start)-----------*/
                let straightRoofval = (params.p_r_p == params.b_l_t_r_pF && !params.singleSlope && params.p_r_s != 1) ? 0 : 1
                var calHeight = state.params.leanF_p_h + Math.round(state.params.leanF_p_w * state.params.b_l_t_r_pF / 12) + straightRoofval;
                let frontLeanRoofHeight = calHeight;

                let isMaxHeight = const_var.roofObject[params.p_b_t][params.p_r_s].max_height
                if(const_var.isForStandardBuilding == true && !const_var.b_o_J_1[params.p_b_t].includes("Free Standing") && !const_var.b_o_J_1[params.p_b_t].includes("RV Covers") && params.p_w <= const_var.roofObject[params.p_b_t][params.p_r_s].max_height){
                    isMaxHeight = params.p_w
                }

                // if (calHeight > state.params.p_h && calHeight <= state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                if (calHeight > state.params.p_h && calHeight <= isMaxHeight) {
                    // state.params.p_h = state.params.leanF_p_h + Math.round(state.params.leanF_p_w * state.params.b_l_t_r_pF / 12);
                    state.params.p_h = ( params.p_h <= frontLeanRoofHeight ) ? frontLeanRoofHeight : state.params.p_h;
                    const_var.UpdatedPriceData.height_price_changed = true;
                    const_var.UpdatedPriceData.certificate_price_changed = true;
                    const_var.UpdatedPriceData.right_wall_price_changed = true;
                    const_var.UpdatedPriceData.left_wall_price_changed = true;
                    const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
                    const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
                    const_var.UpdatedPriceData.front_wall_price_changed = true;
                    const_var.UpdatedPriceData.back_wall_price_changed = true;
                    const_var.UpdatedPriceData.utility_price_changed = true;
                    const_var.UpdatedPriceData.common_height_changed = true;
                    if (params.p_f_i) const_var.UpdatedPriceData.insulation_price = undefined;
                }
                /*------------Write code to increase the main building's height when a lean-to is added. (SE3-I3082) (End)-----------*/


                cuBuilding.UpdateFrontLean();
                makeDimensionUpdateFront(state);
                if(params.p_f_w!="Open" && params.p_f_w!="Close" && chkEndJtrim==true)
                {
                    params.p_j_t_end = true;
                }
                if (cuComponent.wallnameBySec[params.activeWall] === "frontlean" && !params.add_front_lean) params.activeWall = "c_b_f_w";
            }
            if (action.value == 'addBackLean') {
                state.params.leanB_p_pos = 0;
                state.params.add_back_lean = (action.chkRemoveLean!=undefined)?false:true;
                if (state.params.add_back_lean == true) {
                    //state.params.p_l_w = "Open";
                    params.p_b_b_l = false;
                    ////cuComponent.autoRotateBuilding(state,"Left");
                } else {
                    ////cuComponent.autoRotateBuilding(state,"Front");
                    params.p_b_b_l = true;
                    params.add_storage_check_back = false;
                    const_var.leanBHasDoublelegshow = params.leanB_p_e_l = false;
                    params.insulation.backLean = {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,  }
                }
                if(state.params.add_back_lean == false && !isOlderThen12June && (params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) && (params.p_b_w.toLowerCase() == "one_fourth_close" || params.p_b_w.toLowerCase() == "three_fourth_close" || params.p_b_w.toLowerCase() == "half_close")){
                    params.p_b_w = 'Open'
                }
                if(state.params.add_back_lean == false){
                    // state.checkwallposition = ""
                    state.checkwallposition = state.params.add_front_lean ? 'front' : state.params.add_right_lean ? 'right' : state.params.add_left_lean ? 'left' : ''
                }
                // params.p_f_w = "Gable";
                // state.params.ShowLeanRecord = (params.add_back_lean == true) ? true : false;
                params.isShowCenter = false;
                const_var.llsh = false;
                const_var.rlsh = false;
                const_var.flsh = false;
                const_var.blsh = false;
                state.params.b_l_t_r_pB = "2";
                state.params.b_b_l_t_f = "Open";
                state.params.b_b_l_t_r = "Open";
                state.params.b_b_l_t_l = "Open";
                state.params.p_b_c_b_b_f = "Open";
                state.params.p_b_c_b_b_b = "Open";
                state.params.p_b_c_b_b_l = "Open";
                state.params.leantoAlignmentBack = "1"
                // state.params.leanB_p_d = 21;
                state.params.leanB_p_d = state.params.p_w;
                state.params.leanB_p_w = 12
                state.params.leanB_p_h = state.const_var.b_m_i_hlean;
                const_var.lengthData.backLean.length = state.params.leanB_p_d;
                state.isFullyEnclosedCheckedForBackLeanTo = false;
                state.isFullyOpenedCheckedForBackLeanTo = true;
                UpdateAction = action.event + action.value + state.params.add_back_lean;
                const_var.checkforLeanto = (state.params.add_back_lean == true) ? true : false;
                if (state.params.add_back_lean == false) {
                    state.params.add_left_back_lean_porch = false
                    state.params.add_right_back_lean_porch = false
                }

                /*------------Write code to increase the main building's height when a lean-to is added. (SE3-I3082) (Start)-----------*/
                let straightRoofval = (params.p_r_p == params.b_l_t_r_pB && !params.singleSlope && params.p_r_s != 1) ? 0 : 1
                var calHeight = state.params.leanB_p_h + Math.round(state.params.leanB_p_w * state.params.b_l_t_r_pB / 12) + straightRoofval;
                let backLeanRoofHeight = calHeight;
                
                let isMaxHeight = const_var.roofObject[params.p_b_t][params.p_r_s].max_height
                if(const_var.isForStandardBuilding == true && !const_var.b_o_J_1[params.p_b_t].includes("Free Standing") && !const_var.b_o_J_1[params.p_b_t].includes("RV Covers") && params.p_w <= const_var.roofObject[params.p_b_t][params.p_r_s].max_height){
                    isMaxHeight = params.p_w
                }

                // if (calHeight > state.params.p_h && calHeight <= state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                if (state.params.add_back_lean == true && calHeight > state.params.p_h && calHeight <= isMaxHeight) {
                    // state.params.p_h = state.params.leanB_p_h + Math.round(state.params.leanB_p_w * state.params.b_l_t_r_pB / 12);
                    state.params.p_h = ( params.p_h < backLeanRoofHeight ) ? backLeanRoofHeight : state.params.p_h;
                    const_var.UpdatedPriceData.height_price_changed = true;
                    const_var.UpdatedPriceData.certificate_price_changed = true;
                    const_var.UpdatedPriceData.right_wall_price_changed = true;
                    const_var.UpdatedPriceData.left_wall_price_changed = true;
                    const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
                    const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
                    const_var.UpdatedPriceData.front_wall_price_changed = true;
                    const_var.UpdatedPriceData.back_wall_price_changed = true;
                    const_var.UpdatedPriceData.utility_price_changed = true;
                    const_var.UpdatedPriceData.common_height_changed = true;
                    if (params.p_f_i) const_var.UpdatedPriceData.insulation_price = undefined;
                }
                /*------------Write code to increase the main building's height when a lean-to is added. (SE3-I3082) (End)-----------*/

                cuBuilding.UpdateBackLean();
                makeDimensionUpdateBack(state);
                if(params.p_b_w!="Open" && params.p_b_w!="Close" && chkEndJtrim==true)
                {
                    params.p_j_t_end = true;
                }
                if (cuComponent.wallnameBySec[params.activeWall] === "backlean" && !params.add_back_lean) params.activeWall = "c_b_b_w";
            }
            if (action.value == 'addLeftLean') {
                state.params.lean_p_pos = 0;
                state.params.add_left_lean = (action.chkRemoveLean!=undefined)?false:true;
                if(!state.params.add_left_lean) const_var.isStraightRoofL = true
                if (state.params.add_left_lean == true) {
                    //state.params.p_l_w = "Open";
                    params.p_l_b_l = false;
                } else {
                    //cuComponent.autoRotateBuilding(state,"Front");
                    params.p_l_b_l = true;
                    params.add_storage_check = false;
                    const_var.leanHasDoublelegshow = params.lean_p_e_l = false;
                    params.insulation.leftLean = {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,  }
                }
                // console.log(state.isFullyEnclosedChecked ,"state.isFullyEnclosedChecked ");

                if(state.params.add_left_lean == false){
                    // state.checkwallposition = ""
                    state.checkwallposition = state.params.add_front_lean ? 'front' : state.params.add_right_lean ? 'right' : state.params.add_back_lean ? 'back' : ''
                }
                // state.params.ShowLeanRecord = (state.params.add_left_lean == false) ? state.params.add_left_lean : true;
                params.isShowCenter = false;
                const_var.llsh = false;
                const_var.rlsh = false;
                const_var.flsh = false;
                const_var.blsh = false;
                state.params.b_l_t_r_p = checkType ? "3" : "2";
                state.params.b_l_l_t_f = "Open";
                state.params.b_l_l_t_b = "Open";
                state.params.b_l_l_t_l = "Open";


                state.params.p_b_c_b_l_f = "Open";
                state.params.p_b_c_b_l_b = "Open";
                state.params.p_b_c_b_l = "Open";

                state.params.lean_p_w = 12;
                state.params.lean_p_d = state.params.p_d;
                state.params.lean_p_h = state.const_var.b_m_i_hlean;
                const_var.lengthData.leftLean.length = state.params.lean_p_d;
                params.leantoAlignmentLeft = "1" 
                UpdateAction = action.event + action.value + state.params.add_left_lean;
                const_var.checkforLeanto = (state.params.add_left_lean == true) ? true : false;

                if (state.params.add_left_lean == false) {
                    state.params.add_left_front_lean_porch = false
                    state.params.add_left_back_lean_porch = false
                }
                // if (state.isFullyEnclosedChecked == true) {
                state.isFullyEnclosedCheckedForLeftLeanTo = false;
                state.isFullyOpenedCheckedForLeftLeanTo = true;
                //   fullyWallEnclosedLeftLeanTo(state);
                //   // state.params.p_b_c_b_l_f = "Close";
                //   // state.params.p_b_c_b_l_b = "Close";
                //   // state.params.p_b_c_b_l = "Close";
                // }

                /*------------Write code to increase the main building's height when a lean-to is added. (SE3-I3082) (Start)-----------*/
                let straightRoofval = (params.p_r_p == params.b_l_t_r_p && !params.singleSlope && params.p_r_s != 1) ? 0 : 1
                var calHeight = state.params.lean_p_h + Math.round(state.params.lean_p_w * state.params.b_l_t_r_p / 12) + straightRoofval;
                let leftLeanRoofHeight = calHeight;

                let isMaxHeight = const_var.roofObject[params.p_b_t][params.p_r_s].max_height
                if(const_var.isForStandardBuilding == true && !const_var.b_o_J_1[params.p_b_t].includes("Free Standing") && !const_var.b_o_J_1[params.p_b_t].includes("RV Covers") && params.p_w <= const_var.roofObject[params.p_b_t][params.p_r_s].max_height){
                    isMaxHeight = params.p_w
                }

                // if (calHeight > state.params.p_h && calHeight <= state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                if (state.params.add_left_lean == true && calHeight > state.params.p_h && calHeight <= isMaxHeight) {
                    // state.params.p_h = state.params.lean_p_h + Math.round(state.params.lean_p_w * state.params.b_l_t_r_p / 12);
                    state.params.p_h = ( params.p_h < leftLeanRoofHeight ) ? leftLeanRoofHeight : state.params.p_h;
                    const_var.UpdatedPriceData.height_price_changed = true;
                    const_var.UpdatedPriceData.certificate_price_changed = true;
                    const_var.UpdatedPriceData.right_wall_price_changed = true;
                    const_var.UpdatedPriceData.left_wall_price_changed = true;
                    const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
                    const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
                    const_var.UpdatedPriceData.front_wall_price_changed = true;
                    const_var.UpdatedPriceData.back_wall_price_changed = true;
                    const_var.UpdatedPriceData.utility_price_changed = true;
                    const_var.UpdatedPriceData.common_height_changed = true;
                    if (params.p_f_i) const_var.UpdatedPriceData.insulation_price = undefined;
                }
                /*------------Write code to increase the main building's height when a lean-to is added. (SE3-I3082) (End)-----------*/

                cuBuilding.UpdateLeftLean();
                makeDimensionUpdateLeft(state);
                if(params.p_l_w!="Open" && params.p_l_w!="Close" && chkSideJtrim==true)
                {
                    params.p_j_t = true;
                }

                if (cuComponent.wallnameBySec[params.activeWall] === "leftlean" && !params.add_left_lean) params.activeWall = "c_b_l_w";
            }
            if (action.value == 'addRightLean') {
                state.params.leanR_p_pos = 0;
                state.params.add_right_lean = (action.chkRemoveLean!=undefined)?false:true;
                if(!state.params.add_right_lean) const_var.isStraightRoofR = true
                if (state.params.add_right_lean == true) {
                    //state.params.p_r_w = "Open";
                    params.p_r_b_l = false;
                    //cuComponent.autoRotateBuilding(state,"Right");
                } else {
                    params.p_r_b_l = true;
                    params.add_storage_check_right = false;
                    const_var.leanRHasDoublelegshow = params.leanR_p_e_l = false;
                    //cuComponent.autoRotateBuilding(state,"Front");
                    params.insulation.rightLean = { showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,  }
                }
                if(state.params.add_right_lean == false){
                    // state.checkwallposition = ""
                    state.checkwallposition = state.params.add_front_lean ? 'front' : state.params.add_left_lean ? 'left' : state.params.add_back_lean ? 'back' : ''
                }
                state.params.b_l_t_r_pR = checkType ? "3" : "2";
                state.params.b_r_l_t_f = "Open";
                state.params.b_r_l_t_b = "Open";
                state.params.b_r_l_t_r = "Open";
                // state.params.ShowLeanRecord = (state.params.add_left_lean == false) ? state.params.add_right_lean : true;
                params.isShowCenter = false;
                const_var.llsh = false;
                const_var.rlsh = false;
                const_var.flsh = false;
                const_var.blsh = false;
                state.params.p_b_c_b_r_f = "Open";
                state.params.p_b_c_b_r_b = "Open";
                state.params.p_b_c_b_r = "Open";

                state.params.leanR_p_w = 12;
                state.params.leanR_p_d = state.params.p_d;
                state.params.leanR_p_h = state.const_var.b_m_i_hlean;
                const_var.lengthData.rightLean.length = state.params.leanR_p_d;
                params.leantoAlignmentRight = "1"
                UpdateAction = action.event + action.value + state.params.add_right_lean;
                state.isFullyEnclosedCheckedForRightLeanTo = false;
                state.isFullyOpenedCheckedForRightLeanTo = true;
                //cuComponent.autoRotateBuilding(state,"Right");
                const_var.checkforLeanto = (state.params.add_right_lean == true) ? true : false;
                if (state.params.add_right_lean == false) {
                    state.params.add_right_front_lean_porch = false
                    state.params.add_right_back_lean_porch = false
                }

                /*------------Write code to increase the main building's height when a lean-to is added. (SE3-I3082) (Start)-----------*/
                let straightRoofval = (params.p_r_p == params.b_l_t_r_pR && !params.singleSlope && params.p_r_s != 1) ? 0 : 1
                var calHeight = state.params.leanR_p_h + Math.round(state.params.leanR_p_w * state.params.b_l_t_r_pR / 12) + straightRoofval;
                let rightLeanRoofHeight = calHeight;

                let isMaxHeight = const_var.roofObject[params.p_b_t][params.p_r_s].max_height
                if(const_var.isForStandardBuilding == true && !const_var.b_o_J_1[params.p_b_t].includes("Free Standing") && !const_var.b_o_J_1[params.p_b_t].includes("RV Covers") && params.p_w <= const_var.roofObject[params.p_b_t][params.p_r_s].max_height){
                    isMaxHeight = params.p_w
                }

                // if (calHeight > state.params.p_h && calHeight <= state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                if (state.params.add_right_lean == true && calHeight > state.params.p_h && calHeight <= isMaxHeight) {
                    // state.params.p_h = state.params.leanR_p_h + Math.round(state.params.leanR_p_w * state.params.b_l_t_r_pR / 12);
                    state.params.p_h = ( params.p_h < rightLeanRoofHeight ) ? rightLeanRoofHeight : state.params.p_h;
                    const_var.UpdatedPriceData.height_price_changed = true;
                    const_var.UpdatedPriceData.certificate_price_changed = true;
                    const_var.UpdatedPriceData.right_wall_price_changed = true;
                    const_var.UpdatedPriceData.left_wall_price_changed = true;
                    const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
                    const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
                    const_var.UpdatedPriceData.front_wall_price_changed = true;
                    const_var.UpdatedPriceData.back_wall_price_changed = true;
                    const_var.UpdatedPriceData.utility_price_changed = true;
                    const_var.UpdatedPriceData.common_height_changed = true;
                    if (params.p_f_i) const_var.UpdatedPriceData.insulation_price = undefined;
                }
                /*------------Write code to increase the main building's height when a lean-to is added. (SE3-I3082) (End)-----------*/

                cuBuilding.UpdateRightLean();
                makeDimensionUpdateRight(state);
                if(params.p_r_w!="Open" && params.p_r_w!="Close" && chkSideJtrim==true)
                {
                    params.p_j_t = true;
                }
                if (cuComponent.wallnameBySec[params.activeWall] === "rightlean" && !params.add_right_lean) params.activeWall = "c_b_r_w";
            }
            state.params.ShowLeanRecord = (params.add_front_lean == true || params.add_back_lean == true || params.add_left_lean == true || params.add_right_lean == true) ? true : false;

            // const_var.entry_points.map((val, i) => {
            //     if (val.entry_component_location != "fend" && val.entry_component_location != "bend" && val.entry_component_location != "lside" && val.entry_component_location != "rside" && val.entry_component_location != "ufend") {
            //         const_var.scene.getObjectByName(val.component_name + val.uniqueId).visible = (params.isShowCenter == true) ? false : true;
            //     }
            // })

            state.const_var.ExtraItemsFeaturesArray.map(item => {
                if(item!=null && item!=undefined)
                {
                    item.is_edit = false;
                    if (const_var.UpdatedPriceData['elements'] != undefined && const_var.UpdatedPriceData['elements'][item.label.toString()] != undefined && const_var.UpdatedPriceData['elements'][item.label.toString()].is_edit!=true) {
                        const_var.UpdatedPriceData['elements'][item.label.toString()].is_edit = false;
                    }
                }

            });
            state.const_var.ExtraItemsFeaturesQuantityArray.map(item => {
                if(item!=null && item!=undefined)
                {
                    item.is_edit = false;
                    if (item.name == "bows" &&const_var.UpdatedPriceData['elements'] != undefined && const_var.UpdatedPriceData['elements'][item.label.toString()] != undefined && const_var.UpdatedPriceData['elements'][item.label.toString()].is_edit==true) {
                        const_var.UpdatedPriceData['elements'][item.label.toString()].is_edit = false;
                    }
                    if (const_var.UpdatedPriceData['elements'] != undefined && const_var.UpdatedPriceData['elements'][item.label.toString()] != undefined && const_var.UpdatedPriceData['elements'][item.label.toString()].is_edit!=true) {
                        const_var.UpdatedPriceData['elements'][item.label.toString()].is_edit = false;
                    }
                }
            });
            if (state.params.p_v_w == true) {
                const_var.b_I_g_n_e = "building-normal.jpg";
                const_var.b_T_t_L_u = "";
            } else {
                const_var.b_I_g_n_e = "imgpsh_fullsizeth.jpeg";
                const_var.b_T_t_L_u = "";
            }
            if(params.p_i_o!=0)
            {
                const_var.UpdatedPriceData.insulation_price = undefined;
            }
            /*SE3-I4058 under edit mode, insulation wall is coming checked also price is also not coming START*/
            if(!params.add_front_lean && !params.add_back_lean && !params.add_left_lean && !params.add_right_lean){
                if(const_var.post_data?.building?.insulation_type != undefined){
                    if(const_var.post_data.building.insulation=='custom' && const_var.post_data.building.insulation_type.insulation_wall!=undefined)
                    {
                        let checkWallLength = Object.keys(const_var.post_data.building.insulation_type.insulation_wall)
                        if(checkWallLength?.length == 0 && const_var.post_data.building.insulation_type.insulation_wall != undefined){
                            params.p_i_o = 0
                            params.p_c_i = false
                            params.p_r_o = false
                            params.p_f_i = false
                        }
                    }
                }
            }
            /*SE3-I4058 under edit mode, insulation wall is coming checked also price is also not coming END*/
            const_var.UpdatedPriceData.bothLeanto = true;
            const_var.UpdatedPriceData.wainscot_price_changed = true;
            // const_var.UpdatedPriceData.color_price_changed = true;
            const_var.UpdatedPriceData.roof_color_price_changed = true;
            const_var.UpdatedPriceData.wall_color_price_changed = true;
            const_var.UpdatedPriceData.trim_color_price_changed = true;
            const_var.UpdatedPriceData.certificate_price_changed = true;
            
            cuBuilding.uBmLDimension();
            dynamicWallOptions(state, action.value);
            dynamicWallOptionsForLeanTo(state);
            
            cuBuilding.leanuUdD();
            // cuBuilding.uUdDp();
            cuBuilding.BuildingUpdate(true, action.value);
            cuComponent.RemovePorchComponent();
            // if (params.add_left_front_lean_porch == true || params.add_left_back_lean_porch == true || params.add_right_front_lean_porch == true ||params.add_right_back_lean_porch == true){
            // }
            
            if (const_var.callMesure){
            }
            const_var.UpdatedPriceData.connection_fee_side_changed = true;
            if (params.checkeditName != true) {
                let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
                params.other_building_type_name = newVal;
                if (const_var.post_data.building != undefined) {
                    const_var.post_data.building.other_building_type_name = params.other_building_type_name;
                    const_var.post_data.building.name = params.other_building_type_name;
                }
            }
            const_var.wallSelection.centerBuildingWall = "c_b_f_w";
            const_var.wallSelection.leanToWall = "select";
            params.activeWall = "c_b_f_w";
            cuComponent.cameraFocusOnWall("c_b_f_w");

            if(state.params.add_left_lean == false && state.params.add_right_lean == false && state.params.add_front_lean == false && state.params.add_back_lean == false) {
                const_var.commonBuildingFlag.wrap = false
            }
            return {
                ...state,
                newColor: UpdateAction
            }
            break;
        case "addLeantoPorches":

            let maxLeanToRoofPitch = 2;
            // let maxLeanWidth = 12;
            let tempBuildingName = const_var.defaultBuildingArr[const_var.BuldingIDforReset] && const_var.defaultBuildingArr[const_var.BuldingIDforReset]?.image_name.split(".").includes("Straight_Roof_Barns");

            let assignRoofPitch = params.m_s_n == 3 && tempBuildingName && ( ( const_var.editAPIDataByResponse.data?.main_created_at >= "2024-07-01" && (const_var.crmSetting.is_Edit == true || const_var.isKLinkEnable == true) || (const_var.loginSession == false || const_var.loginSession == true) )) ? true : false
    
            if(assignRoofPitch == true){
                state.params.b_l_t_r_p = "3"
                state.params.b_l_t_r_pR = "3" 
                state.params.b_l_t_r_pF = "3"
                state.params.b_l_t_r_pB = "3"
                maxLeanToRoofPitch = "3"
            }
            let maxLeanToHeightArr =[state.params.lean_p_h,state.params.leanF_p_h,state.params.leanB_p_h,state.params.leanR_p_h]
            // let maxLeanRoofPitchArr = [state.params.b_l_t_r_p,state.params.b_l_t_r_pF,state.params.b_l_t_r_pB,state.params.b_l_t_r_pR];
            let maxLeanWidthArr = [state.params.leanF_p_w,state.params.lean_p_w,state.params.leanB_p_w,state.params.leanR_p_w]
            let maxLeanToHeight =  Math.max(...maxLeanToHeightArr);
            // let maxLeanToRoofPitch =  Math.max(...maxLeanRoofPitchArr);
            let maxLeanWidth =  Math.max(...maxLeanWidthArr);
            if(state.const_var.b_m_i_hlean > params.lean_p_h && state.const_var.b_m_i_hlean > params.leanF_p_h && state.const_var.b_m_i_hlean > params.leanB_p_h && state.const_var.b_m_i_hlean > params.leanR_p_h){
                maxLeanToHeight = state.const_var.b_m_i_hlean
            }else{
                maxLeanToHeight =  Math.max(...maxLeanToHeightArr)
            }
            if (action.value ==  "endLeantoPorchessForTubulerBuildingMnf") {           
                const_var.isShowAlert = true;
                const_var.alertUsedFor = "endLeantoPorchessForTubulerBuildingMnf";
                return {
                    ...state,
                    action
                }
            }
            for (const key in params) {
                params.params_cancel[key] = params[key];
            }
            let isHeightChanged = false;
            var chkEndJtrim = false;
            var chkSideJtrim = false;
            if((const_var.a_p_d_a.jtrim) && const_var.a_p_d_a.jtrim.length>0)
            {
                chkEndJtrim = (const_var.a_p_d_a.jtrim.filter(data=>data.type=="end")).length>0?true:false;
                chkSideJtrim = (const_var.a_p_d_a.jtrim.filter(data=>data.type=="side")).length>0?true:false;
            }
            let dimensions = const_var.roof_style_Barn;
            if(const_var.roof_style_Barn_with_centerbuilding[params.p_b_t]) {
                dimensions = const_var.roof_style_Barn_with_centerbuilding[params.p_b_t];
            }
            let minWidth = 0;
            dimensions.map(dim => {
                if (params.p_r_s == dim.roof_id) {
                    minWidth = dim.min_width;
                }
            })
            
            // --------remove this code and add into the full  building wrap case--------//
            // if(params.m_s_n == 122){
            //     state.params.b_l_t_r_p = "3"
            //     state.params.b_l_t_r_pR = "3" 
            //     state.params.b_l_t_r_pF = "3"
            //     state.params.b_l_t_r_pB = "3"
            //     maxLeanToRoofPitch = 3
            // }
            // --------remove this code and add into the full  building wrap case--------//

            if (action.value == 'addLeftFrontLeanToPorch') {

                let frontLeanToLength = Math.round(params.p_w / 2), apiMinLengthNotMatch = false;
                if(action.key != "FullBuilding"){
                    state.params.add_left_front_lean_porch = !state.params.add_left_front_lean_porch;
                    params.lean_p_h = state.const_var.b_m_i_hlean > params.lean_p_h ? state.const_var.b_m_i_hlean : params.lean_p_h;
                }
                if(action.key != undefined && action.key === "FullBuilding"){
                    state.params.leanF_p_w = maxLeanWidth
                    state.params.lean_p_w = maxLeanWidth
                    state.params.leanF_p_d = state.params.p_w
                    state.params.lean_p_d = state.params.p_d
                    state.params.b_l_t_r_pF = (params.m_s_n == 122) ? "3" : maxLeanToRoofPitch
                    state.params.b_l_t_r_p = (params.m_s_n == 122) ? "3" : maxLeanToRoofPitch
                    state.params.leanF_p_h = maxLeanToHeight
                    state.params.lean_p_h =  maxLeanToHeight
                    // state.params.add_left_front_lean_porch = !state.params.add_left_front_lean_porch
                    if(state.params.add_full_lean_porch == true){
                        state.params.add_left_front_lean_porch = true
                    }else{
                        state.params.add_left_front_lean_porch = false
                    }
                }else{
                    state.params.add_full_lean_porch = false
                }
                // params.lean_p_h = state.const_var.b_m_i_hlean > params.lean_p_h ? state.const_var.b_m_i_hlean : params.lean_p_h;
                //   console.log(params.lean_p_h,state.const_var.b_m_i_hlean,"state.const_var.b_m_i_hlean");
                // state.params.add_left_front_lean_porch = !state.params.add_left_front_lean_porch;
                state.params.ShowLeanRecord = (params.add_left_front_lean_porch == true) ? true : state.params.ShowLeanRecord;

                if ((params.add_left_lean == true && params.add_front_lean == true && params.lean_p_w != params.leanF_p_w) ||
                    (params.add_left_lean == true && params.add_front_lean == true && params.b_l_t_r_p != params.b_l_t_r_pF) ||
                    (params.add_left_lean == true && params.add_front_lean == true && params.lean_p_h != params.leanF_p_h)
                ) {
                    // console.log(params.lean_p_h,state.const_var.b_m_i_hlean,"state.const_var.b_m_i_hlean",params.add_left_front_lean_porch);
                    state.params.add_left_front_lean_porch = false;
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YouCanNotAddPorch";
                }
                if (state.params.add_left_front_lean_porch == true) {
                    params.isShowCenter = false;

                    ////////--------------below code we manage the height dynamically according to height and roof pitch of lean-to(previously we assign the height 9 directly which is not correct)-----------////////
                    let maxLeanToHeight = Math.max(params.lean_p_h,params.leanF_p_h);
                    let maxLeanToRoofPitch = Math.max(params.b_l_t_r_p,params.b_l_t_r_pF);
                    let straightRoofval = (params.p_r_p == params.b_l_t_r_p && !params.singleSlope && params.p_r_s != 1) ? 0 : 1

                    if (params.p_h < Math.round(maxLeanToHeight + ((maxLeanToRoofPitch/12)*12)) + straightRoofval) {
                        /////---------when we have calculated height greater than width for SBS, safeguard, heritage, Custom built we take height as it is---------///////////
                        if(const_var.isForStandardBuilding){
                            if(params.p_w >= Math.round(maxLeanToHeight + ((maxLeanToRoofPitch/12)*12)) + straightRoofval){
                                params.p_h = Math.round(maxLeanToHeight + ((maxLeanToRoofPitch/12)*12)) + straightRoofval;
                                params.lean_p_w = 12
                                params.leanF_p_w = 12
                                isHeightChanged = true;
                            }
                        } else {
                            params.p_h = Math.round(maxLeanToHeight + ((maxLeanToRoofPitch/12)*12)) + straightRoofval;
                            params.lean_p_w = 12
                            params.leanF_p_w = 12
                            isHeightChanged = true;
                        }
                    }

                    if (state.params.add_front_lean == false) {
                        state.params.leanF_p_w = (state.params.lean_p_w==0)?12:params.lean_p_w
                        state.params.leantoAlignmentFront = "2"
                        state.params.b_l_t_r_pF = state.params.b_l_t_r_p
                        if ( params.p_w / 2 <= minWidth){
                            frontLeanToLength = minWidth
                            apiMinLengthNotMatch = true;
                        }
                        // state.params.leanF_p_d = Math.round(params.p_w / 2)
                        state.params.leanF_p_d = frontLeanToLength;
                        const_var.lengthData.frontLean.length = state.params.leanF_p_d;
                        params.leanF_p_h = params.lean_p_h
                    }

                    if (state.params.add_left_lean == false) {
                        state.params.lean_p_d = Math.round(params.p_d / 2)
                        state.params.leantoAlignmentLeft = "2"
                        state.params.b_l_t_r_p = state.params.b_l_t_r_pF;
                        //state.params.lean_p_w = params.leanF_p_w;
                        state.params.lean_p_w = (state.params.leanF_p_w==0)?12:params.leanF_p_w;
                        const_var.lengthData.leftLean.length = state.params.lean_p_d;
                        state.params.lean_p_h = state.params.leanF_p_h;
                    }

                    if (params.add_left_lean == true && params.add_front_lean == true && state.params.leanF_p_w != state.params.lean_p_w
                        || params.add_left_lean == true && params.add_front_lean == true && state.params.b_l_t_r_pF != state.params.b_l_t_r_p
                        || params.add_left_lean == true && params.add_front_lean == true && params.lean_p_h != params.leanF_p_h
                        || state.params.add_right_front_lean_porch != true
                        && state.params.leantoAlignmentFront != "2" && (params.p_w != params.leanF_p_d)
                        || params.leantoAlignmentLeft != "2"
                        && params.lean_p_d != params.p_d && params.add_left_back_lean_porch == false
                    ) {
                        state.params.add_left_front_lean_porch = false
                        state.const_var.isShowAlert = true;
                        state.const_var.alertUsedFor = "YouCanNotAddPorch";
                    }


                    if (state.params.add_right_front_lean_porch == true) {
                        state.params.add_front_lean = state.params.add_right_front_lean_porch;
                        state.params.leantoAlignmentFront = "3"
                        state.params.leanF_p_w = state.params.leanR_p_w
                    }

                    if (state.params.leanF_p_w == state.params.lean_p_w && params.leanF_p_h == params.lean_p_h && (state.params.leanF_p_d == Math.round(params.p_w / 2) || apiMinLengthNotMatch) && state.params.leantoAlignmentFront == "2" && state.params.b_l_t_r_pF == state.params.b_l_t_r_p) {
                        state.params.add_front_lean = state.params.add_left_front_lean_porch;
                    }

                    if (state.params.lean_p_d == Math.round(params.p_d / 2) && state.params.leantoAlignmentLeft == "2") {
                        state.params.add_left_lean = state.params.add_left_front_lean_porch;
                    }


                    if (state.params.add_right_front_lean_porch == true && state.params.lean_p_w != state.params.leanR_p_w || state.params.add_right_front_lean_porch == true && state.params.b_l_t_r_p != state.params.b_l_t_r_pR) {
                        state.params.add_left_front_lean_porch = false
                    }

                    if (state.params.add_left_front_lean_porch == true && state.params.add_right_front_lean_porch == true) {
                        state.params.leanF_p_d = state.params.p_w;
                    }

                    if (state.params.add_left_front_lean_porch == true && state.params.add_left_back_lean_porch == true) {
                        state.params.lean_p_d = state.params.p_d;
                    }


                    if (state.params.add_front_lean == false) {
                        state.params.leanF_p_d = state.params.p_w
                        state.params.leantoAlignmentFront = "1"
                        state.params.b_l_t_r_pF = "2"
                        state.params.leanF_p_w = state.params.leanF_p_w
                        params.leanF_p_h = params.lean_p_h
                        state.params.p_b_c_b_f_l = "Open";
                        state.params.p_b_c_b_f_b = "Open";
                        state.params.p_b_c_b_f_f = "Open";
                        state.params.b_f_l_t_f = "Open";
                        state.params.b_f_l_t_l = "Open";
                        state.params.b_f_l_t_r = "Open";

                    }

                    if (state.params.add_left_lean == false) {

                        state.params.leantoAlignmentLeft = "1"
                        //   state.params.b_l_t_r_p = "2";
                        state.params.lean_p_w = state.params.lean_p_w

                        state.params.p_b_c_b_l_f = "Open";
                        state.params.p_b_c_b_l_b = "Open";
                        state.params.p_b_c_b_l = "Open";
                        state.params.b_l_l_t_l = "Open";
                        state.params.b_l_l_t_b = "Open";
                        state.params.b_l_l_t_f = "Open";
                    }
                    if (params.leanF_p_d == params.p_w && !apiMinLengthNotMatch) {
                        params.leantoAlignmentFront = "1"   
                    }
                    if (params.lean_p_d == params.p_d) {
                        params.leantoAlignmentLeft = "1"   
                    }

                }
                const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
                const_var.UpdatedPriceData.front_wall_price_changed = true
                const_var.UpdatedPriceData.left_wall_price_changed = true
                cuBuilding.UpdateLeftLean();
                cuBuilding.UpdateFrontLean();
                makeDimensionUpdateLeft(state);
                makeDimensionUpdateFront(state);


            }
            if (action.value == 'addRightFrontLeanToPorch') {
                let frontLeanToLength = Math.round(params.p_w / 2), apiMinLengthNotMatch = false;
                if(action.key != "FullBuilding"){
                    state.params.add_right_front_lean_porch = !state.params.add_right_front_lean_porch;
                    params.leanR_p_h = state.const_var.b_m_i_hlean > params.leanR_p_h ? state.const_var.b_m_i_hlean : params.leanR_p_h;
                }
                if(action.key != undefined && action.key === "FullBuilding"){                  
                    state.params.leanF_p_w = maxLeanWidth
                    state.params.leanR_p_w = maxLeanWidth
                    state.params.leanB_p_d = state.params.p_w
                    state.params.leanR_p_d = state.params.p_d
                    state.params.b_l_t_r_pF =  (params.m_s_n == 122) ? "3" : maxLeanToRoofPitch
                    state.params.b_l_t_r_pR =  (params.m_s_n == 122) ? "3" : maxLeanToRoofPitch
                    state.params.leanF_p_h = maxLeanToHeight
                    state.params.leanR_p_h = maxLeanToHeight
                    // state.params.add_right_front_lean_porch = !state.params.add_right_front_lean_porch
                    if(state.params.add_full_lean_porch == true){
                        state.params.add_right_front_lean_porch = true
                    }else{
                        state.params.add_right_front_lean_porch = false
                    }
                }else{
                    state.params.add_full_lean_porch = false
                }
                // params.leanR_p_h = state.const_var.b_m_i_hlean > params.leanR_p_h ? state.const_var.b_m_i_hlean : params.leanR_p_h;

                // state.params.add_right_front_lean_porch = !state.params.add_right_front_lean_porch;
                state.params.ShowLeanRecord = (params.add_right_front_lean_porch == true) ? true : state.params.ShowLeanRecord;


                if ((params.add_right_lean == true && params.add_front_lean == true && params.leanR_p_w != params.leanF_p_w) ||
                    (params.add_right_lean == true && params.add_front_lean == true && params.b_l_t_r_pR != params.b_l_t_r_pF) ||
                    (params.add_right_lean == true && params.add_front_lean == true && params.leanR_p_h != params.leanF_p_h)
                ) {
                    state.params.add_right_front_lean_porch = false;
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YouCanNotAddPorch";
                }

                if (state.params.add_right_front_lean_porch == true) {
                    params.isShowCenter = false;

                    ////////--------------below code we manage the height dynamically according to height and roof pitch of lean-to(previously we assign the height 9 directly which is not correct)-----------////////
                    let maxLeanToHeight = Math.max(params.leanR_p_h,params.leanF_p_h);
                    let maxLeanToRoofPitch = Math.max(params.b_l_t_r_pR,params.b_l_t_r_pF);
                    let straightRoofval = (params.p_r_p == params.b_l_t_r_pR && !params.singleSlope && params.p_r_s != 1) ? 0 : 1

                    if (params.p_h < Math.round(maxLeanToHeight + ((maxLeanToRoofPitch/12)*12)) + straightRoofval) {
                        /////---------when we have calculated height greater than width for SBS, safeguard, heritage, Custom built we take height as it is---------///////////
                        if(const_var.isForStandardBuilding){
                            if(params.p_w >= Math.round(maxLeanToHeight + ((maxLeanToRoofPitch/12)*12)) + straightRoofval){
                                params.p_h = Math.round(maxLeanToHeight + ((maxLeanToRoofPitch/12)*12)) + straightRoofval;
                                params.leanR_p_w = 12
                                params.leanF_p_w = 12
                                isHeightChanged = true;
                            }
                        } else {
                            params.p_h = Math.round(maxLeanToHeight + ((maxLeanToRoofPitch/12)*12)) + straightRoofval;
                            params.leanR_p_w = 12
                            params.leanF_p_w = 12
                            isHeightChanged = true;
                        }
                    }

                    if (state.params.add_front_lean == false) {

                        state.params.leanF_p_w = (state.params.leanR_p_w==0)?12:state.params.leanR_p_w;

                        state.params.leantoAlignmentFront = "3"
                        state.params.b_l_t_r_pF = state.params.b_l_t_r_pR
                        params.leanF_p_h = params.leanR_p_h
                        // state.params.leanF_p_d = Math.round(params.p_w / 2)
                        if ( params.p_w / 2 <= minWidth){
                            frontLeanToLength = minWidth
                            apiMinLengthNotMatch = true;
                        }
                        state.params.leanF_p_d = frontLeanToLength;
                        const_var.lengthData.frontLean.length = state.params.leanF_p_d;
                    }

                    if (state.params.add_right_lean == false) {
                        state.params.leanR_p_d = Math.round(params.p_d / 2)
                        const_var.lengthData.rightLean.length = state.params.leanR_p_d;
                        state.params.leantoAlignmentRight = "2"
                        state.params.b_l_t_r_pR = state.params.b_l_t_r_pF;
                        params.leanR_p_h = params.leanF_p_h
                        state.params.leanR_p_w = (state.params.leanF_p_w==0)?12:state.params.leanF_p_w;
                    }

                    if (params.add_right_lean == true && params.add_front_lean == true && state.params.leanF_p_w != state.params.leanR_p_w
                        || params.add_right_lean == true && params.add_front_lean == true && state.params.b_l_t_r_pF != state.params.b_l_t_r_pR
                        || params.add_right_lean == true && params.add_front_lean == true && params.leanR_p_h != params.leanF_p_h
                        || state.params.add_left_front_lean_porch != true && state.params.leantoAlignmentFront != "3" && params.p_w != params.leanF_p_d
                        || params.leantoAlignmentRight != "2" && params.leanR_p_d != params.p_d && params.add_right_back_lean_porch == false
                    ) {
                        state.params.add_right_front_lean_porch = false
                        state.const_var.isShowAlert = true;
                        state.const_var.alertUsedFor = "YouCanNotAddPorch";
                    }


                    if (state.params.add_left_front_lean_porch == true) {
                        state.params.add_front_lean = state.params.add_left_front_lean_porch;
                        state.params.leantoAlignmentFront = "2"
                        state.params.leanF_p_w = state.params.lean_p_w
                    }
                    // else{
                    //     state.params.add_front_lean = state.params.add_right_front_lean_porch;
                    // }

                    if (state.params.leanF_p_w == state.params.leanR_p_w && params.leanF_p_h == params.leanR_p_h &&( state.params.leanF_p_d == Math.round(params.p_w / 2) || apiMinLengthNotMatch )&& state.params.leantoAlignmentFront == "3" && state.params.b_l_t_r_pF == state.params.b_l_t_r_pR) {
                        state.params.add_front_lean = state.params.add_right_front_lean_porch;
                    }


                    if (state.params.leanR_p_d == Math.round(params.p_d / 2) && state.params.leantoAlignmentRight == "2") {
                        state.params.add_right_lean = state.params.add_right_front_lean_porch;
                    }

                    if (state.params.add_left_front_lean_porch == true && state.params.lean_p_w != state.params.leanR_p_w || state.params.add_left_front_lean_porch == true && state.params.b_l_t_r_p != state.params.b_l_t_r_pR) {
                        state.params.add_right_front_lean_porch = false
                    }

                    if (state.params.add_left_front_lean_porch == true && state.params.add_right_front_lean_porch == true) {
                        state.params.leanF_p_d = state.params.p_w
                    }

                    if (state.params.add_right_back_lean_porch == true && state.params.add_right_front_lean_porch == true) {
                        state.params.leanR_p_d = state.params.p_d
                    }

                    if (state.params.add_front_lean == false) {
                        state.params.leanF_p_d = state.params.p_w
                        state.params.leantoAlignmentFront = "1"
                        // state.params.leanF_p_w = state.params.p_w
                        state.params.b_l_t_r_pF = "2"
                        state.params.leanF_p_w = state.params.leanF_p_w

                        state.params.p_b_c_b_f_l = "Open";
                        state.params.p_b_c_b_f_b = "Open";
                        state.params.p_b_c_b_f_f = "Open";
                        state.params.b_f_l_t_f = "Open";
                        state.params.b_f_l_t_l = "Open";
                        state.params.b_f_l_t_r = "Open";

                    }

                    if (state.params.add_right_lean == false) {

                        state.params.leantoAlignmentRight = "1"
                        //   state.params.b_l_t_r_pR = "2"
                        state.params.leanR_p_w = state.params.lean_p_w

                        state.params.p_b_c_b_r_f = "Open";
                        state.params.p_b_c_b_r_b = "Open";
                        state.params.p_b_c_b_r = "Open";
                        state.params.b_r_l_t_r = "Open";
                        state.params.b_r_l_t_b = "Open";
                        state.params.b_r_l_t_f = "Open";
                    }
                    if (params.leanF_p_d == params.p_w && !apiMinLengthNotMatch) {
                        params.leantoAlignmentFront = "1"   
                    }
                    if (params.leanR_p_d == params.p_d) {
                        params.leantoAlignmentRight = "1"   
                    }

                }
                const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
                const_var.UpdatedPriceData.front_wall_price_changed = true
                const_var.UpdatedPriceData.right_wall_price_changed = true
                cuBuilding.UpdateFrontLean();
                cuBuilding.UpdateRightLean();
                makeDimensionUpdateRight(state);
                makeDimensionUpdateFront(state);

            }
            if (action.value == 'addRightBackLeanToPorch') {
                let backLeanToLength = Math.round(params.p_w / 2), apiMinLengthNotMatch = false;
                if(action.key != "FullBuilding"){
                    state.params.add_right_back_lean_porch = !state.params.add_right_back_lean_porch;
                    params.leanR_p_h = state.const_var.b_m_i_hlean > params.leanR_p_h ? state.const_var.b_m_i_hlean : params.leanR_p_h;
                }
                if(action.key != undefined && action.key === "FullBuilding"){
                    state.params.leanB_p_w = maxLeanWidth
                    state.params.leanR_p_w = maxLeanWidth
                    state.params.leanB_p_d = state.params.p_w
                    state.params.leanR_p_d = state.params.p_d
                    state.params.b_l_t_r_pB = (params.m_s_n == 122) ? "3" : maxLeanToRoofPitch 
                    state.params.b_l_t_r_pR = (params.m_s_n == 122) ? "3" : maxLeanToRoofPitch 
                    state.params.leanB_p_h = maxLeanToHeight
                    state.params.leanR_p_h = maxLeanToHeight
                    // state.params.add_right_back_lean_porch = !state.params.add_right_back_lean_porch
                    if(state.params.add_full_lean_porch == true){
                        state.params.add_right_back_lean_porch = true
                    }else{
                        state.params.add_right_back_lean_porch = false
                    }
                }else{
                    state.params.add_full_lean_porch = false
                }
                // params.leanR_p_h = state.const_var.b_m_i_hlean > params.leanR_p_h ? state.const_var.b_m_i_hlean : params.leanR_p_h;
                // state.params.add_right_back_lean_porch = !state.params.add_right_back_lean_porch;
                state.params.ShowLeanRecord = (params.add_right_back_lean_porch == true) ? true : state.params.ShowLeanRecord;

                if ((params.add_right_lean == true && params.add_back_lean == true && params.leanR_p_w != params.leanB_p_w) ||
                    (params.add_right_lean == true && params.add_back_lean == true && params.b_l_t_r_pR != params.b_l_t_r_pB) ||
                    (params.add_right_lean == true && params.add_back_lean == true && params.leanR_p_h != params.leanB_p_h)) {
                    state.params.add_right_back_lean_porch = false;
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YouCanNotAddPorch";
                }

                if (state.params.add_right_back_lean_porch == true) {
                    params.isShowCenter = false;

                    ////////--------------below code we manage the height dynamically according to height and roof pitch of lean-to(previously we assign the height 9 directly which is not correct)-----------////////
                    let maxLeanToHeight = Math.max(params.leanR_p_h,params.leanB_p_h);
                    let maxLeanToRoofPitch = Math.max(params.b_l_t_r_pR,params.b_l_t_r_pB);
                    let straightRoofval = (params.p_r_p == params.b_l_t_r_pR && !params.singleSlope && params.p_r_s != 1) ? 0 : 1

                    if (params.p_h < Math.round(maxLeanToHeight + ((maxLeanToRoofPitch/12)*12)) + straightRoofval) {
                        /////---------when we have calculated height greater than width for SBS, safeguard, heritage, Custom built we take height as it is---------///////////
                        if(const_var.isForStandardBuilding){
                            if(params.p_w >= Math.round(maxLeanToHeight + ((maxLeanToRoofPitch/12)*12)) + straightRoofval){
                                params.p_h = Math.round(maxLeanToHeight + ((maxLeanToRoofPitch/12)*12)) + straightRoofval;
                                params.leanR_p_w = 12
                                params.leanB_p_w = 12
                                isHeightChanged = true;
                            }
                        } else {
                            params.p_h = Math.round(maxLeanToHeight + ((maxLeanToRoofPitch/12)*12)) + straightRoofval;
                            params.leanR_p_w = 12
                            params.leanB_p_w = 12
                            isHeightChanged = true;
                        }
                    }

                    if (state.params.add_back_lean == false) {
                        state.params.leanB_p_w = (state.params.leanR_p_w==0)?12:state.params.leanR_p_w;
                        state.params.leantoAlignmentBack = "2"
                        state.params.b_l_t_r_pB = state.params.b_l_t_r_pR
                        params.leanB_p_h = params.leanR_p_h
                        // state.params.leanB_p_d = Math.round(params.p_w / 2)
                        if ( params.p_w / 2 <= minWidth){
                            backLeanToLength = minWidth;
                            apiMinLengthNotMatch = true;
                        }
                        state.params.leanB_p_d = backLeanToLength;
                        const_var.lengthData.backLean.length = state.params.leanB_p_d;
                    }

                    if (state.params.add_right_lean == false) {
                        state.params.leanR_p_d = Math.round(params.p_d / 2)
                        const_var.lengthData.rightLean.length = state.params.leanR_p_d;
                        state.params.leantoAlignmentRight = "3"
                        state.params.b_l_t_r_pR = state.params.b_l_t_r_pB
                        params.leanR_p_h = params.leanB_p_h
                        state.params.leanR_p_w = (state.params.leanB_p_w==0)?12:state.params.leanB_p_w;
                    }
                    if (params.add_right_lean == true && params.add_back_lean == true && state.params.leanB_p_w != state.params.leanR_p_w
                        || params.add_right_lean == true && params.add_back_lean == true && state.params.b_l_t_r_pB != state.params.b_l_t_r_pR
                        || params.add_right_lean == true && params.add_back_lean == true && params.leanR_p_h != params.leanB_p_h
                        || state.params.add_left_back_lean_porch != true
                        && state.params.leantoAlignmentBack != "2" && params.p_w != params.leanB_p_d
                        || state.params.leantoAlignmentRight != "3" && params.leanR_p_d != params.p_d
                        && params.add_right_front_lean_porch == false
                    ) {
                        state.params.add_right_back_lean_porch = false
                        state.const_var.isShowAlert = true;
                        state.const_var.alertUsedFor = "YouCanNotAddPorch";
                    }

                    if (state.params.add_left_back_lean_porch == true) {
                        state.params.add_back_lean = state.params.add_left_back_lean_porch;
                        state.params.leantoAlignmentBack = "3"
                        state.params.leanB_p_w = state.params.leanR_p_w
                    }


                    if (state.params.leanB_p_w == state.params.leanR_p_w && params.leanB_p_h == params.leanR_p_h && (state.params.leanB_p_d == Math.round(params.p_w / 2) || apiMinLengthNotMatch )&& state.params.leantoAlignmentBack == "2" && state.params.b_l_t_r_pB == state.params.b_l_t_r_pR) {
                        state.params.add_back_lean = state.params.add_right_back_lean_porch;
                    }

                    if (state.params.leanR_p_d == Math.round(params.p_d / 2) && state.params.leantoAlignmentRight == "3") {
                        state.params.add_right_lean = state.params.add_right_back_lean_porch;
                    }

                    if (state.params.add_left_back_lean_porch == true && state.params.lean_p_w != state.params.leanR_p_w || state.params.add_left_back_lean_porch == true && state.params.b_l_t_r_p != state.params.b_l_t_r_pR) {
                        state.params.add_right_back_lean_porch = false
                    }

                    if (state.params.add_left_back_lean_porch == true && state.params.add_right_back_lean_porch == true) {
                        state.params.leanB_p_d = state.params.p_w
                    }

                    if (state.params.add_right_back_lean_porch == true && state.params.add_right_front_lean_porch == true) {
                        state.params.leanR_p_d = state.params.p_d
                    }

                    if (state.params.add_back_lean == false) {
                        state.params.leanB_p_d = state.params.p_w
                        state.params.leantoAlignmentBack = "1"
                        state.params.b_l_t_r_pB = "2"
                        state.params.leanB_p_w = state.params.leanB_p_w

                        state.params.p_b_c_b_b_l = "Open";
                        state.params.p_b_c_b_b_f = "Open";
                        state.params.p_b_c_b_b_b = "Open";
                        state.params.b_b_l_t_f = "Open";
                        state.params.b_b_l_t_l = "Open";
                        state.params.b_b_l_t_r = "Open";
                    }
                    if (state.params.add_right_lean == false) {
                        state.params.leantoAlignmentRight = "1"
                        //   state.params.b_l_t_r_pR = "2"
                        state.params.leanR_p_w = state.params.lean_p_w
                        state.params.p_b_c_b_r_f = "Open";
                        state.params.p_b_c_b_r_b = "Open";
                        state.params.p_b_c_b_r = "Open";
                        state.params.b_r_l_t_r = "Open";
                        state.params.b_r_l_t_b = "Open";
                        state.params.b_r_l_t_f = "Open";
                    }
                    if (params.leanB_p_d == params.p_w && !apiMinLengthNotMatch) {
                        params.leantoAlignmentBack = "1"   
                    }
                    if (params.leanR_p_d == params.p_d) {
                        params.leantoAlignmentRight = "1"   
                    }

                }
                const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
                const_var.UpdatedPriceData.back_wall_price_changed = true
                const_var.UpdatedPriceData.right_wall_price_changed = true
                cuBuilding.UpdateRightLean();
                cuBuilding.UpdateBackLean();
                makeDimensionUpdateRight(state);
                makeDimensionUpdateBack(state);

            }
            if (action.value == 'addLeftBackLeanToPorch') {
                let backLeanToLength = Math.round(params.p_w / 2), apiMinLengthNotMatch = false;
                if(action.key != "FullBuilding"){
                    state.params.add_left_back_lean_porch = !state.params.add_left_back_lean_porch;
                    params.lean_p_h = state.const_var.b_m_i_hlean > params.lean_p_h ? state.const_var.b_m_i_hlean : params.lean_p_h;
                }
                if(action.key != undefined && action.key === "FullBuilding"){             
                    state.params.leanB_p_w = maxLeanWidth
                    state.params.lean_p_w = maxLeanWidth
                    state.params.leanB_p_d = state.params.p_w
                    state.params.lean_p_d = state.params.p_d
                    state.params.b_l_t_r_pB = (params.m_s_n == 122) ? "3" : maxLeanToRoofPitch 
                    state.params.b_l_t_r_p = (params.m_s_n == 122) ? "3" : maxLeanToRoofPitch 
                    state.params.leanB_p_h = maxLeanToHeight 
                    state.params.lean_p_h = maxLeanToHeight
                    // state.params.add_left_back_lean_porch = !state.params.add_left_back_lean_porch
                    if(state.params.add_full_lean_porch == true){
                        state.params.add_left_back_lean_porch = true
                    }else{
                        state.params.add_left_back_lean_porch = false
                    }
                }else{
                    state.params.add_full_lean_porch = false
                }
                // params.lean_p_h = state.const_var.b_m_i_hlean > params.lean_p_h ? state.const_var.b_m_i_hlean : params.lean_p_h;
                // state.params.add_left_back_lean_porch = !state.params.add_left_back_lean_porch;
                state.params.ShowLeanRecord = (params.add_left_back_lean_porch == true) ? true : state.params.ShowLeanRecord;


                if ((params.add_left_lean == true && params.add_back_lean == true && params.lean_p_w != params.leanB_p_w) ||
                    (params.add_left_lean == true && params.add_back_lean == true && params.b_l_t_r_p != params.b_l_t_r_pB) ||
                    (params.add_left_lean == true && params.add_back_lean == true && params.lean_p_h != params.leanB_p_h)
                ) {
                    state.params.add_left_back_lean_porch = false;
                    state.const_var.isShowAlert = true;
                    state.const_var.alertUsedFor = "YouCanNotAddPorch";
                }
                
                if (state.params.add_left_back_lean_porch == true) {
                    params.isShowCenter = false;

                    ////////--------------below code we manage the height dynamically according to height and roof pitch of lean-to(previously we assign the height 9 directly which is not correct)-----------////////
                    let maxLeanToHeight = Math.max(params.lean_p_h,params.leanB_p_h);
                    let maxLeanToRoofPitch = Math.max(params.b_l_t_r_p,params.b_l_t_r_pB);
                    let straightRoofval = (params.p_r_p == params.b_l_t_r_p && !params.singleSlope && params.p_r_s != 1) ? 0 : 1

                    if (params.p_h < Math.round(maxLeanToHeight + ((maxLeanToRoofPitch/12)*12)) + straightRoofval) {
                        /////---------when we have calculated height greater than width for SBS, safeguard, heritage, Custom built we take height as it is---------///////////
                        if(const_var.isForStandardBuilding){
                            if(params.p_w >= Math.round(maxLeanToHeight + ((maxLeanToRoofPitch/12)*12)) + straightRoofval){
                                params.p_h = Math.round(maxLeanToHeight + ((maxLeanToRoofPitch/12)*12)) + straightRoofval;
                                params.lean_p_w = 12
                                params.leanB_p_w = 12
                                isHeightChanged = true;
                            }
                        } else {
                            params.p_h = Math.round(maxLeanToHeight + ((maxLeanToRoofPitch/12)*12)) + straightRoofval;
                            params.lean_p_w = 12
                            params.leanB_p_w = 12
                            isHeightChanged = true;
                        }
                    }

                    if (state.params.add_back_lean == false) {
                        // state.params.leanB_p_d = Math.round(params.p_w / 2)
                        if ( params.p_w / 2 <= minWidth){
                            backLeanToLength = minWidth;
                            apiMinLengthNotMatch = true;
                        }
                        state.params.leanB_p_d = backLeanToLength;
                        const_var.lengthData.backLean.length = state.params.leanB_p_d;
                        state.params.leanB_p_w = (state.params.lean_p_w==0)?12:state.params.lean_p_w;
                        state.params.leantoAlignmentBack = "3"
                        state.params.b_l_t_r_pB = state.params.b_l_t_r_p
                        params.leanB_p_h = params.lean_p_h
                    }

                    if (state.params.add_left_lean == false) {
                        state.params.lean_p_d = Math.round(params.p_d / 2)
                        const_var.lengthData.leftLean.length = state.params.lean_p_d;
                        state.params.leantoAlignmentLeft = "3"
                        state.params.lean_p_w = (state.params.leanB_p_w==0)?12:state.params.leanB_p_w;
                        state.params.b_l_t_r_p = state.params.b_l_t_r_pB
                        params.lean_p_h = params.leanB_p_h
                    }

                    if (params.add_left_lean == true && params.add_back_lean == true && state.params.leanB_p_w != state.params.lean_p_w
                        || params.add_left_lean == true && params.add_back_lean == true && state.params.b_l_t_r_pB != state.params.b_l_t_r_p
                        || params.add_left_lean == true && params.add_back_lean == true && params.lean_p_h != params.leanB_p_h
                        || state.params.add_right_back_lean_porch != true && state.params.leantoAlignmentBack != "3" && params.p_w != params.leanB_p_d
                        || state.params.leantoAlignmentLeft != "3"
                        && params.lean_p_d != params.p_d && params.add_left_front_lean_porch == false
                    ) {
                        state.params.add_left_back_lean_porch = false
                        state.const_var.isShowAlert = true;
                        state.const_var.alertUsedFor = "YouCanNotAddPorch";
                    }

                    if (state.params.add_right_back_lean_porch == true) {
                        state.params.add_back_lean = state.params.add_right_back_lean_porch;
                        state.params.leantoAlignmentBack = "2"
                        state.params.leanB_p_w = state.params.lean_p_w
                    }


                    if (state.params.leanB_p_w == state.params.lean_p_w && params.leanB_p_h == params.lean_p_h &&( state.params.leanB_p_d == Math.round(params.p_w / 2) || apiMinLengthNotMatch )&& state.params.leantoAlignmentBack == "3" && state.params.b_l_t_r_pB == state.params.b_l_t_r_p) {
                        state.params.add_back_lean = state.params.add_left_back_lean_porch;
                    }

                    if (state.params.lean_p_d == Math.round(params.p_d / 2) && state.params.leantoAlignmentLeft == "3") {
                        state.params.add_left_lean = state.params.add_left_back_lean_porch;
                    }

                    if (state.params.add_right_back_lean_porch == true && state.params.lean_p_w != state.params.leanR_p_w || state.params.add_right_back_lean_porch == true && state.params.b_l_t_r_p != state.params.b_l_t_r_pR) {
                        state.params.add_left_back_lean_porch = false;
                    }

                    if (state.params.add_left_back_lean_porch == true && state.params.add_right_back_lean_porch == true) {
                        state.params.leanB_p_d = state.params.p_w
                    }

                    if (state.params.add_left_front_lean_porch == true && state.params.add_left_back_lean_porch == true) {
                        state.params.lean_p_d = state.params.p_d;
                    }

                    if (state.params.add_back_lean == false) {
                        state.params.leanB_p_d = state.params.p_w
                        state.params.leantoAlignmentBack = "1"
                        state.params.leanB_p_w = state.params.leanB_p_w
                        state.params.b_l_t_r_pB = "2"

                        state.params.p_b_c_b_b_l = "Open";
                        state.params.p_b_c_b_b_f = "Open";
                        state.params.p_b_c_b_b_b = "Open";
                        state.params.b_b_l_t_f = "Open";
                        state.params.b_b_l_t_l = "Open";
                        state.params.b_b_l_t_r = "Open";
                    }

                    if (state.params.add_left_lean == false) {

                        state.params.leantoAlignmentLeft = "1"
                        //   state.params.b_l_t_r_p = "2"
                        state.params.lean_p_w = state.params.lean_p_w

                        state.params.p_b_c_b_l_f = "Open";
                        state.params.p_b_c_b_l_b = "Open";
                        state.params.p_b_c_b_l = "Open";
                        state.params.b_l_l_t_l = "Open";
                        state.params.b_l_l_t_b = "Open";
                        state.params.b_l_l_t_f = "Open";
                    }
                    if (params.leanB_p_d == params.p_w && !apiMinLengthNotMatch) {
                        params.leantoAlignmentBack = "1"   
                    }
                    if (params.lean_p_d == params.p_d) {
                        params.leantoAlignmentLeft = "1"   
                    }

                }

                const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
                const_var.UpdatedPriceData.back_wall_price_changed = true
                const_var.UpdatedPriceData.left_wall_price_changed = true
                cuBuilding.UpdateLeftLean();
                cuBuilding.UpdateBackLean();
                makeDimensionUpdateLeft(state);
                makeDimensionUpdateBack(state);
            }
            if(state.params.add_right_front_lean_porch == true &&
                state.params.add_right_back_lean_porch == true &&
                state.params.add_left_front_lean_porch == true &&
                state.params.add_left_back_lean_porch == true)
            {
                state.params.add_full_lean_porch = true
            }
            updatePorchLengths();
            cuComponent.RemovePorchComponent();
            const_var.UpdatedPriceData.bothLeanto = true;
            cuBuilding.uBmLDimension();
            dynamicWallOptions(state);
            dynamicWallOptionsForLeanTo(state);
            cuBuilding.leanuUdD();
            cuBuilding.BuildingUpdate()
            // cuBuilding.uUdDp();
            if (isHeightChanged && params.cupola) cuComponent.handlCupolaPositionOnDimensionChange("h");
            if(params.p_r_w!="Open" && params.p_r_w!="Close" && chkSideJtrim==true)
            {
                params.p_j_t = true;
            }
            if(params.p_l_w!="Open" && params.p_l_w!="Close" && chkSideJtrim==true)
            {
                params.p_j_t = true;
            }
            if(params.p_b_w!="Open" && params.p_b_w!="Close" && chkEndJtrim==true)
            {
                params.p_j_t_end = true;
            }
            if(params.p_f_w!="Open" && params.p_f_w!="Close" && chkEndJtrim==true)
            {
                params.p_j_t_end = true;
            }

            // if (params.p_i_o!=0) {
            //     const_var.UpdatedPriceData.insulation_price = undefined;
            // }
            const_var.UpdatedPriceData.connection_fee_side_changed = true;
            const_var.UpdatedPriceData.wainscot_price_changed = true;
            // const_var.UpdatedPriceData.color_price_changed = true;
            const_var.UpdatedPriceData.roof_color_price_changed = true;
            const_var.UpdatedPriceData.wall_color_price_changed = true;
            const_var.UpdatedPriceData.trim_color_price_changed = true;
            if (params.checkeditName != true) {
                let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
                params.other_building_type_name = newVal;
                if (const_var.post_data.building != undefined) {
                    const_var.post_data.building.other_building_type_name = params.other_building_type_name;
                    const_var.post_data.building.name = params.other_building_type_name;
                }
            }
                const_var.UpdatedPriceData.height_price_changed = true;
            return {
                ...state,
                action
                // newColor:UpdateAction
            }
            break;    
    case "endLeantosForTubulerBuildingMnf":

            return {
                ...state,
                action
            }
            break;     
        case "AddandRemoveComponent":
            if (action.typeMatch == "extra_anchors") {
                if (action.key == "add") {
                    state.const_var.inputs.push({
                        additional_name: '',
                        additional_quantity: ''
                    })

                } if (action.key == "remove") {
                    state.const_var.inputs.splice(action.index, 1);

                    cuBuilding.cP();
                }
            } if (action.typeMatch == "addNewComponent") {
                if (action.key == "add") {
                    state.const_var.Componentinputs.push({
                        additional_name: '',
                        additional_quantity: ''
                    })

                } if (action.key == "remove") {
                    delete state.const_var.Componentinputs.splice(action.index, 1);
                    cuBuilding.cP();
                }
            } if (action.typeMatch == "addMoreTax") {
                if (action.key == "add") {
                    state.const_var.MoreTaxinputs.push({
                        name: '',
                        type: '%',
                        percentage: '',
                    })

                } if (action.key == "remove") {
                    state.const_var.MoreTaxinputs.splice(action.index, 1);
                    cuBuilding.cP();
                }
            }

            return {
                ...state,
                newColor: action.value + action.key + state.const_var.inputs.length + action.index + action.typeMatch + state.const_var.MoreTaxinputs.length + state.const_var.Componentinputs.length
            }
            break;
            case "setPriceCompareForNonLoggedIn": {
                console.log(action,"action")
                if(action.value=='' && action.key=='')
                {
                    let stateId = params.p_s_n;
                     let selectedState = const_var.bjDData.find(state => state.id == stateId);
                     if(selectedState==undefined && params.p_s_n=='')
                     {
                        if(const_var.bjDData != undefined)
                        {
                            stateId = const_var.bjDData[0].id;
                            params.p_s_n = stateId
                            selectedState = const_var.bjDData[0];
                            params.m_s_n = const_var.bjDData[0].manufacturer_list.id
                        }
                     }
                     console.log(selectedState,"stateIdstateIdstateIdstateId",const_var.bjDData,stateId)
                     if(selectedState && !const_var.loginSession && selectedState?.manufacturer_list?.price_comparision?.length > 0) {
                        const key = `selectedState_${stateId}`;
                        state.nonLoggedInpriceCompareData = {
                        ...state.nonLoggedInpriceCompareData,
                        [key]: selectedState?.manufacturer_list?.price_comparision
                        };
                     }
                }else{
                    state.nonLoggedInpriceCompareData = {
                       ...state.nonLoggedInpriceCompareData,
                       [action.key]: action.value
                    };
                }
                console.log(action,"state.nonLoggedInpriceCompareData",params.p_s_n,state.nonLoggedInpriceCompareData)
                return {
                   ...state,
                   newColor : state.nonLoggedInpriceCompareData
                }
             }
             case "discountBannerAction": {
                    // if(action.forAll == "all" && action.value?.data?.data?.results?.length > 0){
                    let selRespFor = action.forAll == "single" || action.value == undefined ? state.discount_Offers_all : action.value.data.data.results
                    if(selRespFor?.length > 0){
                        if(action.forAll == "all"){
                            state.discount_Offers_all = action.value.data.data.results
                            action.value?.data?.data?.results.map((obj) => {

                                obj.offers.length > 0 && obj.offers.forEach((ofr,idx)=>{
                                    obj.offers[idx]['discount_name'] = obj.name
                                    obj.offers[idx]['offer_name'] = obj.offers.length == 1 ? 'Offer ' : 'Offer ' + (idx+1)
                                })
                                if(const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'] == undefined){
                                    const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'] = []
                                }
                                const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][obj.manufacturer_id] = obj.offers;
                                const_var.stateManufacturerNewDiscount[obj.manufacturer_id] = obj.offers;
                                
                                console.log('obj.offers',const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][obj.manufacturer_id]);
                            })
                        }
                        // discount_Offers[0]['discount_name'] = discount_Offers[0].discount_name
                        //         discount_Offers[0]['offer_name'] = appliedOfferId
                    // }else if(action.value?.data?.data?.results?.length > 0 && action.forAll == "single"){
                        let oldDiscount = const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][params.m_s_n]
                        let isChanged = false
                        let num = 0
                        let selRespFor = action.forAll == "single" || action.value == undefined ? state.discount_Offers_all : action.value.data.data.results
                        let mainResp = []
                        let appliedOfferId = ''
                        if(action.forAll == "all"){
                            mainResp = selRespFor.filter((all,idx) => {
                                if(all.manufacturer_id == params.m_s_n){
                                    appliedOfferId = idx+1
                                    return all
                                }
                            }) 
                        }
                        else{
                            mainResp = selRespFor.filter((all) => {
                                if(all.manufacturer_id == action.msnID){
                                    return all
                                }
                            }) 
                        }

                        
                        if(mainResp.length > 0){
                            let discount_banner = false
                            let discount_Offers = ''
                            let discount_Offers_end_date = ''
                            if(mainResp[0].offers.length > 0){

                                discount_banner = true
                                discount_Offers = mainResp
                                discount_Offers_end_date = discount_Offers[0].end_date
                                discount_Offers[0]['discount_name'] = discount_Offers[0].discount_name
                                discount_Offers[0]['offer_name'] = appliedOfferId
                                
                                // state.discount_banner = true
                                // state.discount_Offers = mainResp
                                // state.discount_Offers_end_date = state.discount_Offers[0].end_date
                                
                                // const_var.discount_Offers_end_date  = state.discount_Offers[0].end_date
                                // utils.countDown(state.discount_Offers_end_date, "timer")
                            }
                            if(discount_Offers != undefined && discount_Offers.length > 0){
                                discount_Offers.map((item) => {
                                    if(item?.offers != undefined && item?.offers?.length > 0)
                                    item.offers.forEach((offer) => {
                                    if(offer.amount > num){
                                        num = parseFloat(offer.amount)
                                    } 
                                    })  
                                })
                                if(num > 0){
                                    state.higherOfferPercentage = num
                                }
                            }
                            if(selRespFor?.length > 0 && params.m_s_n != undefined && const_var.ComparisionDataArray == undefined ){
                                const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][params.m_s_n] = discount_Offers[0]?.offers?.length > 0 ? discount_Offers[0]?.offers : [] 
                                isChanged = const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][params.m_s_n] && JSON.stringify(oldDiscount) != JSON.stringify(const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][params.m_s_n]) ? true : false
                            }
                            if(const_var.ComparisionDataArray != undefined && action.msnID != undefined){
                                if(selRespFor?.length > 0  && const_var.ComparisionDataArray != undefined){
                                    const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][action.msnID] = discount_Offers[0]?.offers?.length > 0 ? discount_Offers[0]?.offers : [] 
                                    isChanged =  const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][action.msnID] && JSON.stringify(oldDiscount) != JSON.stringify( const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][action.msnID]) ? true : false
                                }
                            }
                            
                            if(action.isComp == true){
                                const_var.discount_Offers_end_date = discount_Offers_end_date
                                const_var.discount_Offers = discount_Offers
                            }
                            else{
                                state.discount_banner = discount_banner
                                state.discount_Offers = discount_Offers
                                state.discount_Offers_end_date = discount_Offers_end_date
                            }
                        }else{
                            // state.discount_banner = false
                            // // const_var.discount_Offers_end_date  = ''
                            // state.discount_Offers = []
                            // state.higherOfferPercentage = 0
                            // const_var.post_data['building'].freebies = []

                            if(action.isComp){
                                const_var.discount_Offers_end_date = ''
                                const_var.discount_Offers = []
                            }
                            else{
                                state.discount_banner = false
                                // const_var.discount_Offers_end_date  = ''
                                state.discount_Offers = []
                                state.higherOfferPercentage = 0
                                if (const_var.post_data.building != undefined) {
                                    const_var.post_data['building'].freebies = []
                                }
                            }
                            //const_var.post_data['building'].freebies = []
                        }

                        if(state.const_var.crmSetting.is_Edit == true ){
                            cuBuilding.cP()
                        }
                    }else{
                        if(const_var.ComparisionDataArray != undefined && action.msnID != undefined && selRespFor.length > 0){
                            if(selRespFor?.length > 0  && const_var.ComparisionDataArray != undefined){
                                const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][action.msnID] = state?.discount_Offers[0]?.offers?.length > 0 ? state?.discount_Offers[0]?.offers : [] 
                            }
                        }else{
                            state.discount_banner = false
                            state.discount_Offers = []
                            state.higherOfferPercentage = 0
                            if (const_var.post_data.building != undefined) {
                                const_var.post_data.building.freebies = [];
                            }
                        }
                    }
                    if(const_var.stateManufacturerNewDiscount[params.m_s_n]!=undefined)
                        {
                            state.isShowDiscountsPanel = true;
                        }
                return {
                ...state,
                newColor : state.discount_Offers +state.isShowDiscountsPanel + new Date()
                }
            }
             case "STATE_QUOTE_NON_LOGGED_IN_COMPARE": {
                state.nonLoggedInpriceCompareData[action?.key]?.forEach(item => {
                    if(item?.id == action?.manufactureId) {
                        item.manufactureStateQuote = action.value
                    }
                })
                return {
                   ...state,
                   nonLoggedInpriceCompareData:state.nonLoggedInpriceCompareData
                }
             }
            break;
        case "setDealerStateList": {
            if(action.value.is_custom_building == true){
                const_var.is_custom_building = true
            }
            //const_var.estimator_QuestionAnswer = [];
            if (localStorage.getItem('userData') != undefined && const_var.isPublicEdit!=true) {
                const_var.loginSession = true;
                document.querySelector("body").classList.remove('extraoptionnonlogin');
            }
            state.const_var.showProcessLoaderchkEdit = false;
            const_var.bjDData = action.value.data;
            const_var.stateData = action.value

            if(state.const_var.crmSetting.is_Edit == true && const_var.loginSession != true && const_var.crmSetting.is_zipcode_screen != undefined && const_var.crmSetting.is_zipcode_screen == true && const_var.editAPIDataByResponse != undefined) {
                const stateId = const_var.editAPIDataByResponse.data?.request_data?.building.state;
                const selectedState = const_var.bjDData != undefined && const_var.bjDData.find(state => state.id == stateId);
            
                if(selectedState && selectedState?.manufacturer_list?.price_comparision?.length > 0) {
                   const key = `selectedState_${stateId}`;
                  
                   state.nonLoggedInpriceCompareData = {
                        ...state.nonLoggedInpriceCompareData,
                        [key]: [selectedState?.manufacturer_list, ...selectedState?.manufacturer_list?.price_comparision]
                        // [key]: selectedState?.manufacturer_list?.price_comparision
                    };
                }
            }
            if((state.const_var.crmSetting.pre_quote_form != undefined && state.const_var.crmSetting.pre_quote_form == true) || (state.const_var.crmSetting.is_zipcode_screen != undefined && state.const_var.crmSetting.is_zipcode_screen == true)){
                let isAlreadySelect = state.const_var.bjD != undefined && state.const_var.bjD.length > 0 ? (state.const_var.bjD.filter(obj => obj.name == 'Select').length > 0 ? true : false) : false;
                if(isAlreadySelect == false){
                    state.const_var.bjD.push({ "name": "Select", "id": "Select" });
                }

            }
            else{
                state.const_var.bjD.push({ "name": "Select", "id": "Select" });
            }           
            state.const_var.showStateBoxInZipDefault =  (action.value.data!=undefined && action.value.data.length == 1) ? true : false;      
            state.const_var.zipErrDefaultMessage =   action.value.message;      
            for (let i = 0; i < action.value.data.length; i++) {
                state.const_var.bjD[action.value.data[i].id] = { "id": action.value.data[i].id, "name": action.value.data[i].state_name };
                state.const_var.stateNameAcordingAPI[action.value.data[i].id] = action.value.data[i].state_name;
                state.const_var.stateColorAcordingAPI[action.value.data[i].id] = { "wall_color": action.value.data[i].manufacturer_list.wall_color, "roof_color": action.value.data[i].manufacturer_list.roof_color, "trim_color": action.value.data[i].manufacturer_list.trim_color, "garageDoorColor": action.value.data[i].manufacturer_list.garageDoorColor };
                state.const_var.stateManufacturerAcordingAPI[action.value.data[i].id] = action.value.data[i].manufacturer_list;
            }
            const_var.estimator_disclaimer = action.value.estimator_disclaimer;
            const_var.hide_price_calculation = action.value.hide_price_calculation;
            const_var.crmSetting.order_now = action.value.is_online_checkout == 1 ? true : false;
            if (action.value.hide_price_calculation == 1) {
                document.querySelector('body').classList.add("active-hidden-price");
            } else {
                document.querySelector('body').classList.remove("active-hidden-price");
            }
            if(state.params.p_s_n!=undefined && state.const_var.stateNameAcordingAPI[state.params.p_s_n]!=undefined && state.const_var.stateNameAcordingAPI[state.params.p_s_n].length!=undefined && state.params.m_s_n!=undefined){
                let mgfName = (state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n].length>1)?state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n].find(item=>item.id == state.params.m_s_n):state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n]
                if(mgfName!=undefined){
                    params.selectedManufacture = mgfName.name
                }
             }
            if (const_var.crmSetting.is_Edit != true) {
                state.const_var.UpdatedPriceData = { 'roof_style_price_changed': true,'lifttype_price_changed':true,'cupola_price_changed':true, 'width_price_changed': true, 'length_price_changed': true, 'height_price_changed': true, 'left_wall_price_changed': true, 'right_wall_price_changed': true, "right_wall_cut_panel_price_changed": true, "left_wall_cut_panel_price_changed": true, 'front_wall_price_changed': true, 'back_wall_price_changed': true, "certificate_price_changed": true, "common_width_changed": true, "common_length_changed": true, "common_height_changed": true, "utility_price_changed": true, "front_utility_price_changed": true, "wainscot_price_changed": true, "connection_fee_end_changed": true, "connection_fee_side_changed": true, "roof_pitch_price_changed": true,'lifttype_price_changed':true, 'left_lean_roof_style_price_changed': true, 'left_lean_width_price_changed': true, 'left_lean_length_price_changed': true, 'left_lean_height_price_changed': true, 'left_lean_left_wall_price_changed': true, 'left_lean_front_wall_price_changed': true, 'left_lean_back_wall_price_changed': true, "left_lean_certificate_price_changed": true, "left_lean_utility_price_changed": true, "left_lean_roof_pitch_price_changed": true, 'right_lean_roof_style_price_changed': true, 'right_lean_width_price_changed': true, 'right_lean_length_price_changed': true, 'right_lean_height_price_changed': true, 'right_lean_right_wall_price_changed': true, 'right_lean_front_wall_price_changed': true, 'right_lean_back_wall_price_changed': true, "right_lean_certificate_price_changed": true, "right_lean_utility_price_changed": true, "right_lean_roof_pitch_price_changed": true, 'front_lean_roof_style_price_changed': true, 'front_lean_width_price_changed': true, 'front_lean_length_price_changed': true, 'front_lean_height_price_changed': true, 'front_lean_left_wall_price_changed': true, 'front_lean_front_wall_price_changed': true, 'front_lean_back_wall_price_changed': true, "front_lean_certificate_price_changed": true, "front_lean_utility_price_changed": true, "front_lean_roof_pitch_price_changed": true, 'back_lean_roof_style_price_changed': true, 'back_lean_width_price_changed': true, 'back_lean_length_price_changed': true, 'back_lean_height_price_changed': true, 'back_lean_left_wall_price_changed': true, 'back_lean_front_wall_price_changed': true, 'back_lean_back_wall_price_changed': true, "back_lean_certificate_price_changed": true, "back_lean_utility_price_changed": true, "back_lean_roof_pitch_price_changed": true,"color_price_changed":true,"left_front_wrap_connection_fee_changed":true,"right_front_wrap_connection_fee_changed":true,"right_back_wrap_connection_fee_changed":true,"left_back_wrap_connection_fee_changed":true,"front_lean_insulation_price_changed":true,"left_lean_insulation_price_changed":true, "right_lean_insulation_price_changed":true,"back_lean_insulation_price_changed":true, "truss_price_changed": true};
                const_var.estimator_QuestionAnswer = action.value.questions;
                const_var.estimator_DefaultQuestionAnswer = JSON.parse(JSON.stringify(action.value.questions));
                const_var.user_type_for_comparision = (action.value.user_type != undefined) ? action.value.user_type : 'standard';
                const_var.checkUserRole = (action.value.compare != undefined) ? action.value.compare : '';
                const_var.two_d_layuot = action.value.two_d_layuot;
                const_var.feedback_object = action.value['3d_feedback'];
                const_var.price_breakdown_key = action.value.price_breakdown;
                const_var.card_processing_fee = action.value.card_processing_fee;
                if (const_var.card_processing_fee != undefined && Object.keys(const_var.card_processing_fee).length > 0) {
                    const_var.order_extra_items.dont_show_processing_fee_pdf = (const_var.card_processing_fee.add_in == "invoice") ? 2 : 1;
                }
                const_var.order_extra_items.pdf_price_breakdown = const_var.price_breakdown_key[const_var.crmSetting.is_module_name];
            } else {
                const_var.estimator_QuestionAnswer = (const_var.estimator_QuestionAnswer.length > 0) ? const_var.estimator_QuestionAnswer : action.value.questions;
                const_var.estimator_DefaultQuestionAnswer = JSON.parse(JSON.stringify(action.value.questions));
                const_var.two_d_layuot = (const_var.two_d_layuot && Object.keys(const_var.two_d_layuot).length > 0) ? const_var.two_d_layuot : action.value.two_d_layuot;
                const_var.feedback_object = action.value['3d_feedback'];
                const_var.price_breakdown_key = (const_var.price_breakdown_key && Object.keys(const_var.price_breakdown_key).length > 0) ? const_var.price_breakdown_key : action.value.price_breakdown;
                const_var.card_processing_fee = (const_var.card_processing_fee && Object.keys(const_var.card_processing_fee).length > 0) ? const_var.card_processing_fee : action.value.card_processing_fee;
                if (const_var.card_processing_fee != undefined && Object.keys(const_var.card_processing_fee).length > 0) {
                    if(const_var.editAPIDataByResponse!=undefined && Object.keys(const_var.editAPIDataByResponse).length>0 && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.request_data!=undefined)
                    {
                        const_var.order_extra_items.dont_show_processing_fee_pdf = (const_var.editAPIDataByResponse.data.request_data.building.order_extra_items!=undefined)?const_var.editAPIDataByResponse.data.request_data.building.order_extra_items.dont_show_processing_fee_pdf:(const_var.card_processing_fee.add_in == "invoice") ? 2 : 1;
                    }else{
                        const_var.order_extra_items.dont_show_processing_fee_pdf = (const_var.card_processing_fee.add_in == "invoice") ? 2 : 1;
                    }
                    
                }
                const_var.user_type_for_comparision = (action.value.user_type != undefined) ? action.value.user_type : 'standard';
                const_var.checkUserRole = (action.value.compare != undefined) ? action.value.compare : '';
                const_var.order_extra_items.pdf_price_breakdown = (const_var.order_extra_items.pdf_price_breakdown != undefined) ? const_var.order_extra_items.pdf_price_breakdown : const_var.price_breakdown_key[const_var.crmSetting.is_module_name];
                const_var.stateManufacturerAcordingAPIDiscount['commissions'] = [];
                const_var.stateManufacturerAcordingAPIDiscount['surcharge'] = [];
                const_var.stateManufacturerAcordingAPIDiscount['surchargeArray'] = [];
                const_var.stateManufacturerAcordingAPIDiscount['discount'] = [];
                const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'] = [];
                const_var.stateManufacturerAcordingAPIDiscount['manuName'] = [];
                if (const_var.stateManufacturerAcordingAPI[params.p_s_n].length != undefined) {
                    const_var.stateManufacturerAcordingAPI[params.p_s_n].map((val, i) => {
                        const_var.stateManufacturerAcordingAPIDiscount['manuName'][val.id] = val.name;
                        if (val.commissions.length > 0) {
                            const_var.stateManufacturerAcordingAPIDiscount['commissions'][val.id] = val.commissions;
                        } if (val.discounts.length > 0) {
                            const_var.stateManufacturerAcordingAPIDiscount['discount'][val.id] = val.discounts;
                        }
                        if (val.surcharge && Object.keys(val.surcharge).length > 0) {
                            if (val.surcharge.taxable == undefined) {
                                val.surcharge.taxable = 0;
                            }
                            const_var.stateManufacturerAcordingAPIDiscount['surcharge'][val.id] = val.surcharge;
                            const_var.stateManufacturerAcordingAPIDiscount['surchargeArray'][val.id] = val.surcharge;
                        }
                        if (params.m_s_n == val.id) {
                            const_var.order_extra_items['document_fee'] = (val.document_fee != null && const_var.order_extra_items['document_fee'] == 0 && const_var.crmSetting.is_Edit != true) ? val.document_fee : const_var.order_extra_items['document_fee'];
                            const_var.order_extra_items['order_processing_fee'] = (val.order_processing_fee != null && val.order_processing_fee == 0 && const_var.crmSetting.is_Edit != true) ? val.order_processing_fee : const_var.order_extra_items['order_processing_fee']; 

                            const_var.order_extra_items['order_permit_fee'] = (val.order_permit_fee!= null && const_var.crmSetting.is_Edit != true) ? val.order_permit_fee : const_var.order_extra_items['order_permit_fee']!=undefined ? const_var.order_extra_items['order_permit_fee']: 0
                            const_var.exact_order_permit_fee = (val.order_permit_fee!= null && const_var.crmSetting.is_Edit != true) ? val.order_permit_fee : const_var.exact_order_permit_fee
                            if(const_var.order_extra_items['order_permit_fee']!='' && const_var.order_extra_items['order_permit_fee']!=0 && const_var.crmSetting.is_Edit != true){
                                const_var.order_extra_items['permit'] = "yes"
                            }
                            if(const_var.order_extra_items['order_permit_fee']!=undefined && const_var.order_extra_items['order_permit_fee']==0 && const_var.crmSetting.is_Edit == true & const_var.order_extra_items['permit'] == null){
                                const_var.order_extra_items['permit'] = "no"
                            }
                            if((params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9)) && const_var.order_extra_items['permit']== "yes" && const_var.order_extra_items['extra_labour'] != null ){

                                if(const_var.crmSetting.is_module_name == "inventory" && const_var.crmSetting.sub_module == "") {
                                    if(const_var.editAPIDataByResponse.data && const_var.editAPIDataByResponse.data.main_created_at != undefined && const_var.editAPIDataByResponse.data.main_created_at <= "2024-03-18"){
                                        const_var.order_extra_items['extra_labour'] =  const_var.crmSetting.is_Edit != true ? parseFloat(val.labor_fee) : parseFloat(const_var.order_extra_items['extra_labour']) - parseFloat(const_var.exact_order_permit_fee) ;
                                    }else{
                                        const_var.order_extra_items['extra_labour'] =  const_var.crmSetting.is_Edit != true ? parseFloat(val.labor_fee) : parseFloat(const_var.order_extra_items['extra_labour']);
                                    }
                                }else if(const_var.crmSetting.is_module_name == "inventory"  && const_var.crmSetting.duplicate_module == "inventory" && const_var.crmSetting.sub_module == "customer"){
                                    const_var.order_extra_items['extra_labour'] = (val.labor_fee != null && const_var.crmSetting.is_Edit != true) ? parseFloat(const_var.order_extra_items['order_permit_fee']) + parseFloat(val.labor_fee):   parseFloat(const_var.order_extra_items['extra_labour']) - parseFloat(const_var.exact_order_permit_fee);

                                }else if(const_var.crmSetting.is_module_name == "quote" && const_var.crmSetting.sub_module == "" && const_var.crmSetting.duplicate_module == "quote" ){
                                    const_var.order_extra_items['extra_labour'] = (val.labor_fee != null && const_var.crmSetting.is_Edit != true) ? parseFloat(const_var.order_extra_items['order_permit_fee']) + parseFloat(val.labor_fee):  parseFloat(const_var.order_extra_items['extra_labour']) + parseFloat(const_var.exact_order_permit_fee);
                                }else if(const_var.crmSetting.is_module_name == "order" && const_var.crmSetting.sub_module == "customer" && const_var.crmSetting.duplicate_module == "order" ){
                                    const_var.order_extra_items['extra_labour'] = (val.labor_fee != null && const_var.crmSetting.is_Edit != true) ? parseFloat(const_var.order_extra_items['order_permit_fee']) + parseFloat(val.labor_fee):  parseFloat(const_var.order_extra_items['extra_labour']) + parseFloat(const_var.exact_order_permit_fee);
                                } else {                                    
                                    const_var.order_extra_items['extra_labour'] = (val.labor_fee != null && const_var.crmSetting.is_Edit != true) ? parseFloat(const_var.order_extra_items['order_permit_fee']) + parseFloat(val.labor_fee): parseFloat(const_var.order_extra_items['order_permit_fee']) +  parseFloat(const_var.order_extra_items['extra_labour']);
                                }              
                                const_var.order_extra_items['order_permit_fee'] = 0;
                            }else{
                                 const_var.order_extra_items['extra_labour'] = (val.labor_fee != null && const_var.crmSetting.is_Edit != true) ? val.labor_fee : const_var.order_extra_items['extra_labour'];                                
                            }                           
                        }

                        if (val.manufacture_discount!=undefined && val.manufacture_discount.length > 0) {
                            //const_var.stateManufacturerAcordingAPIDiscount['discount'][val.id] = val.discounts;
                            const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][val.id] = val.manufacture_discount;
                        }else{
                            if (val.discounts.length > 0) {
                                const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][val.id] = [];
                                const_var.stateManufacturerAcordingAPIDiscount['discount'][val.id].map((val1, ii) => {
                                    if(val1.manufacturer_discount!=undefined)
                                    {
                                        const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][val.id].push({'amount':val1.manufacturer_discount,'amount_type':val1.manufacturer_discount_in,'price_from':val1.from,'price_to':val1.to})
                                    }

                                })
                            }
                        }

                    })
                } else {
                    
                    let selMfgInfo = const_var.stateManufacturerAcordingAPI[params.p_s_n]
                    if(const_var.stateManufacturerAcordingAPI[params.p_s_n].price_comparision!= undefined && const_var.stateManufacturerAcordingAPI[params.p_s_n].price_comparision.length > 0 && const_var.stateManufacturerAcordingAPI[params.p_s_n].id != params.m_s_n){
                        selMfgInfo = const_var.stateManufacturerAcordingAPI[params.p_s_n].price_comparision.find(obj => obj.id == params.m_s_n)

                        if(selMfgInfo == undefined && (const_var.crmSetting.is_quote_Edit == true || const_var.isInspirationBuilding == true)){
                            state.const_var.isShowAlert = true;
                            state.const_var.alertUsedFor = "NoMfgExsist";
                            selMfgInfo = const_var.stateManufacturerAcordingAPI[params.p_s_n]
                        }
                        // console.log('params.m_s_n',params.m_s_n,const_var.stateManufacturerAcordingAPI[params.p_s_n] ,selMfgInfo);
                    }
                    if(selMfgInfo != undefined && selMfgInfo.id != undefined){
                        const_var.stateManufacturerAcordingAPIDiscount['manuName'][selMfgInfo.id] = selMfgInfo.name;
                    }
                    if (selMfgInfo?.commissions?.length > 0) {
                        const_var.stateManufacturerAcordingAPIDiscount['commissions'][selMfgInfo.id] = selMfgInfo.commissions;
                    } if (selMfgInfo?.discounts?.length > 0) {
                        const_var.stateManufacturerAcordingAPIDiscount['discount'][selMfgInfo.id] = selMfgInfo.discounts;
                    }
                    if (selMfgInfo?.manufacture_discount!=undefined && selMfgInfo.manufacture_discount?.length > 0) {
                        const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][selMfgInfo.id] = selMfgInfo.manufacture_discount;
                    }
                    if(selMfgInfo?.manufacture_discount!=undefined && selMfgInfo.manufacture_discount?.length > 0)
                    {
                        const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][selMfgInfo.id] = selMfgInfo.manufacture_discount;
                    }else{
                        if (selMfgInfo != undefined && const_var.stateManufacturerAcordingAPIDiscount['discount'][selMfgInfo.id]!=undefined && const_var.stateManufacturerAcordingAPIDiscount['discount'][selMfgInfo.id].length > 0) {
                                const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][selMfgInfo.id] = []
                                const_var.stateManufacturerAcordingAPIDiscount['discount'][selMfgInfo.id].map((val1, ii) => {
                                    if(val1.manufacturer_discount!=undefined)
                                    {
                                        const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][selMfgInfo.id].push({'amount':val1.manufacturer_discount,'amount_type':val1.manufacturer_discount_in,'price_from':val1.from,'price_to':val1.to})
                                    }
 
                                })

                            }
                        }
                        const selectedState = const_var.stateData?.data?.find(d => d.id == params.p_s_n);
                        let mfgList = selectedState?.manufacturer_list;
                        if(const_var.isFromCompare && const_var.crmSetting.is_zipcode_screen != undefined && const_var.crmSetting.is_zipcode_screen == true && const_var.loginSession == false){
                            mfgList = selectedState
                        }
                        const priceCompArr = mfgList?.price_comparision || [];
                        if(priceCompArr.length > 0) {
                            priceCompArr.forEach(objval => {
                                const_var.stateManufacturerAcordingAPIDiscount['manuName'][objval.id] = objval.name;
                                if (objval.commissions.length > 0) {
                                    const_var.stateManufacturerAcordingAPIDiscount['commissions'][objval.id] = objval.commissions;
                                } if (objval.discounts.length > 0) {
                                    const_var.stateManufacturerAcordingAPIDiscount['discount'][objval.id] = objval.discounts;
                                }
                                if (objval.surcharge && Object.keys(objval.surcharge).length > 0) {
                                    if (objval.surcharge.taxable == undefined) {
                                        objval.surcharge.taxable = 0;
                                    }
                                    const_var.stateManufacturerAcordingAPIDiscount['surcharge'][objval.id] = objval.surcharge;
                                    const_var.stateManufacturerAcordingAPIDiscount['surchargeArray'][objval.id] = objval.surcharge;
                                }
                                if (objval.manufacture_discount!=undefined && objval.manufacture_discount.length > 0) {
                                    //const_var.stateManufacturerAcordingAPIDiscount['discount'][objval.id] = objval.discounts;
                                    const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][objval.id] = objval.manufacture_discount;
                                }else{
                                    if (objval.discounts.length > 0) {
                                        const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][objval.id] = [];
                                        const_var.stateManufacturerAcordingAPIDiscount['discount'][objval.id].map((val1, ii) => {
                                            if(val1.manufacturer_discount!=undefined)
                                            {
                                                const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][objval.id].push({'amount':val1.manufacturer_discount,'amount_type':val1.manufacturer_discount_in,'price_from':val1.from,'price_to':val1.to})
                                            }
        
                                        })
                                    }
                                }
                            })
                        }
                    if (selMfgInfo?.surcharge && Object.keys(selMfgInfo.surcharge).length > 0) {
                        if (selMfgInfo.surcharge.taxable == undefined) {
                            selMfgInfo.surcharge.taxable = 0;
                        }
                        const_var.stateManufacturerAcordingAPIDiscount['surcharge'][selMfgInfo.id] = selMfgInfo.surcharge;
                        const_var.stateManufacturerAcordingAPIDiscount['surchargeArray'][selMfgInfo.id] = selMfgInfo.surcharge;
                    }
                    if (params.m_s_n == selMfgInfo?.id) {
                        const_var.order_extra_items['document_fee'] = (selMfgInfo.document_fee != null && const_var.order_extra_items['document_fee'] == 0 && const_var.crmSetting.is_Edit != true) ? selMfgInfo.document_fee : const_var.order_extra_items['document_fee'];
                        const_var.order_extra_items['order_processing_fee'] = (selMfgInfo.order_processing_fee != null && selMfgInfo.order_processing_fee == 0 && const_var.crmSetting.is_Edit != true) ? selMfgInfo.order_processing_fee : const_var.order_extra_items['order_processing_fee'];  
                  
                        if(const_var.crmSetting.is_Edit==true && const_var.isKLinkEnable != false)
                        {
                            const_var.stateManufacturerAcordingAPI[params.p_s_n].is_permit_show_in_3d = (selMfgInfo.is_permit_show_in_3d==false)?true:selMfgInfo.is_permit_show_in_3d;

                            const_var.stateManufacturerAcordingAPI[params.p_s_n].is_labor_show_in_3d = (selMfgInfo.is_labor_show_in_3d==false)?true:selMfgInfo.is_labor_show_in_3d;

                            const_var.stateManufacturerAcordingAPI[params.p_s_n].is_document_show_in_3d = (selMfgInfo.is_document_show_in_3d==false)?true:selMfgInfo.is_document_show_in_3d;

                            const_var.stateManufacturerAcordingAPI[params.p_s_n].is_processing_show_in_3d = (selMfgInfo.is_processing_show_in_3d==false)?true:selMfgInfo.is_processing_show_in_3d;

                           
                            if((params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9)) && const_var.order_extra_items['permit']== "yes" && const_var.order_extra_items['extra_labour'] != null){
    
                                if(const_var.crmSetting.is_module_name == "inventory") {
                                    const_var.order_extra_items['extra_labour'] = parseFloat(const_var.order_extra_items['extra_labour']) 
                                } else {
                                    const_var.order_extra_items['extra_labour'] = parseFloat(const_var.order_extra_items['order_permit_fee'])+parseFloat(const_var.order_extra_items['extra_labour'])           
                                }
                            }else{
                                const_var.order_extra_items['extra_labour'] = (const_var.order_extra_items['extra_labour'] != null) ? const_var.order_extra_items['extra_labour'] : 0;
                            }
                            if( const_var.stateManufacturerAcordingAPI[params.p_s_n].is_labor_show_in_3d==false){
                                const_var.order_extra_items['extra_labour'] = 0
                            }
                            if((params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9)) &&  const_var.stateManufacturerAcordingAPI[params.p_s_n].is_labor_show_in_3d==false &&  const_var.stateManufacturerAcordingAPI[params.p_s_n].is_permit_show_in_3d==true){
                                const_var.order_extra_items['extra_labour'] =const_var.order_extra_items['order_permit_fee'];
                                const_var.exact_order_permit_fee =const_var.order_extra_items['order_permit_fee'];
                                const_var.order_extra_items['order_permit_fee'] = 0
                            }

                        }
                      

                    }


                        // let selMfgInfo = const_var.stateManufacturerAcordingAPI[params.p_s_n]
                        // if(const_var.stateManufacturerAcordingAPI[params.p_s_n].price_comparision!= undefined && const_var.stateManufacturerAcordingAPI[params.p_s_n].price_comparision.length > 0 && const_var.stateManufacturerAcordingAPI[params.p_s_n].id != params.m_s_n){
                        //     selMfgInfo = const_var.stateManufacturerAcordingAPI[params.p_s_n].price_comparision.find(obj => obj.id == params.m_s_n)
                        //     console.log('params.m_s_n',params.m_s_n,const_var.stateManufacturerAcordingAPI[params.p_s_n].id ,selMfgInfo);
                        // }
                        // console.log('params.m_s_n',const_var.stateManufacturerAcordingAPI[params.p_s_n]);
                        // const_var.stateManufacturerAcordingAPIDiscount['manuName'][const_var.stateManufacturerAcordingAPI[params.p_s_n].id] = const_var.stateManufacturerAcordingAPI[params.p_s_n].name;
                        // if (const_var.stateManufacturerAcordingAPI[params.p_s_n].commissions.length > 0) {
                        //     const_var.stateManufacturerAcordingAPIDiscount['commissions'][const_var.stateManufacturerAcordingAPI[params.p_s_n].id] = const_var.stateManufacturerAcordingAPI[params.p_s_n].commissions;
                        // } if (const_var.stateManufacturerAcordingAPI[params.p_s_n].discounts.length > 0) {
                        //     const_var.stateManufacturerAcordingAPIDiscount['discount'][const_var.stateManufacturerAcordingAPI[params.p_s_n].id] = const_var.stateManufacturerAcordingAPI[params.p_s_n].discounts;
                        // }
                        // if (const_var.stateManufacturerAcordingAPI[params.p_s_n].manufacture_discount!=undefined && const_var.stateManufacturerAcordingAPI[params.p_s_n].manufacture_discount.length > 0) {
                        //     const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][const_var.stateManufacturerAcordingAPI[params.p_s_n].id] = const_var.stateManufacturerAcordingAPI[params.p_s_n].manufacture_discount;
                        // }
                        // if(const_var.stateManufacturerAcordingAPI[params.p_s_n].manufacture_discount!=undefined && const_var.stateManufacturerAcordingAPI[params.p_s_n].manufacture_discount.length > 0)
                        // {
                        //     const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][const_var.stateManufacturerAcordingAPI[params.p_s_n].id] = const_var.stateManufacturerAcordingAPI[params.p_s_n].manufacture_discount;
                        // }else{
                        //     if (const_var.stateManufacturerAcordingAPIDiscount['discount'][const_var.stateManufacturerAcordingAPI[params.p_s_n].id]!=undefined && const_var.stateManufacturerAcordingAPIDiscount['discount'][const_var.stateManufacturerAcordingAPI[params.p_s_n].id].length > 0) {
                        //             const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][const_var.stateManufacturerAcordingAPI[params.p_s_n].id] = []
                        //             const_var.stateManufacturerAcordingAPIDiscount['discount'][const_var.stateManufacturerAcordingAPI[params.p_s_n].id].map((val1, ii) => {
                        //                 if(val1.manufacturer_discount!=undefined)
                        //                 {
                        //                     const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][const_var.stateManufacturerAcordingAPI[params.p_s_n].id].push({'amount':val1.manufacturer_discount,'amount_type':val1.manufacturer_discount_in,'price_from':val1.from,'price_to':val1.to})
                        //                 }
     
                        //             })
                        //         }
                        // }
                        // if (const_var.stateManufacturerAcordingAPI[params.p_s_n].surcharge && Object.keys(const_var.stateManufacturerAcordingAPI[params.p_s_n].surcharge).length > 0) {
                        //     if (const_var.stateManufacturerAcordingAPI[params.p_s_n].surcharge.taxable == undefined) {
                        //         const_var.stateManufacturerAcordingAPI[params.p_s_n].surcharge.taxable = 0;
                        //     }
                        //     const_var.stateManufacturerAcordingAPIDiscount['surcharge'][const_var.stateManufacturerAcordingAPI[params.p_s_n].id] = const_var.stateManufacturerAcordingAPI[params.p_s_n].surcharge;
                        //     const_var.stateManufacturerAcordingAPIDiscount['surchargeArray'][const_var.stateManufacturerAcordingAPI[params.p_s_n].id] = const_var.stateManufacturerAcordingAPI[params.p_s_n].surcharge;
                        // }
                        // if (params.m_s_n == const_var.stateManufacturerAcordingAPI[params.p_s_n].id) {
                        //     const_var.order_extra_items['document_fee'] = (const_var.stateManufacturerAcordingAPI[params.p_s_n].document_fee != null && const_var.order_extra_items['document_fee'] == 0 && const_var.crmSetting.is_Edit != true) ? const_var.stateManufacturerAcordingAPI[params.p_s_n].document_fee : const_var.order_extra_items['document_fee'];
                        //     const_var.order_extra_items['order_processing_fee'] = (const_var.stateManufacturerAcordingAPI[params.p_s_n].order_processing_fee != null && const_var.stateManufacturerAcordingAPI[params.p_s_n].order_processing_fee == 0 && const_var.crmSetting.is_Edit != true) ? const_var.stateManufacturerAcordingAPI[params.p_s_n].order_processing_fee : const_var.order_extra_items['order_processing_fee'];  
                      
                        //     if(const_var.crmSetting.is_Edit==true && const_var.isKLinkEnable != false)
                        //     {
                        //         state.const_var.stateManufacturerAcordingAPI[params.p_s_n].is_permit_show_in_3d = (state.const_var.stateManufacturerAcordingAPI[params.p_s_n].is_permit_show_in_3d==false)?true:state.const_var.stateManufacturerAcordingAPI[params.p_s_n].is_permit_show_in_3d;
    
                        //         const_var.stateManufacturerAcordingAPI[params.p_s_n].is_labor_show_in_3d = (const_var.stateManufacturerAcordingAPI[params.p_s_n].is_labor_show_in_3d==false)?true:const_var.stateManufacturerAcordingAPI[params.p_s_n].is_labor_show_in_3d;
    
                        //         const_var.stateManufacturerAcordingAPI[params.p_s_n].is_document_show_in_3d = (const_var.stateManufacturerAcordingAPI[params.p_s_n].is_document_show_in_3d==false)?true:const_var.stateManufacturerAcordingAPI[params.p_s_n].is_document_show_in_3d;
    
                        //         const_var.stateManufacturerAcordingAPI[params.p_s_n].is_processing_show_in_3d = (const_var.stateManufacturerAcordingAPI[params.p_s_n].is_processing_show_in_3d==false)?true:const_var.stateManufacturerAcordingAPI[params.p_s_n].is_processing_show_in_3d;
    
                               
                        //         if((params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9)) && const_var.order_extra_items['permit']== "yes" && const_var.order_extra_items['extra_labour'] != null){
        
                        //             if(const_var.crmSetting.is_module_name == "inventory") {
                        //                 const_var.order_extra_items['extra_labour'] = parseFloat(const_var.order_extra_items['extra_labour']) 
                        //             } else {
                        //                 const_var.order_extra_items['extra_labour'] = parseFloat(const_var.order_extra_items['order_permit_fee'])+parseFloat(const_var.order_extra_items['extra_labour'])           
                        //             }
                        //         }else{
                        //             const_var.order_extra_items['extra_labour'] = (const_var.order_extra_items['extra_labour'] != null) ? const_var.order_extra_items['extra_labour'] : 0;
                        //         }
                        //         if(const_var.stateManufacturerAcordingAPI[params.p_s_n].is_labor_show_in_3d==false){
                        //             const_var.order_extra_items['extra_labour'] = 0
                        //         }
                        //         if((params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9)) && const_var.stateManufacturerAcordingAPI[params.p_s_n].is_labor_show_in_3d==false && const_var.stateManufacturerAcordingAPI[params.p_s_n].is_permit_show_in_3d==true){
                        //             const_var.order_extra_items['extra_labour'] =const_var.order_extra_items['order_permit_fee'];
                        //             const_var.exact_order_permit_fee =const_var.order_extra_items['order_permit_fee'];
                        //             const_var.order_extra_items['order_permit_fee'] = 0
                        //         }
    
                        //     }
                          
    
                        // }
                }
            } 
            return {
                ...state,
                action,
                newColor: state.const_var.bjD
            }
        }
            break;

        case "commonsActionforAttribute":
            let UpdateVal = "";
            if (action.key == "Tax") {
                state.params.tax_exempt = !state.params.tax_exempt;
                UpdateVal = state.params.tax_exempt;
                const_var.tax = { "percentage": 0, "type": "%", "name": '', "amount": 0 };
                state.params.tax_zipcode = action.setZipCode != '' ? action.setZipCode : "";
                const_var.MoreTaxinputs = [];
                cuBuilding.cP();
            }
            return {
                ...state,
                newColor: action.value + action.key + UpdateVal
            }
            break;
        case "callTaxApiAndCalculatePrice":
            let newFlag = 0;
            if (action.key == "add_zipcode") {
                if (state.const_var.LeadCustomerData.showZip != undefined) {
                    state.const_var.LeadCustomerData.showZip = action.value;
                }
                state.params.tax_zipcode = action.value;
                if (action.value == '' || action.value.length < 4) {
                    state.const_var.tax.amount = 0;
                    const_var.post_data['building'].tax_amount = 0;
                    const_var.UpdatedPriceData.tax_amount = 0;
                    state.const_var.tax.type = (state.const_var.tax.type == "amt") ? "per" : state.const_var.tax.type;
                }
                state.const_var.tax.percentage = 0;
                if (isNaN(parseInt(state.const_var.tax.amount)) == true) {
                    state.const_var.tax.amount = 0;
                }
                if(state.const_var.tax.percentage==0)
                {
                    const_var.MoreTaxinputs = [];
                    cuBuilding.cP();
                }
            } else {
                state.const_var.tax.percentage = (action.value.data != undefined && action.value.data.length>0) ? action.value.data[0] : 0;
                state.const_var.tax.type = (state.const_var.tax.type == "amt") ? "per" : state.const_var.tax.type;
                if (action.value.data != undefined && action.value.data.length>0){
                     state.const_var.tax.tax_value = action.value.data[0];
                }else{
                    state.const_var.tax.tax_value = 0;
                    state.const_var.tax.amount = 0;
                }
                if(action.newvalue!=undefined && action.newvalue!='')
                {
                    const sortOrder = {
                        "county_rate": 1,
                        "city_rate": 2,
                        "local_rate":3,
                        "state_rate": 4,
                        "surtax_rate": 5,
                        "special_dist_rate":6
                     };
                     const taxTypesArray = Object.entries(action.newvalue).map(([key, value]) => ({ key, value }));

                      // Sort the tax types array based on the sorting order
                      taxTypesArray.sort((a, b) => sortOrder[a.key] - sortOrder[b.key]);

                      // Create a new object with the sorted tax type names
                      const sortedTaxTypes = {};
                      taxTypesArray.forEach(item => {
                          sortedTaxTypes[item.key] = item.value;
                      });


                    let i = 0;
                    Object.entries(action.newvalue).sort().map(([value, key])=>{
                        if(key!=0)
                        {
                            if(i==0)
                            {
                                state.const_var.tax.percentage = key;
                                state.const_var.tax.tax_value = key;
                                state.const_var.tax.name = const_var.taxTypeName[value];
                            }else{
                                const_var.MoreTaxinputs.push({'amount':0,'name':const_var.taxTypeName[value],'percentage':key,'type':'per'})
                            }

                            i++;
                        }
                        newFlag = i+key+value+newFlag;
                        
                    })
                    //state.const_var.tax.name = action.value.data.tax_data.city_rate!=0?action.value.data.tax_data.city_rate:action.value.data.tax_data.county_rate;
                }
                // console.log(state.const_var.tax,"state.const_var.tax")
                if (isNaN(parseInt(state.const_var.tax.amount)) == true) {
                    state.const_var.tax.amount = 0;
                }
                cuBuilding.cP();
            }
            return {
                ...state,
                newColor: action + const_var.LeadCustomerData.showZip + params.tax_zipcode + const_var.tax.amount + const_var.tax.percentage+const_var.MoreTaxinputs.length+newFlag
            }
            break;
        case "ShowMeasure":
            if(action.key != undefined && action.key == "save"){
                state.const_var.callMesure = false;
            }else{
                state.const_var.callMesure = !state.const_var.callMesure;
                const_var.crmSetting.is_show_wall_lable = const_var.callMesure;
            }
            return {
                ...state,
                newColor: state.const_var.callMesure
            }
        case "isOpenBookaDemo":
                if(const_var.crmSetting.main_domain_url=="Walkerbuildings.com"){
                    if(action.value == true){
                        document.querySelector('.walk-checkout-modal').scrollTo({ 
                            top: 0,  
                            behavior: 'auto'
                            });                            
                            // document.querySelector('.walk-checkout-modal').style.overflowY = "hidden";                           
                            }
                    else{
                        // document.querySelector('.walk-checkout-modal').style.overflowY = "auto";
                    }
                }
            state.const_var.isOpenMeeting = action.value;
            return {
                ...state,
                newColor: action.value
            }
            break;
            
            case "UsertourAction":   
            // const checkfullscreen = document.querySelector('.active-fullview'); 
            // if(checkfullscreen!=null) {
            //     document.querySelector('.full-view-cntroler a').click();
            // } 
            state.const_var.iswelcomeModal=false;     
            state.const_var.isOpenUserTour = action.value;
            state.const_var.startTourNumber = action.opennumber;
            state.const_var.currentStepTour = +action.key+1;      
            return {
                ...state,
                newColor: action.value + action.key +  action.opennumber
            }
            break;

             case "isOpenWelcomeModal":        
                 state.const_var.iswelcomeModal = action.value; 
                 if(action.key=='actionclose') {
                    localStorage.setItem('WelcomePopupClosed', 'true'); 
                 }
                  
            return {
                ...state,
                newColor: action.value + action.key
            }
            break;       

             case "isOpenLayoutDesignModal":       
                 state.const_var.isLayoutDesign = action.value;                  
                  
            return {
                ...state,
                newColor: action.value + action.key
            }
            break;
        case "defaultBuildingArrData":
            console.log(action, "defaultBuildingArrData")
            const_var.defaultBuildingArr = action.val;
            state.defaultBuilding = action.val[0]?.id;
            return {
                ...state,action
            }
            break;            

        // case "handleTabsClick":            
        // state.activemaintabkey = action.key;
        // state.const_var.activemaintabkey =  action.key;
        // if (const_var.activemaintabkey == "doorwindow") {
        //     state.params.activeWall = "c_b_f_w";
        //     state.activeWall = "c_b_f_w";
        //     state.const_var.wallSectionTab = "Center Building";
        //     cuComponent.cameraFocusOnWall(state, state.params.activeWall);
        // } else {
        //     // const_var.scene.traverse((child) => {
        //     //     if (!params.is_translusant) {
        //     //         if (child.type === "Mesh") {
        //     //             child.material.transparent = false;
        //     //             child.material.opacity = 1;
        //     //             child.material.depthWrite = true;
        //     //         }
        //     //     }
        //     // })
        // }
        //     return {
        //         ...state,action
        //     }
        //     break;

        case "changeWallName":            
            state.checkwallposition = action.key;
                return {
                    ...state,action
                }
                break;

        case "changeWrapSide": 
            if(action.key === 'FullBuilding'){
                state.params.add_full_lean_porch = !state.params.add_full_lean_porch
            // }else{
            //     state.params.add_full_lean_porch = false
            }            
            state.checkwrapside = action.key;
            return {
                ...state,action
            }
            break;
        case "deleteLeanTo":
            state.const_var.isShowAlert = !state.const_var.isShowAlert;
            state.const_var.alertUsedFor = "REMOVEPOSITIONCOMPONENT";
            break;
        case "moredetail":
            state.const_var.isShowMoreDetail = !state.const_var.isShowMoreDetail;
            if(state.const_var.isShowMoreDetail == true){
                document.querySelector('body').classList.add("active-summary-popup");       
            }else{
                document.querySelector('body').classList.remove("active-summary-popup");       
            }
            break; 
        case "TALKEXPERT":
            state.const_var.isShowTalkExpert = !state.const_var.isShowTalkExpert;
            state.const_var.isShowConnectBox = action.key;
            state.const_var.orderSaveForm = true
            break;
        case "SHOWSHARE":
            state.const_var.isShowShare = !state.const_var.isShowShare;
            break;
        case "ShowSavelater":
            if(action.value == "pdf"){
                if(action.key == true){
                    const_var.i_g_A_y = []
                }
                state.const_var.isShowSaveLaterForPdf = action.key;
            }
            if(action.value == "form"){
                state.const_var.isShowSaveLater = action.key;
            }
            if(action.key == false){
                state.const_var.orderSaveForm = false
            }
            break;
        case "SHOWIMAGE":
            state.const_var.isShowImage = action.key;
            break;
        case "SHOWDOWNLOADPROGRESSBAR":
            state.const_var.isShowDownloadProgressBar = !state.const_var.isShowDownloadProgressBar;
            break;
        case "SHOWSAVETHANK":
            state.const_var.isShowTalkExpert === true && (state.const_var.isShowTalkExpert = !state.const_var.isShowTalkExpert)
            state.const_var.isShowCallForPricing === true && (state.const_var.isShowCallForPricing = !state.const_var.isShowCallForPricing)
            if(action.key != undefined && action.key == "show" ){
                state.const_var.isShowSaveThankBox = !state.const_var.isShowSaveThankBox;
                if(state.const_var.isShowSaveThankBox && const_var.crmSetting.main_domain_url == "probuiltsteel.com"){
                    window.open("https://www.probuiltsteel.com/thank-you-order-confirmation/", "_self")
                }
            }else{
                state.const_var.isShowThankBox = !state.const_var.isShowThankBox
                if(state.const_var.isShowThankBox && const_var.crmSetting.main_domain_url == "probuiltsteel.com"){
                    window.open("https://www.probuiltsteel.com/thank-you-order-confirmation/", "_self")
                }
            }
            state.const_var.checkValidate = true;
            state.const_var.orderSaveForm = false;
            break;
        case "CALLFORPRICING":
            state.const_var.isShowTalkExpert === true && (state.const_var.isShowTalkExpert = !state.const_var.isShowTalkExpert)
            state.const_var.isShowCallForPricing = !state.const_var.isShowCallForPricing;
            break;
        case "WALLSECTIONTAB":
            state.const_var.wallSectionTab = action.value;

            const activeWall = action.wallSection == "centerbuilding" ? "c_b_f_w" : action.wallSection == "centerbuildingStorage" ? params.p_u_c == true ? "c_b_f_s_w" : "c_b_f_w" : state.activeLeanWalls[action.wallSection];
            if (state.const_var.wallSectionTab != "close") {
                state.params.activeWall = activeWall
                cuComponent.cameraFocusOnWall(state, state.params.activeWall);
            } else {
                const_var.scene.traverse((child) => {
                    if (!params.is_translusant) {
                        if (child.type === "Mesh") {
                            child.material.transparent = false;
                            child.material.opacity = 1;
                            child.material.depthWrite = true;
                        }
                    }
                })
            }
            break;
        case "changeActiveWall":
            // state.activeWall = action.value;
            state.params.activeWall = action.value;
            return {
                ...state,
                action
            }
        case "changeActiveLeanWall":
            if(action.key == "leftlean") {
                state.activeLeanWalls = {...state.activeLeanWalls, "leftlean" : action.value}
            };
            if(action.key == "rightlean") {
                state.activeLeanWalls = {...state.activeLeanWalls, "rightlean" : action.value}
            }
            if(action.key == "frontlean") {
                state.activeLeanWalls = {...state.activeLeanWalls, "frontlean" : action.value}
            }
            if(action.key == "backlean") {
                state.activeLeanWalls = {...state.activeLeanWalls, "backlean" : action.value}
            }

            state.params.activeWall = action.value;
            
            return {...state,action}

        case "getCarportPricingData":
                if(action.response.status == true) {
                    state.carportDirectData = action.response.data
                    // setBuildingData(state, action.response, state.defaulProductLoad)
                    state.defaultBuilding = action.response.data.building_data?.default_building[0]
                    // state.defaultBuilding["wainscot_color"] = state.defaultBuilding.wall_color
                    state.buildingDimension = {
                        "min_width" : action.response.data.pricing_data?.building_structure[0]?.min_width,
                        "max_width" : action.response.data.pricing_data?.building_structure[0]?.max_width,
                        "min_height" :action.response.data.pricing_data?.building_structure[0]?.min_height,
                        "max_height" : action.response.data.pricing_data?.building_structure[0]?.max_height,
                        "min_length" : action.response.data.pricing_data?.building_structure[0]?.start_length,
                        "max_length" : action.response.data.pricing_data?.building_structure[0]?.end_length,
                    }

                    state.buildingStructure = action.response.data.pricing_data?.building_structure[0];

                    state.legsData = action.response.data.pricing_data?.building_structure[0].conditions.condition

                    state.legsData = action.response.data.pricing_data?.building_structure[0].conditions.condition

                    let colorScrewData = action.response.data.pricing_data?.additional_features.filter((item) => item.additional_feature == "Colored Screws");
                    if(colorScrewData.length > 0) {
                        state.isColoredScrew = true
                    } else {
                        state.isColoredScrew = false
                    }
                }

                    if(Object.keys(state.carportDirectData).length>0 && state.carportDirectData.building_data !=undefined){
                        Object.entries(state.carportDirectData.building_data?.building[0]).map(([key,value])=>{
                            if(key  == "garage_door"){
                                state.doorSizesData = value
                                state.doorDataType = "garage_door";
                                let setdoorComponent =  [
                                        ...state.doorComponent,
                                            {
                                                "id":const_var.componentCount.door,
                                                "type":key,
                                                "sizes":value, 
                                            }
                                ]
                                state.doorComponent = setdoorComponent
                            }
                            if(key  == "window_frameout"){
                                state.windowSizesData = value
                                state.windowDataType = "window_frameout"
                                let setWindowComponent =  [
                                    ...state.windowComponent,
                                        {
                                            "id":const_var.componentCount.window,
                                            "type":key,
                                            "sizes":value, 
                                        }
                                ]
                                state.windowComponent = setWindowComponent
                            }
                            if(key.includes("door")){
                                state.doorData[key] = []
                                state.doorData[key].push(value)
                            } 
                            if(key.includes("window")){
                                state.windowData[key] = []
                                state.windowData[key].push(value)
                            }    
                        })                   
                    }
                console.log(" state.carportDirectData;" ,state.carportDirectData)
            return {
                ...state,
                action
            }
        case "showMoreLessSidesAndEnds":
            showMoreLess(action.position);
            return {
                ...state,
                action
            }
        case "toggleCustomCheckboxChange":
            if(action.key == "centerBuilding"){
                const_var.setSidesEndsWallOption = "partial"
            }
            if(action.key == "frontLeanto"){
                const_var.setLeanWallOption.frontLean = 'partial'
            }
            if(action.key == "backLeanto"){
                const_var.setLeanWallOption.backLean = 'partial'
            }
            if(action.key == "leftLeanto"){
                const_var.setLeanWallOption.leftLean = 'partial'
            }
            return {
                ...state,
                action
            }
        case 'setDoorDataType':

                state.doorDataType = action.value 
                state.doorComponent.map((data,index)=>{
                    if(action.item == index){
                        data.type = action.value
                        if(action.value == "garage_door_frameout"){
                            let lastindex = state.doorData[action.value][0].findLastIndex((i)=>i);
                            state.doorSizesData = Array.from({ length: Number(state.doorData[action.value][0][lastindex].frame_out_length.split('-')[1]) - Number(state.doorData[action.value][0][0].frame_out_length.split('-')[0]) +  1 }, (_, i) => i + Number(state.doorData[action.value][0][0].frame_out_length.split('-')[0]));
                            data.sizes = state.doorSizesData
                        }else{
                            data.sizes = state.doorData[action.value][0]
                            state.doorSizesData = state.doorData[action.value][0]
                        }
                    }
                })  
            return {
                ...state,
                action
            } 

        case 'setWindowDataType':
                state.windowDataType = action.value 
                state.windowComponent.map((data,index)=>{
                    if(action.item == index){
                        data.type = action.value
                        data.sizes = state.windowData[action.value][0]
                        state.windowSizesData = state.windowData[action.value][0]
                        
                    }
                })   
                console.log(state.windowComponent," state.windowComponent",state.windowDataType)

            return {
                ...state,
                action
            }
            break;
            case "addDoorWindowComponent":
                if(action.componentType == "door"){
                    if(action.key == "add"){ 
                        let setdoorComponent =  [
                            ...state.doorComponent,
                            {
                                "id":const_var.componentCount.door+1,
                                "type":state.doorDataType,
                                "sizes":state.doorSizesData,    
                            }
                        ]
                        const_var.componentCount.door +=1
                        state.doorComponent = setdoorComponent
                    }
                    if(action.key == "delete"){
                        let deletedoorComponent =  [...state.doorComponent]
                        deletedoorComponent.splice(action.index,1)
                        state.doorComponent = deletedoorComponent
                    }
                }
                if(action.componentType == "window"){
                    if(action.key == "add"){ 
                        let setWindowComponent =  [
                            ...state.windowComponent,
                            {
                                "id":const_var.componentCount.window+1,
                                "type":state.windowDataType,
                                "sizes":state.windowSizesData,   
                            }
                        ]
                        const_var.componentCount.window +=1
                        state.windowComponent = setWindowComponent
                    }
                    if(action.key == "delete"){
                        let deleteWindowComponent =  [...state.windowComponent]
                        deleteWindowComponent.splice(action.index,1)
                        state.windowComponent = deleteWindowComponent
                    }
                }
                console.log(action,state.windowComponent)
            return {
                ...state,
                action
            }

        case 'setColorData':
    
            let colorObj = {"name": action.name, "hex_code" :action.value, "type": action.key}

            let filterData = state.colorData.filter((item) => item.type != action.key)

            state.colorData = [...filterData, colorObj]

            state.defaultBuilding = {...state.defaultBuilding, [action.key] : action.id}

            return {
                ...state,
                action
            }

        case "setRadioButtonValue":

            if(action.value === "doublelegbaserail") {
                let baseRailIndex = ""
                let updatedData = [...state.legsData]
                updatedData.map((item,index) => {
                    if(item.name == "Double Legs" && item.legs_type == "double") {
                        baseRailIndex = index
                    }
                })

                if(baseRailIndex != undefined || baseRailIndex != "") {
                    updatedData[baseRailIndex].is_default = updatedData[baseRailIndex].is_default == "Y" ? "" : "Y"
                }
                state.legsData = updatedData
            } else {
                state.buildingStructure = {...state.buildingStructure, default_gauge: action.value}
            }
            
            
            return {
                ...state,
                action
            }
        case "OpenCustomPopup":               
            state.iscustompopup = action.value;               
            return {
                ...state,
                action
            }
        case "handleProfileModal":
                const_var.showProfileModal = action.value;
            return{
                ...state,
                action
            }
        case "ShowHideCheckout":
            state.isShowBuynowConfirm = false;
            state.const_var.isShowConfigBox = !state.const_var.isShowConfigBox;
            if(state.const_var.isShowConfigBox == false){
                document.querySelector('body').classList.add('active-product-detail');
            }else{
                document.querySelector('body').classList.remove('active-product-detail');
                const_var.post_data['first_name'] = ""
                const_var.post_data['last_name'] = ""
                const_var.post_data['email'] = ""
                const_var.post_data['phone_no'] = ""
                const_var.post_data['shipping_zipcode'] = ""
                const_var.post_data['shipping_address_line_1'] = ""
                const_var.post_data['shipping_city'] = ""
                const_var.post_data['shipping_state'] = ""
                const_var.post_data['cardnumber'] = ""
                const_var.post_data['expirydate'] = ""
                const_var.post_data['cvv'] = ""
                const_var.post_data['shipping_address_line_2'] = ""
                const_var.post_data['mobile_no'] = ""
                const_var.post_data['order_notes'] = "";
                const_var.displayerrorMessage = [];
            }
            window.scrollTo(0, 0);
            return {
                ...state,
                action
            }
        case 'ShowBuynowConfirm':
            state.isShowBuynowConfirm = !state.isShowBuynowConfirm;
            return {
                ...state,
                action
            }
        case "ShowCustomizeBuilding":
            state.isCustomizeBuilding = !state.isCustomizeBuilding;
            if(action.from == "setThumb"){
                if(const_var?.controls?.enabled != undefined){
                    const_var.controls.enabled = false;
                }
                state.showThumb = true
                document.getElementsByClassName("building-size")[0].style.height = "110px"
                document.getElementsByClassName("building-size")[0].style.width = "150px"
                document.getElementsByClassName("building-size")[0].style.borderRadius = "8px"
                // document.getElementsByClassName("building-size").style.borderRadius = '8px'
                document.getElementById("canvas").style.width = '150px'
                document.getElementById("canvas").style.height = '110px' 
                document.getElementById("canvas").style.right = '0px' 
                document.getElementById("canvas").style.bottom = '0px' 
                document.getElementById("canvas").style.position = 'fixed' 
                document.getElementById("canvas").style.borderRadius = '8px' 
                document.getElementById("canvas").style.zIndex = '999' 
                document.getElementById("canvas").style.boxShadow = "0px 0px 30px #00000066"
                document.getElementById("canvas").style.overflow = 'hidden';
                document.getElementsByClassName("thumb-wrapper")[0].classList.remove("active-arrow-right");
                document.getElementsByClassName("thumb-wrapper")[0].classList.remove("active-arrow-left");
            
            }else{
                if(const_var?.controls?.enabled != undefined){
                    const_var.controls.enabled = true;
                }
                let area = (window.innerHeight * 50 / 100) * window.innerWidth/2
                let mobileTabPosition = document.getElementById("canvas");
                document.getElementsByClassName("building-size")[0].style.height = `${parseInt(Math.sqrt(area))}px`
                document.getElementsByClassName("building-size")[0].style.width = `auto`
                document.getElementsByClassName("building-size")[0].style.borderRadius = '0px'
                document.getElementById("canvas").style = {}
                document.getElementById("canvas").style.height = `${parseInt(Math.sqrt(area))}px`
                state.showThumb = false
                state.isCustomizeBuilding = false 
                document.getElementById("canvas-container").style.transition = "none";
                document.getElementById("canvas").style.transition = "none";
                mobileTabPosition.scrollIntoView({ behavior: "smooth", block: "start" });
                // setTimeout(() => {
                //     cuComponent.onResize();
                // },300)
            } 
            // const_var.controls.update();
            // cuComponent.onResize();
            return {
                ...state,
                action
            }
        case "ShowSpecification":
            if(action.value === "specification") {
                state.isShowSpecification = !state.isShowSpecification;
            } else {
                state.isShowMobileBuildingSummary = !state.isShowMobileBuildingSummary;
            }
            return {
                ...state,
                action
            }
        case "SetIsMobile":
            state.isMobile = action.value;
            return {
                ...state,
                action
            }
        case "setCheckboxValue":
            console.log(action, "setCheckboxValue")
            if(action.key === "color-screw") {
                state.isColoredScrew = !state.isColoredScrew 
            }

        // state.carportDirectData.pricing_data?.additional_features

            return {
                ...state,
                action
            }
    
        case "updateSliderRange":
            if(action.key == "horizontal") state.horizontalSliderRange = action.value
            if(action.key == "vertical") state.verticalSliderRange = action.value

            return {
                ...state,
                action
            }
        case "handleFeedbackMandatory":
                const_var.isFeedbackFieldMandatory = action.value;

                if(action.value == false) {
                    const_var.displayerrorMessage.feedback_email = "";
                    const_var.displayerrorMessage.feedback_first_name = "";
                    const_var.displayerrorMessage.feedback_last_name = "";
                    const_var.displayerrorMessage.feedback_phone_number = "";   
                }
            return {
                ...state,
                action
            }
        case "setNavtab":
            if(action.key == 'input'){
                const_var.navEventKey.leanto = action.value.target.id
            }
            if(action.key == "nav"){
                const_var.navEventKey.leanto = action.value
            }

            return{
                ...state,
                action
            }
        case "fullyWrapClick":
                // state.params.add_full_lean_porch = !state.params.add_full_lean_porch;
                state.params.add_full_lean_porch = action.key;
                if(state.params.add_full_lean_porch == true){
                    params.leanR_p_pos = 0
                    params.lean_p_pos = 0
                    params.leanF_p_pos = 0
                    params.leanB_p_pos = 0
                    params.lean_p_d = params.p_d
                    params.leanR_p_d = params.p_d
                    params.leanF_p_d = params.p_w
                    params.leanB_p_d = params.p_w
                }

                // state.params.add_full_lean_porch = action.key;
                // if(state.params.add_full_lean_porch == true){
                //     params.lean_p_d = params.p_d
                //     params.leanR_p_d = params.p_d
                //     params.leanF_p_d = params.p_w
                //     params.leanB_p_d = params.p_w
                // }
            return{
                ...state,
                action
            }

            case "fullViewbuild":

                if (const_var.isShowEditConfigurationButton == false && const_var.crmSetting.is_quote_Edit == true) {
                    return;
                }

                const removea = document.querySelector('body');

                state.isfullviewbuilding = !state.isfullviewbuilding

                if (state.isfullviewbuilding) {
                    removea.classList.add("active-fullview");
            
                } else {
                    removea.classList.remove("active-fullview");
                }

                // cuComponent.onResize()

            return{
                ...state,
                action
            }

            
        // ############### reducer to handle Modal on change of state and manufacture #################
        case "showStateOrManufactureChangeModal":
            const_var.isShowAlert = true;
            const_var.alertUsedFor = action.value;
            const_var.stateManufactureChangeId = action.id;
            const_var.stateManufactureFlag = action.flag;
            return {
                ...state,
                action
            }

        
        // ############### Action to handle click on zipcode tool tip #################
        case "handleStateManufactureChange":

            if(action.key == "state") {
                params.p_s_n = action.value
            }
            if(action.key == "manufacture") {
                params.m_s_n = action.value
            }

            return {
                ...state,
                newColor : params.p_s_n
            }
        case "GlobalZipUpdate":
            if(action.value!=undefined && action.value !=""){
                const_var.isGlobalZipUpdate = action.value
            }else{
                const_var.zipcodeToolTipDataFlag = true
            }
            return {
                ...state,
                action,
                newColor : const_var.isGlobalZipUpdate + const_var.zipcodeToolTipDataFlag
            }
            break; 
           }
        

    return newState;
};
const showMoreLess = (position) => {
    switch (position) {
        case "frontLeanFront":
            const_var.isFrontLeanFront = !const_var.isFrontLeanFront;
            break;
        case "frontLeanLeft":
            const_var.isFrontLeanLeft = !const_var.isFrontLeanLeft;
            break;
        case "frontLeanRight":
            const_var.isFrontLeanRight = !const_var.isFrontLeanRight;
            break;
        case "backLeanFront":
            const_var.isBackLeanFront = !const_var.isBackLeanFront;
            break;
        case "backLeanLeft":
            const_var.isBackLeanLeft = !const_var.isBackLeanLeft;
            break;
        case "backLeanRight":
            const_var.isBackLeanRight = !const_var.isBackLeanRight;
            break;
        case "leftLeanFront":
            const_var.isLeftLeanFront = !const_var.isLeftLeanFront;
            break;
        case "leftLeanBack":
            const_var.isLeftLeanBack = !const_var.isLeftLeanBack;
            break;
        case "leftLeanLeft":
            const_var.isLeftLeanLeft = !const_var.isLeftLeanLeft;
            break;
        case "centerFront":
            const_var.isCenterFront = !const_var.isCenterFront;
            break;
        case "centerBack":
            const_var.isCenterBack = !const_var.isCenterBack;
            break;
        case "centerRight":
            const_var.isCenterRight = !const_var.isCenterRight;
            break;
        case "centerLeft":
            const_var.isCenterLeft = !const_var.isCenterLeft;
            break;
        case "rightLeanFront":
            const_var.isRightLeanFront = !const_var.isRightLeanFront;
            break;
        case "rightLeanBack":
            const_var.isRightLeanBack = !const_var.isRightLeanBack;
            break;
        case "rightLeanRight":
            const_var.isRightLeanRight = !const_var.isRightLeanRight;
            break;
    }
}

const resetLeantoStoragePrice = (leanType) => {
    if (leanType == "frontLean" && params.add_front_lean && params.add_storage_check_front) {
        const_var.UpdatedPriceData.front_lean_utility_price_changed = true;
        cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
    }
    if (leanType == "leftLean" && params.add_left_lean && params.add_storage_check) {
        const_var.UpdatedPriceData.left_lean_utility_price_changed = true;
        cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
    }
    if (leanType == "rightLean" && params.add_right_lean && params.add_storage_check_right) {
        const_var.UpdatedPriceData.right_lean_utility_price_changed = true;
        cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
    }
    if (leanType == "backLean" && params.add_back_lean && params.add_storage_check_back) {
        const_var.UpdatedPriceData.back_lean_utility_price_changed = true;
        cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
    }
}

const setBuildingData = (state, resData, flag) => {
    let response = resData;
    let responseData = response
    response = response.data;
const isInspirationAndLoggedIn = const_var.isInspirationBuilding && const_var.loginSession;
const isInspirationalAndNotLogin = Boolean(const_var.isInspirationBuilding && !const_var.loginSession)
const isManufacturerOrStateDiffrence = const_var?.post_data?.building?.manufacturer != const_var?.editAPIDataByResponse?.data?.request_data?.building?.manufacturer || 
const_var?.post_data?.building?.state != const_var.editAPIDataByResponse?.data?.request_data?.building?.state;
const nonLoggedInCondition = const_var?.post_data?.building && (isInspirationalAndNotLogin || (isManufacturerOrStateDiffrence && const_var.isInspirationBuilding))
const isWainscotBuildingWithLoggedinInspirationFlow = Boolean(const_var?.editAPIDataByResponse?.data?.request_data?.building?.wainscot) && const_var.loginSession && const_var.isInspirationBuilding;
    //flag = false;
 
    // console.log(response,"responseresponseresponseresponse",response.data)
    let CommonColorData = "";

    if (const_var.crmSetting.is_Edit == true) {
        CommonColorData = const_var.editstateColorAcordingAPI;
    } else {

        CommonColorData = const_var.stateColorAcordingAPI;
        CommonColorData[params.p_s_n].roof_color = response.color_object[CommonColorData[params.p_s_n].roof_color];
        CommonColorData[params.p_s_n].wall_color = response.color_object[CommonColorData[params.p_s_n].wall_color];
        CommonColorData[params.p_s_n].trim_color = response.color_object[CommonColorData[params.p_s_n].trim_color];
        CommonColorData[params.p_s_n].garageDoorColor = response.color_object[CommonColorData[params.p_s_n].garageDoorColor];

    }
    if(nonLoggedInCondition) {
        state.params.p_r_c = response.color[0].hex_value.replace("#", "0x");//(flag==true)?responseData.data.form_data.roof_color.hex_value.replace("#","0x"):response.color[0].hex_value.replace("#","0x");
        state.params.p_r_c_name =  response.color[0].name;//(flag==true)?responseData.data.form_data.roof_color.name:response.color[0].name;
        state.params.p_r_c_id = response.color[0].id;//(flag==true)?responseData.data.form_data.roof_color.name:response.color[0].name;
        state.params.p_w_c =  response.color[0].hex_value.replace("#", "0x");//(flag==true)?responseData.data.form_data.wall_color.hex_value.replace("#","0x"):response.color[0].hex_value.replace("#","0x");
        state.params.p_w_c_name =  response.color[0].name;//(flag==true)?responseData.data.form_data.wall_color.name:response.color[0].name;
        state.params.p_w_c_id = response.color[0].id;//(flag==true)?responseData.data.form_data.wall_color.name:response.color[0].name;
        state.params.p_t_c = response.color[0].hex_value.replace("#", "0x");//(flag==true)?responseData.data.form_data.trim_color.hex_value.replace("#","0x"):response.color[0].hex_value.replace("#","0x");
        state.params.p_t_c_name = response.color[0].name;//(flag==true)?responseData.data.form_data.trim_color.name:response.color[0].name;
        state.params.p_t_c_id =   response.color[0].id;//(flag==true)?responseData.data.form_data.trim_color.name:response.color[0].name;
        state.params.p_w_c_c = response.color[0].hex_value.replace("#", "0x");//(flag==true && responseData.data.form_data.wainscot)?responseData.data.form_data.wainscot.hex_value.replace("#","0x"):response.color[0].hex_value.replace("#","0x");
        state.params.p_w_c_c_name =   response.color[0].name;//(flag==true && responseData.data.form_data.wainscot)?responseData.data.form_data.wainscot.name:response.color[0].name;
        state.params.p_w_c_c_id =   response.color[0].id;//(flag==true && responseData.data.form_data.wainscot)?responseData.data.form_data.wainscot.name:response.color[0].name;
    } else {
        state.params.p_r_c = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].roof_color != undefined) ? CommonColorData[params.p_s_n].roof_color.hex_value.replace("#", "0x") : response.color[0].hex_value.replace("#", "0x");//(flag==true)?responseData.data.form_data.roof_color.hex_value.replace("#","0x"):response.color[0].hex_value.replace("#","0x");
        state.params.p_r_c_name = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].roof_color != undefined) ? CommonColorData[params.p_s_n].roof_color.name : response.color[0].name;//(flag==true)?responseData.data.form_data.roof_color.name:response.color[0].name;
        state.params.p_r_c_id = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].roof_color != undefined) ? CommonColorData[params.p_s_n].roof_color.id : response.color[0].id;//(flag==true)?responseData.data.form_data.roof_color.name:response.color[0].name;
        state.params.p_w_c = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].wall_color != undefined) ? CommonColorData[params.p_s_n].wall_color.hex_value.replace("#", "0x") : response.color[0].hex_value.replace("#", "0x");//(flag==true)?responseData.data.form_data.wall_color.hex_value.replace("#","0x"):response.color[0].hex_value.replace("#","0x");
        state.params.p_w_c_name = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].wall_color != undefined) ? CommonColorData[params.p_s_n].wall_color.name : response.color[0].name;//(flag==true)?responseData.data.form_data.wall_color.name:response.color[0].name;
        state.params.p_w_c_id = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].wall_color != undefined) ? CommonColorData[params.p_s_n].wall_color.id : response.color[0].id;//(flag==true)?responseData.data.form_data.wall_color.name:response.color[0].name;
        state.params.p_t_c = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].trim_color != undefined) ? CommonColorData[params.p_s_n].trim_color.hex_value.replace("#", "0x") : response.color[0].hex_value.replace("#", "0x");//(flag==true)?responseData.data.form_data.trim_color.hex_value.replace("#","0x"):response.color[0].hex_value.replace("#","0x");
        state.params.p_t_c_name = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].trim_color != undefined) ? CommonColorData[params.p_s_n].trim_color.name : response.color[0].name;//(flag==true)?responseData.data.form_data.trim_color.name:response.color[0].name;
        state.params.p_t_c_id = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].trim_color != undefined) ? CommonColorData[params.p_s_n].trim_color.id : response.color[0].id;//(flag==true)?responseData.data.form_data.trim_color.name:response.color[0].name;
        state.params.p_w_c_c = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].trim_color != undefined) ? CommonColorData[params.p_s_n].trim_color.hex_value.replace("#", "0x") : response.color[0].hex_value.replace("#", "0x");//(flag==true && responseData.data.form_data.wainscot)?responseData.data.form_data.wainscot.hex_value.replace("#","0x"):response.color[0].hex_value.replace("#","0x");
        state.params.p_w_c_c_name = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].trim_color != undefined) ? CommonColorData[params.p_s_n].trim_color.name : response.color[0].name;//(flag==true && responseData.data.form_data.wainscot)?responseData.data.form_data.wainscot.name:response.color[0].name;
        state.params.p_w_c_c_id = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].trim_color != undefined) ? CommonColorData[params.p_s_n].trim_color.id : response.color[0].id;//(flag==true && responseData.data.form_data.wainscot)?responseData.data.form_data.wainscot.name:response.color[0].name;
    }
    const_var.defaultBuildingColorArray['mainColorObject'] = response.color_object;
    if (response.garageDoorColor != undefined && response.garageDoorColor.length > 0) {
        state.params.g_d_c = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].garageDoorColor != undefined) ? CommonColorData[params.p_s_n].garageDoorColor.hex_value.replace("#", "0x") : response.garageDoorColor[0].hex_value.replace("#", "0x");//(flag==true)?responseData.data.form_data.wall_color.hex_value.replace("#","0x"):response.color[0].hex_value.replace("#","0x");
        state.params.g_d_c_name = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].garageDoorColor != undefined) ? CommonColorData[params.p_s_n].garageDoorColor.name : response.garageDoorColor[0].name;//(flag==true)?responseData.data.form_data.wall_color.name:response.color[0].name;
        state.params.g_d_c_id = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].garageDoorColor != undefined) ? CommonColorData[params.p_s_n].garageDoorColor.id : response.garageDoorColor[0].id;//(flag==true)?responseData.data.form_data.wall_color.name:response.color[0].name;
        state.params.g_d_c_Obj = (response.garageDoorColor != undefined) ? response.garageDoorColor : "";

    } else {
        CommonColorData[params.p_s_n].garageDoorColor = params.g_d_c_Obj;
        state.params.g_d_c = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].garageDoorColor != undefined) ? CommonColorData[params.p_s_n].garageDoorColor.hex_value.replace("#", "0x") : response.garageDoorColor[0].hex_value.replace("#", "0x");//(flag==true)?responseData.data.form_data.wall_color.hex_value.replace("#","0x"):response.color[0].hex_value.replace("#","0x");
        state.params.g_d_c_name = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].garageDoorColor != undefined) ? CommonColorData[params.p_s_n].garageDoorColor.name : response.garageDoorColor[0].name;//(flag==true)?responseData.data.form_data.wall_color.name:response.color[0].name;
        state.params.g_d_c_id = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].garageDoorColor != undefined) ? CommonColorData[params.p_s_n].garageDoorColor.id : response.garageDoorColor[0].id;//(flag==true)?responseData.data.form_data.wall_color.name:response.color[0].name;
    }
    if (const_var.crmSetting.is_Edit == true && !nonLoggedInCondition) {
        state.params.p_w_c_c = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].wainscot != undefined) ? CommonColorData[params.p_s_n].wainscot.hex_value.replace("#", "0x") : response.color[0].hex_value.replace("#", "0x");//(flag==true && responseData.data.form_data.wainscot)?responseData.data.form_data.wainscot.hex_value.replace("#","0x"):response.color[0].hex_value.replace("#","0x");
        state.params.p_w_c_c_name = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].wainscot != undefined) ? CommonColorData[params.p_s_n].wainscot.name : response.color[0].name;//(flag==true && responseData.data.form_data.wainscot)?responseData.data.form_data.wainscot.name:response.color[0].name;
    }
    if (response.manufacture_data != undefined) {
        const_var.leanto_condition_by_mfg = response.manufacture_data[0];
    }
    state.const_var.CheckSnowLoadFlag = false;
    let snowValue = response.building.filter(data => data.building_type.heavy_snow == 0);
    // console.log(snowValue,"snowValuesnowValuesnowValue")
    if (snowValue.length == 0) {
        const_var.CheckSnowLoadValue = 65;
    }
    const_var.regionId = [];
    for (var i = 0; i <= response.building.length - 1; i++) {
        if (response.building[i].building_type.heavy_snow == 1) {
            state.const_var.CheckSnowLoadFlag = true;
        }
        // console.log(const_var.CheckSnowLoadValue,"const_var.CheckSnowLoadValue")
        if (const_var.CheckSnowLoadValue == 65 && response.building[i].building_type.heavy_snow == 1) {

            state.const_var.b_o_J_1[response.building[i].building_type.building_id] = response.building[i].building_type.name;
            state.const_var.Map_Id[response.building[i].building_type.building_id] = response.building[i].building_type.map_id;
            state.const_var.ExtraBuildingID[response.building[i].building_type.building_id] = response.building[i].building_type;
            state.const_var.regionId[response.building[i].building_type.building_id] = response.building[i].building_type.region_id;
            //Map_Id[obj.building[i].building_type.building_id] = obj.building[i].building_type.map_id;
            if (response.building[i].building_type.type_of_building == 1) {
                if (state.const_var.mapIdforLean == "") {
                    state.const_var.mapIdforLean = response.building[i].building_type.map_id;
                }
            }
            state.c_m_a[response.building[i].building_type.building_id] = new Array();
            //b_o_J_1.value1 = obj.buildingTypes[i].building_type.name;
            //state.c_m_a[response.building[i].building_type.building_id] = response.building[i].roof_style;
            state.c_m_a[response.building[i].building_type.building_id].roof_style = response.building[i].roof_style;
            if(response.building[i].fixed_new_leg_width!=undefined && response.building[i].fixed_new_leg_width.length>0)
            {
                state.c_m_a[response.building[i].building_type.building_id].fixed_new_leg_width = response.building[i].fixed_new_leg_width;
            }
            if (response.building[i].building_type.type_of_building == 2) {
                const_var.roof_style_Barn = response.building[i].roof_style;
            }
            if(response.building[i].building_type.lean_to_building_id!='' && response.building[i].building_type.lean_to_building_id!=null)
            {
                let roofData = const_var.SendAPIBuildingData.building.filter(data=>data.building_type.building_id==response.building[i].building_type.lean_to_building_id && data.building_type.heavy_snow == 1);
                if(roofData.length>0)
                {
                    const_var.roof_style_Barn_with_centerbuilding[response.building[i].building_type.building_id] = roofData[0].roof_style;
                }
            }
            if(response.building[i].building_type.lean_to_building_id == null && response.building[i].building_type.name.includes("Free Standing Lean-to"))
            {
                if(const_var.roof_style_Barn.length>0)
                {
                    const_var.roof_style_Barn_with_centerbuilding[response.building[i].building_type.building_id] = const_var.roof_style_Barn;
                }
            }
            state.c_m_a[response.building[i].building_type.building_id].menuID = response.building[i].building_type.manufacturer_id;
            state.c_m_a[response.building[i].building_type.building_id].default_lean_id = (response.building[i].building_type.lean_to_building_id != undefined) ? response.building[i].building_type.lean_to_building_id : 2;

            state.c_m_a[response.building[i].building_type.building_id].defaultBuldingcheck = response.building[i].building_type.type_of_building;
            state.c_m_a[response.building[i].building_type.building_id].drawings = response.building[i] != undefined && response.building[i].drawings != undefined ? response.building[i].drawings : [];
           
            if(state.c_m_a[response.building[i].building_type.building_id] != undefined && state.c_m_a[response.building[i].building_type.building_id].drawings != undefined && state.c_m_a[response.building[i].building_type.building_id].drawings.length > 0){
                let defaultSel = state.c_m_a[response.building[i].building_type.building_id].drawings.filter(obj => obj.is_default == 'yes')

                state.const_var.order_extra_items['engineer_drawings_name'] = defaultSel.length > 0 ? defaultSel[0].name : ''
                state.const_var.order_extra_items['engineer_drawings'] = defaultSel.length > 0 ? defaultSel[0].cost : 0
            }
            state.c_m_a[response.building[i].building_type.building_id].trussType = response.building[i].truss_name;
            state.const_var.ConditionArr[response.building[i].building_type.building_id] = [];
            state.const_var.BarnConditionArr[response.building[i].building_type.building_id] = [];
            state.const_var.DistanceArr[response.building[i].building_type.building_id] = [];
            state.const_var.roofObject[response.building[i].building_type.building_id] = [];
            for (var j = 0; j < response.building[i].roof_style.length; j++) {
                if (response.building[i].roof_style[j].distance_on_length == undefined) {
                    response.building[i].roof_style[j].distance_on_length = 5;
                }
                if (response.building[i].roof_style[j].distance_on_width == undefined) {
                    response.building[i].roof_style[j].distance_on_width = 2;
                }
                state.params.frame_length = (response.building[i].roof_style[j].roof_length != undefined) ? response.building[i].roof_style[j].roof_length : 0;
                state.const_var.DistanceArr[response.building[i].building_type.building_id][response.building[i].roof_style[j].roof_id] = (params.fourth_center_cost != true) ? response.building[i].roof_style[j].distance_on_center : 4;
                if (Object.keys(response.building[i].roof_style[j].conditions).length !== 0) {
                    if (response.building[i].building_type.building_id == 2) {
                        state.const_var.BarnConditionArr[response.building[i].building_type.building_id][response.building[i].roof_style[j].roof_id] = response.building[i].roof_style[j].conditions['width-length'];
                    }
                    state.const_var.ConditionArr[response.building[i].building_type.building_id][response.building[i].roof_style[j].roof_id] = response.building[i].roof_style[j].conditions['condition'];
                    utils.checkReinforcedLeg( state.const_var.ConditionArr[response.building[i].building_type.building_id][response.building[i].roof_style[j].roof_id])
                }
                state.const_var.TypeEnumID[response.building[i].roof_style[j].roof_id] = response.building[i].roof_style[j].name;
                state.const_var.roofObject[response.building[i].building_type.building_id][response.building[i].roof_style[j].roof_id] = response.building[i].roof_style[j];

            }
        } if (const_var.CheckSnowLoadValue != 65 && response.building[i].building_type.heavy_snow == 0) {
            state.const_var.b_o_J_1[response.building[i].building_type.building_id] = response.building[i].building_type.name;
            state.const_var.Map_Id[response.building[i].building_type.building_id] = response.building[i].building_type.map_id;
            state.const_var.ExtraBuildingID[response.building[i].building_type.building_id] = response.building[i].building_type;
            state.const_var.regionId[response.building[i].building_type.building_id] = response.building[i].building_type.region_id;
            //Map_Id[obj.building[i].building_type.building_id] = obj.building[i].building_type.map_id;
            if (response.building[i].building_type.type_of_building == 1) {
                if (state.const_var.mapIdforLean == "") {
                    state.const_var.mapIdforLean = response.building[i].building_type.map_id;
                }
            }
            state.c_m_a[response.building[i].building_type.building_id] = new Array();
            //b_o_J_1.value1 = obj.buildingTypes[i].building_type.name;
            //state.c_m_a[response.building[i].building_type.building_id] = response.building[i].roof_style;
            state.c_m_a[response.building[i].building_type.building_id].roof_style = response.building[i].roof_style;
            if(response.building[i].fixed_new_leg_width!=undefined && response.building[i].fixed_new_leg_width.length>0)
            {
                state.c_m_a[response.building[i].building_type.building_id].fixed_new_leg_width = response.building[i].fixed_new_leg_width;
            }
            if (response.building[i].building_type.type_of_building == 2) {
                const_var.roof_style_Barn = response.building[i].roof_style;
            }
            if(response.building[i].building_type.lean_to_building_id!='' && response.building[i].building_type.lean_to_building_id!=null)
            {
                let roofData = const_var.SendAPIBuildingData.building.filter(data=>data.building_type.building_id==response.building[i].building_type.lean_to_building_id);
                if(roofData.length>0)
                {
                    const_var.roof_style_Barn_with_centerbuilding[response.building[i].building_type.building_id] = roofData[0].roof_style;
                }
            }

            if(response.building[i].building_type.lean_to_building_id == null && response.building[i].building_type.name.includes("Free Standing Lean-to"))
            {
                if(const_var.roof_style_Barn.length>0)
                {
                    const_var.roof_style_Barn_with_centerbuilding[response.building[i].building_type.building_id] = const_var.roof_style_Barn;
                }
            }

            state.c_m_a[response.building[i].building_type.building_id].menuID = response.building[i].building_type.manufacturer_id;
            state.c_m_a[response.building[i].building_type.building_id].default_lean_id = (response.building[i].building_type.lean_to_building_id != undefined) ? response.building[i].building_type.lean_to_building_id : 2;
 

            state.c_m_a[response.building[i].building_type.building_id].defaultBuldingcheck = response.building[i].building_type.type_of_building;
            state.c_m_a[response.building[i].building_type.building_id].drawings = response.building[i] != undefined && response.building[i].drawings != undefined ? response.building[i].drawings : [];
            state.c_m_a[response.building[i].building_type.building_id].trussType = response.building[i].truss_name;
            state.const_var.ConditionArr[response.building[i].building_type.building_id] = [];
            state.const_var.BarnConditionArr[response.building[i].building_type.building_id] = [];
            state.const_var.DistanceArr[response.building[i].building_type.building_id] = [];
            state.const_var.roofObject[response.building[i].building_type.building_id] = [];
            for (var j = 0; j < response.building[i].roof_style.length; j++) {
                if (response.building[i].roof_style[j].distance_on_length == undefined) {
                    response.building[i].roof_style[j].distance_on_length = 5;
                }
                if (response.building[i].roof_style[j].distance_on_width == undefined) {
                    response.building[i].roof_style[j].distance_on_width = 2;
                }
                state.params.frame_length = (response.building[i].roof_style[j].roof_length != undefined) ? response.building[i].roof_style[j].roof_length : 0;
                state.const_var.DistanceArr[response.building[i].building_type.building_id][response.building[i].roof_style[j].roof_id] = (params.fourth_center_cost != true) ? response.building[i].roof_style[j].distance_on_center : 4;
                if (Object.keys(response.building[i].roof_style[j].conditions).length !== 0) {
                    if (response.building[i].building_type.type_of_building == 2) {
                        state.const_var.BarnConditionArr[response.building[i].building_type.building_id][response.building[i].roof_style[j].roof_id] = response.building[i].roof_style[j].conditions['width-length'];
                    }
                    state.const_var.ConditionArr[response.building[i].building_type.building_id][response.building[i].roof_style[j].roof_id] = response.building[i].roof_style[j].conditions['condition'];
                    utils.checkReinforcedLeg( state.const_var.ConditionArr[response.building[i].building_type.building_id][response.building[i].roof_style[j].roof_id])
                }
                state.const_var.TypeEnumID[response.building[i].roof_style[j].roof_id] = response.building[i].roof_style[j].name;
                state.const_var.roofObject[response.building[i].building_type.building_id][response.building[i].roof_style[j].roof_id] = response.building[i].roof_style[j];
            }

        }

    }


    for (var i = 0; i <= response.color.length - 1; i++) {
        const_var.c_m_a_Colors[response.color[i].hex_value.replace("#", "0x")] = response.color[i];
        const_var.c_m_a_Colors[response.color[i].id] = response.color[i];
    }
    if (const_var.crmSetting.is_Edit == true && !isInspirationalAndNotLogin && !isWainscotBuildingWithLoggedinInspirationFlow) {
        state.params.p_w_c_c = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].wainscot != undefined) ? CommonColorData[params.p_s_n].wainscot.hex_value.replace("#", "0x") : response.color[0].hex_value.replace("#", "0x");//(flag==true && responseData.data.form_data.wainscot)?responseData.data.form_data.wainscot.hex_value.replace("#","0x"):response.color[0].hex_value.replace("#","0x");
        state.params.p_w_c_c_name = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].wainscot != undefined) ? CommonColorData[params.p_s_n].wainscot.name : response.color[0].name;//(flag==true && responseData.data.form_data.wainscot)?responseData.data.form_data.wainscot.name:response.color[0].name;
        state.params.p_w_c_c_id = (CommonColorData[params.p_s_n] != undefined && CommonColorData[params.p_s_n].wainscot != undefined) ? CommonColorData[params.p_s_n].wainscot.id : response.color[0].id;//(flag==true && responseData.data.form_data.wainscot)?responseData.data.form_data.wainscot.name:response.color[0].name;
    }

    state.const_var.color = response.color;
    state.const_var.building = response.building;
    state.const_var.popular_colors = utils.mapPopularColors(response.color,response.popular_colors);

    state.const_var.roof_style = state.c_m_a[state.params.p_b_t].roof_style;

    let dataNew;


    if (responseData.data.form_data != undefined && responseData.data.form_data.leanto != undefined && responseData.data.form_data.leanto.length > 0 && dataNew.roof_pitch != undefined) {
        params.b_l_t_r_p = "2";
        params.b_l_t_r_pR = "2";
        for (var i = 0; i <= dataNew.roof_pitch.length - 1; i++) {
            const_var.b_r_p_l_to_a[(dataNew.roof_pitch[i].roof_pitch).split("/")[0]] = dataNew.roof_pitch[i];
            const_var.BuildingLRoofPitch[dataNew.roof_pitch[i].roof_pitch] = (dataNew.roof_pitch[i].roof_pitch).split("/")[0];
            if (dataNew.roof_pitch[i].is_default == "yes") {
                params.isDefault_l_t_r_p = params.b_l_t_r_p = params.b_l_t_r_pR = (dataNew.roof_pitch[i].roof_pitch).split("/")[0];
            }
        }
        if (const_var.newLeanArr['left'] != undefined && const_var.newLeanArr['left'].roof_pitch != undefined) {
            params.b_l_t_r_p = (const_var.newLeanArr['left'].roof_pitch_name != undefined) ? (const_var.newLeanArr['left'].roof_pitch_name).split("/")[0] : (const_var.newLeanArr['left'].roof_pitch).split("/")[0];
        } if (const_var.newLeanArr['right'] != undefined && const_var.newLeanArr['right'].roof_pitch != undefined) {
            params.b_l_t_r_pR = (const_var.newLeanArr['right'].roof_pitch_name != undefined) ? (const_var.newLeanArr['right'].roof_pitch_name).split("/")[0] : (const_var.newLeanArr['right'].roof_pitch).split("/")[0];
        }
        if (const_var.newLeanArr['front'] != undefined && const_var.newLeanArr['front'].roof_pitch != undefined) {
            params.b_l_t_r_pF = (const_var.newLeanArr['front'].roof_pitch_name != undefined) ? (const_var.newLeanArr['front'].roof_pitch_name).split("/")[0] : (const_var.newLeanArr['front'].roof_pitch).split("/")[0];
        } if (const_var.newLeanArr['back'] != undefined && const_var.newLeanArr['back'].roof_pitch != undefined) {
            params.b_l_t_r_pB = (const_var.newLeanArr['back'].roof_pitch_name != undefined) ? (const_var.newLeanArr['back'].roof_pitch_name).split("/")[0] : (const_var.newLeanArr['back'].roof_pitch).split("/")[0];
        }
    }
    cuBuilding.makeInsulationArrayForLeanto();

    state.const_var.anchors_cost = response.anchors_cost;
    ////state.const_var.garageDoorColor = response.garageDoorColor;
    if (response.garageDoorColor.length > 0) {
        for (var i = 0; i <= response.garageDoorColor.length - 1; i++) {
            const_var.garageDoorColor[response.garageDoorColor[i].id] = response.garageDoorColor[i];
        }
    } else {
        const_var.garageDoorColor[params.g_d_c_Obj.id] = params.g_d_c_Obj;
    }

    state.const_var.selectedBuilding = response.building[0];
    state.b_m_i_w = state.c_m_a[state.params.p_b_t];
    //state.params.p_r_s = (flag==true)?responseData.data.form_data.roof_style:state.c_m_a[response.building[0].building_type.building_id].roof_style[0].roof_id;
    state.const_var.c_m_a = state.c_m_a;

    cuBuilding.uUdD();
    cuBuilding.uUdDCB();
    cuBuilding.leanuUdD();  

    //makeComponentArray(state);
    makeDimensionArray(state);
    makeDimensionUpdateRight(state);
    makeDimensionUpdateLeft(state);
    makeDimensionUpdateFront(state);
    makeDimensionUpdateBack(state);
    cuBuilding.CheckLegsByResponse(state);
    cuBuilding.BuildingUpdate(true);
    cuBuilding.UpdateFrontLean();
    cuBuilding.UpdateLeftLean();
    cuBuilding.UpdateRightLean();
    cuBuilding.UpdateBackLean();
    if (!const_var.crmSetting.is_Edit)cuBuilding.CheckLeanLegsByResponse(state, "all");

}

const setPricingDataForLeantoComparision = (state, response, type, flag, iiD) => {
    // let responseStatus = (flag==true && const_var.CallApionAction==false)?response.status:response.success;
    // console.log(response,"responseStatus");
    // if (responseStatus == true) {

    let dataNew = "";
    // console.log({response});
    if (type == "addLeftLean") {
        const_var.leanGetDataLeftComparision = (response.success == true) ? response.data : const_var.leanGetDataLeft;
        // console.log(const_var.leanGetDataLeftComparision ,"const_var.leanGetDataLeftComparision");
        if (const_var.leanGetDataLeftComparision.central_side != undefined && const_var.leanGetDataLeftComparision.central_side.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.side = const_var.leanGetDataLeftComparision.central_side;
        }
        if (const_var.leanGetDataLeftComparision.central_end != undefined && const_var.leanGetDataLeftComparision.central_end.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.end = const_var.leanGetDataLeftComparision.central_end;
        }
        if (const_var.leanGetDataLeftComparision.central_utility_side != undefined && const_var.leanGetDataLeftComparision.central_utility_side.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.utility_side = const_var.leanGetDataLeftComparision.central_utility_side;
        }
        if (const_var.leanGetDataLeftComparision.end_combo_v3 != undefined && const_var.leanGetDataLeftComparision.end_combo_v3.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.end_combo_v3 = const_var.leanGetDataLeftComparision.end_combo_v3;
        }
        if (const_var.leanGetDataLeftComparision.side_combo_v3 != undefined && const_var.leanGetDataLeftComparision.side_combo_v3.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.side_combo_v3 = const_var.leanGetDataLeftComparision.side_combo_v3;
        }
        if (const_var.leanGetDataLeftComparision.central_trusses != undefined && const_var.leanGetDataLeftComparision.central_trusses.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.trusses = const_var.leanGetDataLeftComparision.central_trusses;
        }

        //const_var.a_p_d_a.extra_items = const_var.leanGetDataLeftComparision.extra_items;
        dataNew = const_var.leanGetDataLeftComparision;
        if (const_var.compareMainBuildingPriceRes.connection_fees != undefined && const_var.compareMainBuildingPriceRes.connection_fees.length == 0) {
            const_var.compareMainBuildingPriceRes.connection_fees = const_var.leanGetDataLeftComparision.connection_fees;
        }
        if (const_var.leanGetDataLeftComparision.building_structure!=undefined && const_var.leanGetDataLeftComparision.building_structure.length > 0) {
            if (Object.keys(const_var.leanGetDataLeftComparision.building_structure[0].conditions).length !== 0) {
                const_var.conditionArrForLeanCompare['left'] = const_var.leanGetDataLeftComparision.building_structure[0].conditions['condition'];
            }
        }
        cuBuilding.cPforLLeanOnlyComparision(const_var.leanGetDataLeftComparision, iiD);

    } else if (type == "addFrontLean") {
        const_var.leanGetDataFrontComparision = (response.success == true) ? response.data : const_var.leanGetDataFront;
        if (const_var.leanGetDataFrontComparision.central_side != undefined && const_var.leanGetDataFrontComparision.central_side.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.side = const_var.leanGetDataFrontComparision.central_side;
        }
        if (const_var.leanGetDataFrontComparision.central_end != undefined && const_var.leanGetDataFrontComparision.central_end.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.end = const_var.leanGetDataFrontComparision.central_end;
        }
        if (const_var.leanGetDataFrontComparision.central_utility_side != undefined && const_var.leanGetDataFrontComparision.central_utility_side.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.utility_side = const_var.leanGetDataFrontComparision.central_utility_side;
        }
        if (const_var.leanGetDataFrontComparision.end_combo_v3 != undefined && const_var.leanGetDataFrontComparision.end_combo_v3.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.end_combo_v3 = const_var.leanGetDataFrontComparision.end_combo_v3;
        }
        if (const_var.leanGetDataFrontComparision.side_combo_v3 != undefined && const_var.leanGetDataFrontComparision.side_combo_v3.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.side_combo_v3 = const_var.leanGetDataFrontComparision.side_combo_v3;
        }
        if (const_var.leanGetDataFrontComparision.central_trusses != undefined && const_var.leanGetDataFrontComparision.central_trusses.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.trusses = const_var.leanGetDataFrontComparision.central_trusses;
        }


        dataNew = const_var.leanGetDataFrontComparision;
        if (const_var.compareMainBuildingPriceRes.connection_fees != undefined && const_var.compareMainBuildingPriceRes.connection_fees.length == 0) {
            const_var.compareMainBuildingPriceRes.connection_fees = const_var.leanGetDataFrontComparision.connection_fees;
        }
        if (const_var.leanGetDataFrontComparision.building_structure!=undefined && const_var.leanGetDataFrontComparision.building_structure.length > 0) {
            if (Object.keys(const_var.leanGetDataFrontComparision.building_structure[0].conditions).length !== 0) {
                const_var.conditionArrForLeanCompare['front'] = const_var.leanGetDataFrontComparision.building_structure[0].conditions['condition'];
            }
        }

        cuBuilding.cPforFLeanOnlyComparision(const_var.leanGetDataFrontComparision, iiD);
  } else if (type == "addBackLean") {
        const_var.leanGetDataBackComparision = (response.success == true) ? response.data : const_var.leanGetDataFront;
        if (const_var.leanGetDataBackComparision.central_side != undefined && const_var.leanGetDataBackComparision.central_side.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.side = const_var.leanGetDataBackComparision.central_side;
        }
        if (const_var.leanGetDataBackComparision.central_end != undefined && const_var.leanGetDataBackComparision.central_end.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.end = const_var.leanGetDataBackComparision.central_end;
        }
        if (const_var.leanGetDataBackComparision.central_utility_side != undefined && const_var.leanGetDataBackComparision.central_utility_side.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.utility_side = const_var.leanGetDataBackComparision.central_utility_side;
        }
        if (const_var.leanGetDataBackComparision.end_combo_v3 != undefined && const_var.leanGetDataBackComparision.end_combo_v3.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.end_combo_v3 = const_var.leanGetDataBackComparision.end_combo_v3;
        }
        if (const_var.leanGetDataBackComparision.side_combo_v3 != undefined && const_var.leanGetDataBackComparision.side_combo_v3.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.side_combo_v3 = const_var.leanGetDataBackComparision.side_combo_v3;
        }
        if (const_var.leanGetDataBackComparision.central_trusses != undefined && const_var.leanGetDataBackComparision.central_trusses.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.trusses = const_var.leanGetDataBackComparision.central_trusses;
        }

        dataNew = const_var.leanGetDataBackComparision;
        if (const_var.compareMainBuildingPriceRes.connection_fees != undefined && const_var.compareMainBuildingPriceRes.connection_fees.length == 0) {
            const_var.compareMainBuildingPriceRes.connection_fees = const_var.leanGetDataBackComparision.connection_fees;
        }
        if (const_var.leanGetDataBackComparision.building_structure!=undefined && const_var.leanGetDataBackComparision.building_structure.length > 0) {
            if (Object.keys(const_var.leanGetDataBackComparision.building_structure[0].conditions).length !== 0) {
                const_var.conditionArrForLeanCompare['back'] = const_var.leanGetDataBackComparision.building_structure[0].conditions['condition'];
            }
        }

        cuBuilding.cPforBLeanOnlyComparision(const_var.leanGetDataBackComparision, iiD);

    } else if (type == "addRightLean") {
        const_var.leanGetDataRightComparision = (response.success == true) ? response.data : const_var.leanGetDataRight;
        if (const_var.leanGetDataRightComparision.central_side != undefined && const_var.leanGetDataRightComparision.central_side.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.side = const_var.leanGetDataRightComparision.central_side;
        }
        if (const_var.leanGetDataRightComparision.central_end != undefined && const_var.leanGetDataRightComparision.central_end.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.end = const_var.leanGetDataRightComparision.central_end;
        }
        if (const_var.leanGetDataRightComparision.central_utility_side != undefined && const_var.leanGetDataRightComparision.central_utility_side.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.utility_side = const_var.leanGetDataRightComparision.central_utility_side;
        }
        if (const_var.leanGetDataRightComparision.end_combo_v3 != undefined && const_var.leanGetDataRightComparision.end_combo_v3.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.end_combo_v3 = const_var.leanGetDataRightComparision.end_combo_v3;
        }
        if (const_var.leanGetDataRightComparision.side_combo_v3 != undefined && const_var.leanGetDataRightComparision.side_combo_v3.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.side_combo_v3 = const_var.leanGetDataRightComparision.side_combo_v3;
        }
        if (const_var.leanGetDataRightComparision.central_trusses != undefined && const_var.leanGetDataRightComparision.central_trusses.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.trusses = const_var.leanGetDataRightComparision.central_trusses;
        }
        // const_var.a_p_d_a.extra_items = const_var.leanGetDataRightComparision.extra_items;
        dataNew = const_var.leanGetDataRightComparision;
        if (const_var.compareMainBuildingPriceRes.connection_fees != undefined && const_var.compareMainBuildingPriceRes.connection_fees.length == 0) {
            const_var.compareMainBuildingPriceRes.connection_fees = const_var.leanGetDataRightComparision.connection_fees;
        }
        if (const_var.leanGetDataRightComparision.building_structure!=undefined && const_var.leanGetDataRightComparision.building_structure.length > 0) {
            if (Object.keys(const_var.leanGetDataRightComparision.building_structure[0].conditions).length !== 0) {
                const_var.conditionArrForLeanCompare['right'] = const_var.leanGetDataRightComparision.building_structure[0].conditions['condition'];
            }
        }

        cuBuilding.cPforRLeanOnlyComparision(const_var.leanGetDataRightComparision, iiD);

    }
    // console.log(const_var.leanGetDataRightComparision,"const_var.leanGetDataRightComparision");
    state.const_var.comparisionLoadermfg1 = false;
    state.const_var.comparisionLoadermfg2 = false;

}
const setPricingDataForLeanto = (state, response, type, flag) => {
    // let responseStatus = (flag==true && const_var.CallApionAction==false)?response.status:response.success;
    // console.log( response, type,"responseStatus");
    // if (responseStatus == true) {
    let dataNew = "";
    // const_var.legsForCut = [];
    if(response.data != undefined) {
        const_var.roof_style_Barn  = response.data.building_structure;
    }   
    if (type == "addLeftLean") {
        const_var.makeCertificateArrayLeft = {};
        // console.log('const_var.leanGetDataLeft',const_var.leanGetDataLeft);    
        const_var.leanGetDataLeft = (response.success == true) ? response.data : const_var.leanGetDataLeft;
       
        if(params.p_c_i == true && response.success == true && response.data.insulation && const_var.leanGetDataLeft && const_var.insulationArrayForLeantoLeft.insulation_wall && Object.keys(const_var.insulationArrayForLeantoLeft.insulation_wall).length > 0){
            let isInsulationAdded = Object.keys(const_var.insulationArrayForLeantoLeft.insulation_wall).find(key => const_var.insulationArrayForLeantoLeft.insulation_wall[key] == true)
            params.p_c_i = isInsulationAdded != undefined ? params.p_c_i : false
            params.p_f_i = false
        }

        // if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.leanGetDataLeft.central_insulation);
        utils.updateCenterBuildingInsulation(const_var.leanGetDataLeft.central_insulation);
        cuBuilding.makeInsulationArrayForLeanto();
        cuBuilding.makeCertificateArrayLeft('left');
        // console.log( const_var.leanGetDataLeft,"const_var.leanGetDataLeft");
        if (const_var.leanGetDataLeft.building_structure!=undefined && const_var.leanGetDataLeft.building_structure.length > 0) {
            if (Object.keys(const_var.leanGetDataLeft.building_structure[0].conditions).length !== 0) {
                const_var.ConditionArrForLean['left'] = const_var.leanGetDataLeft.building_structure[0].conditions['condition'];
                utils.checkReinforcedLeg(const_var.ConditionArrForLean['left'])
                // console.log(const_var.ConditionArrForLean['left'],"const_var.ConditionArrForLean['left'] left 11");
            }
        }
        cuBuilding.CheckLeanLegsByResponse(state,type);
        if(const_var.leanGetDataLeft.central_certificate!=undefined && const_var.leanGetDataLeft.central_certificate.length>0)
        {
            const_var.a_p_d_a.certificate = const_var.leanGetDataLeft.central_certificate;
            cuBuilding.makeCertificateArray();
            if (const_var.crmSetting.is_Edit != true) {
                const_var.UpdatedPriceData.certificate_price_changed = true;  
            }
            if (params.add_left_lean==false) {
                
                if (const_var.crmSetting.is_Edit) {
                  utils.updateFourFeetOnCenterPriceWithExtraBowsOnLeanRemoval();
                } else {
                  calculateLegsCount();
                }
                commonFunctionForExtraBows();
              }
              
        }
        if((!const_var.crmSetting.is_Edit || const_var.isPriceAPIcalled) && params.fourth_center_cost==true)
        {
            let quantityval = const_var.ExtraItemsFeaturesArray.findIndex(data => data && (data.name=="fourth_center_cost" || data.label == "4ft on Center"));
            if(quantityval>=0 && params.fourth_center_cost)
            {
                const_var.ExtraItemsFeaturesArray[quantityval].cost = 0;
            }
            if (params.add_left_lean) calculateLegsCount(const_var.leanGetDataLeft,'leftLean');
            if (params.add_front_lean) calculateLegsCount(const_var.leanGetDataFront,'frontLean');
            if (params.add_right_lean) calculateLegsCount(const_var.leanGetDataRight,'rightLean');
            if (params.add_back_lean) calculateLegsCount(const_var.leanGetDataBack,'backLean'); 
        }
        if (const_var.leanGetDataLeft.central_side != undefined && const_var.leanGetDataLeft.central_side.length > 0) {
            const_var.a_p_d_a.side = const_var.leanGetDataLeft.central_side;
        }
        if (const_var.leanGetDataLeft.central_side_full_length != undefined && const_var.leanGetDataLeft.central_side_full_length.length > 0) {
            const_var.a_p_d_a.full_length_side = const_var.leanGetDataLeft.central_side_full_length;
        }
        // if (const_var.leanGetDataLeft.central_insulation != undefined && const_var.leanGetDataLeft.central_insulation.length > 0) {
        //     const_var.a_p_d_a.insulation = const_var.leanGetDataLeft.central_insulation;
        // }
        if (const_var.leanGetDataLeft.central_end != undefined && const_var.leanGetDataLeft.central_end.length > 0) {
            const_var.a_p_d_a.end = const_var.leanGetDataLeft.central_end;
        }
        if (const_var.leanGetDataLeft.central_utility_side != undefined && const_var.leanGetDataLeft.central_utility_side.length > 0) {
            const_var.a_p_d_a.utility_side = const_var.leanGetDataLeft.central_utility_side;
        }if (const_var.leanGetDataLeft.end_combo_v3 != undefined && const_var.leanGetDataLeft.end_combo_v3.length > 0) {
            const_var.a_p_d_a.end_combo_v3 = const_var.leanGetDataLeft.end_combo_v3;
        }
        if (const_var.leanGetDataLeft.side_combo_v3 != undefined && const_var.leanGetDataLeft.side_combo_v3.length > 0) {
            const_var.a_p_d_a.side_combo_v3 = const_var.leanGetDataLeft.side_combo_v3;
        }
         if (const_var.leanGetDataLeft.central_trusses != undefined && const_var.leanGetDataLeft.central_trusses.length > 0) {
            const_var.a_p_d_a.trusses = const_var.leanGetDataLeft.central_trusses;
        }
        utils.updateCenterBuildingPricesOnLeanAPICalls(state, "leanGetDataLeft",'left');
        if (const_var.crmSetting.is_Edit != true) {
            if(type != undefined && (type == 'addLeftLean' && state.params.add_left_lean != true)){
                if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.a_p_d_a.old_insulation);

                if(state.params.add_front_lean || state.params.add_back_lean || state.params.add_right_lean) {
                    if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.leanGetDataLeft.central_insulation);
                }
                const_var.UpdatedPriceData.insulation_price = undefined;
                const_var.UpdatedPriceData.insulation_price_changed = true;
            }
            else{
                const_var.UpdatedPriceData.front_wall_price_changed = true;
                const_var.UpdatedPriceData.back_wall_price_changed = true;
            }
            const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
            const_var.UpdatedPriceData.height_price_changed = true;
            const_var.UpdatedPriceData.certificate_price_changed = true;
            const_var.UpdatedPriceData.wainscot_price_changed = true;
                // const_var.UpdatedPriceData.color_price_changed = true;
            const_var.UpdatedPriceData.roof_color_price_changed = true;
            const_var.UpdatedPriceData.wall_color_price_changed = true;
            const_var.UpdatedPriceData.trim_color_price_changed = true;
            const_var.UpdatedPriceData.left_lean_roof_pitch_price_changed = true
            if(const_var.a_p_d_a.side[0].lift_type!=undefined && const_var.a_p_d_a.side[0].lift_type!='')
            {
                const_var.UpdatedPriceData.lifttype_price_changed = true;
                params.lift_type = true;
                //params.lifttype_price = const_var.a_p_d_a.side[0].lifttype_price;
            }
        } 
        else {
            if(type != undefined && (type == 'addLeftLean' && state.params.add_left_lean != true)){
                if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.a_p_d_a.old_insulation);

                if(state.params.add_front_lean || state.params.add_back_lean || state.params.add_right_lean) {
                    if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.leanGetDataLeft.central_insulation);
                }
                const_var.UpdatedPriceData.insulation_price = undefined;
                const_var.UpdatedPriceData.insulation_price_changed = true;
            }
        }
        if (const_var.a_p_d_a.connection_fees != undefined && const_var.a_p_d_a.connection_fees.length == 0) {
            const_var.a_p_d_a.connection_fees = const_var.leanGetDataLeft.connection_fees;
        }
        
        //const_var.a_p_d_a.extra_items = const_var.leanGetDataLeft.extra_items;
        dataNew = const_var.leanGetDataLeft;
        let filterRoofPitchData = '';
        if(params.p_r_s==1 && params.m_s_n==13)
        {
            state.const_var.BuildingLRoofPitch = [];
            
            filterRoofPitchData = (dataNew.roof_pitch!=undefined)?dataNew.roof_pitch.filter(data=>params.m_s_n==13 && params.p_r_s==1 && (data.roof_pitch).split("/")[0]<=3):'';
            if(filterRoofPitchData!='' && filterRoofPitchData.length>0)
            {
                dataNew.roof_pitch = JSON.parse(JSON.stringify(filterRoofPitchData));
                if(filterRoofPitchData.filter(data=>data.roof_pitch.split("/")[0]==params.b_l_t_r_p).length==0)
                {
                    let chkData = filterRoofPitchData.filter(data=>data.is_default == "yes");
                    if(chkData.length>0)
                    {
                        params.isDefault_l_t_r_p = params.b_l_t_r_p = (chkData[0].roof_pitch).split("/")[0];
                    }else
                    {
                        params.isDefault_l_t_r_p = params.b_l_t_r_p = (filterRoofPitchData[0].roof_pitch).split("/")[0];
                        cuBuilding.BuildingUpdate(true, '');
                    }
                }
                
            }
        }
        state.params.b_l_t_r_p = state.params.b_l_t_r_p;
        if (dataNew.roof_pitch != undefined && dataNew.roof_pitch.length > 0 ) {
            state.const_var.b_r_p_l_to_a = [];
            for (var i = 0; i <= dataNew.roof_pitch.length - 1; i++) {
                state.const_var.b_r_p_l_to_a[(dataNew.roof_pitch[i].roof_pitch).split("/")[0]] = dataNew.roof_pitch[i];
                state.const_var.BuildingLRoofPitch[dataNew.roof_pitch[i].roof_pitch] = (dataNew.roof_pitch[i].roof_pitch).split("/")[0];
                if (dataNew.roof_pitch[i].is_default == "yes" && const_var.checkforLeanto == true) {

                    let buildingName = const_var.defaultBuildingArr[const_var.BuldingIDforReset] && const_var.defaultBuildingArr[const_var.BuldingIDforReset]?.image_name.split(".").includes("Straight_Roof_Barns")

                    let checkType = params.m_s_n == 3 && buildingName && ( ( const_var.editAPIDataByResponse.data?.main_created_at >= "2024-07-01" && (const_var.crmSetting.is_Edit == true || const_var.isKLinkEnable == true) || (const_var.loginSession == false || const_var.loginSession == true) )) ? true : false
                    params.isDefault_l_t_r_p = params.b_l_t_r_p = (dataNew.roof_pitch[i].roof_pitch).split("/")[0];
                    if(checkType == true){  
                        params.b_l_t_r_p = "3"
                    }
                    cuBuilding.UpdateLeftLean();
                }
                // if(dataNew.roof_pitch[i].is_default=="yes")
                // {
                //      params.isDefault_l_t_r_p = params.b_l_t_r_p = params.b_l_t_r_pR = (dataNew.roof_pitch[i].roof_pitch).split("/")[0];
                //      cuBuilding.B(true,'addLeftLean');
                // }   
            }

        }
        if(const_var.crmSetting.is_Edit == false && const_var.defaultBuildingArr[state.defaultBuilding]!=undefined)
        {
            if(const_var.checkforLeanto == true && const_var.defaultBuildingArr[state.defaultBuilding].leanto_data!=undefined && Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['left']).length>0)
            {
                    params.isDefault_l_t_r_p = params.b_l_t_r_p = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['left'].roof_pitch.split("/")[0];
                    state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['left'].roof_pitch] = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['left'].roof_pitch.split("/")[0];
                    cuBuilding.UpdateLeftLean();
                    
            }else
            {
                if(const_var.checkforLeanto == true && const_var.defaultBuildingArr[state.defaultBuilding].leanto_data!=undefined && Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['left']).length==0 && (const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch!=undefined || const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch!=null))
                {
                    params.isDefault_l_t_r_p = params.b_l_t_r_p = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
                    state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch] = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
                    cuBuilding.UpdateLeftLean();
                }
            }
        }
        
                            
        if (const_var.checkforLeanto == true) {
            const_var.UpdatedPriceData.insulation_price = true;
            const_var.UpdatedPriceData.height_price_changed = true;
            if(params.p_i_o!=0)
            {
                const_var.UpdatedPriceData.roof_style_price_changed = true;
            }
            const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
            //const_var.UpdatedPriceData.roof_style_price_changed = true;
            const_var.UpdatedPriceData.bothLeanto = true;
            const_var.UpdatedPriceData.connection_fee_end_changed = true;
            const_var.UpdatedPriceData.connection_fee_side_changed = true;
            const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
            const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
            const_var.UpdatedPriceData.common_length_changed = true;
            const_var.UpdatedPriceData.left_wall_price_changed = true;
            
        }
        
        
        // const_var.UpdatedPriceData.connection_fee_end_changed = true;
        // const_var.UpdatedPriceData.connection_fee_side_changed = true;
        cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
        const_var.checkforLeanto = false;

        makeDimensionUpdateLeft(state);


    } else if (type == "addFrontLean") {
        const_var.makeCertificateArrayFront = {};
        const_var.leanGetDataFront = (response.success == true) ? response.data : const_var.leanGetDataFront;

        if(params.p_c_i == true && response.success == true && response.data.insulation && const_var.leanGetDataFront && const_var.insulationArrayForLeantoFront.insulation_wall && Object.keys(const_var.insulationArrayForLeantoFront.insulation_wall).length > 0){
            let isInsulationAdded = Object.keys(const_var.insulationArrayForLeantoFront.insulation_wall).find(key => const_var.insulationArrayForLeantoFront.insulation_wall[key] == true)
            params.p_c_i = isInsulationAdded != undefined ? params.p_c_i : false
            params.p_f_i = false
        }

        if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.leanGetDataFront.central_insulation);    
        cuBuilding.makeInsulationArrayForLeanto();
        cuBuilding.makeCertificateArrayLeft('front');
        if (const_var.leanGetDataFront.building_structure!=undefined && const_var.leanGetDataFront.building_structure.length > 0) {
            if (Object.keys(const_var.leanGetDataFront.building_structure[0].conditions).length !== 0) {
                const_var.ConditionArrForLean['front'] = const_var.leanGetDataFront.building_structure[0].conditions['condition'];
                utils.checkReinforcedLeg(const_var.ConditionArrForLean['front'])
                // console.log(const_var.ConditionArrForLean['front'],"const_var.ConditionArrForLean['left'] front 11");

            }
        }
        cuBuilding.CheckLeanLegsByResponse(state,type );
        if(const_var.leanGetDataFront.central_certificate!=undefined && const_var.leanGetDataFront.central_certificate.length>0)
        {
            const_var.a_p_d_a.certificate = const_var.leanGetDataFront.central_certificate;
            cuBuilding.makeCertificateArray();
            if (const_var.crmSetting.is_Edit != true) {
                const_var.UpdatedPriceData.certificate_price_changed = true;  
            } 
            if (params.add_front_lean == false) {
                if (const_var.crmSetting.is_Edit) {
                  utils.updateFourFeetOnCenterPriceWithExtraBowsOnLeanRemoval();
                } else {
                  calculateLegsCount();
                }
                commonFunctionForExtraBows();
              }
              
        }

        if((!const_var.crmSetting.is_Edit || const_var.isPriceAPIcalled) && params.fourth_center_cost==true)
        {
            let quantityval = const_var.ExtraItemsFeaturesArray.findIndex(data => data && (data.name=="fourth_center_cost" || data.label == "4ft on Center") );
            if(quantityval>=0 && params.fourth_center_cost)
            {
                const_var.ExtraItemsFeaturesArray[quantityval].cost = 0;
            }
            if (params.add_front_lean) calculateLegsCount(const_var.leanGetDataFront,'frontLean');
            if (params.add_left_lean) calculateLegsCount(const_var.leanGetDataLeft,'leftLean');
            if (params.add_right_lean) calculateLegsCount(const_var.leanGetDataRight,'rightLean');
            if (params.add_back_lean) calculateLegsCount(const_var.leanGetDataBack,'backLean'); 
        }
        // console.log(const_var.ConditionArrForLean['front'],"ConditionArrForLean15151");
        if (const_var.leanGetDataFront.central_side != undefined && const_var.leanGetDataFront.central_side.length > 0) {
            const_var.a_p_d_a.side = const_var.leanGetDataFront.central_side;
        }
        if (const_var.leanGetDataFront.central_side_full_length != undefined && const_var.leanGetDataFront.central_side_full_length.length > 0) {
            const_var.a_p_d_a.full_length_side = const_var.leanGetDataFront.central_side_full_length;
        }
        // if (const_var.leanGetDataFront.central_insulation != undefined && const_var.leanGetDataFront.central_insulation.length > 0) {
        //     const_var.a_p_d_a.insulation = const_var.leanGetDataFront.central_insulation;
        // }
        if (const_var.leanGetDataFront.central_end != undefined && const_var.leanGetDataFront.central_end.length > 0) {
            const_var.a_p_d_a.end = const_var.leanGetDataFront.central_end;
        }
        if (const_var.leanGetDataFront.central_utility_side != undefined && const_var.leanGetDataFront.central_utility_side.length > 0) {
            const_var.a_p_d_a.utility_side = const_var.leanGetDataFront.central_utility_side;
        }if (const_var.leanGetDataFront.end_combo_v3 != undefined && const_var.leanGetDataFront.end_combo_v3.length > 0) {
            const_var.a_p_d_a.end_combo_v3 = const_var.leanGetDataFront.end_combo_v3;
        }
        if (const_var.leanGetDataFront.side_combo_v3 != undefined && const_var.leanGetDataFront.side_combo_v3.length > 0) {
            const_var.a_p_d_a.side_combo_v3 = const_var.leanGetDataFront.side_combo_v3;
        } if (const_var.leanGetDataFront.central_trusses != undefined && const_var.leanGetDataFront.central_trusses.length > 0) {
            const_var.a_p_d_a.trusses = const_var.leanGetDataFront.central_trusses;
        }
        utils.updateCenterBuildingPricesOnLeanAPICalls(state, "leanGetDataFront",'front');
        if (const_var.crmSetting.is_Edit != true) {
            if(type != undefined && (type == 'addFrontLean' && state.params.add_front_lean != true)){
                if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.a_p_d_a.old_insulation);

                if(state.params.add_left_lean || state.params.add_back_lean || state.params.add_right_lean) {
                    if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.leanGetDataFront.central_insulation);
                }
                const_var.UpdatedPriceData.insulation_price = undefined;
                const_var.UpdatedPriceData.insulation_price_changed = true;
            }
            else{
                const_var.UpdatedPriceData.front_wall_price_changed = true;
                const_var.UpdatedPriceData.back_wall_price_changed = true;
            }
            const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
            const_var.UpdatedPriceData.height_price_changed = true;
            const_var.UpdatedPriceData.certificate_price_changed = true;
            const_var.UpdatedPriceData.wainscot_price_changed = true;
            // const_var.UpdatedPriceData.color_price_changed = true;
            const_var.UpdatedPriceData.roof_color_price_changed = true;
            const_var.UpdatedPriceData.wall_color_price_changed = true;
            const_var.UpdatedPriceData.trim_color_price_changed = true;
            const_var.UpdatedPriceData.front_lean_roof_pitch_price_changed = true
            if(const_var.a_p_d_a.side[0].lift_type!=undefined && const_var.a_p_d_a.side[0].lift_type!='')
            {
                const_var.UpdatedPriceData.lifttype_price_changed = true;
                params.lift_type = true;
                //params.lifttype_price = const_var.a_p_d_a.side[0].lifttype_price;
            }
        } else {
            if(type != undefined && (type == 'addFrontLean' && state.params.add_front_lean != true)){
                if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.a_p_d_a.old_insulation);

                if(state.params.add_left_lean || state.params.add_back_lean || state.params.add_right_lean) {
                    if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.leanGetDataFront.central_insulation);
                }
                const_var.UpdatedPriceData.insulation_price = undefined;
                const_var.UpdatedPriceData.insulation_price_changed = true;
            }
        }
        if (const_var.a_p_d_a.connection_fees != undefined && const_var.a_p_d_a.connection_fees.length == 0) {
            const_var.a_p_d_a.connection_fees = const_var.leanGetDataFront.connection_fees;
        }
        
        //const_var.a_p_d_a.extra_items = const_var.leanGetDataFront.extra_items;
        dataNew = const_var.leanGetDataFront;
        let filterRoofPitchData = '';
        if(params.p_r_s==1 && params.m_s_n==13)
        {
            state.const_var.BuildingLRoofPitch = [];
            
            filterRoofPitchData = (dataNew.roof_pitch!=undefined)?dataNew.roof_pitch.filter(data=>params.m_s_n==13 && params.p_r_s==1 && (data.roof_pitch).split("/")[0]<=3):'';
            if(filterRoofPitchData!='' && filterRoofPitchData.length>0)
            {
                dataNew.roof_pitch = JSON.parse(JSON.stringify(filterRoofPitchData));
                if(filterRoofPitchData.filter(data=>data.roof_pitch.split("/")[0]==params.b_l_t_r_pF).length==0)
                {
                    let chkData = filterRoofPitchData.filter(data=>data.is_default == "yes");
                    if(chkData.length>0)
                    {
                        params.isDefault_l_t_r_p = params.b_l_t_r_pF = (chkData[0].roof_pitch).split("/")[0];
                    }else
                    {
                        params.isDefault_l_t_r_p = params.b_l_t_r_pF = (filterRoofPitchData[0].roof_pitch).split("/")[0];
                        cuBuilding.BuildingUpdate(true, '');
                    }
                }
                
            }
        }
        state.params.b_l_t_r_pF = state.params.b_l_t_r_pF;
        if (dataNew.roof_pitch != undefined && dataNew.roof_pitch.length > 0 ) {
            state.const_var.b_r_p_l_to_a = [];
            for (var i = 0; i <= dataNew.roof_pitch.length - 1; i++) {
                state.const_var.b_r_p_l_to_a[(dataNew.roof_pitch[i].roof_pitch).split("/")[0]] = dataNew.roof_pitch[i];
                state.const_var.BuildingLRoofPitch[dataNew.roof_pitch[i].roof_pitch] = (dataNew.roof_pitch[i].roof_pitch).split("/")[0];
                if (dataNew.roof_pitch[i].is_default == "yes" && const_var.checkforLeanto == true) {
                    params.isDefault_l_t_r_p = params.b_l_t_r_pF = (dataNew.roof_pitch[i].roof_pitch).split("/")[0];
                    cuBuilding.UpdateFrontLean();
                }
                // if(dataNew.roof_pitch[i].is_default=="yes")
                // {
                //      params.isDefault_l_t_r_p = params.b_l_t_r_p = params.b_l_t_r_pR = (dataNew.roof_pitch[i].roof_pitch).split("/")[0];
                //      cuBuilding.B(true,'addLeftLean');
                // }   
            }
        }
        if(const_var.crmSetting.is_Edit == false && const_var.defaultBuildingArr[state.defaultBuilding]!=undefined)
        {
            if(const_var.checkforLeanto == true && const_var.defaultBuildingArr[state.defaultBuilding].leanto_data!=undefined && Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['front']).length>0)
            {
                params.isDefault_l_t_r_p = params.b_l_t_r_pF = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['front'].roof_pitch.split("/")[0];
                state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['front'].roof_pitch] = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['front'].roof_pitch.split("/")[0];
                cuBuilding.UpdateFrontLean();
            }else
            {
                if(const_var.checkforLeanto == true && const_var.defaultBuildingArr[state.defaultBuilding].leanto_data!=undefined && Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['front']).length==0 && (const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch!=undefined || const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch!=null))
                {
                    params.isDefault_l_t_r_p = params.b_l_t_r_pF = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
                    state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch] = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
                    cuBuilding.UpdateFrontLean();
                }
            }
        }
        
        
        // console.log(params.b_l_t_r_pF,"params.b_l_t_r_pF")
        if (const_var.checkforLeanto == true) {
            const_var.UpdatedPriceData.insulation_price = true;
            const_var.UpdatedPriceData.height_price_changed = true;
            if(params.p_i_o!=0)
            {
                const_var.UpdatedPriceData.roof_style_price_changed = true;
            }
            const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
            //const_var.UpdatedPriceData.roof_style_price_changed = true;
            const_var.UpdatedPriceData.bothLeanto = true;
            const_var.UpdatedPriceData.connection_fee_end_changed = true;
            const_var.UpdatedPriceData.connection_fee_side_changed = true;
            const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
            const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
            const_var.UpdatedPriceData.common_length_changed = true;
            const_var.UpdatedPriceData.front_wall_price_changed = true;
        }
        // console.log(const_var.leanGetDataFront,"const_var.leanGetDataFront",type)
        // const_var.UpdatedPriceData.connection_fee_end_changed = true;
        // const_var.UpdatedPriceData.connection_fee_side_changed = true;
        // const_var.UpdatedPriceData.color_price_changed = true;
        
        cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
        const_var.checkforLeanto = false;
        makeDimensionUpdateFront(state);

    } else if (type == "addBackLean") {
        const_var.makeCertificateArrayBack = {};
        const_var.leanGetDataBack = (response.success == true) ? response.data : const_var.leanGetDataBack;

        if(params.p_c_i == true && response.success == true && response.data.insulation && const_var.leanGetDataBack && const_var.insulationArrayForLeantoBack.insulation_wall && Object.keys(const_var.insulationArrayForLeantoBack.insulation_wall).length > 0){
            let isInsulationAdded = Object.keys(const_var.insulationArrayForLeantoBack.insulation_wall).find(key => const_var.insulationArrayForLeantoBack.insulation_wall[key] == true)
            params.p_c_i = isInsulationAdded != undefined ? params.p_c_i : false
            params.p_f_i = false
        }

        if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.leanGetDataBack.central_insulation);
        cuBuilding.makeInsulationArrayForLeanto();
        cuBuilding.makeCertificateArrayLeft('back');
        if (const_var.leanGetDataBack.building_structure!=undefined && const_var.leanGetDataBack.building_structure.length > 0) {
            if (Object.keys(const_var.leanGetDataBack.building_structure[0].conditions).length !== 0) {
                const_var.ConditionArrForLean['back'] = const_var.leanGetDataBack.building_structure[0].conditions['condition'];
                utils.checkReinforcedLeg(const_var.ConditionArrForLean['back'])
                // console.log(const_var.ConditionArrForLean['back'],"const_var.ConditionArrForLean['left'] back 11");

            }
        }
        cuBuilding.CheckLeanLegsByResponse(state,type );
        if(const_var.leanGetDataBack.central_certificate!=undefined && const_var.leanGetDataBack.central_certificate.length>0)
        {
            const_var.a_p_d_a.certificate = const_var.leanGetDataBack.central_certificate;
            cuBuilding.makeCertificateArray();
            if (const_var.crmSetting.is_Edit != true) {
                const_var.UpdatedPriceData.certificate_price_changed = true;  
            }
            if (params.add_back_lean==false)  {
                if (const_var.crmSetting.is_Edit) {
                  utils.updateFourFeetOnCenterPriceWithExtraBowsOnLeanRemoval();
                } else {
                  calculateLegsCount();
                }
                commonFunctionForExtraBows();
            }
        }
       
        if((!const_var.crmSetting.is_Edit || const_var.isPriceAPIcalled) && params.fourth_center_cost==true)
        {
            let quantityval = const_var.ExtraItemsFeaturesArray.findIndex(data => data && (data.name=="fourth_center_cost" || data.label == "4ft on Center"));
            if(quantityval>=0 && params.fourth_center_cost)
            {
                const_var.ExtraItemsFeaturesArray[quantityval].cost = 0;
            }
            if (params.add_back_lean) calculateLegsCount(const_var.leanGetDataBack,'backLean');
            if (params.add_front_lean) calculateLegsCount(const_var.leanGetDataFront,'frontLean');
            if (params.add_left_lean) calculateLegsCount(const_var.leanGetDataLeft,'leftLean');
            if (params.add_right_lean) calculateLegsCount(const_var.leanGetDataRight,'rightLean');
        }
        if (const_var.leanGetDataBack.central_side != undefined && const_var.leanGetDataBack.central_side.length > 0) {
            const_var.a_p_d_a.side = const_var.leanGetDataBack.central_side;
        }
        // if (const_var.leanGetDataBack.central_insulation != undefined && const_var.leanGetDataBack.central_insulation.length > 0) {
        //     const_var.a_p_d_a.insulation = const_var.leanGetDataBack.central_insulation;
        // }
        if (const_var.leanGetDataBack.central_side_full_length != undefined && const_var.leanGetDataBack.central_side_full_length.length > 0) {
            const_var.a_p_d_a.full_length_side = const_var.leanGetDataBack.central_side_full_length;
        }
        if (const_var.leanGetDataBack.central_end != undefined && const_var.leanGetDataBack.central_end.length > 0) {
            const_var.a_p_d_a.end = const_var.leanGetDataBack.central_end;
        }
        if (const_var.leanGetDataBack.central_utility_side != undefined && const_var.leanGetDataBack.central_utility_side.length > 0) {
            const_var.a_p_d_a.utility_side = const_var.leanGetDataBack.central_utility_side;
        }if (const_var.leanGetDataBack.end_combo_v3 != undefined && const_var.leanGetDataBack.end_combo_v3.length > 0) {
            const_var.a_p_d_a.end_combo_v3 = const_var.leanGetDataBack.end_combo_v3;
        }
        if (const_var.leanGetDataBack.side_combo_v3 != undefined && const_var.leanGetDataBack.side_combo_v3.length > 0) {
            const_var.a_p_d_a.side_combo_v3 = const_var.leanGetDataBack.side_combo_v3;
        } if (const_var.leanGetDataBack.central_trusses != undefined && const_var.leanGetDataBack.central_trusses.length > 0) {
            const_var.a_p_d_a.trusses = const_var.leanGetDataBack.central_trusses;
        }
        utils.updateCenterBuildingPricesOnLeanAPICalls(state, "leanGetDataBack",'back');
        if (const_var.crmSetting.is_Edit != true) {
            if(type != undefined && (type == 'addBackLean' && state.params.add_back_lean != true)){
                if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.a_p_d_a.old_insulation); 

                if(state.params.add_left_lean || state.params.add_front_lean || state.params.add_right_lean) {
                    if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.leanGetDataBack.central_insulation);
                }
                const_var.UpdatedPriceData.insulation_price = undefined;
                const_var.UpdatedPriceData.insulation_price_changed = true;
            }
            else{
                const_var.UpdatedPriceData.front_wall_price_changed = true;
                const_var.UpdatedPriceData.back_wall_price_changed = true;
            }
            const_var.UpdatedPriceData.height_price_changed = true;
            const_var.UpdatedPriceData.certificate_price_changed = true;
            const_var.UpdatedPriceData.wainscot_price_changed = true;
            const_var.UpdatedPriceData.roof_color_price_changed = true;
            const_var.UpdatedPriceData.wall_color_price_changed = true;
            const_var.UpdatedPriceData.trim_color_price_changed = true;
            const_var.UpdatedPriceData.back_lean_roof_pitch_price_changed = true
            const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
            if(const_var.a_p_d_a.side[0].lift_type!=undefined && const_var.a_p_d_a.side[0].lift_type!='')
            {
                const_var.UpdatedPriceData.lifttype_price_changed = true;
                params.lift_type = true;
                //params.lifttype_price = const_var.a_p_d_a.side[0].lifttype_price;
            }
        }
        else {
            if(type != undefined && (type == 'addBackLean' && state.params.add_back_lean != true)){
                if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.a_p_d_a.old_insulation);

                if(state.params.add_left_lean || state.params.add_front_lean || state.params.add_right_lean) {
                    if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.leanGetDataBack.central_insulation);
                }
                const_var.UpdatedPriceData.insulation_price = undefined;
                const_var.UpdatedPriceData.insulation_price_changed = true;
            }
        }
        if (const_var.a_p_d_a.connection_fees != undefined && const_var.a_p_d_a.connection_fees.length == 0) {
            const_var.a_p_d_a.connection_fees = const_var.leanGetDataBack.connection_fees;
        }
        
        //const_var.a_p_d_a.extra_items = const_var.leanGetDataBack.extra_items;
        dataNew = const_var.leanGetDataBack;
        let filterRoofPitchData = '';
        if(params.p_r_s==1 && params.m_s_n==13)
        {
            state.const_var.BuildingLRoofPitch = [];
            
            filterRoofPitchData = (dataNew.roof_pitch!=undefined)?dataNew.roof_pitch.filter(data=>params.m_s_n==13 && params.p_r_s==1 && (data.roof_pitch).split("/")[0]<=3):'';
            if(filterRoofPitchData!='' && filterRoofPitchData.length>0)
            {
                dataNew.roof_pitch = JSON.parse(JSON.stringify(filterRoofPitchData));
                if(filterRoofPitchData.filter(data=>data.roof_pitch.split("/")[0]==params.b_l_t_r_pB).length==0)
                {
                    let chkData = filterRoofPitchData.filter(data=>data.is_default == "yes");
                    if(chkData.length>0)
                    {
                        params.isDefault_l_t_r_p = params.b_l_t_r_pB = (chkData[0].roof_pitch).split("/")[0];
                    }else
                    {
                        params.isDefault_l_t_r_p = params.b_l_t_r_pB = (filterRoofPitchData[0].roof_pitch).split("/")[0];
                        cuBuilding.BuildingUpdate(true, '');
                    }
                }
                
            }
        }
        state.params.b_l_t_r_pB = state.params.b_l_t_r_pB;
        if (dataNew.roof_pitch != undefined && dataNew.roof_pitch.length > 0 ) {
            state.const_var.b_r_p_l_to_a = [];
            for (var i = 0; i <= dataNew.roof_pitch.length - 1; i++) {
                state.const_var.b_r_p_l_to_a[(dataNew.roof_pitch[i].roof_pitch).split("/")[0]] = dataNew.roof_pitch[i];
                state.const_var.BuildingLRoofPitch[dataNew.roof_pitch[i].roof_pitch] = (dataNew.roof_pitch[i].roof_pitch).split("/")[0];
                if (dataNew.roof_pitch[i].is_default == "yes" && const_var.checkforLeanto == true) {
                    params.isDefault_l_t_r_p = params.b_l_t_r_pB = (dataNew.roof_pitch[i].roof_pitch).split("/")[0];
                    cuBuilding.UpdateBackLean();
                }
                // if(dataNew.roof_pitch[i].is_default=="yes")
                // {
                //      params.isDefault_l_t_r_p = params.b_l_t_r_p = params.b_l_t_r_pR = (dataNew.roof_pitch[i].roof_pitch).split("/")[0];
                //      cuBuilding.B(true,'addLeftLean');
                // }   
            }
        }
        if(const_var.crmSetting.is_Edit == false && const_var.defaultBuildingArr[state.defaultBuilding]!=undefined)
        {
            if(const_var.checkforLeanto == true && const_var.defaultBuildingArr[state.defaultBuilding].leanto_data!=undefined && Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['back']).length>0)
            {
                params.isDefault_l_t_r_p = params.b_l_t_r_pB = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['back'].roof_pitch.split("/")[0];
                state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['back'].roof_pitch] = (const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['back'].roof_pitch).split("/")[0];
                cuBuilding.UpdateBackLean();
            }else
            {
                if(const_var.checkforLeanto == true && const_var.defaultBuildingArr[state.defaultBuilding].leanto_data!=undefined && Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['back']).length==0 && (const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch!=undefined || const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch!=null))
                {
                    params.isDefault_l_t_r_p = params.b_l_t_r_pB = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
                    state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch] = (const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch).split("/")[0];
                    cuBuilding.UpdateBackLean();
                }
            }
        }
        
       
        if (const_var.checkforLeanto == true) {
            const_var.UpdatedPriceData.insulation_price = true;
            const_var.UpdatedPriceData.height_price_changed = true;
            if(params.p_i_o!=0)
            {
                const_var.UpdatedPriceData.roof_style_price_changed = true;
            }
            const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
            //const_var.UpdatedPriceData.roof_style_price_changed = true;
            const_var.UpdatedPriceData.bothLeanto = true;
            const_var.UpdatedPriceData.connection_fee_end_changed = true;
            const_var.UpdatedPriceData.connection_fee_side_changed = true;
            const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
            const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
            const_var.UpdatedPriceData.common_length_changed = true;
            const_var.UpdatedPriceData.back_wall_price_changed = true;
        }
        // console.log(const_var.leanGetDataBack,"const_var.leanGetDataBack",type)
        // const_var.UpdatedPriceData.connection_fee_end_changed = true;
        // const_var.UpdatedPriceData.connection_fee_side_changed = true;
        // const_var.UpdatedPriceData.color_price_changed = true;
        
        cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
        const_var.checkforLeanto = false;
        makeDimensionUpdateBack(state);

    } else if (type == "addRightLean") {
        const_var.makeCertificateArrayRight = {};
        const_var.leanGetDataRight = (response.success == true) ? response.data : const_var.leanGetDataRight;

        if(params.p_c_i == true && response.success == true && response.data.insulation && const_var.leanGetDataRight && const_var.insulationArrayForLeantoRight.insulation_wall && Object.keys(const_var.insulationArrayForLeantoRight.insulation_wall).length > 0){
            let isInsulationAdded = Object.keys(const_var.insulationArrayForLeantoRight.insulation_wall).find(key => const_var.insulationArrayForLeantoRight.insulation_wall[key] == true)
            params.p_c_i = isInsulationAdded != undefined ? params.p_c_i : false
            params.p_f_i = false
        }

        if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.leanGetDataRight.central_insulation);
        cuBuilding.makeInsulationArrayForLeanto();
        cuBuilding.makeCertificateArrayLeft('right');
        if (const_var.leanGetDataRight.building_structure!=undefined && const_var.leanGetDataRight.building_structure.length > 0) {
            if (Object.keys(const_var.leanGetDataRight.building_structure[0].conditions).length !== 0) {
                const_var.ConditionArrForLean['right'] = const_var.leanGetDataRight.building_structure[0].conditions['condition'];
                utils.checkReinforcedLeg(const_var.ConditionArrForLean['right'])
                // console.log(const_var.ConditionArrForLean['right'],"const_var.ConditionArrForLean['left'] right 11");

            }
        }
        cuBuilding.CheckLeanLegsByResponse(state,type );
        if(const_var.leanGetDataRight.central_certificate!=undefined && const_var.leanGetDataRight.central_certificate.length>0)
        {
            const_var.a_p_d_a.certificate = const_var.leanGetDataRight.central_certificate;
            cuBuilding.makeCertificateArray();
            if (const_var.crmSetting.is_Edit != true) {
                const_var.UpdatedPriceData.certificate_price_changed = true;  
            }
            if (params.add_right_lean==false)  {
                if (const_var.crmSetting.is_Edit) {
                  utils.updateFourFeetOnCenterPriceWithExtraBowsOnLeanRemoval();
                } else {
                  calculateLegsCount();
                }
                commonFunctionForExtraBows();
              }
        }
        if((!const_var.crmSetting.is_Edit || const_var.isPriceAPIcalled) && params.fourth_center_cost==true)
        {
            let quantityval = const_var.ExtraItemsFeaturesArray.findIndex(data => data && (data.name=="fourth_center_cost" || data.label == "4ft on Center"));
            if(quantityval>=0 && params.fourth_center_cost)
            {
                const_var.ExtraItemsFeaturesArray[quantityval].cost = 0;
            }
            if (params.add_right_lean) calculateLegsCount(const_var.leanGetDataRight,'rightLean');
            if (params.add_front_lean) calculateLegsCount(const_var.leanGetDataFront,'frontLean');
            if (params.add_left_lean) calculateLegsCount(const_var.leanGetDataLeft,'leftLean');
            if (params.add_back_lean) calculateLegsCount(const_var.leanGetDataBack,'backLean'); 
        }
        if (const_var.leanGetDataRight.central_side != undefined && const_var.leanGetDataRight.central_side.length > 0) {
            const_var.a_p_d_a.side = const_var.leanGetDataRight.central_side;
        }
        if (const_var.leanGetDataRight.central_side_full_length != undefined && const_var.leanGetDataRight.central_side_full_length.length > 0) {
            const_var.a_p_d_a.full_length_side = const_var.leanGetDataRight.central_side_full_length;
        }
        // if (const_var.leanGetDataRight.central_insulation != undefined && const_var.leanGetDataRight.central_insulation.length > 0) {
        //     const_var.a_p_d_a.insulation = const_var.leanGetDataRight.central_insulation;
        // }
        if (const_var.leanGetDataRight.central_end != undefined && const_var.leanGetDataRight.central_end.length > 0) {
            const_var.a_p_d_a.end = const_var.leanGetDataRight.central_end;
        }
        if (const_var.leanGetDataRight.central_utility_side != undefined && const_var.leanGetDataRight.central_utility_side.length > 0) {
            const_var.a_p_d_a.utility_side = const_var.leanGetDataRight.central_utility_side;
        }if (const_var.leanGetDataRight.end_combo_v3 != undefined && const_var.leanGetDataRight.end_combo_v3.length > 0) {
            const_var.a_p_d_a.end_combo_v3 = const_var.leanGetDataRight.end_combo_v3;
        }
        if (const_var.leanGetDataRight.side_combo_v3 != undefined && const_var.leanGetDataRight.side_combo_v3.length > 0) {
            const_var.a_p_d_a.side_combo_v3 = const_var.leanGetDataRight.side_combo_v3;
        } if (const_var.leanGetDataRight.central_trusses != undefined && const_var.leanGetDataRight.central_trusses.length > 0) {
            const_var.a_p_d_a.trusses = const_var.leanGetDataRight.central_trusses;
        }
        utils.updateCenterBuildingPricesOnLeanAPICalls(state, "leanGetDataRight",'right');
        if (const_var.crmSetting.is_Edit != true) {
            if(type != undefined && (type == 'addRightLean' && state.params.add_right_lean != true )){
                if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.a_p_d_a.old_insulation);

                if(state.params.add_left_lean || state.params.add_front_lean || state.params.add_back_lean) {
                    if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.leanGetDataRight.central_insulation);
                }
                const_var.UpdatedPriceData.insulation_price = undefined;
                const_var.UpdatedPriceData.insulation_price_changed = true;

            }
            else{
                const_var.UpdatedPriceData.front_wall_price_changed = true;
                const_var.UpdatedPriceData.back_wall_price_changed = true;
            }
            const_var.UpdatedPriceData.height_price_changed = true;
            const_var.UpdatedPriceData.certificate_price_changed = true;
            const_var.UpdatedPriceData.wainscot_price_changed = true;
            // const_var.UpdatedPriceData.color_price_changed = true;
            const_var.UpdatedPriceData.roof_color_price_changed = true;
            const_var.UpdatedPriceData.wall_color_price_changed = true;
            const_var.UpdatedPriceData.trim_color_price_changed = true;
            const_var.UpdatedPriceData.right_lean_roof_pitch_price_changed = true
            const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
            if(const_var.a_p_d_a.side[0].lift_type!=undefined && const_var.a_p_d_a.side[0].lift_type!='')
            {
                const_var.UpdatedPriceData.lifttype_price_changed = true;
                params.lift_type = true;
                //params.lifttype_price = const_var.a_p_d_a.side[0].lifttype_price;
            }
        }
        else {
            if(type != undefined && (type == 'addRightLean' && state.params.add_right_lean != true )){
                if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.a_p_d_a.old_insulation);

                if(state.params.add_left_lean || state.params.add_front_lean || state.params.add_back_lean) {
                    if (params.p_i_o != 0 && params.p_f_i) utils.updateCenterBuildingInsulation(const_var.leanGetDataRight.central_insulation);
                }
                const_var.UpdatedPriceData.insulation_price = undefined;
                const_var.UpdatedPriceData.insulation_price_changed = true;
            }
        }
        if (const_var.a_p_d_a.connection_fees != undefined && const_var.a_p_d_a.connection_fees.length == 0) {
            const_var.a_p_d_a.connection_fees = const_var.leanGetDataRight.connection_fees;
        }
        
        // const_var.a_p_d_a.extra_items = const_var.leanGetDataRight.extra_items;
        dataNew = const_var.leanGetDataRight;
        let filterRoofPitchData = '';
        if(params.p_r_s==1 && params.m_s_n==13)
        {
            state.const_var.BuildingLRoofPitch = [];
            
            filterRoofPitchData = (dataNew.roof_pitch!=undefined)?dataNew.roof_pitch.filter(data=>params.m_s_n==13 && params.p_r_s==1 && (data.roof_pitch).split("/")[0]<=3):'';
            if(filterRoofPitchData!='' && filterRoofPitchData.length>0)
            {
                dataNew.roof_pitch = JSON.parse(JSON.stringify(filterRoofPitchData));
                if(filterRoofPitchData.filter(data=>data.roof_pitch.split("/")[0]==params.b_l_t_r_pR).length==0)
                {
                    let chkData = filterRoofPitchData.filter(data=>data.is_default == "yes");
                    if(chkData.length>0)
                    {
                        params.isDefault_l_t_r_p = params.b_l_t_r_pR = (chkData[0].roof_pitch).split("/")[0];
                    }else
                    {
                        params.isDefault_l_t_r_p = params.b_l_t_r_pR = (filterRoofPitchData[0].roof_pitch).split("/")[0];
                        cuBuilding.BuildingUpdate(true, '');
                    }
                }
                
            }
        }
        state.params.b_l_t_r_pR = state.params.b_l_t_r_pR;
        if (dataNew.roof_pitch != undefined && dataNew.roof_pitch.length > 0 ) {
            state.const_var.b_r_p_l_to_a = [];
            for (var i = 0; i <= dataNew.roof_pitch.length - 1; i++) {
                state.const_var.b_r_p_l_to_a[(dataNew.roof_pitch[i].roof_pitch).split("/")[0]] = dataNew.roof_pitch[i];
                state.const_var.BuildingLRoofPitch[dataNew.roof_pitch[i].roof_pitch] = (dataNew.roof_pitch[i].roof_pitch).split("/")[0];
                if (dataNew.roof_pitch[i].is_default == "yes" && const_var.checkforLeanto == true) {
                    let buildingName = const_var.defaultBuildingArr[const_var.BuldingIDforReset] && const_var.defaultBuildingArr[const_var.BuldingIDforReset]?.image_name.split(".").includes("Straight_Roof_Barns")

                    let checkType = params.m_s_n == 3 && buildingName && ( ( const_var.editAPIDataByResponse.data?.main_created_at >= "2024-07-01" && (const_var.crmSetting.is_Edit == true || const_var.isKLinkEnable == true) || (const_var.loginSession == false || const_var.loginSession == true) )) ? true : false

                    params.isDefault_l_t_r_p = params.b_l_t_r_pR = (dataNew.roof_pitch[i].roof_pitch).split("/")[0];
                    if(checkType == true){  
                        params.b_l_t_r_pR = "3"
                    }
                    cuBuilding.UpdateRightLean();
                }

                // if(dataNew.roof_pitch[i].is_default=="yes" && state.params.b_l_t_r_p!="")
                // {
                //      params.isDefault_l_t_r_p = params.b_l_t_r_p = params.b_l_t_r_pR = (dataNew.roof_pitch[i].roof_pitch).split("/")[0];
                // }            
            }
        }
        if(const_var.crmSetting.is_Edit == false && const_var.defaultBuildingArr[state.defaultBuilding]!=undefined)
        {
            if(const_var.checkforLeanto == true && const_var.defaultBuildingArr[state.defaultBuilding].leanto_data!=undefined && Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['right']).length>0)
            {
                params.isDefault_l_t_r_p = params.b_l_t_r_pR = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['right'].roof_pitch.split("/")[0];
                state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['right'].roof_pitch] = (const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['right'].roof_pitch).split("/")[0];
                cuBuilding.UpdateRightLean();
            }else{
                if(const_var.checkforLeanto == true && const_var.defaultBuildingArr[state.defaultBuilding].leanto_data!=undefined && Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data['right']).length==0 && (const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch!=undefined || const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch!=null))
                {
                    params.isDefault_l_t_r_p = params.b_l_t_r_pR = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
                    state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch] = (const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch).split("/")[0];
                    cuBuilding.UpdateRightLean();
                }
            }
        }
        
        if (const_var.checkforLeanto == true) {
            const_var.UpdatedPriceData.insulation_price = true;
            const_var.UpdatedPriceData.height_price_changed = true;
            if(params.p_i_o!=0)
            {
                const_var.UpdatedPriceData.roof_style_price_changed = true;
            }
            const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
            const_var.UpdatedPriceData.bothLeanto = true;
            const_var.UpdatedPriceData.connection_fee_end_changed = true;
            const_var.UpdatedPriceData.connection_fee_side_changed = true;
            const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
            const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
            const_var.UpdatedPriceData.right_wall_price_changed = true;
            if (params.p_j_t == true) {
                const_var.UpdatedPriceData.common_length_changed = true;
            }
        }
        // const_var.UpdatedPriceData.connection_fee_end_changed = true;
        // const_var.UpdatedPriceData.connection_fee_side_changed = true;
        cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
        const_var.checkforLeanto = false;
        makeDimensionUpdateRight(state);

        ////cuComponent.autoRotateBuilding(state,"Right");

    }
        //--- front lean wall
        if(state.params.p_b_c_b_f_l == "Close" && state.params.p_b_c_b_f_b == "Close" && state.params.p_b_c_b_f_f == "Close"){
            const_var.setLeanWallOption.frontLean = 'close'
        }else if(state.params.p_b_c_b_f_l == "Open" && state.params.p_b_c_b_f_b == "Open" && state.params.p_b_c_b_f_f == "Open"){
            const_var.setLeanWallOption.frontLean = 'open'
        }else{
            const_var.setLeanWallOption.frontLean = 'partial'
        }
        //--- right lean wall
        if(state.params.p_b_c_b_r == "Close" && state.params.p_b_c_b_r_b == "Close" && state.params.p_b_c_b_r_f == "Close"){
            const_var.setLeanWallOption.rightLean = 'close'
        }else if(state.params.p_b_c_b_r == "Open" && state.params.p_b_c_b_r_b == "Open" && state.params.p_b_c_b_r_f == "Open"){
            const_var.setLeanWallOption.rightLean = 'open'
        }else{
            const_var.setLeanWallOption.rightLean = 'partial'
        }
        //--- left lean wall
        if(state.params.p_b_c_b_l == "Close" && state.params.p_b_c_b_l_b == "Close" && state.params.p_b_c_b_l_f == "Close"){
            const_var.setLeanWallOption.leftLean = 'close'
        }else if(state.params.p_b_c_b_l == "Open" && state.params.p_b_c_b_l_b == "Open" && state.params.p_b_c_b_l_f == "Open"){
            const_var.setLeanWallOption.leftLean = 'open'
        }else{
            const_var.setLeanWallOption.leftLean = 'partial'
        }
        //--- back lean wall
        if(state.params.p_b_c_b_b_l == "Close" && state.params.p_b_c_b_b_b == "Close" && state.params.p_b_c_b_b_f == "Close"){
            const_var.setLeanWallOption.backLean = 'close'
        }else if(state.params.p_b_c_b_b_l == "Open" && state.params.p_b_c_b_b_b == "Open" && state.params.p_b_c_b_b_f == "Open"){
            const_var.setLeanWallOption.backLean = 'open'
        }else{
            const_var.setLeanWallOption.backLean = 'partial'
        }
    if(const_var.crmSetting.is_Edit==true)
    {
        if(const_var.c_f_aCer[params.p_e_i]!=undefined)
        {
            utils.calculateFourthCenterCostwithExtraBows();
        }
    }
    
    const_var.is_loader = false;
    state.is_checked_loader = const_var.is_loader;
    dynamicWallOptions(state, type);
    if (state.params.p_w_c_n == true) {
    }
    cuBuilding.BuildingUpdate(true);

}
const AddDoorComponentonWall = async(compType, compName, wall, componentsize, parentkey, childkey, nestedkey,rot,pos,is_edit,parentOBJ, buildingType) =>{
    // console.log('giorgi- AddDoorComponentonWall: ', {compType, compName, wall, componentsize, parentkey, childkey, nestedkey,rot,pos,is_edit,parentOBJ, buildingType});
    let prom = Promise.resolve(undefined);
    return new Promise((res, rej) => {
        const_var.removed_door = '';
        const_var.AddDoorComponentonWallRes = res;
        if(rot!=undefined && pos!=undefined)
        {
            const newfuncforDoorWindows = (compType, compName, wall, componentsize, parentkey, childkey, nestedkey,rot,pos,is_edit,parentOBJ, buildingType) => {
                prom = prom.then(async(res, rej) => {
                                commonFunctionForColor(componentsize, parentkey, childkey, nestedkey,false,parentOBJ);
                                const ans = await cuComponent.loadDoorComponentOnWall(compType, compName, wall, componentsize, parentkey, childkey, nestedkey,rot,pos,undefined,parentOBJ, buildingType);
                            });                        
                        } 

                        newfuncforDoorWindows(compType, compName, wall, componentsize, parentkey, childkey, nestedkey,rot,pos,is_edit,parentOBJ, buildingType);

        }else{
            const newfuncforDoorWindows = (compType, compName, wall, componentsize, parentkey, childkey, nestedkey,rot,pos,is_edit,parentOBJ, buildingType) => {
                prom = prom.then(async(res, rej) => {
                                commonFunctionForColor(componentsize, parentkey, childkey, nestedkey);
                                //const ans = await cuComponent.loadDoorComponentOnWall(compType, compName, wall, componentsize, parentkey, childkey, nestedkey, rot, pos, is_edit);
                                const ans = await cuComponent.loadDoorComponentOnWall(compType, compName, wall, componentsize, parentkey, childkey, nestedkey);
                            });                        
                        } 

                        newfuncforDoorWindows(compType, compName, wall, componentsize, parentkey, childkey, nestedkey,rot,pos,is_edit,parentOBJ, buildingType);

       }
        
    })
    //cuBuilding.calculateDoorComponentPrice(true);
}
export const commonFunctionForComponent = ()=>{
    // console.log('giorgi- commonFunctionForComponent: ');
        let chkDoorIsExist = '';
        let newEntryData = JSON.parse(JSON.stringify(const_var.entry_points));
        if(newEntryData.length>0 && const_var.crmSetting.is_Edit==true)
        {
            newEntryData.map((data,i)=>{
                if(const_var.newComponentArray[data.parent_array_key]!=undefined)
                {
                    if(const_var.newComponentArray[data.parent_array_key][data.child_array_key]!=undefined && const_var.newComponentArray[data.parent_array_key][data.child_array_key][data.nested_array_key]!=undefined)
                    {
                        chkDoorIsExist = const_var.newComponentArray[data.parent_array_key][data.child_array_key][data.nested_array_key]['Size'][data.name];
                        if(data.entry_doorNewType != "Custom Size" && (const_var.newComponentArray[data.parent_array_key][data.child_array_key][data.nested_array_key]==undefined || const_var.newComponentArray[data.parent_array_key][data.child_array_key][data.nested_array_key]['Size'][data.name]==undefined))
                        {
                            cuComponent.RemoveDoorComponent(data.uniqueId, data.component_name)
                        }
                    }else{
                        cuComponent.RemoveDoorComponent(data.uniqueId, data.component_name)
                    }
                }else{
                    cuComponent.RemoveDoorComponent(data.uniqueId, data.component_name)
                }      
            })

        }
}
export const commonFunctionForColor = (componentsize, parentkey, childkey, nestedkey,chkColor,currentComponentData) =>{
    // console.log(componentsize, parentkey, childkey, nestedkey,chkColor,currentComponentData,"componentsize, parentkey, childkey, nestedkey,chkColor,currentComponentData")
    let objData = (const_var.newComponentArray[parentkey][childkey][nestedkey]!=undefined)?const_var.newComponentArray[parentkey][childkey][nestedkey]['Size'][componentsize]:undefined;
    if(objData!=undefined && objData.color_cost_combination!=undefined && typeof objData.color_cost_combination=="string")
    {
        let newParseData = JSON.parse(objData.color_cost_combination);
        objData.color_cost_combination = (newParseData.color_cost_data!=undefined)?newParseData.color_cost_data:newParseData;
    }
    if(objData!=undefined && parentkey=="Garage" && objData.color_cost_combination!=undefined && objData.color_cost_combination!=null && objData.color_cost_combination.length>0)
    {
        const_var.garageDoorColor = [];
        if(currentComponentData!=undefined)
        {
            if(currentComponentData.entry_garageDoor_color_Obj!=undefined)
            {
                params.g_d_c_id = currentComponentData.entry_garageDoor_color_Obj.id;
                params.g_d_c_name = currentComponentData.entry_garageDoor_color_Obj.name;
                params.g_d_c = currentComponentData.entry_garageDoor_color_Obj.hex_value.replace('#', '0x');
                // console.log(params.g_d_c,"params.g_d_c")
            }
        }
        params.g_d_c_id = (chkColor==undefined)?'':params.g_d_c_id;
        objData.color_cost_combination.map((data,index)=>{
            data.color.map((value,key)=>{
                let findData = const_var.SendAPIBuildingData.garageDoorColor.find(findData=>findData?.hex_value==value);
                if(findData!=undefined)
                {
                    if(params.g_d_c_id=='')
                    {
                        params.g_d_c_name = findData.name;
                        params.g_d_c_id = findData.id;
                        params.g_d_c = findData.hex_value.replace('#', '0x');
                    }
                    // console.log(params.g_d_c,"params.g_d_c11")
                    findData.cost = data.cost;
                    findData.percentage_of_cost = data.cost_type=="$"?0:1;
                    findData.is_show = true;
                    const_var.garageDoorColor[findData.id] = findData;
                }
            })
            
        })
        if(const_var.garageDoorColor.length==0)
        {
            params.g_d_c_id = '';
            for (var i = 0; i <= const_var.SendAPIBuildingData.garageDoorColor.length - 1; i++) {
                params.g_d_c_name = const_var.SendAPIBuildingData.garageDoorColor[0].name;
                params.g_d_c_id = const_var.SendAPIBuildingData.garageDoorColor[0].id;
                params.g_d_c = const_var.SendAPIBuildingData.garageDoorColor[0].hex_value.replace('#', '0x');

                const_var.garageDoorColor[const_var.SendAPIBuildingData.garageDoorColor[i].id] = const_var.SendAPIBuildingData.garageDoorColor[i];
            }
            // console.log(params.g_d_c,"params.g_d_c222")
        }
        if (chkColor==undefined && (params.g_d_c != '0xffffff' || params.g_d_c != "#FFFFFF" || params.g_d_c != "#e8ebeb")) {
            let findwhiteColor =  const_var.garageDoorColor.find(color => color?.hex_value == "#ffffff" || color?.hex_value == "#FFFFFF" || color?.hex_value == "#e8ebeb" );
            if (findwhiteColor) {
                params.g_d_c_name = findwhiteColor.name;
                params.g_d_c_id = findwhiteColor.id;
                params.g_d_c = findwhiteColor.hex_value.replace('#', '0x');
            }
            // console.log(params.g_d_c,"params.g_d_c")
        }else{
            let findwhiteColor =  const_var.garageDoorColor.find(color => color?.id == params.g_d_c_id );
            if(findwhiteColor==undefined)
            {
                let findwhiteColorNew =  const_var.garageDoorColor.find(color => color?.hex_value == "#ffffff" || color?.hex_value == "#FFFFFF" || color?.hex_value == "#e8ebeb" );
                if (findwhiteColorNew) {
                    params.g_d_c_name = findwhiteColorNew.name;
                    params.g_d_c_id = findwhiteColorNew.id;
                    params.g_d_c = findwhiteColorNew.hex_value.replace('#', '0x');
                }
            }
            // console.log(params.g_d_c,"params.g_d_c")
        }
    }else{

         params.g_d_c_id = '';
         for (var i = 0; i <= const_var.SendAPIBuildingData.garageDoorColor.length - 1; i++) {
            params.g_d_c_name = const_var.SendAPIBuildingData.garageDoorColor[0].name;
            params.g_d_c_id = const_var.SendAPIBuildingData.garageDoorColor[0].id;
            params.g_d_c = const_var.SendAPIBuildingData.garageDoorColor[0].hex_value.replace('#', '0x');

            const_var.garageDoorColor[const_var.SendAPIBuildingData.garageDoorColor[i].id] = const_var.SendAPIBuildingData.garageDoorColor[i];
        }
    }
}
const updateBreezewayFrameAndStorages =(action, currentLength, height, length,popularSize,dimensionType) => {
    // console.log('giorgi- updateBreezewayFrameAndStorages: ', {action, currentLength, height, length,popularSize,dimensionType});
    // console.log(action,currentLength, "currentLength",height ,"height",params.cB_addStorage_front,params.p_u_t, const_var.breezewayLength);
    let breezewayFrameouts,leftFrameout,rightFrameout,size = '10x10',prevFrameLength,prevFrontStorageLength,prevBackStorageLength, posOffset = -0.09 ;
    const distanceOncenter = const_var.DistanceArr[params.p_b_t][params.p_r_s];
    // console.log({distanceOncenter});
    const maxBreezewayLength = 20;
    // breezewayFrameouts = const_var.entry_points.filter(door => ((door.uniqueName == "standard_door1" && door.uniqueId==1 )|| (door.uniqueName == "standard_door2" && door.uniqueId==2))); 
    breezewayFrameouts = const_var.entry_points.filter(door => (door.is_breezeway_frameout!==undefined && door.is_breezeway_frameout === true)); 
    // console.log({breezewayFrameouts});
    leftFrameout = breezewayFrameouts.length > 0 && breezewayFrameouts.find(door => door.component_wall_name == "c_b_l_w" );
    rightFrameout = breezewayFrameouts.length > 0 && breezewayFrameouts.find(door => door.component_wall_name == "c_b_r_w" );
    prevFrameLength =  Number(leftFrameout.entry_dimension_width);
    prevFrontStorageLength = Number(params.cB_addStorage_front);
    prevBackStorageLength = Number(params.p_u_t);
    // console.log({prevFrameLength,prevFrontStorageLength,prevBackStorageLength});
    
    if (action.option == "frameout") {
        if (currentLength!= undefined){
            const_var.breezewayLength = currentLength;
            size = currentLength+'x'+Number(params.p_h);
            // console.log(size,currentLength,"currentLength",(currentLength < prevFrameLength),(currentLength > prevFrameLength));
            /* while performing the operation on frameout( change in frameout size form breezeway size dropdown)
               then we are keeping back storage length as const until frontstorage length becomes Min 
               once front storage reaches min length the we started reducing the size of back storage
            
               In here the first condiiotn will excute when we decrease the frameout width
               
               In second when we increase the frameout width once it reach to front storage min then the else if condsiton will excute
            */

            if ( (currentLength < prevFrameLength)) {
                params.cB_addStorage_front = params.p_d-params.p_u_t-currentLength;
                rightFrameout.entry_position.z = leftFrameout.entry_position.z = -(params.p_d/2) + params.p_u_t + currentLength/2;
            } 
            
            if ( currentLength > prevFrameLength && (params.p_d-currentLength-params.p_u_t) >= distanceOncenter ) {
                params.cB_addStorage_front = params.p_d-currentLength-params.p_u_t;
                rightFrameout.entry_position.z = leftFrameout.entry_position.z = -(params.p_d/2) + params.p_u_t + currentLength/2;
                // console.log(leftFrameout.entry_position.z , "n distanceOncenter",prevFrameLength ,currentLength/2, leftFrameout.entry_position.z + (prevFrameLength - currentLength/2));
            } else if (currentLength > prevFrameLength && (params.p_d-currentLength-params.p_u_t) <= distanceOncenter ) {
                params.cB_addStorage_front = distanceOncenter;
                params.p_u_t =  params.p_d-params.cB_addStorage_front-currentLength;
                rightFrameout.entry_position.z = leftFrameout.entry_position.z = params.p_d/2-params.cB_addStorage_front-currentLength/2;
                // console.log("distanceOncenter else if");
            }


            cuComponent.RemoveDoorComponent(leftFrameout.uniqueId, leftFrameout.entry_type, 'standard_door', leftFrameout.component_wall_name, size, leftFrameout.parent_array_key, leftFrameout.child_array_key, leftFrameout.nested_array_key, leftFrameout.entry_rotation, leftFrameout.entry_position, undefined,undefined,undefined,'isBreezewayFrame' );
            cuComponent.RemoveDoorComponent(rightFrameout.uniqueId, rightFrameout.entry_type, 'standard_door', rightFrameout.component_wall_name, size, rightFrameout.parent_array_key, rightFrameout.child_array_key, rightFrameout.nested_array_key, rightFrameout.entry_rotation, rightFrameout.entry_position, undefined,undefined,undefined,'isBreezewayFrame' );
        }
    }

    if ( action.option == "buildingHeight" ){
        if (height != undefined){
            size = const_var.breezewayLength+'x'+height;
            // console.log({size},"buildingHeight");
            cuComponent.RemoveDoorComponent(leftFrameout.uniqueId, leftFrameout.entry_type, 'standard_door', leftFrameout.component_wall_name, size, leftFrameout.parent_array_key, leftFrameout.child_array_key, leftFrameout.nested_array_key, leftFrameout.entry_rotation, leftFrameout.entry_position, undefined,undefined,undefined,'isBreezewayFrame' );
            cuComponent.RemoveDoorComponent(rightFrameout.uniqueId, rightFrameout.entry_type, 'standard_door', rightFrameout.component_wall_name, size, rightFrameout.parent_array_key, rightFrameout.child_array_key, rightFrameout.nested_array_key, rightFrameout.entry_rotation, rightFrameout.entry_position, undefined,undefined,undefined,'isBreezewayFrame' );
        }
    }

    if ( action.option == "buildingWidth" ){ 
        leftFrameout.entry_position.x = -(params.p_w / 2) - posOffset;
        rightFrameout.entry_position.x = (params.p_w / 2) + posOffset;
        rightFrameout.entry_position.z = leftFrameout.entry_position.z = -( params.p_d / 2) + params.p_u_t + const_var.breezewayLength / 2;

        size =  const_var.breezewayLength+'x'+Number(params.p_h);
        cuComponent.RemoveDoorComponent(leftFrameout.uniqueId, leftFrameout.entry_type, 'standard_door', leftFrameout.component_wall_name, size, leftFrameout.parent_array_key, leftFrameout.child_array_key, leftFrameout.nested_array_key, leftFrameout.entry_rotation, leftFrameout.entry_position, undefined, undefined,undefined,'isBreezewayFrame' );
        cuComponent.RemoveDoorComponent(rightFrameout.uniqueId, rightFrameout.entry_type, 'standard_door', rightFrameout.component_wall_name, size, rightFrameout.parent_array_key, rightFrameout.child_array_key, rightFrameout.nested_array_key, rightFrameout.entry_rotation, rightFrameout.entry_position, undefined, undefined,undefined,'isBreezewayFrame' );
    }

    if ( action.option == "buildingLength" ){
        if (length !== undefined) {
            if ( distanceOncenter == 5 ) {
                const_var.breezewayLength = 10;
                if ( length % 10 == 0 ){
                    params.cB_addStorage_front =  (length - const_var.breezewayLength) / 2;
                    params.p_u_t = (length - const_var.breezewayLength) / 2;
                } else {
                    params.cB_addStorage_front =  (length - const_var.breezewayLength) / 2 + 2.5;
                    params.p_u_t = (length - const_var.breezewayLength) / 2 - 2.5;
                }
            }

            if ( distanceOncenter == 4 ) {
                const_var.breezewayLength = 8;
                if ( length % 4 == 0 ){
                    if (Object.values(const_var.breezewayFrontStorageOptions).includes((length - const_var.breezewayLength) / 2)){
                        params.cB_addStorage_front =  (length - const_var.breezewayLength) / 2 + 4;
                        params.p_u_t = (length - const_var.breezewayLength) / 2 - 4;
                    } else {
                        params.cB_addStorage_front =  (length - const_var.breezewayLength) / 2 + 2;
                        params.p_u_t = (length - const_var.breezewayLength) / 2 - 2;
                    }
               
                }
            }
        }
        size = const_var.breezewayLength+'x'+height
        // console.log({size},"buildingLength");
        leftFrameout.entry_position.z = rightFrameout.entry_position.z = -( params.p_d / 2) + params.p_u_t + const_var.breezewayLength / 2;
        if (popularSize === 'popularSize'){
            leftFrameout.entry_position.x = -params.p_w / 2 - posOffset;
            rightFrameout.entry_position.x = params.p_w / 2 + posOffset; 
        }


        cuComponent.RemoveDoorComponent(leftFrameout.uniqueId, leftFrameout.entry_type, 'standard_door', leftFrameout.component_wall_name, size, leftFrameout.parent_array_key, leftFrameout.child_array_key, leftFrameout.nested_array_key, leftFrameout.entry_rotation, leftFrameout.entry_position,undefined, undefined,undefined,'isBreezewayFrame' );
        cuComponent.RemoveDoorComponent(rightFrameout.uniqueId, rightFrameout.entry_type, 'standard_door', rightFrameout.component_wall_name, size, rightFrameout.parent_array_key, rightFrameout.child_array_key, rightFrameout.nested_array_key, rightFrameout.entry_rotation, rightFrameout.entry_position,undefined, undefined,undefined,'isBreezewayFrame' );
    }

    if ( action.option == "pickThisBuilding" ) {
        const_var.breezewayLength = params.p_d - params.cB_addStorage_front - params.p_u_t;
        size =  const_var.breezewayLength+'x'+Number(params.p_h);
        leftFrameout.entry_position.z = rightFrameout.entry_position.z = -( params.p_d / 2) + params.p_u_t + const_var.breezewayLength / 2;
        
        cuComponent.RemoveDoorComponent(leftFrameout.uniqueId, leftFrameout.entry_type, 'standard_door', leftFrameout.component_wall_name, size, leftFrameout.parent_array_key, leftFrameout.child_array_key, leftFrameout.nested_array_key, leftFrameout.entry_rotation, leftFrameout.entry_position,undefined, undefined,undefined,'isBreezewayFrame' );
        cuComponent.RemoveDoorComponent(rightFrameout.uniqueId, rightFrameout.entry_type, 'standard_door', rightFrameout.component_wall_name, size, rightFrameout.parent_array_key, rightFrameout.child_array_key, rightFrameout.nested_array_key, rightFrameout.entry_rotation, rightFrameout.entry_position,undefined, undefined,undefined,'isBreezewayFrame' );
    }

    if ( action.option == "frontStorageLength" ) {
        if ( currentLength < prevFrontStorageLength  && params.p_d-currentLength-params.p_u_t <= maxBreezewayLength) {
        //    console.log("On decrease frontStorageLength");
           params.cB_addStorage_front = currentLength;
           const_var.breezewayLength= params.p_d-params.cB_addStorage_front-params.p_u_t;
           size =  const_var.breezewayLength+'x'+Number(params.p_h);
        } else if ( currentLength < prevFrontStorageLength  && params.p_d-currentLength-params.p_u_t > maxBreezewayLength) {
            // console.log("On decrease frontStorageLength else if");
            params.cB_addStorage_front = currentLength;
            const_var.breezewayLength = maxBreezewayLength;
            params.p_u_t =params.p_d-currentLength-const_var.breezewayLength;
            size =  const_var.breezewayLength+'x'+Number(params.p_h);
        }
    
        if ( currentLength > prevFrontStorageLength  && params.p_d-currentLength-params.p_u_t >= distanceOncenter ){
            // console.log("On increase frontStorageLength");
            params.cB_addStorage_front = currentLength;
            const_var.breezewayLength = params.p_d-params.p_u_t-currentLength;
            size =  const_var.breezewayLength+'x'+Number(params.p_h);
        }else if (currentLength > prevFrontStorageLength && (params.p_d-currentLength-params.p_u_t) <= distanceOncenter ) {
            // console.log("On increase else if frontStorageLength");
            params.cB_addStorage_front = currentLength;
            // params.p_u_t = distanceOncenter
            const_var.breezewayLength = distanceOncenter;
            params.p_u_t = params.p_d-const_var.breezewayLength-currentLength;
            size =  const_var.breezewayLength+'x'+Number(params.p_h);
        }
        
        rightFrameout.entry_position.z = leftFrameout.entry_position.z = -( params.p_d / 2) + params.p_u_t + const_var.breezewayLength / 2;
        cuComponent.RemoveDoorComponent(leftFrameout.uniqueId, leftFrameout.entry_type, 'standard_door', leftFrameout.component_wall_name, size, leftFrameout.parent_array_key, leftFrameout.child_array_key, leftFrameout.nested_array_key, leftFrameout.entry_rotation, leftFrameout.entry_position, undefined,undefined,undefined,'isBreezewayFrame' );
        cuComponent.RemoveDoorComponent(rightFrameout.uniqueId, rightFrameout.entry_type, 'standard_door', rightFrameout.component_wall_name, size, rightFrameout.parent_array_key, rightFrameout.child_array_key, rightFrameout.nested_array_key, rightFrameout.entry_rotation, rightFrameout.entry_position, undefined,undefined,undefined,'isBreezewayFrame' );

    }

    if (action.option == "backStorageLength"){
        params.p_u_t = Number(action.value);

        if ( currentLength < prevBackStorageLength && params.p_d-currentLength-params.cB_addStorage_front <= maxBreezewayLength ) {
            // console.log("On decrease backStorageLength");
            params.p_u_t = currentLength;
            const_var.breezewayLength = params.p_d-params.cB_addStorage_front-params.p_u_t;
            size =  const_var.breezewayLength+'x'+Number(params.p_h);
        } else if ( currentLength < prevBackStorageLength  && params.p_d-currentLength-params.cB_addStorage_front > maxBreezewayLength) {
            // console.log("On decrease backStorageLength else if");
            params.p_u_t = currentLength;
            const_var.breezewayLength = maxBreezewayLength;
            params.cB_addStorage_front =params.p_d - currentLength - const_var.breezewayLength;
            size =  const_var.breezewayLength+'x'+Number(params.p_h);
        }
     
        if ( currentLength > prevBackStorageLength  && params.p_d-currentLength-params.cB_addStorage_front >= distanceOncenter ){
            // console.log("On increase backStorageLength");
            params.p_u_t = currentLength;
            const_var.breezewayLength = params.p_d-params.cB_addStorage_front-currentLength;
            size =  const_var.breezewayLength+'x'+Number(params.p_h);
        }else if (currentLength > prevBackStorageLength && (params.p_d-currentLength-params.cB_addStorage_front) <= distanceOncenter ) {
            // console.log("On increase else if backStorageLength");
            params.p_u_t = currentLength;
            const_var.breezewayLength = distanceOncenter;
            params.cB_addStorage_front = params.p_d-const_var.breezewayLength-currentLength;
            size =  const_var.breezewayLength+'x'+Number(params.p_h);
        }
        rightFrameout.entry_position.z = leftFrameout.entry_position.z = -( params.p_d / 2) + params.p_u_t + const_var.breezewayLength / 2;
            
        cuComponent.RemoveDoorComponent(leftFrameout.uniqueId, leftFrameout.entry_type, 'standard_door', leftFrameout.component_wall_name, size, leftFrameout.parent_array_key, leftFrameout.child_array_key, leftFrameout.nested_array_key, leftFrameout.entry_rotation, leftFrameout.entry_position,undefined,undefined,undefined,'isBreezewayFrame' );
        cuComponent.RemoveDoorComponent(rightFrameout.uniqueId, rightFrameout.entry_type, 'standard_door', rightFrameout.component_wall_name, size, rightFrameout.parent_array_key, rightFrameout.child_array_key, rightFrameout.nested_array_key, rightFrameout.entry_rotation, rightFrameout.entry_position,undefined,undefined,undefined,'isBreezewayFrame' );

    }

    const_var.UpdatedPriceData.utility_price_changed = true;
    const_var.UpdatedPriceData.front_utility_price_changed = true;
    cuBuilding.cP();
    cuBuilding.breezwayStoragevalues();
    cuBuilding.BuildingUpdate();

}
const editActionAfterPreparingData = (state, data,doorData) => {
    // console.log('giorgi- editActionAfterPreparingData: ', {state, data,doorData});
    const_var.showProcessLoaderchkEdit = false;
    const_var.confirmState = true;
    let updatebuildId = false;
    state.selectedTabKey = "buildsizes";
    let checkHeavySnowVal = (const_var.CheckSnowLoadValue==65)?1:0;
    if (data != '') {
        for (let i = 0; i < data.default_building.length; i++) {
            if (params.building_type_name == data.default_building[i].name) {
                const_var.BuldingIDforReset = data.default_building[i].id;
                state.OlddefaultBuilding = data.default_building[i].id;
                state.defaultBuilding = data.default_building[i].id;
                if (data.default_building[i].building_id == params.p_b_t){
                    const_var.isTripleWide = data.default_building[i]?.image_name.split(".")[0]?.includes("Triple_Wide") ? true : false;
                }
            }
            if (data.default_building[i].heavy_snow == 1 && const_var.CheckSnowLoadValue == 65) {
                const_var.defaultBuildingArr[data.default_building[i].id] = data.default_building[i];
                if (params.building_type_name == data.default_building[i].name) {
                    state.OlddefaultBuilding = data.default_building[i].id;
                }
                state.defaultBuilding = data.default_building[i].id;

            } if (data.default_building[i].heavy_snow==0 && const_var.CheckSnowLoadValue != 65) {
                const_var.defaultBuildingArr[data.default_building[i].id] = data.default_building[i];
                if (params.building_type_name == data.default_building[i].name) {
                    state.OlddefaultBuilding = data.default_building[i].id;
                }
                state.defaultBuilding = data.default_building[i].id;

            }
            
            if (const_var.editAPIDataByResponse.data.request_data.building.default_building_image_name != undefined && const_var.editAPIDataByResponse.data.request_data.building.default_building_image_name == data.default_building[i].image_name && data.default_building[i].heavy_snow==checkHeavySnowVal) {
                state.defaultBuilding = data.default_building[i].id;
                checkHeavySnowVal = data.default_building[i].id;
                updatebuildId = true;
                const_var.BuldingIDforReset = data.default_building[i].id;
                state.OlddefaultBuilding = data.default_building[i].id;
            }
        }
    }
    if(updatebuildId && state.defaultBuilding!=checkHeavySnowVal)
    {
        state.defaultBuilding = checkHeavySnowVal;
    }
    state.defaultRoof = const_var.TypeEnumINDEX[params.p_r_s];
    for (var i = 0; i <= const_var.roof_style.length - 1; i++) {
        if (state.const_var.roof_style[i].roof_id == state.params.p_r_s) {
            roofStyleChange(state, i, true, true, "edit");
        }
    }
    if (const_var.editAPIDataByResponse.data.request_data.building.insulation_type!=undefined && const_var.editAPIDataByResponse.data.request_data.building.insulation_type.name!= undefined) {
        const_var.UpdatedPriceData.insulation_price = const_var.editAPIDataByResponse.data.request_data.building.insulation_price;
        params.p_i_o = (const_var.editAPIDataByResponse.data.request_data.building.insulation_type) ? (const_var.editAPIDataByResponse.data.request_data.building.insulation_type.insulation_id) : 0;
        if(const_var.a_p_d_a!=undefined && const_var.a_p_d_a.insulation!=undefined && const_var.a_p_d_a.insulation.find((item) => item.insulation_id == params.p_i_o)==undefined)
        {
            if(const_var.crmSetting.is_Edit == true && const_var.editAPIDataByResponse.data.request_data.building.insulation_type!=undefined)
            {  
                let newName = const_var.a_p_d_a.insulation.find((item) => item.name.includes(const_var.editAPIDataByResponse.data.request_data.building.insulation_type.name));
                params.p_i_o = (newName!=undefined)? newName.insulation_id:params.p_i_o;
            }
        }
        const_var.showDefaultInsullation = (const_var.editAPIDataByResponse.data.request_data.building.insulation_type && const_var.editAPIDataByResponse.data.request_data.building.insulation_type.insulation_id != 0) ? true : false;
        params.p_f_i = true;
        if (const_var.editAPIDataByResponse.data.request_data.building.insulation_type != undefined && const_var.editAPIDataByResponse.data.request_data.building.insulation == "roof_only") {
            params.p_r_o = true;
            params.p_f_i = false;
            params.p_c_i = false;
        } else if (const_var.editAPIDataByResponse.data.request_data.building.insulation_type != undefined && (const_var.editAPIDataByResponse.data.request_data.building.insulation == "custom" || const_var.editAPIDataByResponse.data.request_data.building.insulation == "Custom")) {
            params.p_r_o = false;
            params.p_f_i = false;
            params.p_c_i = true;
        } else {
            params.p_r_o = params.p_r_o;
            params.p_c_i = params.p_c_i;
        }
        cuBuilding.cP();
    }
    if ((const_var.editAPIDataByResponse.data.request_data.building.connection_fee_side != undefined && const_var.editAPIDataByResponse.data.request_data.building.connection_fee_side != 0) || (const_var.editAPIDataByResponse.data.request_data.building.connection_fee_end != undefined && const_var.editAPIDataByResponse.data.request_data.building.connection_fee_end != 0)) {
        if (const_var.editAPIDataByResponse.data.request_data.building.connection_fee_side != undefined && const_var.editAPIDataByResponse.data.request_data.building.connection_fee_side != 0) {
            const_var.UpdatedPriceData.connection_fee_side = const_var.editAPIDataByResponse.data.request_data.building.connection_fee_side;
        }
        if (const_var.editAPIDataByResponse.data.request_data.building.connection_fee_end != undefined && const_var.editAPIDataByResponse.data.request_data.building.connection_fee_end != 0) {
            const_var.UpdatedPriceData.connection_fee_end = const_var.editAPIDataByResponse.data.request_data.building.connection_fee_end;
        }
    }

    if (const_var.editAPIDataByResponse.data.request_data.building.connection_fee_left_front != undefined && const_var.editAPIDataByResponse.data.request_data.building.connection_fee_left_front != 0) {
        const_var.UpdatedPriceData.connection_fee_left_front = const_var.editAPIDataByResponse.data.request_data.building.connection_fee_left_front;
    }
    if (const_var.editAPIDataByResponse.data.request_data.building.connection_fee_right_front != undefined && const_var.editAPIDataByResponse.data.request_data.building.connection_fee_right_front != 0) {
        const_var.UpdatedPriceData.connection_fee_right_front = const_var.editAPIDataByResponse.data.request_data.building.connection_fee_right_front;
    }
    if (const_var.editAPIDataByResponse.data.request_data.building.connection_fee_right_back != undefined && const_var.editAPIDataByResponse.data.request_data.building.connection_fee_right_back != 0) {
        const_var.UpdatedPriceData.connection_fee_right_back = const_var.editAPIDataByResponse.data.request_data.building.connection_fee_right_back;
    }
    if (const_var.editAPIDataByResponse.data.request_data.building.connection_fee_left_back != undefined && const_var.editAPIDataByResponse.data.request_data.building.connection_fee_left_back != 0) {
        const_var.UpdatedPriceData.connection_fee_left_back = const_var.editAPIDataByResponse.data.request_data.building.connection_fee_left_back;
    }

    //roofStyleChange(state, state.defaultRoof,true,true)
    if (const_var.editAPIDataByResponse.data.request_data.building.entry_points != undefined) {
        const_var.componentPriceUpdateData = const_var.editAPIDataByResponse.data.request_data.building.entry_points;
        cuBuilding.addComponent(state, const_var.editAPIDataByResponse.data.request_data.building);
        cuBuilding.cP(true);
    }
    
    if(const_var.checkPickThisBuilding && const_var.callMesure){
    }
    
}

export const calculateLegsCount = (value,name)=>{
    // console.log({value,name});
    let eqiDis = 0;
    let eqiDisfive = 0;
    let eqiDisCenter = 0;
    let eqiDisfiveCenter = 0;
    let exactLength = 0;
   
    if(name!=undefined)
    {
        exactLength = parseFloat(const_var.lengthData[name].length) + parseFloat(const_var.lengthData[name].porchLength);
        if(params.fourth_center_cost==true)
        {
            if(const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined)
            {
                eqiDis = (params.oncenter_val_with_action!='')?((exactLength)/parseInt(params.oncenter_val_with_action)).toFixed(0):((exactLength)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);

                eqiDisfive = (const_var.DistanceArr[params.p_b_t][params.p_r_s]==5)?((exactLength)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0):((exactLength)/parseInt(5)).toFixed(0);
                
                eqiDisfive = parseFloat(eqiDisfive) + 1;
                eqiDis = parseFloat(eqiDis) +1;
                if((params.add_left_front_lean_porch && name=="frontLean"))
                {
                    eqiDisfive = parseFloat(eqiDisfive) - 1;
                    eqiDis = parseFloat(eqiDis) -1;
                }
                if((params.add_left_back_lean_porch && name=="backLean") )
                {
                    eqiDisfive = parseFloat(eqiDisfive) - 1;
                    eqiDis = parseFloat(eqiDis) -1;
                }
                if((params.add_right_front_lean_porch && name=="frontLean"))
                {
                    eqiDisfive = parseFloat(eqiDisfive) - 1;
                    eqiDis = parseFloat(eqiDis) -1;
                }
                if((params.add_right_back_lean_porch && name=="backLean") )
                {
                    eqiDisfive = parseFloat(eqiDisfive) - 1;
                    eqiDis = parseFloat(eqiDis) -1;
                }
            }
        }
    }

    if(params.fourth_center_cost==true)
    {
        if(const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined)
        {
            eqiDisCenter = (params.oncenter_val_with_action!='')?((params.p_d)/parseInt(params.oncenter_val_with_action)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
            eqiDisfiveCenter = (const_var.a_p_d_a.building_structure[0]?.distance_on_center==5)?((params.p_d)/parseInt(const_var.a_p_d_a.building_structure[0]?.distance_on_center)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
            eqiDisfiveCenter = parseFloat(eqiDisfiveCenter) + 1;
            eqiDisCenter = parseFloat(eqiDisCenter) +1;
        }
    } else {
        if(const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined)
        {
            eqiDisCenter = (params.oncenter_val_with_action!='')?((params.p_d)/parseInt(params.oncenter_val_with_action)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0)
            eqiDisfiveCenter = (const_var.a_p_d_a.building_structure[0]?.distance_on_center==5)?((params.p_d)/parseInt(const_var.a_p_d_a.building_structure[0]?.distance_on_center)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
            eqiDisfiveCenter = parseFloat(eqiDisfiveCenter) + 1;
        }
    }
    if ((params.fourth_center_cost)) {
                let quantityval = const_var.ExtraItemsFeaturesArray.findIndex(data => data && data.name=="fourth_center_cost");
                if (const_var.DistanceArr[params.p_b_t][params.p_r_s] == 4 && quantityval >= 0 && const_var.ExtraItemsFeaturesArray[quantityval] !=undefined) {
                        if(const_var.ExtraItemsFeaturesArray[quantityval].cost==0 && const_var.a_p_d_a.extra_items!=undefined && const_var.a_p_d_a.extra_items.length > 0 && const_var.a_p_d_a.extra_items[0].checkbox_quantity!=undefined)
                        {
                            let newFilterData = const_var.a_p_d_a.extra_items[0].checkbox.filter(data=>data.name=="fourth_center_cost");
                            if(newFilterData.length>0 && newFilterData[0].cost!=0 && (params.m_s_n == 13 || params.m_s_n == 145 || (params.p_s_n==8 && params.m_s_n==34) || (params.p_s_n==8 && params.m_s_n==27)))
                            {
                                const_var.ExtraItemsFeaturesArray[quantityval].cost = newFilterData[0].cost;
                            }else{
                            let dataNew = JSON.parse(JSON.stringify(const_var.a_p_d_a.extra_items[0].checkbox_quantity));
                            dataNew.map((data, index1)=> {
                            if(data.name=="bows")
                            {
                                if(data.cost!=0 || data.double_leg!=0 || data.ladder_leg!=0)
                                {
                                    let exactNum = Math.abs(eqiDisfiveCenter - eqiDisCenter);
                                    let price = (params.p_e_l && const_var.legstype.includes("double") && data.double_leg != 0 )?parseFloat(data.double_leg):(params.p_e_l && const_var.legstype.includes("ladder") && data.ladder_leg != 0 )?parseFloat(data.ladder_leg):parseFloat(data.cost);
                                    const_var.ExtraItemsFeaturesArray[quantityval].cost = (parseFloat(price) * parseFloat(exactNum));
                                    if(const_var.c_f_aCer[params.p_e_i]!=undefined && const_var.c_f_aCer[params.p_e_i].distance_on_center==5 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=4)
                                    {
                                        if(params.fourth_center_cost && const_var.DistanceArr[params.p_b_t][params.p_r_s]==4)
                                        {
                                            const_var.ExtraItemsFeaturesArray[quantityval].cost = 0;
                                        }
                                    }

                                    const_var.extraItemsFeaturesCost[quantityval] = const_var.ExtraItemsFeaturesArray[quantityval].cost;
                                            if(data.name == "bows")
                                            {
                                                if(params.fourth_center_cost==true)
                                                {
                                                    const_var.ExtraItemsFeaturesQuantityArray[index1] = data;
                                                    const_var.ExtraItemsFeaturesQuantityArray[index1].quantity = 1;
                                                    const_var.ExtraItemsFeaturesQuantityArray[index1].is_checked = (params.fourth_center_cost==true)?true:false;
                                                    const_var.ExtraItemsFeaturesQuantityArray[index1].cost = 0;
                                                    const_var.ExtraItemsFeaturesQuantityArray[index1].double_leg = 0;
                                                    const_var.ExtraItemsFeaturesQuantityArray[index1].ladder_leg = 0;
                                                    const_var.ExtraItemsFeaturesQuantityArray[index1].is_edit = false;
                                                    const_var.ExtraItemsFeaturesQuantityArray[index1].is_disabled = true;
                                                }
                                            }
                                       
                                }
                            }
                        })
                        }
                        }

                        if(value!=undefined && value.extra_items!=undefined && value.extra_items.length>0 && value.extra_items[0].checkbox!=undefined)
                        {
                            value.extra_items[0].checkbox.map((data,index)=>{
                                if(data.name=="fourth_center_cost" && (data.cost==0 || const_var.ExtraItemsFeaturesArray[quantityval].cost==0) && params.fourth_center_cost)
                                {
                                    value.extra_items[0].checkbox_quantity.map((quantityData,key)=>{
                                        if(quantityData.name=="bows")
                                        {
                                            if(quantityData.cost!=0 || quantityData.double_leg!=0 || quantityData.ladder_leg!=0)
                                            {
                                                let bowsPrice = 0;
                                                if (name=="frontLean") bowsPrice = params.add_front_lean ? (params.leanF_p_e_l && const_var.leanFLegstype.includes("double") && quantityData.double_leg != 0 )?parseFloat(quantityData.double_leg):(params.leanF_p_e_l && const_var.leanFLegstype.includes("ladder") && quantityData.ladder_leg != 0 )?parseFloat(quantityData.ladder_leg):parseFloat(quantityData.cost) : 0;
                                                if (name=="leftLean") bowsPrice = params.add_left_lean ? (params.lean_p_e_l && const_var.leanLegstype.includes("double") && quantityData.double_leg != 0 )?parseFloat(quantityData.double_leg):(params.lean_p_e_l && const_var.leanLegstype.includes("ladder") && quantityData.ladder_leg != 0 )?parseFloat(quantityData.ladder_leg):parseFloat(quantityData.cost) : 0;
                                                if (name=="rightLean") bowsPrice = params.add_right_lean ? (params.leanR_p_e_l && const_var.leanRLegstype.includes("double") && quantityData.double_leg != 0 )?parseFloat(quantityData.double_leg):(params.leanR_p_e_l && const_var.leanRLegstype.includes("ladder") && quantityData.ladder_leg != 0 )?parseFloat(quantityData.ladder_leg):parseFloat(quantityData.cost) : 0;
                                                if (name=="backLean") bowsPrice = params.add_back_lean ? (params.leanB_p_e_l && const_var.leanBLegstype.includes("double") && quantityData.double_leg != 0 )?parseFloat(quantityData.double_leg):(params.leanB_p_e_l && const_var.leanBLegstype.includes("ladder") && quantityData.ladder_leg != 0 )?parseFloat(quantityData.ladder_leg):parseFloat(quantityData.cost) : 0;
                                                let exactNum = Math.abs(eqiDisfive - eqiDis);
                                                
                                                const_var.ExtraItemsFeaturesArray[quantityval].cost = parseFloat(const_var.ExtraItemsFeaturesArray[quantityval].cost) + parseFloat(bowsPrice * exactNum)
                                                
                                            }
                                        }
                                    })
                                }
                            })
                        }
                    
                    
                    
                }


        }
}
const commonFunctionForExtraBows = ()=>{
    let eqiDis = 0;
    let eqiDisfive = 0;
    if(params.fourth_center_cost==true)
    {
        if(const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined)
        {
            eqiDis = (params.oncenter_val_with_action!='')?((params.p_d)/parseInt(params.oncenter_val_with_action)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
            eqiDisfive = (const_var.a_p_d_a.building_structure[0]?.distance_on_center==5)?((params.p_d)/parseInt(const_var.a_p_d_a.building_structure[0]?.distance_on_center)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
            eqiDisfive = parseFloat(eqiDisfive) + 1;
            eqiDis = parseFloat(eqiDis) +1;
        }
    } else {
        if(const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined)
        {
            eqiDis = (params.oncenter_val_with_action!='')?((params.p_d)/parseInt(params.oncenter_val_with_action)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0)
            eqiDisfive = (const_var.a_p_d_a.building_structure[0]?.distance_on_center==5)?((params.p_d)/parseInt(const_var.a_p_d_a.building_structure[0]?.distance_on_center)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
            eqiDisfive = parseFloat(eqiDisfive) + 1;
        }
    }
    if(const_var.a_p_d_a.building_structure!=undefined && const_var.a_p_d_a.building_structure[0].distance_on_center!=undefined)
    {
        if(const_var.c_f_aCer[params.p_e_i]!=undefined && const_var.c_f_aCer[params.p_e_i].distance_on_center != 4 && const_var.a_p_d_a.building_structure[0].distance_on_center!= 4)
        {
            const_var.DistanceArr[params.p_b_t][params.p_r_s] = (const_var.a_p_d_a.building_structure[0].distance_on_center!=4 && const_var.c_f_aCer[params.p_e_i].distance_on_center==4)?4:const_var.a_p_d_a.building_structure[0].distance_on_center;
        }
    }
    if(const_var.ExtraItemsFeaturesQuantityArray.length>0 && params.isDefaultfourFeet!=true)
    {
        let FilterIndex = const_var.ExtraItemsFeaturesQuantityArray.findIndex(data=> data && data.name=="bows" && data.is_disabled!=undefined);
         if (FilterIndex >= 0){
            if(const_var.c_f_aCer[params.p_e_i]!=undefined && const_var.c_f_aCer[params.p_e_i].distance_on_center==5 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=4)
            {
                let quantityval = const_var.ExtraItemsFeaturesArray.findIndex(data => data && data.name=="fourth_center_cost");
                if(quantityval>=0)
                {
                    if(const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].cost==0)
                    {
                        if(const_var.ExtraItemsFeaturesArray[quantityval].is_checked)
                        {
                            const_var.ExtraItemsFeaturesArray[quantityval].is_checked = false;
                            params.fourth_center_cost = false;
                        }
                        const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].cost = 0;
                    }
                }
            }
            const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].is_checked = false;
            const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].quantity = 1;
            const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].is_edit = false;
            const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].is_disabled = false;
            if(const_var.c_f_aCer[params.p_e_i]!=undefined && const_var.c_f_aCer[params.p_e_i].distance_on_center==5 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=4)
            {
                let quantityval = const_var.ExtraItemsFeaturesArray.findIndex(data => data && data.name=="fourth_center_cost");
                if(quantityval>=0)
                {
                    if(const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].is_checked==false && const_var.ExtraItemsFeaturesArray[quantityval].cost!=0)
                    {
                        const_var.ExtraItemsFeaturesArray[quantityval].cost = 0;
                    }
                }
            }
            //const_var.ExtraItemsFeaturesQuantityArray.splice(FilterIndex,1);
        }
    }
    
}
const setPricingData = async (state, response, flag, str, isEdit = false) => {
    let responseStatus = (flag == true && const_var.CallApionAction == false) ? response.status : response.success;
    if(isEdit == true){
        const_var.isDataWithlegCut= true
    }
    else{
        const_var.isDataWithlegCut= false
    }
    if (responseStatus == true) {
        let dataNew = (flag == true && const_var.CallApionAction == false) ? response.data.pricing_data : response.data;
        const_var.checkForCutPannel = (dataNew.panel.length>0)?dataNew.panel[0].cut_panel_cost:0;
       
        if(params.p_c_i == true && dataNew && dataNew.insulation && const_var.a_p_d_a && const_var.insulationPriceJson.insulation_wall && Object.keys(const_var.insulationPriceJson.insulation_wall).length > 0){
            let isInsulationAdded = Object.keys(const_var.insulationPriceJson.insulation_wall).find(key => const_var.insulationPriceJson.insulation_wall[key] == true)
            params.p_c_i = isInsulationAdded != undefined ? params.p_c_i : (params.m_s_n == 153 && (params.add_left_lean || params.add_front_lean || params.add_back_lean || params.add_right_lean) ? params.p_c_i : false)
            params.p_f_i = false;
        }

        let singleSlopeHeight = (const_var.c_m_a[params.p_b_t]!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length>0 ) ? Math.floor(params.p_h-((params.p_w * params.p_r_p) / 12)) : Math.round(params.p_h-((params.p_w * params.p_r_p) / 12))

        if(params.singleSlope == true && (params.p_c_i == true || params.p_r_o == true || params.p_f_i == true) &&  params.m_s_n == 153 && (params.p_r_s  == 1 || params.p_r_s == 2) && singleSlopeHeight > 10) {
            params.p_c_i = false;
            params.p_r_o = false;
            params.p_f_i = false;
        }
        
        const_var.showGaugePriceVal = 0;
        state.const_var.b_n_B_d = (dataNew.building_structure.length > 0) ? dataNew.building_structure[0].building_id : state.const_var.b_n_B_d;
        if (Object.keys(dataNew.anchors_cost).length > 0) {
            for (var i = 0; i <= dataNew.anchors_cost.length - 1; i++) {
                state.const_var.c_m_a_Anchors[dataNew.anchors_cost[i].name] = dataNew.anchors_cost[i];
            }
        }
        let countofLegs = (const_var.count_numberofLegsBefore!=undefined)?const_var.count_numberofLegsBefore:const_var.count_numberofLegs;
        if (dataNew.building_structure.length > 0) {
            if (Object.keys(dataNew.building_structure[0].conditions).length !== 0) {
                //state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s] = dataNew.building_structure[0].conditions['condition'];
                // if(const_var.crmSetting.is_Edit==true)
                // {
                //     cuBuilding.CheckLegsByResponse(state);
                // }
            }
            if (dataNew?.extra_items[0]?.checkbox?.length > 0) {
                let check4ftOnCenter  = dataNew.extra_items[0].checkbox.find(item => item && item.name =="fourth_center_cost")
                if (!const_var.crmSetting.is_Edit && check4ftOnCenter == undefined){
                    params.fourth_center_cost = false;
                }
                if (!const_var.crmSetting.is_Edit && check4ftOnCenter != undefined ){
                    //params.fourth_center_cost = (check4ftOnCenter.cost==0 && dataNew.building_structure[0].distance_on_center==5)?false:params.fourth_center_cost;
                    params.fourth_center_cost = (check4ftOnCenter.cost!=undefined)?params.fourth_center_cost:params.fourth_center_cost;
                }
            }
            if (const_var.DistanceArr[params.p_b_t][params.p_r_s] != dataNew.building_structure[0].distance_on_center) {
                const_var.DistanceArr[params.p_b_t][params.p_r_s] = (params.fourth_center_cost != true) ? dataNew.building_structure[0].distance_on_center : 4;
                cuBuilding.uUdDCB();
                cuBuilding.uUdD();
                // cuBuilding.uUdDp();
                // cuBuilding.leanuUdD();
                
                if ( params.isBreezeway && const_var.checkPickThisBuilding && const_var.isBreezewayPickThisBuilding && const_var.isPriceAPIcalled ) {
                    const_var.isBreezewayPickThisBuilding = false;
                    params.p_u_t = const_var.DistanceArr[params.p_b_t][params.p_r_s] == 4 ? utils.findNearestMultipleOfFour( params.p_u_t) : utils.findNearestMultipleOfFive( params.p_u_t);
                    params.cB_addStorage_front = const_var.DistanceArr[params.p_b_t][params.p_r_s] == 4 ?  utils.findNearestMultipleOfFour(params.cB_addStorage_front) : utils.findNearestMultipleOfFive(params.cB_addStorage_front);
                    makeDimensionArray(state);
                    updateBreezewayFrameAndStorages({option:"pickThisBuilding"}, undefined,  Number(params.p_h), Number(params.p_d));
                } 
            }
            
            const_var.DistanceArr[params.p_b_t][params.p_r_s] = (params.fourth_center_cost != true) ? dataNew.building_structure[0].distance_on_center : 4;
            if (dataNew.building_structure[0]?.distance_on_center == 4) {
                params.isDefaultfourFeet = true; 
            } else {
                params.isDefaultfourFeet = false;
            }
            if (const_var.DistanceArr[params.p_b_t][params.p_r_s] == 4 && params.fourth_center_cost == false) {
                params.fourth_center_cost = true;
            }
            if (params.isBreezeway) makeDimensionArray(state);
            const_var.defaultDistanceOnCenter = dataNew.building_structure[0].distance_on_center;
        }
         if(dataNew.side[0].lift_type!=undefined && dataNew.side[0].lift_type!='')
        {
            params.lift_type = params.lift_type==undefined? false : true;
            params.lifttype_price = dataNew.side[0].lifttype_price;
            if(params.lift_type == true){
                const_var.UpdatedPriceData.lifttype_price_changed = true;
            }
        }
        if(dataNew.cupola!=undefined && Object.keys(dataNew.cupola).length>0)
        {
            if (Object.keys(dataNew.cupola).length === 1 && Object.keys(const_var.cupolasData).length>0) {
              const isAddedCupolaAvilable = Object.keys(dataNew.cupola).filter(element => Object.keys(const_var.cupolasData).includes(element));
              if (isAddedCupolaAvilable.length === 0) cuComponent.removeAllCupolas();
            } 
            const_var.cupolaObj =  dataNew.cupola;
            const_var.cupolasData =  dataNew.cupola;
            const_var.cupolaType = Object.keys(const_var.cupolasData)[0];
        } else{
            const_var.cupolaObj = [];
            const_var.cupolasData = [];
            state.cupolaEditIconsPos = [];
            cuComponent.removeAllCupolas();
        }
        if (const_var.b_o_J_1[params.p_b_t] != "Custom Buildings") {
            if (dataNew.side[0].side_close_cost != 0) {
                state.const_var.checkFunCalling = true;
            } else if (const_var.hide_price_calculation == 1 && dataNew.side[0].side_close_cost == 0) {
                state.params.p_v_w = false;
                state.const_var.checkFunCalling = true;
            } else {
                if (dataNew.side[0].vertical_side_cost != 0) {
                    state.params.p_v_w = true;
                    state.const_var.checkFunCalling = false;
                }
            }
        } else {
            state.const_var.checkFunCalling = true;
        }
        if (dataNew.side[0].side_close_cost == 0) {
            if (params.p_v_w == false) {
                state.params.p_v_w = (dataNew.side[0].vertical_side_cost != 0) ? true : false;
                cuBuilding.BuildingUpdate(true, '');
            }
        }
        if (dataNew.side[0].side_close_cost == 0) {
            const_var.checkVerticalCheckBox = true;
            if (params.p_v_w == false) {
                state.params.p_v_w = (dataNew.side[0].vertical_side_cost != 0) ? true : false;
            }
        } else {
            state.const_var.checkFunCalling = true;
        }

        if (dataNew.side[0].side_close_cost == 0) {
            if (params.p_v_w == false) {
                state.params.p_v_w = (dataNew.side[0].vertical_side_cost != 0) ? true : false;
                cuBuilding.BuildingUpdate(true, '');
            }

        }
        if (dataNew.side[0].side_close_cost == 0) {
            const_var.checkVerticalCheckBox = true;
            if (params.p_v_w == false && dataNew.side[0].vertical_side_cost != 0) {
                state.params.p_v_w = true;
            }

        }
        if (dataNew.side[0].side_close_cost == 0 && dataNew.side[0].vertical_side_cost == 0) {
            const_var.checkVerticalCheckBox = false;
        }
        if (dataNew.side[0].side_close_cost != 0) {
            const_var.checkVerticalCheckBox = false;
        }
        //console.log(params.p_v_w,"params.p_v_w")
        if (dataNew.truss_name.length > 0) {
            state.const_var.c_m_a[state.params.p_b_t].trussType = dataNew.truss_name;
            let trussAccordingWidth = dataNew.truss_name.filter(data=>params.p_w >= data.min_width && params.p_w <= data.max_width)
            if(trussAccordingWidth.length>0) state.const_var.c_m_a[state.params.p_b_t].trussType = trussAccordingWidth;
            if(const_var.crmSetting.is_Edit==true && params.newtrussType!='' && dataNew.truss_name.length>0)
            {
                let filterDatan = dataNew.truss_name.filter(data=>data.name.includes(params.newtrussType))
                if(filterDatan.length>0)
                {
                    params.trussType = params.newtrussType;
                }
            }
        }
        if (dataNew.end_cross_bracing != undefined && dataNew.end_cross_bracing.length > 0) {
            // if(dataNew.end_cross_bracing[0].is_default=='yes')
            // {
            //     params.p_e_c_b = true;
            //     const_var.checkedEndCrossBracing = true;
            // }
            if (dataNew.end_cross_bracing[0].is_default == 'included') {
                params.p_e_c_b = true;
                const_var.checkedEndCrossBracing = true;
            }
            if (dataNew.end_cross_bracing[0].is_default == 'no') {
                const_var.checkedEndCrossBracing = false;
                params.p_e_c_b = false;
            }
        }
        if (params.p_e_c_b == true && dataNew.end_cross_bracing.length <= 0) {
            params.p_e_c_b = false;
            const_var.checkedEndCrossBracing = false;
            //cuBuilding.rP();
        }
        if (dataNew.side_cross_bracing != undefined && dataNew.side_cross_bracing.length > 0) {
            // if(dataNew.side_cross_bracing[0].is_default=='yes')
            // {
            //     params.p_s_c_b = true;
            //     const_var.checkedSideCrossBracing = true;
            // }
            if (dataNew.side_cross_bracing[0].is_default == 'included') {
                params.p_s_c_b = true;
                const_var.checkedSideCrossBracing = true;
            }
            if (dataNew.side_cross_bracing[0].is_default == 'no') {
                const_var.checkedSideCrossBracing = false;
                params.p_s_c_b = false;
            }
        }
        if (params.p_s_c_b == true && dataNew.side_cross_bracing.length <= 0) {
            params.p_s_c_b = false;
            const_var.checkedSideCrossBracing = false;
        }
        // params.gauge_val = dataNew.building_structure[0].default_gauge; 
        // const_var.g_v = params.gauge_val;
        //params.gauge_val = ; 
        let gaugeCheck = params.gauge_val;
        params.gauge_val = dataNew.building_structure[0].default_gauge;
        const_var.g_v = dataNew.building_structure[0].default_gauge;
        if (dataNew.base.length == 2) {
            const_var.showGaugePrice = true;
        }
        for (var i = 0; i <= dataNew.base.length - 1; i++) {
            const_var.showGaugePriceVal = (const_var.showGaugePriceVal != 0) ? const_var.showGaugePriceVal - dataNew.base[i][const_var.map[params.p_r_s]] : dataNew.base[i][const_var.map[params.p_r_s]];
            if (params.gauge_val != gaugeCheck && gaugeCheck == dataNew.base[i].gauge) {
                params.gauge_val = dataNew.base[i].gauge;
                const_var.g_v = params.gauge_val;
            }
        }
        if (params.gauge_val == 12) {
            params.gauge_val_check = true;
        }
        state.const_var.a_p_d_a = dataNew;
        if(const_var.crmSetting.is_Edit == true &&  const_var.a_p_d_a.old_insulation != undefined) {
            state.const_var.a_p_d_a["old_insulation"] = dataNew.old_insulation;
        } else {
            state.const_var.a_p_d_a["old_insulation"] = dataNew.insulation;
        }
        if((params.add_front_lean==true || params.add_left_lean==true || params.add_right_lean==true || params.add_back_lean==true) && (const_var.a_p_d_a.connection_fees == undefined || const_var.a_p_d_a.connection_fees.length == 0)){
            if(params.add_left_lean==true && const_var.leanGetDataLeft != undefined && const_var.leanGetDataLeft.connection_fees != undefined){
                const_var.a_p_d_a.connection_fees = const_var.leanGetDataLeft.connection_fees;                
            }
            if(params.add_front_lean==true && const_var.leanGetDataFront != undefined && const_var.leanGetDataFront.connection_fees != undefined){
                const_var.a_p_d_a.connection_fees = const_var.leanGetDataFront.connection_fees;                
            }
            if(params.add_back_lean==true && const_var.leanGetDataBack != undefined && const_var.leanGetDataBack.connection_fees != undefined){
                const_var.a_p_d_a.connection_fees = const_var.leanGetDataBack.connection_fees;                
            }
            if(params.add_right_lean==true && const_var.leanGetDataRight != undefined && const_var.leanGetDataRight.connection_fees != undefined){
                const_var.a_p_d_a.connection_fees = const_var.leanGetDataRight.connection_fees;                
            }
        }

        let filterRoofPitchData = '';
        if(params.p_r_s==1 && params.m_s_n==13)
        {
            state.const_var.BuildingRoofPitch = [];
            
            filterRoofPitchData = (state.const_var.a_p_d_a.roof_pitch!=undefined)?state.const_var.a_p_d_a.roof_pitch.filter(data=>params.m_s_n==13 && params.p_r_s==1 && (data.roof_pitch).split("/")[0]<=3):'';
            if(filterRoofPitchData!='' && filterRoofPitchData.length>0)
            {
                dataNew.roof_pitch = JSON.parse(JSON.stringify(filterRoofPitchData));
                state.const_var.a_p_d_a.roof_pitch = JSON.parse(JSON.stringify(filterRoofPitchData));
                if(filterRoofPitchData.filter(data=>data.roof_pitch.replace("/", "")==params.b_r_p).length==0)
                {
                    let chkData = filterRoofPitchData.filter(data=>data.is_default == "yes");
                    if(chkData.length>0)
                    {
                        state.params.b_r_p = (chkData[0].roof_pitch).replace("/", "");
                        if(params.singleSlope == true && const_var.c_m_a[params.p_b_t]!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length>0){
                          let newRoofPitch = Number((chkData[0].roof_pitch).split("/")[0])-1
                          state.params.p_r_p = newRoofPitch;
                        }else{
                          state.params.p_r_p = (chkData[0].roof_pitch).split("/")[0];
                        }
                    }else
                    {
                        state.params.b_r_p = (filterRoofPitchData[0].roof_pitch).replace("/", "");
                        if(params.singleSlope == true && const_var.c_m_a[params.p_b_t]!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length>0){
                            let newRoofPitch = Number((filterRoofPitchData[0].roof_pitch).split("/")[0])-1
                            state.params.p_r_p = newRoofPitch;
                        }else{
                            state.params.p_r_p = (filterRoofPitchData[0].roof_pitch).split("/")[0];
                        }
                    }
                    cuBuilding.BuildingUpdate(true, '');
                }
                
            }
        }
        let eqiDis = 0;
        let eqiDisfive = 0;
        if(state.params.fourth_center_cost==true)
        {
            if(const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined)
            {
                eqiDis = (params.oncenter_val_with_action!='')?((params.p_d)/parseInt(params.oncenter_val_with_action)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
                eqiDisfive = (dataNew.building_structure[0]?.distance_on_center==5)?((params.p_d)/parseInt(dataNew.building_structure[0]?.distance_on_center)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
                eqiDisfive = parseFloat(eqiDisfive) + 1;
                eqiDis = parseFloat(eqiDis) +1;
            }
        } else {
            if(const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined)
            {
                eqiDis = (params.oncenter_val_with_action!='')?((params.p_d)/parseInt(params.oncenter_val_with_action)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0)
                eqiDisfive = (dataNew.building_structure[0]?.distance_on_center==5)?((params.p_d)/parseInt(dataNew.building_structure[0]?.distance_on_center)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
                eqiDisfive = parseFloat(eqiDisfive) + 1;
            }
        }
        if(
            //const_var.crmSetting.is_Edit == true && 
            const_var.editAPIDataByResponse && const_var.editAPIDataByResponse.data && const_var.editAPIDataByResponse.data.main_created_at != undefined && const_var.editAPIDataByResponse.data.main_created_at <= "2024-03-06"){
            const_var.isMultiSelectDrawingOpt = false
            // const_var.order_extra_items['engineer_drawings_name'] = 'Engineered Drawing'
        }
        // if(const_var.crmSetting.is_Edit == false){
            
        //     const_var.isMultiSelectDrawingOpt = true
        // }

        let DataNewDrawing = const_var.c_m_a != undefined && const_var.c_m_a[params.p_b_t] != undefined &&  const_var.c_m_a[params.p_b_t].drawings != undefined ? const_var.c_m_a[params.p_b_t].drawings : []
        if(
            (
                //const_var.crmSetting.is_Edit == true && 
                const_var.editAPIDataByResponse && const_var.editAPIDataByResponse.data && const_var.editAPIDataByResponse.data.main_created_at != undefined && const_var.editAPIDataByResponse.data.main_created_at > "2024-03-06" &&
                const_var.crmSetting.duplicate_module != '' && DataNewDrawing.length == 0) 
            || 
            DataNewDrawing.length == 0
            // ( const_var.crmSetting.is_Edit == false && DataNewDrawing.length == 0)
        )
        {
            const_var.isMultiSelectDrawingOpt = false
            const_var.order_extra_items['engineer_drawings_name'] = ''
            // const_var.order_extra_items['engineer_drawings_name'] = 'Engineered Drawing'
        }

        // let updateEDCost = (const_var.crmSetting.is_Edit == false || (const_var.crmSetting.is_Edit == true && const_var.editAPIDataByResponse && const_var.editAPIDataByResponse.data && const_var.editAPIDataByResponse.data.main_created_at != undefined && const_var.editAPIDataByResponse.data.main_created_at > "2024-03-06")) ? true : false

        let updateEDCost =  const_var.editAPIDataByResponse && const_var.editAPIDataByResponse.data && const_var.editAPIDataByResponse.data.main_created_at != undefined && const_var.editAPIDataByResponse.data.main_created_at <= "2024-03-06" ? false : true
// || const_var.isFromCompare == true
        // if(DataNewDrawing != undefined && DataNewDrawing.length > 0){
        if(DataNewDrawing != undefined && DataNewDrawing.length > 0 && updateEDCost == true){

            if( // const_var.crmSetting.is_Edit == true && 
            const_var.editAPIDataByResponse && const_var.editAPIDataByResponse.data && const_var.editAPIDataByResponse.data.main_created_at != undefined && const_var.editAPIDataByResponse.data.main_created_at > "2024-03-06"){
                let editSelOpt = const_var.editAPIDataByResponse.data.request_data.building.order_extra_items.engineer_drawings_name != undefined ? const_var.editAPIDataByResponse.data.request_data.building.order_extra_items.engineer_drawings_name : ''

                
                let isSelOptExsist = editSelOpt != '' ? DataNewDrawing.filter(obj => obj.name.toLowerCase() == editSelOpt.toLowerCase()) : []
                if(isSelOptExsist.length > 0 && const_var.isFromStateChange == false){
                    
                    const_var.order_extra_items['engineer_drawings_name'] = editSelOpt
                    const_var.order_extra_items['engineer_drawings'] = const_var.editAPIDataByResponse.data.request_data.building.order_extra_items.engineer_drawings
                }
                else{
                    let risk1Cost = DataNewDrawing.filter(obj => obj.is_default == 'yes')
                   
                    const_var.order_extra_items['engineer_drawings_name'] = risk1Cost.length > 0 ? risk1Cost[0].name : ''
                    const_var.order_extra_items['engineer_drawings'] = risk1Cost.length > 0 ? risk1Cost[0].cost : 0
                }
            }
            else{
                if(// const_var.crmSetting.is_Edit == true && 
                const_var.isKLinkEnable != true &&
                const_var.editAPIDataByResponse && const_var.editAPIDataByResponse.data && const_var.editAPIDataByResponse.data.main_created_at != undefined && const_var.editAPIDataByResponse.data.main_created_at <= "2024-03-06"){
                    let editSelOpt = (const_var.editAPIDataByResponse.data.request_data.building.order_extra_items.engineer_drawings_name == undefined || const_var.editAPIDataByResponse.data.request_data.building.order_extra_items.engineer_drawings_name == '') && const_var.editAPIDataByResponse.data.request_data.building.order_extra_items.engineer_drawings != undefined && const_var.editAPIDataByResponse.data.request_data.building.order_extra_items.engineer_drawings != '' ? 'Engineered Drawing' : ''
                    
                    let isSelOptExsist = editSelOpt != '' ? DataNewDrawing.filter(obj => obj.name.toLowerCase() == editSelOpt.toLowerCase()) : []
    
                    if(isSelOptExsist.length > 0 && const_var.isFromStateChange == false){
                        const_var.order_extra_items['engineer_drawings_name'] = editSelOpt
                        const_var.order_extra_items['engineer_drawings'] = const_var.editAPIDataByResponse.data.request_data.building.order_extra_items.engineer_drawings
                    }
                    else{
                        let risk1Cost = DataNewDrawing.filter(obj => obj.is_default == 'yes')
                        const_var.order_extra_items['engineer_drawings_name'] = risk1Cost.length > 0 ? risk1Cost[0].name : ''
                        const_var.order_extra_items['engineer_drawings'] = risk1Cost.length > 0 ? risk1Cost[0].cost : 0
                    }
                }
                else{
                    if(const_var.isKLinkEnable != true){
                        let TempObj= const_var.order_extra_items['engineer_drawings_name'] != undefined && const_var.order_extra_items['engineer_drawings_name'] != '' ? DataNewDrawing.filter(obj => obj.name.toLowerCase() == const_var.order_extra_items['engineer_drawings_name'].toLowerCase()) : []
                        let isExsist = TempObj.length > 0 ? true :false
                        if(const_var.order_extra_items['engineer_drawings_name'] != undefined && const_var.order_extra_items['engineer_drawings_name'] != '' && isExsist == true  && const_var.isFromStateChange == false){
                            const_var.order_extra_items['engineer_drawings_name'] = const_var.order_extra_items['engineer_drawings_name']
                            // const_var.order_extra_items['engineer_drawings'] = TempObj.length > 0 ? TempObj[0].cost : 0            
                            const_var.order_extra_items['engineer_drawings'] = const_var.order_extra_items['engineer_drawings']               
                        }
                        else{
                            let risk1Cost = DataNewDrawing.filter(obj => obj.is_default == 'yes')
                            const_var.order_extra_items['engineer_drawings_name'] = risk1Cost.length > 0 ? risk1Cost[0].name : ''
                            const_var.order_extra_items['engineer_drawings'] = risk1Cost.length > 0 ? risk1Cost[0].cost : 0                        
                        }
                    }
                    if(const_var.isKLinkEnable == true && const_var.order_extra_items.engineer_drawings_name != undefined && const_var.order_extra_items.engineer_drawings_name != '' && const_var.editAPIDataByResponse && const_var.editAPIDataByResponse.data && const_var.editAPIDataByResponse.data.main_created_at != undefined && const_var.editAPIDataByResponse.data.main_created_at > "2024-03-06" ){
                        let isvalueExsist = DataNewDrawing.filter(obj => obj.name == const_var.order_extra_items.engineer_drawings_name)
                        if(isvalueExsist.length == 0){
                            let risk1Cost = DataNewDrawing.filter(obj => obj.is_default == 'yes')
                            const_var.order_extra_items['engineer_drawings_name'] = risk1Cost.length > 0 ? risk1Cost[0].name : ''
                            const_var.order_extra_items['engineer_drawings'] = risk1Cost.length > 0 ? risk1Cost[0].cost : 0   
                        }
                    }
                }
            }
        }

        cuBuilding.makeCertificateArray();
        dynamicWallOptions(state);
        dynamicWallOptionsForLeanTo(state);
        
        // if ((str != 'w' || str != 'l' ) && str != 'roofPitch') cuBuilding.CheckLegsByResponse(state);
        if (str == "h"){
            cuBuilding.CheckLegsByResponse(state);
        }else {
            cuBuilding.BuildingUpdate(true,'');
        }


        if (const_var.ExtraItemsFeaturesQuantityArray.length > 0) {
            const extraItemsCheckboxQuantity = JSON.parse(JSON.stringify(const_var.ExtraItemsFeaturesQuantityArray));
            let updateExtraItemsCheckboxQuantity = [];
            let extraItemsCheckboxQuantityPricingAPI = JSON.parse(JSON.stringify(const_var.a_p_d_a.extra_items[0].checkbox_quantity));
            extraItemsCheckboxQuantityPricingAPI.forEach((currentItem , index) => {
                let oldItem = extraItemsCheckboxQuantity.find(oldItem => oldItem && oldItem.label === currentItem.label);
                if (oldItem) {
                    currentItem.is_checked = oldItem.is_checked;
                    currentItem.is_disabled = oldItem.is_disabled;
                    if(currentItem.is_checked==true)
                    {
                        oldItem.is_edit = oldItem.is_edit
                    }
                    currentItem.cost = oldItem.is_edit ? oldItem.cost : currentItem.cost;
                    currentItem.quantity = oldItem.quantity;
                    currentItem.is_edit = oldItem.is_edit;

                    if (oldItem.name == 'bows') {
                        currentItem.double_leg = oldItem.is_edit ? oldItem.double_leg : currentItem.double_leg;
                        currentItem.ladder_leg = oldItem.is_edit ? oldItem.ladder_leg : currentItem.ladder_leg;
                    }

                    if ( const_var.crmSetting.is_Edit && !const_var.isPriceAPIcalled && oldItem.name == 'bows' && !oldItem.is_edit && oldItem.is_disabled != undefined && oldItem.is_disabled) {
                        currentItem.cost = 0;
                        currentItem.double_leg = 0;
                        currentItem.ladder_leg = 0;
                        if (const_var.UpdatedPriceData['elements']!=undefined && const_var.UpdatedPriceData['elements'][oldItem.label.toString()]!=undefined && const_var.UpdatedPriceData['elements'][oldItem.label.toString()].is_edit!= undefined){
                            const_var.UpdatedPriceData['elements'][oldItem.label.toString()].is_edit = false;
                            const_var.UpdatedPriceData['elements'][oldItem.label.toString()].item_price = 0;
                        }
                    }
                    if (!const_var.crmSetting.is_Edit && params.fourth_center_cost==false ){
                        if (oldItem.name == 'bows') {
                            currentItem.is_disabled = false;
                            currentItem.cost = currentItem.cost;
                        }
                    }
                    const_var.extraItemsFeaturesQuantityCost[index] = currentItem.cost;
                } else {
                    currentItem = null;
                    const_var.extraItemsFeaturesQuantityCost[index] = null;
                }
                updateExtraItemsCheckboxQuantity.push(currentItem);
            });
            const_var.ExtraItemsFeaturesQuantityArray = updateExtraItemsCheckboxQuantity;
        }
        if (const_var.additionalFeaturesArray.length > 0) {
            state.const_var.additionalFeaturesArray.map((item,index) => {
                if (item!=null)
                {
                    let chkData = const_var.a_p_d_a.additional_features && const_var.a_p_d_a.additional_features.length > 0 && const_var.a_p_d_a.additional_features.find(data=>item && data.additional_feature==item.additional_feature);
                    if(chkData==undefined)
                    {
                        const_var.additionalFeaturesArray.splice(index,1);
                    }
                }
            })
            const_var.a_p_d_a.additional_features && const_var.a_p_d_a.additional_features.length > 0 && const_var.a_p_d_a.additional_features.map((val) => {
                state.const_var.additionalFeaturesArray.map(item => {
                    if (item && item.additional_feature == val.additional_feature &&const_var.UpdatedPriceData['elements']!=undefined  && const_var.UpdatedPriceData['elements'][item.additional_feature.toString()] != undefined &&  !const_var.UpdatedPriceData['elements'][item.additional_feature.toString()].is_edit) {
                        item.cost = val.cost;
                        item.cost_type = val.cost_type;
                        item.is_cumulative = val.is_cumulative;
                        item.percentage_of = val.percentage_of;
                    }
                });
            });
        }

        if ((const_var.crmSetting.is_Edit!=true || const_var.isPriceAPIcalled) && (const_var.ExtraItemsFeaturesArray.length > 0 || params.fourth_center_cost)) {
            const_var.a_p_d_a.extra_items[0].checkbox.map((val, index) => {
                state.const_var.ExtraItemsFeaturesArray.map(item => {
                    if (item != null) {
                        if (item.label == val.label && item.is_edit == false) {
                            item.cost = val.cost;
                        }
                        
                    }
                });
                if (const_var.DistanceArr[params.p_b_t][params.p_r_s] == 4 && val.name =="fourth_center_cost") {
                    state.const_var.ExtraItemsFeaturesArray[index] = JSON.parse(JSON.stringify(val));
                    const_var.extraItemsFeaturesCost[index] = val.cost;
                    state.const_var.ExtraItemsFeaturesArray[index].is_checked = true;
                    state.const_var.ExtraItemsFeaturesArray[index].quantity = 1;
                    if (const_var.UpdatedPriceData['elements']!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()]!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit!= undefined){
                        const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit = false;
                        const_var.UpdatedPriceData['elements'][val.label.toString()].item_price = val.cost;
                    }

                    if(state.const_var.ExtraItemsFeaturesArray[index].cost==0 && state.params.fourth_center_cost)
                    {
                        if(const_var.a_p_d_a.extra_items!=undefined && const_var.a_p_d_a.extra_items[0].checkbox_quantity!=undefined)
                        {
                            let dataNew = JSON.parse(JSON.stringify(const_var.a_p_d_a.extra_items[0].checkbox_quantity));
                            dataNew.map((quantityval, index1)=> {
                            if(quantityval.name=="bows")
                            {
                                if(quantityval.cost!=0 || quantityval.double_leg!=0 || quantityval.ladder_leg!=0)
                                {
                                    if(params.isDefaultfourFeet==false)
                                    {
                                        let exactNum = Math.abs(eqiDisfive - eqiDis);
                                        let price = (params.p_e_l && const_var.legstype.includes("double") && quantityval.double_leg != 0 )?parseFloat(quantityval.double_leg):(params.p_e_l && const_var.legstype.includes("ladder") && quantityval.ladder_leg != 0 )?parseFloat(quantityval.ladder_leg):parseFloat(quantityval.cost)
                                        state.const_var.ExtraItemsFeaturesArray[index].cost = state.const_var.ExtraItemsFeaturesArray[index].cost==0?parseFloat(price * exactNum):state.const_var.ExtraItemsFeaturesArray[index].cost;
                                    }
                                    if(params.isDefaultfourFeet==true)
                                    {
                                        state.const_var.ExtraItemsFeaturesArray[index].cost = state.const_var.ExtraItemsFeaturesArray[index].cost;
                                    }
                                    const_var.extraItemsFeaturesCost[index] = state.const_var.ExtraItemsFeaturesArray[index].cost;
                                            if(quantityval.name == "bows")
                                            {
                                                if(params.fourth_center_cost==true)
                                                {
                                                    const_var.ExtraItemsFeaturesQuantityArray[index1] = quantityval;
                                                    const_var.ExtraItemsFeaturesQuantityArray[index1].quantity = 1;
                                                    const_var.ExtraItemsFeaturesQuantityArray[index1].is_checked = (params.fourth_center_cost==true)?true:false;
                                                    const_var.ExtraItemsFeaturesQuantityArray[index1].cost = 0;
                                                    const_var.ExtraItemsFeaturesQuantityArray[index1].double_leg = 0;
                                                    const_var.ExtraItemsFeaturesQuantityArray[index1].ladder_leg = 0;
                                                    const_var.ExtraItemsFeaturesQuantityArray[index1].is_edit = false;
                                                    const_var.ExtraItemsFeaturesQuantityArray[index1].is_disabled = true;
                                                }
                                            }
                                       
                                }
                                if(params.fourth_center_cost==true)
                                {
                                    if (params.add_front_lean) calculateLegsCount(const_var.leanGetDataFront,'frontLean');
                                    if (params.add_left_lean) calculateLegsCount(const_var.leanGetDataLeft,'leftLean');
                                    if (params.add_right_lean) calculateLegsCount(const_var.leanGetDataRight,'rightLean');
                                    if (params.add_back_lean) calculateLegsCount(const_var.leanGetDataBack,'backLean'); 

                                }
                            }
                        })
                        }
                    }else{
                        if(params.isDefaultfourFeet)
                        {
                            if (params.add_front_lean) calculateLegsCount(const_var.leanGetDataFront,'frontLean');
                            if (params.add_left_lean) calculateLegsCount(const_var.leanGetDataLeft,'leftLean');
                            if (params.add_right_lean) calculateLegsCount(const_var.leanGetDataRight,'rightLean');
                            if (params.add_back_lean) calculateLegsCount(const_var.leanGetDataBack,'backLean'); 

                        }
                    }
                }
                
            });
            if(const_var.a_p_d_a.overhang != undefined && ((const_var.a_p_d_a.overhang.end != undefined && const_var.a_p_d_a.overhang.end.length > 0) || (const_var.a_p_d_a.overhang.side != undefined && const_var.a_p_d_a.overhang.side.length > 0) || (const_var.a_p_d_a.overhang.both != undefined && const_var.a_p_d_a.overhang.both != ''))){
                Object.entries(const_var.a_p_d_a.overhang).map((val,key)=>{
                    
                    val = val[0];

                    if(val == 'both'){
                        if(const_var.a_p_d_a.overhang[val] != '' && const_var.a_p_d_a.overhang[val] != null){
                            state.const_var.ExtraItemsFeaturesArray.map(item => {
                                if (item != null) {
                                    if (item.sheet_type != undefined && item.sheet_type == "both" && item.is_edit == false) {
                                        item.cost = const_var.a_p_d_a.overhang[val].cost;
                                        item.cost_type = const_var.a_p_d_a.overhang[val].cost_type
                                        item.price_of = const_var.a_p_d_a.overhang[val].price_of
                                    }
                                    
                                }
                            });
                        }
                    }
                    else{
                        if(const_var.a_p_d_a.overhang[val] != '' && const_var.a_p_d_a.overhang[val].length == 0 && const_var.a_p_d_a.overhang[val]['sheet_name'] != undefined){
                            state.const_var.ExtraItemsFeaturesArray.map(item => {
                                if (item != null) {
                                    if (item.sheet_name != undefined && item.sheet_name == const_var.a_p_d_a.overhang[val].sheet_name && item.is_edit == false) {
                                        item.cost = const_var.a_p_d_a.overhang[val].cost;
                                        item.cost_type = const_var.a_p_d_a.overhang[val].cost_type
                                        item.price_of = const_var.a_p_d_a.overhang[val].price_of
                                    }
                                    
                                }
                            });
                        }
                        if(const_var.a_p_d_a.overhang[val] && const_var.a_p_d_a.overhang[val].length > 0 && const_var.a_p_d_a.overhang[val][0] != undefined){
                            const_var.a_p_d_a.overhang[val].map((overItem, idx)=>{
                                state.const_var.ExtraItemsFeaturesArray.map(item => {
                                    if (item != null) {
                                        if (item.sheet_name != undefined && item.sheet_name == overItem.sheet_name && item.is_edit == false) {
                                            item.cost = overItem.cost;
                                            item.cost_type = overItem.cost_type
                                            item.price_of = overItem.price_of
                                        }
                                        
                                    }
                                });
                            })
                        }
                    }
 
                })
            }

        }

        if ((dataNew.roof_pitch != undefined) && (dataNew.roof_pitch.length > 0)) {
            state.const_var.b_r_p_a = [];

            var data = state.const_var.a_p_d_a;
            var chkPitchDataforRoof = false;
            if (data.roof_pitch.length > 0) {
                let chkPitchData = data.roof_pitch.filter(data => data.roof_pitch.replace("/", "") == params.b_r_p)
                //console.log(chkPitchData,"chkPitchData",chkPitchData.length)
                if (chkPitchData != undefined && chkPitchData.length == 0) {
                    state.const_var.BuildingRoofPitch = [];
                    chkPitchDataforRoof = true;
                }

            }
            if(const_var.crmSetting.is_Edit && response.data.fixed_new_leg_width!=undefined && response.data.fixed_new_leg_width.length>0)
            {
                state.const_var.BuildingRoofPitch = [];
                chkPitchDataforRoof = true;
                state.c_m_a[state.params.p_b_t].fixed_new_leg_width = response.data.fixed_new_leg_width;
                makeDimensionArray(state);
            }
            for (var i = 0; i <= data.roof_pitch.length - 1; i++) {
                let repl = (data.roof_pitch[i].roof_pitch).split("/");
                state.const_var.b_r_p_a[(data.roof_pitch[i].roof_pitch).replace("/", "")] = data.roof_pitch[i];
                state.const_var.BuildingRoofPitch[data.roof_pitch[i].roof_pitch] = (data.roof_pitch[i].roof_pitch).replace("/", "");
                if (data.roof_pitch[i].is_default == "yes") {
                    state.const_var.checkRoofDefault = (data.roof_pitch[i].roof_pitch).replace("/", "");
                    if(state.params.b_r_p !== state.const_var.checkRoofDefault && const_var.crmSetting.is_Edit !== true){
                        let otherBuildingExist = state.const_var.defaultBuildingJson.id !== undefined && state.const_var.defaultBuildingArr[state.const_var.defaultBuildingJson.id] !== undefined ? state.const_var.defaultBuildingArr[state.const_var.defaultBuildingJson.id].other_building_id.split(",") : []
                        if(const_var.c_m_a[params.p_b_t]!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length>0 && otherBuildingExist.length > 0 && state.const_var.defaultBuildingArr[state.const_var.defaultBuildingJson.id].central_roof_pitch !== undefined){
                            state.params.b_r_p = state.const_var.checkRoofDefault
                            state.params.p_r_p = Number((data.roof_pitch[i].roof_pitch).split("/")[0])
                            const_var.UpdatedPriceData.roof_pitch_price_changed = true;
                            state.const_var.defaultBuildingArr[state.const_var.defaultBuildingJson.id].central_roof_pitch = (data.roof_pitch[i].roof_pitch)
                            cuBuilding.BuildingUpdate(true, '');
                        }
                    }
                }
                if (data.roof_pitch[i].is_default == "yes" && const_var.CallApionAction == false) {
                    state.params.b_r_p = (data.roof_pitch[i].roof_pitch).replace("/", "");
                    if(params.singleSlope == true && const_var.c_m_a[params.p_b_t]!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length>0){
                        let newRoofPitch = Number((data.roof_pitch[i].roof_pitch).split("/")[0])-1
                        state.params.p_r_p = newRoofPitch;
                    }else{
                        state.params.p_r_p = (data.roof_pitch[i].roof_pitch).split("/")[0];
                    }                    
                }
                if (data.roof_pitch[i].is_default == "yes" && chkPitchDataforRoof == true) {
                    state.params.b_r_p = (data.roof_pitch[i].roof_pitch).replace("/", "");
                    if(params.singleSlope == true && const_var.c_m_a[params.p_b_t]!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length>0){
                        let newRoofPitch = Number((data.roof_pitch[i].roof_pitch).split("/")[0])-1
                        state.params.p_r_p = newRoofPitch;
                    }else{
                        state.params.p_r_p = (data.roof_pitch[i].roof_pitch).split("/")[0];
                    }                    
                }
                if(chkPitchDataforRoof == true)
                {
                    const_var.UpdatedPriceData.roof_pitch_price_changed = true;
                }

            }
            if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
                makeDimensionArray(state);

            }
            if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
                cuBuilding.BuildingUpdate(true, '');

            }
            const {m_s_n,p_r_s} = {...state.params}
            const isRegularRoofStyle = p_r_s ==ManufacturesDefaultDetails.JV_METALS_BUILDING_LLC.roofStyle;
            const isJVMetalsMfgWithDefaultRoofStyle = ManufacturesDefaultDetails.JV_METALS_BUILDING_LLC.id == m_s_n && Object.values(const_var.BuildingRoofPitch).includes('312') && isRegularRoofStyle;
      
      
            const selectedRoof = Object.values(const_var.BuildingRoofPitch).find(item => item == ManufacturesDefaultDetails.JV_METALS_BUILDING_LLC.defaultRoofPitch);
            if(isJVMetalsMfgWithDefaultRoofStyle && selectedRoof) {
                state.params.b_r_p = selectedRoof;
                state.const_var.checkRoofDefault = selectedRoof;
            } else {
                state.params.b_r_p = (state.params.b_r_p != "") ? state.params.b_r_p : "Select";
            }
        }
        if (params.add_left_lean == true && const_var.leanGetDataLeft.central_side != undefined && const_var.leanGetDataLeft.central_side.length > 0) {
            const_var.leanGetDataLeft.central_side = undefined;
        }
        if (params.add_left_lean == true && const_var.leanGetDataLeft.central_end != undefined && const_var.leanGetDataLeft.central_end.length > 0) {
            const_var.leanGetDataLeft.central_end = undefined;
        }
        if (params.add_right_lean == true && const_var.leanGetDataRight.central_side != undefined && const_var.leanGetDataRight.central_side.length > 0) {
            const_var.leanGetDataRight.central_side = undefined;
        }
        if (params.add_right_lean == true && const_var.leanGetDataRight.central_end != undefined && const_var.leanGetDataRight.central_end.length > 0) {
            const_var.leanGetDataRight.central_end = undefined;
        }
        //state.params.b_r_p = const_var.defaultProData.roof_pitch.replace("/", "");
        // if(state.params.p_b_t==2)
        // {

        state.c_m_a[state.params.p_b_t].garage_door = dataNew.garage_door;
        state.c_m_a[state.params.p_b_t].walkings = dataNew.walkin;
        state.c_m_a[state.params.p_b_t].windows = dataNew.windows;
        state.c_m_a[state.params.p_b_t].garage_door_frameout = dataNew.garage_door_frameout;
        state.c_m_a[state.params.p_b_t].walkin_door_frameout = dataNew.walkin_door_frameout;
        state.c_m_a[state.params.p_b_t].window_frameout = dataNew.window_frameout;

        state.c_m_a[state.params.p_b_t].garage_door_v3 = dataNew.garage_door_v3;
        state.c_m_a[state.params.p_b_t].garage_door_frameout_v3 = dataNew.garage_door_frameout_v3;
        state.c_m_a[state.params.p_b_t].walkin_door_frameout_v3 = dataNew.walkin_door_frameout_v3;
        state.c_m_a[state.params.p_b_t].window_frameout_v3 = dataNew.window_frameout_v3;
        if(dataNew.walkin_door_v3!=undefined)
        {
            state.c_m_a[state.params.p_b_t].walkin_door_v3 = dataNew.walkin_door_v3;
            state.c_m_a[state.params.p_b_t].window_v3 = dataNew.window_v3;
        }

        const_var.newComponentArray = {};
        const_var.CustomDoorArr = {
            'Garage': { 'Size': {}, 'Object': {}, 'SidePrice': {}, 'EndPrice': {}, 'TrimKit': {}, 'Chain_Hoist': {}, 'Header_Seal': {}, 'Is_Chain_Hoist': {}, 'Is_Header_Seal': {}, 'Is_Certified': {}, 'Certified_Cost': {}, 'Is_Automatic_Openers': {}, 'Automatic_Openers_Cost': {}, 'garageDoorColor': {} },
            'sectionalGarage': { 'Size': {}, 'Object': {}, 'SidePrice': {}, 'EndPrice': {}, 'TrimKit': {}, 'Chain_Hoist': {}, 'Header_Seal': {} },
            'Walk': { 'Size': {}, 'Object': {}, 'SidePrice': {}, 'EndPrice': {} },
            'WalkFrameout': { 'Size': {}, 'Object': {}, 'SidePrice': {}, 'EndPrice': {} },
            'Windows': { 'Size': {}, 'Object': {}, 'SidePrice': {}, 'EndPrice': {} },
            'WindowsFrameout': { 'Size': {}, 'Object': {}, 'SidePrice': {}, 'EndPrice': {} },
            'GarageFrameout': { 'Size': {}, 'Object': {}, 'SidePrice': {}, 'EndPrice': {}, 'TrimKit': {} },
            'CustomFrameout': { 'Size': {}, 'Object': {}, 'SidePrice': {}, 'EndPrice': {}, 'TrimKit': {}, 'Width': {}, 'Height': {} }
        };
        const_var.customFrameoutInitialSize = "";
        makeComponentArray(state);
        if (state.const_var.defaultProData.roof_pitch != undefined && state.const_var.defaultProData.roof_pitch != params.b_r_p && const_var.CallApionAction == false) {
            state.params.b_r_p = state.const_var.defaultProData.roof_pitch.replace("/", "");
        }

        cuBuilding.makeExtraElements();
        if(const_var.crmSetting.is_Edit==true)
        {
            if(const_var.c_f_aCer[params.p_e_i]!=undefined && const_var.c_f_aCer[params.p_e_i].distance_on_center!=undefined && const_var.c_f_aCer[params.p_e_i].distance_on_center!=5)
            {
                utils.calculateFourthCenterCostwithExtraBows();
            }

            if(const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.request_data !=undefined && const_var.editAPIDataByResponse.data.request_data.building !=undefined && (params.m_s_n==122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97)){
                if(params.p_l_w.toLowerCase() != const_var.editAPIDataByResponse.data.request_data.building.left_wall.toLowerCase()){
                    const_var.UpdatedPriceData.left_wall_price_changed = true;
                }
                if(params.p_r_w.toLowerCase() != const_var.editAPIDataByResponse.data.request_data.building.right_wall.toLowerCase()){
                    const_var.UpdatedPriceData.right_wall_price_changed = true;
                }          
                let editedFrontWall = const_var.editAPIDataByResponse.data.request_data.building.front_wall.toLowerCase() == 'extended_gable' ? const_var.editAPIDataByResponse.data.request_data.building.front_wall.replace("_", " ") : const_var.editAPIDataByResponse.data.request_data.building.front_wall
                let editedBackall = const_var.editAPIDataByResponse.data.request_data.building.back_wall.toLowerCase() == 'extended_gable' ? const_var.editAPIDataByResponse.data.request_data.building.back_wall.replace("_", " ") : const_var.editAPIDataByResponse.data.request_data.building.back_wall
                if(params.p_f_w.toLowerCase() != editedFrontWall.toLowerCase()){
                    const_var.UpdatedPriceData.front_wall_price_changed = true;
                }
                if(params.p_b_w.toLowerCase() != editedBackall.toLowerCase()){
                    const_var.UpdatedPriceData.back_wall_price_changed = true;
                }
                // if(params.p_f_w != const_var.editAPIDataByResponse.data.request_data.building.front_wall){
                //     const_var.UpdatedPriceData.front_wall_price_changed = true;
                // }
                // if(params.p_b_w != const_var.editAPIDataByResponse.data.request_data.building.back_wall){
                //     const_var.UpdatedPriceData.back_wall_price_changed = true;
                // }
            }
        }


        cuBuilding.cP();
        if (params.p_b_w == "Close" && params.p_l_w == "Close" && params.p_r_w == "Close" && params.p_f_w == "Close") {
            state.isFullyEnclosedChecked = true
        }
        if (state.params.p_b_c_b_l_f == "Close" && state.params.p_b_c_b_l_b == "Close" && state.params.p_b_c_b_l == "Close") {
            state.isFullyEnclosedCheckedForLeftLeanTo = true
        }
        if (state.params.p_b_c_b_r_f == "Close" && state.params.p_b_c_b_r_b == "Close" && state.params.p_b_c_b_r == "Close") {
            state.isFullyEnclosedCheckedForRightLeanTo = true
        }
        if (state.params.p_b_c_b_l_f == "Open" && state.params.p_b_c_b_l_b == "Open" && state.params.p_b_c_b_l == "Open") {
            state.isFullyOpenedCheckedForLeftLeanTo = true
        }
        if (state.params.p_b_c_b_r_f == "Open" && state.params.p_b_c_b_r_b == "Open" && state.params.p_b_c_b_r == "Open") {
            state.isFullyOpenedCheckedForRightLeanTo = true
        }
        let checkWallVal = false;
        if(const_var.crmSetting.is_Edit==false && (params.p_f_w=="Close" || params.p_b_w=="Close" || params.p_l_w=="Close" || params.p_r_w=="Close" || state.const_var.defaultBuildingImgName == "Utility_Buildings" || state.const_var.defaultBuildingImgName.includes("Breezeway_Building")))
        {
            checkWallVal = true;
        }
        //console.log(const_var.CallApionAction,"const_var.CallApionAction")
        if(const_var.CallApionAction==false && const_var.crmSetting.is_Edit == false && const_var.defaultBuildingArr[state.defaultBuilding]!=undefined && const_var.defaultBuildingArr[state.defaultBuilding].central_roof_pitch!=undefined && const_var.defaultBuildingArr[state.defaultBuilding].central_roof_pitch!=null)
        {
            state.params.b_r_p = const_var.defaultBuildingArr[state.defaultBuilding].central_roof_pitch.replace("/", "");
            if(params.singleSlope == true && const_var.c_m_a[params.p_b_t]!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length>0){
                let newRoofPitch = Number((const_var.defaultBuildingArr[state.defaultBuilding].central_roof_pitch).split("/")[0])-1
                state.params.p_r_p = newRoofPitch;
            }else{                    
                state.params.p_r_p = const_var.defaultBuildingArr[state.defaultBuilding].central_roof_pitch.split("/")[0];
            }
        }
        if(const_var.crmSetting.is_Edit == false && const_var.defaultBuildingArr[state.defaultBuilding]!=undefined)
        {
            var chkEndJtrim = false;
            var chkSideJtrim = false;
            if((const_var.a_p_d_a.jtrim) && const_var.a_p_d_a.jtrim.length>0)
            {
                chkEndJtrim = (const_var.a_p_d_a.jtrim.filter(data=>data.type=="end")).length>0?true:false;
                chkSideJtrim = (const_var.a_p_d_a.jtrim.filter(data=>data.type=="side")).length>0?true:false;
                if(params.p_f_w!="Open" && params.p_f_w!="Close" && params.p_f_w!="Half Dutch End" && params.p_f_w!="Half End" && chkEndJtrim==true)
                {
                    params.p_j_t_end = true;
                }
               if(params.p_b_w!="Open" && params.p_b_w!="Close" && params.p_b_w!="Half Dutch End" && params.p_b_w!="Half End" && chkEndJtrim==true)
                {
                    params.p_j_t_end = true;
                }
                if(params.p_l_w!="Open" && params.p_l_w!="Close" && chkSideJtrim==true)
                {
                    params.p_j_t = true;
                }
                if(params.p_r_w!="Open" && params.p_r_w!="Close" && chkSideJtrim==true)
                {
                    params.p_j_t = true;
                }
                if(params.p_b_c_b_f_f!="Open" && params.p_b_c_b_f_f!="Close" && params.p_b_c_b_f_f!="Half Dutch End" && params.p_b_c_b_f_f!="Half End" && chkEndJtrim==true)
                {
                    params.p_j_t_end = true;
                }
                if(params.p_b_c_b_f_b!="Open" && params.p_b_c_b_f_b!="Close" && params.p_b_c_b_f_b!="Half Dutch End" && params.p_b_c_b_f_b!="Half End" && chkEndJtrim==true)
                {
                    params.p_j_t_end = true;
                }
                if(params.p_b_c_b_f_l!="Open" && params.p_b_c_b_f_l!="Close" && chkSideJtrim==true)
                {
                    params.p_j_t = true;
                }
                if(params.p_b_c_b_b_b!="Open" && params.p_b_c_b_b_b!="Close" && params.p_b_c_b_b_b!="Half Dutch End" && params.p_b_c_b_b_b!="Half End" && chkEndJtrim==true)
                {
                    params.p_j_t_end = true;
                }
                if(params.p_b_c_b_b_l!="Open" && params.p_b_c_b_b_l!="Close" && chkSideJtrim==true)
                {
                    params.p_j_t = true;
                }
                if(params.p_b_c_b_b_f!="Open" && params.p_b_c_b_b_f!="Close" && params.p_b_c_b_b_f!="Half Dutch End" && params.p_b_c_b_b_f!="Half End" && chkEndJtrim==true)
                {
                    params.p_j_t_end = true;
                }
                if(params.p_b_c_b_l_f!="Open" && params.p_b_c_b_l_f!="Close" && params.p_b_c_b_l_f!="Half Dutch End" && params.p_b_c_b_l_f!="Half End" && chkEndJtrim==true)
                {
                    params.p_j_t_end = true;
                }
                if(params.p_b_c_b_l_b!="Open" && params.p_b_c_b_l_b!="Close" && params.p_b_c_b_l_b!="Half Dutch End" && params.p_b_c_b_l_b!="Half End" && chkEndJtrim==true)
                {
                    params.p_j_t_end = true;
                }
                if(params.p_b_c_b_l!="Open" && params.p_b_c_b_l!="Close" && chkSideJtrim==true)
                {
                    params.p_j_t = true;
                }
                if(params.p_b_c_b_r_f!="Open" && params.p_b_c_b_r_f!="Close" && params.p_b_c_b_r_f!="Half Dutch End" && params.p_b_c_b_r_f!="Half End" && chkEndJtrim==true)
                {
                    params.p_j_t_end = true;
                }
                if(params.p_b_c_b_r_b!="Open" && params.p_b_c_b_r_b!="Close" && params.p_b_c_b_r_b!="Half Dutch End" && params.p_b_c_b_r_b!="Half End" && chkEndJtrim==true)
                {
                    params.p_j_t_end = true;
                }
                if(params.p_b_c_b_r!="Open" && params.p_b_c_b_r!="Close" && chkSideJtrim==true)
                {
                    params.p_j_t = true;
                }
            }
        }
        // console.log(const_var.showProcessLoaderchkEdit,"const_var.showProcessLoaderchkEdit")
        if (const_var.crmSetting.is_Edit == false && checkWallVal==true && state.const_var.defalutProductLoad == true && const_var.defaultBuildingArr[state.defaultBuilding].default_doors != undefined && const_var.defaultBuildingArr[state.defaultBuilding].default_doors != null && const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0) {
            // console.log(const_var.showProcessLoaderchkEdit,"const_var.showProcessLoaderchkEdit")
            const_var.CheckDoorForEdit = true;
            cuComponent.removeAlltheComponent();
            // console.log(const_var.showProcessLoaderchkEdit,"const_var.showProcessLoaderchkEdit")
            // let prom = Promise.resolve(undefined);
            if(const_var.defaultBuildingArr[state.defaultBuilding].central_roof_pitch!=undefined && const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0 && Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].wall).length>1 && const_var.defaultBuildingArr[state.defaultBuilding].wall.front!=undefined)
            {
                // console.log(const_var.showProcessLoaderchkEdit,"const_var.showProcessLoaderchkEdit")
                let DoorMainIndexName = "";
                if(const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0) {
                const_var.defaultBuildingArr[state.defaultBuilding].default_doors.map(async(data,index)=>{
                    if(const_var.b_o_J_1[params.p_b_t].includes("Free Standing") && (data.wall=="right" || data.wall=="c_b_r_w"))
                    {
                        data.wall = "F_S_L_R_W";
                    }

                    if (isEdit === false && const_var.b_o_J_1[params.p_b_t].includes("Free Standing") && data.wall === "F_S_L_R_W") {
                        data.wall = "c_b_r_w";
                    }

                    let checkType = data.component == undefined ? data.type : data.component;
                    if(state.const_var.defaultBuildingImgName == "Utility_Buildings" && params.p_u_c==true)
                    {
                        data.wall = data.wall=="front"?"ufend":data.wall;
                    }
                    if(checkType =="standard_door" || checkType =="garage_door")
                    {
                        if(const_var.newComponentArray['Garage'][data.type]==undefined)
                        {
                            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index,1);
                        }
                        if(const_var.newComponentArray['Garage'][data.type][data.category]==undefined)
                        {
                            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index,1);
                        }
                        DoorMainIndexName = "Garage";
                    }
                    if(checkType =="garage_door_frameout")
                    {
                        if(const_var.newComponentArray['Garage_Frameout'][data.type]==undefined)
                        {
                            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index,1);
                        }
                        if(const_var.newComponentArray['Garage_Frameout'][data.type][data.category]==undefined)
                        {
                            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index,1);
                        }
                        DoorMainIndexName = "Garage_Frameout";
                    }
                    if(data.type.includes("walkin"))
                    {
                        if(data.component == "walk_in_door"){
                            data.component = "walkin"
                        }
                        if(const_var.newComponentArray['Walk'][data.type]==undefined)
                        {
                            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index,1);
                        }
                        if(const_var.newComponentArray['Walk'][data.type][data.category]==undefined)
                        {
                            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index,1);
                        }
                        
                        DoorMainIndexName = "Walk";
                    }
                    if(data.type =="walkin_frameout")
                    {
                        if(const_var.newComponentArray['Walk_Frameout'][data.type]==undefined)
                        {
                            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index,1);
                        }
                        if(const_var.newComponentArray['Walk_Frameout'][data.type][data.category]==undefined)
                        {
                            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index,1);
                        }
                        DoorMainIndexName = "Walk_Frameout";
                    }

                    if(data.type.includes("window") && !data.type.includes("walkin") && !data.type.includes("window_frameout"))
                    {
                        if(const_var.newComponentArray['Windows'][data.type]==undefined)
                        {
                            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index,1);
                        }
                        if(const_var.newComponentArray['Windows'][data.type][data.category]==undefined)
                        {
                            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index,1);
                        }
                        DoorMainIndexName = "Windows";
                    }
                    if(data.type =="window_frameout")
                    {
                        if(const_var.newComponentArray['Windows_Frameout'][data.type]==undefined)
                        {
                            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index,1);
                        }
                        if(const_var.newComponentArray['Windows_Frameout'][data.type][data.category]==undefined)
                        {
                            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index,1);
                        }
                        DoorMainIndexName = "Windows_Frameout";
                    }

                    if(const_var.defaultBuildingArr[state.defaultBuilding].default_doors[index]!=undefined)
                    {
                        // const func = (compType, compName, wall, componentsize, parentkey, childkey, nestedkey,rot,pos,is_edit,parentOBJ, buildingType) => {
                        //     prom = prom.then(async(res, rej) => {
                        //         const ans = await AddDoorComponentonWall(compType, compName, wall, componentsize, parentkey, childkey, nestedkey,rot,pos,is_edit,parentOBJ, buildingType);
                        //     });                        
                        // } 
                        
                        AddDoorComponentonWall(data.component, data.type, const_var.entry_wall_location_reverse[data.wall]!=undefined?const_var.entry_wall_location_reverse[data.wall]:data.wall, data.size, DoorMainIndexName, data.type, data.category);

                    }
                })
            }

            }else{
          
            //  console.log(const_var.showProcessLoaderchkEdit,"const_var.showProcessLoaderchkEdit")   
            if (const_var.defaultBuildingArr[state.defaultBuilding].default_doors != null && typeof const_var.defaultBuildingArr[state.defaultBuilding].default_doors == 'string') {
                const_var.defaultBuildingArr[state.defaultBuilding].default_doors = JSON.parse(const_var.defaultBuildingArr[state.defaultBuilding].default_doors);
            }

            if(const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0) {
                const_var.defaultBuildingArr[state.defaultBuilding].default_doors.map((data,index)=>{
                    let checkType = data.component == undefined ? data.type : data.component;
                    if(checkType =="standard_door" || checkType =="garage_door")
                    {
                        if(data.type=="garage_door")
                        {
                            data.type = "standard_door"
                        }
                        if(data.component==undefined)
                        {
                            data.component = checkType;
                            if(data.category==undefined)
                            {
                                data.category = "Roll-Up";
                            }
                        }
                        if(const_var.newComponentArray['Garage'][data.type]==undefined)
                        {
                            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index,1);
                        }
                        if(data.category!=undefined && const_var.newComponentArray['Garage'][data.type][data.category]==undefined)
                        {
                            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index,1);
                        }
                    }
                    if(data.type =="standard_walkin")
                    {
                        if(const_var.newComponentArray['Walk'][data.type]==undefined)
                        {
                            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index,1);
                        }
                        if(data.category!=undefined && const_var.newComponentArray['Walk'][data.type][data.category]==undefined)
                        {
                            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index,1);
                        }
                    }
                })
                

            }    
            if (const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0) {
                let leftWallComponent = const_var.defaultBuildingArr[state.defaultBuilding].default_doors.filter(data => data.wall == "left" || data.wall == "c_b_l_w");
                if (leftWallComponent.length > 0) {

                    let mainPos = 0;
                    let mainPosArray = [];
                    for (let leftWallData of leftWallComponent) {
                        let h = (params.p_w / -2 - 0) * 1 - 1 * 1;
                        let j = (params.p_d / 2 + 0) * 1 + 1 * 1;
                        let newData = "";
                        let checkType = leftWallData.component == undefined ? leftWallData.type : leftWallData.component;
                        // console.log({checkType});
                        if (checkType == "garage_door") {
                            var splitname = leftWallData.size.split("x");
                            if (mainPosArray[mainPos - 1] == undefined) {
                                newData = (params.p_d / 2) - (splitname[0] / 2 + 1);
                            } else {
                                newData = Number(mainPosArray[mainPos - 1]) - Number(parseInt(splitname[0]) + 1);
                            }
                            state.params.DoorPosOnEdit = { 'x': h, 'y': 0, 'z': newData };
                            mainPosArray[mainPos] = newData;

                            state.params.UpdatedDoorPosOnEdit = "";
                            state.params.DoorLocOnEdit = leftWallData.wall;
                            state.params.DoorRotOnEdit = Math.PI / -2 * 1;
                            state.params.doorType = "Garage";
                            if (leftWallData.component == undefined) {
                                AddDoorComponentonWall(leftWallData.type, 'standard_door', const_var.entry_wall_location_reverse[leftWallData.wall], leftWallData.size, 'Garage', 'standard_door', 'Roll-Up');
                            } else {
                                AddDoorComponentonWall(leftWallData.component, 'standard_door', const_var.entry_wall_location_reverse[leftWallData.wall], leftWallData.size, 'Garage', leftWallData.type, leftWallData.category);
                            }

                        }
                        else {
                            var splitname = leftWallData.size.split("x");
                            if (mainPosArray[mainPos - 1] == undefined) {
                                newData = (params.p_d / 2) - ((splitname[0] / 12) / 2 + 1);
                            } else {
                                newData = Number(mainPosArray[mainPos - 1]) - Number(parseInt((splitname[0] / 12)) + parseInt((splitname[0] / 12)));
                            }
                            state.params.DoorPosOnEdit = { 'x': h, 'y': 0, 'z': newData };
                            mainPosArray[mainPos] = newData;

                            state.params.UpdatedDoorPosOnEdit = "";
                            state.params.DoorLocOnEdit = leftWallData.wall;
                            state.params.DoorRotOnEdit = Math.PI / -2 * 1;
                            params.doorType = "Walk";
                            if (leftWallData.component == undefined) {
                                if(const_var.newComponentArray['Walk']['standard_walkin']!=undefined)
                                {
                                    AddDoorComponentonWall(leftWallData.type, 'standard_walkin', const_var.entry_wall_location_reverse[leftWallData.wall], leftWallData.size, 'Walk', 'standard_walkin', 'Man Door');
                                }

                            } else {
                                AddDoorComponentonWall(leftWallData.component=="walk_in_door"?'walkin':leftWallData.component, leftWallData.type, const_var.entry_wall_location_reverse[leftWallData.wall], leftWallData.size, 'Walk', leftWallData.type, leftWallData.category);
                            }
                        }
                        mainPos++;
                                
                            }
                        }
                        
                    }
                    if (const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0) {
                        let leftWallComponent = const_var.defaultBuildingArr[state.defaultBuilding].default_doors.filter(data => data.wall == "right" || data.wall == "c_b_r_w");
                        if (leftWallComponent.length > 0) {
                            let mainPos = 0;
                            let mainPosArray = [];
                            for (let leftWallData of leftWallComponent) {

                                let h = (params.p_w / 2 + 0) * 1 + 1 * 1;
                                let newData = "";
                                let checkType = leftWallData.component == undefined ? leftWallData.type : leftWallData.component;
                                if (checkType == "garage_door") {
                                    var splitname = leftWallData.size.split("x");

                                    if (mainPosArray[mainPos - 1] == undefined) {
                                        // console.log(newData,"params.DoorPosOnEdit111")
                                        newData = (params.p_d / 2) - (splitname[0] / 2 + 1);
                                    } else {
                                        // console.log(newData,"params.DoorPosOnEdit2222",splitname,splitname[0],typeof splitname[0],Number(mainPosArray[mainPos-1]) - Number(splitname[0]+1))
                                        newData = Number(mainPosArray[mainPos - 1]) - Number(parseInt(splitname[0]) + 1);
                                    }
                                    state.params.DoorPosOnEdit = { 'x': h, 'y': 0, 'z': newData };
                                    mainPosArray[mainPos] = newData;

                                    state.params.UpdatedDoorPosOnEdit = "";
                                    state.params.DoorLocOnEdit = leftWallData.wall;
                                    state.params.DoorRotOnEdit = Math.PI / 2 * 1;
                                    state.params.doorType = "Garage";
                                    let newWallName = const_var.entry_wall_location_reverse[leftWallData.wall];
                                    if(const_var.b_o_J_1[params.p_b_t].includes("Free Standing"))
                                    {
                                        newWallName = "c_b_r_w";
                                    }
                                    if (leftWallData.component == undefined) {
                                        AddDoorComponentonWall(leftWallData.type, 'standard_door', newWallName, leftWallData.size, 'Garage', 'standard_door', 'Roll-Up');
                                    } else {
                                        AddDoorComponentonWall(leftWallData.component, 'standard_door', newWallName, leftWallData.size, 'Garage', leftWallData.type, leftWallData.category);
                                    }
                                } else {
                                    state.params.p_a_g_r_u_d = "Select";
                                    var splitname = leftWallData.size.split("x");
                                    if (mainPosArray[mainPos - 1] == undefined) {
                                        newData = (params.p_d / 2) - ((splitname[0] / 12) / 2 + 1);
                                    } else {
                                        newData = Number(mainPosArray[mainPos - 1]) - Number(parseInt((splitname[0] / 12)) + parseInt((splitname[0] / 12)) + 2);
                                    }
                                    state.params.DoorPosOnEdit = { 'x': h, 'y': 0, 'z': newData };
                                    mainPosArray[mainPos] = newData;

                                    state.params.UpdatedDoorPosOnEdit = "";
                                    state.params.DoorLocOnEdit = leftWallData.wall;
                                    state.params.DoorRotOnEdit = Math.PI / 2 * 1;
                                    params.doorType = "Walk";
                                    params.p_d_c = splitname[0] + 'X' + splitname[1];
                                    if (leftWallData.component == undefined) {
                                        if(const_var.newComponentArray['Walk']['standard_walkin']!=undefined)
                                        {
                                            AddDoorComponentonWall(leftWallData.type, 'standard_walkin', const_var.entry_wall_location_reverse[leftWallData.wall], leftWallData.size, 'Walk', 'standard_walkin', 'Man Door');
                                        }
                                    } else {
                                        AddDoorComponentonWall(leftWallData.component=="walk_in_door"?'walkin':leftWallData.component, leftWallData.type, const_var.entry_wall_location_reverse[leftWallData.wall], leftWallData.size, 'Walk', leftWallData.type, leftWallData.category);

                                    }
                                } 
                                mainPos++;
                                
                            }
                        }
                        
                    }
                    
                    if (const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0) {
                        let leftWallComponent = const_var.defaultBuildingArr[state.defaultBuilding].default_doors.filter(data => data.wall == "front" || data.wall == 'c_b_f_w'  || data.wall == 'ufend');
                        if (leftWallComponent.length > 0) {
                            let mainPos = 0;
                            let mainPosArray = [];
                            for (let leftWallData of leftWallComponent) {

                                let h = (params.p_w / 2 + 0) * 1 + 1 * 1;
                                let newData = "";
                                let checkType = leftWallData.component == undefined ? leftWallData.type : leftWallData.component;
                                if (checkType == "garage_door") {
                                    var splitname = leftWallData.size.split("x");

                                    if (mainPosArray[mainPos - 1] == undefined) {
                                        newData = (params.p_w / -2) + (splitname[0] / 2 + 1);
                                        // console.log(newData,"params.DoorPosOnEdit111");
                                    } else {
                                        newData = Number(mainPosArray[mainPos - 1]) + Number(parseInt(splitname[0]) + 2);
                                        // console.log(newData,"params.DoorPosOnEdit2222",splitname,splitname[0],typeof splitname[0],Number(mainPosArray[mainPos-1]) - Number(splitname[0]+1));
                                    }
                                    if(leftWallComponent.length==1)
                                    {
                                        newData = 0;
                                    }
                                    let componentdimension = leftWallData.size.split("x");
                                    const doorWidth = (checkType == "garage_door") ? parseInt(componentdimension[0]) : parseInt(componentdimension[0]) / 12,
                                        doorHeight = (checkType == "garage_door") ? parseInt(componentdimension[1]) : parseInt(componentdimension[1]) / 12;

                                    if (params.p_u_c != true) {

                                        state.params.DoorPosOnEdit = { 'x': newData, 'y': doorHeight / 2, 'z': params.p_d / 2 - 0.09 };
                                    } else {
                                        state.params.DoorPosOnEdit = { 'x': newData, 'y': doorHeight / 2, 'z': -params.p_d / 2 + Number(params.p_u_t) - 0.09 };
                                    }
                                    mainPosArray[mainPos] = newData;
                                    // console.log(state.params.DoorPosOnEdit,"newData")
                                    state.params.UpdatedDoorPosOnEdit = "";
                                    state.params.DoorLocOnEdit = leftWallData.wall;
                                    state.params.DoorRotOnEdit = 0;
                                    state.params.doorType = "Garage";
                                    if (leftWallData.component == undefined) {
                                        AddDoorComponentonWall(leftWallData.type, 'standard_door', (params.p_u_c == true) ? const_var.entry_wall_location_reverse['ufend'] : const_var.entry_wall_location_reverse[leftWallData.wall], leftWallData.size, 'Garage', 'standard_door', 'Roll-Up', '', params.DoorPosOnEdit);
                                    } else {
                                
                                        AddDoorComponentonWall(leftWallData.component, leftWallData.type, (params.p_u_c == true) ? const_var.entry_wall_location_reverse['ufend'] : const_var.entry_wall_location_reverse[leftWallData.wall], leftWallData.size, 'Garage', leftWallData.type, leftWallData.category, '', params.DoorPosOnEdit);

                                    }
                                    // console.log(state.params.DoorPosOnEdit,"newData")
                                } else {
                                    state.params.p_a_g_r_u_d = "Select";
                                    var splitname = leftWallData.size.split("x");
                                    if (mainPosArray[mainPos - 1] == undefined) {
                                        newData = (params.p_d / -2) + ((splitname[0] / 12) / 2 + 1);
                                    } else {
                                        newData = Number(mainPosArray[mainPos - 1]) + Number(parseInt((splitname[0] / 12)) + parseInt((splitname[0] / 12)) + 2);
                                    }
                                    state.params.DoorPosOnEdit = { 'x': newData, 'y': 0, 'z': params.p_d / 2 };
                                    mainPosArray[mainPos] = newData;

                                    state.params.UpdatedDoorPosOnEdit = "";
                                    state.params.DoorLocOnEdit = leftWallData.wall;
                                    state.params.DoorRotOnEdit = 0;
                                    params.doorType = "Walk";
                                    params.p_d_c = splitname[0] + 'X' + splitname[1];
                                    if (leftWallData.component == undefined) {
                                        AddDoorComponentonWall(leftWallData.type, 'standard_walkin', const_var.entry_wall_location_reverse[leftWallData.wall], leftWallData.size, 'Walk', 'standard_walkin', 'Man Door', params.DoorPosOnEdit);
                                    } else {
                                        AddDoorComponentonWall(leftWallData.component, leftWallData.type, const_var.entry_wall_location_reverse[leftWallData.wall], leftWallData.size, 'Walk', leftWallData.type, leftWallData.category, params.DoorPosOnEdit);
                                    }
                               } 
                                mainPos++;
                                
                            }
                        }
                        
                    }
            if (const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0) {
                let leftWallComponent = const_var.defaultBuildingArr[state.defaultBuilding].default_doors.filter(data => data.wall == "back" || data.wall == 'c_b_b_w');
                if (leftWallComponent.length > 0) {
                    let mainPos = 0;
                    let mainPosArray = [];
                    for (let leftWallData of leftWallComponent) {
                        params.p_w_cc = "Select";
                        params.p_d_c = "Select";
                        params.p_a_g_r_u_d = "Select";
                        let h = (params.p_w / 2 + 0) * 1 + 1 * 1;
                        let newData = "";
                        let checkType = leftWallData.component == undefined ? leftWallData.type : leftWallData.component;
                        if (checkType == "garage_door") {
                            var splitname = leftWallData.size.split("x");

                            if (mainPosArray[mainPos - 1] == undefined) {
                                // console.log(newData,"params.DoorPosOnEdit111")
                                newData = (params.p_w / -2) + (splitname[0] / 2 + 1);
                            } else {
                                // console.log(newData,"params.DoorPosOnEdit2222",splitname,splitname[0],typeof splitname[0],Number(mainPosArray[mainPos-1]) - Number(splitname[0]+1))
                                newData = Number(mainPosArray[mainPos - 1]) + Number(parseInt(splitname[0]) + 2);
                            }
                            state.params.DoorPosOnEdit = { 'x': newData, 'y': 0, 'z': params.p_d / 2 };
                            mainPosArray[mainPos] = newData;

                            state.params.UpdatedDoorPosOnEdit = "";
                            state.params.DoorLocOnEdit = leftWallData.wall;
                            state.params.DoorRotOnEdit = .5 * Math.PI * (1 + 1);
                            state.params.doorType = "Garage";
                            state.params.p_a_g_r_u_d = splitname[0] + 'X' + splitname[1];
                        } else {
                            state.params.p_a_g_r_u_d = "Select";
                            var splitname = leftWallData.size.split("x");
                            if (mainPosArray[mainPos - 1] == undefined) {
                                newData = (params.p_d / -2) + ((splitname[0] / 12) / 2 + 1);
                            } else {
                                newData = Number(mainPosArray[mainPos - 1]) + Number(parseInt((splitname[0] / 12)) + parseInt((splitname[0] / 12)) + 2);
                            }
                            state.params.DoorPosOnEdit = { 'x': newData, 'y': 0, 'z': params.p_d / 2 };
                            mainPosArray[mainPos] = newData;

                            state.params.UpdatedDoorPosOnEdit = "";
                            state.params.DoorLocOnEdit = leftWallData.wall;
                            state.params.DoorRotOnEdit = .5 * Math.PI * (1 + 1);
                            params.doorType = "Walk";
                            params.p_d_c = splitname[0] + 'X' + splitname[1];
                        }
                        mainPos++;

                    }
                }

            }
            if (const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0) {
                let frontStorageWallComponent = const_var.defaultBuildingArr[state.defaultBuilding].default_doors.filter(data => data.wall == "fubend");
                if (frontStorageWallComponent.length > 0) {
                    for (let component of frontStorageWallComponent) {
                        let checkType = component.component == undefined ? component.type : component.component;
                        if (checkType == "garage_door") {
                            state.params.doorType = "Garage";
                            if (component.component == undefined) {
                                AddDoorComponentonWall(component.type, 'standard_door', const_var.entry_wall_location_reverse['fubend'], component.size, 'Garage', 'standard_door', 'Roll-Up', '',);
                            } else {
                                AddDoorComponentonWall(component.component, component.type,const_var.entry_wall_location_reverse['fubend'], component.size, 'Garage', component.type, component.category, '',);
                            }
                        } 
                        
                    }
                }
                
                if (params.isBreezeway || params.cB_addStorage_check_front ) {
                    const width = (params.fourth_center_cost) ? 8 : 10;
                    const breezeWayFrameSize = width+"x"+params.p_h;
                    // console.log(distanceOnLength,const_var.DistanceArr[params.p_b_t][params.p_r_s],breezeWayFrameSize ,"breezeWayFrameSize");
                    AddDoorComponentonWall("garage_door_frameout", "standard_door",'c_b_l_w', breezeWayFrameSize, "Garage_Frameout", "standard_door", "Roll-Up",'','',undefined,undefined,'isBreezewayFrame');
                    AddDoorComponentonWall("garage_door_frameout", "standard_door",'c_b_r_w', breezeWayFrameSize, "Garage_Frameout", "standard_door", "Roll-Up",'','',undefined,undefined,'isBreezewayFrame');
                } 
            }

                
            
            }
            if (state.params.p_f_w === "Close" && state.params.p_r_w === "Close" && state.params.p_l_w === "Close" && state.params.p_b_w === "Close") {
                const_var.setSidesEndsWallOption ="close";
            }else if(state.params.p_f_w === "Open" && state.params.p_r_w === "Open" && state.params.p_l_w === "Open" && state.params.p_b_w === "Open" && state.params.p_c_p_l == false && state.params.p_c_p_r == false) {
                const_var.setSidesEndsWallOption = "open"
            }
             else {
                const_var.setSidesEndsWallOption = "partial";
            }
           
            cuBuilding.cP();
            

        }else{
            // console.log(const_var.showProcessLoaderchkEdit,"const_var.showProcessLoaderchkEdit")
            if ((const_var.entry_points == undefined || const_var.entry_points.length == 0) && document.querySelector('body').classList.contains("active-modal-loader")){
                document.querySelector('body').classList.remove('active-modal-loader');
            }
            const_var.isCheckDisabled = false;
        }
        //cuBuilding.uUdD();
        //var priceCalOutput = priceCalculation.cP(state.const_var.a_p_d_a);
        const_var.defalutProductLoad = false;
        
        const_var.is_loader = false;
      
        if(params.building_type_name != "" && params.building_type_name === "Custom Buildings" ){
            const_var.checkmoreCustomizeFlag = true
        }else{
            const_var.checkmoreCustomizeFlag = false
        }

            if (const_var?.defaultBuildingArr[state.defaultBuilding]?.default_doors?.length == 0 || const_var?.defaultBuildingArr[state.defaultBuilding]?.default_doors?.length==undefined  )  {
                        document.querySelector('body').classList.remove('active-modal-loader');
            }


     
      
    }

}
const changeBuildingAccordingToInspirationGalary = () =>{

}
const buildingTypeChange = (state, val) => {

    // state.params.p_b_t = val;
    // state.params.p_r_c= const_var.stateColorAcordingAPI[params.p_s_n].roof_color.hex_value.replace("#","0x");//(flag==true)?responseData.data.form_data.roof_color.hex_value.replace("#","0x"):response.color[0].hex_value.replace("#","0x");
    // state.params.p_r_c_name = const_var.stateColorAcordingAPI[params.p_s_n].roof_color.name;//(flag==true)?responseData.data.form_data.roof_color.name:response.color[0].name;
    // state.params.p_w_c= const_var.stateColorAcordingAPI[params.p_s_n].wall_color.hex_value.replace("#","0x");//(flag==true)?responseData.data.form_data.wall_color.hex_value.replace("#","0x"):response.color[0].hex_value.replace("#","0x");
    // state.params.p_w_c_name = const_var.stateColorAcordingAPI[params.p_s_n].wall_color.name;//(flag==true)?responseData.data.form_data.wall_color.name:response.color[0].name;
    // state.params.p_t_c= const_var.stateColorAcordingAPI[params.p_s_n].trim_color.hex_value.replace("#","0x");//(flag==true)?responseData.data.form_data.trim_color.hex_value.replace("#","0x"):response.color[0].hex_value.replace("#","0x");
    // state.params.p_t_c_name = const_var.stateColorAcordingAPI[params.p_s_n].trim_color.name;//(flag==true)?responseData.data.form_data.trim_color.name:response.color[0].name;
    // state.params.p_w_c_c= const_var.stateColorAcordingAPI[params.p_s_n].trim_color.hex_value.replace("#","0x");//(flag==true && responseData.data.form_data.wainscot)?responseData.data.form_data.wainscot.hex_value.replace("#","0x"):response.color[0].hex_value.replace("#","0x");
    // state.params.p_w_c_c_name = const_var.stateColorAcordingAPI[params.p_s_n].trim_color.name;
    //console.log(const_var.stateColorAcordingAPI[params.p_s_n],const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['RoofColor']],const_var.defaultBuildingColorArray['RoofColor'],"const_var.defaultBuildingColorArray");
        // console.log(const_var.defaultBuildingArr,"const_var.defaultBuildingArr",state.defaultBuilding,const_var.stateColorAcordingAPI,params.m_s_n,params.p_s_n)
        
        const_var.isFreeStandingBuilding = false
        if((const_var.isInspirtionGalleryEditFlow && state.defaultBuilding==undefined && const_var.defaultBuildingArr.length>0) || (const_var.isInspirtionGalleryEditFlow == undefined && state.defaultBuilding==undefined && const_var.defaultBuildingArr.length>0 && const_var.isShowSaveQuote == false))
        {
            state.defaultBuilding = const_var.defaultBuildingArr.length-1;
        }
        
        
        const_var.defaultBuildingColorArray['RoofColor'] = (const_var.stateColorAcordingAPI[params.p_s_n].roof_color != undefined && const_var.stateColorAcordingAPI[params.p_s_n].roof_color != '') && !const_var.defaultBuildingArr[state.defaultBuilding].roof_color ? const_var.stateColorAcordingAPI[params.p_s_n].roof_color.id : const_var.defaultBuildingArr[state.defaultBuilding].roof_color;
        const_var.defaultBuildingColorArray['WallColor'] = (const_var.stateColorAcordingAPI[params.p_s_n].wall_color != undefined && const_var.stateColorAcordingAPI[params.p_s_n].wall_color != '') && !const_var.defaultBuildingArr[state.defaultBuilding].wall_color ? const_var.stateColorAcordingAPI[params.p_s_n].wall_color.id : const_var.defaultBuildingArr[state.defaultBuilding].wall_color;
        const_var.defaultBuildingColorArray['TrimColor'] = (const_var.stateColorAcordingAPI[params.p_s_n].trim_color != undefined && const_var.stateColorAcordingAPI[params.p_s_n].trim_color != '') && !const_var.defaultBuildingArr[state.defaultBuilding].trim_color ? const_var.stateColorAcordingAPI[params.p_s_n].trim_color.id : const_var.defaultBuildingArr[state.defaultBuilding].trim_color;
        const_var.defaultBuildingColorArray['RoofColor'] = (const_var.defaultBuildingColorArray['RoofColor'] == undefined) ? '' : const_var.defaultBuildingColorArray['RoofColor'];


    const_var.defaultBuildingColorArray['WallColor'] = (const_var.defaultBuildingColorArray['WallColor'] == undefined) ? '' : const_var.defaultBuildingColorArray['WallColor'];
    const_var.defaultBuildingColorArray['TrimColor'] = (const_var.defaultBuildingColorArray['TrimColor'] == undefined) ? '' : const_var.defaultBuildingColorArray['TrimColor'];
    state.params.p_r_c = (const_var.defaultBuildingColorArray['RoofColor'] != '' && const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['RoofColor']] !== undefined && Object.keys(const_var.defaultBuildingColorArray['mainColorObject']).length>0) ? const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['RoofColor']].hex_value.replace("#", "0x") : const_var.color[0].hex_value.replace("#", "0x");
    state.params.p_r_c_name = (const_var.defaultBuildingColorArray['RoofColor'] != '' && const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['RoofColor']] !== undefined && Object.keys(const_var.defaultBuildingColorArray['mainColorObject']).length>0) ? const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['RoofColor']].name : const_var.color[0].name;
    state.params.p_r_c_id = (const_var.defaultBuildingColorArray['RoofColor'] != '' && const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['RoofColor']] !== undefined && Object.keys(const_var.defaultBuildingColorArray['mainColorObject']).length>0) ? const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['RoofColor']].id : const_var.color[0].id;

    
    state.params.p_w_c = (const_var.defaultBuildingColorArray['WallColor'] != '' && const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['WallColor']] !== undefined && Object.keys(const_var.defaultBuildingColorArray['mainColorObject']).length>0) ? const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['WallColor']].hex_value.replace("#", "0x") : const_var.color[0].hex_value.replace("#", "0x");
    state.params.p_w_c_name = (const_var.defaultBuildingColorArray['WallColor'] != '' && const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['WallColor']] !== undefined && Object.keys(const_var.defaultBuildingColorArray['mainColorObject']).length>0) ? const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['WallColor']].name : const_var.color[0].name;
    state.params.p_w_c_id = (const_var.defaultBuildingColorArray['WallColor'] != '' && const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['WallColor']] !== undefined && Object.keys(const_var.defaultBuildingColorArray['mainColorObject']).length>0) ? const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['WallColor']].id : const_var.color[0].id;

    state.params.p_t_c = (const_var.defaultBuildingColorArray['TrimColor'] != '' && const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['TrimColor']] !== undefined && Object.keys(const_var.defaultBuildingColorArray['mainColorObject']).length>0) ? const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['TrimColor']].hex_value.replace("#", "0x") : const_var.color[0].hex_value.replace("#", "0x");
    state.params.p_t_c_name = (const_var.defaultBuildingColorArray['TrimColor'] != '' && const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['TrimColor']] !== undefined && Object.keys(const_var.defaultBuildingColorArray['mainColorObject']).length>0) ? const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['TrimColor']].name : const_var.color[0].name;

    state.params.p_t_c_id = (const_var.defaultBuildingColorArray['TrimColor'] != '' && const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['TrimColor']] !== undefined && Object.keys(const_var.defaultBuildingColorArray['mainColorObject']).length>0) ? const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['TrimColor']].id : const_var.color[0].id;
    state.params.p_w_c_c = params.p_t_c;
    state.params.p_w_c_c_name = params.p_t_c_name;
    state.params.p_w_c_c_id = params.p_t_c_id;
    
    if(const_var.defaultBuildingColorArray['WainscotColor'] != undefined && const_var.defaultBuildingColorArray['WainscotColor'] != 0)
    {
        state.params.p_w_c_c = (const_var.defaultBuildingColorArray['WainscotColor'] != '' && Object.keys(const_var.defaultBuildingColorArray['mainColorObject']).length>0) ? const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['WainscotColor']].hex_value.replace("#", "0x") : const_var.color[0].hex_value.replace("#", "0x");
        state.params.p_w_c_c_name = (const_var.defaultBuildingColorArray['WainscotColor'] != '' && Object.keys(const_var.defaultBuildingColorArray['mainColorObject']).length>0) ? const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['WainscotColor']].name : const_var.color[0].name;

        state.params.p_w_c_c_id = (const_var.defaultBuildingColorArray['WainscotColor'] != '' && Object.keys(const_var.defaultBuildingColorArray['mainColorObject']).length>0) ? const_var.defaultBuildingColorArray['mainColorObject'][const_var.defaultBuildingColorArray['WainscotColor']].id : const_var.color[0].id;
    }

    const_var.surcharge_amount_is_edit = false;
    //let garageDoorColor = params.g_d_c_Obj.filter(data=>data.name=='White'); 
    let colorData = '';
     if(const_var.garageDoorColor!=undefined)
     {
        let colorData = const_var.garageDoorColor.filter(data=>data.name=="White");
        if(colorData.length==0)
        {
            colorData = const_var.SendAPIBuildingData.garageDoorColor[0];
        }else
        {
            colorData = colorData[0];
        }
        params.g_d_c_name = colorData.name;
        params.g_d_c_id = colorData.id;
        params.g_d_c = colorData.hex_value.replace('#', '0x');
        
     }
    

    if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
        //cuBuilding.rP();
        params.singleSlope = true;
        params.p_w_c_n = false;
    }
    if (params.p_w > 32 && const_var.b_o_J_1[params.p_b_t] != "Custom Buildings") {
        params.p_v_w = (params.m_s_n!="75")?true:false;
    } else {
        params.p_v_w = false;
    }
    if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
        params.p_r_p = "2";
        params.b_r_p = "212";
    }
    if (state.params.building_type_name.includes("Breezeway") || state.const_var.defaultBuildingImgName == "Breezeway_Building") {
        //params.isBreezeway = true;
        // console.log(params.isBreezeway ,"params.isBreezeway");
    }
    params.cupola = false;
    params.cupolasize = '';
    const_var.cupolaObj = {};
    const_var.callMesure = false;
    const_var.checkforLeanto = false;
    state.const_var.roof_style = state.c_m_a[state.params.p_b_t].roof_style;
    state.params.frame_length = (state.const_var.roofObject[params.p_b_t][params.p_r_s].roof_length != undefined) ? state.const_var.roofObject[params.p_b_t][params.p_r_s].roof_length : 0;

    const_var.textureImageForRoofSecond = '';
    const_var.textureImageForRoof = '';
    const_var.textureImageForRoofL = '';
    const_var.textureImageForRoofR = '';

    let fLength = params.p_d;
    let fWidth = params.p_w;                        
    params.add_front_lean && (fLength += params.leanF_p_w);
    params.add_back_lean && (fLength += params.leanB_p_w);
    params.add_left_lean && (fWidth += params.lean_p_w);
    params.add_right_lean && (fWidth += params.leanR_p_w);
    let diag = new THREE.Vector3(fLength, fWidth, params.p_h).length();
    // const_var.controls.maxDistance =  (diag  >= 100) ? 500: (diag * 6);
    
    utils.makeTranslucent(controls.isCheckActiveTab,params.activeWall,params.is_translusant,const_var.scene);
    reSelExtEle(state);
    cuComponent.removeAlltheComponent(true);
    cuComponent.removeAllCupolas();
    makeDimensionArray(state);
    cuBuilding.uUdDCB();
    cuBuilding.uUdD();
    cuBuilding.leanuUdD();
    //cuBuilding.CheckLegsByResponse(state);
    const_var.CheckDoorForEdit = false;
    cuBuilding.BuildingUpdate(true, '');
    cuBuilding.UpdateFrontLean();
    cuBuilding.UpdateLeftLean();
     cuBuilding.UpdateRightLean();
    cuBuilding.UpdateBackLean();
    // commenting below code as Rahul Ji said for the issue of /api/save-oq-image
    // console.log("----reset 2d layout images----");
    window.twoDMapReqPng = undefined;
    window.twoDMapReqSvg = undefined;
    window.twoDMapAutoPng = undefined;
    window.twoDMapAutoSvg = undefined;
    const_var.twoDImageObj = []; 
    const_var.ShowTwodLayoutDefault = false;
    if(const_var.hasDoublelegshow === true || (const_var.a_p_d_a.side != undefined && Object.keys(const_var.a_p_d_a.side).length > 0 && const_var.a_p_d_a.side[0].lift_type != undefined && const_var.a_p_d_a.side[0].lift_type != '')|| ((const_var.a_p_d_a.addons_width) && const_var.a_p_d_a.addons_width.length > 0 && const_var.a_p_d_a.addons_width[0].end_cross_bracing != undefined && const_var.a_p_d_a.addons_width[0].end_cross_bracing != 0) || ((const_var.a_p_d_a.side_cross_bracing != undefined) && const_var.a_p_d_a.side_cross_bracing.length > 0 && const_var.a_p_d_a.side_cross_bracing[0].is_default != 'no')){
        const_var.commonBuildingFlag.center.buildingHeight = true
    }
    if(state.params.add_left_lean == true && state.params.add_right_lean == true){
        const_var.navEventKey.leanto = "leftLean";
    }else if(state.params.add_right_lean == true){
        const_var.navEventKey.leanto = "rightLean";
    }else{
        const_var.navEventKey.leanto = "leftLean";
    }
}

const buildingStyleChange = (state, val) => {
    const_var.commonBuildingFlag.center.buildingHeightChk = false
    params.isBuildingStyleChange = true;
    const_var.dealer_discount_label = "" ;
    const_var.manufacturer_discount_label = "" ;
    state.params.ShowLeanRecord = false
    //const_var.LeadCustomerData = {};
    if (const_var.crmSetting.is_Action_url != "order/save") {
        const_var.order_extra_items = {
            job_site_level: "",
            inside_city: "",
            installation_ready: "",
            surface_level: "",
            electricity: "",
            welded_spacer:'no',
            notched_lip:'no',
            space_around_building:'no',
            site_clear_obstacle:'no',
            order_permit_fee: const_var.order_extra_items['order_permit_fee'],
            permit: "yes",
            includeIn: "",
            equipment_rental: 0,
            document_fee: const_var.order_extra_items['document_fee'],
            order_processing_fee: const_var.order_extra_items['order_processing_fee'],
            surchargeFees: const_var.order_extra_items['surchargeFees'],
            delivery_fee: 0,
            engineer_drawings: 0,
            freight: 0,
            extra_labour:  const_var.order_extra_items['extra_labour'],
            processing_fee: 0,
            concrete_work: 0,
            ground_work: 0,
            grvy_value: 0,
            has_grvy: 0,
            pdf_price_breakdown: '0',
            dont_show_processing_fee_pdf: 1,
            engineer_drawings_name: '' ,
        }
    }
    
    if (const_var.card_processing_fee != undefined && Object.keys(const_var.card_processing_fee).length > 0) {
        const_var.order_extra_items.dont_show_processing_fee_pdf = (const_var.card_processing_fee.add_in == "invoice") ? 2 : 1;
    }
    const_var.BuildingPriceArrar['surcharge_amount'] = 0;
    if (const_var.stateManufacturerAcordingAPIDiscount['surcharge']!==undefined && const_var.stateManufacturerAcordingAPIDiscount['surcharge'][params.m_s_n] != undefined) {
        const_var.stateManufacturerAcordingAPIDiscount['surcharge'][params.m_s_n].is_edit = undefined;
    }
    const_var.surcharge_amount_is_edit = false;
    const_var.order_extra_items['surchargeFees'] = 0;
    cuComponent.removeAlltheComponent(true);
    params.trimkit = params.chain_hoist = params.header_seal = params.certified_door = params.automatic_openers = params.insulated = params.motor = false;
    Object.keys(params).map((e) => {
        if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price"))  {
            let prop = e.replace("entry_", "");
            params[prop] = false;
        }
    })
    params.extra_notes = "";
    params.activeWall = 'c_b_f_w';
    state.doorWindowIconsPos = [];
    state.cupolaEditIconsPos = [];
    params.p_e_i = "";
    params.p_e_l = params.lean_p_e_l = params.leanR_p_e_l = params.leanF_p_e_l = params.leanB_p_e_l = false;
    const_var.hasDoublelegName = "";
    params.o_v_h_n_g = false;
    params.o_v_h_n_g_e = false;
    params.fourth_center_cost = false;
    params.isDefaultfourFeet = false;
    const_var.callMesure = false;
    const_var.inputs = [];
    const_var.Componentinputs = [];
    const_var.ExtraItemsFeaturesArray = [];
    const_var.ExtraItemsFeaturesQuantityArray = [];
    const_var.cupolaObj = {};
    cuComponent.removeAllCupolas();
    const_var.tax = { "percentage": 0, "type": "%", "name": '', "amount": 0 };
    params.tax_zipcode = '';
    const_var.MoreTaxinputs = [];
    state.const_var.UpdatedPriceData = { 'roof_style_price_changed': true,'lifttype_price_changed':true,'cupola_price_changed':true, 'width_price_changed': true, 'length_price_changed': true, 'height_price_changed': true, 'left_wall_price_changed': true, 'right_wall_price_changed': true, "right_wall_cut_panel_price_changed": true, "left_wall_cut_panel_price_changed": true, 'front_wall_price_changed': true, 'back_wall_price_changed': true, "certificate_price_changed": true, "common_width_changed": true, "common_length_changed": true, "common_height_changed": true, "utility_price_changed": true, "front_utility_price_changed": true, "wainscot_price_changed": true, "connection_fee_end_changed": true, "connection_fee_side_changed": true, "roof_pitch_price_changed": true,'lifttype_price_changed':true, 'left_lean_roof_style_price_changed': true, 'left_lean_width_price_changed': true, 'left_lean_length_price_changed': true, 'left_lean_height_price_changed': true, 'left_lean_left_wall_price_changed': true, 'left_lean_front_wall_price_changed': true, 'left_lean_back_wall_price_changed': true, "left_lean_certificate_price_changed": true, "left_lean_utility_price_changed": true, "left_lean_roof_pitch_price_changed": true, 'right_lean_roof_style_price_changed': true, 'right_lean_width_price_changed': true, 'right_lean_length_price_changed': true, 'right_lean_height_price_changed': true, 'right_lean_right_wall_price_changed': true, 'right_lean_front_wall_price_changed': true, 'right_lean_back_wall_price_changed': true, "right_lean_certificate_price_changed": true, "right_lean_utility_price_changed": true, "right_lean_roof_pitch_price_changed": true, 'front_lean_roof_style_price_changed': true, 'front_lean_width_price_changed': true, 'front_lean_length_price_changed': true, 'front_lean_height_price_changed': true, 'front_lean_left_wall_price_changed': true, 'front_lean_front_wall_price_changed': true, 'front_lean_back_wall_price_changed': true, "front_lean_certificate_price_changed": true, "front_lean_utility_price_changed": true, "front_lean_roof_pitch_price_changed": true, 'back_lean_roof_style_price_changed': true, 'back_lean_width_price_changed': true, 'back_lean_length_price_changed': true, 'back_lean_height_price_changed': true, 'back_lean_left_wall_price_changed': true, 'back_lean_front_wall_price_changed': true, 'back_lean_back_wall_price_changed': true, "back_lean_certificate_price_changed": true, "back_lean_utility_price_changed": true, "back_lean_roof_pitch_price_changed": true,"color_price_changed":true,"down_payment_type": "per", "down_payment_discount_type": "per", "discount_type": "per","left_front_wrap_connection_fee_changed":true,"right_front_wrap_connection_fee_changed":true,"right_back_wrap_connection_fee_changed":true,"left_back_wrap_connection_fee_changed":true,"front_lean_insulation_price_changed":true,"left_lean_insulation_price_changed":true, "right_lean_insulation_price_changed":true,"back_lean_insulation_price_changed":true, "wall_color_price_changed" :true , "roof_color_price_changed" :true , "trim_color_price_changed" :true , "wainscot_price_changed" :true, "truss_price_changed": true};
    if(const_var.isInspirtionGalleryEditFlow && val==undefined && const_var.defaultBuildingArr.length>0)
    {
        val = const_var.defaultBuildingArr.length-1;
    }
    state.defaultBuilding = val;
    state.checkedBuildingType = (state.checkedBuildingType == undefined) ? params.p_b_t : state.checkedBuildingType;

    if (state.const_var.defaultBuildingArr[state.defaultBuilding] != undefined && (state.const_var.defaultBuildingArr[state.defaultBuilding].other_building_id.split(",")).length == 1) {
        state.OlddefaultBuilding = val;
    } if (state.const_var.defaultBuildingArr[state.defaultBuilding] != undefined && (state.const_var.defaultBuildingArr[state.defaultBuilding].other_building_id.split(",")).length > 1) {
        state.OlddefaultBuilding = val;
    }

    if(state.const_var.defaultBuildingArr[state.defaultBuilding] != undefined && state.const_var.defaultBuildingArr[state.defaultBuilding].oldBuildingID != undefined){
        state.OlddefaultBuilding = state.const_var.defaultBuildingArr[state.defaultBuilding].oldBuildingID
    }
    const_var.BuldingIDforReset = state.defaultBuilding;
    if(state.const_var.defaultBuildingArr[state.defaultBuilding] != undefined && state.const_var.defaultBuildingArr[state.defaultBuilding].oldBuildingID != undefined){
        state.OlddefaultBuilding = state.const_var.defaultBuildingArr[state.defaultBuilding].oldBuildingID;
        const_var.BuldingIDforReset = state.const_var.defaultBuildingArr[state.defaultBuilding].oldBuildingID;
    }
    // console.log(state.OlddefaultBuilding,state.defaultBuilding,"state.OlddefaultBuilding")
    const_var.BuildingLRoofPitch = {};
    const_var.UpdatedPriceData.utility_price_changed = true; 
    const_var.UpdatedPriceData.front_utility_price_changed = true; 
    state.params.gauge_val_check = false;
    state.params.gauge_val = 14;
    state.params.p_c_p_l = state.params.p_c_p_r = state.params.p_c_p_f = false;
    state.a_c_p_l = state.a_c_p_r = state.a_c_p_f = false;
    state.const_var.b_r_p_a = [];
    state.const_var.b_r_p_l_to_a = [];
    state.const_var.BuildingRoofPitch = [];
    state.params.p_a_g_r_u_d = "Select";
    state.params.f_r_m_o_t = "Select";
    state.params.f_r_m_o_t1 = "Select";
    state.params.p_w_cc = "Select";
    state.params.p_d_c = "Select";
    const_var.leanto = [];
    const_var.ExtraItemsFeaturesArray = [];
    const_var.additionalFeaturesArray = [];
    const_var.additionalFeaturesArrayWithPosition = [];
    const_var.ExtraItemsFeaturesQuantityArray = [];
    params.b_r_p = "312";
    params.p_r_p = 3;
    params.b_l_t_r_p = params.b_l_t_r_pR = "2";
    params.p_i_s = "1";
    state.isFullyOpenedCheckedForLeftLeanTo = false;
    state.isFullyOpenedCheckedForRightLeanTo = false;
    state.isFullyEnclosedChecked = false;
    state.isFullyEnclosedCheckedForLeftLeanTo = false;
    state.isFullyEnclosedCheckedForRightLeanTo = false;
    state.params.p_w_c_n = false;
    const_var.checkVerticalCheckBox = false;
    state.params.isShowCenter = false
    state.params.newtrussType = ""

    params.singleSlope = false;
    params.isBreezeway = false;
    params.p_i_o = "0";
    state.params.selectedInsulationId = 0;
    params.p_f_i = params.p_r_o = false;
    params.p_c_i = false;
    const_var.showDefaultInsullation = false;
    const_var.showInsulation = true;//(const_var.defaultBuildingArr[state.defaultBuilding].wall!=null && const_var.defaultBuildingArr[state.defaultBuilding].wall=="close")?true:false;
    //console.log(state.const_var.DistanceArr,"state.const_var.DistanceArr")


    params.insulation = {
        center: {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,custom:false  }, 
        frontLean: {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,custom:false  }, 
        leftLean: {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,custom:false  }, 
        rightLean: {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,custom:false  }, 
        backLean: {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,custom:false  }
    };

    const_var.insulationArrayForLeantoLeft = [];
    const_var.insulationArrayForLeantoRight = [];
    const_var.insulationArrayForLeantoFront = [];
    const_var.insulationArrayForLeantoBack = [];
    
    const_var.insulationJson = [];
    state.params.add_full_lean_porch = false
    state.params.add_left_front_lean_porch = false;
    state.params.add_left_back_lean_porch = false;
    state.params.add_right_front_lean_porch = false;
    state.params.add_right_back_lean_porch = false;

    state.params.add_left_lean = false;
    state.params.add_right_lean = false;
    state.params.add_front_lean = false;
    state.params.add_back_lean = false;

    state.params.lean_p_pos = 0;
    state.params.leanR_p_pos = 0;
    state.params.leanF_p_pos = 0;
    state.params.leanB_p_pos = 0;

    state.isFullyOpenedCheckedForFrontLeanTo = false;
    state.isFullyOpenedCheckedForBackLeanTo = false;
    state.isFullyOpenedCheckedForLeftLeanTo = false;
    state.isFullyOpenedCheckedForRightLeanTo = false;
    const_var.setSidesEndsWallOption = "open"
    params.add_wrap_around_porch = false;

    state.params.add_storage_check_front = false;
    state.params.p_c_a_f_l_w = false;
    state.params.p_b_c_b_f_l = "Open";
    state.params.p_b_c_b_f_b = "Open";
    state.params.p_b_c_b_f_f = "Open";
    state.params.b_f_l_t_f = "Open";
    state.params.b_f_l_t_l = "Open";
    state.params.b_f_l_t_r = "Open";

    state.params.add_storage_check_back = false;
    state.params.p_c_a_b_l_w = false;
    state.params.p_b_c_b_b_l = "Open";
    state.params.p_b_c_b_b_f = "Open";
    state.params.p_b_c_b_b_b = "Open";
    state.params.b_b_l_t_f = "Open";
    state.params.b_b_l_t_l = "Open";
    state.params.b_b_l_t_r = "Open";

    state.params.add_storage_check = false;
    state.params.p_c_a_l_l_w = false;
    state.params.p_b_c_b_l_f = "Open";
    state.params.p_b_c_b_l_b = "Open";
    state.params.p_b_c_b_l = "Open";
    state.params.b_l_l_t_l = "Open";
    state.params.b_l_l_t_b = "Open";
    state.params.b_l_l_t_f = "Open";

    state.params.add_storage_check_right = false;
    state.params.p_c_a_r_l_w = false;
    state.params.p_b_c_b_r_f = "Open";
    state.params.p_b_c_b_r_b = "Open";
    state.params.p_b_c_b_r = "Open";
    state.params.b_r_l_t_r = "Open";
    state.params.b_r_l_t_b = "Open";
    state.params.b_r_l_t_f = "Open";

    // state.params.cB_addStorage_check_front = false;
    state.params.cB_addStorage_check_left = false;
    state.params.cB_addStorage_check_right = false;
    state.params.cB_addStorage_check_right_utility = false;
    state.params.cB_addStorage_check_left_utility = false;
    state.params.add_storage_check_front = false;
    state.params.add_storage_check_back = false;
    state.params.add_storage_check_right = false;
    params.cB_addStorage_check_both_with_back = false;
    params.cB_addStorage_check_both = false;
    state.params.nostorage = true;

    state.isFullyOpenedCheckedForFrontLeanTo = true;
    state.isFullyOpenedCheckedForBackLeanTo = true;
    state.isFullyEnclosedCheckedForFrontLeanTo = false;
    state.isFullyEnclosedCheckedForBackLeanTo = false;
    params.cupola = false;
    params.cupolasize = '';
    params.is_translusant = false
    cuBuilding.loadDefaultBuilding(state, '');
    buildingTypeChange(state, params.p_b_t);

    
}

const roofStyleChange = (state, val, bool, groove, chkEdit) => {
    //console.log(val,"val",state.const_var.roof_style,state.const_var.arrayendLengthRoof);
    state.holdPreviousRoofStyle = state.params.p_r_s;
    state.holdCurrentRoofStyle = state.const_var.roof_style[val].roof_id;
    state.params.p_r_s = state.const_var.roof_style[val].roof_id;
    state.params.frame_length = (state.const_var.roof_style[val].roof_length != undefined) ? state.const_var.roof_style[val].roof_length : 0;
    if(state.params.p_r_s == "1"){
        state.params.o_v_h_n_g = false;
        state.params.o_v_h_n_g_e = false;
        state.const_var.isOverhang = {
            'end' : {
                isChecked: false,
                selected: '',
                size: 0.5
            },
            'side' : {
                isChecked: false,
                selected: '',
                size: 0.5
            },
            'both' : {
                isChecked: false,
                selected: '',
                size: 0.5
            }
        }
        if(state.const_var.ExtraItemsFeaturesArray && state.const_var.ExtraItemsFeaturesArray.length > 0){
            state.const_var.ExtraItemsFeaturesArray.map((item,idx)=>{
                if(item && item.name != undefined && item.name=='overhang'){
                    item['is_checked'] = false
                }
            })
        }
    }
    if (const_var.TypeEnum[state.params.p_r_s] == "Regular" && const_var.b_o_J_1[params.p_b_t] == "Custom Buildings" && params.p_w > 30) {
        params.p_w = 12;
    }
    if (params.p_v_w == true && const_var.TypeEnum[state.params.p_r_s] == "Regular" && params.m_s_n!="12") {
        state.params.p_v_w = false;
        state.params.wallTexture = "none"
    }
    if (state.const_var.arrayendLengthRoof != undefined && (state.params.p_d > (state.const_var.arrayendLengthRoof[params.p_r_s])) && ("Vertical" != state.const_var.TypeEnum[state.params.p_r_s])) {
        state.params.p_r_s = 3;
        for (var i = 0; i <= const_var.roof_style.length - 1; i++) {
            if (const_var.roof_style[i].roof_id == state.params.p_r_s) {
                state.params.p_r_s = state.const_var.roof_style[i].roof_id;
                state.params.frame_length = (state.const_var.roof_style[i].roof_length != undefined) ? state.const_var.roof_style[i].roof_length : 0;
            }
        }
        state.const_var.isShowAlert = true;
        state.const_var.alertUsedFor = "RoofStyleLength";
    }
    if (chkEdit != "edit") {
        const_var.UpdatedPriceData.roof_style_price_changed = true;
        const_var.UpdatedPriceData.front_wall_price_changed = true;
        const_var.UpdatedPriceData.back_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_price_changed = true;
        const_var.UpdatedPriceData.right_wall_price_changed = true;
        const_var.UpdatedPriceData.wainscot_price_changed = true;
        // const_var.UpdatedPriceData.color_price_changed = true;
        const_var.UpdatedPriceData.roof_color_price_changed = true;
        const_var.UpdatedPriceData.wall_color_price_changed = true;
        const_var.UpdatedPriceData.trim_color_price_changed = true;
        const_var.UpdatedPriceData.lifttype_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.truss_price_changed = true;

    }
    if(!const_var.isTBSOldQuotesForVerticalRoof && (params.m_s_n == 13 && params.p_r_s !== 3 && (params.add_front_lean || params.add_back_lean))){
        params.p_r_s = state.holdPreviousRoofStyle;
        state.const_var.isShowAlert = true;
        state.const_var.alertUsedFor = "nonVerticalRoofStyleForTubulerBuildingMnf";
    }
    const_var.checkLoadDefaultBuildingRespone = (bool == true) ? true : false;
    //const_var.defalutProductLoad = (bool==true)?true:false;
    const_var.textureImageForRoofSecond = '';
    const_var.textureImageForRoof = '';
    const_var.textureImageForRoofL = '';
    const_var.textureImageForRoofR = '';

    if (const_var.DistanceArr[params.p_b_t][params.p_r_s] == undefined) {
        const_var.DistanceArr[params.p_b_t][params.p_r_s] = (params.isDefaultfourFeet || params.fourth_center_cost) ? 4 : 5;
    }
    //console.log(state.const_var.DistanceArr[state.params.p_b_t][state.params.p_r_s],"state.const_var.DistanceArr[state.params.p_b_t][state.params.p_r_s]")
    makeDimensionArray(state);

    if ( state.params.p_r_s == 1) {
        const isSelecedHeight = const_var.buildingHeightArray.find(height => height.value == params.p_h)
        if (isSelecedHeight == undefined) {
            state.params.p_r_s = state.holdPreviousRoofStyle;
            state.const_var.isShowAlert = true;
            state.const_var.alertUsedFor = "regularRoofStyleHeight";
            makeDimensionArray(state);
        }
    }
        // ############### For heritage manufacture / msn = 153

        let heritageEditCase = const_var.crmSetting.is_Edit == true && params.m_s_n == 153 && (params.p_r_s  == 1 || params.p_r_s == 2) && const_var.editAPIDataByResponse != undefined && const_var.editAPIDataByResponse.data != undefined;

        let lowerHeightOfFreeStanding = (const_var.c_m_a[params.p_b_t]!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length>0 ) ? Math.floor(params.p_h-((params.p_w * params.p_r_p) / 12)) : Math.round(params.p_h-((params.p_w * params.p_r_p) / 12))

        if(params.singleSlope != true && (const_var.crmSetting.is_Edit != true && params.m_s_n == 153 && ((params.p_r_s == 2 || params.p_r_s == 1) && params.p_h > 10)) || (heritageEditCase == true && params.p_h > 10)) {

            if(const_var.insulationPriceJson?.insulation_wall != undefined && Object.keys(const_var.insulationPriceJson.insulation_wall).length > 0){
                const_var.insulationPriceJson.insulation_wall = {}
            }
           
            // params.p_i_o = 0;
            params.insulation.center.insulationId = 0;
    
            params.insulation.center.isCheked = false;
    
            params.insulation.center.showInsulationOptions =  false;
            params.insulation.center.roofOnly = params.insulation.center.insulationId !== 0 ? true : false;
            params.insulation.center.fullBuilding = params.insulation.center.roofOnly ? false :params.insulation.center.fullBuilding;
            params.insulation.center.custom = (params.insulation.center.roofOnly || params.insulation.center.fullBuilding) ? false :params.insulation.center.custom;
            // params.p_r_o = params.p_i_o !== 0 ? true : false;
            // params.p_f_i = params.p_r_o ? false : params.p_f_i;
            // const_var.UpdatedPriceData.insulation_price = undefined;
            const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
    
            // ########### Front lean ##############
    
            if(params.add_front_lean == true && params.insulation["frontLean"] != undefined && params.m_s_n == 153 && ((params.p_r_s == 1 || params.p_r_s == 2)) && params.leanF_p_h > 10) {
                params.insulation["frontLean"].isCheked = false;  
                params.insulation["frontLean"].insulationId = 0;
                
                params.insulation["frontLean"].showInsulationOptions = false;
                params.insulation["frontLean"].roofOnly = params.insulation["frontLean"].insulationId !== 0 ? true : false;
                params.insulation["frontLean"].fullBuilding = params.insulation["frontLean"].roofOnly ? false : params.insulation["frontLean"].fullBuilding;
                params.insulation["frontLean"].custom = (params.insulation["frontLean"].roofOnly || params.insulation["frontLean"].fullBuilding) ? false : params.insulation["frontLean"].custom;
            }
    
            // ########### Back lean ##############
            if(params.add_back_lean == true && params.insulation["backLean"] != undefined && params.m_s_n == 153 && ((params.p_r_s == 1 || params.p_r_s == 2)) && params.leanB_p_h > 10) {
                params.insulation["backLean"].isCheked = false;  
                params.insulation["backLean"].insulationId = 0;
                
                params.insulation["backLean"].showInsulationOptions = false;
                params.insulation["backLean"].roofOnly = params.insulation["backLean"].insulationId !== 0 ? true : false;
                params.insulation["backLean"].fullBuilding = params.insulation["backLean"].roofOnly ? false : params.insulation["backLean"].fullBuilding;
                params.insulation["backLean"].custom = (params.insulation["backLean"].roofOnly || params.insulation["backLean"].fullBuilding) ? false : params.insulation["backLean"].custom;
            }
    
            // ########### Right lean ##############
            if(params.add_right_lean == true && params.insulation["rightLean"] != undefined && params.m_s_n == 153 && ((params.p_r_s == 1 || params.p_r_s == 2)) && params.leanR_p_h > 10) {
                params.insulation["rightLean"].isCheked = false;  
                params.insulation["rightLean"].insulationId = 0;
                
                params.insulation["rightLean"].showInsulationOptions = false;
                params.insulation["rightLean"].roofOnly = params.insulation["rightLean"].insulationId !== 0 ? true : false;
                params.insulation["rightLean"].fullBuilding = params.insulation["rightLean"].roofOnly ? false : params.insulation["rightLean"].fullBuilding;
                params.insulation["rightLean"].custom = (params.insulation["rightLean"].roofOnly || params.insulation["rightLean"].fullBuilding) ? false : params.insulation["rightLean"].custom;
            }
    
            // ########### Left lean ##############
    
            if(params.add_left_lean == true && params.insulation["leftLean"] != undefined && params.m_s_n == 153 && ((params.p_r_s == 1 || params.p_r_s == 2)) && params.lean_p_h > 10) {
                params.insulation["leftLean"].isCheked = false;  
                params.insulation["leftLean"].insulationId = 0;
                
                params.insulation["leftLean"].showInsulationOptions = false;
                params.insulation["leftLean"].roofOnly = params.insulation["leftLean"].insulationId !== 0 ? true : false;
                params.insulation["leftLean"].fullBuilding = params.insulation["leftLean"].roofOnly ? false : params.insulation["leftLean"].fullBuilding;
                params.insulation["leftLean"].custom = (params.insulation["leftLean"].roofOnly || params.insulation["leftLean"].fullBuilding) ? false : params.insulation["leftLean"].custom;
            }
        }

        if(params.singleSlope == true && ((const_var.crmSetting.is_Edit != true && params.m_s_n == 153 && ((params.p_r_s == 2 || params.p_r_s == 1 ) && lowerHeightOfFreeStanding > 10)) || (heritageEditCase == true && lowerHeightOfFreeStanding > 10))) {
            // params.p_i_o = 0;
            params.insulation.center.insulationId = 0;

            params.insulation.center.isCheked = false;

            params.insulation.center.showInsulationOptions =  false;
            params.insulation.center.roofOnly = params.insulation.center.insulationId !== 0 ? true : false;
            params.insulation.center.fullBuilding = params.insulation.center.roofOnly ? false :params.insulation.center.fullBuilding;
            params.insulation.center.custom = (params.insulation.center.roofOnly || params.insulation.center.fullBuilding) ? false :params.insulation.center.custom;
            // params.p_r_o = params.p_i_o !== 0 ? true : false;
            // params.p_f_i = params.p_r_o ? false : params.p_f_i;
            // const_var.UpdatedPriceData.insulation_price = undefined;
            const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
            

        }
    
    dynamicWallOptions(state);
    dynamicWallOptionsForLeanTo(state);
    state.const_var.c_m_a = state.c_m_a;
    if(params.add_front_lean)
    {
        makeDimensionUpdateFront(state);
    }
    if(params.add_back_lean)
    {
        makeDimensionUpdateBack(state);
    }
    if(params.add_left_lean)
    {
        makeDimensionUpdateLeft(state);
    }
    if(params.add_right_lean)
    {
        makeDimensionUpdateRight(state);
    }

    if(const_var.isDataWithlegCut == false){
        //params.p_e_l = false;
    } 
    cuBuilding.CheckLegsByResponse(state);
    if(const_var.crmSetting.is_Edit==true && const_var.UpdatedPriceData.height_price_changed==undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.request_data.building!==undefined && (const_var.editAPIDataByResponse.data.request_data.building.roof_style!=undefined))
    {
        if(const_var.editAPIDataByResponse.data.request_data.building.roof_style!= params.p_r_s)
        {
            const_var.UpdatedPriceData.height_price_changed = true; 
        }else{
            const_var.UpdatedPriceData.height_price_changed = undefined; 
        }
    }else{
        const_var.UpdatedPriceData.height_price_changed = true; 
    }
    const_var.UpdatedPriceData.height_price_changed = (const_var.crmSetting.is_Edit==true && const_var.UpdatedPriceData.height_price_changed==undefined)?undefined:true; 
    // cuBuilding.uUdDCB();
    // cuBuilding.uUdD();
    // cuBuilding.leanuUdD();
    ////cuBuilding.rEaEfW(const_var.b_d_g_b_O_c,'');
    if(const_var.crmSetting.is_Edit != true){
        const_var.UpdatedPriceData.roof_pitch_price_changed = true
    }
    cuBuilding.BuildingUpdate(true, '');
     if(params.isBreezeway && chkEdit != "edit") updateBreezewayFrameAndStorages({option:"buildingHeight"}, undefined, Number(params.p_h));
    if (params.cupola) cuComponent.handlCupolaPositionOnDimensionChange('roofPitch');
    if (params.add_front_lean == true) cuBuilding.UpdateFrontLean();
    if (params.add_left_lean == true) cuBuilding.UpdateLeftLean();
    if (params.add_right_lean == true) cuBuilding.UpdateRightLean();
    if (params.add_back_lean == true) cuBuilding.UpdateBackLean();
     //cuBuilding.cP();
}

const changeBuildingDimension = (state, value, str, secondParam, checkCustomDimension,valueToSet,from) => { 
    // console.log('giorgi- changeBuildingDimension: ', {state, value, str, secondParam, checkCustomDimension});
    for (const key in params) {
        params.params_cancel[key] = params[key];
    }
    const_var.CheckDefaultLoadForTween = false;
    if (checkCustomDimension != undefined) {
        const_var.lengthData.center.previousWidth = state.params.p_w;
        state.params.p_w = parseInt(value);
        const_var.UpdatedPriceData.roof_style_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.front_wall_price_changed = true;
        const_var.UpdatedPriceData.back_wall_price_changed = true;
        const_var.UpdatedPriceData.common_width_changed = true;
        const_var.UpdatedPriceData.wainscot_price_changed = true;
        const_var.UpdatedPriceData.wainscot_price_changed = true;
        // const_var.UpdatedPriceData.color_price_changed = true;
        const_var.UpdatedPriceData.roof_color_price_changed = true;
        const_var.UpdatedPriceData.wall_color_price_changed = true;
        const_var.UpdatedPriceData.trim_color_price_changed = true;
        const_var.UpdatedPriceData.truss_price_changed = undefined;
        
        if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
            const_var.UpdatedPriceData.roof_pitch_price_changed = true;
        }
        const_var.lengthData.center.previousLength = state.params.p_d;
        state.params.p_d = parseInt(secondParam);
        const_var.lengthData.center.length = state.params.p_d;
        if ((state.params.p_d > (state.const_var.arrayendLengthRoof[params.p_r_s])) && ("Vertical" != state.const_var.TypeEnum[state.params.p_r_s])) {
            state.params.p_r_s = 3;
            for (var i = 0; i <= const_var.roof_style.length - 1; i++) {
                if (state.const_var.roof_style[i].roof_id == state.params.p_r_s) {
                    roofStyleChange(state, i, true, true);
                }
            }
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "RoofStyleLength";
        }
        const_var.UpdatedPriceData.connection_fee_end_changed = true;
        const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
        const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
        const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
        const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
        const_var.UpdatedPriceData.roof_style_price_changed = true;
        const_var.UpdatedPriceData.height_price_changed = true;
        const_var.UpdatedPriceData.roof_pitch_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.right_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
        const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
        const_var.UpdatedPriceData.common_length_changed = true;
        const_var.UpdatedPriceData.wainscot_price_changed = true;
        const_var.UpdatedPriceData.truss_price_changed = true;

        updateTemplateWidthL();
        updateTemplateWidthR();
        updateTemplateWidthF();
        updateTemplateWidthB();
      
        // && (params.lean_p_d+params.leanF_p_w+params.leanB_p_w < 80)

        if (state.params.add_left_front_lean_porch == true && state.params.add_right_front_lean_porch == true) {
            state.params.leanF_p_d = state.params.p_w;
        }

        if (state.params.add_right_back_lean_porch == true && state.params.add_left_back_lean_porch == true) {
            state.params.leanB_p_d = state.params.p_w;
        }

        if (state.params.add_left_front_lean_porch == true && state.params.add_left_back_lean_porch == true) {
            state.params.lean_p_d = state.params.p_d;
        }

        if (state.params.add_right_back_lean_porch == true && state.params.add_right_front_lean_porch == true) {
            state.params.leanR_p_d = state.params.p_d;
        }
        if (state.params.add_left_front_lean_porch == true
            && state.params.leantoAlignmentFront != "2"
            && (params.p_w != params.leanF_p_d)) {

            state.params.add_left_front_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_front_lean_porch == true
            && state.params.leantoAlignmentFront != "3"
            && (params.p_w != params.leanF_p_d)) {

            state.params.add_right_front_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_left_back_lean_porch == true
            && state.params.leantoAlignmentBack != "3"
            && (params.p_w != params.leanB_p_d)) {

            state.params.add_left_back_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_back_lean_porch == true
            && state.params.leantoAlignmentBack != "2"
            && (params.p_w != params.leanB_p_d)) {

            state.params.add_right_back_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }
        if (state.params.add_left_front_lean_porch == true
            && state.params.leantoAlignmentLeft != "2"
            && (params.p_d != params.lean_p_d)) {
            state.params.add_left_front_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_left_back_lean_porch == true
            && state.params.leantoAlignmentLeft != "3"
            && (params.p_d != params.lean_p_d)) {

            state.params.add_left_back_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_front_lean_porch == true
            && state.params.leantoAlignmentRight != "2"
            && (params.p_d != params.lean_p_d)) {

            state.params.add_right_front_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_back_lean_porch == true
            && state.params.leantoAlignmentRight != "3"
            && (params.p_d != params.lean_p_d)) {

            state.params.add_right_back_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        // let frontLean = const_var.scene.getObjectByName("FrontLeanWalls");
        let lstPos = 0;
        let currPos = 0;
        // if(frontLean) lstPos = frontLean.position.x;
        if (params.leantoAlignmentFront=="1") currPos = 0;
        if (params.leantoAlignmentFront=="3") currPos = params.p_w/2-params.leanF_p_d/2;
        if (params.leantoAlignmentFront=="2") currPos = -params.p_w/2+params.leanF_p_d/2;
        if (lstPos != currPos) {
            const diff = currPos - lstPos;
            const_var.entry_points.forEach((e) => {
                if (e.component_wall_name == "F_L_F_W" || e.component_wall_name == "F_L_F_S_W") e.entry_position.x +=diff;
            })
        }

        if (params.p_u_c) {
            const_var.newDoorsArray.forEach((e) => {
                if (e.userData.wallName == "c_b_r_s_w") {
                    e.positionX += (params.p_d - const_var.lengthData.center.previousLength)/2;
                } else if (e.userData.wallName == "c_b_l_s_w"){
                    e.positionX += (const_var.lengthData.center.previousLength - params.p_d)/2;
                }
            })
        }

        const_var.newDoorsArray.forEach((e) => {
            if (["L_L_F_W", "L_L_F_S_W"].includes(e.userData.wallName)) e.positionX += ((-params.p_w/2 - params.lean_p_w/2) - (-const_var.lengthData.center.previousWidth /2 - params.lean_p_w/2));
        })
        const_var.entry_points.forEach((e) => {
            if (["L_L_F_W", "L_L_F_S_W"].includes(e.component_wall_name)) e.entry_position.positionX += ((-params.p_w/2 - params.lean_p_w/2) - (-const_var.lengthData.center.previousWidth /2 - params.lean_p_w/2));
        })
        //
        const_var.newDoorsArray.forEach((e) => {
            if ("L_L_B_W".includes(e.userData.wallName)) e.positionX -= ((-params.p_w/2 - params.lean_p_w/2) - (-const_var.lengthData.center.previousWidth /2 - params.lean_p_w/2));
        })
        const_var.entry_points.forEach((e) => {
            if ("L_L_B_W".includes(e.component_wall_name)) e.entry_position.positionX -= ((-params.p_w/2 - params.lean_p_w/2) - (-const_var.lengthData.center.previousWidth /2 - params.lean_p_w/2));
        })
        //
        const_var.newDoorsArray.forEach((e) => {
            if (["R_L_F_W", "R_L_F_S_W"].includes(e.userData.wallName)) e.positionX +=((params.p_w/2 + params.leanR_p_w/2) - (const_var.lengthData.center.previousWidth /2 + params.lean_p_w/2));
        })
        const_var.entry_points.forEach((e) => {
            if (["R_L_F_W", "R_L_F_S_W"].includes(e.component_wall_name)) e.entry_position.positionX +=((params.p_w/2 + params.leanR_p_w/2) - (const_var.lengthData.center.previousWidth /2 + params.lean_p_w/2));
        })
        //
        const_var.newDoorsArray.forEach((e) => {
            if (["R_L_B_W"].includes(e.userData.wallName)) e.positionX -=((params.p_w/2 + params.leanR_p_w/2) - (const_var.lengthData.center.previousWidth /2 + params.lean_p_w/2));
        })
        const_var.entry_points.forEach((e) => {
            if (["R_L_B_W"].includes(e.component_wall_name)) e.entry_position.positionX -=((params.p_w/2 + params.leanR_p_w/2) - (const_var.lengthData.center.previousWidth /2 + params.lean_p_w/2));
        })
        //
        const_var.newDoorsArray.forEach((e) => {
            if (["B_L_B_W"].includes(e.userData.wallName)) e.positionX += ((-params.p_d/2 - params.leanB_p_w/2) - (-const_var.lengthData.center.previousLength / 2 - params.leanB_p_w / 2));
        })
        const_var.entry_points.forEach((e) => {
            if (["B_L_B_W"].includes(e.component_wall_name)) e.entry_position.positionX += ((-params.p_d/2 - params.leanB_p_w/2) - (-const_var.lengthData.center.previousLength / 2 - params.leanB_p_w / 2));
        })
        //
        const_var.newDoorsArray.forEach((e) => {
            if (["B_L_F_W", "B_L_L_S_W"].includes(e.userData.wallName)) e.positionX -= ((-params.p_d/2 - params.leanB_p_w/2) - (-const_var.lengthData.center.previousLength / 2 - params.leanB_p_w / 2));
        })
        const_var.entry_points.forEach((e) => {
            if (["B_L_F_W", "B_L_L_S_W"].includes(e.component_wall_name)) e.entry_position.positionX -= ((-params.p_d/2 - params.leanB_p_w/2) - (-const_var.lengthData.center.previousLength / 2 - params.leanB_p_w / 2));
        })
        //
        const_var.newDoorsArray.forEach((e) => {
            if (["F_L_L_W"].includes(e.userData.wallName)) e.positionX += ((params.p_d/2 + params.leanF_p_w/2) - (const_var.lengthData.center.previousLength / 2 + (params.leanF_p_w/2)));
        })
        const_var.entry_points.forEach((e) => {
            if (["F_L_L_W"].includes(e.component_wall_name)) e.entry_position.positionX += ((params.p_d/2 + params.leanF_p_w/2) - (const_var.lengthData.center.previousLength / 2 + (params.leanF_p_w/2)));
        })
        //
        const_var.newDoorsArray.forEach((e) => {
            if (["F_L_R_W", "F_L_R_S_W"].includes(e.userData.wallName)) e.positionX -=((params.p_d/2 + params.leanF_p_w/2) - (const_var.lengthData.center.previousLength / 2 + (params.leanF_p_w/2)));
        })
        const_var.entry_points.forEach((e) => {
            if (["F_L_R_W", "F_L_R_S_W"].includes(e.component_wall_name)) e.entry_position.positionX -=((params.p_d/2 + params.leanF_p_w/2) - (const_var.lengthData.center.previousLength / 2 + (params.leanF_p_w/2)));
        })


        // let backLean = const_var.scene.getObjectByName("BackLeanWalls");
        lstPos = 0;
        currPos = 0;
        // if(backLean) lstPos = backLean.position.x;
        if (params.leantoAlignmentBack=="1") currPos = 0;
        if (params.leantoAlignmentBack=="2") currPos = params.p_w/2-params.leanB_p_d/2;
        if (params.leantoAlignmentBack=="3") currPos = -params.p_w/2+params.leanB_p_d/2;
        if (lstPos != currPos) {
            const diff = currPos - lstPos;
            const_var.entry_points.forEach((e) => {
                if (e.component_wall_name == "B_L_S_W" || e.component_wall_name == "B_L_F_S_W") e.entry_position.x +=diff;
            })
        }

        // let leftLean = const_var.scene.getObjectByName("LeftLeanWalls");
        lstPos = 0;
        currPos = 0;
        // if(leftLean) lstPos = leftLean.position.z;
        if (params.leantoAlignmentLeft=="1") currPos = 0;
        if (params.leantoAlignmentLeft=="2") currPos = params.p_d/2-params.lean_p_d/2;
        if (params.leantoAlignmentLeft=="3") currPos = -params.p_d/2+params.lean_p_d/2;
        if (lstPos != currPos) {
            const diff = currPos - lstPos;
            const_var.entry_points.forEach((e) => {
                if (e.component_wall_name == "L_L_L_W" || e.component_wall_name == "L_L_L_S_W" || e.component_wall_name == "L_L_R_S_W") e.entry_position.z +=diff;
            })
        }

        // let rightLean = const_var.scene.getObjectByName("RightLeanWalls");
        lstPos = 0;
        currPos = 0;
        // if(rightLean) lstPos = rightLean.position.z;
        if (params.leantoAlignmentRight=="1") currPos = 0;
        if (params.leantoAlignmentRight=="2") currPos = params.p_d/2-params.leanR_p_d/2;
        if (params.leantoAlignmentRight=="3") currPos = -params.p_d/2+params.leanR_p_d/2;
        if (lstPos != currPos) {
            const diff = currPos - lstPos;
            const_var.entry_points.forEach((e) => {
                if (e.component_wall_name == "R_L_R_W" || e.component_wall_name == "R_L_R_S_W" || e.component_wall_name == "R_L_L_S_W") e.entry_position.z +=diff;
            })
        }


        if (!params.isBreezeway) cuBuilding.uUdD()
        else updateBreezewayFrameAndStorages({option:"buildingLength"}, undefined,  Number(params.p_h), Number(params.p_d),"popularSize",);
        cuBuilding.leanuUdD();  
    }
    if (str == "w" && checkCustomDimension == undefined) {

        const_var.lengthData.center.previousWidth = state.params.p_w;
        state.params.p_w = parseInt(value);
        const_var.UpdatedPriceData.roof_style_price_changed = true;
        const_var.UpdatedPriceData.height_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.front_wall_price_changed = true;
        const_var.UpdatedPriceData.back_wall_price_changed = true;
        const_var.UpdatedPriceData.common_width_changed = true;
        const_var.UpdatedPriceData.wainscot_price_changed = true;
        const_var.UpdatedPriceData.wainscot_price_changed = true;
        // const_var.UpdatedPriceData.color_price_changed = true;
        const_var.UpdatedPriceData.roof_color_price_changed = true;
        const_var.UpdatedPriceData.wall_color_price_changed = true;
        const_var.UpdatedPriceData.trim_color_price_changed = true;
        const_var.UpdatedPriceData.truss_price_changed = true;

        let fLength = params.p_d;
        let fWidth = params.p_w;                        
        params.add_front_lean && (fLength += params.leanF_p_w);
        params.add_back_lean && (fLength += params.leanB_p_w);
        params.add_left_lean && (fWidth += params.lean_p_w);
        params.add_right_lean && (fWidth += params.leanR_p_w);
        let diag = new THREE.Vector3(fLength, fWidth, params.p_h).length();
        // const_var.controls.maxDistance =  (diag  >= 100) ? 500: (diag * 6);

        if (params.leanF_p_d >= params.p_w) {
            params.leanF_p_d = params.p_w
        }
        if (params.leanB_p_d >= params.p_w) {
            params.leanB_p_d = params.p_w
        }

        if (params.cB_addStorage_left >= params.p_w) {
            params.cB_addStorage_left = params.p_w - 1
        }
        if (params.cB_addStorage_right >= params.p_w) {
            params.cB_addStorage_right = params.p_w - 1
        }

        if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
            const_var.UpdatedPriceData.roof_pitch_price_changed = true;
        }
        const_var.BuildingRoofPitch = [];

        if (state.params.add_left_front_lean_porch == true && state.params.add_right_front_lean_porch == true) {
            const_var.lengthData.frontLean.previousLength = state.params.leanF_p_d;
            state.params.leanF_p_d = state.params.p_w;
            const_var.lengthData.frontLean.length = state.params.leanF_p_d;
            
        }


        if (state.params.add_right_back_lean_porch == true && state.params.add_left_back_lean_porch == true) {
            const_var.lengthData.backLean.previousLength = state.params.leanB_p_d;
            state.params.leanB_p_d = state.params.p_w;
            const_var.lengthData.backLean.length = state.params.leanB_p_d;
        }

        if (state.params.add_left_front_lean_porch == true
            && state.params.leantoAlignmentFront != "2"
            && (params.p_w != params.leanF_p_d)) {

            state.params.add_left_front_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_front_lean_porch == true
            && state.params.leantoAlignmentFront != "3"
            && (params.p_w != params.leanF_p_d)) {

            state.params.add_right_front_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_left_back_lean_porch == true
            && state.params.leantoAlignmentBack != "3"
            && (params.p_w != params.leanB_p_d)) {

            state.params.add_left_back_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_back_lean_porch == true
            && state.params.leantoAlignmentBack != "2"
            && (params.p_w != params.leanB_p_d)) {

            state.params.add_right_back_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }
        if(params.isBreezeway) updateBreezewayFrameAndStorages({option:"buildingWidth"}, undefined, undefined);
        cuBuilding.leanuUdD();

        updateTemplateWidthF()
        updateTemplateWidthB()

        const_var.newDoorsArray.forEach((e) => {
            if (["L_L_F_W", "L_L_F_S_W"].includes(e.userData.wallName)) e.positionX += ((-params.p_w/2 - params.lean_p_w/2) - (-const_var.lengthData.center.previousWidth /2 - params.lean_p_w/2));
        })
        const_var.entry_points.forEach((e) => {
            if (["L_L_F_W", "L_L_F_S_W"].includes(e.component_wall_name)) e.entry_position.positionX += ((-params.p_w/2 - params.lean_p_w/2) - (-const_var.lengthData.center.previousWidth /2 - params.lean_p_w/2));
        })
        //
        const_var.newDoorsArray.forEach((e) => {
            if ("L_L_B_W".includes(e.userData.wallName)) e.positionX -= ((-params.p_w/2 - params.lean_p_w/2) - (-const_var.lengthData.center.previousWidth /2 - params.lean_p_w/2));
        })
        const_var.entry_points.forEach((e) => {
            if ("L_L_B_W".includes(e.component_wall_name)) e.entry_position.positionX -= ((-params.p_w/2 - params.lean_p_w/2) - (-const_var.lengthData.center.previousWidth /2 - params.lean_p_w/2));
        })
        //
        const_var.newDoorsArray.forEach((e) => {
            if (["R_L_F_W", "R_L_F_S_W"].includes(e.userData.wallName)) e.positionX +=((params.p_w/2 + params.leanR_p_w/2) - (const_var.lengthData.center.previousWidth /2 + params.leanR_p_w/2));
        })
        const_var.entry_points.forEach((e) => {
            if (["R_L_F_W", "R_L_F_S_W"].includes(e.component_wall_name)) e.entry_position.positionX +=((params.p_w/2 + params.leanR_p_w/2) - (const_var.lengthData.center.previousWidth /2 + params.leanR_p_w/2));
        })
        //
        const_var.newDoorsArray.forEach((e) => {
            if (["R_L_B_W"].includes(e.userData.wallName)) e.positionX -=((params.p_w/2 + params.leanR_p_w/2) - (const_var.lengthData.center.previousWidth /2 + params.leanR_p_w/2));
        })
        const_var.entry_points.forEach((e) => {
            if (["R_L_B_W"].includes(e.component_wall_name)) e.entry_position.positionX -=((params.p_w/2 + params.leanR_p_w/2) - (const_var.lengthData.center.previousWidth /2 + params.leanR_p_w/2));
        })



        let lstPos = 0;
        let currPos = 0;
        // if(frontLean) lstPos = frontLean.position.x;
        if (params.leantoAlignmentFront=="1") currPos = 0;
        if (params.leantoAlignmentFront=="3") currPos = params.p_w/2-params.leanF_p_d/2;
        if (params.leantoAlignmentFront=="2") currPos = -params.p_w/2+params.leanF_p_d/2;
        if (lstPos != currPos) {
            const diff = currPos - lstPos;
            const_var.entry_points.forEach((e) => {
                if (e.component_wall_name == "F_L_F_W" || e.component_wall_name == "F_L_F_S_W") e.entry_position.x +=diff;
            })
        }

        // let backLean = const_var.scene.getObjectByName("BackLeanWalls");
        lstPos = 0;
        currPos = 0;
        // if(backLean) lstPos = backLean.position.x;
        if (params.leantoAlignmentBack=="1") currPos = 0;
        if (params.leantoAlignmentBack=="2") currPos = params.p_w/2-params.leanB_p_d/2;
        if (params.leantoAlignmentBack=="3") currPos = -params.p_w/2+params.leanB_p_d/2;
        if (lstPos != currPos) {
            const diff = currPos - lstPos;
            const_var.entry_points.forEach((e) => {
                if (e.component_wall_name == "B_L_S_W" || e.component_wall_name == "B_L_F_S_W") e.entry_position.x +=diff;
            })
        }

    } else if (str == "l" && checkCustomDimension == undefined) {
        const_var.lengthData.center.previousLength = state.params.p_d;
        state.params.p_d = parseInt(value);
        const_var.lengthData.center.length = state.params.p_d;
        if ((state.params.p_d > (state.const_var.arrayendLengthRoof[params.p_r_s])) && ("Vertical" != state.const_var.TypeEnum[state.params.p_r_s])) {
            state.params.p_r_s = 3;
            for (var i = 0; i <= const_var.roof_style.length - 1; i++) {
                if (state.const_var.roof_style[i].roof_id == state.params.p_r_s) {
                    roofStyleChange(state, i, true, true);
                }
            }
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "RoofStyleLength";
        }

        const_var.UpdatedPriceData.connection_fee_end_changed = true;
        const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
        const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
        const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
        const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
        const_var.UpdatedPriceData.roof_style_price_changed = true;
        const_var.UpdatedPriceData.height_price_changed = true;
        const_var.UpdatedPriceData.roof_pitch_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.right_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
        const_var.UpdatedPriceData.front_wall_price_changed = true;
        const_var.UpdatedPriceData.front_wall_cut_panel_price_changed = true;
        const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
        const_var.UpdatedPriceData.common_length_changed = true;
        const_var.UpdatedPriceData.wainscot_price_changed = true;
        const_var.UpdatedPriceData.wainscot_price_changed = true;
        // const_var.UpdatedPriceData.color_price_changed = true;
        const_var.UpdatedPriceData.roof_color_price_changed = true;
        const_var.UpdatedPriceData.wall_color_price_changed = true;
        const_var.UpdatedPriceData.trim_color_price_changed = true;
        const_var.UpdatedPriceData.truss_price_changed = true;

        let fLength = params.p_d;
        let fWidth = params.p_w;                        
        params.add_front_lean && (fLength += params.leanF_p_w);
        params.add_back_lean && (fLength += params.leanB_p_w);
        params.add_left_lean && (fWidth += params.lean_p_w);
        params.add_right_lean && (fWidth += params.leanR_p_w);
        let diag = new THREE.Vector3(fLength, fWidth, params.p_h).length();
        // const_var.controls.maxDistance =  (diag  >= 100) ? 500: (diag * 6)
  
        if (state.params.add_left_front_lean_porch == true && state.params.add_left_back_lean_porch == true) {
            const_var.lengthData.leftLean.previousLength = state.params.lean_p_d;
            state.params.lean_p_d = state.params.p_d;
            const_var.lengthData.leftLean.length = state.params.lean_p_d;
        }

        if (state.params.add_right_back_lean_porch == true && state.params.add_right_front_lean_porch == true) {
            const_var.lengthData.rightLean.previousLength = state.params.leanR_p_d;
            state.params.leanR_p_d = state.params.p_d;
            const_var.lengthData.rightLean.length = state.params.leanR_p_d;
        }


        if (params.p_u_c) {
            const_var.newDoorsArray.forEach((e) => {
                if (e.userData.wallName == "c_b_r_s_w") {
                    e.positionX += (params.p_d - const_var.lengthData.center.previousLength)/2;
                } else if (e.userData.wallName == "c_b_l_s_w"){
                    e.positionX += (const_var.lengthData.center.previousLength - params.p_d)/2;
                }
            })
        }


        const_var.newDoorsArray.forEach((e) => {
            if (["B_L_B_W"].includes(e.userData.wallName)) e.positionX += ((-params.p_d/2 - params.leanB_p_w/2) - (-const_var.lengthData.center.previousLength / 2 - params.leanB_p_w / 2));
        })

        const_var.newDoorsArray.forEach((e) => {
            if (["B_L_F_W", "B_L_L_S_W"].includes(e.userData.wallName)) e.positionX -= ((-params.p_d/2 - params.leanB_p_w/2) - (-const_var.lengthData.center.previousLength / 2 - params.leanB_p_w / 2));
        })

        const_var.newDoorsArray.forEach((e) => {
            if (["F_L_L_W"].includes(e.userData.wallName)) e.positionX += ((params.p_d/2 + params.leanF_p_w/2) - (const_var.lengthData.center.previousLength / 2 + (params.leanF_p_w/2)));
        })

        const_var.newDoorsArray.forEach((e) => {
            if (["F_L_R_W", "F_L_R_S_W"].includes(e.userData.wallName)) e.positionX -=((params.p_d/2 + params.leanF_p_w/2) - (const_var.lengthData.center.previousLength / 2 + (params.leanF_p_w/2)));
        })



        let lstPos = 0;
        let currPos = 0;
        // if(leftLean) lstPos = leftLean.position.z;
        if (params.leantoAlignmentLeft=="1") currPos = 0;
        if (params.leantoAlignmentLeft=="2") currPos = params.p_d/2-params.lean_p_d/2;
        if (params.leantoAlignmentLeft=="3") currPos = -params.p_d/2+params.lean_p_d/2;
        if (lstPos != currPos) {
            const diff = currPos - lstPos;
            const_var.entry_points.forEach((e) => {
                if (e.component_wall_name == "L_L_L_W" || e.component_wall_name == "L_L_L_S_W" || e.component_wall_name == "L_L_R_S_W") e.entry_position.z +=diff;
            })
        }

        // let rightLean = const_var.scene.getObjectByName("RightLeanWalls");
        lstPos = 0;
        currPos = 0;
        // if(rightLean) lstPos = rightLean.position.z;
        if (params.leantoAlignmentRight=="1") currPos = 0;
        if (params.leantoAlignmentRight=="2") currPos = params.p_d/2-params.leanR_p_d/2;
        if (params.leantoAlignmentRight=="3") currPos = -params.p_d/2+params.leanR_p_d/2;
        if (lstPos != currPos) {
            const diff = currPos - lstPos;
            const_var.entry_points.forEach((e) => {
                if (e.component_wall_name == "R_L_R_W" || e.component_wall_name == "R_L_R_S_W" || e.component_wall_name == "R_L_L_S_W") e.entry_position.z +=diff;
            })
        }

        if (params.add_right_lean)makeDimensionUpdateRight(state);
        if (params.add_left_lean)makeDimensionUpdateLeft(state);
        if (params.add_front_lean)makeDimensionUpdateFront(state);
        if (params.add_back_lean)makeDimensionUpdateBack(state);
        if ( !params.isBreezeway ) {
            cuBuilding.uUdD();
        } else {
            updateBreezewayFrameAndStorages({option:"buildingLength"}, undefined,  Number(params.p_h), Number(params.p_d));
        }
        if(params.add_front_lean || params.add_left_lean || params.add_right_lean || params.add_back_lean ){
            cuBuilding.leanuUdD();
        }

        if (state.params.add_left_front_lean_porch == true
            && state.params.leantoAlignmentLeft != "2"
            && (params.p_d != params.lean_p_d)) {
            state.params.add_left_front_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_left_back_lean_porch == true
            && state.params.leantoAlignmentLeft != "3"
            && (params.p_d != params.lean_p_d)) {

            state.params.add_left_back_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_front_lean_porch == true
            && state.params.leantoAlignmentRight != "2"
            && (params.p_d != params.lean_p_d)) {

            state.params.add_right_front_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_back_lean_porch == true
            && state.params.leantoAlignmentRight != "3"
            && (params.p_d != params.lean_p_d)) {

            state.params.add_right_back_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }


        
    } else if (str == "h" || (from != undefined && from.str == "h" && from?.cmp == "popularSizes")) {
        state.params.p_h = (from != undefined && from?.cmp == "popularSizes" ? from.val : parseInt(value)) ;

        if(isNaN(params.p_l_w) == false && (Math.abs(params.p_l_w) * 3) >= params.p_h){
            params.p_l_w = "Close"
        }
        if(isNaN(params.p_r_w) == false && (Math.abs(params.p_r_w) * 3) >= params.p_h){
            params.p_r_w = "Close"
        }
        makeDimensionArray(state)

        const_var.UpdatedPriceData.height_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.right_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
        const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
        const_var.UpdatedPriceData.front_wall_price_changed = true;
        const_var.UpdatedPriceData.back_wall_price_changed = true;
        const_var.UpdatedPriceData.utility_price_changed = true;
        const_var.UpdatedPriceData.front_utility_price_changed = true;
        const_var.UpdatedPriceData.common_height_changed = true;
        const_var.UpdatedPriceData.lifttype_price_changed = true;

        if (params.add_left_lean == true && const_var.leanGetDataLeft.central_side != undefined && const_var.leanGetDataLeft.central_side.length > 0) {
            const_var.leanGetDataLeft.central_side = [];
            const_var.leanGetDataLeft.central_end = [];
        }
        if (params.add_right_lean == true && const_var.leanGetDataRight.central_side != undefined && const_var.leanGetDataRight.central_side.length > 0) {
            const_var.leanGetDataRight.central_side = [];
            const_var.leanGetDataRight.central_end = [];
        }
        params.p_e_l = false;
        makeDimensionUpdateRight(state);
        makeDimensionUpdateLeft(state);
        makeDimensionUpdateFront(state);
        makeDimensionUpdateBack(state);
        const_var.UpdatedPriceData.certificate_price_changed = true;
        cuBuilding.CheckLeanLegsByResponse(state ,"all");
        updateJTrim();
        if(params.isBreezeway) updateBreezewayFrameAndStorages({option:"buildingHeight"}, undefined, Number(params.p_h));
        const_var.commonBuildingFlag.center.buildingHeightChk = true
        const_var.commonBuildingFlag.center.buildingHeight = true
    } else if (str == "lean_w") {
        state.params.lean_p_w = parseInt(value);
        const_var.UpdatedPriceData.left_lean_roof_style_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.left_lean_front_wall_price_changed = true;
        const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
        const_var.UpdatedPriceData.connection_fee_end_changed = true;
        const_var.UpdatedPriceData.wainscot_price_changed = true;


        if (state.params.add_left_front_lean_porch != false && state.params.leanF_p_w != state.params.lean_p_w) {
            state.params.add_left_front_lean_porch = false
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_left_back_lean_porch != false && state.params.leanB_p_w != state.params.lean_p_w) {
            state.params.add_left_back_lean_porch = false
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_front_lean_porch != false && state.params.add_left_front_lean_porch == true && state.params.lean_p_w != state.params.leanR_p_w) {
            state.params.add_right_front_lean_porch = false
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_back_lean_porch != false && state.params.add_left_back_lean_porch == true && state.params.lean_p_w != state.params.leanR_p_w) {
            state.params.add_right_back_lean_porch = false
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
            const_var.UpdatedPriceData.left_lean_roof_pitch_price_changed = true;
        }
        cuBuilding.UpdateLeftLean();
        updateTemplateWidthL();
    } else if (str == "lean_l") {
        const_var.lengthData.leftLean.previousLength = state.params.lean_p_d;
        state.params.lean_p_d = parseInt(value);
        const_var.lengthData.leftLean.length = state.params.lean_p_d;
        // if (state.params.add_storage >= (state.params.lean_p_d - (state.const_var.DistanceArr[params.p_b_t][params.p_r_s] * 2))) {
        //     state.params.add_storage = state.const_var.DistanceArr[params.p_b_t][params.p_r_s] * 2;
        // }
        const_var.UpdatedPriceData.left_lean_roof_style_price_changed = true;
        const_var.UpdatedPriceData.left_lean_height_price_changed = true;
        const_var.UpdatedPriceData.left_lean_roof_pitch_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
        const_var.UpdatedPriceData.wainscot_price_changed = true;
        if (state.params.add_left_front_lean_porch != false && state.params.leantoAlignmentLeft != "2") {
            state.params.add_left_front_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_left_back_lean_porch != false && state.params.leantoAlignmentLeft != "3") {
            state.params.add_left_back_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        cuBuilding.UpdateLeftLean();
        cuBuilding.leanuUdD();

    } else if (str == "lean_h") {
        state.params.lean_p_h = parseInt(value);
        const_var.UpdatedPriceData.left_lean_height_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
        const_var.UpdatedPriceData.left_lean_front_wall_price_changed = true;
        const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
        const_var.UpdatedPriceData.left_lean_utility_price_changed = true;
 
        if (state.params.add_left_front_lean_porch != false && state.params.leanF_p_h != state.params.lean_p_h) {
            state.params.add_left_front_lean_porch = false
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_left_back_lean_porch != false && state.params.leanB_p_h != state.params.lean_p_h) {
            state.params.add_left_back_lean_porch = false
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_front_lean_porch != false && state.params.add_left_front_lean_porch == true && state.params.lean_p_h != state.params.leanR_p_h) {
            state.params.add_right_front_lean_porch = false
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_back_lean_porch != false && state.params.add_left_back_lean_porch == true && state.params.lean_p_h != state.params.leanR_p_h) {
            state.params.add_right_back_lean_porch = false
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }
        cuBuilding.UpdateLeftLean();
        updateTemplateWidthL(); 
        const_var.commonBuildingFlag.leftLean.leftLeanHeight = valueToSet != undefined ? valueToSet : true
    } else if (str == "leanR_w") {
        state.params.leanR_p_w = parseInt(value);
        const_var.UpdatedPriceData.right_lean_roof_style_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.right_lean_front_wall_price_changed = true;
        const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
        const_var.UpdatedPriceData.connection_fee_end_changed = true;
        const_var.UpdatedPriceData.wainscot_price_changed = true;


        if (state.params.add_right_front_lean_porch != false && state.params.leanF_p_w != state.params.leanR_p_w) {
            state.params.add_right_front_lean_porch = false
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_back_lean_porch != false && state.params.leanB_p_w != state.params.leanR_p_w) {
            state.params.add_right_back_lean_porch = false
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }


        if (state.params.add_left_front_lean_porch != false && state.params.add_right_front_lean_porch == true && state.params.lean_p_w != state.params.leanR_p_w) {
            state.params.add_left_front_lean_porch = false
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_left_back_lean_porch != false && state.params.add_right_back_lean_porch == true && state.params.lean_p_w != state.params.leanR_p_w) {
            state.params.add_left_back_lean_porch = false
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
            const_var.UpdatedPriceData.right_lean_roof_pitch_price_changed = true;
        }
        cuBuilding.UpdateRightLean();
        updateTemplateWidthR();
    } else if (str == "leanR_l") {
        const_var.lengthData.rightLean.previousLength = state.params.leanR_p_d;
        state.params.leanR_p_d = parseInt(value);
        const_var.lengthData.rightLean.length = state.params.leanR_p_d;
    // console.log(state.const_var.DistanceArr,state.const_var.DistanceArr[params.p_b_t],state.const_var.DistanceArr[params.p_b_t][params.p_r_s],"state.const_var.DistanceArr[params.p_b_t][params.p_r_s]");
        // if (state.params.add_storage_right >= (state.params.leanR_p_d - (state.const_var.DistanceArr[params.p_b_t][params.p_r_s] * 2))) {
        //     state.params.add_storage_right = state.const_var.DistanceArr[params.p_b_t][params.p_r_s] * 2;
        // }
        const_var.UpdatedPriceData.right_lean_roof_style_price_changed = true;
        const_var.UpdatedPriceData.right_lean_height_price_changed = true;
        const_var.UpdatedPriceData.right_lean_roof_pitch_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
        const_var.UpdatedPriceData.wainscot_price_changed = true;

        if (state.params.add_right_front_lean_porch != false && state.params.leantoAlignmentRight != "2") {
            state.params.add_right_front_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_back_lean_porch != false && state.params.leantoAlignmentRight != "3") {
            state.params.add_right_back_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        let wNames = ["R_L_R_S_W", "R_L_L_S_W"];

        // })
        cuBuilding.UpdateRightLean();
        cuBuilding.leanuUdD();

    } else if (str == "leanR_h") {
        state.params.leanR_p_h = parseInt(value);
        const_var.UpdatedPriceData.right_lean_height_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
        const_var.UpdatedPriceData.right_lean_front_wall_price_changed = true;
        const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
        const_var.UpdatedPriceData.right_lean_utility_price_changed = true;

        if (state.params.add_right_front_lean_porch != false) {
            state.params.add_right_front_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_back_lean_porch != false) {
            state.params.add_right_back_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }
        cuBuilding.UpdateRightLean();
        updateTemplateWidthR();
        const_var.commonBuildingFlag.rightLean.rightLeanHeight = valueToSet != undefined ? valueToSet : true
    }
    //   else if (str=="leanF_w") {
    else if (str == "leanF_w") {
        state.params.leanF_p_w = parseInt(value);
        // console.log(parseInt(value),"parseInt(value)")
        const_var.UpdatedPriceData.front_lean_roof_style_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;
        const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
        const_var.UpdatedPriceData.connection_fee_end_changed = true;
        const_var.UpdatedPriceData.wainscot_price_changed = true;

        if (state.params.add_left_front_lean_porch != false) {
            state.params.add_left_front_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_front_lean_porch != false) {
            state.params.add_right_front_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }
        if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
            const_var.UpdatedPriceData.front_lean_roof_pitch_price_changed = true;
        }
        cuBuilding.UpdateFrontLean();
        updateTemplateWidthF();

    }
    else if (str == "leanF_l") {
        // if (state.params.add_storage_front >= (state.params.leanF_p_d - (state.const_var.DistanceArr[params.p_b_t][params.p_r_s] * 2))) {
        //     state.params.add_storage_front = state.const_var.DistanceArr[params.p_b_t][params.p_r_s];
        // }

        //state.params.p_w = parseInt(value);
        const_var.lengthData.frontLean.previousLength = state.params.leanF_p_d;
        state.params.leanF_p_d = parseInt(value);
        const_var.lengthData.frontLean.length = state.params.leanF_p_d;
        const_var.UpdatedPriceData.roof_style_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.front_wall_price_changed = true;
        const_var.UpdatedPriceData.back_wall_price_changed = true;
        const_var.UpdatedPriceData.common_width_changed = true;
        const_var.UpdatedPriceData.wainscot_price_changed = true;
        if (state.params.add_left_front_lean_porch != false && state.params.leantoAlignmentFront != "2" && params.leanF_p_d != params.p_w) {
            state.params.add_left_front_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_front_lean_porch != false && state.params.leantoAlignmentFront != "3" && params.leanF_p_d != params.p_w) {
            state.params.add_right_front_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }
        // state.params.add_left_front_lean_porch = false;
        // state.params.add_right_front_lean_porch = false;
        if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
            const_var.UpdatedPriceData.roof_pitch_price_changed = true;
        }

        cuBuilding.UpdateFrontLean();
        cuBuilding.leanuUdD();

        if (Object.keys(const_var.FrontLeandrop_arr).length==0 && params.add_storage_check_front){
            params.add_storage_check_front = false;
            (state.isFullyEnclosedCheckedForFrontLeanTo) ? params.p_b_c_b_f_b = "Close" : params.p_b_c_b_f_b = "Open"
        }
    }
    else if (str == "leanF_h") {
        state.params.leanF_p_h = parseInt(value);
        const_var.UpdatedPriceData.front_lean_height_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.front_lean_left_wall_price_changed = true;
        const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;
        const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
        const_var.UpdatedPriceData.front_lean_utility_price_changed = true;

        if (state.params.add_left_front_lean_porch != false) {
            state.params.add_left_front_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_front_lean_porch != false) {
            state.params.add_right_front_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }
        cuBuilding.UpdateFrontLean();
        updateTemplateWidthF();
        const_var.commonBuildingFlag.frontLean.frontLeanHeight = valueToSet != undefined ? valueToSet : true
    }
    else if (str == "leanB_w") {
        state.params.leanB_p_w = parseInt(value);
        const_var.UpdatedPriceData.back_lean_roof_style_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;
        const_var.UpdatedPriceData.back_lean_right_wall_price_changed = true;
        const_var.UpdatedPriceData.connection_fee_end_changed = true;
        const_var.UpdatedPriceData.wainscot_price_changed = true;

        if (state.params.add_left_back_lean_porch != false) {
            state.params.add_left_back_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_back_lean_porch != false) {
            state.params.add_right_back_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }
        if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
            const_var.UpdatedPriceData.back_lean_roof_pitch_price_changed = true;
        }
        updateTemplateWidthB();
        cuBuilding.UpdateBackLean();
    }
    else if (str == "leanB_l" ) {

        //state.params.p_w = parseInt(value);
        const_var.lengthData.backLean.previousLength = state.params.leanB_p_d;
        state.params.leanB_p_d = parseInt(value);
        const_var.lengthData.backLean.length = state.params.leanB_p_d;
        // console.log(params.leanB_p_d,"params.leanB_p_d")
        // if (state.params.add_storage_back >= (state.params.leanB_p_d - (state.const_var.DistanceArr[params.p_b_t][params.p_r_s] * 2))) {
        //     state.params.add_storage_back = state.const_var.DistanceArr[params.p_b_t][params.p_r_s] ;
        // }
        const_var.UpdatedPriceData.roof_style_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.front_wall_price_changed = true;
        const_var.UpdatedPriceData.back_wall_price_changed = true;
        const_var.UpdatedPriceData.common_width_changed = true;
        const_var.UpdatedPriceData.wainscot_price_changed = true;
        if (state.params.add_left_back_lean_porch != false && state.params.leantoAlignmentBack != "3" && params.leanB_p_d != params.p_w) {
            state.params.add_left_back_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_back_lean_porch != false && state.params.leantoAlignmentBack != "2" && params.leanB_p_d != params.p_w) {
            state.params.add_right_back_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }
        // state.params.add_left_back_lean_porch = false;
        // state.params.add_right_back_lean_porch = false;
        if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
            const_var.UpdatedPriceData.roof_pitch_price_changed = true;
        }

        cuBuilding.UpdateBackLean();
        cuBuilding.leanuUdD();

        if (Object.keys(const_var.BackLeandrop_arr).length==0 && params.add_storage_check_back){
            params.add_storage_check_back = false;
            (state.isFullyEnclosedCheckedForBackLeanTo) ? params.p_b_c_b_b_b = "Close" : params.p_b_c_b_b_b = "Open"
        }

    }
    else if (str == "leanB_h") {
        state.params.leanB_p_h = parseInt(value);
        const_var.UpdatedPriceData.back_lean_height_price_changed = true;
        const_var.UpdatedPriceData.certificate_price_changed = true;
        const_var.UpdatedPriceData.back_lean_left_wall_price_changed = true;
        const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;
        const_var.UpdatedPriceData.back_lean_right_wall_price_changed = true;
        const_var.UpdatedPriceData.back_lean_utility_price_changed = true;

        if (state.params.add_left_back_lean_porch != false) {
            state.params.add_left_back_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }

        if (state.params.add_right_back_lean_porch != false) {
            state.params.add_right_back_lean_porch = false;
            // state.const_var.isShowAlert = true;
            // state.const_var.alertUsedFor = "YourCanNotAddPorch";
        }
        updateTemplateWidthB();
        cuBuilding.UpdateBackLean();
        const_var.commonBuildingFlag.backLean.backLeanHeight = valueToSet != undefined ? valueToSet : true
    }
    // state.params.p_u_t = Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s]
    if (const_var.loginSession == false) { reSelExtEle(state); }
    dynamicWallOptions(state);
    dynamicWallOptionsForLeanTo(state);
    if ((state.params.add_front_lean == true) || (state.params.p_r_s == "4" || state.params.p_r_s == "5")) {
        state.params.p_f_w = (state.params.p_f_w == "Close" || state.params.p_f_w == "Open") ? state.params.p_f_w : (params.a_c_p_f == false) ? state.params.p_f_w : state.params.p_f_w;
    }
    if ((state.params.add_left_lean == true) || (state.params.p_r_s == "4" || state.params.p_r_s == "5")) {
        state.params.p_l_w = (state.params.p_l_w == "Close" || state.params.p_l_w == "Open") ? state.params.p_l_w : (params.a_c_p_l == false) ? 1 : state.params.p_l_w;
    }
    if ((state.params.add_right_lean == true) || (state.params.p_r_s == "4" || state.params.p_r_s == "5")) {
        state.params.p_r_w = (state.params.p_r_w == "Close" || state.params.p_r_w == "Open") ? state.params.p_r_w : (params.a_c_p_r == false) ? 1 : state.params.p_r_w;
    }

    if (params.checkeditName != true) {
        let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
        params.other_building_type_name = newVal;
        if (const_var.post_data.building != undefined) {
            const_var.post_data.building.other_building_type_name = params.other_building_type_name;
            const_var.post_data.building.name = params.other_building_type_name;
        }
    }

    
    cuBuilding.uUdDCB();
    // if (checkCustomDimension != undefined) {
    // //  if (params.cupola) cuComponent.handlCupolaPositionOnDimensionChange(str);
    // }else{
    // //   if (params.cupola) cuComponent.handlCupolaPositionOnDimensionChange(str);
    // }
    if (const_var.callMesure == true ){
        if (params.add_front_lean || params.add_back_lean || params.add_left_lean || params.add_right_lean) {
        }
    }
    const_var.UpdatedPriceData.wainscot_price_changed = true;
    // const_var.UpdatedPriceData.color_price_changed = true;
    const_var.UpdatedPriceData.roof_color_price_changed = true;
    const_var.UpdatedPriceData.wall_color_price_changed = true;
    const_var.UpdatedPriceData.trim_color_price_changed = true;
    utils.installationSurface(state.params.p_i_s)
    cuBuilding.BuildingUpdate(true, );
   
}


const changePorchDimension = (state, value, str, secondParam, checkCustomDimension) => {


    if (str == "w" && checkCustomDimension == undefined) {

        state.params.r_f_p_w = parseInt(value);

        if (params.add_left_front_porch == true) {

            const_var.l_f_p_w_arr = [];
            for (i = 5; i <= (params.p_w - params.r_f_p_w); i++) {
                const_var.l_f_p_w_arr.push(i)
            }
        }

        if (params.r_f_p_w > params.p_w) {
            params.r_f_p_w = params.p_w
        }
        if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
            const_var.UpdatedPriceData.roof_pitch_price_changed = true;
        }

        //   if(state.params.r_f_p_w > state.params.l_f_p_w){
        //     state.params.add_left_front_porch = false;
        //   }

    } else if (str == "l" && checkCustomDimension == undefined) {
        state.params.r_f_p_d = parseInt(value);

        if (params.add_right_back_porch == true) {

            const_var.r_b_p_d_arr = [];
            for (i = 5; i <= (params.p_d - params.r_f_p_d); i++) {
                const_var.r_b_p_d_arr.push(i)
            }
        }

        if ((state.params.r_f_p_d > (state.const_var.arrayendLengthRoof[params.p_r_s])) && ("Vertical" != state.const_var.TypeEnum[state.params.p_r_s])) {
            state.params.p_r_s = 3;
            for (var i = 0; i <= const_var.roof_style.length - 1; i++) {
                if (state.const_var.roof_style[i].roof_id == state.params.p_r_s) {
                    roofStyleChange(state, i, true, true);
                }
            }
            state.const_var.isShowAlert = true;
            state.const_var.alertUsedFor = "RoofStyleLength";
        }
        //   if(state.params.r_f_p_w > state.params.l_f_p_w){
        //     state.params.add_left_front_porch = false;
        //   }
    } else if (str == "lfw" && checkCustomDimension == undefined) {

        state.params.l_f_p_w = parseInt(value);

        if (params.add_right_front_porch == true) {

            const_var.r_f_p_w_arr = [];
            for (i = 5; i <= (params.p_w - params.l_f_p_w); i++) {
                const_var.r_f_p_w_arr.push(i)
            }
        }

        if (params.l_f_p_w > params.p_w) {
            params.l_f_p_w = params.p_w
        }

        if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
            const_var.UpdatedPriceData.roof_pitch_price_changed = true;
        }
    } else if (str == "lfl" && checkCustomDimension == undefined) {
        state.params.l_f_p_d = parseInt(value);

        if (params.add_left_back_porch == true) {

            const_var.l_b_p_d_arr = [];
            for (i = 5; i <= (params.p_d - params.l_f_p_d); i++) {
                const_var.l_b_p_d_arr.push(i)
            }
        }

        if ((state.params.l_f_p_d > (state.const_var.arrayendLengthRoof[params.p_r_s])) && ("Vertical" != state.const_var.TypeEnum[state.params.p_r_s])) {
            state.params.p_r_s = 3;
            for (var i = 0; i <= const_var.roof_style.length - 1; i++) {
                if (state.const_var.roof_style[i].roof_id == state.params.p_r_s) {
                    roofStyleChange(state, i, true, true);
                }
            }
            state.const_var.isShowAlert = true;
            state.const_var.alertUsedFor = "RoofStyleLength";
        }
    } else if (str == "lbw" && checkCustomDimension == undefined) {

        state.params.l_b_p_w = parseInt(value);

        if (params.add_right_back_porch == true) {

            const_var.r_b_p_w_arr = [];
            for (i = 5; i <= (params.p_w - params.l_b_p_w); i++) {
                const_var.r_b_p_w_arr.push(i)
            }
        }

        if (params.l_b_p_w > params.p_w) {
            params.l_b_p_w = params.p_w
        }

        if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
            const_var.UpdatedPriceData.roof_pitch_price_changed = true;
        }
    } else if (str == "lbl" && checkCustomDimension == undefined) {
        state.params.l_b_p_d = parseInt(value);

        if (params.add_left_front_porch == true) {

            const_var.l_f_p_d_arr = [];
            for (i = 5; i <= (params.p_d - params.l_b_p_d); i++) {
                const_var.l_f_p_d_arr.push(i)
            }
        }


        if ((state.params.l_b_p_d > (state.const_var.arrayendLengthRoof[params.p_r_s])) && ("Vertical" != state.const_var.TypeEnum[state.params.p_r_s])) {
            state.params.p_r_s = 3;
            for (var i = 0; i <= const_var.roof_style.length - 1; i++) {
                if (state.const_var.roof_style[i].roof_id == state.params.p_r_s) {
                    roofStyleChange(state, i, true, true);
                }
            }
            state.const_var.isShowAlert = true;
            state.const_var.alertUsedFor = "RoofStyleLength";
        }
    } else if (str == "rbw" && checkCustomDimension == undefined) {

        state.params.r_b_p_w = parseInt(value);

        if (params.add_left_back_porch == true) {

            const_var.l_b_p_w_arr = [];
            for (i = 5; i <= (params.p_w - params.r_b_p_w); i++) {
                const_var.l_b_p_w_arr.push(i)
            }
        }

        if (params.r_b_p_w > params.p_w) {
            params.r_b_p_w = params.p_w
        }

        if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
            const_var.UpdatedPriceData.roof_pitch_price_changed = true;
        }
    } else if (str == "rbl" && checkCustomDimension == undefined) {
        state.params.r_b_p_d = parseInt(value);

        if (params.add_right_front_porch == true) {

            const_var.r_f_p_d_arr = [];
            for (i = 5; i <= (params.p_d - params.r_b_p_d); i++) {
                const_var.r_f_p_d_arr.push(i)
            }
        }


        if ((state.params.r_b_p_d > (state.const_var.arrayendLengthRoof[params.p_r_s])) && ("Vertical" != state.const_var.TypeEnum[state.params.p_r_s])) {
            state.params.p_r_s = 3;
            for (var i = 0; i <= const_var.roof_style.length - 1; i++) {
                if (state.const_var.roof_style[i].roof_id == state.params.p_r_s) {
                    roofStyleChange(state, i, true, true);
                }
            }
            state.const_var.isShowAlert = true;
            state.const_var.alertUsedFor = "RoofStyleLength";
        }
    }

}
const makeDimensionUpdateFront = (state) => {
    let straightRoofval = (params.p_r_p == params.b_l_t_r_pF && !params.singleSlope && params.p_r_s != 1) ? 0 : 1
    const LeftLengthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];
    const LeftWidthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];
    var calulateDataF = 6;
    var standradWidthF = 6;
    if (state.params.p_h - ((state.params.b_l_t_r_pF * 12) / 12) >= state.const_var.b_m_i_hlean) {
        calulateDataF = state.params.p_h - ((state.params.b_l_t_r_pF * 12) / 12);
        standradWidthF = 12;
    } if (state.params.p_h - ((state.params.b_l_t_r_pF * 18) / 12) >= state.const_var.b_m_i_hlean) {
        calulateDataF = state.params.p_h - ((state.params.b_l_t_r_pF * 18) / 12);
        standradWidthF = 18;
    }
    if (state.params.p_h - ((state.params.b_l_t_r_pF * 24) / 12) >= state.const_var.b_m_i_hlean) {
        calulateDataF = state.params.p_h - ((state.params.b_l_t_r_pF * 24) / 12);
        standradWidthF = 24;
    }

    // var CheckVal = state.params.b_l_t_r_pF;
    if(const_var.BuildingLRoofPitch != undefined && Object.keys(const_var.BuildingLRoofPitch).length > 0){
        let CheckVal =  Math.round(state.params.leanF_p_w * Number(state.params.b_l_t_r_pF) / 12);
        let pitchArray = Object.values(const_var.BuildingLRoofPitch)
        let minPitch = Math.min(...pitchArray.map(Number));
        let checkCurrentMinHeight = ((state.params.p_h - straightRoofval) < (state.const_var.b_m_i_hlean + CheckVal) && (state.params.add_front_lean == true))

        if(checkCurrentMinHeight && minPitch < Number(state.params.b_l_t_r_pF)){
            state.params.b_l_t_r_pF = minPitch.toString()
        }

    }
    var CheckVal =  Math.round(state.params.leanF_p_w * Number(state.params.b_l_t_r_pF) / 12);
    if ((state.params.p_h - straightRoofval) < (state.const_var.b_m_i_hlean + CheckVal) && (state.params.add_front_lean == true)) {
        state.const_var.isShowAlert = true;
        state.const_var.alertUsedFor = "YourCanNotAddLeanTo";
        state.params.add_full_lean_porch = false
        // state.params.add_storage_check = false;
        // state.params.add_storage_check_right = false;
        // state.params.p_l_w = "Open";
        // state.params.p_r_w = "Open";
        // state.params.p_f_w = "Open";
        const_var.UpdatedPriceData.right_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_price_changed = true;
        const_var.UpdatedPriceData.front_wall_price_changed = true;
        const_var.UpdatedPriceData.front_wall_cut_panel_price_changed = true;
        const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
        const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
        if (const_var.isInsulaltionForOldQuotes && params.p_i_o != 0){
            const_var.UpdatedPriceData.height_price_changed = true;
            const_var.UpdatedPriceData.insulation_price = undefined;
        } 
        state.params.p_f_b_l = true;
        state.params.p_l_b_l = true;
        state.params.p_r_b_l = true;
        // const_var.leanto = [];
        // state.params.continous_front_lean = false;
        // state.params.continous_left_lean = false;
        // state.params.continous_right_lean = false;
        // state.params.add_left_lean = false;
        // state.params.add_right_lean = false;
        // state.params.lean_p_w =  state.params.leanF_p_d = 12;
        cuBuilding.removeDataFromArray(3);
        if ( state.params.add_left_front_lean_porch || state.params.add_right_front_lean_porch) {
            state.params.add_left_front_lean_porch = false;
            state.params.add_right_front_lean_porch = false;
        }
        state.params.add_storage_check_front = false;
        state.params.add_front_lean = false;
        const_var.leanFHasDoublelegshow = params.leanF_p_e_l = false;
        params.insulation.frontLean = {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,custom:false,}
        state.params.isShowCenter = false;
        state.params.leanF_p_d = 21;
        state.params.leanF_p_h = state.const_var.b_m_i_hlean;
        state.params.b_l_t_r_pF = "2";
        params.p_b_c_b_f_f = params.p_b_c_b_f_b = params.p_b_c_b_f_l = "Open";
        cuBuilding.BuildingUpdate(true, 'addFrontLean');
        cuBuilding.UpdateFrontLean();
        utils.updateFourFeetOnCenterPriceWithExtraBowsOnLeanRemoval();
        utils.onForceLeantoRemoval();
        cuBuilding.cP();
        params.activeWall = "c_b_f_w"
        const_var.wallSelection.centerBuildingWall = params.activeWall;
        const_var.wallSelection.leanToWall = "select"
    }

    var iVal = 12;
    if (params.p_w < 12) {
        iVal = params.p_w;
        if (iVal <= params.p_w) {
            const_var.dimensionsLeanLDF[iVal] = iVal;
        }
    }

    for (var i = iVal; i <= params.p_w; i++) {
        const_var.dimensionsLeanLDF[i] = i;
    }
    for (let i = iVal; i <= params.p_w; i++) {
        if ((i - iVal) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_length === 0) {
            LeftLengthoptions[0].options.push({
                label: i,
                value: i
            });
        } else {
            LeftLengthoptions[1].options.push({
                label: i,
                value: i
            });
        }
    }
    const_var.dimensionsLeanLDF = LeftLengthoptions;
    // for(var i=12;i <= params.p_w;i++)
    // {
    //     const_var.dimensionsLeanLWF[i] = i;
    // }
    for (var i = 12; i <= params.p_w; i++) {
            const_var.dimensionsLeanLWF[i] = i;
    }
    for (let i = 6; i <= standradWidthF; i++) {
        if ((i - 6) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_width === 0) {
                if(params.m_s_n==10 && (params.leanF_p_w!=14 && params.leanF_p_w!=16))
                {
                    if(i==14 ||i== 16  )
                    {
                        continue;
                    }
                }
                LeftWidthoptions[0].options.push({
                    label: i,
                    value: i
                });
        } else {
                if(params.m_s_n==10 && (params.leanF_p_w!=14 && params.leanF_p_w!=16))
                {
                    if(i==14 ||i== 16  )
                    {
                        continue;
                    }
                }
                LeftWidthoptions[1].options.push({
                    label: i,
                    value: i
                });
        }
    }
    const_var.dimensionsLeanLWF = LeftWidthoptions;

    let leanDefaultHeightF = params.p_h - params.b_l_t_r_pF;
    var heigF = params.p_h - parseInt(params.b_l_t_r_pF);
    for (var i = parseInt(state.const_var.b_m_i_hlean); i <= parseInt(calulateDataF); i++) {
        state.const_var.dimensionsLeanLHF[i] = i;
    }
    if (calulateDataF < state.params.leanF_p_h) {
        if (state.const_var.dimensionsLeanLHF[state.params.leanF_p_h] == undefined) {
            if (Math.floor(params.p_h - ((params.leanF_p_w * params.b_l_t_r_pF) / 12)) >= params.leanF_p_h) {
                state.params.leanF_p_h = params.leanF_p_h;
            } else {
                state.params.leanF_p_h = calulateDataF;
            }
        }
    }

    updateTemplateWidthF();

}
const makeDimensionUpdateBack = (state) => {
    let straightRoofval = (params.p_r_p == params.b_l_t_r_pB && !params.singleSlope && params.p_r_s != 1) ? 0 : 1
    const LeftLengthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];
    const LeftWidthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];
    var calulateDataB = 6;
    var standradWidthB = 6;
    if (state.params.p_h - ((state.params.b_l_t_r_pB * 12) / 12) >= state.const_var.b_m_i_hlean) {
        calulateDataB = state.params.p_h - ((state.params.b_l_t_r_pB * 12) / 12);
        standradWidthB = 12;
    } if (state.params.p_h - ((state.params.b_l_t_r_pB * 18) / 12) >= state.const_var.b_m_i_hlean) {
        calulateDataB = state.params.p_h - ((state.params.b_l_t_r_pB * 18) / 12);
        standradWidthB = 18;
    }
    if (state.params.p_h - ((state.params.b_l_t_r_pB * 24) / 12) >= state.const_var.b_m_i_hlean) {
        calulateDataB = state.params.p_h - ((state.params.b_l_t_r_pB * 24) / 12);
        standradWidthB = 24;
    }

    // var CheckVal = state.params.b_l_t_r_pB;
    if(const_var.BuildingLRoofPitch != undefined && Object.keys(const_var.BuildingLRoofPitch).length > 0){
        let CheckVal =  Math.round(state.params.leanB_p_w * Number(state.params.b_l_t_r_pB) / 12);
        let pitchArray = Object.values(const_var.BuildingLRoofPitch)
        let minPitch = Math.min(...pitchArray.map(Number));
        let checkCurrentMinHeight = ((state.params.p_h - straightRoofval) < (state.const_var.b_m_i_hlean + CheckVal) && (state.params.add_back_lean == true))

        if(checkCurrentMinHeight && minPitch < Number(state.params.b_l_t_r_pB)){
            state.params.b_l_t_r_pB = minPitch.toString()
        }

    }
    var CheckVal = Math.round(state.params.leanB_p_w * Number(state.params.b_l_t_r_pB) / 12);
    if ((state.params.p_h - straightRoofval) < (state.const_var.b_m_i_hlean + CheckVal) && (state.params.add_back_lean == true)) {
        state.const_var.isShowAlert = true;
        state.const_var.alertUsedFor = "YourCanNotAddLeanTo";
        state.params.add_full_lean_porch = false
        // state.params.add_storage_check = false;
        // state.params.add_storage_check_right = false;
        // state.params.p_l_w = "Open";
        // state.params.p_r_w = "Open";
        // state.params.p_f_w = "Open";
        // const_var.leanto = [];
        const_var.UpdatedPriceData.right_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_price_changed = true;
        const_var.UpdatedPriceData.back_wall_price_changed = true;
        const_var.UpdatedPriceData.back_wall_cut_panel_price_changed = true;
        const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
        const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
        if (const_var.isInsulaltionForOldQuotes && params.p_i_o != 0){
            const_var.UpdatedPriceData.height_price_changed = true;
            const_var.UpdatedPriceData.insulation_price = undefined;
        } 
        state.params.p_b_b_l = true;
        state.params.p_l_b_l = true;
        state.params.p_r_b_l = true;
        // state.params.continous_front_lean = false;
        // state.params.continous_left_lean = false;
        // state.params.continous_right_lean = false;
        // state.params.add_left_lean = false;
        // state.params.add_right_lean = false;
        // state.params.lean_p_w =  state.params.leanB_p_d = 12;
        cuBuilding.removeDataFromArray(4);
        if ( state.params.add_left_back_lean_porch || state.params.add_right_back_lean_porch) {
            state.params.add_left_back_lean_porch = false;
            state.params.add_right_back_lean_porch = false;
        }
        const_var.leanBHasDoublelegshow = params.leanB_p_e_l = false;
        params.insulation.backLean = {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,custom:false,}
        state.params.isShowCenter = false;
        state.params.add_storage_check_back = false;
        state.params.add_back_lean = false;
        state.params.leanB_p_d = 21;
        state.params.leanB_p_h = state.const_var.b_m_i_hlean;
        state.params.b_l_t_r_pB = "2";
        params.p_b_c_b_b_f = params.p_b_c_b_b_b = params.p_b_c_b_b_l = "Open";
        cuBuilding.BuildingUpdate(true, 'addBackLean');
        cuBuilding.UpdateBackLean();
        utils.onForceLeantoRemoval();
        utils.updateFourFeetOnCenterPriceWithExtraBowsOnLeanRemoval();
        cuBuilding.cP();
        if (const_var.callMesure){
        }
        params.activeWall = "c_b_f_w"
        const_var.wallSelection.centerBuildingWall = params.activeWall;
        const_var.wallSelection.leanToWall = "select"
    }

    var iVal = 12;
    if (params.p_w < 12) {
        iVal = params.p_w;
        if (iVal <= params.p_w) {
            const_var.dimensionsLeanLDB[iVal] = iVal;
        }
    }

    for (var i = iVal; i <= params.p_w; i++) {
        const_var.dimensionsLeanLDB[i] = i;
    }
    for (let i = iVal; i <= params.p_w; i++) {
        if ((i - iVal) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_length === 0) {
            LeftLengthoptions[0].options.push({
                label: i,
                value: i
            });
        } else {
            LeftLengthoptions[1].options.push({
                label: i,
                value: i
            });
        }
    }
    const_var.dimensionsLeanLDB = LeftLengthoptions;
    // for(var i=12;i <= params.p_w;i++)
    // {
    //     const_var.dimensionsLeanLWB[i] = i;
    // }
    for (var i = 12; i <= params.p_w; i++) {
            const_var.dimensionsLeanLWB[i] = i;
    }
    for (let i = 6; i <= standradWidthB; i++) {
        if ((i - 6) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_width === 0) {
                if(params.m_s_n==10 && (params.leanB_p_w!=14 && params.leanB_p_w!=16))
                {
                    if(i==14 ||i== 16  )
                    {
                        continue;
                    }
                }
                LeftWidthoptions[0].options.push({
                    label: i,
                    value: i
                });
        } else {
                if(params.m_s_n==10 && (params.leanB_p_w!=14 && params.leanB_p_w!=16))
                {
                    if(i==14 ||i== 16  )
                    {
                        continue;
                    }
                }
                LeftWidthoptions[1].options.push({
                    label: i,
                    value: i
                });
        }
    }
    const_var.dimensionsLeanLWB = LeftWidthoptions;
    let leanDefaultHeightB = params.p_h - params.b_l_t_r_pB;
    var heigB = params.p_h - parseInt(params.b_l_t_r_pB);
    for (var i = parseInt(state.const_var.b_m_i_hlean); i <= parseInt(calulateDataB); i++) {
        state.const_var.dimensionsLeanLHB[i] = i;
    }
    if (calulateDataB < state.params.leanB_p_h) {
        if (state.const_var.dimensionsLeanLHB[state.params.leanB_p_h] == undefined) {
            if (Math.floor(params.p_h - ((params.leanB_p_w * params.b_l_t_r_pB) / 12)) >= params.leanB_p_h) {
                state.params.leanB_p_h = params.leanB_p_h;
            } else {
                state.params.leanB_p_h = calulateDataB;
            }
        }
    }

    updateTemplateWidthB();

}
const makeDimensionUpdateLeft = (state) => {

    var calulateData = 6;
    var standraWidth = 6;
    var calulateDataR = 6;
    var standraWidthR = 6;
    let straightRoofval = (params.p_r_p == params.b_l_t_r_p && !params.singleSlope && params.p_r_s != 1) ? 0 : 1
    if (state.params.p_h - ((state.params.b_l_t_r_p * 12) / 12) >= state.const_var.b_m_i_hlean) {
        calulateData = state.params.p_h - ((state.params.b_l_t_r_p * 12) / 12);
        standraWidth = 12;
    } if (state.params.p_h - ((state.params.b_l_t_r_p * 18) / 12) >= state.const_var.b_m_i_hlean) {
        calulateData = state.params.p_h - ((state.params.b_l_t_r_p * 18) / 12);
        standraWidth = 18;
    }
    if (state.params.p_h - ((state.params.b_l_t_r_p * 24) / 12) >= state.const_var.b_m_i_hlean) {
        calulateData = state.params.p_h - ((state.params.b_l_t_r_p * 24) / 12);
        standraWidth = 24;
    }
    const LeftLengthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];
    const LeftWidthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];
    // var CheckVal = state.params.b_l_t_r_p;
    if(const_var.BuildingLRoofPitch != undefined && Object.keys(const_var.BuildingLRoofPitch).length > 0){
        let CheckVal =  Math.round(state.params.lean_p_w * Number(state.params.b_l_t_r_p) / 12);
        let pitchArray = Object.values(const_var.BuildingLRoofPitch)
        let minPitch = Math.min(...pitchArray.map(Number));
        let checkCurrentMinHeight = ((state.params.p_h - straightRoofval) < (state.const_var.b_m_i_hlean + CheckVal) && (state.params.add_left_lean == true ))

        if(checkCurrentMinHeight && minPitch < Number(state.params.b_l_t_r_p)){
            state.params.b_l_t_r_p = minPitch.toString()
        }

    }
    var CheckVal =  Math.round(state.params.lean_p_w * Number(state.params.b_l_t_r_p) / 12);
    if ((state.params.p_h - straightRoofval) < (state.const_var.b_m_i_hlean + CheckVal) && (state.params.add_left_lean == true )) {
        state.const_var.isShowAlert = true;
        state.const_var.alertUsedFor = "YourCanNotAddLeanTo";
        state.params.add_full_lean_porch = false
        // state.params.p_l_w = "Open";
        // state.params.p_r_w = "Open";
        const_var.UpdatedPriceData.right_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
        const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
        if (const_var.isInsulaltionForOldQuotes && params.p_i_o != 0){
            const_var.UpdatedPriceData.height_price_changed = true;
            const_var.UpdatedPriceData.insulation_price = undefined;
        } 
        state.params.p_l_b_l = true;
        state.params.p_r_b_l = true;
        // state.params.add_storage_check_right = false;
        // state.params.continous_left_lean = false;
        // state.params.continous_right_lean = false;
        // state.params.add_front_lean = false;
        // state.params.add_right_lean = false;
        // const_var.leanto = [];
        state.params.lean_p_w = 12;
        state.params.lean_p_d = 21;
        state.params.lean_p_h = state.const_var.b_m_i_hlean;
        state.params.b_l_t_r_p = "2";
        // cuComponent.removeAlltheComponent();
         cuBuilding.removeDataFromArray(1);
         const_var.leanHasDoublelegshow = params.lean_p_e_l = false;
         params.insulation.leftLean = {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,custom:false,}
         state.params.isShowCenter = false;
         state.params.add_left_lean = false;
         state.params.add_storage_check = false;
         state.params.add_left_front_lean_porch = false;
        state.params.add_left_back_lean_porch = false;
        params.p_b_c_b_l_f = params.p_b_c_b_l = params.p_b_c_b_l_b = "Open";
        cuBuilding.BuildingUpdate(true, 'addLeftLean');
        cuBuilding.UpdateLeftLean();
        utils.updateFourFeetOnCenterPriceWithExtraBowsOnLeanRemoval();
        utils.onForceLeantoRemoval();
        cuBuilding.cP();

        params.activeWall = "c_b_f_w"
        const_var.wallSelection.centerBuildingWall = params.activeWall;
        const_var.wallSelection.leanToWall = "select"
    }

    // if(standraWidth<state.params.lean_p_w)
    // {
    //     state.params.lean_p_w = standraWidth;
    // }
    var iVal = 21;
    if (params.p_d < 21) {
        iVal = params.p_d;
        if (iVal <= params.p_d) {
            const_var.dimensionsLeanLD[iVal] = iVal;
        }
    }
    for (var i = iVal; i <= params.p_d; i++) {
        const_var.dimensionsLeanLD[i] = i;
    }
    for (let i = Math.round(iVal); i <= params.p_d; i++) {
        if ((i - iVal) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_length === 0) {
            LeftLengthoptions[0].options.push({
                label: i,
                value: i
            });
        } else {
            LeftLengthoptions[1].options.push({
                label: i,
                value: i
            });
        }
    }
    const_var.dimensionsLeanLD = LeftLengthoptions;
    for (var i = 6; i <= standraWidth; i++) {
            state.const_var.dimensionsLeanLW[i] = i;
    }
    for (let i = 6; i <= standraWidth; i++) {
        if ((i - 6) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_width === 0) {
                if(params.m_s_n==10 && (params.lean_p_w!=14 && params.lean_p_w!=16))
                {
                    if(i==14 ||i== 16  )
                    {
                        continue;
                    }
                }
                LeftWidthoptions[0].options.push({
                    label: i,
                    value: i
                });
        } else {
                if(params.m_s_n==10 && (params.lean_p_w!=14 && params.lean_p_w!=16))
                {
                    if(i==14 ||i== 16  )
                    {
                        continue;
                    }
                }
                LeftWidthoptions[1].options.push({
                    label: i,
                    value: i
                });
        }
    }
    const_var.dimensionsLeanLW = LeftWidthoptions;

    let leanDefaultHeight = params.p_h - params.b_l_t_r_p;
    var heig = params.p_h - parseInt(params.b_l_t_r_p);
    for (var i = parseInt(state.const_var.b_m_i_hlean); i <= parseInt(calulateData); i++) {
        state.const_var.dimensionsLeanLH[i] = i;
    }
    if (calulateData < state.params.lean_p_h) {
        if (state.const_var.dimensionsLeanLH[state.params.lean_p_h] == undefined) {
            if (Math.floor(params.p_h - ((params.lean_p_w * params.b_l_t_r_p) / 12)) >= params.lean_p_h) {
                state.params.lean_p_h = params.lean_p_h;
            } else {
                state.params.lean_p_h = calulateData;
            }
        }
    }

    updateTemplateWidthL();

    //console.log(dimensionsLeanLW, dimensionsLeanLD, dimensionsLeanLH);
}
const makeDimensionUpdateRight = (state) => {

    var calulateData = 6;
    var standraWidth = 6;
    var calulateDataR = 6;
    var standraWidthR = 6;
    let straightRoofval = (params.p_r_p == params.b_l_t_r_pR && !params.singleSlope && params.p_r_s != 1) ? 0 : 1
    const RightLengthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];
    const RightWidthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];
    if (state.params.p_h - ((state.params.b_l_t_r_pR * 12) / 12) >= state.const_var.b_m_i_hlean) {
        calulateDataR = state.params.p_h - ((state.params.b_l_t_r_pR * 12) / 12);
        standraWidthR = 12;
    } if (state.params.p_h - ((state.params.b_l_t_r_pR * 18) / 12) >= state.const_var.b_m_i_hlean) {
        calulateDataR = state.params.p_h - ((state.params.b_l_t_r_pR * 18) / 12);
        standraWidthR = 18;
    }
    if (state.params.p_h - ((state.params.b_l_t_r_pR * 24) / 12) >= state.const_var.b_m_i_hlean) {
        calulateDataR = state.params.p_h - ((state.params.b_l_t_r_pR * 24) / 12);
        standraWidthR = 24;
    }
    var CheckVal = "";
    // if(state.params.b_l_t_r_p >= state.params.b_l_t_r_pR)
    // {
    //     CheckVal = state.params.b_l_t_r_p;
    // }if(state.params.b_l_t_r_p <= state.params.b_l_t_r_pR)
    // {
    //     CheckVal = state.params.b_l_t_r_pR;
    // }
    // CheckVal = state.params.b_l_t_r_pR;
    if(const_var.BuildingLRoofPitch != undefined && Object.keys(const_var.BuildingLRoofPitch).length > 0){
        let CheckVal =  Math.round(state.params.leanR_p_w * Number(state.params.b_l_t_r_pR) / 12);
        let pitchArray = Object.values(const_var.BuildingLRoofPitch)
        let minPitch = Math.min(...pitchArray.map(Number));
        let checkCurrentMinHeight = ((state.params.p_h - straightRoofval) < (state.const_var.b_m_i_hlean + CheckVal) && (state.params.add_right_lean == true))

        if(checkCurrentMinHeight && minPitch < Number(state.params.b_l_t_r_pR)){
            state.params.b_l_t_r_pR = minPitch.toString()
        }

    }
    CheckVal = Math.round(state.params.leanR_p_w * Number(state.params.b_l_t_r_pR) / 12);
    if ((state.params.p_h - straightRoofval) < (state.const_var.b_m_i_hlean + CheckVal) && (state.params.add_right_lean == true)) {
        // bootbox.alert({
        //     message: "Your can not add lean-to with selected height",
        //     size: 'small',
        //     closeButton:false,
        //     className: 'custom-bootbox timeout-modal',
        //      callback: function () {
        //         return true;
        //     }
        // });

        state.const_var.isShowAlert = true;
        state.const_var.alertUsedFor = "YourCanNotAddLeanTo";
        state.params.add_full_lean_porch = false
        //$(".add_storage input:checkbox").prop('checked',false);
        //$(".add_storage_right input:checkbox").prop('checked',false);
        // state.params.p_l_w = "Open";
        // state.params.p_r_w = "Open";
        const_var.UpdatedPriceData.right_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
        const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
        if (const_var.isInsulaltionForOldQuotes && params.p_i_o != 0){
            const_var.UpdatedPriceData.height_price_changed = true;
            const_var.UpdatedPriceData.insulation_price = undefined;
        } 
        state.params.p_l_b_l = true;
        state.params.p_r_b_l = true;
        // state.params.continous_left_lean = false;
        // state.params.continous_right_lean = false;
        // state.params.add_storage_check = false;
        // state.params.add_left_lean = false;
        // const_var.leanto = [];
         state.params.leanR_p_w = 12;
         state.params.leanR_p_d = 21;
         state.params.leanR_p_h = state.const_var.b_m_i_hlean;
         state.params.b_l_t_r_pR = "2";
        // cuComponent.removeAlltheComponent();
        cuBuilding.removeDataFromArray(2);
        const_var.leanRHasDoublelegshow = params.leanR_p_e_l = false;
        params.insulation.rightLean = {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,custom:false,}
        state.params.isShowCenter = false;
        state.params.add_right_lean = false;
        state.params.add_storage_check_right = false;
        state.params.add_right_front_lean_porch = false;
        state.params.add_right_back_lean_porch = false;
        params.p_b_c_b_r_f = params.p_b_c_b_r = params.p_b_c_b_r_b ="Open";
        cuBuilding.BuildingUpdate(true, 'addRightLean');
        cuBuilding.UpdateRightLean();
        utils.updateFourFeetOnCenterPriceWithExtraBowsOnLeanRemoval();
        utils.onForceLeantoRemoval();
        cuBuilding.cP();
        if (const_var.callMesure){
        }
        params.activeWall = "c_b_f_w"
        const_var.wallSelection.centerBuildingWall = params.activeWall;
        const_var.wallSelection.leanToWall = "select"

    }

    // if(standraWidthR<state.params.leanR_p_w)
    // {
    //     state.params.leanR_p_w = standraWidthR;
    // }

    var iVal = 21;
    if (params.p_d < 21) {
        iVal = params.p_d;
        if (iVal <= params.p_d) {
            const_var.dimensionsLeanLDR[iVal] = iVal;
        }
    }
    for (var i = iVal; i <= params.p_d; i++) {

        const_var.dimensionsLeanLDR[i] = i;
    }
    for (let i = Math.round(iVal / 2); i <= params.p_d; i++) {
        if ((i - iVal) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_length === 0) {
            RightLengthoptions[0].options.push({
                label: i,
                value: i
            });
        } else {
            RightLengthoptions[1].options.push({
                label: i,
                value: i
            });
        }
    }
    const_var.dimensionsLeanLDR = RightLengthoptions;

    for (var i = 6; i <= standraWidthR; i++) {
        state.const_var.dimensionsLeanLWR[i] = i;
    }

    for (let i = 6; i <= standraWidthR; i++) {
        if ((i - 6) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_width === 0) {
                if(params.m_s_n==10 && (params.leanR_p_w!=14 && params.leanR_p_w!=16))
                {
                    if(i==14 ||i== 16  )
                    {
                        continue;
                    }
                }
                RightWidthoptions[0].options.push({
                    label: i,
                    value: i
                });
        } else {
                if(params.m_s_n==10 && (params.leanR_p_w!=14 && params.leanR_p_w!=16))
                {
                    if(i==14 ||i== 16  )
                    {
                        continue;
                    }
                }
                RightWidthoptions[1].options.push({
                    label: i,
                    value: i
                });
        }
    }
    const_var.dimensionsLeanLWR = RightWidthoptions;

    let leanDefaultHeightR = params.p_h - params.b_l_t_r_pR;
    var heigR = params.p_h - parseInt(params.b_l_t_r_pR);
    // console.log(calulateDataR,"calulateDataR");
    for (var i = parseInt(state.const_var.b_m_i_hlean); i <= parseInt(calulateDataR); i++) {
        state.const_var.dimensionsLeanLHR[i] = i;
    }
    if (calulateDataR < state.params.leanR_p_h) {
        if (state.const_var.dimensionsLeanLHR[state.params.leanR_p_h] == undefined) {
            if (Math.floor(params.p_h - ((params.leanR_p_w * params.b_l_t_r_pR) / 12)) >= params.leanR_p_h) {
                state.params.leanR_p_h = params.leanR_p_h;
            } else {
                state.params.leanR_p_h = calulateDataR;
            }
        }
        //state.params.leanR_p_h = calulateDataR;
    }


    updateTemplateWidthR();
    //console.log(dimensionsLeanLW, dimensionsLeanLD, dimensionsLeanLH);
}


function widerlongeranimate() {
    document.querySelector('body').classList.add('animate-left-panel');
    setTimeout(function () {
        document.querySelector('body').classList.remove('animate-left-panel');
    }, 1000);
}

function updateTemplateWidthF(state) {
    if (params.p_w < params.leanF_p_d) {
        const_var.lengthData.frontLean.previousLength = params.leanF_p_d;
        params.leanF_p_d = params.p_w;
        const_var.lengthData.frontLean.length = params.leanF_p_d;
        // params.leanF_p_d = params.lean_p_d = params.leanR_p_d = params.p_d;
        // if (params.add_storage_check_front == true && params.add_front_lean == true) {
        //     params.add_storage_front = const_var.DistanceArr[params.p_b_t][params.p_r_s] * 1;
        // }
        // if (params.add_storage_check_back == true && params.add_back_lean == true) {
        //     params.add_storage_back = const_var.DistanceArr[params.p_b_t][params.p_r_s] * 1;
        // }

    }
    const LeftLengthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];
    const LeftWidthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];
    const_var.dimensionsLeanLWF = [];
    const_var.dimensionsLeanLDF = [];
    const_var.dimensionsLeanLHF = [];
    let iVal = 12;
    let startLength = 0;
    let endLength = 0;
    let minWidth = 0;
    let maxWidth = 0;
    let maxHeight = 0;
    let minHeight = 0;
    let roofDatanew = const_var.roof_style_Barn;

    if(const_var.roof_style_Barn_with_centerbuilding[params.p_b_t]!=undefined) {
        roofDatanew = const_var.roof_style_Barn_with_centerbuilding[params.p_b_t];
    }
    roofDatanew.map((val, i) => {
        if (params.p_r_s == val.roof_id) {
            iVal = val.min_width;
            startLength = val.start_length;
            endLength = val.building_max_length; // val.end_length;
            minWidth = val.min_width;
            maxWidth = val.max_width;
            maxHeight = val.max_height;
            minHeight = val.min_height;
            const_var.leanDimension = val;
            const_var.b_m_i_hlean = val.min_height
        }
    })
    if (params.p_w < minWidth) {
        iVal = params.p_w;
        if (iVal <= params.p_w) {
            const_var.dimensionsLeanLDF[iVal] = iVal;
        }
    }
    const newDataF = params.p_w <= maxWidth ? params.p_w : maxWidth;

    for (let i = iVal; i <= params.p_w; i++) {
        if ((i - iVal) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_length === 0) {
            LeftLengthoptions[0].options.push({
                label: i,
                value: i
            });
        } else {
            LeftLengthoptions[1].options.push({
                label: i,
                value: i
            });
        }
    }
    const_var.dimensionsLeanLDF = LeftLengthoptions;

    let straightRoofval = (params.p_r_p == params.b_l_t_r_pF && !params.singleSlope && params.p_r_s != 1) ? 0 : 1
    var dataH = Math.floor(params.p_h - ((params.leanF_p_w * Number(params.b_l_t_r_pF)) / 12) - straightRoofval);
    var newDataH = (parseInt(dataH) > maxHeight) ? maxHeight : parseInt(dataH);
    for (var i = minHeight; i <= newDataH; i++) {
        const_var.dimensionsLeanLHF[i] = i;
    }
    if (params.leanF_p_h > dataH) {
        params.leanF_p_h = dataH < minHeight ? minHeight : dataH;
        cuBuilding.UpdateFrontLean(); 
    }

    // var dataW = Math.floor(((params.p_h - params.leanF_p_h) * 100) / ((Number(params.b_l_t_r_pF) / 12) * 100));
    var dataW = Math.floor(((12 * ((params.p_h - straightRoofval) - params.leanF_p_h)) / params.b_l_t_r_pF))
    //console.log(dataW,maxWidth,"newDataW")
    var newDataW = (parseInt(dataW) > maxWidth) ? maxWidth : parseInt(dataW);

    for (let i = minWidth; i <= newDataW; i++) {
        if ((i - minWidth) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_width === 0) {
                if(params.m_s_n==10 && (params.leanF_p_w!=14 && params.leanF_p_w!=16))
                {
                    if(i==14 ||i== 16  )
                    {
                        continue;
                    }
                }
                LeftWidthoptions[0].options.push({
                    label: i,
                    value: i
                });
        } else {
                if(params.m_s_n==10 && (params.leanF_p_w!=14 && params.leanF_p_w!=16))
                {
                    if(i==14 ||i== 16  )
                    {
                        continue;
                    }
                }
                LeftWidthoptions[1].options.push({
                    label: i,
                    value: i
                });
        }
    }
    const_var.dimensionsLeanLWF = LeftWidthoptions;
    if (params.leanF_p_w > newDataW) {
        params.leanF_p_w = newDataW;
    }
    if (params.add_front_lean == false) {
        if (const_var.dimensionsLeanLHF.length == 0 ) const_var.dimensionsLeanLHF[minHeight] = minHeight;
        params.leanF_p_d = params.p_w;
        params.leanF_p_h = const_var.b_m_i_hlean;
        params.leanF_p_w = 12;
        if (const_var.dimensionsLeanLWF.length > 0 && const_var.dimensionsLeanLWF[0].options.length==0 && const_var.dimensionsLeanLWF[1].options.length==0){
            const_var.dimensionsLeanLWF[0].options.push({ label: minWidth, value: minWidth});
            params.leanF_p_w = minWidth; 
        } 
    }

    if (Array.isArray(const_var.dimensionsLeanLWF)) {
        const_var.dimensionsLeanLWF = const_var.dimensionsLeanLWF.filter((s) => {
            if (s.label === "Custom" && s.options.length === 0) {
                return false;
            }
            return true;
        });
    }
}
function updateTemplateWidthB(state) {
    if (params.leanB_p_d > params.p_w) {
        const_var.lengthData.backLean.previousLength = params.leanB_p_d;
        params.leanB_p_d = params.p_w;
        const_var.lengthData.backLean.length = params.leanB_p_d;
        // params.leanB_p_d = params.lean_p_d = params.leanR_p_d = params.p_d;
        // if (params.add_storage_check_back == true && params.add_back_lean == true) {
        //     params.add_storage_front = const_var.DistanceArr[params.p_b_t][params.p_r_s] * 1;
        // }
        // if (params.add_storage_check_front == true && params.add_front_lean == true) {
        //     params.add_storage_back = const_var.DistanceArr[params.p_b_t][params.p_r_s] * 1;
        // }
    }

    const_var.dimensionsLeanLWB = [];
    const_var.dimensionsLeanLDB = [];
    const_var.dimensionsLeanLHB = [];
    const LeftLengthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];
    const LeftWidthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];
    let iVal = 12;
    let startLength = 0;
    let endLength = 0;
    let minWidth = 0;
    let maxWidth = 0;
    let maxHeight = 0;
    let minHeight = 0;
    // console.log(const_var.roof_style_Barn);
    let roofDatanew = const_var.roof_style_Barn;

    if(const_var.roof_style_Barn_with_centerbuilding[params.p_b_t]!=undefined) {
        roofDatanew = const_var.roof_style_Barn_with_centerbuilding[params.p_b_t];
    }
    roofDatanew.map((val, i) => {
        if (params.p_r_s == val.roof_id) {
            iVal = val.min_width;
            startLength = val.start_length;
            endLength = val.building_max_length; // val.end_length;
            minWidth = val.min_width;
            maxWidth = val.max_width;
            maxHeight = val.max_height;
            minHeight = val.min_height;
            const_var.leanDimension = val;
            const_var.b_m_i_hlean = val.min_height
            // console.log(const_var.leanDimension ,"const_var.leanDimension");

        }
    })
    if (params.p_w < minWidth) {
        iVal = params.p_w;
        if (iVal <= params.p_w) {
            const_var.dimensionsLeanLDB[iVal] = iVal;
        }
    }
    const newDataF = params.p_w <= maxWidth ? params.p_w : maxWidth;

    for (let i = iVal; i <= params.p_w; i++) {
        if ((i - iVal) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_length === 0) {
            LeftLengthoptions[0].options.push({
                label: i,
                value: i
            });
        } else {
            LeftLengthoptions[1].options.push({
                label: i,
                value: i
            });
        }
    }
    const_var.dimensionsLeanLDB = LeftLengthoptions;

    let straightRoofval = (params.p_r_p == params.b_l_t_r_pB && !params.singleSlope && params.p_r_s != 1) ? 0 : 1
    var dataH = Math.floor(params.p_h - ((params.leanB_p_w * Number(params.b_l_t_r_pB)) / 12) - straightRoofval);
    var newDataH = (parseInt(dataH) > maxHeight) ? maxHeight : parseInt(dataH);
    for (var i = minHeight; i <= newDataH; i++) {
        const_var.dimensionsLeanLHB[i] = i;
    }
    if (params.leanB_p_h > dataH) {
        params.leanB_p_h = dataH < minHeight ? minHeight : dataH;
        cuBuilding.UpdateBackLean(); 
    }

    // var dataW = Math.floor(((params.p_h - params.leanB_p_h) * 100) / ((Number(params.b_l_t_r_pB) / 12) * 100));   // commented this condition to restrict the leanto to make straight roof in the case of defferent roof pitches 
    var dataW = Math.floor(((12 * ((params.p_h - straightRoofval) - params.leanB_p_h)) / params.b_l_t_r_pB))
    //console.log(dataW,maxWidth,"newDataW")
    var newDataW = (parseInt(dataW) > maxWidth) ? maxWidth : parseInt(dataW);

    for (let i = minWidth; i <= newDataW; i++) {
        if ((i - minWidth) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_width === 0) {
                if(params.m_s_n==10 && (params.leanB_p_w!=14 && params.leanB_p_w!=16))
                {
                    if(i==14 ||i== 16  )
                    {
                        continue;
                    }
                }
                LeftWidthoptions[0].options.push({
                    label: i,
                    value: i
                });
        } else {
                if(params.m_s_n==10 && (params.leanB_p_w!=14 && params.leanB_p_w!=16))
                {
                    if(i==14 ||i== 16  )
                    {
                        continue;
                    }
                }
                LeftWidthoptions[1].options.push({
                    label: i,
                    value: i
                });
        }
    }
    const_var.dimensionsLeanLWB = LeftWidthoptions;
    if (params.leanB_p_w > newDataW) {
        params.leanB_p_w = newDataW;
    }
    if (params.add_back_lean == false) {
        if (const_var.dimensionsLeanLHB.length == 0 ) const_var.dimensionsLeanLHB[minHeight] = minHeight;
        params.leanB_p_d = params.p_w;
        params.leanB_p_h = const_var.b_m_i_hlean;
        params.leanB_p_w = 12;
        if (const_var.dimensionsLeanLWB.length > 0 && const_var.dimensionsLeanLWB[0].options.length==0 && const_var.dimensionsLeanLWB[1].options.length==0){
            const_var.dimensionsLeanLWB[0].options.push({ label: minWidth, value: minWidth});
            params.leanB_p_w = minWidth; 
        } 
    }

    if (Array.isArray(const_var.dimensionsLeanLWB)) {
        const_var.dimensionsLeanLWB = const_var.dimensionsLeanLWB.filter((s) => {
            if (s.label === "Custom" && s.options.length === 0) {
                return false;
            }
            return true;
        });
    }
}
const updateTemplateWidthR = () => {
    if (params.p_d < params.leanR_p_d) {
        const_var.lengthData.rightLean.previousLength = params.leanR_p_d;
        params.leanR_p_d = params.p_d;
         const_var.lengthData.rightLean.length = params.leanR_p_d;
        const_var.UpdatedPriceData.connection_fee_side_changed = true;
        // if (params.add_storage_check_right == true && params.add_left_lean == true) {
        //     params.add_storage_right = const_var.DistanceArr[params.p_b_t][params.p_r_s] * 1;
        // }
        // if (params.add_storage_check == true && params.add_right_lean == true) {
        //     params.add_storage = const_var.DistanceArr[params.p_b_t][params.p_r_s] * 1;
        // }
    }
    const RightLengthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];
    const RightWidthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];
    const_var.dimensionsLeanLWR = [];
    const_var.dimensionsLeanLDR = [];
    const_var.dimensionsLeanLHR = [];
    let iVal = 21;
    let startLength = 0;
    let endLength = 0;
    let maxWidth = 0;
    let minWidth = 0;
    let maxHeight = 0;
    let minHeight = 0;
    let roofDatanew = const_var.roof_style_Barn;

    if(const_var.roof_style_Barn_with_centerbuilding[params.p_b_t]!=undefined) {
        roofDatanew = const_var.roof_style_Barn_with_centerbuilding[params.p_b_t];
    }
    roofDatanew.map((val, i) => {
        if (params.p_r_s == val.roof_id) {
            iVal = val.start_length;
            startLength = val.start_length;
            endLength = val.building_max_length; // val.end_length;
            maxWidth = val.max_width;
            minWidth = val.min_width;
            maxHeight = val.max_height;
            minHeight = val.min_height;
            const_var.b_m_i_hlean = val.min_height

            const_var.leanDimension = val;
        }
    })
    if (params.p_d < startLength) {
        iVal = params.p_d;
        if (iVal <= params.p_d) {
            const_var.dimensionsLeanLDR[iVal] = iVal;
        }
    }
    const newDataL = params.p_d <= endLength ? params.p_d : endLength;

    if ( params.p_d < startLength) {
        startLength = params.p_d
    }
    for (let i = Math.round(startLength / 2); i <= newDataL; i++) {
        if ((i - startLength) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_length === 0) {
            RightLengthoptions[0].options.push({
                label: i,
                value: i
            });
        } else {
            RightLengthoptions[1].options.push({
                label: i,
                value: i
            });
        }
    }
    const_var.dimensionsLeanLDR = RightLengthoptions;

    let straightRoofval = (params.p_r_p == params.b_l_t_r_pR && !params.singleSlope && params.p_r_s != 1) ? 0 : 1
    var dataH = Math.floor(params.p_h - ((params.leanR_p_w * Number(params.b_l_t_r_pR)) / 12) - straightRoofval);
    var newDataH = (parseInt(dataH) >= maxHeight) ? maxHeight : parseInt(dataH);
    // console.log(newDataH,maxHeight , parseInt(dataH),"maxHeight : parseInt(dataH)");
    for (var i = minHeight; i <= newDataH; i++) {
        const_var.dimensionsLeanLHR[i] = i;
    }

    if (params.leanR_p_h > dataH) {
        params.leanR_p_h = dataH < minHeight ? minHeight : dataH;
        cuBuilding.UpdateRightLean();
    }

    if (params.leanR_p_d > endLength) {
        params.leanR_p_d = endLength;
    }

    // var dataW = Math.floor(((params.p_h - params.leanR_p_h) * 100) / ((Number(params.b_l_t_r_pR) / 12) * 100));  // commented this condition to restrict the leanto to make straight roof in the case of defferent roof pitches 
    var dataW = Math.floor(((12 * ((params.p_h - straightRoofval) - params.leanR_p_h)) / params.b_l_t_r_pR))
    var newDataW = (parseInt(dataW) >= maxWidth) ? maxWidth : parseInt(dataW);

    for (let i = minWidth; i <= newDataW; i++) {
        if ((i - minWidth) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_width === 0) {
                if(params.m_s_n==10 && (params.leanR_p_w!=14 && params.leanR_p_w!=16))
                {
                    if(i==14 ||i== 16  )
                    {
                        continue;
                    }
                }
                RightWidthoptions[0].options.push({
                    label: i,
                    value: i
                });
        } else {
                if(params.m_s_n==10 && (params.leanR_p_w!=14 && params.leanR_p_w!=16))
                {
                    if(i==14 ||i== 16  )
                    {
                        continue;
                    }
                }
                RightWidthoptions[1].options.push({
                    label: i,
                    value: i
                });
        }
    }
    const_var.dimensionsLeanLWR = RightWidthoptions;

    if (params.leanR_p_w > newDataW) {
        params.leanR_p_w = newDataW;
    }
    if (!params.add_right_lean) {
        if (const_var.dimensionsLeanLHR.length == 0 ) const_var.dimensionsLeanLHR[minHeight] = minHeight;
        params.leanR_p_d = params.p_d;
        params.leanR_p_h = const_var.b_m_i_hlean;
        params.leanR_p_w = 12;
        if (const_var.dimensionsLeanLWR.length > 0 && const_var.dimensionsLeanLWR[0].options.length==0 && const_var.dimensionsLeanLWR[1].options.length==0){
            const_var.dimensionsLeanLWR[0].options.push({ label: minWidth, value: minWidth});
            params.leanR_p_w = minWidth; 
        } 
    }
    
    if (Array.isArray(const_var.dimensionsLeanLWR)) {
        const_var.dimensionsLeanLWR = const_var.dimensionsLeanLWR.filter((s) => {
            if (s.label === "Custom" && s.options.length === 0) {
                return false;
            }
            return true;
        });
    }
}

function updateTemplateWidthL(state) {
        if (params.p_d < params.lean_p_d) {
        const_var.lengthData.leftLean.previousLength = params.lean_p_d;
        params.lean_p_d = params.p_d;
        const_var.lengthData.leftLean.length = params.lean_p_d;    
        
        const_var.UpdatedPriceData.connection_fee_side_changed = true;
        // if (params.add_storage_check_right == true && params.add_left_lean == true) {
        //     params.add_storage_right = const_var.DistanceArr[params.p_b_t][params.p_r_s] * 1;
        // }
        // if (params.add_storage_check == true && params.add_right_lean == true) {
        //     params.add_storage = const_var.DistanceArr[params.p_b_t][params.p_r_s] * 1;
        // }
    }

    const LeftLengthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];
    const LeftWidthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];

    const_var.dimensionsLeanLW = [];
    const_var.dimensionsLeanLD = [];
    const_var.dimensionsLeanLH = [];
    const_var.leanDimension = {};

    let iVal = 21;
    let startLength = 0;
    let endLength = 0;
    let maxWidth = 0;
    let minWidth = 0;
    let maxHeight = 0;
    let minHeight = 0;
    let roofDatanew = const_var.roof_style_Barn;

    if(const_var.roof_style_Barn_with_centerbuilding[params.p_b_t]!=undefined) {
        roofDatanew = const_var.roof_style_Barn_with_centerbuilding[params.p_b_t];
    }
    roofDatanew.map((val, i) => {
        if (params.p_r_s == val.roof_id) {
            iVal = val.start_length;
            startLength = val.start_length;
            endLength = val.building_max_length; // val.end_length;
            maxWidth = val.max_width;
            minWidth = val.min_width;
            maxHeight = val.max_height;
            minHeight = val.min_height;
            const_var.b_m_i_hlean = val.min_height;
            const_var.leanDimension = val;
        }
    })
    if (params.p_d < startLength) {
        iVal = params.p_d;
        if (iVal <= params.p_d) {
            const_var.dimensionsLeanLD[iVal] = iVal;
        }
    }
    const newDataL = params.p_d <= endLength ? params.p_d : endLength;

    if ( params.p_d < startLength ) {
        startLength = params.p_d
    }
    for (let i = Math.round(startLength / 2); i <= newDataL; i++) {
        if ((i - startLength) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_length === 0) {
            LeftLengthoptions[0].options.push({
                label: i,
                value: i
            });
        } else {
            LeftLengthoptions[1].options.push({
                label: i,
                value: i
            });
        }
    }
    const_var.dimensionsLeanLD = LeftLengthoptions;

    let straightRoofval = (params.p_r_p == params.b_l_t_r_p && !params.singleSlope && params.p_r_s != 1) ? 0 : 1
    var dataH = Math.floor(params.p_h - ((params.lean_p_w * Number(params.b_l_t_r_p)) / 12) - straightRoofval);
    var newDataH = (parseInt(dataH) > maxHeight) ? maxHeight : parseInt(dataH);
    for (var i = minHeight; i <= newDataH; i++) {
        const_var.dimensionsLeanLH[i] = i;
    }
    if (params.lean_p_h > dataH) {
        params.lean_p_h = dataH < minHeight ? minHeight : dataH;
        cuBuilding.UpdateLeftLean();
    }
    if (params.lean_p_d > endLength) {
        params.lean_p_d = endLength;
    }
    // var dataW = Math.floor(((params.p_h - params.lean_p_h) * 100) / ((Number(params.b_l_t_r_p) / 12) * 100));   // commented this condition to restrict the leanto to make straight roof in the case of defferent roof pitches 
    var dataW = Math.floor(((12 * ((params.p_h - straightRoofval) - params.lean_p_h)) / params.b_l_t_r_p))
    // console.log(dataW,maxWidth,"newDataW111")
    var newDataW = (parseInt(dataW) > maxWidth) ? maxWidth : parseInt(dataW);
    for (let i = minWidth; i <= newDataW; i++) {
        if ((i - minWidth) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_width === 0) {
                if(params.m_s_n==10 && (params.lean_p_w!=14 && params.lean_p_w!=16))
                {
                    if(i==14 ||i== 16  )
                    {
                        continue;
                    }
                }
                LeftWidthoptions[0].options.push({
                    label: i,
                    value: i
                });
        } else {
                if(params.m_s_n==10 && (params.lean_p_w!=14 && params.lean_p_w!=16))
                {
                    if(i==14 ||i== 16  )
                    {
                        continue;
                    }
                }
                LeftWidthoptions[1].options.push({
                    label: i,
                    value: i
                });
        }
    }
    const_var.dimensionsLeanLW = LeftWidthoptions;
    if (params.lean_p_w > newDataW) {
        params.lean_p_w = newDataW;
    }
    if (!params.add_left_lean) {
        if (const_var.dimensionsLeanLH.length == 0 ) const_var.dimensionsLeanLH[minHeight] = minHeight;
        params.lean_p_d = params.p_d;
        params.lean_p_h = const_var.b_m_i_hlean;
        params.lean_p_w = 12;
        if (const_var.dimensionsLeanLW.length > 0 && const_var.dimensionsLeanLW[0].options.length==0 && const_var.dimensionsLeanLW[1].options.length==0){
            const_var.dimensionsLeanLW[0].options.push({ label: minWidth, value: minWidth});
            params.lean_p_w = minWidth; 
        } 
    }

    if (Array.isArray(const_var.dimensionsLeanLW)) {
        const_var.dimensionsLeanLW = const_var.dimensionsLeanLW.filter((s) => {
            if (s.label === "Custom" && s.options.length === 0) {
                return false;
            }
            return true;
        });
    }
}

const reSelExtEle = (state) => {

    let chkEndJtrim = (const_var.a_p_d_a.jtrim?.filter(data=>data.type=="end"))?.length>0?true:false;
    let chkSideJtrim = (const_var.a_p_d_a.jtrim?.filter(data=>data.type=="side"))?.length>0?true:false;

    if(!state.params.p_j_t_end || !chkEndJtrim) state.params.p_j_t_end = false
    if(!state.params.p_j_t || !chkSideJtrim) state.params.p_j_t = false

    state.params.p_t_u = state.params.p_e_b = state.params.p_e_t = state.params.p_b_p_feetVal =  state.params.p_a_ch = state.params.p_m_h_a = state.params.p_r_a = params.p_p_b = 0;
    state.params.risk_cost = state.params.cert_pac_cost = state.params.p_b_p = params.p_g_c = params.p_o_p = params.p_s_c_b = params.p_e_c_b = false;
    state.params.p_b_p_feet = "Select";
    state.additionalFeaturesArray = [];
    state.additionalFeaturesArrayWithPosition = [];
}
const stateManufacturerChange = (state, value, key) => {
    state.const_var.UpdatedPriceData = { 'roof_style_price_changed': true,'lifttype_price_changed':true,'cupola_price_changed':true, 'width_price_changed': true, 'length_price_changed': true, 'height_price_changed': true, 'left_wall_price_changed': true, 'right_wall_price_changed': true, "right_wall_cut_panel_price_changed": true, "left_wall_cut_panel_price_changed": true, 'front_wall_price_changed': true, 'back_wall_price_changed': true, "certificate_price_changed": true, "common_width_changed": true, "common_length_changed": true, "common_height_changed": true, "utility_price_changed": true, "front_utility_price_changed": true, "front_utility_price_changed": true, "wainscot_price_changed": true, "connection_fee_end_changed": true, "connection_fee_side_changed": true, "roof_pitch_price_changed": true, 'left_lean_roof_style_price_changed': true, 'left_lean_width_price_changed': true, 'left_lean_length_price_changed': true, 'left_lean_height_price_changed': true, 'left_lean_left_wall_price_changed': true, 'left_lean_front_wall_price_changed': true, 'left_lean_back_wall_price_changed': true, "left_lean_certificate_price_changed": true, "left_lean_utility_price_changed": true, "left_lean_roof_pitch_price_changed": true, 'right_lean_roof_style_price_changed': true, 'right_lean_width_price_changed': true, 'right_lean_length_price_changed': true, 'right_lean_height_price_changed': true, 'right_lean_right_wall_price_changed': true, 'right_lean_front_wall_price_changed': true, 'right_lean_back_wall_price_changed': true, "right_lean_certificate_price_changed": true, "right_lean_utility_price_changed": true, "right_lean_roof_pitch_price_changed": true, 'front_lean_roof_style_price_changed': true, 'front_lean_width_price_changed': true, 'front_lean_length_price_changed': true, 'front_lean_height_price_changed': true, 'front_lean_left_wall_price_changed': true, 'front_lean_front_wall_price_changed': true, 'front_lean_back_wall_price_changed': true, "front_lean_certificate_price_changed": true, "front_lean_utility_price_changed": true, "front_lean_roof_pitch_price_changed": true, 'back_lean_roof_style_price_changed': true, 'back_lean_width_price_changed': true, 'back_lean_length_price_changed': true, 'back_lean_height_price_changed': true, 'back_lean_left_wall_price_changed': true, 'back_lean_front_wall_price_changed': true, 'back_lean_back_wall_price_changed': true, "back_lean_certificate_price_changed": true, "back_lean_utility_price_changed": true, "back_lean_roof_pitch_price_changed": true, "color_price_changed":true,"left_front_wrap_connection_fee_changed":true,"right_front_wrap_connection_fee_changed":true,"right_back_wrap_connection_fee_changed":true,"left_back_wrap_connection_fee_changed":true,"front_lean_insulation_price_changed":true,"left_lean_insulation_price_changed":true, "right_lean_insulation_price_changed":true,"back_lean_insulation_price_changed":true,"wall_color_price_changed" :true , "roof_color_price_changed" :true , "trim_color_price_changed" :true};
    params.o_v_h_n_g = false;
    params.o_v_h_n_g_e = false;

    if (key == "state") {
     
        state.params.p_s_n = parseInt(value);
        state.params.m_s_n = (const_var.loginSession != false) ? state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n][0].id : state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n].id;
        state.params.p_r_o = false;
        state.params.p_f_i = false;
        state.params.p_c_i = false;
        const_var.insulationPriceJson= [];
        const_var.insulationJsonLeanTo  = [];
        const_var.insulationArrayForLeantoLeft= [];
        const_var.insulationArrayForLeantoFront= [];
        const_var.insulationArrayForLeantoBack= [];
        const_var.insulationArrayForLeantoRight= [];
    } else {
        state.params.m_s_n = parseInt(value);
        state.params.p_r_o = false;
        state.params.p_f_i = false;
        state.params.p_c_i = false;
    const_var.insulationPriceJson= [];
    const_var.insulationJsonLeanTo  = [];
    const_var.insulationArrayForLeantoLeft= [];
    const_var.insulationArrayForLeantoFront= [];
    const_var.insulationArrayForLeantoBack= [];
    const_var.insulationArrayForLeantoRight= [];
    }

    if(params.p_s_n!='' && params.m_s_n!='' && const_var.crmSetting.is_zipcode_screen != undefined && const_var.crmSetting.is_zipcode_screen == true)
    {
        let manuID = state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n].length > 1 ? state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n].filter(obj => obj.id == state.params.m_s_n)[0] : state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n];

        const_var.isZipcodeIncluded = manuID.is_zipcode_included!=undefined ? (manuID.is_zipcode_included == 0 ? false : true) : true;
    }
    const_var.stateManufacturerAcordingAPIDiscount['commissions'] = [];
    const_var.stateManufacturerAcordingAPIDiscount['surcharge'] = [];
    const_var.stateManufacturerAcordingAPIDiscount['surchargeArray'] = [];
    const_var.stateManufacturerAcordingAPIDiscount['discount'] = [];
    const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'] = [];
    const_var.stateManufacturerAcordingAPIDiscount['manuName'] = [];
    
    if (const_var.loginSession != false) {
        const_var.stateManufacturerAcordingAPI[params.p_s_n].map((val, i) => {
            const_var.stateManufacturerAcordingAPIDiscount['manuName'][val.id] = val.name;
            if (val.commissions.length > 0) {
                const_var.stateManufacturerAcordingAPIDiscount['commissions'][val.id] = val.commissions;
            } if (val.discounts.length > 0) {
                const_var.stateManufacturerAcordingAPIDiscount['discount'][val.id] = val.discounts;
                //const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][val.id] = val.manufacture_discount;
            } if (val.surcharge != undefined && Object.keys(val.surcharge).length > 0) {
                if (val.surcharge.taxable == undefined) {
                    val.surcharge.taxable = 0;
                }
                const_var.stateManufacturerAcordingAPIDiscount['surcharge'][val.id] = val.surcharge;
                const_var.stateManufacturerAcordingAPIDiscount['surchargeArray'][val.id] = val.surcharge;
            }
            if (params.m_s_n == val.id) {
                const_var.order_extra_items['document_fee'] = (val.document_fee != null) ? val.document_fee : 0;
                const_var.order_extra_items['order_processing_fee'] = (val.order_processing_fee != null) ? val.order_processing_fee : 0;
                const_var.order_extra_items['order_permit_fee'] = (val.order_permit_fee!= null) ? val.order_permit_fee: 0
                const_var.exact_order_permit_fee = (val.order_permit_fee!= null) ? val.order_permit_fee: 0
                if(const_var.order_extra_items['order_permit_fee']!='' && const_var.order_extra_items['order_permit_fee']!=0){
                    const_var.order_extra_items['permit'] = "yes"
                 }
                 if((params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9)) && const_var.order_extra_items['permit']== "yes" && val.labor_fee != null){

                    if(const_var.crmSetting.is_module_name == "inventory" && params.m_s_n == 3) {
                        const_var.order_extra_items['extra_labour'] =  parseFloat(val.labor_fee);
                    } else {
                        const_var.order_extra_items['extra_labour'] = parseFloat(const_var.order_extra_items['order_permit_fee']) +  parseFloat(val.labor_fee);
                    }              
                    const_var.order_extra_items['order_permit_fee'] = 0;
                   }else{
                     const_var.order_extra_items['extra_labour'] = (val.labor_fee != null) ? val.labor_fee : 0;
                }

            }
            if (val.manufacture_discount!=undefined && val.manufacture_discount.length > 0) {
                //const_var.stateManufacturerAcordingAPIDiscount['discount'][val.id] = val.discounts;
                const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][val.id] = val.manufacture_discount;
            }else{
                if (val.discounts.length > 0) {
                    const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][val.id] = [];
                    const_var.stateManufacturerAcordingAPIDiscount['discount'][val.id].map((val1, ii) => {
                        if(val1.manufacturer_discount!=undefined)
                        {
                            const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][val.id].push({'amount':val1.manufacturer_discount,'amount_type':val1.manufacturer_discount_in,'price_from':val1.from,'price_to':val1.to})
                        }
                    })
                }
            }

        })
    } else {
       
        const_var.stateManufacturerAcordingAPIDiscount['commissions'][params.m_s_n] = const_var.stateManufacturerAcordingAPI[params.p_s_n].commissions;
        const_var.stateManufacturerAcordingAPIDiscount['discount'][params.m_s_n] = const_var.stateManufacturerAcordingAPI[params.p_s_n].discounts;
        if(const_var.stateManufacturerAcordingAPI[params.p_s_n].manufacture_discount!=undefined)
        {
            const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][params.m_s_n] = const_var.stateManufacturerAcordingAPI[params.p_s_n].manufacture_discount;
        }else{
            if (const_var.stateManufacturerAcordingAPIDiscount['discount'][params.m_s_n]!=undefined && const_var.stateManufacturerAcordingAPIDiscount['discount'][params.m_s_n].length > 0) {
                    const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][params.m_s_n] = [];
                    const_var.stateManufacturerAcordingAPIDiscount['discount'][params.m_s_n].map((val1, ii) => {
                        if(val1.manufacturer_discount!=undefined)
                        {
                            const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][params.m_s_n].push({'amount':val1.manufacturer_discount,'amount_type':val1.manufacturer_discount_in,'price_from':val1.from,'price_to':val1.to})
                        }
  
                    })
                }
        }
        
        const_var.stateManufacturerAcordingAPIDiscount['surcharge'][params.m_s_n] = const_var.stateManufacturerAcordingAPI[params.p_s_n].surcharge;
        const_var.stateManufacturerAcordingAPIDiscount['surchargeArray'][params.m_s_n] = const_var.stateManufacturerAcordingAPI[params.p_s_n].surcharge;
        if (const_var.stateManufacturerAcordingAPIDiscount['surcharge'] != undefined && const_var.stateManufacturerAcordingAPIDiscount['surcharge'][params.m_s_n] != undefined && Object.keys(const_var.stateManufacturerAcordingAPIDiscount['surcharge'][params.m_s_n]).length > 0) {
            if (const_var.stateManufacturerAcordingAPIDiscount['surcharge'][params.m_s_n].taxable == undefined) {
                const_var.stateManufacturerAcordingAPIDiscount['surcharge'][params.m_s_n].taxable = 0;
            }
        }
        const_var.stateManufacturerAcordingAPIDiscount['manuName'][params.m_s_n] = const_var.stateManufacturerAcordingAPI[params.p_s_n].name;
        const_var.order_extra_items['document_fee'] = (const_var.stateManufacturerAcordingAPI[params.p_s_n].document_fee != null && const_var.stateManufacturerAcordingAPI[params.p_s_n].is_document_show_in_3d==true) ? const_var.stateManufacturerAcordingAPI[params.p_s_n].document_fee : 0;
        const_var.order_extra_items['order_processing_fee'] = (const_var.stateManufacturerAcordingAPI[params.p_s_n].order_processing_fee != null && const_var.stateManufacturerAcordingAPI[params.p_s_n].is_processing_show_in_3d==true) ? const_var.stateManufacturerAcordingAPI[params.p_s_n].order_processing_fee : 0;
        const_var.order_extra_items['order_permit_fee'] = (const_var.stateManufacturerAcordingAPI[params.p_s_n].order_permit_fee!= null) ? const_var.stateManufacturerAcordingAPI[params.p_s_n].order_permit_fee: 0
        const_var.exact_order_permit_fee = (const_var.stateManufacturerAcordingAPI[params.p_s_n].order_permit_fee!= null) ? const_var.stateManufacturerAcordingAPI[params.p_s_n].order_permit_fee: 0
        if(const_var.order_extra_items['order_permit_fee']!='' && const_var.order_extra_items['order_permit_fee']!=0){
            const_var.order_extra_items['permit'] = "yes"
        }
        if(const_var.stateManufacturerAcordingAPI[params.p_s_n].is_permit_show_in_3d==false){
            const_var.order_extra_items['order_permit_fee'] = 0;
            const_var.exact_order_permit_fee = 0;
            const_var.order_extra_items['permit'] = "no";
        }
       
        if((params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9)) && const_var.order_extra_items['permit']== "yes" && const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee != null){

            if(const_var.crmSetting.is_module_name == "inventory") {
                const_var.order_extra_items['extra_labour'] = parseFloat(const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee) 
            } else {
                const_var.order_extra_items['extra_labour'] = parseFloat(const_var.order_extra_items['order_permit_fee'])+parseFloat(const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee)           
            }
        }else{
             const_var.order_extra_items['extra_labour'] = (const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee != null) ? const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee : 0;
        }
        if(const_var.stateManufacturerAcordingAPI[params.p_s_n].is_labor_show_in_3d==false){
            const_var.order_extra_items['extra_labour'] = 0
        }
        if((params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9)) && const_var.stateManufacturerAcordingAPI[params.p_s_n].is_labor_show_in_3d==false && const_var.stateManufacturerAcordingAPI[params.p_s_n].is_permit_show_in_3d==true){
            const_var.order_extra_items['extra_labour'] = const_var.stateManufacturerAcordingAPI[params.p_s_n].order_permit_fee;
            const_var.exact_order_permit_fee = const_var.stateManufacturerAcordingAPI[params.p_s_n].order_permit_fee;
            const_var.order_extra_items['order_permit_fee'] = 0
        }
     

    }


}
const makeDimensionArray = (state) => {
    state.const_var.buildingWidthArray = [];
    state.const_var.buildingLengthArray = [];
    state.const_var.buildingHeightArray = [];
    state.const_var.buildingWidthArrayCust = [];
    state.const_var.buildingLengthArrayCust = [];
    let b_m_i_h = 0;
    // state.const_var.b_m_i_hlean = b_m_i_h;
    const Widthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];
    let chkFixedWidthFlag = false;
    let chkFixedWidthFlagNew = false

    state.const_var.roof_style.map((val, i) => {
        let widthRange;

        if (state.params.p_r_s == val.roof_id) {
            let minHeightValue = params.singleSlope == true ? val.start_height : val.min_height

            // state.const_var.isForStandardBuilding = (state.params.m_s_n == 3 || state.params.m_s_n == 153 || state.params.m_s_n == 9) && const_var.checkmoreCustomizeFlag!=true && (state.const_var.crmSetting.is_Edit == false || (state.const_var.crmSetting.is_Edit == true && const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.main_created_at!=undefined && const_var.editAPIDataByResponse.data.main_created_at>="2024-06-18") && minHeightValue != undefined && (parseInt(minHeightValue) <= parseInt(state.params.p_w))) ? true : false
            if((state.params.m_s_n == 3 || state.params.m_s_n == 153 || state.params.m_s_n == 9 || state.params.m_s_n == 33) && const_var.checkmoreCustomizeFlag!=true && !const_var.b_o_J_1[params.p_b_t].includes("Free Standing") && !const_var.b_o_J_1[params.p_b_t].includes("RV Covers")){
                if(state.const_var.crmSetting.is_Edit == false){
                    state.const_var.isForStandardBuilding = true
                }
                if(state.const_var.crmSetting.is_Edit == true){
                    if(const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.request_data !=undefined && const_var.editAPIDataByResponse.data.request_data.building !=undefined && const_var.editAPIDataByResponse.data.request_data.building.create_at_date !=undefined){
                        if( ((state.params.m_s_n != 33 && const_var.editAPIDataByResponse.data.request_data.building.create_at_date>="2024-07-01") || (state.params.m_s_n == 33 && const_var.editAPIDataByResponse.data.request_data.building.create_at_date>="2024-07-09")) && minHeightValue != undefined && (parseInt(minHeightValue) <= parseInt(state.params.p_w))){
                            state.const_var.isForStandardBuilding = true
                        }
                        else{
                            state.const_var.isForStandardBuilding = false
                        }
                    }
                    else if( const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.main_created_at!=undefined && ((state.params.m_s_n != 33 && const_var.editAPIDataByResponse.data.main_created_at>="2024-07-01") || (state.params.m_s_n == 33 && const_var.editAPIDataByResponse.data.main_created_at>="2024-07-09")) && minHeightValue != undefined && (parseInt(minHeightValue) <= parseInt(state.params.p_w))){
                        state.const_var.isForStandardBuilding = true
                    }
                    else{
                        if(const_var.editAPIDataByResponse?.data?.main_created_at == undefined && const_var.editAPIDataByResponse?.data?.request_data?.building?.create_at_date == undefined){
                            state.const_var.isForStandardBuilding = true
                        }
                        else{
                            state.const_var.isForStandardBuilding = false
                        }
                    }
                }

                 if(const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.request_data !=undefined && const_var.editAPIDataByResponse.data.request_data.building !=undefined && const_var.editAPIDataByResponse.data.request_data.building.manufacturer == state.params.m_s_n && const_var.editAPIDataByResponse.data.request_data.building.state == state.params.p_s_n && const_var.editAPIDataByResponse.data.request_data.building.create_at_date !=undefined){
                        if( ((state.params.m_s_n != 33 && const_var.editAPIDataByResponse.data.request_data.building.create_at_date>="2024-07-01") || (state.params.m_s_n == 33 && const_var.editAPIDataByResponse.data.request_data.building.create_at_date>="2024-07-09")) && minHeightValue != undefined && (parseInt(minHeightValue) <= parseInt(state.params.p_w))){
                            state.const_var.isForStandardBuilding = true
                        }
                        else{
                            state.const_var.isForStandardBuilding = false
                        }
                    }else{  
                        if(const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.request_data !=undefined && const_var.editAPIDataByResponse.data.request_data.building !=undefined && const_var.editAPIDataByResponse.data.main_created_at!=undefined && ((state.params.m_s_n != 33 && const_var.editAPIDataByResponse.data.main_created_at<"2024-07-01") || (state.params.m_s_n == 33 && const_var.editAPIDataByResponse.data.main_created_at<"2024-07-09"))){
                            state.const_var.isForStandardBuilding = false;
                        }
                    }
                if(const_var.isForStandardBuilding == true && const_var.a_p_d_a != undefined && const_var.a_p_d_a.length > 0){
                    if(params.p_h && (parseFloat(params.p_h) > parseFloat(state.params.p_w)) && minHeightValue != undefined && (parseInt(minHeightValue) <= parseInt(state.params.p_w))){
                        changeBuildingDimension({val:state.params.p_w, str: 'h'});    
                    }
                }
            }
            if(const_var.b_o_J_1[params.p_b_t].includes("Free Standing") || const_var.b_o_J_1[params.p_b_t].includes("RV Covers")){
                state.const_var.isForStandardBuilding = false;
            }
            // let minStartWidthRange = state.const_var.isForStandardBuilding && params.p_b_t == 27 && val.min_start_width < val.start_height ? val.start_height : val.min_start_width
            let minStartWidthRange = val.min_start_width

            //----------to resolve the issue of fixed width of free standing building with only one width ---------//
            // if(val.min_width !== val.max_width && val.fixed_width!=undefined && val.fixed_width!=null)
            if(val.fixed_width!=undefined && val.fixed_width!=null)
            {
                let splitRecord = val.fixed_width.split(",");
                if(splitRecord.length>0)
                    {  
                        chkFixedWidthFlag = true;  
                        splitRecord.map((data,index)=>{
                            state.const_var.buildingWidthArray.push({ "value": data, "label": data });
                            state.const_var.buildingWidthArrayCust.push({ "value": data, "label": data });
                            //Widthoptions.push({ "value": data, "label": data });
                        })
                    }
                }else
                {
                if (minStartWidthRange != undefined) {
                    const_var.BuildingMinWidth[val.roof_id] = minStartWidthRange;
                widthRange = Array.apply(null, { length: val.max_width + 1 }).map(Number.call, Number).slice(minStartWidthRange).map((val, index) => {
                    if(params.m_s_n==10 && (params.p_w!=14 && params.p_w!=16))
                    {
                        if(val!=14 && val!= 16  )
                        {
                            state.const_var.buildingWidthArray.push({ "value": val, "label": val });
                            state.const_var.buildingWidthArrayCust.push({ "value": val, "label": val });
                        }
                    }else{
                        state.const_var.buildingWidthArray.push({ "value": val, "label": val });
                        state.const_var.buildingWidthArrayCust.push({ "value": val, "label": val });
                    }
                })
                for (let i = minStartWidthRange; i <= val.max_width; i++) {
                    if(params.m_s_n==10 && (params.p_w!=14 && params.p_w!=16))
                        {
                            if(i==14 ||i== 16  )
                            {
                                continue;
                            }
                        }
                        if ((i - minStartWidthRange) % val.distance_on_width === 0) {
                            Widthoptions[0].options.push({
                                label: i,
                                value: i
                            });
                        } else {
                            Widthoptions[1].options.push({
                                label: i,
                                value: i
                            });
                        }
                    
                }
            } else {
                const_var.BuildingMinWidth[val.roof_id] = val.min_width;
                widthRange = Array.apply(null, { length: val.max_width + 1 }).map(Number.call, Number).slice(val.min_width).map((val, index) => {
                        if(params.m_s_n==10 && (params.p_w!=14 && params.p_w!=16))
                        {
                            if(val!=14 && val!= 16  )
                            {
                                state.const_var.buildingWidthArray.push({ "value": val, "label": val });
                                state.const_var.buildingWidthArrayCust.push({ "value": val, "label": val });
                            }
                        }
                        else{
                            state.const_var.buildingWidthArray.push({ "value": val, "label": val });
                            state.const_var.buildingWidthArrayCust.push({ "value": val, "label": val });
                        }
                })
                for (let i = val.min_width; i <= val.max_width; i++) {
                    if(params.m_s_n==10 && (params.p_w!=14 && params.p_w!=16))
                    {
                        if(i==14 ||i== 16  )
                        {
                            continue;
                        }
                    }
                    if ((i - val.min_width) % val.distance_on_width === 0) {
                        Widthoptions[0].options.push({
                            label: i,
                            value: i
                        });
                    } else {
                        Widthoptions[1].options.push({
                            label: i,
                            value: i
                        });
                    }
                    
                }
            }
            }
        }
    })
    
    if(Widthoptions[1].options.length == 0){
        Widthoptions.splice(1,1)
    }

    state.const_var.buildingWidthArray = (chkFixedWidthFlag==false)?Widthoptions:state.const_var.buildingWidthArray;
    const Lengthoptions = [
        {
            label: 'Standard',
            options: []
        },
        {
            label: 'Custom',
            options: []
        }
    ];
    state.const_var.roof_style.map((val, i) => {
        let lengthRange;
        state.const_var.arrayendLengthRoof[val.roof_id] = val.building_max_length;
        if (state.params.p_r_s == val.roof_id) {
            lengthRange = Array.apply(null, { length: val.building_max_length + 1 }).map(Number.call, Number).slice(val.min_start_length).map((val, index) => {
                state.const_var.buildingLengthArray.push({ "value": val, "label": val });
                state.const_var.buildingLengthArrayCust.push({ "value": val, "label": val });
            })
            if (params.isBreezeway){
                // console.log( val.distance_on_length,"val.distance_on_length", const_var.DistanceArr[params.p_b_t][params.p_r_s]);
                for (let i = val.min_start_length; i <= val.building_max_length; i++) {
                    if ((i - val.min_start_length) % const_var.DistanceArr[params.p_b_t][params.p_r_s] === 0) {
                        Lengthoptions[0].options.push({
                            label: i,
                            value: i
                        });
                    }
                }
                
                let dropDownValues = Lengthoptions[0].options;
                let checkMatch = Lengthoptions[0].options.find(element => element.value == params.p_d);
            
                if(checkMatch == undefined){
                    let closest = dropDownValues.length > 0 && dropDownValues.reduce((a, b) => {
                      return Math.abs(b.value - params.p_d) < Math.abs(a.value - params.p_d) ? b : a;
                    });
                    params.p_d = closest.value;

                    if (params.checkeditName != true) {
                        let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
                        params.other_building_type_name = newVal;
                        if (const_var.post_data.building != undefined) {
                            const_var.post_data.building.other_building_type_name = params.other_building_type_name;
                            const_var.post_data.building.name = params.other_building_type_name;
                        }
                    }
                }


            }else{
                for (let i = val.min_start_length; i <= val.building_max_length; i++) {
                    if ((i - val.min_start_length) % val.distance_on_length === 0) {
                        Lengthoptions[0].options.push({
                            label: i,
                            value: i
                        });
                    } else {
                        Lengthoptions[1].options.push({
                            label: i,
                            value: i
                        });
                    }
                }
            }
        }


    })
    state.const_var.buildingLengthArray = Lengthoptions;
    state.const_var.roof_style.map((val, i) => {
        let heightRange;       
        if (state.params.p_r_s == val.roof_id) {
            let minHeightValue = params.singleSlope == true ? val.start_height : val.min_height

            // state.const_var.isForStandardBuilding = (state.params.m_s_n == 3 || state.params.m_s_n == 153 || state.params.m_s_n == 9) && const_var.checkmoreCustomizeFlag!=true && (state.const_var.crmSetting.is_Edit == false || (state.const_var.crmSetting.is_Edit == true && const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.main_created_at!=undefined && const_var.editAPIDataByResponse.data.main_created_at>="2024-06-18") && minHeightValue != undefined && (parseInt(minHeightValue) <= parseInt(state.params.p_w))) ? true : false
           
           
            if((state.params.m_s_n == 3 || state.params.m_s_n == 153 || state.params.m_s_n == 9 || state.params.m_s_n == 33) && const_var.checkmoreCustomizeFlag!=true && !const_var.b_o_J_1[params.p_b_t].includes("Free Standing") && !const_var.b_o_J_1[params.p_b_t].includes("RV Covers")){
                if(state.const_var.crmSetting.is_Edit == false){
                    state.const_var.isForStandardBuilding = true
                }
                if(state.const_var.crmSetting.is_Edit == true){
                    if(const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.request_data !=undefined && const_var.editAPIDataByResponse.data.request_data.building !=undefined && const_var.editAPIDataByResponse.data.request_data.building.create_at_date !=undefined){
                        if( ((state.params.m_s_n != 33 && const_var.editAPIDataByResponse.data.request_data.building.create_at_date>="2024-07-01") || (state.params.m_s_n == 33 && const_var.editAPIDataByResponse.data.request_data.building.create_at_date>="2024-07-09")) && minHeightValue != undefined && (parseInt(minHeightValue) <= parseInt(state.params.p_w))){
                            state.const_var.isForStandardBuilding = true
                        }
                        else{
                            state.const_var.isForStandardBuilding = false

                        }
                    }
                    else if( const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.main_created_at!=undefined && ((state.params.m_s_n != 33 && const_var.editAPIDataByResponse.data.main_created_at>="2024-07-01") || (state.params.m_s_n == 33 && const_var.editAPIDataByResponse.data.main_created_at>="2024-07-09")) && minHeightValue != undefined && (parseInt(minHeightValue) <= parseInt(state.params.p_w))){
                        state.const_var.isForStandardBuilding = true
                    }
                    else{
                       
                        if(const_var.editAPIDataByResponse?.data?.main_created_at == undefined && const_var.editAPIDataByResponse?.data?.request_data?.building?.create_at_date == undefined){
                            state.const_var.isForStandardBuilding = true
                        }
                        else{
                            state.const_var.isForStandardBuilding = false
                        }
                    }
                }
                if(const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.request_data !=undefined && const_var.editAPIDataByResponse.data.request_data.building !=undefined && const_var.editAPIDataByResponse.data.request_data !=undefined && const_var.editAPIDataByResponse.data.request_data.building !=undefined && const_var.editAPIDataByResponse.data.request_data.building.manufacturer == state.params.m_s_n && const_var.editAPIDataByResponse.data.request_data.building.state == state.params.p_s_n && const_var.editAPIDataByResponse.data.request_data.building.create_at_date !=undefined){
                        if( ((state.params.m_s_n != 33 && const_var.editAPIDataByResponse.data.request_data.building.create_at_date>="2024-07-01") || (state.params.m_s_n == 33 && const_var.editAPIDataByResponse.data.request_data.building.create_at_date>="2024-07-09")) && minHeightValue != undefined && (parseInt(minHeightValue) <= parseInt(state.params.p_w))){
                            state.const_var.isForStandardBuilding = true
                        }
                        else{
                            state.const_var.isForStandardBuilding = false
                        }
                    }else{
                        if(const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.request_data !=undefined && const_var.editAPIDataByResponse.data.request_data.building !=undefined && const_var.editAPIDataByResponse.data.main_created_at!=undefined && ((state.params.m_s_n != 33 && const_var.editAPIDataByResponse.data.main_created_at<"2024-07-01") || (state.params.m_s_n == 33 && const_var.editAPIDataByResponse.data.main_created_at<"2024-07-09"))){
                            state.const_var.isForStandardBuilding = false;
                        }
                    }
            }
            if(const_var.b_o_J_1[params.p_b_t].includes("Free Standing") || const_var.b_o_J_1[params.p_b_t].includes("RV Covers")){
                state.const_var.isForStandardBuilding = false;
            }
            if(state.const_var.isForStandardBuilding == true){
                state.params.lift_type = false 
            }
            if (state.params.p_b_t == "2") {
                if (state.params.p_r_s == "4" || state.params.p_r_s == "5") {
                    b_m_i_h = val.min_height + 5;
                    // state.const_var.b_m_i_hlean = b_m_i_h;
                } else {
                    b_m_i_h = val.min_height + 3;
                    // state.const_var.b_m_i_hlean = b_m_i_h;
                }
            } else {
                b_m_i_h = val.min_height;
                // state.const_var.b_m_i_hlean = (state.params.p_b_t=="5" || state.params.p_b_t=="6")?val.min_height-3:b_m_i_h;   
            }

            let maxHeight = val.max_height
            if(state.const_var.isForStandardBuilding == true && maxHeight > state.params.p_w && minHeightValue != undefined && (parseInt(minHeightValue) <= parseInt(state.params.p_w))){
                maxHeight = state.params.p_w
            }

            if (params.singleSlope == true) {
                if((val.min_height != maxHeight) && (const_var.c_m_a[params.p_b_t]!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length>0 && state.const_var.c_m_a[params.p_b_t].fixed_new_leg_width[0][params.p_w] !== undefined))
                {
                    let filterData = state.const_var.c_m_a[params.p_b_t].fixed_new_leg_width[0][params.p_w];
                    heightRange = Array.apply(null, { length: filterData.max_height + 1 }).map(Number.call, Number).slice(filterData.min_height).map((val, index) => {
                        state.const_var.buildingHeightArray.push({ "value": val, "label": (chkFixedWidthFlag==true)?val +" x "+ (filterData.min_smaller_height+index):val });                       
                    })                   
                    let chkHeight = state.const_var.buildingHeightArray.filter((data)=>data.value==params.p_h);
                    if(chkHeight.length==0){
                        params.p_h = state.const_var.buildingHeightArray[0].value;
                    }                    
                }else{
                 if(const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.request_data.building!==undefined && (!isNaN(const_var.editAPIDataByResponse.data.request_data.building?.height) || const_var.editAPIDataByResponse.data.request_data.building?.height.includes("x")== false)){
                    chkFixedWidthFlag= false
                 } 
                heightRange = Array.apply(null, { length: maxHeight + 1 }).map(Number.call, Number).slice(val.start_height).map((val, index) => {
                    /*Fir checking max Height not will cross the Max Height that are coming from API */
                    if( index > 0 && Math.round(val-params.p_r_p) >= b_m_i_h )
                     {
                         state.const_var.buildingHeightArray.push({ "value": val, "label": (chkFixedWidthFlag==true)?val +" x "+ parseInt(Math.round(val-params.p_r_p)):val });
                    }else{
                        state.const_var.buildingHeightArray.push({ "value": val, "label": (chkFixedWidthFlag==true)?val +" x "+ parseInt(Math.round(val-params.p_r_p)):val });
                     }
                })
               }
            } else {
                heightRange = Array.apply(null, { length: maxHeight + 1 }).map(Number.call, Number).slice(b_m_i_h).map((val, index) => {
                    state.const_var.buildingHeightArray.push({ "value": val, "label": val });
                })
            }

        }
    })
    // if(state.params.p_b_t=="2"){

    //     if(state.params.p_r_s=="4" || state.params.p_r_s=="5")
    //     {  
    //         var heig = state.params.p_h + 5;
    //         b_m_i_h = heig;
    //         state.params.p_h = heig;
    //     }else
    //     {
    //         var heig = state.params.p_h + 3;
    //         b_m_i_h = heig;
    //         state.params.p_h = heig;
    //     }
    // }
    if ((state.params.p_r_s == "4" || state.params.p_r_s == "5") && state.params.p_b_t == "2") {
        state.params.p_l_w = (state.params.p_l_w != "Open") ? state.params.p_l_w : 1;
        state.params.p_r_w = (state.params.p_r_w != "Open") ? state.params.p_r_w : 1;
    } else {
        state.params.p_l_w = state.params.p_l_w;//(checkBitly)?state.params.p_l_w:"Open";
        state.params.p_r_w = state.params.p_r_w// (checkBitly)?state.params.p_r_w:"Open";

    }
}

// Fully wall enclosed
const fullyWallEnclosed = (state) => {
    state.params.p_c_p_r = false;
    state.params.p_c_p_l = false;
    if (state.isFullyEnclosedChecked) {
        state.params.p_f_w = "Close";
        state.params.p_b_w = "Close";
        state.params.p_l_w = "Close";
        state.params.p_r_w = "Close";
        state.params.p_f_w_f = state.params.p_f_w;
        // state.params.insulation.center.isDisableFullInsulation = false;
    } else {
        state.params.p_f_w = "Open";
        state.params.p_b_w = "Open";
        state.params.p_l_w = state.params.p_b_t != 2 ? "Open" : 1;
        state.params.p_r_w = state.params.p_b_t != 2 ? "Open" : 1;
        state.params.p_f_w_f = state.params.p_f_w;
        // state.params.p_r_o = true;
        // state.params.p_f_i = false;
        // state.params.insulation.center.isDisableFullInsulation = true;
        const_var.UpdatedPriceData.insulation_price = undefined;
       
    }
    cuBuilding.BuildingUpdate(true, 'centerwall');
    if (state.params.p_f_w === "Close" && state.params.p_r_w === "Close" && state.params.p_l_w === "Close" && state.params.p_b_w === "Close") {
        state.const_var.setSidesEndsWallOption = "close";
    }else if(state.params.p_f_w === "Open" && state.params.p_r_w === "Open" && state.params.p_l_w === "Open" && state.params.p_b_w === "Open" && state.params.p_c_p_l == false && state.params.p_c_p_r == false){
        state.const_var.setSidesEndsWallOption = "open";
    }


    if ( params.add_front_lean && params.add_storage_check_front ) {
    }
    if ( params.add_left_lean && params.add_storage_check ){
    } 
    if ( params.add_right_lean && params.add_storage_check_right ) {
    }
    if ( params.add_back_lean && params.add_storage_check_back ) {
    }

    const_var.UpdatedPriceData.roof_pitch_price_changed = true;
    const_var.UpdatedPriceData.right_wall_price_changed = true;
    const_var.UpdatedPriceData.left_wall_price_changed = true;
    const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
    const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
    const_var.UpdatedPriceData.front_wall_price_changed = true;
    const_var.UpdatedPriceData.back_wall_price_changed = true;
    const_var.UpdatedPriceData.wainscot_price_changed = true;
    const_var.UpdatedPriceData.wainscot_price_changed = true;
    // const_var.UpdatedPriceData.color_price_changed = true;
    const_var.UpdatedPriceData.roof_color_price_changed = true;
    const_var.UpdatedPriceData.wall_color_price_changed = true;
    const_var.UpdatedPriceData.trim_color_price_changed = true;
    const_var.UpdatedPriceData.utility_price_changed = true;
    if ( params.p_e_i != "other" ) const_var.UpdatedPriceData.certificate_price_changed = true;
    const_var.UpdatedPriceData.surcharge_amount = undefined;
    const_var.UpdatedPriceData.insulation_price = undefined;
    resetLeantoStoragePrice("frontLean");
    resetLeantoStoragePrice("leftLean");
    resetLeantoStoragePrice("rightLean");
    resetLeantoStoragePrice("backLean");
    cuBuilding.cP();
}
const halfWallClose = (state, val) => {
    //console.log(val,"val")
    if (state.const_var.isHalfEnclosedChecked == true) {
        state.params.p_f_w = "Close";
        state.params.p_b_w = "Close";
        state.params.p_l_w = "Close";
        state.params.p_r_w = "Close";
        state.const_var.isHalfEnclosedCheckedVal = val;
        state.params.p_f_w_f = state.params.p_f_w;
    }
}
// Fully wall enclosed front lean to
const fullyWallEnclosedFrontLeanTo = (state) => {

    if (state.isFullyEnclosedCheckedForFrontLeanTo) {

        state.params.p_c_a_f_l_w = true;
        state.params.p_b_c_b_f_l = "Close";
        state.params.p_b_c_b_f_b = "Close";
        state.params.p_b_c_b_f_f = "Close";
        state.params.b_f_l_t_l = "Close";
        state.params.b_f_l_t_r = "Close";
        state.params.b_f_l_t_f = "Close";
    } else {
        state.params.add_storage_check_front = false;
        state.params.p_c_a_f_l_w = false;
        state.params.p_b_c_b_f_l = "Open";
        state.params.p_b_c_b_f_b = "Open";
        state.params.p_b_c_b_f_f = "Open";
        state.params.b_f_l_t_f = "Open";
        state.params.b_f_l_t_l = "Open";
        state.params.b_f_l_t_r = "Open";
        //updateWainscot(state);
    }
    if(state.params.p_b_c_b_f_l == "Close" && state.params.p_b_c_b_f_b == "Close" && state.params.p_b_c_b_f_f == "Close"){
        const_var.setLeanWallOption.frontLean = 'close'
    }else if(state.params.p_b_c_b_f_l == "Open" && state.params.p_b_c_b_f_b == "Open" && state.params.p_b_c_b_f_f == "Open"){
        const_var.setLeanWallOption.frontLean = 'open'
    }
   
    // if (state.params.p_u_c == true) {
    //     state.params.p_u_c = false
    // }
    const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;
    const_var.UpdatedPriceData.front_lean_left_wall_price_changed = true;
    const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;

    const_var.UpdatedPriceData.wainscot_price_changed = true;
    // const_var.UpdatedPriceData.color_price_changed = true;
    const_var.UpdatedPriceData.roof_color_price_changed = true;
    const_var.UpdatedPriceData.wall_color_price_changed = true;
    const_var.UpdatedPriceData.trim_color_price_changed = true;
    const_var.UpdatedPriceData.surcharge_amount = undefined;
    if (const_var.isInsulaltionForOldQuotes && params.p_i_o != 0) const_var.UpdatedPriceData.insulation_price = undefined;
    const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
    state.params.p_c_p_r = false;
    state.params.p_c_p_f = false;
    cuBuilding.BuildingUpdate(true, 'leanwall');
    cuBuilding.UpdateFrontLean("walls");
    cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);


}
const fullyWallEnclosedBackLeanTo = (state) => {

    if (state.isFullyEnclosedCheckedForBackLeanTo) {

        state.params.p_c_a_b_l_w = true;
        state.params.p_b_c_b_b_l = "Close";
        state.params.p_b_c_b_b_f = "Close";
        state.params.p_b_c_b_b_b = "Close";
        state.params.b_b_l_t_l = "Close";
        state.params.b_b_l_t_r = "Close";
        state.params.b_b_l_t_f = "Close";
    } else {
        state.params.add_storage_check_back = false;
        state.params.p_c_a_b_l_w = false;
        state.params.p_b_c_b_b_l = "Open";
        state.params.p_b_c_b_b_f = "Open";
        state.params.p_b_c_b_b_b = "Open";
        state.params.b_b_l_t_f = "Open";
        state.params.b_b_l_t_l = "Open";
        state.params.b_b_l_t_r = "Open";

    }
    if(state.params.p_b_c_b_b_l == "Close" && state.params.p_b_c_b_b_b == "Close" && state.params.p_b_c_b_b_f == "Close"){
        const_var.setLeanWallOption.backLean = 'close'
    }else if(state.params.p_b_c_b_b_l == "Open" && state.params.p_b_c_b_b_b == "Open" && state.params.p_b_c_b_b_f == "Open"){
        const_var.setLeanWallOption.backLean = 'open'
    }
    // if (state.params.p_u_c == true) {
    //     state.params.p_u_c = false
    // }
    const_var.UpdatedPriceData.back_lean_back_wall_price_changed = true;
    const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;
    const_var.UpdatedPriceData.back_lean_left_wall_price_changed = true;

    const_var.UpdatedPriceData.wainscot_price_changed = true;
    // const_var.UpdatedPriceData.color_price_changed = true;
    const_var.UpdatedPriceData.roof_color_price_changed = true;
    const_var.UpdatedPriceData.wall_color_price_changed = true;
    const_var.UpdatedPriceData.trim_color_price_changed = true;
    const_var.UpdatedPriceData.surcharge_amount = undefined;
    if (const_var.isInsulaltionForOldQuotes && params.p_i_o != 0) const_var.UpdatedPriceData.insulation_price = undefined;
    const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
    state.params.p_c_p_r = false;
    state.params.p_c_p_l = false;
    cuBuilding.BuildingUpdate(true, 'leanwall');
    cuBuilding.UpdateBackLean("walls");
    cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);


}

// Fully wall enclosed left lean to
const fullyWallEnclosedLeftLeanTo = (state) => {

    if (state.isFullyEnclosedCheckedForLeftLeanTo) {

        state.params.p_c_a_l_l_w = true;
        state.params.p_b_c_b_l_f = "Close";
        state.params.p_b_c_b_l_b = "Close";
        state.params.p_b_c_b_l = "Close";
        state.params.b_l_l_t_l = "Close";
        state.params.b_l_l_t_b = "Close";
        state.params.b_l_l_t_f = "Close";
    } else {
        state.params.add_storage_check = false;
        state.params.p_c_a_l_l_w = false;
        state.params.p_b_c_b_l_f = "Open";
        state.params.p_b_c_b_l_b = "Open";
        state.params.p_b_c_b_l = "Open";
        state.params.b_l_l_t_l = "Open";
        state.params.b_l_l_t_b = "Open";
        state.params.b_l_l_t_f = "Open";
        //updateWainscot(state);
    }
    if(state.params.p_b_c_b_l == "Close" && state.params.p_b_c_b_l_b == "Close" && state.params.p_b_c_b_l_f == "Close"){
        const_var.setLeanWallOption.leftLean = 'close'
    }else if(state.params.p_b_c_b_l == "Open" && state.params.p_b_c_b_l_b == "Open" && state.params.p_b_c_b_l_f == "Open"){
        const_var.setLeanWallOption.leftLean = 'open'
    }
    // if (state.params.p_u_c == true) {
    //     state.params.p_u_c = false
    // }
    const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
    const_var.UpdatedPriceData.left_lean_front_wall_price_changed = true;
    const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;

    const_var.UpdatedPriceData.wainscot_price_changed = true;
    // const_var.UpdatedPriceData.color_price_changed = true;
    const_var.UpdatedPriceData.roof_color_price_changed = true;
    const_var.UpdatedPriceData.wall_color_price_changed = true;
    const_var.UpdatedPriceData.trim_color_price_changed = true;
    const_var.UpdatedPriceData.surcharge_amount = undefined;
    if (const_var.isInsulaltionForOldQuotes && params.p_i_o != 0) const_var.UpdatedPriceData.insulation_price = undefined;
    const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
    state.params.p_c_p_r = false;
    state.params.p_c_p_l = false;
    cuBuilding.BuildingUpdate(true, 'leanwall');
    cuBuilding.UpdateLeftLean("walls");
    cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);


}

// Fully wall enclosed Right lean to
const fullyWallEnclosedRightLeanTo = (state) => {

    if (state.isFullyEnclosedCheckedForRightLeanTo) {

        state.params.p_c_a_r_l_w = true;
        state.params.p_b_c_b_r_f = "Close";
        state.params.p_b_c_b_r_b = "Close";
        state.params.p_b_c_b_r = "Close";
        state.params.b_r_l_t_r = "Close";
        state.params.b_r_l_t_b = "Close";
        state.params.b_r_l_t_f = "Close";
    } else {
        state.params.add_storage_check_right = false;
        state.params.p_c_a_r_l_w = false;
        state.params.p_b_c_b_r_f = "Open";
        state.params.p_b_c_b_r_b = "Open";
        state.params.p_b_c_b_r = "Open";
        state.params.b_r_l_t_r = "Open";
        state.params.b_r_l_t_b = "Open";
        state.params.b_r_l_t_f = "Open";
        //updateWainscot(state);
    }
    if(state.params.p_b_c_b_r == "Close" && state.params.p_b_c_b_r_b == "Close" && state.params.p_b_c_b_r_f == "Close"){
        const_var.setLeanWallOption.rightLean = 'close'
    }else if(state.params.p_b_c_b_r == "Open" && state.params.p_b_c_b_r_b == "Open" && state.params.p_b_c_b_r_f == "Open"){
        const_var.setLeanWallOption.rightLean = 'open'
    }
    // if (state.params.p_u_c == true) {
    //     state.params.p_u_c = false
    // }
    const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
    const_var.UpdatedPriceData.right_lean_front_wall_price_changed = true;
    const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
    const_var.UpdatedPriceData.wainscot_price_changed = true;
    // const_var.UpdatedPriceData.color_price_changed = true;
    const_var.UpdatedPriceData.roof_color_price_changed = true;
    const_var.UpdatedPriceData.wall_color_price_changed = true;
    const_var.UpdatedPriceData.trim_color_price_changed = true;
    const_var.UpdatedPriceData.surcharge_amount = undefined;
    if (const_var.isInsulaltionForOldQuotes && params.p_i_o != 0) const_var.UpdatedPriceData.insulation_price = undefined;
    const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
    state.params.p_c_p_r = false;
    state.params.p_c_p_l = false;
    cuBuilding.BuildingUpdate(true, 'leanwall');
    cuBuilding.UpdateRightLean("walls");
    cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);

}

const removeStorage = (state) => {
    params.nostorage = !params.nostorage;
    if (params.nostorage == true) {
        params.activeWall = "c_b_f_w";
        // params.p_u_c = false;
        // params.cB_addStorage_check_right = false;
        // params.cB_addStorage_check_left = false;
        // params.p_b_w = "Open";
        if (state.isFullyEnclosedChecked == true) {
            params.p_b_w = params.p_l_w = params.p_r_w = "Close";
            params.p_u_c = false;
            params.cB_addStorage_check_right = false;
            params.cB_addStorage_check_left = false;
            params.cB_addStorage_check_both =false;
            params.cB_addStorage_check_both_with_back = false;            

        } else {
            // params.p_l_w = (params.add_left_lean == true) ? "1" : "Open";
            // params.p_r_w = (params.add_right_lean == true) ? "1" : "Open";
            if(params.p_u_c == true){
                params.p_b_w = "Open"
                params.p_u_c = false;
            }
            if(params.cB_addStorage_check_front == true){
                params.p_f_w = "Open"
                params.cB_addStorage_check_front = false;
            }
            if(params.cB_addStorage_check_left == true){
                params.p_l_w = "Open"
                params.cB_addStorage_check_left = false;
            }
            if(params.cB_addStorage_check_right == true){
                params.p_r_w = "Open"
                params.cB_addStorage_check_right = false
            }
            params.cB_addStorage_check_both =false;
            params.cB_addStorage_check_both_with_back = false;
        }
        const_var.UpdatedPriceData.utility_price_changed = true;
        const_var.UpdatedPriceData.front_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_price_changed = true;
        const_var.UpdatedPriceData.right_wall_price_changed = true;
        const_var.UpdatedPriceData.back_wall_price_changed = true;
        const_var.UpdatedPriceData.roof_pitch_price_changed = true;
        const_var.UpdatedPriceData.wainscot_price_changed = true;
        // const_var.UpdatedPriceData.color_price_changed = true;
        const_var.UpdatedPriceData.roof_color_price_changed = true;
        const_var.UpdatedPriceData.wall_color_price_changed = true;
        const_var.UpdatedPriceData.trim_color_price_changed = true;
        const_var.UpdatedPriceData.surcharge_amount = undefined;
        const_var.UpdatedPriceData.insulation_price = undefined;
        if( params.p_e_i != "other" ) const_var.UpdatedPriceData.certificate_price_changed = true;
        params.noStorageCertificatePriceChange = true;
        const compRemoveWalls = ['c_b_r_s_f_w', 'c_b_r_s_b_w', 'c_b_r_s_l_w', 'c_b_l_s_f_w', 'c_b_l_s_b_w', 'c_b_l_s_r_w', 'c_b_f_s_w', 'c_b_l_s_w', 'c_b_r_s_w'];
        if(params.p_b_w != 'Close') compRemoveWalls.push('c_b_b_w');
        if(params.p_l_w != 'Close') compRemoveWalls.push('c_b_l_w');
        if(params.p_r_w != 'Close') compRemoveWalls.push('c_b_r_w');
        cuBuilding.cP()
    }
    cuBuilding.BuildingUpdate(false, 'utilitywallRight');

}

const handleWallSelectonChangeValue = (state, e, wall) => {
    var chkEndJtrim = false;
    var chkSideJtrim = false;
    if((const_var.a_p_d_a.jtrim) && const_var.a_p_d_a.jtrim.length>0)
    {
        chkEndJtrim = (const_var.a_p_d_a.jtrim.filter(data=>data.type=="end")).length>0?true:false;
        chkSideJtrim = (const_var.a_p_d_a.jtrim.filter(data=>data.type=="side")).length>0?true:false;
    }
    // console.log(chkSideJtrim,"chkSideJtrim")
    if (wall === "front") {

        if ((state.params.cB_addStorage_check_left || state.params.cB_addStorage_check_right) && (e.target.value == "Half Dutch End" || e.target.value == "Half End")) removeStorage(state);

        state.params.p_f_w = e.target.value;
        state.params.p_f_w_f = state.params.p_f_w;
        params.dropdown_flagF = true;
        if(params.p_f_w!="Open" && params.p_f_w!="Close" && params.p_f_w!="Half Dutch End" && params.p_f_w!="Half End" && chkEndJtrim==true)
        {
            params.p_j_t_end = true;
        }
        const_var.ManageDoorArrar["front"] = []; const_var.ManageGlobalComponent["front"] = [];
        const_var.UpdatedPriceData.front_wall_price_changed = true;
        const_var.UpdatedPriceData.common_width_changed = true;
        const_var.UpdatedPriceData.utility_price_changed = true
        resetLeantoStoragePrice("frontLean");
    }
    else if (wall === "back") {

        if ((state.params.cB_addStorage_check_left || state.params.cB_addStorage_check_right) && (e.target.value == "Half Dutch End" || e.target.value == "Half End")) removeStorage(state);
        
        state.params.p_b_w = e.target.value;
        params.dropdown_flagB = true;
        if(params.p_b_w!="Open" && params.p_b_w!="Close" && params.p_b_w!="Half Dutch End" && params.p_b_w!="Half End" && chkEndJtrim==true)
        {
            params.p_j_t_end = true;
        }
        const_var.ManageDoorArrar["back"] = []; const_var.ManageGlobalComponent["back"] = [];
        const_var.UpdatedPriceData.back_wall_price_changed = true;
        const_var.UpdatedPriceData.common_width_changed = true;
        const_var.UpdatedPriceData.utility_price_changed = true
        resetLeantoStoragePrice("backLean");
    }
    else if (wall === "left") {
        if(e.target.value?.includes("1/2 Panel")){
            state.params.p_l_w = e.target.value.split(" ")[0]
        }else{
            state.params.p_l_w = e.target.value;
        }
            // state.params.p_c_p_l = (state.params.p_l_w=="Close")?false:state.params.p_c_p_l;
        if(params.p_l_w!="Open" && params.p_l_w!="Close" && chkSideJtrim==true)
        {
            params.p_j_t = true;
        }
        const_var.checkPanelForLean.left = '';
        const_var.ManageDoorArrar["left"] = []; const_var.ManageGlobalComponent["left"] = [];
        state.params.a_c_p_l = true;
        const_var.UpdatedPriceData.left_wall_price_changed = true;
        const_var.UpdatedPriceData.common_length_changed = true;
        const_var.UpdatedPriceData.utility_price_changed = true;
        // if(state.params.p_l_w !== const_var.UpdatedPriceData.left_wall)
        // {
        //     const_var.UpdatedPriceData.left_wall_price_changed = true;
        // }
        if (e.target.value?.includes("1/2 Panel")) {
            state.params.p_c_p_l = true;
            state.params.a_c_p_l = true;
            const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
            const_var.UpdatedPriceData.common_length_changed = true;
            const_var.UpdatedPriceData.surcharge_amount = undefined;
            const_var.UpdatedPriceData.certificate_price_changed = true;
           
            if(params.p_c_p_l==true && chkSideJtrim==true)
            {
                params.p_j_t = true;
            }

        }else{
            state.params.p_c_p_l = false
        }

        resetLeantoStoragePrice("leftLean");
    }
    else if (wall === "right") {
        if(e.target.value?.includes("1/2 Panel")){
            state.params.p_r_w = e.target.value.split(" ")[0]
        }else{
            state.params.p_r_w = e.target.value;
        }
        // state.params.p_c_p_r = false
        // state.params.p_c_p_r = (state.params.p_r_w=="Close")?false:state.params.p_c_p_r;
        if(params.p_r_w!="Open" && params.p_r_w!="Close" && chkSideJtrim==true)
        {
            params.p_j_t = true;
        }
        const_var.checkPanelForLean.right = '';
        const_var.ManageDoorArrar["right"] = []; const_var.ManageGlobalComponent["right"] = [];
        state.params.a_c_p_r = true;
        const_var.UpdatedPriceData.right_wall_price_changed = true;
        const_var.UpdatedPriceData.common_length_changed = true;
        const_var.UpdatedPriceData.utility_price_changed = true;
        // if(state.params.p_r_w !== const_var.UpdatedPriceData.right_wall)
        // {
        //     const_var.UpdatedPriceData.right_wall_price_changed = true;
        // }
        if(e.target.value?.includes("1/2 Panel")){
            state.params.p_c_p_r = true;
            state.params.a_c_p_r = true;
            const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
            const_var.UpdatedPriceData.common_length_changed = true;
            const_var.UpdatedPriceData.surcharge_amount = undefined;
            const_var.UpdatedPriceData.certificate_price_changed = true;
            if(params.p_c_p_r==true && chkSideJtrim==true)
            {
                params.p_j_t = true;
            }
        }else{
            state.params.p_c_p_r = false
        }
        resetLeantoStoragePrice("rightLean");
    }
    // check condition according to wall change
    if (state.params.p_b_w != "Close" || state.params.p_f_w != "Close" || state.params.p_l_w != "Close" || state.params.p_r_w != "Close") {
        state.isFullyEnclosedChecked = false;
    } else {
        state.isFullyEnclosedChecked = true;
    }

    // state.params.insulation.center.isDisableFullInsulation = false;
    const_var.UpdatedPriceData.wainscot_price_changed = true;
    // const_var.UpdatedPriceData.color_price_changed = true;
    const_var.UpdatedPriceData.roof_color_price_changed = true;
    const_var.UpdatedPriceData.wall_color_price_changed = true;
    const_var.UpdatedPriceData.trim_color_price_changed = true;
    
    const_var.UpdatedPriceData.insulation_price_changed = true;
    // priceCalculation = new PriceCalculation({const_var: state.const_var, params:state.params});
    // priceCalculation.cP(const_var.a_p_d_a)
    // // update building
    const_var.UpdatedPriceData.roof_pitch_price_changed = true;
    if(params.p_e_i != "other") const_var.UpdatedPriceData.certificate_price_changed = true;
    if (params.p_f_i) const_var.UpdatedPriceData.insulation_price = undefined;
    const_var.UpdatedPriceData.surcharge_amount = undefined;
    cuBuilding.BuildingUpdate(true, 'centerwall');
    // utils.updateWallSelection('center')
    cuBuilding.cP();   
}

const dynamicWallOptions = (state, isFor) => {

    state.p_l_r = {};
    state.p_l_rL = {};
    state.p_l_rR = {};
    state.b_p_r = {};
    state.b_p_rR = {};

    state.ends = {};
    state.sides = {};
    const_var.wallArray = { "front": {}, "back": {} };

    let showRemainingWallOption = true;
    let isOlderThen12June = const_var.crmSetting.is_Edit == true && const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.main_created_at !=undefined && const_var.editAPIDataByResponse.data.main_created_at<="2024-06-12" ? true : false
    // if(const_var.crmSetting.is_Edit == true && const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.request_data !=undefined && const_var.editAPIDataByResponse.data.request_data.building !=undefined && const_var.editAPIDataByResponse.data.request_data.building.create_at_date !=undefined && const_var.editAPIDataByResponse.data.request_data.building.create_at_date<="2024-06-12"){
    //     isOlderThen12June = true
    // }

    if(!isOlderThen12June && (params.m_s_n==122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97 || params.m_s_n == 13))
    {
        showRemainingWallOption = false;
    }
    if(const_var.crmSetting.is_Edit==true)
    {
        if(const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.created_at<="2023-10-13")
        {
            showRemainingWallOption = true;
        }
    }
    // end wall selections
    state.ends["Open"] = "Open";
    if ((state.const_var.a_p_d_a.gable_end != undefined) && (state.const_var.a_p_d_a.gable_end.length > 0)) {
        if ((state.const_var.a_p_d_a.gable_end[0].extended != 0 || state.const_var.a_p_d_a.gable_end[0].vertical_extended != 0)) {
            state.ends["Gable"] = "Gable";
            state.ends["Extended Gable"] = "Extended Gable";
        } else {
            state.ends["Gable"] = "Gable";
        }
    }
    if(showRemainingWallOption==true)
    {
        state.ends["1/4 Closed"] = "One_Fourth_Close";
        state.ends["1/2 Closed"] = "Half_Close";
        state.ends["3/4 Closed"] = "Three_Fourth_Close";
    }
    if(showRemainingWallOption==false && (params.add_front_lean==true || params.add_back_lean==true))
    {
        state.ends["1/4 Closed"] = "One_Fourth_Close";
        state.ends["1/2 Closed"] = "Half_Close";
        state.ends["3/4 Closed"] = "Three_Fourth_Close";
    }
    state.ends["Closed"] = "Close";

    // vallues for front wall
    const_var.wallArray["front"]["Open"] = "Open";

    if (params.m_s_n == 9 || params.m_s_n == 3 || params.m_s_n == 167) {
        const_var.wallArray["front"]["Half Dutch End"] = "Half Dutch End";
        const_var.wallArray["front"]["Half End"] = "Half End";
    }

    if (params.m_s_n == 1) {
        const_var.wallArray["front"]["Half End"] = "Half End";
    }


    if ((state.const_var.a_p_d_a.gable_end != undefined) && (state.const_var.a_p_d_a.gable_end.length > 0)) {
        if ((state.const_var.a_p_d_a.gable_end[0].extended != 0 || state.const_var.a_p_d_a.gable_end[0].vertical_extended != 0)) {
            const_var.wallArray["front"]["Gable"] = "Gable";
            const_var.wallArray["front"]["Extended Gable"] = "Extended Gable";
        } else {
            const_var.wallArray["front"]["Gable"] = "Gable";
        }
    }
    if(showRemainingWallOption==true)
    {
        const_var.wallArray["front"]["1/4 Closed"] = "One_Fourth_Close";
        const_var.wallArray["front"]["1/2 Closed"] = "Half_Close";
        const_var.wallArray["front"]["3/4 Closed"] = "Three_Fourth_Close";
    }
    if(showRemainingWallOption==false && params.add_front_lean==true)
    {
        const_var.wallArray["front"]["1/4 Closed"] = "One_Fourth_Close";
        const_var.wallArray["front"]["1/2 Closed"] = "Half_Close";
        const_var.wallArray["front"]["3/4 Closed"] = "Three_Fourth_Close";
    }
    const_var.wallArray["front"]["Closed"] = "Close";
    // vallues for back wall
    const_var.wallArray["back"]["Open"] = "Open";
    if (params.m_s_n == 9 || params.m_s_n == 3 || params.m_s_n == 167) {
        const_var.wallArray["back"]["Half Dutch End"] = "Half Dutch End";
        const_var.wallArray["back"]["Half End"] = "Half End";
    }

    if (params.m_s_n == 1) {
        const_var.wallArray["back"]["Half End"] = "Half End";
    }


    if ((state.const_var.a_p_d_a.gable_end != undefined) && (state.const_var.a_p_d_a.gable_end.length > 0)) {
        if ((state.const_var.a_p_d_a.gable_end[0].extended != 0 || state.const_var.a_p_d_a.gable_end[0].vertical_extended != 0)) {
            const_var.wallArray["back"]["Gable"] = "Gable";
            const_var.wallArray["back"]["Extended Gable"] = "Extended Gable";
        } else {
            const_var.wallArray["back"]["Gable"] = "Gable";
        }
    }
    if(showRemainingWallOption==true)
    {
        const_var.wallArray["back"]["1/4 Closed"] = "One_Fourth_Close";
        const_var.wallArray["back"]["1/2 Closed"] = "Half_Close";
        const_var.wallArray["back"]["3/4 Closed"] = "Three_Fourth_Close";
    }
    if(showRemainingWallOption==false && params.add_back_lean==true)
    {
        const_var.wallArray["back"]["1/4 Closed"] = "One_Fourth_Close";
        const_var.wallArray["back"]["1/2 Closed"] = "Half_Close";
        const_var.wallArray["back"]["3/4 Closed"] = "Three_Fourth_Close";
    }
    const_var.wallArray["back"]["Closed"] = "Close";


    // side wall selections

    if (state.params.add_left_lean == true && state.params.continous_left_lean == false) {
        var calData = (state.params.lean_p_w * (state.params.b_l_t_r_p) / 12);
        var finalHeight = state.params.p_h - (calData + state.params.lean_p_h);
        var calVal = Math.ceil(finalHeight / 3);
        var oneFourthValue = state.params.p_h / 4;
        if (state.const_var.a_p_d_a.panel.length > 0) {
            var startVal = (calVal != 0) ? (calVal - 1) : 0;
            if (calVal == 0) {
                state.p_l_rL["Open"] = "Open";
            } else {
                state.p_l_rL = {};
            }
            

            for (var i = startVal; i < Math.floor((state.params.p_h - 1) / 3); i++) {
                if(state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0){
                    state.p_l_rL[ " 1/2" + " Panel (1.5') "] = " 1/2" + " Panel (1.5')";
                }
                if (i == 0) {
                    state.p_l_rL[(i + 1) + " Panel (3')"] = i + 1;
                    if(state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0){
                        state.p_l_rL[(i + 1)+ " 1/2" + " Panel (4.5') "] = (i + 1)+ " 1/2" + " Panel (4.5')";
                    }
                } else {
                    var fit_i = (i + 1) * 3;
                    state.p_l_rL[(i + 1) + " Panels (" + fit_i + "')"] = i + 1;
                    if((fit_i + 1.5) <= state.params.p_h && state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0){
                        state.p_l_rL[(i + 1) + " 1/2" + " Panels (" + (fit_i + 1.5) + "')"] = (i + 1) + " 1/2" + " Panels (" + (fit_i + 1.5) + "')";
                    }
                }
            }
            if (!showRemainingWallOption) state.p_l_rL["Closed"] = "Close";
        } else {
                        if (calVal == 0) {
                state.p_l_rL['Open'] = "Open";
            }
            state.p_l_rL["Closed"] = "Close";

        }
        /*state.p_l_rL["1/4 Closed"] = "One_Fourth_Close";
        state.p_l_rL["1/2 Closed"] = "Half_Close";
        state.p_l_rL["3/4 Closed"] = "Three_Fourth_Close";*/
        if(showRemainingWallOption==true)
        {
            if (oneFourthValue >= finalHeight) {
                state.p_l_rL["1/4 Closed"] = "One_Fourth_Close";
            }
            if ((2 * oneFourthValue) >= finalHeight) {
                state.p_l_rL["1/2 Closed"] = "Half_Close";
            }
            if ((3 * oneFourthValue) >= finalHeight) {
                state.p_l_rL["3/4 Closed"] = "Three_Fourth_Close";
            }
            state.p_l_rL["Closed"] = "Close";
            if(params.p_l_w){
                let isExsist = Object.keys(state.p_l_rL).find(key =>state.p_l_rL[key] == params.p_l_w);
                params.p_l_w = isExsist == undefined ? 'Closed' : params.p_l_w
            }
        }
    }
    if (state.params.add_right_lean == true && state.params.continous_right_lean == false) {
        var calData = (state.params.leanR_p_w * (state.params.b_l_t_r_pR) / 12);
        var finalHeight = state.params.p_h - (calData + state.params.leanR_p_h);
        var calVal = Math.ceil(finalHeight / 3);
        var oneFourthValue = state.params.p_h / 4;
        if (state.const_var.a_p_d_a.panel.length > 0) {
            var startVal = (calVal != 0) ? (calVal - 1) : 0;
            if (calVal == 0) {
                state.p_l_rR["Open"] = "Open";
            } else {
                state.p_l_rR = {};
            }
            

            for (var i = startVal; i < Math.floor((state.params.p_h - 1) / 3); i++) {
                if(state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0){
                    state.p_l_rR[ " 1/2" + " Panel (1.5') "] = " 1/2" + " Panel (1.5')";
                }
                if (i == 0) {
                    state.p_l_rR[(i + 1) + " Panel (3')"] = i + 1;
                    if(state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0){
                        state.p_l_rR[(i + 1)+ " 1/2" + " Panel (4.5') "] = (i + 1)+ " 1/2" + " Panel (4.5')";
                    }
                } else {
                    var fit_i = (i + 1) * 3;
                    state.p_l_rR[(i + 1) + " Panels (" + fit_i + "')"] = i + 1;
                    if((fit_i + 1.5) <= state.params.p_h && state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0){
                        state.p_l_rR[(i + 1) + " 1/2" + " Panels (" + (fit_i + 1.5) + "')"] = (i + 1) + " 1/2" + " Panels (" + (fit_i + 1.5) + "')";
                    }
                }
            }
            if (!showRemainingWallOption) state.p_l_rR["Closed"] = "Close";
        } else {
            if (calVal == 0) {
                state.p_l_rR['Open'] = "Open";
            }
            state.p_l_rR["Closed"] = "Close";

        }
        /*state.p_l_rR["1/4 Closed"] = "One_Fourth_Close";
        state.p_l_rR["1/2 Closed"] = "Half_Close";
        state.p_l_rR["3/4 Closed"] = "Three_Fourth_Close";*/
        if(showRemainingWallOption==true)
                {
            if (oneFourthValue >= finalHeight) {
                state.p_l_rR["1/4 Closed"] = "One_Fourth_Close";
            }
            if ((2 * oneFourthValue) >= finalHeight) {
                state.p_l_rR["1/2 Closed"] = "Half_Close";
            }
            if ((3 * oneFourthValue) >= finalHeight) {
                state.p_l_rR["3/4 Closed"] = "Three_Fourth_Close";
            }
            state.p_l_rR["Closed"] = "Close";
            if(params.p_r_w){
                let isExsist = Object.keys(state.p_l_rR).find(key =>state.p_l_rR[key] == params.p_r_w);
                params.p_r_w = isExsist == undefined ? 'Closed' : params.p_r_w
            }
        }
    }

    state.p_l_r['Open'] = "Open";

    if (state.const_var.a_p_d_a.panel.length > 0) {
        for (var i = 0; i < Math.floor((state.params.p_h - 1) / 3); i++) {
            if(state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0){
                state.p_l_r[ " 1/2" + " Panel (1.5') "] = " 1/2" + " Panel (1.5')";
            }
            if (i == 0) {
                state.p_l_r[(i + 1) + " Panel (3')"] = i + 1;
                if(state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0){
                    state.p_l_r[(i + 1)+ " 1/2" + " Panel (4.5') "] = (i + 1)+ " 1/2" + " Panel (4.5')";
                }
            } else {
                var fit_i = (i + 1) * 3;
                state.p_l_r[(i + 1) + " Panels (" + fit_i + "')"] = i + 1;
                if((fit_i + 1.5) <= state.params.p_h && state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0){
                    state.p_l_r[(i + 1) + " 1/2" + " Panels (" + (fit_i + 1.5) + "')"] = (i + 1) + " 1/2" + " Panels (" + (fit_i + 1.5) + "')";
                }
            }
        }
    }
        if(showRemainingWallOption==true)
    {
        state.p_l_r["1/4 Closed"] = "One_Fourth_Close";
        state.p_l_r["1/2 Closed"] = "Half_Close";
        state.p_l_r["3/4 Closed"] = "Three_Fourth_Close";
    }
    state.p_l_r["Closed"] = "Close";


    state.b_p_r['Open'] = "Open";
    if (state.params.p_r_s == "4" || state.params.p_r_s == "5") {
        var val = state.params.p_h - 5;
    } else {
        if (state.params.add_left_lean == true) {
            

            var val = state.params.lean_p_h;
            if (state.const_var.a_p_d_a.panel.length > 0) {
                for (var i = 0; i < Math.floor((val - 1) / 3); i++) {
                    var fit_i = (i + 1) * 3;
                    state.b_p_r[(i + 1) + " Panels (" + fit_i + "')"] = i + 1;

                }
            }
            if(showRemainingWallOption==true)
            {
                state.b_p_r["1/4 Closed"] = "One_Fourth_Close";
                state.b_p_r["1/2 Closed"] = "Half_Close";
                state.b_p_r["3/4 Closed"] = "Three_Fourth_Close";
            }
            state.b_p_r['Closed'] = "Close";
        } if (state.params.add_right_lean == true) {
            var val = state.params.leanR_p_h;
            state.b_p_rR['Open'] = "Open";
            
            if (state.const_var.a_p_d_a.panel.length > 0) {
                for (var i = 0; i < Math.floor((val - 1) / 3); i++) {
                    var fit_i = (i + 1) * 3;
                    state.b_p_rR[(i + 1) + " Panels (" + fit_i + "')"] = i + 1;

                }
            }
            if(showRemainingWallOption==true)
            {
                state.b_p_rR["1/4 Closed"] = "One_Fourth_Close";
                state.b_p_rR["1/2 Closed"] = "Half_Close";
                state.b_p_rR["3/4 Closed"] = "Three_Fourth_Close";
            }
            state.b_p_rR['Closed'] = "Close";
        }
    }

    if (params.add_right_lean == true && params.continous_right_lean == false) {
                state.jsonDataR = state.p_l_rR;
    } else {
                state.jsonDataR = state.p_l_r;
    } if (params.add_left_lean == true && params.continous_left_lean == false) {
                state.jsonDataL = state.p_l_rL;
    } else {
                state.jsonDataL = state.p_l_r;
        if (params.singleSlope) {
                        const p_l_rs = {};
            p_l_rs['Open'] = "Open";
            let slopeHeight = (const_var.c_m_a[params.p_b_t]!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length>0 ? Math.floor((params.p_h  - (Number(params.p_r_p)/12) * (params.p_w)).toFixed(2)) : Math.round((params.p_h  - (Number(params.p_r_p)/12) * (params.p_w)).toFixed(2)));
            if (state.const_var.a_p_d_a.panel.length > 0) {
                for (var i = 0; i < Math.floor((state.params.p_h - (Number(params.p_r_p)/12) * params.p_w - 1) / 3); i++) {
                    if(state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0){
                        p_l_rs[" 1/2" + " Panel (1.5') "] = "Open";
                    }
                    if (i == 0) {
                        p_l_rs[(i + 1) + " Panel (3')"] = i + 1;
                        if(state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0){
                            p_l_rs[(i + 1)+ " 1/2" + " Panel (4.5') "] = i + 1;
                        }
                    } else {
                        var fit_i = (i + 1) * 3;
                        p_l_rs[(i + 1) + " Panels (" + fit_i + "')"] = i + 1;
                        if((fit_i + 1.5) <= (slopeHeight-1.5) && state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0){
                            p_l_rs[(i + 1) + " 1/2" + " Panels (" + (fit_i + 1.5) + "')"] = i + 1;
                        }
                    }
                }
            }
            // let slopeHeight = (const_var.c_m_a[params.p_b_t]!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length>0 ? Math.floor((params.p_h  - (Number(params.p_r_p)/12) * (params.p_w)).toFixed(2)) : Math.round((params.p_h  - (Number(params.p_r_p)/12) * (params.p_w)).toFixed(2)));
            //  if (state.const_var.a_p_d_a.panel.length > 0) {
            //     for (var i = 0; i < Math.floor((state.params.p_h - (Number(params.p_r_p)/12) * params.p_w - 1) / 3); i++) {
            //         if (i == 0) {
            //             p_l_rs[(i + 1) + " Panel (3')"] = i + 1;
            //             if((fit_i + 1.5) <= (slopeHeight-1.5) && state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0){
            //                 state.p_l_rs[(i + 1)+ " 1/2" + " Panel (4.5') "] = i + 1.000001;
            //             }
            //         } else {
            //             var fit_i = (i + 1) * 3;
            //             p_l_rs[(i + 1) + " Panels (" + fit_i + "')"] = i + 1;
            //             if((fit_i + 1.5) <= (slopeHeight-1.5) && state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0){
            //                 state.p_l_rs[(i + 1) + " 1/2" + " Panels (" + (fit_i + 1.5) + "')"] = i + 1.000001;
            //             }
            //         }
            //     }
            // }
            if(showRemainingWallOption==true)
            {
                p_l_rs["1/4 Closed"] = "One_Fourth_Close";
                p_l_rs["1/2 Closed"] = "Half_Close";
                p_l_rs["3/4 Closed"] = "Three_Fourth_Close";
            }
            p_l_rs["Closed"] = "Close";

            state.jsonDataL = p_l_rs
        }
    }

    if(state.params.add_right_lean == true){
        Object.entries(state.jsonDataR).forEach(([key,value],index)=> {
            if(key.includes("1/2 Panel") == true && index == 0 ){
                delete state.jsonDataR[key]
            }
        })
    } 
    if(state.params.add_left_lean == true){
        Object.entries(state.jsonDataL).forEach(([key,value],index)=> {
            if(key.includes("1/2 Panel") == true && index == 0 ){
                delete state.jsonDataL[key]
            }
        })
    }  
    if(state.params.p_v_w == true){
        let newJsonDataL = {}
        let newJsonDataR = {}
        Object.entries(state.jsonDataL).forEach(([key,value])=> {
            if(key.includes("1/2 Panel") == false){
                newJsonDataL[key] = value
            }
        })
            state.jsonDataL = newJsonDataL
        Object.entries(state.jsonDataR).forEach(([key,value])=> {
            if(key.includes("1/2 Panel") == false){
                newJsonDataR[key] = value
            }
        })
            state.jsonDataR = newJsonDataR
    }


    //#####################################################################################
    //#####################################################################################
    // ########################################### Commented the below code because we handled the same cases with 12th june 24 date and all cases are handleded with the same date. And if we uncomment this code it will generate new issue in edit mode having main_created_date between 6nov to 12june ##########################################
    //#####################################################################################
    //#####################################################################################
    // to remove 1/2 closed, 3/4 closed, 1/4 closed option for metal tex manufacturer after 26 oct 2023
    //     if(params.m_s_n == 97 && (const_var.crmSetting.is_Edit==false || (const_var.crmSetting.is_Edit==true && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.created_at > "2023-11-06") || const_var.isFromCompare == true)){
    //     let newROptions = Object.assign({},state.jsonDataR);
    //     let newLOptions = Object.assign({},state.jsonDataL);
    //     let keyToRemove = "1/2 Closed"
    //     let keyToRemove1 = "1/4 Closed"
    //     let keyToRemove2 = "3/4 Closed"
    //     if (newROptions.hasOwnProperty(keyToRemove)) {
    //         delete newROptions[keyToRemove];
    //     }
    //     if (newROptions.hasOwnProperty(keyToRemove1)) {
    //         delete newROptions[keyToRemove1];
    //     }
    //     if (newROptions.hasOwnProperty(keyToRemove2)) {
    //         delete newROptions[keyToRemove2];
    //     }
    //     if (newLOptions.hasOwnProperty(keyToRemove)) {
    //         delete newLOptions[keyToRemove];
    //     }
    //     if (newLOptions.hasOwnProperty(keyToRemove1)) {
    //         delete newLOptions[keyToRemove1];
    //     }
    //     if (newLOptions.hasOwnProperty(keyToRemove2)) {
    //         delete newLOptions[keyToRemove2];
    //     }
    //     state.jsonDataR = newROptions
    //     state.jsonDataL = newLOptions
    // }
    // ###################################################################################
    // ########################################### Commented code ends here ##########################################
    //#####################################################################################

    if (const_var.crmSetting.is_Edit != true) {
        if(isFor != undefined && ((isFor == 'addLeftLean' && state.params.add_left_lean != true) || (isFor == 'addRightLean' && state.params.add_right_lean != true) || (isFor == 'addFrontLean' && state.params.add_front_lean != true) || (isFor == 'addBackLean' && state.params.add_back_lean != true))){
        }
        else{
            const_var.UpdatedPriceData.left_wall_price_changed = true;
            const_var.UpdatedPriceData.right_wall_price_changed = true;
        }
    }
}

const dynamicWallOptionsForLeanTo = (state) => {
    if (params.add_front_lean) cuBuilding.UpdateFrontLean();
    if (params.add_left_lean) cuBuilding.UpdateLeftLean();
    if (params.add_right_lean) cuBuilding.UpdateRightLean();
    if (params.add_back_lean) cuBuilding.UpdateBackLean();
    state.frontlentoEnds = {};
    state.frontlentoSides = {};
    state.backlentoEnds = {};
    state.backlentoSides = {};
    state.leftlentoEnds = {};
    state.leftlentoSides = {};
    state.rightlentoEnds = {};
    state.rightlentoSides = {};

    let showRemainingWallOption = true;
    let isOlderThen12June = const_var.crmSetting.is_Edit == true && const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data.main_created_at !=undefined && const_var.editAPIDataByResponse.data.main_created_at<="2024-06-12" ? true : false
    
    if(const_var.crmSetting.is_Edit == true && const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.request_data !=undefined && const_var.editAPIDataByResponse.data.request_data.building !=undefined && const_var.editAPIDataByResponse.data.request_data.building.create_at_date !=undefined && const_var.editAPIDataByResponse.data.request_data.building.create_at_date<="2024-06-12"){
        isOlderThen12June = true
    }

    if(!isOlderThen12June && (params.m_s_n==122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97 || params.m_s_n == 13))
    {
        showRemainingWallOption = false;
    }
    if(const_var.crmSetting.is_Edit==true)
    {
        if(const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.created_at<="2023-10-13")
        {
            showRemainingWallOption = true;
        }
    }

    // Front LeanTo End wall selections
    var l_to_h = 0
    l_to_h = params.leanF_p_h;
    state.frontlentoEnds["Open"] = "Open";
    

    if (state.const_var.a_p_d_a.panel.length > 0) {
        for (var i = 0; i < Math.floor((l_to_h - 1) / 3); i++) {
            if (i == 0) {
                state.frontlentoEnds[(i + 1) + " Panel (3')"] = i + 1;

            } else {
                var fit_i = (i + 1) * 3;
                state.frontlentoEnds[(i + 1) + " Panels (" + fit_i + "')"] = i + 1;
            }

        }
    }
    if(showRemainingWallOption)
    {
        state.frontlentoEnds["1/4 Closed"] = "One_Fourth_Close";
        state.frontlentoEnds["1/2 Closed"] = "Half_Close";
        state.frontlentoEnds["3/4 Closed"] = "Three_Fourth_Close";
    }
    state.frontlentoEnds["Closed"] = "Close";
    // Front LeanTo side wall selections  
    state.frontlentoSides["Open"] = "Open";

    if (params.m_s_n == 9 || params.m_s_n == 3 || params.m_s_n == 167) {
        state.frontlentoSides["Half Dutch End"] = "Half Dutch End";
        state.frontlentoSides["Half End"] = "Half End";
    }

    if (params.m_s_n == 1) {
        state.frontlentoSides["Half End"] = "Half End";
    }
    
    if ((state.const_var.a_p_d_a.gable_end != undefined) && (state.const_var.a_p_d_a.gable_end.length > 0)) {
        state.frontlentoSides["Gable"] = "Gable";
    }
    if(showRemainingWallOption)
    {
        state.frontlentoSides["1/4 Closed"] = "One_Fourth_Close";
        state.frontlentoSides["1/2 Closed"] = "Half_Close";
        state.frontlentoSides["3/4 Closed"] = "Three_Fourth_Close";
    }
    state.frontlentoSides["Closed"] = "Close";
    // Back LeanTo End wall selections
    var l_to_h = 0
    l_to_h = params.leanB_p_h;
    state.backlentoEnds["Open"] = "Open";
    

    if (state.const_var.a_p_d_a.panel.length > 0) {
        for (var i = 0; i < Math.floor((l_to_h - 1) / 3); i++) {
            if (i == 0) {
                state.backlentoEnds[(i + 1) + " Panel (3')"] = i + 1;

            } else {
                var fit_i = (i + 1) * 3;
                state.backlentoEnds[(i + 1) + " Panels (" + fit_i + "')"] = i + 1;
            }

        }
    }
    if(showRemainingWallOption)
    {
        state.backlentoEnds["1/4 Closed"] = "One_Fourth_Close";
        state.backlentoEnds["1/2 Closed"] = "Half_Close";
        state.backlentoEnds["3/4 Closed"] = "Three_Fourth_Close";
    }
    state.backlentoEnds["Closed"] = "Close";
    // Back LeanTo side wall selections  
    state.backlentoSides["Open"] = "Open";

    if (params.m_s_n == 9 || params.m_s_n == 3 || params.m_s_n == 167) {
        state.backlentoSides["Half Dutch End"] = "Half Dutch End";
        state.backlentoSides["Half End"] = "Half End";
    }

    if (params.m_s_n == 1) {
        state.backlentoSides["Half End"] = "Half End";
    }
    
    if ((state.const_var.a_p_d_a.gable_end != undefined) && (state.const_var.a_p_d_a.gable_end.length > 0)) {
        state.backlentoSides["Gable"] = "Gable";
    }
    if(showRemainingWallOption)
    {
        state.backlentoSides["1/4 Closed"] = "One_Fourth_Close";
        state.backlentoSides["1/2 Closed"] = "Half_Close";
        state.backlentoSides["3/4 Closed"] = "Three_Fourth_Close";
    }

    state.backlentoSides["Closed"] = "Close";

    // LeanTo end wall selections  
    state.leftlentoEnds["Open"] = "Open";

    if (params.m_s_n == 9 || params.m_s_n == 3 || params.m_s_n == 167) {
        state.leftlentoEnds["Half Dutch End"] = "Half Dutch End";
        state.leftlentoEnds["Half End"] = "Half End";
    }

    if (params.m_s_n == 1) {
        state.leftlentoEnds["Half End"] = "Half End";
    }

    
    if ((state.const_var.a_p_d_a.gable_end != undefined) && (state.const_var.a_p_d_a.gable_end.length > 0)) {
        state.leftlentoEnds["Gable"] = "Gable";
    }
    if(showRemainingWallOption)
    {
        state.leftlentoEnds["1/4 Closed"] = "One_Fourth_Close";
        state.leftlentoEnds["1/2 Closed"] = "Half_Close";
        state.leftlentoEnds["3/4 Closed"] = "Three_Fourth_Close";
    }
    state.leftlentoEnds["Closed"] = "Close";
    // LeanTo side wall selections
    var l_to_h = 0
    l_to_h = params.lean_p_h;
    state.leftlentoSides["Open"] = "Open";
    

    if (state.const_var.a_p_d_a.panel.length > 0) {
        for (var i = 0; i < Math.floor((l_to_h - 1) / 3); i++) {
            if (i == 0) {
                state.leftlentoSides[(i + 1) + " Panel (3')"] = i + 1;

            } else {
                var fit_i = (i + 1) * 3;
                state.leftlentoSides[(i + 1) + " Panels (" + fit_i + "')"] = i + 1;
            }

        }
    }
    if(showRemainingWallOption)
    {
        state.leftlentoSides["1/4 Closed"] = "One_Fourth_Close";
        state.leftlentoSides["1/2 Closed"] = "Half_Close";
        state.leftlentoSides["3/4 Closed"] = "Three_Fourth_Close";
    }
    state.leftlentoSides["Closed"] = "Close";
    state.rightlentoEnds["Open"] = "Open";

    if (params.m_s_n == 9 || params.m_s_n == 3 || params.m_s_n == 167) {
        state.rightlentoEnds["Half Dutch End"] = "Half Dutch End";
        state.rightlentoEnds["Half End"] = "Half End";
    }

    if (params.m_s_n == 1) {
        state.rightlentoEnds["Half End"] = "Half End";
    }
    

    if ((state.const_var.a_p_d_a.gable_end != undefined) && (state.const_var.a_p_d_a.gable_end.length > 0)) {
        state.rightlentoEnds["Gable"] = "Gable";
    }
    if(showRemainingWallOption)
    {
        state.rightlentoEnds["1/4 Closed"] = "One_Fourth_Close";
        state.rightlentoEnds["1/2 Closed"] = "Half_Close";
        state.rightlentoEnds["3/4 Closed"] = "Three_Fourth_Close";
    }
    state.rightlentoEnds["Closed"] = "Close";
    // LeanTo side wall selections
    var l_to_h = 0
    l_to_h = params.leanR_p_h;
    state.rightlentoSides["Open"] = "Open";
    

    if (state.const_var.a_p_d_a.panel.length > 0) {
        for (var i = 0; i < Math.floor((l_to_h - 1) / 3); i++) {
            if (i == 0) {
                state.rightlentoSides[(i + 1) + " Panel (3')"] = i + 1;

            } else {
                var fit_i = (i + 1) * 3;
                state.rightlentoSides[(i + 1) + " Panels (" + fit_i + "')"] = i + 1;
            }

        }
    }
    if(showRemainingWallOption)
    {
        state.rightlentoSides["1/4 Closed"] = "One_Fourth_Close";
        state.rightlentoSides["1/2 Closed"] = "Half_Close";
        state.rightlentoSides["3/4 Closed"] = "Three_Fourth_Close";
    }
    state.rightlentoSides["Closed"] = "Close";


   if (params.add_left_lean && Object.values(state.leftlentoSides).filter(data=>data==params.p_b_c_b_l).length==0) params.p_b_c_b_l = "Close";
   if (params.add_right_lean && Object.values(state.rightlentoSides).filter(data=>data==params.p_b_c_b_r).length==0) params.p_b_c_b_r = "Close";
   if (params.add_front_lean && Object.values(state.frontlentoEnds).filter(data=>data==params.p_b_c_b_f_l).length==0) params.p_b_c_b_f_l = "Close";
   if (params.add_back_lean && Object.values(state.backlentoEnds).filter(data=>data==params.p_b_c_b_b_l).length==0) params.p_b_c_b_b_l = "Close";
//    if (params.add_front_lean && Object.values(state.frontlentoSides).filter(data=>data==params.p_b_c_b_f_l).length==0) params.p_b_c_b_f_l = "Close";
//    if (params.add_back_lean && Object.values(state.backlentoSides).filter(data=>data==params.p_b_c_b_b_l).length==0) params.p_b_c_b_b_l = "Close";
  
    //#####################################################################################
    //#####################################################################################
    // ########################################### Commented the below code because we handled the same cases with 12th june 24 date and all cases are handleded with the same date. And if we uncomment this code it will generate new issue in edit mode having main_created_date between 6nov to 12june ##########################################
    //#####################################################################################
    //##################################################################################### 
   // to remove 1/2 closed, 3/4 closed, 1/4 closed option for metal tex manufacturer after 26 oct 2023
    //     if(params.m_s_n == 97 && (const_var.crmSetting.is_Edit==false || (const_var.crmSetting.is_Edit==true && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.created_at > "2023-11-06") || const_var.isFromCompare == true)){
    //     let newLLOptions = Object.assign({},state.leftlentoSides);
    //     let newRLOptions = Object.assign({},state.rightlentoSides);
    //     let newFLOptions = Object.assign({},state.frontlentoEnds);
    //     let newBLOptions = Object.assign({},state.backlentoEnds);
        
    //     let keyToRemove = "1/2 Closed"
    //     let keyToRemove1 = "1/4 Closed"
    //     let keyToRemove2 = "3/4 Closed"
    //     if (newLLOptions.hasOwnProperty(keyToRemove)) {
    //         delete newLLOptions[keyToRemove];
    //     }
    //     if (newLLOptions.hasOwnProperty(keyToRemove1)) {
    //         delete newLLOptions[keyToRemove1];
    //     }
    //     if (newLLOptions.hasOwnProperty(keyToRemove2)) {
    //         delete newLLOptions[keyToRemove2];
    //     }
    //     if (newRLOptions.hasOwnProperty(keyToRemove)) {
    //         delete newRLOptions[keyToRemove];
    //     }
    //     if (newRLOptions.hasOwnProperty(keyToRemove1)) {
    //         delete newRLOptions[keyToRemove1];
    //     }
    //     if (newRLOptions.hasOwnProperty(keyToRemove2)) {
    //         delete newRLOptions[keyToRemove2];
    //     }
    //     if (newFLOptions.hasOwnProperty(keyToRemove)) {
    //         delete newFLOptions[keyToRemove];
    //     }
    //     if (newFLOptions.hasOwnProperty(keyToRemove1)) {
    //         delete newFLOptions[keyToRemove1];
    //     }
    //     if (newFLOptions.hasOwnProperty(keyToRemove2)) {
    //         delete newFLOptions[keyToRemove2];
    //     }
    //     if (newBLOptions.hasOwnProperty(keyToRemove)) {
    //         delete newBLOptions[keyToRemove];
    //     }
    //     if (newBLOptions.hasOwnProperty(keyToRemove1)) {
    //         delete newBLOptions[keyToRemove1];
    //     }
    //     if (newBLOptions.hasOwnProperty(keyToRemove2)) {
    //         delete newBLOptions[keyToRemove2];
    //     }
    //     state.leftlentoSides = newLLOptions
    //     state.rightlentoSides = newRLOptions
    //     state.frontlentoEnds = newFLOptions
    //     state.backlentoEnds = newBLOptions
    // } 
    // ###################################################################################
    // ########################################### Commented code ends here ##########################################
    //#####################################################################################

    updateJTrim();
}

const toggleAllVerticalCheckboxChange = (state) => {
    // if walls are vertical thn cut panel must be false
    if (state.params.p_v_w) {
        state.params.p_c_p_l = false;
        state.params.p_c_p_r = false;
    }
    const_var.UpdatedPriceData.wainscot_price_changed = true;
    const_var.UpdatedPriceData.right_wall_price_changed = true;
    const_var.UpdatedPriceData.left_wall_price_changed = true;
    const_var.UpdatedPriceData.front_wall_price_changed = true;
    const_var.UpdatedPriceData.back_wall_price_changed = true;
    const_var.UpdatedPriceData.utility_price_changed = true;
    const_var.UpdatedPriceData.front_utility_price_changed = true;
    const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
    const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
    const_var.UpdatedPriceData.roof_pitch_price_changed = true;
    if( params.p_e_i != "other" ) const_var.UpdatedPriceData.certificate_price_changed = true;
    const_var.UpdatedPriceData.surcharge_amount = undefined;
    state.const_var.b_I_g_n_e = "building-normal.jpg";
    state.const_var.b_T_t_L_u = "";
    if (params.add_left_lean == true) {
        const_var.UpdatedPriceData.wainscot_price_changed = true;
        // const_var.UpdatedPriceData.color_price_changed = true;
        const_var.UpdatedPriceData.roof_color_price_changed = true;
        const_var.UpdatedPriceData.wall_color_price_changed = true;
        const_var.UpdatedPriceData.trim_color_price_changed = true;
        const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
        const_var.UpdatedPriceData.left_lean_front_wall_price_changed = true;
        const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
        const_var.UpdatedPriceData.left_lean_utility_price_changed = true;
        cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
        cuBuilding.UpdateLeftLean("walls");
    }
    if (params.add_front_lean == true) {
        const_var.UpdatedPriceData.wainscot_price_changed = true;
        // const_var.UpdatedPriceData.color_price_changed = true;
        const_var.UpdatedPriceData.roof_color_price_changed = true;
        const_var.UpdatedPriceData.wall_color_price_changed = true;
        const_var.UpdatedPriceData.trim_color_price_changed = true;
        const_var.UpdatedPriceData.front_lean_left_wall_price_changed = true;
        const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;
        const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
        const_var.UpdatedPriceData.front_lean_utility_price_changed = true;
        cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
        cuBuilding.UpdateFrontLean("walls");
    }
    if (params.add_back_lean == true) {
        const_var.UpdatedPriceData.wainscot_price_changed = true;
        // const_var.UpdatedPriceData.color_price_changed = true;
        const_var.UpdatedPriceData.roof_color_price_changed = true;
        const_var.UpdatedPriceData.wall_color_price_changed = true;
        const_var.UpdatedPriceData.trim_color_price_changed = true;
        const_var.UpdatedPriceData.back_lean_left_wall_price_changed = true;
        const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;
        const_var.UpdatedPriceData.back_lean_back_wall_price_changed = true;
        const_var.UpdatedPriceData.back_lean_utility_price_changed = true;
        cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
        cuBuilding.UpdateBackLean("walls");
    }
    if (params.add_right_lean == true) {
        const_var.UpdatedPriceData.wainscot_price_changed = true;
        // const_var.UpdatedPriceData.color_price_changed = true;
        const_var.UpdatedPriceData.roof_color_price_changed = true;
        const_var.UpdatedPriceData.wall_color_price_changed = true;
        const_var.UpdatedPriceData.trim_color_price_changed = true;
        const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
        const_var.UpdatedPriceData.right_lean_front_wall_price_changed = true;
        const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
        const_var.UpdatedPriceData.right_lean_utility_price_changed = true;
        cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
        cuBuilding.UpdateRightLean("walls");
    }
    if (params.add_right_lean == false && params.add_left_lean == false) {
        cuBuilding.cP();
    }
    dynamicWallOptions(state)
    cuBuilding.BuildingUpdate(true, 'leanwall');
    //cuBuilding.C(); 

}

const updateWainscot = (state) => {
    state.params.p_w_c_n = !state.params.p_w_c_n;
    params.p_w_c_c = params.p_t_c
    let filterName = const_var.color.filter((item) => {
        if(item.hex_value.replace("#", "0x") == params.p_t_c){
            return item.hex_value
        }
    })
    if(filterName.length > 0){
        params.p_w_c_c_name = filterName[0].name
    }
    cuBuilding.BuildingUpdate(true);
    cuBuilding.cP();
}

const removeWainscot = (state) => {
    state.params.p_w_c_n = false;
    if (params.add_front_lean) {
        (Object.keys(const_var.wallsData['frontLean']).length>0 && (const_var.wallsData['frontLean'].closedSideWalls!=0 || const_var.wallsData['frontLean'].closedEndWalls!=0 )) ? params.p_w_c_n = true: params.p_w_c_n = false;
    };
    if (params.add_left_lean) {
        (Object.keys(const_var.wallsData['leftLean']).length>0 && (const_var.wallsData['leftLean'].closedSideWalls!=0 || const_var.wallsData['leftLean'].closedEndWalls!=0 )) ? params.p_w_c_n = true: params.p_w_c_n = false;
    };
    if (params.add_right_lean) {
        (Object.keys(const_var.wallsData['rightLean']).length>0 && (const_var.wallsData['rightLean'].closedSideWalls!=0 || const_var.wallsData['rightLean'].closedEndWalls!=0 )) ? params.p_w_c_n = true: params.p_w_c_n = false;
    };
    if (params.add_back_lean) {
        (Object.keys(const_var.wallsData['backLean']).length>0 && (const_var.wallsData['backLean'].closedSideWalls!=0 || const_var.wallsData['backLean'].closedEndWalls!=0 )) ? params.p_w_c_n = true: params.p_w_c_n = false;
    };
    cuBuilding.cP();
}

const handleLeanToWallSelectonChangeValue = (state, e, wall) => {
    checkForFullEnclosedBuilding(state);
    const_var.UpdatedPriceData.insulation_price_changed = true;
    cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
    cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
    cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
    cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
    const_var.UpdatedPriceData.wainscot_price_changed = true;
    const_var.UpdatedPriceData.surcharge_amount = undefined;
}

const checkForFullEnclosedBuilding = (state) => {
    if (state.params.p_b_c_b_f_b == "Close" && state.params.p_b_c_b_f_f == "Close" && state.params.p_b_c_b_f_l == "Close") {
        state.params.p_c_a_f_l_w = true;
    } else {
        state.params.p_c_a_f_l_w = false;
    }
    if (state.params.p_b_c_b_b_f == "Close" && state.params.p_b_c_b_b_b == "Close" && state.params.p_b_c_b_b_l == "Close") {
        state.params.p_c_a_b_l_w = true;
    } else {
        state.params.p_c_a_b_l_w = false;
    }
    if (state.params.p_b_c_b_l_f == "Close" && state.params.p_b_c_b_l_b == "Close" && state.params.p_b_c_b_l == "Close") {
        state.params.p_c_a_l_l_w = true;
    } else {
        state.params.p_c_a_l_l_w = false;
    }

    if (state.params.p_b_c_b_r_f == "Close" && state.params.p_b_c_b_r_b == "Close" && state.params.p_b_c_b_r == "Close") {
        state.params.p_c_a_r_l_w = true;
    } else {
        state.params.p_c_a_r_l_w = false;
    }
    if (state.params.p_c_a_l_l_w != true) {
        state.isFullyEnclosedCheckedForLeftLeanTo = false;
        state.isFullyOpenedCheckedForLeftLeanTo = true;
    }
    else {
        state.isFullyEnclosedCheckedForLeftLeanTo = true;
        state.isFullyOpenedCheckedForLeftLeanTo = false;
    }
    if (state.params.p_c_a_r_l_w != true) {
        state.isFullyEnclosedCheckedForRightLeanTo = false;
        state.isFullyOpenedCheckedForRightLeanTo = true;
    }
    else {
        state.isFullyEnclosedCheckedForRightLeanTo = true;
        state.isFullyOpenedCheckedForRightLeanTo = false;
    }
    if (state.params.p_c_a_f_l_w != true) {
        state.isFullyEnclosedCheckedForFrontLeanTo = false;
        state.isFullyOpenedCheckedForFrontLeanTo = true;
    }
    else {
        state.isFullyEnclosedCheckedForFrontLeanTo = true;
        state.isFullyOpenedCheckedForFrontLeanTo = false;
    }
    if (state.params.p_c_a_b_l_w != true) {
        state.isFullyEnclosedCheckedForBackLeanTo = false;
        state.isFullyOpenedCheckedForBackLeanTo = true;
    }
    else {
        state.isFullyEnclosedCheckedForBackLeanTo = true;
        state.isFullyOpenedCheckedForBackLeanTo = false;
    }
    if(( params.p_f_w=="Half Dutch End" || params.p_f_w=="Half End" || params.p_b_w=="Half Dutch End" || params.p_b_w=="Half End" || (params.p_f_w=="Close" || params.p_b_w=="Close" || params.p_l_w=="Close" || params.p_r_w=="Close") || (params.p_b_c_b_l_f=="Close" || params.p_b_c_b_l=="Close" || params.p_b_c_b_r_f=="Close" || params.p_b_c_b_r=="Close" || params.p_b_c_b_f_f=="Close" || params.p_b_c_b_f_b=="Close" || params.p_b_c_b_f_l=="Close" || params.p_b_c_b_b_f=="Close" || params.p_b_c_b_b_b=="Close" || params.p_b_c_b_b_l=="Close")|| (params.add_storage_check==true) || (params.add_storage_check_right==true) || (params.add_storage_check_front==true) || (params.add_storage_check_back==true) || (params.p_u_c==true))
        || (params.p_b_c_b_l_f=="Half Dutch End" || params.p_b_c_b_l_f=="Half End" || params.p_b_c_b_l_b=="Half Dutch End" || params.p_b_c_b_l_b=="Half End")
        || (params.p_b_c_b_b_f=="Half Dutch End" || params.p_b_c_b_b_f=="Half End" || params.p_b_c_b_b_b=="Half Dutch End" || params.p_b_c_b_b_b=="Half End")
        || (params.p_b_c_b_f_f=="Half Dutch End" || params.p_b_c_b_f_f=="Half End" || params.p_b_c_b_f_b=="Half Dutch End" || params.p_b_c_b_f_b=="Half End")
        || (params.p_b_c_b_r_f=="Half Dutch End" || params.p_b_c_b_r_f=="Half End" || params.p_b_c_b_r_b=="Half Dutch End" || params.p_b_c_b_r_b=="Half End")
    )
        {
            const_var.showWainscotJSX = true;
        }else{
            const_var.showWainscotJSX = false;
        }
        if(((params.p_f_w!="Open" || params.p_b_w!="Open" || params.p_l_w!="Open" || params.p_r_w!="Open") || (params.p_b_c_b_l_f!="Open" || params.p_b_c_b_l!="Open" || params.p_b_c_b_r_f!="Open" || params.p_b_c_b_r!="Open" || params.p_b_c_b_f_f!="Open" || params.p_b_c_b_f_b!="Open" || params.p_b_c_b_f_l!="Open" || params.p_b_c_b_b_f!="Open" || params.p_b_c_b_b_b!="Open" || params.p_b_c_b_b_l!="Open") || (params.p_u_c==true) || (params.add_storage_check==true) || (params.add_storage_check_right==true) || (params.add_storage_check_front==true) || (params.add_storage_check_back==true) || (params.p_c_p_l==true || params.p_c_p_r==true)))
        {
            const_var.showWallColorJSX = true;
        }else{
            const_var.showWallColorJSX = false;
        }
}

const handleAddUtilityCheckboxChange = (state) => {

    if (state.params.p_u_c) {
        state.params.p_u_t = Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
        state.isFullyEnclosedChecked = false;
        state.params.p_u_f_w = "Close";
        state.params.p_f_w = "Open";
        state.params.p_f_w_f = state.params.p_f_w;
        state.params.p_b_w = "Open";
        const_var.UpdatedPriceData.utility_price_changed = true;
        if ((params.p_r_s == "4" || params.p_r_s == "5") && params.p_b_t == "2") {
            state.params.p_l_w = '1';
            state.params.p_r_w = '1';
        } else {
            state.params.p_l_w = "Open";
            state.params.p_r_w = "Open";
        }
        const_var.UpdatedPriceData.right_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_price_changed = true;
    } else {
        state.params.p_u_f_w = "Open";
        state.params.p_f_w = "Open";
        state.params.p_b_w = "Open";
        state.params.p_l_w = "Open";
        state.params.p_r_w = "Open";
        state.params.p_f_w_f = state.params.p_f_w;
    }
    const_var.UpdatedPriceData.surcharge_amount = undefined;
    cuBuilding.BuildingUpdate(true, 'utilitywall');
    cuBuilding.cP();
}


const handleUtilityLenghtSelectonChangeValue = (str, e, state) => {
    const_var.UpdatedPriceData.insulation_price = undefined;
    if (str == "front") {

        state.params.add_storage_front = e.target.value;
        cuBuilding.UpdateFrontLean("walls");
        const_var.UpdatedPriceData.insulation_price_changed = true;
        const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;
        const_var.UpdatedPriceData.front_lean_utility_price_changed = true;
        const_var.UpdatedPriceData.front_lean_roof_pitch_price_changed = true;
    }
    if (str == "back") {
        state.params.add_storage_back = e.target.value;
        cuBuilding.UpdateBackLean("walls");
        const_var.UpdatedPriceData.insulation_price_changed = true;
        const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;
        const_var.UpdatedPriceData.back_lean_utility_price_changed = true;
        const_var.UpdatedPriceData.back_lean_roof_pitch_price_changed = true;
    }
    if (str == "left") {
        state.params.add_storage = e.target.value;
        cuBuilding.UpdateLeftLean("walls");
        const_var.UpdatedPriceData.insulation_price_changed = true;
        const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
        const_var.UpdatedPriceData.left_lean_utility_price_changed = true;
        const_var.UpdatedPriceData.left_lean_roof_pitch_price_changed = true;
    }
    if (str == "right") {
        state.params.add_storage_right = e.target.value;
        cuBuilding.UpdateRightLean("walls");
        const_var.UpdatedPriceData.insulation_price_changed = true;
        const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
        const_var.UpdatedPriceData.right_lean_utility_price_changed = true;
        const_var.UpdatedPriceData.right_lean_roof_pitch_price_changed = true;
    }
    if (str == "center") {
        state.params.p_u_t = e.target.value;
        const_var.UpdatedPriceData.insulation_price_changed = true;
        const_var.UpdatedPriceData.right_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_price_changed = true;
        const_var.UpdatedPriceData.utility_price_changed = true;
        const_var.UpdatedPriceData.surcharge_amount = undefined;
        cuBuilding.BuildingUpdate(true, 'utilitywall');
        cuBuilding.cP();
    }
    if (str == "centerRight") {
        const_var.UpdatedPriceData.insulation_price_changed = true;
        state.params.cB_addStorage_right = e.target.value;
        const_var.UpdatedPriceData.right_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_price_changed = true;
        const_var.UpdatedPriceData.utility_price_changed = true;
        const_var.UpdatedPriceData.surcharge_amount = undefined;
        cuBuilding.BuildingUpdate(true, 'utilitywallRight');
        cuBuilding.cP();
    }
    if (str == "centerRightUtility") {
        const_var.UpdatedPriceData.insulation_price_changed = true;
        state.params.cB_addStorage_right_utility = e.target.value;
        const_var.UpdatedPriceData.right_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_price_changed = true;
        const_var.UpdatedPriceData.utility_price_changed = true;
        const_var.UpdatedPriceData.surcharge_amount = undefined;
        cuBuilding.BuildingUpdate(true, 'utilitywallRightU');
        cuBuilding.cP();
    }
    if (str == "centerLeft") {
        const_var.UpdatedPriceData.insulation_price_changed = true;
        state.params.cB_addStorage_left = e.target.value;
        const_var.UpdatedPriceData.right_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_price_changed = true;
        const_var.UpdatedPriceData.front_wall_price_changed = true;
        const_var.UpdatedPriceData.utility_price_changed = true;
        const_var.UpdatedPriceData.surcharge_amount = undefined;
        cuBuilding.BuildingUpdate(true, 'utilitywallLeft');
        cuBuilding.cP();
    }
    if (str == "centerLeftUtility") {
        const_var.UpdatedPriceData.insulation_price_changed = true;
        state.params.cB_addStorage_left_utility = e.target.value;
        const_var.UpdatedPriceData.right_wall_price_changed = true;
        const_var.UpdatedPriceData.left_wall_price_changed = true;
        const_var.UpdatedPriceData.utility_price_changed = true;
        const_var.UpdatedPriceData.surcharge_amount = undefined;
        cuBuilding.BuildingUpdate(true, 'utilitywallLeftUtility');
        cuBuilding.cP();
    }
 

}
const setDefaultConfiguration = (state, data) => {
    state.selectedTabstate = 'buildingtypetab';
    const_var.checkLoadDefaultBuildingRespone = true;
    const_var.hodldEditBuildingData = data.request_data.building;
    const_var.UpdatedPriceData = data.request_data.building;
    const_var.SendAPIBuildingData = const_var.editAPIDataByResponse.data.building_data;
    const_var.a_p_d_a = data.pricing_data;
    if(const_var.crmSetting.is_Edit == true &&  const_var.a_p_d_a.old_insulation != undefined) {
        const_var.a_p_d_a["old_insulation"] = const_var.a_p_d_a.old_insulation;
    } else {
        const_var.a_p_d_a["old_insulation"] = const_var.a_p_d_a.insulation;
    }
    
    state.const_var.tabCountStateDisplay = true;
    state.defaultBuilding = undefined;
    const_var.crmSetting.module_id_string = data.module_id_string;
    for (var i = 0; i <= data.request_data.building.leanto.length - 1; i++) {
        if (data.request_data.building.leanto[i].leanto_type == "1") {
            const_var.newLeanArr['left'] = data.request_data.building.leanto[i];
            const_var.newLeanArr['left'].main_index = i;
            const_var.UpdatedPriceData.leanto[i] = data.request_data.building.leanto[i];
        }
        if (data.request_data.building.leanto[i].leanto_type == "3") {
            const_var.newLeanArr['front'] = data.request_data.building.leanto[i];
            const_var.newLeanArr['front'].main_index = i;
            const_var.UpdatedPriceData.leanto[i] = data.request_data.building.leanto[i];
        }
        if (data.request_data.building.leanto[i].leanto_type == "4") {
            const_var.newLeanArr['back'] = data.request_data.building.leanto[i];
            const_var.newLeanArr['back'].main_index = i;
            const_var.UpdatedPriceData.leanto[i] = data.request_data.building.leanto[i];
        }
        if (data.request_data.building.leanto[i].leanto_type == "2") {
            const_var.newLeanArr['right'] = data.request_data.building.leanto[i];
            const_var.newLeanArr['right'].main_index = i;
            const_var.UpdatedPriceData.leanto[i] = data.request_data.building.leanto[i];
        }
    }
    if(data.request_data.building.display_building_type_name == "Custom Buildings"){
        state.const_var.checkmoreCustomizeFlag = true;
    }
    cuBuilding.EditloadDefaultBuilding(state, data.request_data, data.tax, data.building_images, data.personal_info, data.states,data);
    

}
const addCustomComponent = (state, event, value, componentName) => {
    state.const_var.CheckDoorForEdit = false;
    state.params.DoorPosOnEdit = "";
    state.params.UpdatedDoorPosOnEdit = "";
    state.params.DoorLocOnEdit = "";
    state.params.DoorRotOnEdit = "";
    state.const_var.StopPRAPI = true;
    //state.params.doorType = "Garage";        
    if (value !== 'CustomFrameout' && componentName !== 'Select') {
        state.params.p_a_g_r_u_d_c_s = "Select"
        state.params.p_a_g_r_u_d = "Select";
        state.params.p_w_cc = "Select";
        state.params.p_d_c = "Select";
        const_var.custDM = {};
        //f_r_o_d = "";
    }
    if (value == 'CustomFrameout' && componentName != '') {
        state.params.doorType = value;
        state.params.p_a_g_r_u_d = "Select";
        state.params.f_r_m_o_t = "Select";
        state.params.f_r_m_o_t1 = "Select";
        state.params.p_w_cc = "Select";
        state.params.p_d_c = "Select";
        const_var.custDM = {};
        //f_r_o_d = "";
    }
    cuBuilding.cP();
}
const mapDoorsEntryPointsForNonLoginInspirationalFlow =(iid,customDoorData,index,existingData,requestDataEntryPoint,parentkey) => {
    // console.log(iid,customDoorData,index,existingData,requestDataEntryPoint,"iid,customDoorData,index,existingData,requestDataEntryPoint")
    if(existingData!=undefined)
    {
    //AddDoorComponentonWall(existingData.door_type, data1.component_name, data1.component_wall_name, data1.name, data1.parent_array_key, data1.child_array_key, data1.nested_array_key, data1.entry_rotation==undefined?0:data1.entry_rotation, data1.entry_position,undefined,data1.entry_size)
    let newDoorName = existingData.door_type;
    if(existingData.door_type == "overhead_door_door")
    {
        if (existingData.door_add_ons?.[0]?.category[0] != undefined) {
        newDoorName = `${existingData.door_type}_${(existingData.door_add_ons?.[0]?.category[0].category.split(' ').join('_')).toLowerCase()}`
       }
    }
    // console.log(requestDataEntryPoint.entry_type, newDoorName, requestDataEntryPoint.component_wall_name, existingData.name, parentkey, existingData.door_type, existingData.door_category,"requestDataEntryPoint.entry_type, newDoorName, requestDataEntryPoint.component_wall_name, existingData.name, parentkey, existingData.door_type, existingData.door_category")                                      
    if(parentkey.includes('_Frameout'))
    {
        AddDoorComponentonWall(requestDataEntryPoint.entry_type, requestDataEntryPoint.child_array_key, requestDataEntryPoint.component_wall_name, (parentkey== 'Garage_Frameout' && existingData.length>0)?existingData[0]:existingData.name, parentkey, requestDataEntryPoint.child_array_key, requestDataEntryPoint.nested_array_key);
    }else{
        AddDoorComponentonWall(requestDataEntryPoint.entry_type, newDoorName, requestDataEntryPoint.component_wall_name, existingData.name, parentkey, existingData.door_type, existingData.door_category);
    }
    
    }
    //return data1
}
const makeComponentArrayForOtherBuildingForInspiration = (state, iid) => {
    commonFunctionForComponent();
    const_var.CustomDoorArrForOtherBtypeInspiration = {};

    //state.const_var.customFrameoutInitialSize = '';
    const_var.CustomDoorArrForOtherBtypeInspiration['Garage'] = [];
    const_var.CustomDoorArrForOtherBtypeInspiration['Garage_Frameout'] = [];
    const_var.CustomDoorArrForOtherBtypeInspiration['Windows'] = [];
    const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'] = [];
    const_var.CustomDoorArrForOtherBtypeInspiration['Walk'] = [];
    const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'] = [];
    const_var.CustomDoorArrForOtherBtypeInspiration['Garage_Frameout']['standard_door'] = [];
    const_var.CustomDoorArrForOtherBtypeInspiration['Garage_Frameout']['standard_door']['Roll-Up'] = [];
    const_var.CustomDoorArrForOtherBtypeInspiration['Garage_Frameout']['standard_door']['Roll-Up']["Size"] = [];
    const_var.CustomDoorArrForOtherBtypeInspiration['Garage_Frameout']['standard_door']['Roll-Up']["Width"] = [];
    const_var.CustomDoorArrForOtherBtypeInspiration['Garage_Frameout']['standard_door']['Roll-Up']["Height"] = [];
    const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'] = [];
    let garageDoorSubCategory,walkinDoorSubCategory,walkinFrameDoorSubCategory,windowsDoorSubCategory,windowsFrameDoorSubCategory  = "";
    // console.log(state.const_var.c_m_a,"state.const_var.c_m_a")
     let newData = const_var.a_p_d_a;
        Object.entries(newData.garage_door_v3).map(([key, value], index) => {
            // console.log(key, value,"newData.garage_door_v3");
            const_var.CustomDoorArrForOtherBtypeInspiration['Garage'][key] = [];
            for (var i = 0; i < newData.garage_door_v3[key].length; i++) {
                if(key=="standard_door")
                {
                    garageDoorSubCategory = newData.garage_door_v3[key][i].name;
                }
                // console.log(newData.garage_door_v3,newData.garage_door_v3[key],newData.garage_door_v3[key][i],newData.garage_door_v3[key][i].name);
                const_var.CustomDoorArrForOtherBtypeInspiration['Garage'][key][newData.garage_door_v3[key][i].name] = newData.garage_door_v3[key][i].data;
                //state.const_var.CustomDoorArrForOtherBtypeInspiration['Garage'][key][newData.garage_door_v3[key][i].name]['garageDoorColor'] = state.params.g_d_c_Obj;
                const_var.CustomDoorArrForOtherBtypeInspiration['Garage'][key][newData.garage_door_v3[key][i].name]["Size"] = [];

                for (var ii = 0; ii <= newData.garage_door_v3[key][i].data.length - 1; ii++) {
                    const_var.CustomDoorArrForOtherBtypeInspiration['Garage'][key][newData.garage_door_v3[key][i].name]["Size"][newData.garage_door_v3[key][i].data[ii].name] = newData.garage_door_v3[key][i].data[ii];

                    // if (const_var.loginSession != false && ii == newData.garage_door_v3[key][i].data.length - 1) {
                    //     state.const_var.CustomDoorArrForOtherBtypeInspiration['Garage'][key][newData.garage_door_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                    // }

                    const_var.CustomDoorArrForOtherBtypeInspiration['Garage'][key][newData.garage_door_v3[key][i].name]["Size"][newData.garage_door_v3[key][i].data[ii].name].end_wall_price = newData.garage_door_v3[key][i].data[ii].cost;
                    const_var.CustomDoorArrForOtherBtypeInspiration['Garage'][key][newData.garage_door_v3[key][i].name]["Size"][newData.garage_door_v3[key][i].data[ii].name].side_wall_price = newData.garage_door_v3[key][i].data[ii].side_cost + newData.garage_door_v3[key][i].data[ii].cost;
                }
            }

        })

        if ((newData.garage_door_frameout.length > 0)) {
            for (var j = 0; j < newData.garage_door_frameout.length; j++) {
                if ((newData.garage_door_frameout[j].frame_out_length != 0 || newData.garage_door_frameout[j].height != 0)) {
                    if (newData.garage_door_frameout[j].is_fixed == 0) {

                        if (newData.garage_door_frameout[j].frame_out_length != 0) {


                            var spl_val = "";
                            if ((newData.garage_door_frameout[j].building_height == 0 || params.p_h >= newData.garage_door_frameout[j].building_height) &&
                                (newData.garage_door_frameout[j].building_width == 0 || params.p_w >= newData.garage_door_frameout[j].building_width) &&
                                (newData.garage_door_frameout[j].building_length == 0 || params.p_d >= newData.garage_door_frameout[j].building_length)) {
                                spl_val = newData.garage_door_frameout[j].frame_out_length.split("-");
                            }

                            //var spl_val = newData.garage_door_frameout[j].frame_out_length.split("-");
                            //width_heigh_arr.push(spl_val[0],spl_val[1]);
                            for (var jj = Number(spl_val[0]); jj <= Number(spl_val[1]); jj++) {

                                for (var ii = 6; ii <= params.p_h; ii++) {

                                    // if (state.const_var.customFrameoutInitialSize == "") {
                                    //     state.const_var.customFrameoutInitialSize = jj + "x" + ii;
                                    // }
                                    const_var.CustomDoorArrForOtherBtypeInspiration['Garage_Frameout']['standard_door']['Roll-Up']["Size"][jj + "x" + ii] = newData.garage_door_frameout[j];
                                    const_var.CustomDoorArrForOtherBtypeInspiration['Garage_Frameout']['standard_door']['Roll-Up']["Size"][jj + "x" + ii].end_wall_price = newData.garage_door_frameout[j].on_end;
                                    const_var.CustomDoorArrForOtherBtypeInspiration['Garage_Frameout']['standard_door']['Roll-Up']["Size"][jj + "x" + ii].side_wall_price = newData.garage_door_frameout[j].on_side;
                                    const_var.CustomDoorArrForOtherBtypeInspiration['Garage_Frameout']['standard_door']['Roll-Up']["Width"][jj] = jj;
                                    const_var.CustomDoorArrForOtherBtypeInspiration['Garage_Frameout']['standard_door']['Roll-Up']["Height"][ii] = ii;

                                }
                            }

                        }
                    } else {

                        const_var.CustomDoorArrForOtherBtypeInspiration['Garage_Frameout']['standard_door']['Roll-Up']["Size"][newData.garage_door_frameout[j].frame_out_length + "x" + newData.garage_door_frameout[j].height] = newData.garage_door_frameout[j];
                        const_var.CustomDoorArrForOtherBtypeInspiration['Garage_Frameout']['standard_door']['Roll-Up']["Size"][newData.garage_door_frameout[j].frame_out_length + "x" + newData.garage_door_frameout[j].height].end_wall_price = newData.garage_door_frameout[j].on_end;
                        const_var.CustomDoorArrForOtherBtypeInspiration['Garage_Frameout']['standard_door']['Roll-Up']["Size"][newData.garage_door_frameout[j].frame_out_length + "x" + newData.garage_door_frameout[j].height].side_wall_price = newData.garage_door_frameout[j].on_side;
                    }
                }
            }

        }
        if(newData.walkin_door_v3 != undefined)
        {
            Object.entries(newData.walkin_door_v3).map(([key, value], index) => {
                 const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][key] = [];
                
                for (var i = 0; i < newData.walkin_door_v3[key].length; i++) {
                    if(key=="standard_walkin")
                    {
                        walkinDoorSubCategory = newData.walkin_door_v3[key][i].name;
                    }
                    const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][key][newData.walkin_door_v3[key][i].name] = newData.walkin_door_v3[key][i].data;
                    const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][key][newData.walkin_door_v3[key][i].name]["Size"] = [];

                    for (var ii = 0; ii <= newData.walkin_door_v3[key][i].data.length - 1; ii++) {
                        const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][key][newData.walkin_door_v3[key][i].name]["Size"][newData.walkin_door_v3[key][i].data[ii].name] = newData.walkin_door_v3[key][i].data[ii];

                        // if (const_var.loginSession != false && ii == newData.walkin_door_v3[key][i].data.length - 1) {
                        //     state.const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][key][newData.walkin_door_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        // }

                        const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][key][newData.walkin_door_v3[key][i].name]["Size"][newData.walkin_door_v3[key][i].data[ii].name].end_wall_price = newData.walkin_door_v3[key][i].data[ii].cost;

                        const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][key][newData.walkin_door_v3[key][i].name]["Size"][newData.walkin_door_v3[key][i].data[ii].name].side_wall_price = newData.walkin_door_v3[key][i].data[ii].cost + newData.walkin_door_v3[key][i].data[ii].vertical_side_cost + newData.walkin_door_v3[key][i].data[ii].on_side_cost;

                    }
                }

            })

            Object.entries(newData.walkin_door_frameout_v3).map(([key, value], index) => {
                 const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][key] = [];

                for (var i = 0; i < newData.walkin_door_frameout_v3[key].length; i++) {
                    if(key=="standard_walkin")
                    {               
                        walkinFrameDoorSubCategory = newData.walkin_door_frameout_v3[key][i].name;
                    }
                    const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name] = newData.walkin_door_frameout_v3[key][i].data;
                     const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"] = [];
                    
                    for (var ii = 0; ii <= newData.walkin_door_frameout_v3[key][i].data.length - 1; ii++) {
                         const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name] = newData.walkin_door_frameout_v3[key][i].data[ii];

                         const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name].end_wall_price = newData.walkin_door_frameout_v3[key][i].data[ii].frameout_cost_end;

                         const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name].side_wall_price = newData.walkin_door_frameout_v3[key][i].data[ii].frameout_cost_side + newData.walkin_door_frameout_v3[key][i].data[ii].vertical_side_cost;
                        
                        // if (const_var.loginSession != false && ii == newData.walkin_door_frameout_v3[key][i].data.length - 1) {
                        //     state. const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        // }
                        

                    }
                }

            })
            
        }
        else{   
            Object.entries(newData.walkin_door_frameout_v3).map(([key, value], index) => {
                const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][key] = [];
                const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][key] = [];
    
                for (var i = 0; i < newData.walkin_door_frameout_v3[key].length; i++) {
                    if(key=="standard_walkin")
                    {
                        walkinDoorSubCategory = newData.walkin_door_frameout_v3[key][i].name;                        
                    }
                    const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][key][newData.walkin_door_frameout_v3[key][i].name] = newData.walkin_door_frameout_v3[key][i].data;
                    const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"] = [];
    
                    const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name] = newData.walkin_door_frameout_v3[key][i].data;
                    const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"] = [];
    
                    for (var ii = 0; ii <= newData.walkin_door_frameout_v3[key][i].data.length - 1; ii++) {
                        const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name] = newData.walkin_door_frameout_v3[key][i].data[ii];
    
                        // if (const_var.loginSession != false && ii == newData.walkin_door_frameout_v3[key][i].data.length - 1) {
                        //     state.const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][key][newData.walkin_door_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        //     state.const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        // }
    
                        const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name].end_wall_price = newData.walkin_door_frameout_v3[key][i].data[ii].cost;
    
                        const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name].side_wall_price = newData.walkin_door_frameout_v3[key][i].data[ii].cost + newData.walkin_door_frameout_v3[key][i].data[ii].vertical_side_cost + newData.walkin_door_frameout_v3[key][i].data[ii].on_side_cost;
    
    
    
                        const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name] = newData.walkin_door_frameout_v3[key][i].data[ii];
    
                        const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name].end_wall_price = newData.walkin_door_frameout_v3[key][i].data[ii].frameout_cost_end;
    
                        const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name].side_wall_price = newData.walkin_door_frameout_v3[key][i].data[ii].frameout_cost_side + newData.walkin_door_frameout_v3[key][i].data[ii].vertical_side_cost;
                    }
                }
    
            })
        }
        if(newData.window_v3!=undefined){
            
            Object.entries(newData.window_v3).map(([key, value], index) => {
                const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][key] = [];
                for (var i = 0; i < newData.window_v3[key].length; i++) {
                    if(key=="standard_window")
                    {
                        windowsDoorSubCategory = newData.window_v3[key][i].name;
                    }
                    const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][key][newData.window_v3[key][i].name] = newData.window_v3[key][i].data;
                    const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][key][newData.window_v3[key][i].name]["Size"] = [];
    
                    for (var ii = 0; ii <= newData.window_v3[key][i].data.length - 1; ii++) {
                        const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][key][newData.window_v3[key][i].name]["Size"][newData.window_v3[key][i].data[ii].name] = newData.window_v3[key][i].data[ii];
    
                        // if (const_var.loginSession != false && ii == newData.window_v3[key][i].data.length - 1) {
                        //     state.const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][key][newData.window_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        // }
    
                        const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][key][newData.window_v3[key][i].name]["Size"][newData.window_v3[key][i].data[ii].name].end_wall_price = newData.window_v3[key][i].data[ii].cost;
    
                        const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][key][newData.window_v3[key][i].name]["Size"][newData.window_v3[key][i].data[ii].name].side_wall_price = newData.window_v3[key][i].data[ii].cost + newData.window_v3[key][i].data[ii].vertical_side_cost;
    
                    }
                }
    
            })

            Object.entries(newData.window_frameout_v3).map(([key, value], index) => {
                const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][key] = [];
                for (var i = 0; i < newData.window_frameout_v3[key].length; i++) {

                    if(key=="standard_window" && newData.window_v3[key] != undefined)
                    {
                        windowsFrameDoorSubCategory = newData.window_v3[key][i].name;
                    }
                    const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name] = newData.window_frameout_v3[key][i].data;
                    const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]["Size"] = [];

                    for (var ii = 0; ii <= newData.window_frameout_v3[key][i].data.length - 1; ii++) {
                        

                    

                        const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name] = newData.window_frameout_v3[key][i].data[ii];

                        const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name].end_wall_price = newData.window_frameout_v3[key][i].data[ii].frameout_cost_end;

                        const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name].side_wall_price = newData.window_frameout_v3[key][i].data[ii].frameout_cost_side + newData.window_frameout_v3[key][i].data[ii].vertical_side_cost;
                        // if (const_var.loginSession != false && ii == newData.window_frameout_v3[key][i].data.length - 1) {
                        //     state.const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        // }
                    }
                    if(const_var.crmSetting.is_Edit==true && const_var.entry_points.length>0 && params.m_s_n==96)
                    {
                        let walkDoorObj = const_var.entry_points.filter(data=>(data.parent_array_key=="Windows_Frameout") && data.child_array_key == key)
                        if(walkDoorObj.length>0)
                        {
                            for(var ii =0; ii<=walkDoorObj.length-1;ii++)
                            {
                                if(state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i]!=undefined)
                                {
                                    walkDoorObj[ii].nested_array_key = state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name;
                                }
                            }
                        }
                    }
                }

            })

        }
        else{
            Object.entries(newData.window_frameout_v3).map(([key, value], index) => {
                const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][key] = [];
                const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][key] = [];
                for (var i = 0; i < newData.window_frameout_v3[key].length; i++) {
                    if(key=="standard_window")
                    {
                        windowsDoorSubCategory = newData.window_frameout_v3[key][i].name;
                    }
                    const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][key][newData.window_frameout_v3[key][i].name] = newData.window_frameout_v3[key][i].data;
                    const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][key][newData.window_frameout_v3[key][i].name]["Size"] = [];
    
    
                    const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name] = newData.window_frameout_v3[key][i].data;
                    const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]["Size"] = [];
    
                    for (var ii = 0; ii <= newData.window_frameout_v3[key][i].data.length - 1; ii++) {
                        const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name] = newData.window_frameout_v3[key][i].data[ii];
    
                        // if (const_var.loginSession != false && ii == newData.window_frameout_v3[key][i].data.length - 1) {
                        //     state.const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][key][newData.window_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        //     state.const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        // }
    
                        const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name].end_wall_price = newData.window_frameout_v3[key][i].data[ii].cost;
    
                        const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name].side_wall_price = newData.window_frameout_v3[key][i].data[ii].cost + newData.window_frameout_v3[key][i].data[ii].vertical_side_cost;
    
    
                        const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name] = newData.window_frameout_v3[key][i].data[ii];
    
                        const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name].end_wall_price = newData.window_frameout_v3[key][i].data[ii].frameout_cost_end;
    
                        const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name].side_wall_price = newData.window_frameout_v3[key][i].data[ii].frameout_cost_side + newData.window_frameout_v3[key][i].data[ii].vertical_side_cost;
                    }
                }
    
            })
        }
        let filterData = [];
    const isInpirationalFlow = const_var.isInspirtionGalleryEditFlow;
    // console.log(const_var.CustomDoorArrForOtherBtypeInspiration,"const_var.CustomDoorArrForOtherBtypeInspiration",{garageDoorSubCategory,walkinDoorSubCategory,walkinFrameDoorSubCategory,windowsDoorSubCategory,windowsFrameDoorSubCategory})
    let NewEntryPoint = isInpirationalFlow ? const_var.inspirationalQuotesDataById.entry_points: const_var.entry_points
    if (NewEntryPoint.length > 0) {
        NewEntryPoint.map((value, key) => {
            
            if (value.parent_array_key == "Garage") {
                // console.log(const_var.CustomDoorArrForOtherBtypeInspiration['Garage'],"const_var.CustomDoorArrForOtherBtypeInspiration['Garage']",value.child_array_key,value.nested_array_key)
                if(const_var.CustomDoorArrForOtherBtypeInspiration['Garage'][value.child_array_key]!=undefined && const_var.CustomDoorArrForOtherBtypeInspiration['Garage'][value.child_array_key][value.nested_array_key]!=undefined)
                {
                    if (const_var.CustomDoorArrForOtherBtypeInspiration['Garage'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Garage'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name)[0];
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key],const_var.inspirationalQuotesDataById.entry_points[key],'Garage')
                    }else{
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Garage'][value.child_array_key][value.nested_array_key][0];
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['Garage']['standard_door']['Roll-Up'][0],const_var.inspirationalQuotesDataById.entry_points[key],'Garage')
                        
                    } 
                }else
                {
                    if (const_var.CustomDoorArrForOtherBtypeInspiration['Garage']['standard_door'][garageDoorSubCategory].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Garage']['standard_door'][garageDoorSubCategory].filter(data => data.name == value.entry_size.name)[0];
                        // console.log(const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key],"const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key]",value)
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key],const_var.inspirationalQuotesDataById.entry_points[key],'Garage')
                    }else{
                        let data = const_var.CustomDoorArrForOtherBtypeInspiration['Garage']['standard_door'][garageDoorSubCategory].filter(data => data.name < value.entry_size.name);
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Garage']['standard_door'][garageDoorSubCategory][0];
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['Garage']['standard_door']['Roll-Up'][0],const_var.inspirationalQuotesDataById.entry_points[key],'Garage')

                        
                    } 
                }
                
                //filterData.push(newData.garage_door_v3.filter(data => data.name == value.entry_size.name));

            } if (value.parent_array_key == "Garage_Frameout" && !value.is_breezeway_frameout) {
                // console.log(const_var.CustomDoorArrForOtherBtypeInspiration['Garage_Frameout']['standard_door']['Roll-Up']['Size'],"Garage_Frameout");
                Object.entries(const_var.CustomDoorArrForOtherBtypeInspiration['Garage_Frameout']['standard_door']['Roll-Up']['Size']).map((val, index) => {
                //    console.log(index ,"index Garage_Frameout");
                    if (val[0] == value.name) {
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = val;
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key],const_var.inspirationalQuotesDataById.entry_points[key],'Garage_Frameout')
                    
                    } else {
                        if(index == 0){
                            const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = val;
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['Garage_Frameout']['standard_door']['Roll-Up']['Size'][0],const_var.inspirationalQuotesDataById.entry_points[key],'Garage_Frameout')

                        }
                    }
                });

            }
            if (value.parent_array_key == "Walk") {
                if(const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][value.child_array_key]!=undefined && const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][value.child_array_key][value.nested_array_key]!=undefined)
                {
                    if (const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name)[0];
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key],const_var.inspirationalQuotesDataById.entry_points[key],'Walk')
                    } else {
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][value.child_array_key][value.nested_array_key][0];
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][value.child_array_key][value.nested_array_key][0],const_var.inspirationalQuotesDataById.entry_points[key],'Walk')
                        
                    } 
                }else
                {
                    if (const_var.CustomDoorArrForOtherBtypeInspiration['Walk']['standard_walkin'] != undefined && const_var.CustomDoorArrForOtherBtypeInspiration['Walk']['standard_walkin'][walkinDoorSubCategory].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Walk']['standard_walkin'][walkinDoorSubCategory].filter(data => data.name == value.entry_size.name)[0];
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key],key,const_var.CustomDoorArrForOtherBtypeInspiration['Walk']['standard_walkin'][walkinDoorSubCategory].filter(data => data.name == value.entry_size.name)[0],const_var.inspirationalQuotesDataById.entry_points[key],'Walk')
                    } else {
                        if(const_var.CustomDoorArrForOtherBtypeInspiration['Walk']['standard_walkin'] == undefined){
                            if(const_var.CustomDoorArrForOtherBtypeInspiration['Walk'].length > 0 || Object.keys(const_var.CustomDoorArrForOtherBtypeInspiration['Walk']).length > 0){
                                let newDoorType = Object.keys(const_var.CustomDoorArrForOtherBtypeInspiration['Walk'])[0]
                                walkinDoorSubCategory = Object.keys(const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][newDoorType])[0]
                                const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][newDoorType][walkinDoorSubCategory][0];
                                mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key],key,const_var.CustomDoorArrForOtherBtypeInspiration['Walk'][newDoorType][walkinDoorSubCategory][0],const_var.inspirationalQuotesDataById.entry_points[key],'Walk')
                                
                            }
                        }
                        else{
                            const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Walk']['standard_walkin'][walkinDoorSubCategory][0];
                            mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key],key,const_var.CustomDoorArrForOtherBtypeInspiration['Walk']['standard_walkin'][walkinDoorSubCategory][0],const_var.inspirationalQuotesDataById.entry_points[key],'Walk')
                            
                        }
                    } 
                }

               
            }
            if (value.parent_array_key == "Walk_Frameout") {

                if(const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][value.child_array_key]!=undefined && const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][value.child_array_key][value.nested_array_key]!=undefined)
                {
                    if (const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name)[0];
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name)[0],const_var.inspirationalQuotesDataById.entry_points[key],'Walk_Frameout')
                    } else {
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][value.child_array_key][value.nested_array_key][0];
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key],key,const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout'][value.child_array_key][value.nested_array_key][0],const_var.inspirationalQuotesDataById.entry_points[key],'Walk_Frameout')
                        
                    } 
                }else
                {
                    if (const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout']['standard_walkin'][walkinFrameDoorSubCategory].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout']['standard_walkin'][walkinFrameDoorSubCategory].filter(data => data.name == value.entry_size.name)[0];
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout']['standard_walkin'][walkinFrameDoorSubCategory].filter(data => data.name == value.entry_size.name)[0],const_var.inspirationalQuotesDataById.entry_points[key],'Walk_Frameout')
                    } else {
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout']['standard_walkin'][walkinFrameDoorSubCategory][0];
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key],key,const_var.CustomDoorArrForOtherBtypeInspiration['Walk_Frameout']['standard_walkin'][walkinFrameDoorSubCategory][0],const_var.inspirationalQuotesDataById.entry_points[key],'Walk_Frameout')
                        
                    } 
                }

               
            }
            if (value.parent_array_key == "Windows") {


                if(const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][value.child_array_key]!=undefined && const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][value.child_array_key][value.nested_array_key]!=undefined)
                {
                    if (const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name)[0];
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name)[0],const_var.inspirationalQuotesDataById.entry_points[key],'Windows')
                        
                    } else {
                        let data = const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][value.child_array_key][value.nested_array_key].filter(data => data.name < value.entry_size.name);
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][value.child_array_key][value.nested_array_key][0];
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name)[0],const_var.inspirationalQuotesDataById.entry_points[key],'Windows')
                        
                    } 
                }else
                {
                    if (const_var.CustomDoorArrForOtherBtypeInspiration['Windows']['standard_window'] != undefined && const_var.CustomDoorArrForOtherBtypeInspiration['Windows']['standard_window'][windowsDoorSubCategory].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Windows']['standard_window'][windowsDoorSubCategory].filter(data => data.name == value.entry_size.name)[0];
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['Windows']['standard_window'][windowsDoorSubCategory].filter(data => data.name == value.entry_size.name)[0],const_var.inspirationalQuotesDataById.entry_points[key],'Windows')
                        
                    } else {
                        if(const_var.CustomDoorArrForOtherBtypeInspiration['Windows']['standard_window'] == undefined){
                            let newDoorType = Object.keys(const_var.CustomDoorArrForOtherBtypeInspiration['Windows'])[0]
                            windowsDoorSubCategory = Object.keys(const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][newDoorType])[0];
                            const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][newDoorType][windowsDoorSubCategory][0];
                            mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['Windows'][newDoorType][windowsDoorSubCategory][0],const_var.inspirationalQuotesDataById.entry_points[key],'Windows')
                        }
                        else{
                            const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Windows']['standard_window'][windowsDoorSubCategory][0];
                            mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['Windows']['standard_window'][windowsDoorSubCategory][0],const_var.inspirationalQuotesDataById.entry_points[key],'Windows')
                        }
                    } 
                }

            }

            if (value.parent_array_key == "Windows_Frameout") {


                if(const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][value.child_array_key]!=undefined && const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][value.child_array_key][value.nested_array_key]!=undefined)
                {
                    if (const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name)[0];
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name)[0],const_var.inspirationalQuotesDataById.entry_points[key],'Windows_Frameout')
                        
                    } else {
                      
                        let data = const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][value.child_array_key][value.nested_array_key].filter(data => data.name < value.entry_size.name);
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][value.child_array_key][value.nested_array_key][0];

                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][value.child_array_key][value.nested_array_key][0],const_var.inspirationalQuotesDataById.entry_points[key],'Windows_Frameout')
                    
                }
                }else
                {
                    if (const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout']['standard_window'][windowsFrameDoorSubCategory].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout']['standard_window'][windowsFrameDoorSubCategory].filter(data => data.name == value.entry_size.name)[0];
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout']['standard_window'][windowsFrameDoorSubCategory].filter(data => data.name == value.entry_size.name)[0],const_var.inspirationalQuotesDataById.entry_points[key],'Windows_Frameout')
                        
                    } else {
                        let data = const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout']['standard_window'][windowsFrameDoorSubCategory].filter(data => data.name < value.entry_size.name);
                        const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout']['standard_window'][windowsFrameDoorSubCategory][0];
                        mapDoorsEntryPointsForNonLoginInspirationalFlow(iid,const_var.CustomDoorArrForOtherBtypeInspiration,key,const_var.CustomDoorArrForOtherBtypeInspiration['Windows_Frameout'][value.child_array_key][value.nested_array_key][0],const_var.inspirationalQuotesDataById.entry_points[key],'Windows_Frameout')
                    } 
                }

            }

            
        })
    }
    
    // console.log(const_var.CustomDoorArrForOtherBtypeInspiration['selectedIndex'],iid,"const_var.CustomDoorArrForOtherBtypeInspiration['Garage'][value.child_array_key][value.nested_array_key]")
    // console.log(const_var.CustomDoorArrForOtherBtype,"const_var.CustomDoorArrForOtherBtype")

    // commonFunctionForComponent();

}

const makeComponentArrayForOtherBuilding = (state, iid) => {
    commonFunctionForComponent();
    const_var.CustomDoorArrForOtherBtype[iid] = {};

    //    state.const_var.customFrameoutInitialSize = '';
    const_var.CustomDoorArrForOtherBtype[iid]['Garage'] = [];
    const_var.CustomDoorArrForOtherBtype[iid]['Garage_Frameout'] = [];
    const_var.CustomDoorArrForOtherBtype[iid]['Windows'] = [];
    const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'] = [];
    const_var.CustomDoorArrForOtherBtype[iid]['Walk'] = [];
    const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'] = [];
    const_var.CustomDoorArrForOtherBtype[iid]['Garage_Frameout']['standard_door'] = [];
    const_var.CustomDoorArrForOtherBtype[iid]['Garage_Frameout']['standard_door']['Roll-Up'] = [];
    const_var.CustomDoorArrForOtherBtype[iid]['Garage_Frameout']['standard_door']['Roll-Up']["Size"] = [];
    const_var.CustomDoorArrForOtherBtype[iid]['Garage_Frameout']['standard_door']['Roll-Up']["Width"] = [];
    const_var.CustomDoorArrForOtherBtype[iid]['Garage_Frameout']['standard_door']['Roll-Up']["Height"] = [];
    const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'] = [];
    let garageDoorSubCategory,walkinDoorSubCategory,walkinFrameDoorSubCategory,windowsDoorSubCategory,windowsFrameDoorSubCategory  = "";
    // console.log(state.const_var.c_m_a,"state.const_var.c_m_a")
     let newData = const_var.ComparisionDataArray[iid].pricing_data;
        Object.entries(newData.garage_door_v3).map(([key, value], index) => {
            // console.log(key, value,"newData.garage_door_v3");
            const_var.CustomDoorArrForOtherBtype[iid]['Garage'][key] = [];
            for (var i = 0; i < newData.garage_door_v3[key].length; i++) {
                if(key=="standard_door")
                {
                    garageDoorSubCategory = newData.garage_door_v3[key][i].name;
                }
                // console.log(newData.garage_door_v3,newData.garage_door_v3[key],newData.garage_door_v3[key][i],newData.garage_door_v3[key][i].name);
                const_var.CustomDoorArrForOtherBtype[iid]['Garage'][key][newData.garage_door_v3[key][i].name] = newData.garage_door_v3[key][i].data;
                state.const_var.CustomDoorArrForOtherBtype[iid]['Garage'][key][newData.garage_door_v3[key][i].name]['garageDoorColor'] = state.params.g_d_c_Obj;
                const_var.CustomDoorArrForOtherBtype[iid]['Garage'][key][newData.garage_door_v3[key][i].name]["Size"] = [];

                for (var ii = 0; ii <= newData.garage_door_v3[key][i].data.length - 1; ii++) {
                    const_var.CustomDoorArrForOtherBtype[iid]['Garage'][key][newData.garage_door_v3[key][i].name]["Size"][newData.garage_door_v3[key][i].data[ii].name] = newData.garage_door_v3[key][i].data[ii];

                    if (const_var.loginSession != false && ii == newData.garage_door_v3[key][i].data.length - 1) {
                        state.const_var.CustomDoorArrForOtherBtype[iid]['Garage'][key][newData.garage_door_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                    }

                    const_var.CustomDoorArrForOtherBtype[iid]['Garage'][key][newData.garage_door_v3[key][i].name]["Size"][newData.garage_door_v3[key][i].data[ii].name].end_wall_price = newData.garage_door_v3[key][i].data[ii].cost;
                    const_var.CustomDoorArrForOtherBtype[iid]['Garage'][key][newData.garage_door_v3[key][i].name]["Size"][newData.garage_door_v3[key][i].data[ii].name].side_wall_price = newData.garage_door_v3[key][i].data[ii].side_cost + newData.garage_door_v3[key][i].data[ii].cost;
                }
            }

        })

        if ((newData.garage_door_frameout.length > 0)) {
            for (var j = 0; j < newData.garage_door_frameout.length; j++) {
                if ((newData.garage_door_frameout[j].frame_out_length != 0 || newData.garage_door_frameout[j].height != 0)) {
                    if (newData.garage_door_frameout[j].is_fixed == 0) {

                        if (newData.garage_door_frameout[j].frame_out_length != 0) {


                            var spl_val = "";
                            if ((newData.garage_door_frameout[j].building_height == 0 || state.params.p_h >= newData.garage_door_frameout[j].building_height) &&
                                (newData.garage_door_frameout[j].building_width == 0 || state.params.p_w >= newData.garage_door_frameout[j].building_width) &&
                                (newData.garage_door_frameout[j].building_length == 0 || state.params.p_d >= newData.garage_door_frameout[j].building_length)) {
                                spl_val = newData.garage_door_frameout[j].frame_out_length.split("-");
                            }

                            //var spl_val = newData.garage_door_frameout[j].frame_out_length.split("-");
                            //width_heigh_arr.push(spl_val[0],spl_val[1]);
                            for (var jj = Number(spl_val[0]); jj <= Number(spl_val[1]); jj++) {

                                for (var ii = 6; ii <= state.params.p_h; ii++) {

                                    // if (state.const_var.customFrameoutInitialSize == "") {
                                    //     state.const_var.customFrameoutInitialSize = jj + "x" + ii;
                                    // }
                                    const_var.CustomDoorArrForOtherBtype[iid]['Garage_Frameout']['standard_door']['Roll-Up']["Size"][jj + "x" + ii] = newData.garage_door_frameout[j];
                                    const_var.CustomDoorArrForOtherBtype[iid]['Garage_Frameout']['standard_door']['Roll-Up']["Size"][jj + "x" + ii].end_wall_price = newData.garage_door_frameout[j].on_end;
                                    const_var.CustomDoorArrForOtherBtype[iid]['Garage_Frameout']['standard_door']['Roll-Up']["Size"][jj + "x" + ii].side_wall_price = newData.garage_door_frameout[j].on_side;
                                    const_var.CustomDoorArrForOtherBtype[iid]['Garage_Frameout']['standard_door']['Roll-Up']["Width"][jj] = jj;
                                    const_var.CustomDoorArrForOtherBtype[iid]['Garage_Frameout']['standard_door']['Roll-Up']["Height"][ii] = ii;

                                }
                            }

                        }
                    } else {

                        const_var.CustomDoorArrForOtherBtype[iid]['Garage_Frameout']['standard_door']['Roll-Up']["Size"][newData.garage_door_frameout[j].frame_out_length + "x" + newData.garage_door_frameout[j].height] = newData.garage_door_frameout[j];
                        const_var.CustomDoorArrForOtherBtype[iid]['Garage_Frameout']['standard_door']['Roll-Up']["Size"][newData.garage_door_frameout[j].frame_out_length + "x" + newData.garage_door_frameout[j].height].end_wall_price = newData.garage_door_frameout[j].on_end;
                        const_var.CustomDoorArrForOtherBtype[iid]['Garage_Frameout']['standard_door']['Roll-Up']["Size"][newData.garage_door_frameout[j].frame_out_length + "x" + newData.garage_door_frameout[j].height].side_wall_price = newData.garage_door_frameout[j].on_side;
                    }
                }
            }

        }
        if(newData.walkin_door_v3 != undefined)
        {
            Object.entries(newData.walkin_door_v3).map(([key, value], index) => {
                 const_var.CustomDoorArrForOtherBtype[iid]['Walk'][key] = [];
                
                for (var i = 0; i < newData.walkin_door_v3[key].length; i++) {
                    if(key=="standard_walkin")
                    {
                        walkinDoorSubCategory = newData.walkin_door_v3[key][i].name;
                    }
                    const_var.CustomDoorArrForOtherBtype[iid]['Walk'][key][newData.walkin_door_v3[key][i].name] = newData.walkin_door_v3[key][i].data;
                    const_var.CustomDoorArrForOtherBtype[iid]['Walk'][key][newData.walkin_door_v3[key][i].name]["Size"] = [];

                    for (var ii = 0; ii <= newData.walkin_door_v3[key][i].data.length - 1; ii++) {
                        const_var.CustomDoorArrForOtherBtype[iid]['Walk'][key][newData.walkin_door_v3[key][i].name]["Size"][newData.walkin_door_v3[key][i].data[ii].name] = newData.walkin_door_v3[key][i].data[ii];

                        if (const_var.loginSession != false && ii == newData.walkin_door_v3[key][i].data.length - 1) {
                            state.const_var.CustomDoorArrForOtherBtype[iid]['Walk'][key][newData.walkin_door_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        }

                        const_var.CustomDoorArrForOtherBtype[iid]['Walk'][key][newData.walkin_door_v3[key][i].name]["Size"][newData.walkin_door_v3[key][i].data[ii].name].end_wall_price = newData.walkin_door_v3[key][i].data[ii].cost;

                        const_var.CustomDoorArrForOtherBtype[iid]['Walk'][key][newData.walkin_door_v3[key][i].name]["Size"][newData.walkin_door_v3[key][i].data[ii].name].side_wall_price = newData.walkin_door_v3[key][i].data[ii].cost + newData.walkin_door_v3[key][i].data[ii].vertical_side_cost + newData.walkin_door_v3[key][i].data[ii].on_side_cost;

                    }
                }

            })

            Object.entries(newData.walkin_door_frameout_v3).map(([key, value], index) => {
                 const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][key] = [];

                for (var i = 0; i < newData.walkin_door_frameout_v3[key].length; i++) {
                    if(key=="standard_walkin")
                    {               
                        walkinFrameDoorSubCategory = newData.walkin_door_frameout_v3[key][i].name;
                    }
                    const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name] = newData.walkin_door_frameout_v3[key][i].data;
                     const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"] = [];
                    
                    for (var ii = 0; ii <= newData.walkin_door_frameout_v3[key][i].data.length - 1; ii++) {
                         const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name] = newData.walkin_door_frameout_v3[key][i].data[ii];

                         const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name].end_wall_price = newData.walkin_door_frameout_v3[key][i].data[ii].frameout_cost_end;

                         const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name].side_wall_price = newData.walkin_door_frameout_v3[key][i].data[ii].frameout_cost_side + newData.walkin_door_frameout_v3[key][i].data[ii].vertical_side_cost;
                        
                        if (const_var.loginSession != false && ii == newData.walkin_door_frameout_v3[key][i].data.length - 1) {
                            state. const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        }
                        

                    }
                }

            })
            
        }
        else{   
            Object.entries(newData.walkin_door_frameout_v3).map(([key, value], index) => {
                const_var.CustomDoorArrForOtherBtype[iid]['Walk'][key] = [];
                const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][key] = [];
    
                for (var i = 0; i < newData.walkin_door_frameout_v3[key].length; i++) {
                    if(key=="standard_walkin")
                    {
                        walkinDoorSubCategory = newData.walkin_door_frameout_v3[key][i].name;                        
                    }
                    const_var.CustomDoorArrForOtherBtype[iid]['Walk'][key][newData.walkin_door_frameout_v3[key][i].name] = newData.walkin_door_frameout_v3[key][i].data;
                    const_var.CustomDoorArrForOtherBtype[iid]['Walk'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"] = [];
    
                    const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name] = newData.walkin_door_frameout_v3[key][i].data;
                    const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"] = [];
    
                    for (var ii = 0; ii <= newData.walkin_door_frameout_v3[key][i].data.length - 1; ii++) {
                        const_var.CustomDoorArrForOtherBtype[iid]['Walk'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name] = newData.walkin_door_frameout_v3[key][i].data[ii];
    
                        if (const_var.loginSession != false && ii == newData.walkin_door_frameout_v3[key][i].data.length - 1) {
                            state.const_var.CustomDoorArrForOtherBtype[iid]['Walk'][key][newData.walkin_door_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                            state.const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        }
    
                        const_var.CustomDoorArrForOtherBtype[iid]['Walk'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name].end_wall_price = newData.walkin_door_frameout_v3[key][i].data[ii].cost;
    
                        const_var.CustomDoorArrForOtherBtype[iid]['Walk'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name].side_wall_price = newData.walkin_door_frameout_v3[key][i].data[ii].cost + newData.walkin_door_frameout_v3[key][i].data[ii].vertical_side_cost + newData.walkin_door_frameout_v3[key][i].data[ii].on_side_cost;
    
    
    
                        const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name] = newData.walkin_door_frameout_v3[key][i].data[ii];
    
                        const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name].end_wall_price = newData.walkin_door_frameout_v3[key][i].data[ii].frameout_cost_end;
    
                        const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][key][newData.walkin_door_frameout_v3[key][i].name]["Size"][newData.walkin_door_frameout_v3[key][i].data[ii].name].side_wall_price = newData.walkin_door_frameout_v3[key][i].data[ii].frameout_cost_side + newData.walkin_door_frameout_v3[key][i].data[ii].vertical_side_cost;
                    }
                }
    
            })
        }
        if(newData.window_v3!=undefined){
            
            Object.entries(newData.window_v3).map(([key, value], index) => {
                const_var.CustomDoorArrForOtherBtype[iid]['Windows'][key] = [];
                for (var i = 0; i < newData.window_v3[key].length; i++) {
                    if(key=="standard_window")
                    {
                        windowsDoorSubCategory = newData.window_v3[key][i].name;
                    }
                    const_var.CustomDoorArrForOtherBtype[iid]['Windows'][key][newData.window_v3[key][i].name] = newData.window_v3[key][i].data;
                    const_var.CustomDoorArrForOtherBtype[iid]['Windows'][key][newData.window_v3[key][i].name]["Size"] = [];
    
                    for (var ii = 0; ii <= newData.window_v3[key][i].data.length - 1; ii++) {
                        const_var.CustomDoorArrForOtherBtype[iid]['Windows'][key][newData.window_v3[key][i].name]["Size"][newData.window_v3[key][i].data[ii].name] = newData.window_v3[key][i].data[ii];
    
                        if (const_var.loginSession != false && ii == newData.window_v3[key][i].data.length - 1) {
                            state.const_var.CustomDoorArrForOtherBtype[iid]['Windows'][key][newData.window_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        }
    
                        const_var.CustomDoorArrForOtherBtype[iid]['Windows'][key][newData.window_v3[key][i].name]["Size"][newData.window_v3[key][i].data[ii].name].end_wall_price = newData.window_v3[key][i].data[ii].cost;
    
                        const_var.CustomDoorArrForOtherBtype[iid]['Windows'][key][newData.window_v3[key][i].name]["Size"][newData.window_v3[key][i].data[ii].name].side_wall_price = newData.window_v3[key][i].data[ii].cost + newData.window_v3[key][i].data[ii].vertical_side_cost;
    
                    }
                }
    
            })

            Object.entries(newData.window_frameout_v3).map(([key, value], index) => {
                const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][key] = [];
                for (var i = 0; i < newData.window_frameout_v3[key].length; i++) {

                    if(key=="standard_window" && newData.window_v3[key] != undefined)
                    {
                        windowsFrameDoorSubCategory = newData.window_v3[key][i].name;
                    }
                    const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name] = newData.window_frameout_v3[key][i].data;
                    const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]["Size"] = [];

                    for (var ii = 0; ii <= newData.window_frameout_v3[key][i].data.length - 1; ii++) {
                        

                    

                        const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name] = newData.window_frameout_v3[key][i].data[ii];

                        const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name].end_wall_price = newData.window_frameout_v3[key][i].data[ii].frameout_cost_end;

                        const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name].side_wall_price = newData.window_frameout_v3[key][i].data[ii].frameout_cost_side + newData.window_frameout_v3[key][i].data[ii].vertical_side_cost;
                        if (const_var.loginSession != false && ii == newData.window_frameout_v3[key][i].data.length - 1) {
                            state.const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        }
                    }
                    if(const_var.crmSetting.is_Edit==true && const_var.entry_points.length>0 && params.m_s_n==96)
                    {
                        let walkDoorObj = const_var.entry_points.filter(data=>(data.parent_array_key=="Windows_Frameout") && data.child_array_key == key)
                        if(walkDoorObj.length>0)
                        {
                            for(var ii =0; ii<=walkDoorObj.length-1;ii++)
                            {
                                if(state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i]!=undefined)
                                {
                                    walkDoorObj[ii].nested_array_key = state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name;
                                }
                            }
                        }
                    }
                }

            })

        }
        else{
            Object.entries(newData.window_frameout_v3).map(([key, value], index) => {
                const_var.CustomDoorArrForOtherBtype[iid]['Windows'][key] = [];
                const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][key] = [];
                for (var i = 0; i < newData.window_frameout_v3[key].length; i++) {
                    if(key=="standard_window")
                    {
                        windowsDoorSubCategory = newData.window_frameout_v3[key][i].name;
                    }
                    const_var.CustomDoorArrForOtherBtype[iid]['Windows'][key][newData.window_frameout_v3[key][i].name] = newData.window_frameout_v3[key][i].data;
                    const_var.CustomDoorArrForOtherBtype[iid]['Windows'][key][newData.window_frameout_v3[key][i].name]["Size"] = [];
    
    
                    const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name] = newData.window_frameout_v3[key][i].data;
                    const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]["Size"] = [];
    
                    for (var ii = 0; ii <= newData.window_frameout_v3[key][i].data.length - 1; ii++) {
                        const_var.CustomDoorArrForOtherBtype[iid]['Windows'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name] = newData.window_frameout_v3[key][i].data[ii];
    
                        if (const_var.loginSession != false && ii == newData.window_frameout_v3[key][i].data.length - 1) {
                            state.const_var.CustomDoorArrForOtherBtype[iid]['Windows'][key][newData.window_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                            state.const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        }
    
                        const_var.CustomDoorArrForOtherBtype[iid]['Windows'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name].end_wall_price = newData.window_frameout_v3[key][i].data[ii].cost;
    
                        const_var.CustomDoorArrForOtherBtype[iid]['Windows'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name].side_wall_price = newData.window_frameout_v3[key][i].data[ii].cost + newData.window_frameout_v3[key][i].data[ii].vertical_side_cost;
    
    
                        const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name] = newData.window_frameout_v3[key][i].data[ii];
    
                        const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name].end_wall_price = newData.window_frameout_v3[key][i].data[ii].frameout_cost_end;
    
                        const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][key][newData.window_frameout_v3[key][i].name]["Size"][newData.window_frameout_v3[key][i].data[ii].name].side_wall_price = newData.window_frameout_v3[key][i].data[ii].frameout_cost_side + newData.window_frameout_v3[key][i].data[ii].vertical_side_cost;
                    }
                }
    
            })
        }

    let filterData = [];

    // console.log(const_var.CustomDoorArrForOtherBtype[iid],"const_var.CustomDoorArrForOtherBtype[iid]",{garageDoorSubCategory,walkinDoorSubCategory,walkinFrameDoorSubCategory,windowsDoorSubCategory,windowsFrameDoorSubCategory})
    // let NewEntryPoint = !const_var.loginSession ? const_var.ComparisionDataArray[iid].entry_points: const_var.entry_points
    if (const_var.entry_points.length > 0) {
        const_var.entry_points.map((value, key) => {
            
            if (value.parent_array_key == "Garage") {
                // console.log(const_var.CustomDoorArrForOtherBtype[iid]['Garage'],"const_var.CustomDoorArrForOtherBtype[iid]['Garage']",value.child_array_key,value.nested_array_key)
                if(const_var.CustomDoorArrForOtherBtype[iid]['Garage'][value.child_array_key]!=undefined && const_var.CustomDoorArrForOtherBtype[iid]['Garage'][value.child_array_key][value.nested_array_key]!=undefined)
                {
                    if (const_var.CustomDoorArrForOtherBtype[iid]['Garage'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Garage'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name)[0];
                    }else{
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Garage'][value.child_array_key][value.nested_array_key][0];
                    } 
                    
                }else
                {
                    if (const_var.CustomDoorArrForOtherBtype[iid]['Garage']['standard_door'][garageDoorSubCategory].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Garage']['standard_door'][garageDoorSubCategory].filter(data => data.name == value.entry_size.name)[0];
                    }else{
                        let data = const_var.CustomDoorArrForOtherBtype[iid]['Garage']['standard_door'][garageDoorSubCategory].filter(data => data.name < value.entry_size.name);
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Garage']['standard_door'][garageDoorSubCategory][0];
                    } 
                }
                
                //filterData.push(newData.garage_door_v3.filter(data => data.name == value.entry_size.name));

            } if (value.parent_array_key == "Garage_Frameout" && !value.is_breezeway_frameout) {
                // console.log(const_var.CustomDoorArrForOtherBtype[iid]['Garage_Frameout']['standard_door']['Roll-Up']['Size'],"Garage_Frameout");
                Object.entries(const_var.CustomDoorArrForOtherBtype[iid]['Garage_Frameout']['standard_door']['Roll-Up']['Size']).map((val, index) => {
                //    console.log(index ,"index Garage_Frameout");
                    if (val[0] == value.name) {
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = val;
                    } else {
                        if(index == 0){
                            const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = val;
                        }
                    }
                });

            }
            if (value.parent_array_key == "Walk") {

                if(const_var.CustomDoorArrForOtherBtype[iid]['Walk'][value.child_array_key]!=undefined && const_var.CustomDoorArrForOtherBtype[iid]['Walk'][value.child_array_key][value.nested_array_key]!=undefined)
                {
                    if (const_var.CustomDoorArrForOtherBtype[iid]['Walk'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Walk'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name)[0];
                    } else {
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Walk'][value.child_array_key][value.nested_array_key][0];
                    } 
                }else
                {
                    if (const_var.CustomDoorArrForOtherBtype[iid]['Walk']['standard_walkin'] != undefined && const_var.CustomDoorArrForOtherBtype[iid]['Walk']['standard_walkin'][walkinDoorSubCategory].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Walk']['standard_walkin'][walkinDoorSubCategory].filter(data => data.name == value.entry_size.name)[0];
                    } else {
                        if(const_var.CustomDoorArrForOtherBtype[iid]['Walk']['standard_walkin'] == undefined){
                            if(const_var.CustomDoorArrForOtherBtype[iid]['Walk'].length > 0 || Object.keys(const_var.CustomDoorArrForOtherBtype[iid]['Walk']).length > 0){
                                let newDoorType = Object.keys(const_var.CustomDoorArrForOtherBtype[iid]['Walk'])[0]
                                walkinDoorSubCategory = Object.keys(const_var.CustomDoorArrForOtherBtype[iid]['Walk'][newDoorType])[0]
                                const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Walk'][newDoorType][walkinDoorSubCategory][0];
                            }
                        }
                        else{
                            const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Walk']['standard_walkin'][walkinDoorSubCategory][0];
                        }
                    } 
                }

               
            }
            if (value.parent_array_key == "Walk_Frameout") {

                if(const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][value.child_array_key]!=undefined && const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][value.child_array_key][value.nested_array_key]!=undefined)
                {
                    //console.log(const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][value.child_array_key][value.nested_array_key],"const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout']['standard_walkin'][value.nested_array_key]")
                    if (const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name)[0];
                    } else {
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout'][value.child_array_key][value.nested_array_key][0];
                    } 
                }else
                {
                    //console.log(const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout']['standard_walkin'][value.nested_array_key],"const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout']['standard_walkin'][value.nested_array_key]")
                    if (const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout']['standard_walkin'][walkinFrameDoorSubCategory].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout']['standard_walkin'][walkinFrameDoorSubCategory].filter(data => data.name == value.entry_size.name)[0];
                    } else {
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Walk_Frameout']['standard_walkin'][walkinFrameDoorSubCategory][0];
                    } 
                }

               
            }
            if (value.parent_array_key == "Windows") {


                if(const_var.CustomDoorArrForOtherBtype[iid]['Windows'][value.child_array_key]!=undefined && const_var.CustomDoorArrForOtherBtype[iid]['Windows'][value.child_array_key][value.nested_array_key]!=undefined)
                {
                    if (const_var.CustomDoorArrForOtherBtype[iid]['Windows'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Windows'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name)[0];
                    } else {
                        let data = const_var.CustomDoorArrForOtherBtype[iid]['Windows'][value.child_array_key][value.nested_array_key].filter(data => data.name < value.entry_size.name);
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Windows'][value.child_array_key][value.nested_array_key][0];
                    } 
                }else
                {
                    if (const_var.CustomDoorArrForOtherBtype[iid]['Windows']['standard_window'] != undefined && const_var.CustomDoorArrForOtherBtype[iid]['Windows']['standard_window'][windowsDoorSubCategory].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Windows']['standard_window'][windowsDoorSubCategory].filter(data => data.name == value.entry_size.name)[0];
                    } else {
                        if(const_var.CustomDoorArrForOtherBtype[iid]['Windows']['standard_window'] == undefined){
                            let newDoorType = Object.keys(const_var.CustomDoorArrForOtherBtype[iid]['Windows'])[0]
                            windowsDoorSubCategory = Object.keys(const_var.CustomDoorArrForOtherBtype[iid]['Windows'][newDoorType])[0];
                            const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Windows'][newDoorType][windowsDoorSubCategory][0];
                        }
                        else{
                            const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Windows']['standard_window'][windowsDoorSubCategory][0];
                        }
                    } 
                }

            }

            if (value.parent_array_key == "Windows_Frameout") {


                if(const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][value.child_array_key]!=undefined && const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][value.child_array_key][value.nested_array_key]!=undefined)
                {
                    if (const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][value.child_array_key][value.nested_array_key].filter(data => data.name == value.entry_size.name)[0];
                    } else {
                        let data = const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][value.child_array_key][value.nested_array_key].filter(data => data.name < value.entry_size.name);
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout'][value.child_array_key][value.nested_array_key][0];
                    } 
                }else
                {
                    if (const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout']['standard_window'][windowsFrameDoorSubCategory].filter(data => data.name == value.entry_size.name).length > 0) {
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout']['standard_window'][windowsFrameDoorSubCategory].filter(data => data.name == value.entry_size.name)[0];
                    } else {
                        let data = const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout']['standard_window'][windowsFrameDoorSubCategory].filter(data => data.name < value.entry_size.name);
                        const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'][key] = const_var.CustomDoorArrForOtherBtype[iid]['Windows_Frameout']['standard_window'][windowsFrameDoorSubCategory][0];
                    } 
                }

            }

            
        })
    }
    // console.log(const_var.CustomDoorArrForOtherBtype[iid]['selectedIndex'],iid,"const_var.CustomDoorArrForOtherBtype[iid]['Garage'][value.child_array_key][value.nested_array_key]")
    // console.log(const_var.CustomDoorArrForOtherBtype,"const_var.CustomDoorArrForOtherBtype")

    // commonFunctionForComponent();

}
const makeComponentArray = (state) => {
    state.const_var.door_w_arr["Width"] = "Select";
    state.const_var.door_h_arr["Height"] = "Select";
    state.const_var.CustomDoorArr['Garage']['Size'].Size = "Select";

    state.const_var.walkFrameoutInitialValue = '';
    state.const_var.walkInitialValue = '';
    state.const_var.windowsFrameoutInitialValue = '';
    state.const_var.windowsInitialValue = '';
    state.const_var.customFrameoutInitialSize = '';
    state.const_var.garageInitialValue = '';
    const_var.newComponentArray['Garage'] = [];
    const_var.newComponentArray['Garage_Frameout'] = [];
    const_var.newComponentArray['Windows'] = [];
    const_var.newComponentArray['Windows_Frameout'] = [];
    const_var.newComponentArray['Walk'] = [];
    const_var.newComponentArray['Walk_Frameout'] = [];
    const_var.newComponentArray['Garage_Frameout']['standard_door'] = [];
    const_var.newComponentArray['Garage_Frameout']['standard_door']['Roll-Up'] = [];
    const_var.newComponentArray['Garage_Frameout']['standard_door']['Roll-Up']["Size"] = [];
    const_var.newComponentArray['Garage_Frameout']['standard_door']['Roll-Up']["Width"] = [];
    const_var.newComponentArray['Garage_Frameout']['standard_door']['Roll-Up']["Height"] = [];
    let isShowCustomSize = true;
    let isShowWindowCutomSize = true
    if(params.m_s_n==3 || params.m_s_n==9 || params.m_s_n == 153)
    {
           isShowCustomSize = false;
    }
    if(params.m_s_n==122)
    {
        isShowWindowCutomSize = false;
    }
    if(const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data.created_at<="2024-06-12")
    {
        if(params.m_s_n==3 || params.m_s_n==9)
        {
            isShowCustomSize = true;
        }   
    } 
    if(const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data.created_at<="2024-06-13")
    {
        if(params.m_s_n==122)
        {
            isShowWindowCutomSize = true;
        }   
    } 
    // ################### SE3-T1226 : for heritage manufacture (m_s_n = 153) #############
    if(const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data.created_at<="2024-08-08")
    {
        if(params.m_s_n == 153)
        {
            isShowCustomSize = true;
        }   
    } 
    if (state.const_var.c_m_a[state.params.p_b_t] != undefined) {

                Object.entries(state.const_var.c_m_a[state.params.p_b_t].garage_door_v3).map(([key, value], index) => {
            const_var.newComponentArray['Garage'][key] = [];
            for (var i = 0; i < state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key].length; i++) {

                if(params.m_s_n==44)
                {
                    state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data.sort((a, b) => {
                        const [aWidth, aHeight] = a.name.split('x').map(Number);
                        const [bWidth, bHeight] = b.name.split('x').map(Number);
                        const heightComparison = aWidth - bWidth;
                        return heightComparison === 0 ? aWidth - bWidth : heightComparison;
                    });
                }else{
                    state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data.sort((a, b) => {
                        const [aWidth, aHeight] = a.name.split('x').map(Number);
                        const [bWidth, bHeight] = b.name.split('x').map(Number);
                        const heightComparison = aHeight - bHeight;
                        return heightComparison === 0 ? aWidth - bWidth : heightComparison;
                    });
                }
        
                const_var.newComponentArray['Garage'][key][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].name] = state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data;
                state.const_var.newComponentArray['Garage'][key][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].name]['garageDoorColor'] = state.params.g_d_c_Obj;
                const_var.newComponentArray['Garage'][key][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].name]["Size"] = [];
                //console.log(state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data.sort((a, b) => a.width-b.width).sort((a, b) => a.height-b.height),"state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data.sort((a, b) => a.name-b.name)")
                for (var ii = 0; ii <= state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data.length - 1; ii++) {
                    const_var.newComponentArray['Garage'][key][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data[ii].name] = state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data[ii];

                    if (isShowCustomSize && const_var.loginSession != false && ii == state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data.length - 1) {
                        state.const_var.newComponentArray['Garage'][key][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                    }

                    const_var.newComponentArray['Garage'][key][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data[ii].name].end_wall_price = state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data[ii].cost;
                    const_var.newComponentArray['Garage'][key][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data[ii].name].side_wall_price = state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data[ii].side_cost + state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data[ii].cost;
                    // if(state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data[ii].color_cost_combination!=undefined && Object.keys(state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data[ii].color_cost_combination).length>0)
                    // {
                    //     const_var.newComponentArray['Garage'][key][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data[ii].name].updated_doorColor = state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data[ii].color_cost_combination 
                    // }
                    // console.log(const_var.garageDoorColor,"const_var.garageDoorColor",state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].data[ii].color_cost_combination)
                }

                if(const_var.crmSetting.is_Edit==true && const_var.entry_points.length>0 && key == "overhead_door_door") {
                    let overheadDoorObj = const_var.entry_points.filter(data=> data.component_name.includes(key))
                    overheadDoorObj.map((doorItem) => {
                        let ndoorItem = const_var.newComponentArray['Garage'][key][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3[key][i].name]["Size"][doorItem.name];
                        if(ndoorItem) {
                            let addOnOptions = ndoorItem.door_add_ons.find((e) => e.door == "add_on_options");
                            addOnOptions?.category?.map((item) => {
                                if (item.category == "Frame Out") {
                                    doorItem["entry_is_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOptions.door] = item.is_cost == 1? true: false;
                                    doorItem["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOptions.door + "_price"] = item.cost;
                                    doorItem["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOptions.door] =  true;
                                }                                                                                                                                                                                                     
                            })
                        }
                    })


                }
            }

        })

        if ((state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout.length > 0)) {
            for (var j = 0; j < state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout.length; j++) {
                if ((state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length != 0 || state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].height != 0)) {
                    if (state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].is_fixed == 0) {

                        if (state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length != 0) {


                            var spl_val = "";
                            if ((state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].building_height == 0 || state.params.p_h >= state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].building_height) &&
                                (state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].building_width == 0 || state.params.p_w >= state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].building_width) &&
                                (state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].building_length == 0 || state.params.p_d >= state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].building_length)) {
                                spl_val = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length.split("-");
                            }

                            //var spl_val = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length.split("-");
                            //width_heigh_arr.push(spl_val[0],spl_val[1]);
                            for (var jj = Number(spl_val[0]); jj <= Number(spl_val[1]); jj++) {

                                for (var ii = 6; ii <= state.params.p_h; ii++) {

                                    if (state.const_var.customFrameoutInitialSize == "") {
                                        state.const_var.customFrameoutInitialSize = jj + "x" + ii;
                                    }
                                    const_var.newComponentArray['Garage_Frameout']['standard_door']['Roll-Up']["Size"][jj + "x" + ii] = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j];
                                    const_var.newComponentArray['Garage_Frameout']['standard_door']['Roll-Up']["Size"][jj + "x" + ii].end_wall_price = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].on_end;
                                    const_var.newComponentArray['Garage_Frameout']['standard_door']['Roll-Up']["Size"][jj + "x" + ii].side_wall_price = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].on_side;
                                    const_var.newComponentArray['Garage_Frameout']['standard_door']['Roll-Up']["Width"][jj] = jj;
                                    const_var.newComponentArray['Garage_Frameout']['standard_door']['Roll-Up']["Height"][ii] = ii;

                                }
                            }

                        }
                    } else {
                        if (state.const_var.customFrameoutInitialSize == "") {
                            state.const_var.customFrameoutInitialSize = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length + "x" + state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].height;
                        }
                        const_var.newComponentArray['Garage_Frameout']['standard_door']['Roll-Up']["Size"][state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length + "x" + state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].height] = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j];
                        const_var.newComponentArray['Garage_Frameout']['standard_door']['Roll-Up']["Size"][state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length + "x" + state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].height].end_wall_price = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].on_end;
                        const_var.newComponentArray['Garage_Frameout']['standard_door']['Roll-Up']["Size"][state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length + "x" + state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].height].side_wall_price = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].on_side;
                        const_var.newComponentArray['Garage_Frameout']['standard_door']['Roll-Up']["Width"][state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length] = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length;
                        const_var.newComponentArray['Garage_Frameout']['standard_door']['Roll-Up']["Height"][state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].height] = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].height;
                    }
                }
            }

        }
        if(state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3!=undefined)
        {
                Object.entries(state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3).map(([key, value], index) => {
                //    console.log(key,value,index,"state.const_var.c_m_a[state.params.p_b_t].garage_door_v3");
                const_var.newComponentArray['Walk'][key] = [];
                
                for (var i = 0; i < state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key].length; i++) {
                    const_var.newComponentArray['Walk'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].name] = state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].data;
                    const_var.newComponentArray['Walk'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].name]["Size"] = [];

                    for (var ii = 0; ii <= state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].data.length - 1; ii++) {
                        const_var.newComponentArray['Walk'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].data[ii].name] = state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].data[ii];

                        if (isShowCustomSize && const_var.loginSession != false && ii == state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].data.length - 1) {
                            state.const_var.newComponentArray['Walk'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        }

                        const_var.newComponentArray['Walk'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].data[ii].name].end_wall_price = state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].data[ii].cost;

                        const_var.newComponentArray['Walk'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].data[ii].name].side_wall_price = state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].data[ii].cost + state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].data[ii].vertical_side_cost + state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].data[ii].on_side_cost;

                    }
                    if(const_var.crmSetting.is_Edit==true && const_var.entry_points.length>0 && (params.m_s_n==96 || params.m_s_n==25))
                    {
                        let walkDoorObj = const_var.entry_points.filter(data=>(data.parent_array_key=="Walk" || data.parent_array_key=="Walk_Frameout") && data.child_array_key == key)
                        if(walkDoorObj.length>0)
                        {
                            for(var ii =0; ii<=walkDoorObj.length-1;ii++)
                            {
                                if(state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i]!=undefined)
                                {
                                    if((walkDoorObj[ii].parent_array_key == "Walk" || walkDoorObj[ii].parent_array_key=="Walk_Frameout") && walkDoorObj[ii].child_array_key==key)
                                    {
                                       walkDoorObj[ii].nested_array_key = state.const_var.c_m_a[state.params.p_b_t].walkin_door_v3[key][i].name;
                                    }
                                }
                            }
                        }
                    }
                }

            })
                        Object.entries(state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3).map(([key, value], index) => {
                //    console.log(key,value,index,"state.const_var.c_m_a[state.params.p_b_t].garage_door_v3");
                const_var.newComponentArray['Walk_Frameout'][key] = [];
                // console.log(key,value,index,"state.const_var.c_m_a[state.params.p_b_t].garage_door_v3");

                for (var i = 0; i < state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key].length; i++) {
                    const_var.newComponentArray['Walk_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name] = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data;
                    const_var.newComponentArray['Walk_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name]["Size"] = [];
                    
                    for (var ii = 0; ii <= state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data.length - 1; ii++) {
                        const_var.newComponentArray['Walk_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].name] = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii];

                        const_var.newComponentArray['Walk_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].name].end_wall_price = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].frameout_cost_end;

                        const_var.newComponentArray['Walk_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].name].side_wall_price = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].frameout_cost_side + state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].vertical_side_cost;
                        
                        if (const_var.loginSession != false && ii == state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data.length - 1) {
                            state.const_var.newComponentArray['Walk_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        }
                        

                    }
                    if(const_var.crmSetting.is_Edit==true && const_var.entry_points.length>0 && (params.m_s_n==96 || params.m_s_n==25))
                    {
                        let walkDoorObj = const_var.entry_points.filter(data=>(data.parent_array_key=="Walk" || data.parent_array_key=="Walk_Frameout") && data.child_array_key == key)
                        if(walkDoorObj.length>0)
                        {
                            for(var ii =0; ii<=walkDoorObj.length-1;ii++)
                            {
                                if(state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i]!=undefined)
                                {
                                    if((walkDoorObj[ii].parent_array_key == "Walk" || walkDoorObj[ii].parent_array_key=="Walk_Frameout") && walkDoorObj[ii].child_array_key==key)
                                    {
                                       walkDoorObj[ii].nested_array_key = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name;
                                    }
                                }
                            }
                        }
                    }
                }

            })
        }else{
            Object.entries(state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3).map(([key, value], index) => {
                //    console.log(key,value,index,"state.const_var.c_m_a[state.params.p_b_t].garage_door_v3");
                const_var.newComponentArray['Walk'][key] = [];
                const_var.newComponentArray['Walk_Frameout'][key] = [];
                // console.log(key,value,index,"state.const_var.c_m_a[state.params.p_b_t].garage_door_v3");

                for (var i = 0; i < state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key].length; i++) {
                    const_var.newComponentArray['Walk'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name] = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data;
                    const_var.newComponentArray['Walk'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name]["Size"] = [];

                    const_var.newComponentArray['Walk_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name] = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data;
                    const_var.newComponentArray['Walk_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name]["Size"] = [];
                    
                    for (var ii = 0; ii <= state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data.length - 1; ii++) {
                        const_var.newComponentArray['Walk'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].name] = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii];

                        if (const_var.loginSession != false && ii == state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data.length - 1) {
                            if(isShowCustomSize)
                            {
                                state.const_var.newComponentArray['Walk'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                            }
                            state.const_var.newComponentArray['Walk_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        }

                        const_var.newComponentArray['Walk'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].name].end_wall_price = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].cost;

                        const_var.newComponentArray['Walk'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].name].side_wall_price = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].cost + state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].vertical_side_cost + state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].on_side_cost;



                        const_var.newComponentArray['Walk_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].name] = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii];

                        const_var.newComponentArray['Walk_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].name].end_wall_price = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].frameout_cost_end;

                        const_var.newComponentArray['Walk_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].name].side_wall_price = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].frameout_cost_side + state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].data[ii].vertical_side_cost;
                        
                    }
                    if(const_var.crmSetting.is_Edit==true && const_var.entry_points.length>0 && (params.m_s_n==96 || params.m_s_n==25))
                    {
                        let walkDoorObj = const_var.entry_points.filter(data=>(data.parent_array_key=="Walk" || data.parent_array_key=="Walk_Frameout") && data.child_array_key == key)
                        if(walkDoorObj.length>0)
                        {
                            for(var ii =0; ii<=walkDoorObj.length-1;ii++)
                            {
                                if(state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i]!=undefined)
                                {
                                    if((walkDoorObj[ii].parent_array_key == "Walk" || walkDoorObj[ii].parent_array_key=="Walk_Frameout") && walkDoorObj[ii].child_array_key==key)
                                    {
                                       walkDoorObj[ii].nested_array_key = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3[key][i].name;
                                    }
                                }
                            }
                        }
                    }
                }

            })
        }
        if(state.const_var.c_m_a[state.params.p_b_t].window_v3!=undefined)
        {
                Object.entries(state.const_var.c_m_a[state.params.p_b_t].window_v3).map(([key, value], index) => {
                    // console.log(key,value,index,"state.const_var.c_m_a[state.params.p_b_t].garage_door_v3");
                    const_var.newComponentArray['Windows'][key] = [];
                    for (var i = 0; i < state.const_var.c_m_a[state.params.p_b_t].window_v3[key].length; i++) {
                        const_var.newComponentArray['Windows'][key][state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i].name] = state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i].data;
                        const_var.newComponentArray['Windows'][key][state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i].name]["Size"] = [];


                        
                        for (var ii = 0; ii <= state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i].data.length - 1; ii++) {
                            const_var.newComponentArray['Windows'][key][state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i].data[ii].name] = state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i].data[ii];

                            if (isShowCustomSize && isShowWindowCutomSize && const_var.loginSession != false && ii == state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i].data.length - 1) {
                                state.const_var.newComponentArray['Windows'][key][state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                            }

                            const_var.newComponentArray['Windows'][key][state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i].data[ii].name].end_wall_price = state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i].data[ii].cost;

                            const_var.newComponentArray['Windows'][key][state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i].data[ii].name].side_wall_price = state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i].data[ii].cost + state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i].data[ii].vertical_side_cost;


                            }
                        // if(const_var.crmSetting.is_Edit==true && const_var.entry_points.length>0 && params.m_s_n==96)
                        // {
                        //     let walkDoorObj = const_var.entry_points.filter(data=>(data.parent_array_key=="Windows") && data.child_array_key == key)
                        //     if(walkDoorObj.length>0)
                        //     {
                        //         for(var ii =0; ii<=walkDoorObj.length-1;ii++)
                        //         {
                        //             if(state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i]!=undefined)
                        //             {
                        //                 walkDoorObj[ii].nested_array_key = state.const_var.c_m_a[state.params.p_b_t].window_v3[key][i].name;
                        //             }
                        //         }
                        //     }
                        // }
                    }

                })

                Object.entries(state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3).map(([key, value], index) => {
                // console.log(key,value,index,"state.const_var.c_m_a[state.params.p_b_t].garage_door_v3");
                const_var.newComponentArray['Windows_Frameout'][key] = [];
                for (var i = 0; i < state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key].length; i++) {
                    const_var.newComponentArray['Windows_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name] = state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data;
                    const_var.newComponentArray['Windows_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name]["Size"] = [];

                    for (var ii = 0; ii <= state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data.length - 1; ii++) {
                        

                    

                        const_var.newComponentArray['Windows_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].name] = state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii];

                        const_var.newComponentArray['Windows_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].name].end_wall_price = state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].frameout_cost_end;

                        const_var.newComponentArray['Windows_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].name].side_wall_price = state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].frameout_cost_side + state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].vertical_side_cost;
                        if (const_var.loginSession != false && ii == state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data.length - 1) {
                            state.const_var.newComponentArray['Windows_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        }
                    }
                    if(const_var.crmSetting.is_Edit==true && const_var.entry_points.length>0 && params.m_s_n==96)
                    {
                        let walkDoorObj = const_var.entry_points.filter(data=>(data.parent_array_key=="Windows_Frameout") && data.child_array_key == key)
                        if(walkDoorObj.length>0)
                        {
                            for(var ii =0; ii<=walkDoorObj.length-1;ii++)
                            {
                                if(state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i]!=undefined)
                                {
                                    walkDoorObj[ii].nested_array_key = state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name;
                                }
                            }
                        }
                    }
                }

            })
        }else{
            Object.entries(state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3).map(([key, value], index) => {
                // console.log(key,value,index,"state.const_var.c_m_a[state.params.p_b_t].garage_door_v3");
                const_var.newComponentArray['Windows'][key] = [];
                const_var.newComponentArray['Windows_Frameout'][key] = [];
                for (var i = 0; i < state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key].length; i++) {
                    const_var.newComponentArray['Windows'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name] = state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data;
                    const_var.newComponentArray['Windows'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name]["Size"] = [];


                    const_var.newComponentArray['Windows_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name] = state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data;
                    const_var.newComponentArray['Windows_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name]["Size"] = [];

                    for (var ii = 0; ii <= state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data.length - 1; ii++) {
                        const_var.newComponentArray['Windows'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].name] = state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii];

                        if (const_var.loginSession != false && ii == state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data.length - 1) {
                            if(isShowCustomSize && isShowWindowCutomSize)
                            {
                                state.const_var.newComponentArray['Windows'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                            }
                            state.const_var.newComponentArray['Windows_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name]['Size']['Custom Size'] = "CustomGarageSize";
                        }

                        const_var.newComponentArray['Windows'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].name].end_wall_price = state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].cost;

                        const_var.newComponentArray['Windows'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].name].side_wall_price = state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].cost + state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].vertical_side_cost;


                        const_var.newComponentArray['Windows_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].name] = state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii];

                        const_var.newComponentArray['Windows_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].name].end_wall_price = state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].frameout_cost_end;

                        const_var.newComponentArray['Windows_Frameout'][key][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].name].side_wall_price = state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].frameout_cost_side + state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].data[ii].vertical_side_cost;
                    }
                    if(const_var.crmSetting.is_Edit==true && const_var.entry_points.length>0 && params.m_s_n==96)
                    {
                        let walkDoorObj = const_var.entry_points.filter(data=>(data.parent_array_key=="Windows" || data.parent_array_key=="Windows_Frameout") && data.child_array_key == key)
                        if(walkDoorObj.length>0)
                        {
                            for(var ii =0; ii<=walkDoorObj.length-1;ii++)
                            {
                                if(state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i]!=undefined)
                                {
                                    walkDoorObj[ii].nested_array_key = state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3[key][i].name;
                                }
                            }
                        }
                    }
                }

            })
        }
        commonFunctionForComponent();
        // for(var i = 0; i < state.const_var.c_m_a[state.params.p_b_t].garage_door_v3.standard.length; i++){
        //     const_var.newComponentArray['Garage'][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3.standard[i].name]=state.const_var.c_m_a[state.params.p_b_t].garage_door_v3.standard[i].data;
        //     state.const_var.newComponentArray['Garage'][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3.standard[i].name]['garageDoorColor'] = state.params.g_d_c_Obj;
        //     const_var.newComponentArray['Garage'][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3.standard[i].name]["Size"] = [];
        //     for (var ii = 0; ii <= state.const_var.c_m_a[state.params.p_b_t].garage_door_v3.standard[i].data.length-1; ii++) {
        //         const_var.newComponentArray['Garage'][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3.standard[i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].garage_door_v3.standard[i].data[ii].name] = state.const_var.c_m_a[state.params.p_b_t].garage_door_v3.standard[i].data[ii];
        //     }
        // }
        // for(var i = 0; i < state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3.standard.length; i++){
        //     const_var.newComponentArray['Walk'][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3.standard[i].name]=state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3.standard[i].data;
        //     const_var.newComponentArray['Walk'][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3.standard[i].name]["Size"] = [];
        //     for (var ii = 0; ii <= state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3.standard[i].data.length-1; ii++) {
        //         const_var.newComponentArray['Walk'][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3.standard[i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3.standard[i].data[ii].name] = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout_v3.standard[i].data[ii];
        //     }
        // }
        // for(var i = 0; i < state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3.standard.length; i++){
        //     const_var.newComponentArray['Windows'][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3.standard[i].name]=state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3.standard[i].data;
        //     const_var.newComponentArray['Windows'][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3.standard[i].name]["Size"] = [];
        //     for (var ii = 0; ii <= state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3.standard[i].data.length-1; ii++) {
        //         const_var.newComponentArray['Windows'][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3.standard[i].name]["Size"][state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3.standard[i].data[ii].name] = state.const_var.c_m_a[state.params.p_b_t].window_frameout_v3.standard[i].data[ii];
        //     }
        // }

        // console.log(const_var.newComponentArray,"const_var.newComponentArray")    
        for (var i = 0; i < state.const_var.c_m_a[state.params.p_b_t].garage_door.length; i++) {

            // console.log(state.const_var.c_m_a[state.params.p_b_t].garage_door[i],"const_var.c_m_a[state.params.p_b_t].garage_door")
            state.const_var.g_d_a.push(state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase());
            state.const_var.CustomDoorArr['Garage']['Size'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase() + "'"] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase();
            state.const_var.CustomDoorArr['Garage']['Object'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i];
            state.const_var.CustomDoorArr['Garage']['EndPrice'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i].cost;
            state.const_var.CustomDoorArr['Garage']['SidePrice'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i].cost + state.const_var.c_m_a[state.params.p_b_t].garage_door[i].side_cost;
            state.const_var.CustomDoorArr['Garage']['TrimKit'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i]['45_degree_angle'];
            state.const_var.CustomDoorArr['Garage']['Chain_Hoist'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i].chain_hoist;
            state.const_var.CustomDoorArr['Garage']['Is_Chain_Hoist'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i].is_chain_hoist;
            state.const_var.CustomDoorArr['Garage']['Is_Header_Seal'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i].is_header_seal;
            state.const_var.CustomDoorArr['Garage']['Header_Seal'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i].header_seal;
            state.const_var.CustomDoorArr['Garage']['Is_Certified'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i].is_certified;
            state.const_var.CustomDoorArr['Garage']['Certified_Cost'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i].certified_cost;

            state.const_var.CustomDoorArr['Garage']['Is_Automatic_Openers'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i].is_automatic_openers;
            state.const_var.CustomDoorArr['Garage']['Automatic_Openers_Cost'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i].automatic_openers;


            state.const_var.g_d_a.push(state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase());
            state.const_var.CustomDoorArr['sectionalGarage']['Size'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase() + "'"] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase();
            state.const_var.CustomDoorArr['sectionalGarage']['Object'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i];
            state.const_var.CustomDoorArr['sectionalGarage']['EndPrice'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i].cost;
            state.const_var.CustomDoorArr['sectionalGarage']['SidePrice'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i].cost + state.const_var.c_m_a[state.params.p_b_t].garage_door[i].side_cost;
            state.const_var.CustomDoorArr['sectionalGarage']['TrimKit'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i]['45_degree_angle'];
            state.const_var.CustomDoorArr['sectionalGarage']['Chain_Hoist'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i].chain_hoist;
            state.const_var.CustomDoorArr['sectionalGarage']['Header_Seal'][state.const_var.c_m_a[state.params.p_b_t].garage_door[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].garage_door[i].header_seal;
        }
        state.const_var.CustomDoorArr['Garage']['garageDoorColor'] = state.params.g_d_c_Obj;
        state.const_var.garageInitialValue = state.const_var.c_m_a[state.params.p_b_t].garage_door[0] != undefined ? state.const_var.CustomDoorArr['Garage']['Size'][state.const_var.c_m_a[state.params.p_b_t].garage_door[0].name.toUpperCase() + "'"] : '';
        if (const_var.loginSession != false) {
            state.const_var.CustomDoorArr['Garage']['Size']['Custom Size'] = "CustomGarageSize";
        }
        if ((state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout.length > 0)) {
            for (var j = 0; j < state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout.length; j++) {
                if ((state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length != 0 || state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].height != 0)) {
                    if (state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].is_fixed == 0) {

                        if (state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length != 0) {

                            var spl_val = "";
                            if ((state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].building_height == 0 || state.params.p_h >= state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].building_height) &&
                                (state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].building_width == 0 || state.params.p_w >= state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].building_width) &&
                                (state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].building_length == 0 || state.params.p_d >= state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].building_length)) {
                                spl_val = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length.split("-");
                            }
                            //var spl_val = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length.split("-");
                            //width_heigh_arr.push(spl_val[0],spl_val[1]);
                            for (var jj = Number(spl_val[0]); jj <= Number(spl_val[1]); jj++) {

                                state.const_var.door_w_arr[jj + "'" + " Wide"] = jj;
                                for (var ii = 6; ii <= state.params.p_h; ii++) {
                                    // if(state.const_var.customFrameoutInitialSize=="")
                                    // {
                                    //     state.const_var.customFrameoutInitialSize = jj+"X"+ii;
                                    // }
                                    state.const_var.door_h_arr[ii + "'" + " Tall"] = ii;
                                    //state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].name = jj+"x"+ii;
                                    state.const_var.CustomDoorArr['CustomFrameout']['Size'][jj + "X" + ii] = jj + "X" + ii + "_Frameout";
                                    state.const_var.CustomDoorArr['CustomFrameout']['Width'][jj] = jj;
                                    state.const_var.CustomDoorArr['CustomFrameout']['Height'][ii] = ii;
                                    state.const_var.CustomDoorArr['CustomFrameout']['Object'][jj + "X" + ii + "_Frameout"] = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j];
                                    state.const_var.CustomDoorArr['CustomFrameout']['EndPrice'][jj + "X" + ii + "_Frameout"] = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].on_end;
                                    state.const_var.CustomDoorArr['CustomFrameout']['SidePrice'][jj + "X" + ii + "_Frameout"] = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].on_side;
                                    state.const_var.CustomDoorArr['CustomFrameout']['TrimKit'][jj + "X" + ii + "_Frameout"] = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].dutch_cost;

                                }
                            }

                        }
                    } else {
                        state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].name = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length + "x" + state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].height;
                        // const_var.customFrameoutInitialSize = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[0].frame_out_length+"X"+state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[0].height;
                        state.const_var.CustomDoorArr['GarageFrameout']['Size'][state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length + "X" + state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].height + " Frameout"] = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length + "X" + state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].height + "_Frameout";
                        state.const_var.CustomDoorArr['GarageFrameout']['Object'][state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length + "X" + state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].height + "_Frameout"] = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j];
                        state.const_var.CustomDoorArr['GarageFrameout']['EndPrice'][state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length + "X" + state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].height + "_Frameout"] = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].on_end;
                        state.const_var.CustomDoorArr['GarageFrameout']['SidePrice'][state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length + "X" + state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].height + "_Frameout"] = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].on_side;
                        state.const_var.CustomDoorArr['GarageFrameout']['TrimKit'][state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].frame_out_length + "X" + state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].height + "_Frameout"] = state.const_var.c_m_a[state.params.p_b_t].garage_door_frameout[j].dutch_cost;


                    }
                }
            }

        }


        var checkWindowsCanBeAdded = false;
        var checkFrameWindowsCanBeAdded = false;
        for (var i = 0; i < state.const_var.c_m_a[state.params.p_b_t].window_frameout.length; i++) {
            if (const_var.b_o_J_1[params.p_b_t] == "Custom Buildings") {
                checkWindowsCanBeAdded = true;
                checkFrameWindowsCanBeAdded = true;
            }
            if (const_var.b_o_J_1[params.p_b_t] != "Custom Buildings" && state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].cost != 0) {
                checkWindowsCanBeAdded = true;
            }
            if (const_var.b_o_J_1[params.p_b_t] != "Custom Buildings" && state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].frameout_cost_end != 0) {
                checkFrameWindowsCanBeAdded = true;
            }
            if (checkWindowsCanBeAdded == true) {
                state.const_var.CustomDoorArr['Windows']['Size'][state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].name.toUpperCase() + '"'] = state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].name.toUpperCase();
                state.const_var.CustomDoorArr['Windows']['Object'][state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].window_frameout[i];
                state.const_var.CustomDoorArr['Windows']['EndPrice'][state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].cost;
                state.const_var.CustomDoorArr['Windows']['SidePrice'][state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].cost + state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].vertical_side_cost;
                state.const_var.windowsInitialValue = state.const_var.c_m_a[state.params.p_b_t].window_frameout[0] != undefined ? state.const_var.CustomDoorArr['Windows']['Size'][state.const_var.c_m_a[state.params.p_b_t].window_frameout[0].name.toUpperCase() + '"'] : '';
            }
            if (checkFrameWindowsCanBeAdded == true) {
                state.const_var.CustomDoorArr['WindowsFrameout']['Size'][state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].name.toUpperCase() + '"' + " Frameout"] = state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].name.toUpperCase() + "_Frameout";
                state.const_var.CustomDoorArr['WindowsFrameout']['Object'][state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].name.toUpperCase() + "_Frameout"] = state.const_var.c_m_a[state.params.p_b_t].window_frameout[i];
                state.const_var.CustomDoorArr['WindowsFrameout']['EndPrice'][state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].name.toUpperCase() + "_Frameout"] = state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].frameout_cost_end;
                state.const_var.CustomDoorArr['WindowsFrameout']['SidePrice'][state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].name.toUpperCase() + "_Frameout"] = state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].frameout_cost_side + state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].vertical_side_cost;
                if (const_var.b_o_J_1[params.p_b_t] != "Custom Buildings" && state.const_var.windowsFrameoutInitialValue == undefined || state.const_var.windowsFrameoutInitialValue == '') {
                    state.const_var.windowsFrameoutInitialValue = state.const_var.c_m_a[state.params.p_b_t].window_frameout[i] != undefined ? state.const_var.CustomDoorArr['WindowsFrameout']['Size'][state.const_var.c_m_a[state.params.p_b_t].window_frameout[i].name.toUpperCase() + '"' + " Frameout"] : '';
                }
                if (const_var.b_o_J_1[params.p_b_t] == "Custom Buildings") {
                    state.const_var.windowsFrameoutInitialValue = state.const_var.c_m_a[state.params.p_b_t].window_frameout[0] != undefined ? state.const_var.CustomDoorArr['WindowsFrameout']['Size'][state.const_var.c_m_a[state.params.p_b_t].window_frameout[0].name.toUpperCase() + '"' + " Frameout"] : '';
                }

            }
        }


        if (const_var.loginSession != false) {
            state.const_var.CustomDoorArr['Windows']['Size']['Custom Size'] = "CustomGarageSize";
            state.const_var.CustomDoorArr['WindowsFrameout']['Size']['Custom Size'] = "CustomGarageSize";
        }
        var checkWalkinCanBeAdded = false;
        var checkFrameWalkinCanBeAdded = false;
        for (var i = 0; i < state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout.length; i++) {
            if (const_var.b_o_J_1[params.p_b_t] == "Custom Buildings") {
                checkWalkinCanBeAdded = true;
                checkFrameWalkinCanBeAdded = true;
            }
            if (const_var.b_o_J_1[params.p_b_t] != "Custom Buildings" && state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].cost != 0) {
                checkWalkinCanBeAdded = true;
            }
            if (const_var.b_o_J_1[params.p_b_t] != "Custom Buildings" && state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].frameout_cost_end != 0 && state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].frameout_cost_side) {
                checkFrameWalkinCanBeAdded = true;
            }
            if (checkWalkinCanBeAdded == true) {
                state.const_var.CustomDoorArr['Walk']['Size'][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].name.toUpperCase() + '"'] = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].name.toUpperCase();
                state.const_var.CustomDoorArr['Walk']['Object'][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i];
                state.const_var.CustomDoorArr['Walk']['EndPrice'][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].cost;
                state.const_var.CustomDoorArr['Walk']['SidePrice'][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].name.toUpperCase()] = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].cost + state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].vertical_side_cost + state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].on_side_cost;
                state.const_var.walkInitialValue = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i] != undefined ? state.const_var.CustomDoorArr['Walk']['Size'][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].name.toUpperCase() + '"'] : '';
            }
            if (checkFrameWalkinCanBeAdded == true) {
                state.const_var.CustomDoorArr['WalkFrameout']['Size'][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].name.toUpperCase() + '"' + " Frameout"] = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].name.toUpperCase() + "_Frameout";
                state.const_var.CustomDoorArr['WalkFrameout']['Object'][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].name.toUpperCase() + "_Frameout"] = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i];
                state.const_var.CustomDoorArr['WalkFrameout']['EndPrice'][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].name.toUpperCase() + "_Frameout"] = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].frameout_cost_end;
                state.const_var.CustomDoorArr['WalkFrameout']['SidePrice'][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].name.toUpperCase() + "_Frameout"] = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].frameout_cost_side + state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].vertical_side_cost;
                state.const_var.walkFrameoutInitialValue = state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i] != undefined ? state.const_var.CustomDoorArr['WalkFrameout']['Size'][state.const_var.c_m_a[state.params.p_b_t].walkin_door_frameout[i].name.toUpperCase() + '"' + " Frameout"] : '';
            }
        }
        if (const_var.loginSession != false) {
            state.const_var.CustomDoorArr['Walk']['Size']['Custom Size'] = "CustomGarageSize";
            state.const_var.CustomDoorArr['WalkFrameout']['Size']['Custom Size'] = "CustomGarageSize";
        }

    }
}


const changeBuildingRoof = (state, event, value) => {

    // for (const key in params) {
    //     params.params_cancel[key] = params[key];
    // }
    let filterData = [];
    if(((params.m_s_n==3 || params.m_s_n==9) && const_var.a_p_d_a.truss_name !== undefined && const_var.a_p_d_a.truss_name.length > 1) || (const_var.a_p_d_a.truss_name !== undefined && const_var.a_p_d_a.truss_name.length > 1))
      {
         filterData = const_var.a_p_d_a.truss_name.filter(data=>data.name.includes(params.trussType));
      }
    state.params.trussType = (filterData.length>0)?filterData[0].name.replace(/[0-9]/g, ''):state.const_var.c_m_a[params.p_b_t].trussType[0].name.replace(/[0-9]/g, '');
    state.params.newtrussType = params.trussType;
    if (state.params.p_w > 80) {
        state.params.p_r_p = 4;
        state.params.b_l_t_r_pF = 3;
        state.params.b_l_t_r_p = 3;
        state.params.b_l_t_r_pR = 3;
        state.params.b_l_t_r_pB = 3;
        state.const_var.roofAction = false;
    } else {
        // params.p_r_p = 3;
        state.const_var.roofAction = true;
        if (value == "center") {
            state.params.b_r_p = event.replace("/", "");
            state.params.p_r_p = event.slice(0, 1);
            //state.params.b_l_t_r_p = state.params.b_l_t_r_p;
            if (state.params.b_r_p != const_var.UpdatedPriceData.roof_pitch.replace("/", "")) {
                const_var.UpdatedPriceData.roof_pitch_price_changed = true;
            }
            
            // apply this conditions to handle the straight roof case -----Start--------
            if(params.add_left_lean && state.params.p_r_p != state.params.b_l_t_r_p && Math.floor(state.params.lean_p_h+((state.params.b_l_t_r_p/12)*state.params.lean_p_w)) == state.params.p_h) makeDimensionUpdateLeft(state)
            if(params.add_right_lean && state.params.p_r_p != state.params.b_l_t_r_pR && Math.floor(state.params.leanR_p_h+((state.params.b_l_t_r_pR/12)*state.params.leanR_p_w)) == state.params.p_h) makeDimensionUpdateRight(state)
            if(params.add_front_lean && state.params.p_r_p != state.params.b_l_t_r_pF && Math.floor(state.params.leanF_p_h+((state.params.b_l_t_r_pF/12)*state.params.leanF_p_w)) == state.params.p_h) makeDimensionUpdateFront(state)
            if(params.add_back_lean && state.params.p_r_p != state.params.b_l_t_r_pB && Math.floor(state.params.leanB_p_h+((state.params.b_l_t_r_pB/12)*state.params.leanB_p_w)) == state.params.p_h) makeDimensionUpdateBack(state)
            // apply this conditions to handle the straight roof case -----End--------

            cuBuilding.BuildingUpdate(true, '');
            if (params.add_front_lean) cuBuilding.UpdateFrontLean();
            if (params.add_left_lean) cuBuilding.UpdateLeftLean();
            if (params.add_right_lean) cuBuilding.UpdateRightLean();
            if (params.add_back_lean) cuBuilding.UpdateBackLean(); 
            if (params.checkeditName != true) {
                let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
                params.other_building_type_name = newVal;
                if (const_var.post_data.building != undefined) {
                    const_var.post_data.building.other_building_type_name = params.other_building_type_name;
                    const_var.post_data.building.name = params.other_building_type_name;
                }

            }
            const_var.UpdatedPriceData.insulation_price = undefined;
            const_var.UpdatedPriceData.utility_price_changed = true;
            const_var.UpdatedPriceData.front_utility_price_changed = true;
            const_var.UpdatedPriceData.insulation_price_changed = true;
           cuBuilding.cP();

        }

        if (value == "front") {
            let b_l_t_r_pF_old = params.b_l_t_r_pF
            state.params.b_l_t_r_pF = parseInt(event);
            if (state.params.add_front_lean == true) {
                // var calHeight = state.params.leanF_p_h + parseInt(state.params.b_l_t_r_pF);
                /* Refer comment in Left Lean to case */
                let straightRoofval = (params.p_r_p == params.b_l_t_r_pF && !params.singleSlope && params.p_r_s != 1) ? 0 : 1
                var calHeight = state.params.leanF_p_h + Math.round(state.params.leanF_p_w * state.params.b_l_t_r_pF / 12) + straightRoofval;
                let frontLeanRoofHeight = calHeight;

                let isMaxHeight = const_var.roofObject[params.p_b_t][params.p_r_s].max_height
                if(const_var.isForStandardBuilding == true && !const_var.b_o_J_1[params.p_b_t].includes("Free Standing") && !const_var.b_o_J_1[params.p_b_t].includes("RV Covers") && params.p_w <= const_var.roofObject[params.p_b_t][params.p_r_s].max_height){
                    isMaxHeight = params.p_w
                }
                
                // if (calHeight > state.params.p_h && calHeight <= state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                if (calHeight > state.params.p_h && calHeight <= isMaxHeight) {
                    // state.params.p_h = state.params.leanF_p_h + Math.round(state.params.leanF_p_w * state.params.b_l_t_r_pF / 12);
                    state.params.p_h = ( params.p_h <= frontLeanRoofHeight ) ? frontLeanRoofHeight : state.params.p_h;
                    const_var.UpdatedPriceData.height_price_changed = true;
                    const_var.UpdatedPriceData.certificate_price_changed = true;
                    const_var.UpdatedPriceData.right_wall_price_changed = true;
                    const_var.UpdatedPriceData.left_wall_price_changed = true;
                    const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
                    const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
                    const_var.UpdatedPriceData.front_wall_price_changed = true;
                    const_var.UpdatedPriceData.back_wall_price_changed = true;
                    const_var.UpdatedPriceData.utility_price_changed = true;
                    const_var.UpdatedPriceData.common_height_changed = true;
                    if (params.p_f_i) const_var.UpdatedPriceData.insulation_price = undefined;
                }
                const_var.UpdatedPriceData.front_lean_height_price_changed = true;
                // if (calHeight > state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                if (calHeight > isMaxHeight) {
                    state.params.b_l_t_r_pF = b_l_t_r_pF_old;
                }
                var exactVal = Math.floor(params.p_h - ((params.leanF_p_w * params.b_l_t_r_pF) / 12));

                // console.log(isMaxHeight,frontLeanRoofHeight,"isMaxHeight")
                // console.log({ exactVal });
                // if (exactVal < 6 && state.params.p_h < state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                if (exactVal < 6 && state.params.p_h < isMaxHeight) {
                    state.params.p_h = state.params.p_h + 1;
                }
            }
            var dataW = Math.floor(((state.params.p_h - state.params.leanF_p_h) * 100) / (((state.params.b_l_t_r_pF) / 12) * 100));
            var newDataW = (parseInt(dataW) >= 24) ? 24 : parseInt(dataW);
            var dataH = Math.floor(state.params.p_h - ((state.params.leanF_p_w * state.params.b_l_t_r_pF) / 12));
            // console.log({dataW,newDataW,dataH});

            utils.checkLegsDataAccordingtoResponse(const_var?.ConditionArr[params.p_b_t][params.p_r_s], "dimension");

            if (dataH < 6 || newDataW < 6) {
                if (newDataW < 6) {
                    state.params.leanF_p_w = 6;
                }
                if (dataH < state.const_var.b_m_i_hlean) {
                    state.params.leanF_p_h = state.const_var.b_m_i_hlean;
                }
                state.params.b_l_t_r_pF = "2";
                // state.const_var.isShowAlert = true;
                // state.const_var.alertUsedFor = "RoofPitchAction";
            }

            if (state.params.add_right_front_lean_porch == true && state.params.b_l_t_r_pF != state.params.b_l_t_r_pR) {
                state.params.add_right_front_lean_porch = false
                // state.const_var.isShowAlert = true;
                // state.const_var.alertUsedFor = "YourCanNotAddPorch";
            }

            if (state.params.add_left_front_lean_porch == true && state.params.b_l_t_r_pF != state.params.b_l_t_r_p) {
                state.params.add_left_front_lean_porch = false
                // state.const_var.isShowAlert = true;
                // state.const_var.alertUsedFor = "YourCanNotAddPorch";
            }

            makeDimensionUpdateFront(state);
            dynamicWallOptions(state);
            dynamicWallOptionsForLeanTo(state);
            cuBuilding.BuildingUpdate(true, '');
            cuBuilding.UpdateFrontLean();
            //const_var.UpdatedPriceData.left_front_roof_pitch_price_changed = true;
            const_var.UpdatedPriceData.front_lean_roof_pitch_price_changed = true;
            const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
            //cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft); 
            

            if (params.checkeditName != true) {
                let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
                params.other_building_type_name = newVal;
                if (const_var.post_data.building != undefined) {
                    const_var.post_data.building.other_building_type_name = params.other_building_type_name;
                    const_var.post_data.building.name = params.other_building_type_name;
                }
            }

        }
        if (value == "left") {
            //state.params.b_r_p = state.params.b_r_p;
            //state.params.p_r_p = state.params.p_r_p;
            let b_l_t_r_p_old = params.b_l_t_r_p
            state.params.b_l_t_r_p = parseInt(event);
            if (state.params.add_left_lean == true) {
                /*
                  * As discussed with Anand & Rahul the below calHeight that we are considering 
                  * is incorrect to get the exact value we have a Forumala: (leanHeight + (leanWidth * leanRoofPitch / 12 ))
                  * with the above formula we can achive the exact value of lean-to height including ROofPitch impleanting same
                  * in all leantos and in makeDimensionUpdateLeantos function at the Remove leanto case we are correcting this
                 */
                // var calHeight = state.params.lean_p_h + parseInt(state.params.b_l_t_r_p);
                let straightRoofval = (params.p_r_p == params.b_l_t_r_p && !params.singleSlope && params.p_r_s != 1) ? 0 : 1
                var calHeight = state.params.lean_p_h + Math.round(state.params.lean_p_w * state.params.b_l_t_r_p / 12) + straightRoofval;
                let leftLeanRoofHeight = calHeight;

                let isMaxHeight = const_var.roofObject[params.p_b_t][params.p_r_s].max_height
                if(const_var.isForStandardBuilding == true && !const_var.b_o_J_1[params.p_b_t].includes("Free Standing") && !const_var.b_o_J_1[params.p_b_t].includes("RV Covers") && params.p_w <= const_var.roofObject[params.p_b_t][params.p_r_s].max_height){
                    isMaxHeight = params.p_w
                }

                // if (calHeight > state.params.p_h && calHeight <= state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                if (calHeight > state.params.p_h && calHeight <= isMaxHeight) {
                    // state.params.p_h = state.params.lean_p_h + Math.round(state.params.lean_p_w * state.params.b_l_t_r_p / 12);
                    state.params.p_h = ( params.p_h < leftLeanRoofHeight ) ? leftLeanRoofHeight : state.params.p_h;
                    const_var.UpdatedPriceData.height_price_changed = true;
                    const_var.UpdatedPriceData.certificate_price_changed = true;
                    const_var.UpdatedPriceData.right_wall_price_changed = true;
                    const_var.UpdatedPriceData.left_wall_price_changed = true;
                    const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
                    const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
                    const_var.UpdatedPriceData.front_wall_price_changed = true;
                    const_var.UpdatedPriceData.back_wall_price_changed = true;
                    const_var.UpdatedPriceData.utility_price_changed = true;
                    const_var.UpdatedPriceData.common_height_changed = true;
                    if (params.p_f_i) const_var.UpdatedPriceData.insulation_price = undefined;
                }
                const_var.UpdatedPriceData.left_lean_height_price_changed = true;
                // if (calHeight > state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                if (calHeight > isMaxHeight) {
                    state.params.b_l_t_r_p = b_l_t_r_p_old;
                }
                var exactVal = Math.floor(params.p_h - ((params.lean_p_w * params.b_l_t_r_p) / 12));

                // if (exactVal < 6 && state.params.p_h < state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                if (exactVal < 6 && state.params.p_h < isMaxHeight) {
                    state.params.p_h = state.params.p_h + 1;
                }
            }
            var dataW = Math.floor(((state.params.p_h - state.params.lean_p_h) * 100) / (((state.params.b_l_t_r_p) / 12) * 100));
            var newDataW = (parseInt(dataW) >= 24) ? 24 : parseInt(dataW);
            var dataH = Math.floor(state.params.p_h - ((state.params.lean_p_w * state.params.b_l_t_r_p) / 12));
            let minWidthL = 6;
            let roofDatanew = const_var.roof_style_Barn;
            if(const_var.roof_style_Barn_with_centerbuilding[params.p_b_t]!=undefined)
            {
                roofDatanew = const_var.roof_style_Barn_with_centerbuilding[params.p_b_t];
            }
            roofDatanew.map((val, i) => {
                if (params.p_r_s == val.roof_id) {
                    minWidthL = val.min_width;
                    const_var.leanDimension = val;
                }
            })

            utils.checkLegsDataAccordingtoResponse(const_var?.ConditionArr[params.p_b_t][params.p_r_s], "dimension")

            if (dataH < 6 || newDataW < minWidthL) {
                if (newDataW < minWidthL) {
                    state.params.lean_p_w = minWidthL;
                }
                if (dataH < state.const_var.b_m_i_hlean) {
                    state.params.lean_p_h = state.const_var.b_m_i_hlean;
                }
                state.params.b_l_t_r_p = "2";
                // state.const_var.isShowAlert = true;
                // state.const_var.alertUsedFor = "RoofPitchAction";
            }

            // if( state.params.add_left_front_lean_porch ==true ){
            //     state.params.b_l_t_r_pF = state.params.b_l_t_r_p
            // }
            // if( state.params.add_left_back_lean_porch ==true ){
            //     state.params.b_l_t_r_pB = state.params.b_l_t_r_p
            // }

            if (state.params.add_left_front_lean_porch != false && params.b_l_t_r_p != params.b_l_t_r_pF) {
                state.params.add_left_front_lean_porch = false;
                cuBuilding.UpdateFrontLean();
                // state.const_var.isShowAlert = true;
                // state.const_var.alertUsedFor = "YourCanNotAddPorch";
            }

            if (state.params.add_left_back_lean_porch != false && params.b_l_t_r_p != params.b_l_t_r_pB) {
                state.params.add_left_back_lean_porch = false;
                cuBuilding.UpdateBackLean();
                // state.const_var.isShowAlert = true;
                // state.const_var.alertUsedFor = "YourCanNotAddPorch";
            }

            if (state.params.add_left_front_lean_porch == true && state.params.b_l_t_r_p != state.params.b_l_t_r_pR) {
                state.params.add_right_front_lean_porch = false
            }

            if (state.params.add_left_back_lean_porch == true && state.params.b_l_t_r_p != state.params.b_l_t_r_pR) {
                state.params.add_right_back_lean_porch = false
            }

            makeDimensionUpdateLeft(state);
            dynamicWallOptions(state);
            dynamicWallOptionsForLeanTo(state);
            cuBuilding.BuildingUpdate(true, '');
            cuBuilding.UpdateLeftLean();
            const_var.UpdatedPriceData.left_lean_roof_pitch_price_changed = true;
            const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
            //cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft); 
            if (params.checkeditName != true) {
                let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
                params.other_building_type_name = newVal;
                if (const_var.post_data.building != undefined) {
                    const_var.post_data.building.other_building_type_name = params.other_building_type_name;
                    const_var.post_data.building.name = params.other_building_type_name;
                }
            }

        }
        if (value == "right") {
            let b_l_t_r_pR_old = params.b_l_t_r_pR
            state.params.b_l_t_r_pR = parseInt(event);
            if (state.params.add_right_lean == true) {
                // var calHeight = state.params.leanR_p_h + parseInt(state.params.b_l_t_r_pR);
                /* Refer comment in Left Lean to case in RoofPitch */
                let straightRoofval = (params.p_r_p == params.b_l_t_r_pR && !params.singleSlope && params.p_r_s != 1) ? 0 : 1
                var calHeight = state.params.leanR_p_h + Math.round(state.params.leanR_p_w * state.params.b_l_t_r_pR / 12) + straightRoofval;
                let rightLeanRoofHeight = calHeight;

                let isMaxHeight = const_var.roofObject[params.p_b_t][params.p_r_s].max_height
                if(const_var.isForStandardBuilding == true && !const_var.b_o_J_1[params.p_b_t].includes("Free Standing") && !const_var.b_o_J_1[params.p_b_t].includes("RV Covers") && params.p_w <= const_var.roofObject[params.p_b_t][params.p_r_s].max_height){
                    isMaxHeight = params.p_w
                }

                //--------------To restrict the automatic height increase in the case of a free-standing building with a fixed height relative to its width------//
                let freeStandingFixedHeight
                if (params.singleSlope == true) {
                    if((const_var.c_m_a[params.p_b_t]!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length>0 && state.const_var.c_m_a[params.p_b_t].fixed_new_leg_width[0][params.p_w] !== undefined))
                    {
                        freeStandingFixedHeight = state.const_var.c_m_a[params.p_b_t].fixed_new_leg_width[0][params.p_w].max_height
                    }
                }

                // if (calHeight > state.params.p_h && calHeight <= state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                if (calHeight > state.params.p_h && calHeight <= isMaxHeight && ((freeStandingFixedHeight == undefined) || (freeStandingFixedHeight != undefined && freeStandingFixedHeight > calHeight))) {
                    // state.params.p_h = state.params.leanR_p_h + Math.round(state.params.leanR_p_w * state.params.b_l_t_r_pR / 12);
                    state.params.p_h = ( params.p_h < rightLeanRoofHeight ) ? rightLeanRoofHeight : state.params.p_h;
                    const_var.UpdatedPriceData.height_price_changed = true;
                    const_var.UpdatedPriceData.certificate_price_changed = true;
                    const_var.UpdatedPriceData.right_wall_price_changed = true;
                    const_var.UpdatedPriceData.left_wall_price_changed = true;
                    const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
                    const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
                    const_var.UpdatedPriceData.front_wall_price_changed = true;
                    const_var.UpdatedPriceData.back_wall_price_changed = true;
                    const_var.UpdatedPriceData.utility_price_changed = true;
                    const_var.UpdatedPriceData.common_height_changed = true;
                    if (params.p_f_i) const_var.UpdatedPriceData.insulation_price = undefined;
                }
                const_var.UpdatedPriceData.right_lean_height_price_changed = true;
                const_var.UpdatedPriceData.right_lean_front_wall_price_changed = true;
                const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
                // if (calHeight > state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                if ((calHeight > isMaxHeight) || (freeStandingFixedHeight != undefined && calHeight > freeStandingFixedHeight)) {
                    state.params.b_l_t_r_pR = b_l_t_r_pR_old;
                }
                var exactVal = Math.floor(params.p_h - ((params.leanR_p_w * params.b_l_t_r_pR) / 12));
                // if (exactVal < 6 && state.params.p_h < state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                if (exactVal < 6 && state.params.p_h < isMaxHeight) {
                    state.params.p_h = state.params.p_h + 1;
                }
            }
            var dataW = Math.floor(((state.params.p_h - state.params.leanR_p_h) * 100) / (((state.params.b_l_t_r_pR) / 12) * 100));

            var newDataW = (parseInt(dataW) >= 24) ? 24 : parseInt(dataW);
            var dataH = Math.floor(state.params.p_h - ((state.params.leanR_p_w * state.params.b_l_t_r_pR) / 12));
            let minWidthR = 6;
            let roofDatanew = const_var.roof_style_Barn;
            if(const_var.roof_style_Barn_with_centerbuilding[params.p_b_t]!=undefined)
            {
                roofDatanew = const_var.roof_style_Barn_with_centerbuilding[params.p_b_t];
            }
            roofDatanew.map((val, i) => {
                if (params.p_r_s == val.roof_id) {
                    minWidthR = val.min_width;
                    const_var.leanDimension = val;
                }
            })
            utils.checkLegsDataAccordingtoResponse(const_var?.ConditionArr[params.p_b_t][params.p_r_s], "dimension")
            if (dataH < 6 || newDataW < minWidthR) {
                if (newDataW < minWidthR) {
                    state.params.leanR_p_w = minWidthR;
                }
                if (dataH < state.const_var.b_m_i_hlean) {
                    state.params.leanR_p_h = state.const_var.b_m_i_hlean;
                }
                state.params.b_l_t_r_pR = "2";
                // state.const_var.isShowAlert = true;
                // state.const_var.alertUsedFor = "RoofPitchAction";
            }

            // if( state.params.add_right_front_lean_porch ==true ){
            //     state.params.b_l_t_r_pF = state.params.b_l_t_r_pR
            // }
            // if( state.params.add_right_back_lean_porch ==true ){
            //     state.params.b_l_t_r_pB = state.params.b_l_t_r_pR
            // }

            if (state.params.add_right_front_lean_porch != false && params.b_l_t_r_pR != params.b_l_t_r_pF) {
                state.params.add_right_front_lean_porch = false;
                cuBuilding.UpdateFrontLean();
                // state.const_var.isShowAlert = true;
                // state.const_var.alertUsedFor = "YourCanNotAddPorch";
            }

            if (state.params.add_right_back_lean_porch != false && params.b_l_t_r_pR != params.b_l_t_r_pB) {
                state.params.add_right_back_lean_porch = false;
                cuBuilding.UpdateBackLean();
                // state.const_var.isShowAlert = true;
                // state.const_var.alertUsedFor = "YourCanNotAddPorch";
            }

            if (state.params.add_right_front_lean_porch == true && state.params.b_l_t_r_p != state.params.b_l_t_r_pR) {
                state.params.add_left_front_lean_porch = false
            }

            if (state.params.add_right_back_lean_porch == true && state.params.b_l_t_r_p != state.params.b_l_t_r_pR) {
                state.params.add_left_back_lean_porch = false
            }
            makeDimensionUpdateRight(state);
            dynamicWallOptions(state);
            dynamicWallOptionsForLeanTo(state);
            cuBuilding.BuildingUpdate(true, '');
            cuBuilding.UpdateRightLean();
            const_var.UpdatedPriceData.right_lean_roof_pitch_price_changed = true;
            const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
            //cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
            if (params.checkeditName != true) {
                let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
                params.other_building_type_name = newVal;
                if (const_var.post_data.building != undefined) {
                    const_var.post_data.building.other_building_type_name = params.other_building_type_name;
                    const_var.post_data.building.name = params.other_building_type_name;
                }
            }

        }
        if (value == "back") {
            let b_l_t_r_pB_old = params.b_l_t_r_pB
            state.params.b_l_t_r_pB = parseInt(event);
            if (state.params.add_back_lean == true) {
                // var calHeight = state.params.leanB_p_h + parseInt(state.params.b_l_t_r_pB);
                /* Refer comment in Left Lean to case in RoofPitch */
                let straightRoofval = (params.p_r_p == params.b_l_t_r_pB && !params.singleSlope && params.p_r_s != 1) ? 0 : 1
                var calHeight = state.params.leanB_p_h + Math.round(state.params.leanB_p_w * state.params.b_l_t_r_pB / 12) + straightRoofval;
                let backLeanRoofHeight = calHeight;
                
                let isMaxHeight = const_var.roofObject[params.p_b_t][params.p_r_s].max_height
                if(const_var.isForStandardBuilding == true && !const_var.b_o_J_1[params.p_b_t].includes("Free Standing") && !const_var.b_o_J_1[params.p_b_t].includes("RV Covers") && params.p_w <= const_var.roofObject[params.p_b_t][params.p_r_s].max_height){
                    isMaxHeight = params.p_w
                }

                // if (calHeight > state.params.p_h && calHeight <= state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                if (calHeight > state.params.p_h && calHeight <= isMaxHeight) {
                    // state.params.p_h = state.params.leanB_p_h + Math.round(state.params.leanB_p_w * state.params.b_l_t_r_pB / 12);
                    state.params.p_h = ( params.p_h < backLeanRoofHeight ) ? backLeanRoofHeight : state.params.p_h;
                    const_var.UpdatedPriceData.height_price_changed = true;
                    const_var.UpdatedPriceData.certificate_price_changed = true;
                    const_var.UpdatedPriceData.right_wall_price_changed = true;
                    const_var.UpdatedPriceData.left_wall_price_changed = true;
                    const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
                    const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
                    const_var.UpdatedPriceData.front_wall_price_changed = true;
                    const_var.UpdatedPriceData.back_wall_price_changed = true;
                    const_var.UpdatedPriceData.utility_price_changed = true;
                    const_var.UpdatedPriceData.common_height_changed = true;
                    if (params.p_f_i) const_var.UpdatedPriceData.insulation_price = undefined;
                }
                const_var.UpdatedPriceData.back_lean_height_price_changed = true;
                // if (calHeight > state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                if (calHeight > isMaxHeight) {
                    state.params.b_l_t_r_pB = b_l_t_r_pB_old;
                }
                var exactVal = Math.floor(params.p_h - ((params.leanB_p_w * params.b_l_t_r_pB) / 12));

                // if (exactVal < 6 && state.params.p_h < state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
                if (exactVal < 6 && state.params.p_h < isMaxHeight) {
                    state.params.p_h = state.params.p_h + 1;
                }
            }
            var dataW = Math.floor(((state.params.p_h - state.params.leanB_p_h) * 100) / (((state.params.b_l_t_r_pB) / 12) * 100));
            var newDataW = (parseInt(dataW) >= 24) ? 24 : parseInt(dataW);
            var dataH = Math.floor(state.params.p_h - ((state.params.leanB_p_w * state.params.b_l_t_r_pB) / 12));

            utils.checkLegsDataAccordingtoResponse(const_var?.ConditionArr[params.p_b_t][params.p_r_s], "dimension") 

            if (dataH < 6 || newDataW < 6) {
                if (newDataW < 6) {
                    state.params.leanB_p_w = 6;
                }
                if (dataH < state.const_var.b_m_i_hlean) {
                    state.params.leanB_p_h = state.const_var.b_m_i_hlean;
                }
                state.params.b_l_t_r_pB = "2";
                // state.const_var.isShowAlert = true;
                // state.const_var.alertUsedFor = "RoofPitchAction";
            }
            if (state.params.add_right_back_lean_porch == true && state.params.b_l_t_r_pB != state.params.b_l_t_r_pR) {
                state.params.add_right_back_lean_porch = false
                cuBuilding.UpdateRightLean();
                // state.const_var.isShowAlert = true;
                // state.const_var.alertUsedFor = "YourCanNotAddPorch";
            }

            if (state.params.add_left_back_lean_porch == true && state.params.b_l_t_r_pB != state.params.b_l_t_r_p) {
                state.params.add_left_back_lean_porch = false
                cuBuilding.UpdateLeftLean();
                // state.const_var.isShowAlert = true;
                // state.const_var.alertUsedFor = "YourCanNotAddPorch";
            }

            makeDimensionUpdateBack(state);
            dynamicWallOptions(state);
            dynamicWallOptionsForLeanTo(state);
            cuBuilding.BuildingUpdate(true, '');
            cuBuilding.UpdateBackLean("roof");
            const_var.UpdatedPriceData.back_lean_roof_pitch_price_changed = true;
            const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
            //cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft); 

            if (params.checkeditName != true) {
                let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
                params.other_building_type_name = newVal;
                if (const_var.post_data.building != undefined) {
                    const_var.post_data.building.other_building_type_name = params.other_building_type_name;
                    const_var.post_data.building.name = params.other_building_type_name;
                }
            }
        }
        if (value == "front" || value == "left" || value == "right" || value == "back"){
            if (const_var.callMesure){
            } 

        }
    }
    if (params.cupola) cuComponent.handlCupolaPositionOnDimensionChange('roofPitch');

        // ################ Handling insulation for heritage building ##################
        if(params.singleSlope != true && ((const_var.crmSetting.is_Edit != true && params.m_s_n == 153 && ((params.p_r_s == 2 || params.p_r_s == 1 ) && params.p_h > 10)) || (const_var.crmSetting.is_Edit == true && params.m_s_n == 153 && (params.p_r_s  == 1 || params.p_r_s == 2) && const_var.editAPIDataByResponse != undefined && const_var.editAPIDataByResponse.data != undefined))) {

            if (const_var.insulationPriceJson?.insulation_wall != undefined && Object.keys(const_var.insulationPriceJson.insulation_wall).length > 0) {
                const_var.insulationPriceJson.insulation_wall = {}
            }

            // params.p_i_o = 0;
            params.insulation.center.insulationId = 0;
    
            params.insulation.center.isCheked = false;
    
            params.insulation.center.showInsulationOptions =  false;
            params.insulation.center.roofOnly = params.insulation.center.insulationId !== 0 ? true : false;
            params.insulation.center.fullBuilding = params.insulation.center.roofOnly ? false :params.insulation.center.fullBuilding;
            params.insulation.center.custom = (params.insulation.center.roofOnly || params.insulation.center.fullBuilding) ? false :params.insulation.center.custom;
            // params.p_r_o = params.p_i_o !== 0 ? true : false;
            // params.p_f_i = params.p_r_o ? false : params.p_f_i;
            // const_var.UpdatedPriceData.insulation_price = undefined;
            const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
           
            
            // ########### Front lean ##############
    
            if(params.add_front_lean == true && params.insulation["frontLean"] != undefined && params.m_s_n == 153 && ((params.p_r_s == 1 || params.p_r_s == 2)) && params.leanF_p_h > 10) {
                params.insulation["frontLean"].isCheked = false;  
                params.insulation["frontLean"].insulationId = 0;
                
                params.insulation["frontLean"].showInsulationOptions = false;
                params.insulation["frontLean"].roofOnly = params.insulation["frontLean"].insulationId !== 0 ? true : false;
                params.insulation["frontLean"].fullBuilding = params.insulation["frontLean"].roofOnly ? false : params.insulation["frontLean"].fullBuilding;
                params.insulation["frontLean"].custom = (params.insulation["frontLean"].roofOnly || params.insulation["frontLean"].fullBuilding) ? false : params.insulation["frontLean"].custom;
            }
    
            // ########### Back lean ##############
            if(params.add_back_lean == true && params.insulation["backLean"] != undefined && params.m_s_n == 153 && ((params.p_r_s == 1 || params.p_r_s == 2)) && params.leanB_p_h > 10) {
                params.insulation["backLean"].isCheked = false;  
                params.insulation["backLean"].insulationId = 0;
                
                params.insulation["backLean"].showInsulationOptions = false;
                params.insulation["backLean"].roofOnly = params.insulation["backLean"].insulationId !== 0 ? true : false;
                params.insulation["backLean"].fullBuilding = params.insulation["backLean"].roofOnly ? false : params.insulation["backLean"].fullBuilding;
                params.insulation["backLean"].custom = (params.insulation["backLean"].roofOnly || params.insulation["backLean"].fullBuilding) ? false : params.insulation["backLean"].custom;
            }
    
            // ########### Right lean ##############
            if(params.add_right_lean == true && params.insulation["rightLean"] != undefined && params.m_s_n == 153 && ((params.p_r_s == 1 || params.p_r_s == 2)) && params.leanR_p_h > 10) {
                params.insulation["rightLean"].isCheked = false;  
                params.insulation["rightLean"].insulationId = 0;
                
                params.insulation["rightLean"].showInsulationOptions = false;
                params.insulation["rightLean"].roofOnly = params.insulation["rightLean"].insulationId !== 0 ? true : false;
                params.insulation["rightLean"].fullBuilding = params.insulation["rightLean"].roofOnly ? false : params.insulation["rightLean"].fullBuilding;
                params.insulation["rightLean"].custom = (params.insulation["rightLean"].roofOnly || params.insulation["rightLean"].fullBuilding) ? false : params.insulation["rightLean"].custom;
            }
    
            // ########### Left lean ##############
    
            if(params.add_left_lean == true && params.insulation["leftLean"] != undefined && params.m_s_n == 153 && ((params.p_r_s == 1 || params.p_r_s == 2)) && params.lean_p_h > 10) {
                params.insulation["leftLean"].isCheked = false;  
                params.insulation["leftLean"].insulationId = 0;
                
                params.insulation["leftLean"].showInsulationOptions = false;
                params.insulation["leftLean"].roofOnly = params.insulation["leftLean"].insulationId !== 0 ? true : false;
                params.insulation["leftLean"].fullBuilding = params.insulation["leftLean"].roofOnly ? false : params.insulation["leftLean"].fullBuilding;
                params.insulation["leftLean"].custom = (params.insulation["leftLean"].roofOnly || params.insulation["leftLean"].fullBuilding) ? false : params.insulation["leftLean"].custom;
            }
        }
     
        // ################# lower height of free standing building ###############
        let lowerHeightOfFreeStanding = (const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0) ? Math.floor(params.p_h - ((params.p_w * params.p_r_p) / 12)) : Math.round(params.p_h - ((params.p_w * params.p_r_p) / 12))
    
    
        // ################# Free standing building check : Heritage Manufacture #################
        if (params.singleSlope == true && ((const_var.crmSetting.is_Edit != true && params.m_s_n == 153 && ((params.p_r_s == 1 || params.p_r_s == 2) && lowerHeightOfFreeStanding > 10)) || (const_var.crmSetting.is_Edit == true && params.m_s_n == 153 && const_var.editAPIDataByResponse != undefined && const_var.editAPIDataByResponse.data != undefined))) {
            if(params.p_f_i == false && params.p_r_o == false && params.p_c_i==false)
            {
                params.p_i_o = 0;
                params.insulation.center.insulationId = 0;
                params.p_c_i = false;
                params.p_f_i = false;
                params.p_r_o = false;
        
                params.insulation.center.isCheked = false;
        
                params.insulation.center.showInsulationOptions = false;
                params.insulation.center.roofOnly = params.insulation.center.insulationId !== 0 ? true : false;
                params.insulation.center.fullBuilding = params.insulation.center.roofOnly ? false : params.insulation.center.fullBuilding;
                params.insulation.center.custom = (params.insulation.center.roofOnly || params.insulation.center.fullBuilding) ? false : params.insulation.center.custom;
                // params.p_r_o = params.p_i_o !== 0 ? true : false;
                // params.p_f_i = params.p_r_o ? false : params.p_f_i;
                //const_var.UpdatedPriceData.insulation_price = undefined;
                //const_var.UpdatedPriceData.insulation_price_changed = true;
                const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
            }
        }


    /* we commented the above function due to while changeing the roof pitch 
      * there is no change in leg condtions of center building & leantos consider a scenerio 
      * that leanto double leg base rail was checked manaullay and then  roof pitch of leanto or cb 
      * then the checked option will get unchecked */
    //cuBuilding.CheckLeanLegsByResponse(state);
    // cuBuilding.CheckLegsByResponse(state);
}

function updateJTrim (type) {
   let checkEndJTrim, checkSideJTrim = false;
   if (type == "sideJTrim"){
       if((const_var.a_p_d_a.jtrim) && const_var.a_p_d_a.jtrim.length>0) {
           checkSideJTrim = (const_var.a_p_d_a.jtrim.filter(data=>data.type=="side")).length>0?true:false;
       }
       if( checkSideJTrim && ((params.p_r_w!="Open" && params.p_r_w!="Close") || (params.p_l_w!="Open" && params.p_l_w!="Close"))) {
           params.p_j_t = true;
       }
    } else if (type == "endJTrim"){
        if((const_var.a_p_d_a.jtrim) && const_var.a_p_d_a.jtrim.length>0) {
            checkEndJTrim = (const_var.a_p_d_a.jtrim.filter(data=>data.type=="end")).length>0?true:false;
        }
        if(checkEndJTrim && ((params.p_f_w!="Open" && params.p_f_w!="Close" ) || (params.p_b_w!="Open" && params.p_b_w!="Close"))) {
            params.p_j_t_end = true;
        }
   } else {
        if((const_var.a_p_d_a.jtrim) && const_var.a_p_d_a.jtrim.length>0) {
            checkSideJTrim = (const_var.a_p_d_a.jtrim.filter(data=>data.type=="side")).length>0?true:false;
            checkEndJTrim = (const_var.a_p_d_a.jtrim.filter(data=>data.type=="end")).length>0?true:false;
        }
        if( checkSideJTrim && ((params.p_r_w!="Open" && params.p_r_w!="Close") || (params.p_l_w!="Open" && params.p_l_w!="Close"))) {
            params.p_j_t = true;
        }
        if(checkEndJTrim && ((params.p_f_w!="Open" && params.p_f_w!="Close" && params.p_f_w!="Half Dutch End" && params.p_f_w!="Half End") 
            || (params.p_b_w!="Open" && params.p_b_w!="Close" && params.p_b_w!="Half Dutch End" && params.p_b_w!="Half End")
        || (params.p_b_c_b_l_f!="Open" && params.p_b_c_b_l_f!="Close" && params.p_b_c_b_l_f!="Half Dutch End" && params.p_b_c_b_l_f!="Half End") ||(params.p_b_c_b_l_b!="Open" && params.p_b_c_b_l_b!="Close" && params.p_b_c_b_l_b!="Half Dutch End" && params.p_b_c_b_l_b!="Half End")
        || (params.p_b_c_b_b_f!="Open" && params.p_b_c_b_b_f!="Close" && params.p_b_c_b_b_f!="Half Dutch End" && params.p_b_c_b_b_f!="Half End") ||(params.p_b_c_b_b_b!="Open" && params.p_b_c_b_b_b!="Close" && params.p_b_c_b_b_b!="Half Dutch End" && params.p_b_c_b_b_b!="Half End")
        || (params.p_b_c_b_f_f!="Open" && params.p_b_c_b_f_f!="Close" && params.p_b_c_b_f_f!="Half Dutch End" && params.p_b_c_b_f_f!="Half End") ||(params.p_b_c_b_f_b!="Open" && params.p_b_c_b_f_b!="Close" && params.p_b_c_b_f_b!="Half Dutch End" && params.p_b_c_b_f_b!="Half End")
        || (params.p_b_c_b_r_f!="Open" && params.p_b_c_b_r_f!="Close" && params.p_b_c_b_r_f!="Half Dutch End" && params.p_b_c_b_r_f!="Half End") ||(params.p_b_c_b_r_b!="Open" && params.p_b_c_b_r_b!="Close" && params.p_b_c_b_r_b!="Half Dutch End" && params.p_b_c_b_r_b!="Half End")
        )) {
            params.p_j_t_end = true;
        }

   }
}
function updatePorchLengths (type) {
   
    const_var.lengthData.leftLean.porchLength = 0;
    const_var.lengthData.rightLean.porchLength = 0;
    const_var.lengthData.frontLean.porchLength = 0;
    const_var.lengthData.backLean.porchLength = 0;
    
    if(params.add_left_back_lean_porch) {
        const_var.lengthData.leftLean.porchLength = params.leanB_p_w;
        const_var.lengthData.backLean.porchLength = params.lean_p_w;
    } 
    if(params.add_left_front_lean_porch){
        const_var.lengthData.leftLean.porchLength = params.leanF_p_w;
        const_var.lengthData.frontLean.porchLength = params.lean_p_w;

    }
    if(params.add_left_back_lean_porch && params.add_left_front_lean_porch) {
        const_var.lengthData.leftLean.porchLength = params.leanF_p_w+params.leanB_p_w;  
    }
    if(params.add_right_back_lean_porch)
    {
        const_var.lengthData.rightLean.porchLength = params.leanB_p_w;
        const_var.lengthData.backLean.porchLength = params.leanR_p_w;
    }
    if(params.add_right_front_lean_porch)
    {
        const_var.lengthData.rightLean.porchLength = params.leanF_p_w;
        const_var.lengthData.frontLean.porchLength = params.leanR_p_w;
    }
    if(params.add_right_back_lean_porch && params.add_right_front_lean_porch)
    {
        const_var.lengthData.rightLean.porchLength = params.leanF_p_w+params.leanB_p_w;
    }
    if(params.add_right_front_lean_porch && params.add_left_front_lean_porch)
    {
        const_var.lengthData.frontLean.porchLength = params.lean_p_w + params.leanR_p_w;
    }
    if(params.add_right_back_lean_porch && params.add_left_back_lean_porch)
    {
        const_var.lengthData.backLean.porchLength = params.lean_p_w + params.leanR_p_w;
    }
   
}



const onSubmitState = (state, event) => {
    event.preventDefault();
    if (state.const_var.confirmState == true) {
        state.const_var.confirmStateError = false;
        state.const_var.tabCountDisplay = true;
        const_var.showReportLoading = true;
        // state.selectedTabstate = 'buildstyle'
        state.selectedTabstate = 'buildingtypetab'
    } else {
        state.const_var.confirmStateError = true;
        state.const_var.tabCountDisplay = false;
    }
}
window.initialstate = initialState;

window.THREE = THREE;

export function calcOverhangSize(overhangVar){
    let isInch = overhangVar.includes(`"`) || overhangVar.includes(`''`)
    let size = 0.5
    if(isInch){
        size = overhangVar.split(`"`) || overhangVar.split(`''`)


        if(params.m_s_n == 153) {

            size = "1"
        } else {

            if(overhangVar.includes(`'`) && !overhangVar.includes(`"`) && !overhangVar.includes(`''`)){
                let inch = size.split(`'`)[1]
                inch = parseInt(inch)/12
                size = overhangVar.split(`'`)[0] + inch
            }
            else{
                size = parseFloat(size)/12
            }
        }
    }
    else{

        size = overhangVar.split(`'`)
        size = size[0]
    }
    // overhangVar['size'] = parseFloat(size) < 0.5 ? 0.5 : size;
    return parseFloat(size) < 0.5 ? 0.5 : size
}

export const updateSlider = (state) => {
    const horizontalSlider = document.getElementById('horizontal-slider');
    if(horizontalSlider!=undefined){
      horizontalSlider.value = ((Math.atan2(const_var.camera.position.x, const_var.camera.position.z) * (180 / Math.PI)) + 360) % 360;
      state.horizontalSliderRange = ((Math.atan2(const_var.camera.position.x, const_var.camera.position.z) * (180 / Math.PI)) + 360) % 360;
    }

    const verticalSlider = document.getElementById('vertical-slider');
    const spherical = new THREE.Spherical().setFromVector3(const_var.camera.position);
    const degrees = THREE.MathUtils.radToDeg(spherical.phi);
    if(verticalSlider!=undefined){
        verticalSlider.value = degrees;
        state.verticalSliderRange = degrees
    }
}

export default reducer;